var F3 = Object.defineProperty;
var B3 = (e, t, n) => t in e ? F3(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ne = (e, t, n) => B3(e, typeof t != "symbol" ? t + "" : t, n);
import { library as z3 } from "@fortawesome/fontawesome-svg-core";
import { faSpinnerThird as V3, faHighlighter as H3 } from "@fortawesome/pro-duotone-svg-icons";
import { faXmark as j3 } from "@fortawesome/pro-light-svg-icons";
import { faItalic as W3, faUnderline as U3, faStrikethrough as q3, faFont as Y3, faTextSize as K3, faListOl as G3, faListUl as J3, faAlignLeft as X3, faAlignCenter as Q3, faAlignRight as Z3, faAlignJustify as eb, faH1 as tb, faH2 as nb, faH3 as rb, faUnlink as ib, faUndoAlt as ob, faRedoAlt as ab, faLink as sb, faChevronUp as lb, faChevronDown as db, faFilePdf as ub, faFileArchive as cb, faFileExcel as fb, faFileWord as pb, faFilePowerpoint as hb, faFileAlt as mb, faFileCsv as gb, faFileImage as vb, faFile as yb, faCalendar as bb, faExclamationCircle as $b, faCheck as wb, faSquare as kb, faXmark as xb } from "@fortawesome/pro-regular-svg-icons";
import { faExternalLink as Sb, faUpload as Cb, faInfoCircle as Tb, faCircleCheck as Mb, faExclamationCircle as Ob, faExclamationTriangle as Eb, faChevronDown as Db, faChevronUp as Ab, faChevronLeft as Pb, faChevronRight as Nb, faBold as Ib, faSpinnerThird as Rb, faSyncAlt as _b, faGraduationCap as Lb, faBan as Fb, faArrowLeft as Bb, faArrowRight as zb, faLock as Vb, faLongArrowRight as Hb, faCheck as jb, faXmark as Wb, faSearch as Ub, faFilter as qb, faSquareCheck as Yb, faMinus as Kb, faPlus as Gb, faEye as Jb, faEyeSlash as Xb, faAngleRight as Qb, faAnglesRight as Zb, faAngleLeft as e4, faAnglesLeft as t4, faUndo as n4 } from "@fortawesome/pro-solid-svg-icons";
import { defineComponent as $e, ref as q, computed as E, watch as Fe, onMounted as ot, openBlock as k, createElementBlock as A, createElementVNode as G, normalizeClass as te, unref as D, renderSlot as se, createCommentVNode as K, h as nn, resolveComponent as Be, createVNode as fe, toDisplayString as Te, mergeProps as $t, createBlock as ge, resolveDynamicComponent as Qn, withCtx as de, getCurrentScope as Lm, onScopeDispose as Fm, isRef as nc, nextTick as an, getCurrentInstance as o0, reactive as Gn, watchEffect as ps, normalizeStyle as mt, Fragment as Ie, renderList as Ze, withKeys as Re, withDirectives as Jt, vModelCheckbox as r4, useSlots as ci, toRef as Ua, onUnmounted as hr, createSlots as qt, normalizeProps as tn, guardReactiveProps as Sn, Teleport as ca, Transition as ur, render as fp, withModifiers as Ge, createTextVNode as it, onBeforeUpdate as Bm, vShow as Cn, onBeforeMount as a0, Comment as i4, vModelText as s0, onBeforeUnmount as bo, inject as Zn, provide as mr, resolveDirective as o4, toHandlers as a4, shallowRef as il, markRaw as s4, customRef as l4, mergeModels as rc, useModel as zm, TransitionGroup as d4, cloneVNode as u4, toRaw as Xr, toRefs as Os } from "vue";
import { FontAwesomeIcon as pp } from "@fortawesome/vue-fontawesome";
const c4 = {
  prefix: "fab",
  iconName: "whatsapp",
  icon: [448, 512, [], "f232", "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"]
};
z3.add(
  // Brands
  c4,
  // Solid
  Sb,
  Cb,
  Tb,
  Mb,
  Ob,
  Eb,
  Db,
  Ab,
  Pb,
  Nb,
  Ib,
  Rb,
  _b,
  Lb,
  Fb,
  Bb,
  zb,
  Vb,
  Hb,
  jb,
  Wb,
  Ub,
  qb,
  Yb,
  Kb,
  Gb,
  Jb,
  Xb,
  Qb,
  Zb,
  e4,
  t4,
  n4,
  // Regular
  W3,
  U3,
  q3,
  Y3,
  K3,
  G3,
  J3,
  X3,
  Q3,
  Z3,
  eb,
  tb,
  nb,
  rb,
  ib,
  ob,
  ab,
  sb,
  lb,
  db,
  ub,
  cb,
  fb,
  pb,
  hb,
  mb,
  gb,
  vb,
  yb,
  bb,
  $b,
  wb,
  kb,
  xb,
  // Light
  j3,
  // Duotone
  V3,
  H3
);
var Vm = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: "normal",
  autoplay: !0,
  timelineOffset: 0
}, l0 = {
  duration: 1e3,
  delay: 0,
  endDelay: 0,
  easing: "easeOutElastic(1, .5)",
  round: 0
}, f4 = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"], ol = {
  CSS: {},
  springs: {}
};
function Dr(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Aa(e, t) {
  return e.indexOf(t) > -1;
}
function Zd(e, t) {
  return e.apply(null, t);
}
var ze = {
  arr: function(e) {
    return Array.isArray(e);
  },
  obj: function(e) {
    return Aa(Object.prototype.toString.call(e), "Object");
  },
  pth: function(e) {
    return ze.obj(e) && e.hasOwnProperty("totalLength");
  },
  svg: function(e) {
    return e instanceof SVGElement;
  },
  inp: function(e) {
    return e instanceof HTMLInputElement;
  },
  dom: function(e) {
    return e.nodeType || ze.svg(e);
  },
  str: function(e) {
    return typeof e == "string";
  },
  fnc: function(e) {
    return typeof e == "function";
  },
  und: function(e) {
    return typeof e == "undefined";
  },
  nil: function(e) {
    return ze.und(e) || e === null;
  },
  hex: function(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  },
  rgb: function(e) {
    return /^rgb/.test(e);
  },
  hsl: function(e) {
    return /^hsl/.test(e);
  },
  col: function(e) {
    return ze.hex(e) || ze.rgb(e) || ze.hsl(e);
  },
  key: function(e) {
    return !Vm.hasOwnProperty(e) && !l0.hasOwnProperty(e) && e !== "targets" && e !== "keyframes";
  }
};
function Hm(e) {
  var t = /\(([^)]+)\)/.exec(e);
  return t ? t[1].split(",").map(function(n) {
    return parseFloat(n);
  }) : [];
}
function jm(e, t) {
  var n = Hm(e), r = Dr(ze.und(n[0]) ? 1 : n[0], 0.1, 100), i = Dr(ze.und(n[1]) ? 100 : n[1], 0.1, 100), o = Dr(ze.und(n[2]) ? 10 : n[2], 0.1, 100), a = Dr(ze.und(n[3]) ? 0 : n[3], 0.1, 100), s = Math.sqrt(i / r), l = o / (2 * Math.sqrt(i * r)), d = l < 1 ? s * Math.sqrt(1 - l * l) : 0, u = 1, c = l < 1 ? (l * s + -a) / d : -a + s;
  function f(p) {
    var m = t ? t * p / 1e3 : p;
    return l < 1 ? m = Math.exp(-m * l * s) * (u * Math.cos(d * m) + c * Math.sin(d * m)) : m = (u + c * m) * Math.exp(-m * s), p === 0 || p === 1 ? p : 1 - m;
  }
  function h() {
    var p = ol.springs[e];
    if (p)
      return p;
    for (var m = 1 / 6, g = 0, v = 0; ; )
      if (g += m, f(g) === 1) {
        if (v++, v >= 16)
          break;
      } else
        v = 0;
    var b = g * m * 1e3;
    return ol.springs[e] = b, b;
  }
  return t ? f : h;
}
function p4(e) {
  return e === void 0 && (e = 10), function(t) {
    return Math.ceil(Dr(t, 1e-6, 1) * e) * (1 / e);
  };
}
var h4 = function() {
  var e = 11, t = 1 / (e - 1);
  function n(u, c) {
    return 1 - 3 * c + 3 * u;
  }
  function r(u, c) {
    return 3 * c - 6 * u;
  }
  function i(u) {
    return 3 * u;
  }
  function o(u, c, f) {
    return ((n(c, f) * u + r(c, f)) * u + i(c)) * u;
  }
  function a(u, c, f) {
    return 3 * n(c, f) * u * u + 2 * r(c, f) * u + i(c);
  }
  function s(u, c, f, h, p) {
    var m, g, v = 0;
    do
      g = c + (f - c) / 2, m = o(g, h, p) - u, m > 0 ? f = g : c = g;
    while (Math.abs(m) > 1e-7 && ++v < 10);
    return g;
  }
  function l(u, c, f, h) {
    for (var p = 0; p < 4; ++p) {
      var m = a(c, f, h);
      if (m === 0)
        return c;
      var g = o(c, f, h) - u;
      c -= g / m;
    }
    return c;
  }
  function d(u, c, f, h) {
    if (!(0 <= u && u <= 1 && 0 <= f && f <= 1))
      return;
    var p = new Float32Array(e);
    if (u !== c || f !== h)
      for (var m = 0; m < e; ++m)
        p[m] = o(m * t, u, f);
    function g(v) {
      for (var b = 0, x = 1, y = e - 1; x !== y && p[x] <= v; ++x)
        b += t;
      --x;
      var C = (v - p[x]) / (p[x + 1] - p[x]), $ = b + C * t, O = a($, u, f);
      return O >= 1e-3 ? l(v, $, u, f) : O === 0 ? $ : s(v, b, b + t, u, f);
    }
    return function(v) {
      return u === c && f === h || v === 0 || v === 1 ? v : o(g(v), c, h);
    };
  }
  return d;
}(), Wm = function() {
  var e = { linear: function() {
    return function(r) {
      return r;
    };
  } }, t = {
    Sine: function() {
      return function(r) {
        return 1 - Math.cos(r * Math.PI / 2);
      };
    },
    Expo: function() {
      return function(r) {
        return r ? Math.pow(2, 10 * r - 10) : 0;
      };
    },
    Circ: function() {
      return function(r) {
        return 1 - Math.sqrt(1 - r * r);
      };
    },
    Back: function() {
      return function(r) {
        return r * r * (3 * r - 2);
      };
    },
    Bounce: function() {
      return function(r) {
        for (var i, o = 4; r < ((i = Math.pow(2, --o)) - 1) / 11; )
          ;
        return 1 / Math.pow(4, 3 - o) - 7.5625 * Math.pow((i * 3 - 2) / 22 - r, 2);
      };
    },
    Elastic: function(r, i) {
      r === void 0 && (r = 1), i === void 0 && (i = 0.5);
      var o = Dr(r, 1, 10), a = Dr(i, 0.1, 2);
      return function(s) {
        return s === 0 || s === 1 ? s : -o * Math.pow(2, 10 * (s - 1)) * Math.sin((s - 1 - a / (Math.PI * 2) * Math.asin(1 / o)) * (Math.PI * 2) / a);
      };
    }
  }, n = ["Quad", "Cubic", "Quart", "Quint"];
  return n.forEach(function(r, i) {
    t[r] = function() {
      return function(o) {
        return Math.pow(o, i + 2);
      };
    };
  }), Object.keys(t).forEach(function(r) {
    var i = t[r];
    e["easeIn" + r] = i, e["easeOut" + r] = function(o, a) {
      return function(s) {
        return 1 - i(o, a)(1 - s);
      };
    }, e["easeInOut" + r] = function(o, a) {
      return function(s) {
        return s < 0.5 ? i(o, a)(s * 2) / 2 : 1 - i(o, a)(s * -2 + 2) / 2;
      };
    }, e["easeOutIn" + r] = function(o, a) {
      return function(s) {
        return s < 0.5 ? (1 - i(o, a)(1 - s * 2)) / 2 : (i(o, a)(s * 2 - 1) + 1) / 2;
      };
    };
  }), e;
}();
function d0(e, t) {
  if (ze.fnc(e))
    return e;
  var n = e.split("(")[0], r = Wm[n], i = Hm(e);
  switch (n) {
    case "spring":
      return jm(e, t);
    case "cubicBezier":
      return Zd(h4, i);
    case "steps":
      return Zd(p4, i);
    default:
      return Zd(r, i);
  }
}
function Um(e) {
  try {
    var t = document.querySelectorAll(e);
    return t;
  } catch {
    return;
  }
}
function dd(e, t) {
  for (var n = e.length, r = arguments.length >= 2 ? arguments[1] : void 0, i = [], o = 0; o < n; o++)
    if (o in e) {
      var a = e[o];
      t.call(r, a, o, e) && i.push(a);
    }
  return i;
}
function ud(e) {
  return e.reduce(function(t, n) {
    return t.concat(ze.arr(n) ? ud(n) : n);
  }, []);
}
function hp(e) {
  return ze.arr(e) ? e : (ze.str(e) && (e = Um(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
}
function u0(e, t) {
  return e.some(function(n) {
    return n === t;
  });
}
function c0(e) {
  var t = {};
  for (var n in e)
    t[n] = e[n];
  return t;
}
function ic(e, t) {
  var n = c0(e);
  for (var r in e)
    n[r] = t.hasOwnProperty(r) ? t[r] : e[r];
  return n;
}
function cd(e, t) {
  var n = c0(e);
  for (var r in t)
    n[r] = ze.und(e[r]) ? t[r] : e[r];
  return n;
}
function m4(e) {
  var t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(e);
  return t ? "rgba(" + t[1] + ",1)" : e;
}
function g4(e) {
  var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, n = e.replace(t, function(s, l, d, u) {
    return l + l + d + d + u + u;
  }), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n), i = parseInt(r[1], 16), o = parseInt(r[2], 16), a = parseInt(r[3], 16);
  return "rgba(" + i + "," + o + "," + a + ",1)";
}
function v4(e) {
  var t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(e), n = parseInt(t[1], 10) / 360, r = parseInt(t[2], 10) / 100, i = parseInt(t[3], 10) / 100, o = t[4] || 1;
  function a(f, h, p) {
    return p < 0 && (p += 1), p > 1 && (p -= 1), p < 1 / 6 ? f + (h - f) * 6 * p : p < 1 / 2 ? h : p < 2 / 3 ? f + (h - f) * (2 / 3 - p) * 6 : f;
  }
  var s, l, d;
  if (r == 0)
    s = l = d = i;
  else {
    var u = i < 0.5 ? i * (1 + r) : i + r - i * r, c = 2 * i - u;
    s = a(c, u, n + 1 / 3), l = a(c, u, n), d = a(c, u, n - 1 / 3);
  }
  return "rgba(" + s * 255 + "," + l * 255 + "," + d * 255 + "," + o + ")";
}
function y4(e) {
  if (ze.rgb(e))
    return m4(e);
  if (ze.hex(e))
    return g4(e);
  if (ze.hsl(e))
    return v4(e);
}
function oi(e) {
  var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(e);
  if (t)
    return t[1];
}
function b4(e) {
  if (Aa(e, "translate") || e === "perspective")
    return "px";
  if (Aa(e, "rotate") || Aa(e, "skew"))
    return "deg";
}
function oc(e, t) {
  return ze.fnc(e) ? e(t.target, t.id, t.total) : e;
}
function Ar(e, t) {
  return e.getAttribute(t);
}
function f0(e, t, n) {
  var r = oi(t);
  if (u0([n, "deg", "rad", "turn"], r))
    return t;
  var i = ol.CSS[t + n];
  if (!ze.und(i))
    return i;
  var o = 100, a = document.createElement(e.tagName), s = e.parentNode && e.parentNode !== document ? e.parentNode : document.body;
  s.appendChild(a), a.style.position = "absolute", a.style.width = o + n;
  var l = o / a.offsetWidth;
  s.removeChild(a);
  var d = l * parseFloat(t);
  return ol.CSS[t + n] = d, d;
}
function qm(e, t, n) {
  if (t in e.style) {
    var r = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = e.style[t] || getComputedStyle(e).getPropertyValue(r) || "0";
    return n ? f0(e, i, n) : i;
  }
}
function p0(e, t) {
  if (ze.dom(e) && !ze.inp(e) && (!ze.nil(Ar(e, t)) || ze.svg(e) && e[t]))
    return "attribute";
  if (ze.dom(e) && u0(f4, t))
    return "transform";
  if (ze.dom(e) && t !== "transform" && qm(e, t))
    return "css";
  if (e[t] != null)
    return "object";
}
function Ym(e) {
  if (ze.dom(e)) {
    for (var t = e.style.transform || "", n = /(\w+)\(([^)]*)\)/g, r = /* @__PURE__ */ new Map(), i; i = n.exec(t); )
      r.set(i[1], i[2]);
    return r;
  }
}
function $4(e, t, n, r) {
  var i = Aa(t, "scale") ? 1 : 0 + b4(t), o = Ym(e).get(t) || i;
  return n && (n.transforms.list.set(t, o), n.transforms.last = t), r ? f0(e, o, r) : o;
}
function h0(e, t, n, r) {
  switch (p0(e, t)) {
    case "transform":
      return $4(e, t, r, n);
    case "css":
      return qm(e, t, n);
    case "attribute":
      return Ar(e, t);
    default:
      return e[t] || 0;
  }
}
function m0(e, t) {
  var n = /^(\*=|\+=|-=)/.exec(e);
  if (!n)
    return e;
  var r = oi(e) || 0, i = parseFloat(t), o = parseFloat(e.replace(n[0], ""));
  switch (n[0][0]) {
    case "+":
      return i + o + r;
    case "-":
      return i - o + r;
    case "*":
      return i * o + r;
  }
}
function Km(e, t) {
  if (ze.col(e))
    return y4(e);
  if (/\s/g.test(e))
    return e;
  var n = oi(e), r = n ? e.substr(0, e.length - n.length) : e;
  return t ? r + t : r;
}
function g0(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function w4(e) {
  return Math.PI * 2 * Ar(e, "r");
}
function k4(e) {
  return Ar(e, "width") * 2 + Ar(e, "height") * 2;
}
function x4(e) {
  return g0(
    { x: Ar(e, "x1"), y: Ar(e, "y1") },
    { x: Ar(e, "x2"), y: Ar(e, "y2") }
  );
}
function Gm(e) {
  for (var t = e.points, n = 0, r, i = 0; i < t.numberOfItems; i++) {
    var o = t.getItem(i);
    i > 0 && (n += g0(r, o)), r = o;
  }
  return n;
}
function S4(e) {
  var t = e.points;
  return Gm(e) + g0(t.getItem(t.numberOfItems - 1), t.getItem(0));
}
function Jm(e) {
  if (e.getTotalLength)
    return e.getTotalLength();
  switch (e.tagName.toLowerCase()) {
    case "circle":
      return w4(e);
    case "rect":
      return k4(e);
    case "line":
      return x4(e);
    case "polyline":
      return Gm(e);
    case "polygon":
      return S4(e);
  }
}
function C4(e) {
  var t = Jm(e);
  return e.setAttribute("stroke-dasharray", t), t;
}
function T4(e) {
  for (var t = e.parentNode; ze.svg(t) && ze.svg(t.parentNode); )
    t = t.parentNode;
  return t;
}
function Xm(e, t) {
  var n = t || {}, r = n.el || T4(e), i = r.getBoundingClientRect(), o = Ar(r, "viewBox"), a = i.width, s = i.height, l = n.viewBox || (o ? o.split(" ") : [0, 0, a, s]);
  return {
    el: r,
    viewBox: l,
    x: l[0] / 1,
    y: l[1] / 1,
    w: a,
    h: s,
    vW: l[2],
    vH: l[3]
  };
}
function M4(e, t) {
  var n = ze.str(e) ? Um(e)[0] : e, r = t || 100;
  return function(i) {
    return {
      property: i,
      el: n,
      svg: Xm(n),
      totalLength: Jm(n) * (r / 100)
    };
  };
}
function O4(e, t, n) {
  function r(u) {
    u === void 0 && (u = 0);
    var c = t + u >= 1 ? t + u : 0;
    return e.el.getPointAtLength(c);
  }
  var i = Xm(e.el, e.svg), o = r(), a = r(-1), s = r(1), l = n ? 1 : i.w / i.vW, d = n ? 1 : i.h / i.vH;
  switch (e.property) {
    case "x":
      return (o.x - i.x) * l;
    case "y":
      return (o.y - i.y) * d;
    case "angle":
      return Math.atan2(s.y - a.y, s.x - a.x) * 180 / Math.PI;
  }
}
function mp(e, t) {
  var n = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, r = Km(ze.pth(e) ? e.totalLength : e, t) + "";
  return {
    original: r,
    numbers: r.match(n) ? r.match(n).map(Number) : [0],
    strings: ze.str(e) || t ? r.split(n) : []
  };
}
function v0(e) {
  var t = e ? ud(ze.arr(e) ? e.map(hp) : hp(e)) : [];
  return dd(t, function(n, r, i) {
    return i.indexOf(n) === r;
  });
}
function Qm(e) {
  var t = v0(e);
  return t.map(function(n, r) {
    return { target: n, id: r, total: t.length, transforms: { list: Ym(n) } };
  });
}
function E4(e, t) {
  var n = c0(t);
  if (/^spring/.test(n.easing) && (n.duration = jm(n.easing)), ze.arr(e)) {
    var r = e.length, i = r === 2 && !ze.obj(e[0]);
    i ? e = { value: e } : ze.fnc(t.duration) || (n.duration = t.duration / r);
  }
  var o = ze.arr(e) ? e : [e];
  return o.map(function(a, s) {
    var l = ze.obj(a) && !ze.pth(a) ? a : { value: a };
    return ze.und(l.delay) && (l.delay = s ? 0 : t.delay), ze.und(l.endDelay) && (l.endDelay = s === o.length - 1 ? t.endDelay : 0), l;
  }).map(function(a) {
    return cd(a, n);
  });
}
function D4(e) {
  for (var t = dd(ud(e.map(function(o) {
    return Object.keys(o);
  })), function(o) {
    return ze.key(o);
  }).reduce(function(o, a) {
    return o.indexOf(a) < 0 && o.push(a), o;
  }, []), n = {}, r = function(o) {
    var a = t[o];
    n[a] = e.map(function(s) {
      var l = {};
      for (var d in s)
        ze.key(d) ? d == a && (l.value = s[d]) : l[d] = s[d];
      return l;
    });
  }, i = 0; i < t.length; i++) r(i);
  return n;
}
function A4(e, t) {
  var n = [], r = t.keyframes;
  r && (t = cd(D4(r), t));
  for (var i in t)
    ze.key(i) && n.push({
      name: i,
      tweens: E4(t[i], e)
    });
  return n;
}
function P4(e, t) {
  var n = {};
  for (var r in e) {
    var i = oc(e[r], t);
    ze.arr(i) && (i = i.map(function(o) {
      return oc(o, t);
    }), i.length === 1 && (i = i[0])), n[r] = i;
  }
  return n.duration = parseFloat(n.duration), n.delay = parseFloat(n.delay), n;
}
function N4(e, t) {
  var n;
  return e.tweens.map(function(r) {
    var i = P4(r, t), o = i.value, a = ze.arr(o) ? o[1] : o, s = oi(a), l = h0(t.target, e.name, s, t), d = n ? n.to.original : l, u = ze.arr(o) ? o[0] : d, c = oi(u) || oi(l), f = s || c;
    return ze.und(a) && (a = d), i.from = mp(u, f), i.to = mp(m0(a, u), f), i.start = n ? n.end : 0, i.end = i.start + i.delay + i.duration + i.endDelay, i.easing = d0(i.easing, i.duration), i.isPath = ze.pth(o), i.isPathTargetInsideSVG = i.isPath && ze.svg(t.target), i.isColor = ze.col(i.from.original), i.isColor && (i.round = 1), n = i, i;
  });
}
var Zm = {
  css: function(e, t, n) {
    return e.style[t] = n;
  },
  attribute: function(e, t, n) {
    return e.setAttribute(t, n);
  },
  object: function(e, t, n) {
    return e[t] = n;
  },
  transform: function(e, t, n, r, i) {
    if (r.list.set(t, n), t === r.last || i) {
      var o = "";
      r.list.forEach(function(a, s) {
        o += s + "(" + a + ") ";
      }), e.style.transform = o;
    }
  }
};
function e2(e, t) {
  var n = Qm(e);
  n.forEach(function(r) {
    for (var i in t) {
      var o = oc(t[i], r), a = r.target, s = oi(o), l = h0(a, i, s, r), d = s || oi(l), u = m0(Km(o, d), l), c = p0(a, i);
      Zm[c](a, i, u, r.transforms, !0);
    }
  });
}
function I4(e, t) {
  var n = p0(e.target, t.name);
  if (n) {
    var r = N4(t, e), i = r[r.length - 1];
    return {
      type: n,
      property: t.name,
      animatable: e,
      tweens: r,
      duration: i.end,
      delay: r[0].delay,
      endDelay: i.endDelay
    };
  }
}
function R4(e, t) {
  return dd(ud(e.map(function(n) {
    return t.map(function(r) {
      return I4(n, r);
    });
  })), function(n) {
    return !ze.und(n);
  });
}
function t2(e, t) {
  var n = e.length, r = function(o) {
    return o.timelineOffset ? o.timelineOffset : 0;
  }, i = {};
  return i.duration = n ? Math.max.apply(Math, e.map(function(o) {
    return r(o) + o.duration;
  })) : t.duration, i.delay = n ? Math.min.apply(Math, e.map(function(o) {
    return r(o) + o.delay;
  })) : t.delay, i.endDelay = n ? i.duration - Math.max.apply(Math, e.map(function(o) {
    return r(o) + o.duration - o.endDelay;
  })) : t.endDelay, i;
}
var gp = 0;
function _4(e) {
  var t = ic(Vm, e), n = ic(l0, e), r = A4(n, e), i = Qm(e.targets), o = R4(i, r), a = t2(o, n), s = gp;
  return gp++, cd(t, {
    id: s,
    children: [],
    animatables: i,
    animations: o,
    duration: a.duration,
    delay: a.delay,
    endDelay: a.endDelay
  });
}
var rr = [], n2 = function() {
  var e;
  function t() {
    !e && (!vp() || !It.suspendWhenDocumentHidden) && rr.length > 0 && (e = requestAnimationFrame(n));
  }
  function n(i) {
    for (var o = rr.length, a = 0; a < o; ) {
      var s = rr[a];
      s.paused ? (rr.splice(a, 1), o--) : (s.tick(i), a++);
    }
    e = a > 0 ? requestAnimationFrame(n) : void 0;
  }
  function r() {
    It.suspendWhenDocumentHidden && (vp() ? e = cancelAnimationFrame(e) : (rr.forEach(
      function(i) {
        return i._onDocumentVisibility();
      }
    ), n2()));
  }
  return typeof document != "undefined" && document.addEventListener("visibilitychange", r), t;
}();
function vp() {
  return !!document && document.hidden;
}
function It(e) {
  e === void 0 && (e = {});
  var t = 0, n = 0, r = 0, i, o = 0, a = null;
  function s(b) {
    var x = window.Promise && new Promise(function(y) {
      return a = y;
    });
    return b.finished = x, x;
  }
  var l = _4(e);
  s(l);
  function d() {
    var b = l.direction;
    b !== "alternate" && (l.direction = b !== "normal" ? "normal" : "reverse"), l.reversed = !l.reversed, i.forEach(function(x) {
      return x.reversed = l.reversed;
    });
  }
  function u(b) {
    return l.reversed ? l.duration - b : b;
  }
  function c() {
    t = 0, n = u(l.currentTime) * (1 / It.speed);
  }
  function f(b, x) {
    x && x.seek(b - x.timelineOffset);
  }
  function h(b) {
    if (l.reversePlayback)
      for (var y = o; y--; )
        f(b, i[y]);
    else
      for (var x = 0; x < o; x++)
        f(b, i[x]);
  }
  function p(b) {
    for (var x = 0, y = l.animations, C = y.length; x < C; ) {
      var $ = y[x], O = $.animatable, z = $.tweens, P = z.length - 1, U = z[P];
      P && (U = dd(z, function(ee) {
        return b < ee.end;
      })[0] || U);
      for (var ie = Dr(b - U.start - U.delay, 0, U.duration) / U.duration, W = isNaN(ie) ? 1 : U.easing(ie), H = U.to.strings, _ = U.round, T = [], M = U.to.numbers.length, V = void 0, Q = 0; Q < M; Q++) {
        var ue = void 0, oe = U.to.numbers[Q], Y = U.from.numbers[Q] || 0;
        U.isPath ? ue = O4(U.value, W * oe, U.isPathTargetInsideSVG) : ue = Y + W * (oe - Y), _ && (U.isColor && Q > 2 || (ue = Math.round(ue * _) / _)), T.push(ue);
      }
      var ce = H.length;
      if (!ce)
        V = T[0];
      else {
        V = H[0];
        for (var S = 0; S < ce; S++) {
          H[S];
          var j = H[S + 1], Z = T[S];
          isNaN(Z) || (j ? V += Z + j : V += Z + " ");
        }
      }
      Zm[$.type](O.target, $.property, V, O.transforms), $.currentValue = V, x++;
    }
  }
  function m(b) {
    l[b] && !l.passThrough && l[b](l);
  }
  function g() {
    l.remaining && l.remaining !== !0 && l.remaining--;
  }
  function v(b) {
    var x = l.duration, y = l.delay, C = x - l.endDelay, $ = u(b);
    l.progress = Dr($ / x * 100, 0, 100), l.reversePlayback = $ < l.currentTime, i && h($), !l.began && l.currentTime > 0 && (l.began = !0, m("begin")), !l.loopBegan && l.currentTime > 0 && (l.loopBegan = !0, m("loopBegin")), $ <= y && l.currentTime !== 0 && p(0), ($ >= C && l.currentTime !== x || !x) && p(x), $ > y && $ < C ? (l.changeBegan || (l.changeBegan = !0, l.changeCompleted = !1, m("changeBegin")), m("change"), p($)) : l.changeBegan && (l.changeCompleted = !0, l.changeBegan = !1, m("changeComplete")), l.currentTime = Dr($, 0, x), l.began && m("update"), b >= x && (n = 0, g(), l.remaining ? (t = r, m("loopComplete"), l.loopBegan = !1, l.direction === "alternate" && d()) : (l.paused = !0, l.completed || (l.completed = !0, m("loopComplete"), m("complete"), !l.passThrough && "Promise" in window && (a(), s(l)))));
  }
  return l.reset = function() {
    var b = l.direction;
    l.passThrough = !1, l.currentTime = 0, l.progress = 0, l.paused = !0, l.began = !1, l.loopBegan = !1, l.changeBegan = !1, l.completed = !1, l.changeCompleted = !1, l.reversePlayback = !1, l.reversed = b === "reverse", l.remaining = l.loop, i = l.children, o = i.length;
    for (var x = o; x--; )
      l.children[x].reset();
    (l.reversed && l.loop !== !0 || b === "alternate" && l.loop === 1) && l.remaining++, p(l.reversed ? l.duration : 0);
  }, l._onDocumentVisibility = c, l.set = function(b, x) {
    return e2(b, x), l;
  }, l.tick = function(b) {
    r = b, t || (t = r), v((r + (n - t)) * It.speed);
  }, l.seek = function(b) {
    v(u(b));
  }, l.pause = function() {
    l.paused = !0, c();
  }, l.play = function() {
    l.paused && (l.completed && l.reset(), l.paused = !1, rr.push(l), c(), n2());
  }, l.reverse = function() {
    d(), l.completed = !l.reversed, c();
  }, l.restart = function() {
    l.reset(), l.play();
  }, l.remove = function(b) {
    var x = v0(b);
    r2(x, l);
  }, l.reset(), l.autoplay && l.play(), l;
}
function yp(e, t) {
  for (var n = t.length; n--; )
    u0(e, t[n].animatable.target) && t.splice(n, 1);
}
function r2(e, t) {
  var n = t.animations, r = t.children;
  yp(e, n);
  for (var i = r.length; i--; ) {
    var o = r[i], a = o.animations;
    yp(e, a), !a.length && !o.children.length && r.splice(i, 1);
  }
  !n.length && !r.length && t.pause();
}
function L4(e) {
  for (var t = v0(e), n = rr.length; n--; ) {
    var r = rr[n];
    r2(t, r);
  }
}
function F4(e, t) {
  t === void 0 && (t = {});
  var n = t.direction || "normal", r = t.easing ? d0(t.easing) : null, i = t.grid, o = t.axis, a = t.from || 0, s = a === "first", l = a === "center", d = a === "last", u = ze.arr(e), c = parseFloat(u ? e[0] : e), f = u ? parseFloat(e[1]) : 0, h = oi(u ? e[1] : e) || 0, p = t.start || 0 + (u ? c : 0), m = [], g = 0;
  return function(v, b, x) {
    if (s && (a = 0), l && (a = (x - 1) / 2), d && (a = x - 1), !m.length) {
      for (var y = 0; y < x; y++) {
        if (!i)
          m.push(Math.abs(a - y));
        else {
          var C = l ? (i[0] - 1) / 2 : a % i[0], $ = l ? (i[1] - 1) / 2 : Math.floor(a / i[0]), O = y % i[0], z = Math.floor(y / i[0]), P = C - O, U = $ - z, ie = Math.sqrt(P * P + U * U);
          o === "x" && (ie = -P), o === "y" && (ie = -U), m.push(ie);
        }
        g = Math.max.apply(Math, m);
      }
      r && (m = m.map(function(H) {
        return r(H / g) * g;
      })), n === "reverse" && (m = m.map(function(H) {
        return o ? H < 0 ? H * -1 : -H : Math.abs(g - H);
      }));
    }
    var W = u ? (f - c) / g : c;
    return p + W * (Math.round(m[b] * 100) / 100) + h;
  };
}
function B4(e) {
  e === void 0 && (e = {});
  var t = It(e);
  return t.duration = 0, t.add = function(n, r) {
    var i = rr.indexOf(t), o = t.children;
    i > -1 && rr.splice(i, 1);
    function a(f) {
      f.passThrough = !0;
    }
    for (var s = 0; s < o.length; s++)
      a(o[s]);
    var l = cd(n, ic(l0, e));
    l.targets = l.targets || e.targets;
    var d = t.duration;
    l.autoplay = !1, l.direction = t.direction, l.timelineOffset = ze.und(r) ? d : m0(r, d), a(t), t.seek(l.timelineOffset);
    var u = It(l);
    a(u), o.push(u);
    var c = t2(o, e);
    return t.delay = c.delay, t.endDelay = c.endDelay, t.duration = c.duration, t.seek(0), t.reset(), t.autoplay && t.play(), t;
  }, t;
}
It.version = "3.2.1";
It.speed = 1;
It.suspendWhenDocumentHidden = !0;
It.running = rr;
It.remove = L4;
It.get = h0;
It.set = e2;
It.convertPx = f0;
It.path = M4;
It.setDashoffset = C4;
It.stagger = F4;
It.timeline = B4;
It.easing = d0;
It.penner = Wm;
It.random = function(e, t) {
  return Math.floor(Math.random() * (t - e + 1)) + e;
};
var ac = /* @__PURE__ */ ((e) => (e.Right = "right", e.Left = "left", e))(ac || {});
const z4 = { class: "ds-accordion" }, LV = /* @__PURE__ */ $e({
  __name: "DsAccordion",
  props: {
    animationDuration: { default: 500 },
    triggerPosition: { default: ac.Left },
    triggerFullWidth: { type: Boolean },
    modelValue: { type: Boolean },
    noAnimation: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = q(!1), o = q(null), a = q(!1), s = E({
      get: () => i.value,
      set: (c) => {
        r("update:modelValue", c), i.value = c;
      }
    });
    Fe(() => n.modelValue, (c) => {
      i.value = c;
    });
    const l = () => {
      a.value || (s.value = !s.value);
    };
    ot(() => {
      n.modelValue && l();
    });
    const d = (c, f, h = !1) => {
      const p = o.value;
      if (p !== null) {
        if (n.noAnimation) {
          p.style.display = h ? "" : "block";
          return;
        }
        a.value = !0, p.style.height = `${c}px`, p.style.overflow = "hidden", p.style.display = "block", It({
          targets: p,
          height: f,
          duration: n.animationDuration,
          easing: "easeInOutCubic",
          complete: () => {
            p.style.height = "", p.style.overflow = "", h && (p.style.display = ""), a.value = !1;
          }
        });
      }
    }, u = (c, f) => {
      if (o.value === null)
        return { currentHeight: 0, targetHeight: 0 };
      const h = o.value.scrollHeight;
      o.value.style.display = f;
      const p = o.value.scrollHeight;
      return o.value.style.display = c, { currentHeight: h, targetHeight: p };
    };
    return Fe(s, (c) => {
      if (c) {
        const { currentHeight: f, targetHeight: h } = u("", "block");
        d(f, h);
      } else {
        const { currentHeight: f, targetHeight: h } = u("block", "");
        d(f, h, !0);
      }
    }), (c, f) => (k(), A("div", z4, [
      G("div", {
        class: te([{ "flex-row-reverse": c.triggerPosition === D(ac).Right }, "flex"])
      }, [
        G("div", {
          class: te([{ grow: c.triggerFullWidth }, "p-1 cursor-pointer ds-accordion-trigger focus:ring-2 focus:border-blue-700"]),
          onClick: l
        }, [
          se(c.$slots, "trigger", { open: s.value })
        ], 2),
        c.triggerFullWidth ? K("", !0) : se(c.$slots, "header", {
          key: 0,
          open: s.value
        })
      ], 2),
      G("div", {
        ref_key: "accordionBody",
        ref: o,
        class: "relative hidden"
      }, [
        se(c.$slots, "default")
      ], 512)
    ]));
  }
}), V4 = {
  duotone: "fad",
  light: "fal",
  regular: "far",
  solid: "fas",
  brands: "fab"
}, Ue = $e({
  name: "DsIcon",
  components: {
    FontAwesomeIcon: pp
  },
  props: {
    name: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: "solid"
    },
    size: {
      type: String,
      default: "1x"
    },
    spin: {
      type: Boolean
    },
    fixedWidth: {
      type: Boolean
    }
  },
  setup(e) {
    return () => nn(pp, {
      icon: [V4[e.variant], e.name],
      size: e.size,
      spin: e.spin,
      "fixed-width": e.fixedWidth
    });
  }
}), H4 = {
  info: {
    bgColor: "bg-blue-100",
    labelColor: "text-blue-800",
    textColor: "text-blue-700",
    iconColor: "text-blue-500",
    borderColor: "border-blue-500",
    icon: "info-circle"
  },
  success: {
    bgColor: "bg-green-100",
    labelColor: "text-green-800",
    textColor: "text-green-800",
    iconColor: "text-green-500",
    borderColor: "border-green-500",
    icon: "circle-check"
  },
  warning: {
    bgColor: "bg-orange-100",
    labelColor: "text-orange-800",
    textColor: "text-orange-800",
    iconColor: "text-orange-500",
    borderColor: "border-orange-500",
    icon: "exclamation-triangle"
  },
  error: {
    bgColor: "bg-red-100",
    labelColor: "text-red-800",
    textColor: "text-red-700",
    iconColor: "text-red-500",
    borderColor: "border-red-500",
    icon: "exclamation-circle"
  }
}, j4 = $e({
  components: {
    DsIcon: Ue
  },
  props: {
    /**
     * The type of the alert.
     */
    type: {
      type: String,
      required: !0
    },
    /**
     * The label of the alert.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * An optional icon, displayed on the left side of the alert.
     */
    icon: {
      type: String,
      default: ""
    }
  },
  setup(e, t) {
    return {
      config: E(() => H4[e.type]),
      hasSlot: E(() => !!t.slots.default)
    };
  }
}), Je = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, W4 = { class: "flex" };
function U4(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), A("div", {
    class: te([`${e.config.borderColor} ${e.config.bgColor}`, "rounded-md border-l-4 p-3"])
  }, [
    G("div", W4, [
      G("div", {
        class: te(`shrink-0 ${e.config.iconColor} leading-none`)
      }, [
        se(e.$slots, "icon", {}, () => [
          fe(a, {
            name: e.icon || e.config.icon,
            size: "lg",
            "fixed-width": ""
          }, null, 8, ["name"])
        ])
      ], 2),
      G("div", {
        class: te(`ml-3 text-sm leading-5 ${e.config.textColor}`)
      }, [
        e.label ? (k(), A("h3", {
          key: 0,
          class: te(["text-sm leading-5 font-semibold", {
            [e.config.labelColor]: !0,
            "mb-0": !e.hasSlot,
            "mb-2": e.hasSlot
          }])
        }, Te(e.label), 3)) : K("", !0),
        se(e.$slots, "default")
      ], 2)
    ])
  ], 2);
}
const FV = /* @__PURE__ */ Je(j4, [["render", U4]]), q4 = {
  default: {
    bgColor: "bg-gray-100 border-gray-500",
    textColor: "text-gray-700",
    dotColor: "text-gray-500"
  },
  primary: {
    bgColor: "bg-blue-100 border-blue-700",
    textColor: "text-blue-700",
    dotColor: "text-blue-500"
  },
  success: {
    bgColor: "bg-green-100 border-green-800",
    textColor: "text-green-800",
    dotColor: "text-green-700"
  },
  warning: {
    bgColor: "bg-orange-100 border-orange-800",
    textColor: "text-orange-800",
    dotColor: "text-orange-700"
  },
  error: {
    bgColor: "bg-red-100 border-red-700",
    textColor: "text-red-700",
    dotColor: "text-red-500"
  }
}, Y4 = $e({
  name: "DsBadge",
  props: {
    type: {
      type: String,
      default: "default",
      validator: (e) => [
        "default",
        "primary",
        "success",
        "warning",
        "error"
      ].includes(e)
    },
    /**
     * Shows the badge as a "dot" variant.
     * Useful for showing a status without being too intrusive.
     */
    dot: {
      type: Boolean
    }
  },
  setup(e) {
    return {
      config: E(() => q4[e.type])
    };
  }
}), K4 = /* @__PURE__ */ G("circle", {
  cx: "4",
  cy: "4",
  r: "4"
}, null, -1), G4 = [
  K4
], J4 = { class: "leading-none" }, X4 = { class: "leading-none" };
function Q4(e, t, n, r, i, o) {
  return e.dot ? (k(), A("span", {
    key: 0,
    class: te([e.config.textColor, "inline-flex items-center text-sm font-medium leading-5"])
  }, [
    (k(), A("svg", {
      class: te(`mr-2 h-2 w-2 ${e.config.dotColor} shrink-0`),
      fill: "currentColor",
      viewBox: "0 0 8 8"
    }, G4, 2)),
    G("span", J4, [
      se(e.$slots, "default")
    ])
  ], 2)) : (k(), A("span", {
    key: 1,
    class: te([[e.config.bgColor, e.config.textColor], "inline-flex rounded-2xl font-medium text-sm px-3 py-.5 items-center min-h-6 border"])
  }, [
    G("span", X4, [
      se(e.$slots, "default")
    ])
  ], 2));
}
const Z4 = /* @__PURE__ */ Je(Y4, [["render", Q4]]), Es = {
  link: {
    tag: "a",
    attributes(e) {
      return e.disabled ? {} : e.external ? {
        target: "_blank",
        rel: "noreferrer noopener",
        href: e.href
      } : {
        href: e.href
      };
    }
  },
  routerLink: {
    tag: "router-link",
    attributes(e) {
      return e.disabled ? {
        to: "#"
      } : {
        to: e.to ? e.to : e.href
      };
    }
  },
  button: {
    tag: "button",
    attributes(e) {
      return {
        type: "button",
        disabled: e.disabled
      };
    }
  }
}, e5 = {
  sm: "px-2 h-6 text-sm",
  default: "px-3 h-8 text-sm",
  lg: "px-4 h-10 text-base"
}, t5 = {
  primary: {
    default: {
      buttonClass: "border-transparent bg-blue-500 hover:bg-blue-700 active:bg-blue-500 text-white focus:border-blue-800 focus:shadow-outline-blue",
      iconClass: "text-blue-100",
      wrapperClass: "shadow"
    },
    disabled: {
      buttonClass: "border-transparent bg-gray-300 text-white",
      iconClass: "text-gray-100",
      wrapperClass: ""
    }
  },
  danger: {
    default: {
      buttonClass: "border-transparent bg-red-500 hover:bg-red-700 active:bg-red-500 text-white focus:border-red-700 focus:shadow-outline-red",
      iconClass: "text-red-100",
      wrapperClass: "shadow"
    },
    disabled: {
      buttonClass: "border-transparent bg-gray-300 text-white",
      iconClass: "text-gray-100",
      wrapperClass: ""
    }
  },
  "danger-outline": {
    default: {
      buttonClass: "bg-white border-red-500 hover:bg-red-100 active:bg-red-100 text-red-500 focus:border-red-500 focus:shadow-outline-red",
      iconClass: "",
      wrapperClass: ""
    },
    disabled: {
      buttonClass: "border-gray-200 text-gray-500",
      iconClass: "",
      wrapperClass: ""
    }
  },
  secondary: {
    default: {
      buttonClass: "border-transparent bg-blue-100 hover:bg-blue-200 active:bg-blue-100 text-blue-700 hover:text-blue-800 focus:border-blue-500 focus:shadow-outline-blue",
      iconClass: "text-blue-500",
      wrapperClass: ""
    },
    disabled: {
      buttonClass: "border-transparent bg-gray-100 text-gray-500",
      iconClass: "text-gray-300",
      wrapperClass: ""
    }
  },
  outline: {
    default: {
      buttonClass: "bg-white border-blue-300 hover:bg-blue-100 active:bg-blue-100 text-blue-700 focus:border-blue-500 focus:shadow-outline-blue",
      iconClass: "",
      wrapperClass: ""
    },
    disabled: {
      buttonClass: "border-gray-200 text-gray-500",
      iconClass: "",
      wrapperClass: ""
    }
  },
  clear: {
    default: {
      buttonClass: "border-transparent hover:bg-blue-100 active:bg-blue-100 text-blue-700 focus:border-blue-500 focus:shadow-outline-blue",
      iconClass: "",
      wrapperClass: ""
    },
    disabled: {
      buttonClass: "border-transparent text-gray-500",
      iconClass: "",
      wrapperClass: ""
    }
  }
}, n5 = $e({
  name: "DsButton",
  components: {
    DsIcon: Ue
  },
  props: {
    icon: {
      type: String,
      default: ""
    },
    iconVariant: {
      type: String,
      default: "solid"
    },
    textAlign: {
      type: String,
      default: "center"
    },
    iconAlign: {
      type: String,
      default: "left"
    },
    /**
     * Contains a URL which renders this button as a link tag instead.
     */
    href: {
      type: String,
      default: "",
      required: !1
    },
    /**
     * In case the `href` tag is provided, this link will open in a new tab.
     */
    external: {
      type: Boolean
    },
    /**
     * When provided together with a href a router-link is used instead of
     * a html link tag.
     */
    routerLink: {
      type: Boolean
    },
    /**
     * When using a routerLink you can specify a named route via this
     */
    to: {
      type: Object,
      default: () => {
      }
    },
    /**
     * Disables all interaction. Doesn't work when being rendered as a link.
     */
    disabled: {
      type: Boolean
    },
    size: {
      type: String,
      default: "default"
    },
    variant: {
      type: String,
      default: "primary"
    },
    /**
     * Instead of listening to `click` events, a handler can be provided,
     * to support asynchronous loading states.
     */
    handler: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["click"],
  setup(e, t) {
    const n = E(() => e.to ? Es.routerLink : e.href !== "" ? e.routerLink ? Es.routerLink : Es.link : Es.button), r = E(() => {
      var o;
      return Object.keys(t.attrs).reduce(
        (a, s) => {
          const l = t.attrs[s];
          return s === "class" || s === "style" ? a.wrapper[s] = l : s.startsWith("on") || (a.button[s] = l), a;
        },
        {
          wrapper: {},
          button: {
            ...n.value.attributes({
              disabled: e.disabled,
              external: e.external,
              href: e.href,
              to: (o = e.to) != null ? o : {}
            }),
            class: e5[e.size]
          }
        }
      );
    }), i = q(!1);
    return {
      attributes: r,
      type: n,
      variantStyle: E(() => t5[e.variant]),
      iconOrFallback: E(
        () => e.icon || (e.external ? "external-link" : "")
      ),
      hasContents: E(() => t.slots.default !== void 0),
      waiting: i,
      async handleClick(o) {
        if (i.value)
          return o.stopPropagation(), !1;
        try {
          t.emit("click", o), i.value = !0, await e.handler();
        } finally {
          i.value = !1;
        }
        return !0;
      },
      textAlignClass: E(() => {
        switch (e.textAlign) {
          case "left":
            return e.iconAlign === "left" ? "justify-start" : "justify-end";
          case "right":
            return e.iconAlign === "left" ? "justify-end" : "justify-start";
          default:
            return "justify-center";
        }
      })
    };
  }
}), r5 = {
  key: 0,
  class: "absolute left-0 right-0 top-0 bottom-0 flex justify-center items-center"
}, i5 = { class: "truncate" };
function o5(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), A("span", $t({
    class: [
      e.disabled ? e.variantStyle.disabled.wrapperClass : e.variantStyle.default.wrapperClass,
      "inline-flex rounded"
    ]
  }, e.attributes.wrapper), [
    (k(), ge(Qn(e.type.tag), $t(e.attributes.button, {
      class: [[
        e.disabled ? `${e.variantStyle.disabled.buttonClass} cursor-not-allowed` : e.variantStyle.default.buttonClass,
        e.waiting ? "relative" : ""
      ], "inline-block font-medium rounded focus:outline-none transition ease-out duration-100 grow min-w-0 border"],
      onClick: e.handleClick
    }), {
      default: de(() => [
        e.waiting ? (k(), A("div", r5, [
          fe(a, {
            class: te({ "text-lg": e.size !== "sm" }),
            name: "spinner-third",
            variant: "duotone",
            spin: ""
          }, null, 8, ["class"])
        ])) : K("", !0),
        G("div", {
          class: te([{
            invisible: e.waiting,
            "flex-row-reverse": e.iconAlign === "right",
            [e.textAlignClass]: !0
          }, "flex items-center h-full"])
        }, [
          e.iconOrFallback !== "" ? (k(), ge(a, {
            key: 0,
            name: e.iconOrFallback,
            class: te([{
              "-ml-1 mr-1": e.hasContents && e.iconAlign === "left",
              "ml-1 -mr-1": e.hasContents && e.iconAlign === "right",
              "-mx-1": !e.hasContents,
              [e.variantStyle.default.iconClass]: !e.disabled,
              [e.variantStyle.disabled.iconClass]: e.disabled
            }, "pointer-events-none flex-none"]),
            variant: e.iconVariant,
            "fixed-width": ""
          }, null, 8, ["name", "class", "variant"])) : K("", !0),
          G("span", i5, [
            se(e.$slots, "default")
          ])
        ], 2)
      ]),
      _: 3
    }, 16, ["class", "onClick"]))
  ], 16);
}
const gr = /* @__PURE__ */ Je(n5, [["render", o5]]);
var Ta = /* @__PURE__ */ ((e) => (e.Action = "action", e.Media = "media", e.Title = "title", e))(Ta || {});
const a5 = $e({
  name: "DsCard",
  props: {
    flat: {
      type: Boolean
    }
  },
  setup(e, { slots: t }) {
    return {
      hasMedia: t[Ta.Media] !== void 0,
      hasAction: t[Ta.Action] !== void 0,
      hasTitle: t[Ta.Title] !== void 0,
      CardSlot: Ta
    };
  }
}), s5 = { key: 0 }, l5 = {
  key: 1,
  class: "text-xl p-4 pb-0"
}, d5 = { class: "p-4" }, u5 = {
  key: 0,
  class: "border-t space-x-2 p-4"
};
function c5(e, t, n, r, i, o) {
  return k(), A("article", {
    class: te(["bg-white space-y-4 rounded flex flex-col justify-between", {
      "shadow-lg": !e.flat
    }])
  }, [
    G("div", null, [
      e.hasMedia ? (k(), A("div", s5, [
        se(e.$slots, e.CardSlot.Media)
      ])) : K("", !0),
      e.hasTitle ? (k(), A("div", l5, [
        se(e.$slots, e.CardSlot.Title)
      ])) : K("", !0),
      G("div", d5, [
        se(e.$slots, "default")
      ])
    ]),
    e.hasAction ? (k(), A("div", u5, [
      se(e.$slots, e.CardSlot.Action)
    ])) : K("", !0)
  ], 2);
}
const BV = /* @__PURE__ */ Je(a5, [["render", c5]]);
function fd(e) {
  return Lm() ? (Fm(e), !0) : !1;
}
function co(e) {
  return typeof e == "function" ? e() : D(e);
}
const i2 = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const f5 = (e) => e != null, p5 = Object.prototype.toString, h5 = (e) => p5.call(e) === "[object Object]", Rr = () => {
}, m5 = /* @__PURE__ */ g5();
function g5() {
  var e, t;
  return i2 && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function y0(e, t) {
  function n(...r) {
    return new Promise((i, o) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(i).catch(o);
    });
  }
  return n;
}
const o2 = (e) => e();
function v5(e, t = {}) {
  let n, r, i = Rr;
  const o = (s) => {
    clearTimeout(s), i(), i = Rr;
  };
  return (s) => {
    const l = co(e), d = co(t.maxWait);
    return n && o(n), l <= 0 || d !== void 0 && d <= 0 ? (r && (o(r), r = null), Promise.resolve(s())) : new Promise((u, c) => {
      i = t.rejectOnCancel ? c : u, d && !r && (r = setTimeout(() => {
        n && o(n), r = null, u(s());
      }, d)), n = setTimeout(() => {
        r && o(r), r = null, u(s());
      }, l);
    });
  };
}
function y5(...e) {
  let t = 0, n, r = !0, i = Rr, o, a, s, l, d;
  !nc(e[0]) && typeof e[0] == "object" ? { delay: a, trailing: s = !0, leading: l = !0, rejectOnCancel: d = !1 } = e[0] : [a, s = !0, l = !0, d = !1] = e;
  const u = () => {
    n && (clearTimeout(n), n = void 0, i(), i = Rr);
  };
  return (f) => {
    const h = co(a), p = Date.now() - t, m = () => o = f();
    return u(), h <= 0 ? (t = Date.now(), m()) : (p > h && (l || !r) ? (t = Date.now(), m()) : s && (o = new Promise((g, v) => {
      i = d ? v : g, n = setTimeout(() => {
        t = Date.now(), r = !0, g(m()), u();
      }, Math.max(0, h - p));
    })), !l && !n && (n = setTimeout(() => r = !0, h)), r = !1, o);
  };
}
function b5(e) {
  return o0();
}
function bp(e, t = 200, n = !1, r = !0, i = !1) {
  return y0(
    y5(t, n, r, i),
    e
  );
}
function $5(e, t, n = {}) {
  const {
    eventFilter: r = o2,
    ...i
  } = n;
  return Fe(
    e,
    y0(
      r,
      t
    ),
    i
  );
}
function a2(e, t = !0, n) {
  b5() ? ot(e, n) : t ? e() : an(e);
}
function w5(e, t, n = {}) {
  const {
    debounce: r = 0,
    maxWait: i = void 0,
    ...o
  } = n;
  return $5(
    e,
    t,
    {
      ...o,
      eventFilter: v5(r, { maxWait: i })
    }
  );
}
function k5(e, t, n = {}) {
  const {
    eventFilter: r = o2,
    ...i
  } = n, o = y0(
    r,
    t
  );
  let a, s, l;
  if (i.flush === "sync") {
    const d = q(!1);
    s = () => {
    }, a = (u) => {
      d.value = !0, u(), d.value = !1;
    }, l = Fe(
      e,
      (...u) => {
        d.value || o(...u);
      },
      i
    );
  } else {
    const d = [], u = q(0), c = q(0);
    s = () => {
      u.value = c.value;
    }, d.push(
      Fe(
        e,
        () => {
          c.value++;
        },
        { ...i, flush: "sync" }
      )
    ), a = (f) => {
      const h = c.value;
      f(), u.value += c.value - h;
    }, d.push(
      Fe(
        e,
        (...f) => {
          const h = u.value > 0 && u.value === c.value;
          u.value = 0, c.value = 0, !h && o(...f);
        },
        i
      )
    ), l = () => {
      d.forEach((f) => f());
    };
  }
  return { stop: l, ignoreUpdates: a, ignorePrevAsyncUpdates: s };
}
function x5(e, t, n) {
  return Fe(
    e,
    (i, o, a) => {
      i && t(i, o, a);
    },
    {
      ...n,
      once: !1
    }
  );
}
function Un(e) {
  var t;
  const n = co(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const fi = i2 ? window : void 0;
function _n(...e) {
  let t, n, r, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, i] = e, t = fi) : [t, n, r, i] = e, !t)
    return Rr;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const o = [], a = () => {
    o.forEach((u) => u()), o.length = 0;
  }, s = (u, c, f, h) => (u.addEventListener(c, f, h), () => u.removeEventListener(c, f, h)), l = Fe(
    () => [Un(t), co(i)],
    ([u, c]) => {
      if (a(), !u)
        return;
      const f = h5(c) ? { ...c } : c;
      o.push(
        ...n.flatMap((h) => r.map((p) => s(u, h, p, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), a();
  };
  return fd(d), d;
}
let $p = !1;
function S5(e, t, n = {}) {
  const { window: r = fi, ignore: i = [], capture: o = !0, detectIframe: a = !1 } = n;
  if (!r)
    return Rr;
  m5 && !$p && ($p = !0, Array.from(r.document.body.children).forEach((f) => f.addEventListener("click", Rr)), r.document.documentElement.addEventListener("click", Rr));
  let s = !0;
  const l = (f) => i.some((h) => {
    if (typeof h == "string")
      return Array.from(r.document.querySelectorAll(h)).some((p) => p === f.target || f.composedPath().includes(p));
    {
      const p = Un(h);
      return p && (f.target === p || f.composedPath().includes(p));
    }
  }), u = [
    _n(r, "click", (f) => {
      const h = Un(e);
      if (!(!h || h === f.target || f.composedPath().includes(h))) {
        if (f.detail === 0 && (s = !l(f)), !s) {
          s = !0;
          return;
        }
        t(f);
      }
    }, { passive: !0, capture: o }),
    _n(r, "pointerdown", (f) => {
      const h = Un(e);
      s = !l(f) && !!(h && !f.composedPath().includes(h));
    }, { passive: !0 }),
    a && _n(r, "blur", (f) => {
      setTimeout(() => {
        var h;
        const p = Un(e);
        ((h = r.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(p != null && p.contains(r.document.activeElement)) && t(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((f) => f());
}
function C5() {
  const e = q(!1), t = o0();
  return t && ot(() => {
    e.value = !0;
  }, t), e;
}
function b0(e) {
  const t = C5();
  return E(() => (t.value, !!e()));
}
function T5(e, t, n = {}) {
  const { window: r = fi, ...i } = n;
  let o;
  const a = b0(() => r && "MutationObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = E(() => {
    const f = co(e), h = (Array.isArray(f) ? f : [f]).map(Un).filter(f5);
    return new Set(h);
  }), d = Fe(
    () => l.value,
    (f) => {
      s(), a.value && f.size && (o = new MutationObserver(t), f.forEach((h) => o.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => o == null ? void 0 : o.takeRecords(), c = () => {
    s(), d();
  };
  return fd(c), {
    isSupported: a,
    stop: c,
    takeRecords: u
  };
}
function M5(e, t = {}) {
  const { window: n = fi } = t, r = b0(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let i;
  const o = q(!1), a = (d) => {
    o.value = d.matches;
  }, s = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", a) : i.removeListener(a));
  }, l = ps(() => {
    r.value && (s(), i = n.matchMedia(co(e)), "addEventListener" in i ? i.addEventListener("change", a) : i.addListener(a), o.value = i.matches);
  });
  return fd(() => {
    l(), s(), i = void 0;
  }), o;
}
function $0(e, t, n = {}) {
  const { window: r = fi, ...i } = n;
  let o;
  const a = b0(() => r && "ResizeObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = E(() => Array.isArray(e) ? e.map((c) => Un(c)) : [Un(e)]), d = Fe(
    l,
    (c) => {
      if (s(), a.value && r) {
        o = new ResizeObserver(t);
        for (const f of c)
          f && o.observe(f, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), d();
  };
  return fd(u), {
    isSupported: a,
    stop: u
  };
}
function O5(e, t = {}) {
  const {
    delayEnter: n = 0,
    delayLeave: r = 0,
    window: i = fi
  } = t, o = q(!1);
  let a;
  const s = (l) => {
    const d = l ? n : r;
    a && (clearTimeout(a), a = void 0), d ? a = setTimeout(() => o.value = l, d) : o.value = l;
  };
  return i && (_n(e, "mouseenter", () => s(!0), { passive: !0 }), _n(e, "mouseleave", () => s(!1), { passive: !0 })), o;
}
function E5(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: r = fi, box: i = "content-box" } = n, o = E(() => {
    var c, f;
    return (f = (c = Un(e)) == null ? void 0 : c.namespaceURI) == null ? void 0 : f.includes("svg");
  }), a = q(t.width), s = q(t.height), { stop: l } = $0(
    e,
    ([c]) => {
      const f = i === "border-box" ? c.borderBoxSize : i === "content-box" ? c.contentBoxSize : c.devicePixelContentBoxSize;
      if (r && o.value) {
        const h = Un(e);
        if (h) {
          const p = h.getBoundingClientRect();
          a.value = p.width, s.value = p.height;
        }
      } else if (f) {
        const h = Array.isArray(f) ? f : [f];
        a.value = h.reduce((p, { inlineSize: m }) => p + m, 0), s.value = h.reduce((p, { blockSize: m }) => p + m, 0);
      } else
        a.value = c.contentRect.width, s.value = c.contentRect.height;
    },
    n
  );
  a2(() => {
    const c = Un(e);
    c && (a.value = "offsetWidth" in c ? c.offsetWidth : t.width, s.value = "offsetHeight" in c ? c.offsetHeight : t.height);
  });
  const d = Fe(
    () => Un(e),
    (c) => {
      a.value = c ? t.width : 0, s.value = c ? t.height : 0;
    }
  );
  function u() {
    l(), d();
  }
  return {
    width: a,
    height: s,
    stop: u
  };
}
function D5(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: r,
    onSwipeEnd: i,
    onSwipeStart: o,
    passive: a = !0,
    window: s = fi
  } = t, l = Gn({ x: 0, y: 0 }), d = Gn({ x: 0, y: 0 }), u = E(() => l.x - d.x), c = E(() => l.y - d.y), { max: f, abs: h } = Math, p = E(() => f(h(u.value), h(c.value)) >= n), m = q(!1), g = E(() => p.value ? h(u.value) > h(c.value) ? u.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), v = (P) => [P.touches[0].clientX, P.touches[0].clientY], b = (P, U) => {
    l.x = P, l.y = U;
  }, x = (P, U) => {
    d.x = P, d.y = U;
  };
  let y;
  const C = A5(s == null ? void 0 : s.document);
  a ? y = C ? { passive: !0 } : { capture: !1 } : y = C ? { passive: !1, capture: !0 } : { capture: !0 };
  const $ = (P) => {
    m.value && (i == null || i(P, g.value)), m.value = !1;
  }, O = [
    _n(e, "touchstart", (P) => {
      if (P.touches.length !== 1)
        return;
      y.capture && !y.passive && P.preventDefault();
      const [U, ie] = v(P);
      b(U, ie), x(U, ie), o == null || o(P);
    }, y),
    _n(e, "touchmove", (P) => {
      if (P.touches.length !== 1)
        return;
      const [U, ie] = v(P);
      x(U, ie), !m.value && p.value && (m.value = !0), m.value && (r == null || r(P));
    }, y),
    _n(e, ["touchend", "touchcancel"], $, y)
  ];
  return {
    isPassiveEventSupported: C,
    isSwiping: m,
    direction: g,
    coordsStart: l,
    coordsEnd: d,
    lengthX: u,
    lengthY: c,
    stop: () => O.forEach((P) => P())
  };
}
function A5(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", Rr, n), e.removeEventListener("x", Rr), t;
}
function P5(e = {}) {
  const {
    window: t = fi,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: o = !0
  } = e, a = q(n), s = q(r), l = () => {
    t && (o ? (a.value = t.innerWidth, s.value = t.innerHeight) : (a.value = t.document.documentElement.clientWidth, s.value = t.document.documentElement.clientHeight));
  };
  if (l(), a2(l), _n("resize", l, { passive: !0 }), i) {
    const d = M5("(orientation: portrait)");
    Fe(d, () => l());
  }
  return { width: a, height: s };
}
const N5 = { class: "overflow-hidden" }, zV = /* @__PURE__ */ $e({
  __name: "DsCarousel",
  props: {
    items: {},
    direction: {},
    slidesOnly: { type: Boolean },
    infinity: { type: Boolean }
  },
  setup(e, { expose: t }) {
    const n = e, r = q(0), i = q(null), { isSwiping: o, direction: a } = D5(i), s = () => {
      (n.infinity || r.value > 0) && (r.value = (r.value - 1 + n.items.length) % n.items.length);
    }, l = () => {
      (n.infinity || r.value < n.items.length - 1) && (r.value = (r.value + 1) % n.items.length);
    }, d = (c) => {
      r.value = c;
    }, u = () => {
      o.value && a.value === "right" ? s() : o.value && a.value === "left" && l();
    };
    return t({
      previous: s,
      next: l,
      slideTo: d,
      slideIndex: r
    }), (c, f) => (k(), A("div", {
      class: te(["flex flex-grow", [c.direction === "row" ? "flex-row" : "flex-col"]])
    }, [
      G("div", N5, [
        G("div", {
          ref_key: "sliderRef",
          ref: i,
          class: "flex flex-row transition-transform duration-300",
          style: mt({ transform: `translateX(-${r.value * 100}%)` }),
          onTouchend: u
        }, [
          (k(!0), A(Ie, null, Ze(c.items, (h, p) => (k(), A("div", {
            key: p,
            class: "w-full shrink-0"
          }, [
            se(c.$slots, "default", {
              item: h,
              index: p
            })
          ]))), 128))
        ], 36)
      ]),
      c.slidesOnly ? K("", !0) : se(c.$slots, "navigation", {
        key: 0,
        slideIndex: r.value,
        next: l,
        previous: s,
        slideTo: d
      })
    ], 2));
  }
}), I5 = $e({
  name: "DsCheckbox",
  components: {
    DsIcon: Ue
  },
  props: {
    disabled: {
      type: Boolean
    },
    indeterminate: {
      type: Boolean
    },
    modelValue: {
      type: Boolean
    },
    id: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue", "update:indeterminate"],
  setup(e, t) {
    const n = q(!1), r = E({
      get: () => e.modelValue,
      set: (a) => {
        t.emit("update:modelValue", a);
      }
    }), i = () => {
      e.disabled || (r.value = !r.value);
    }, o = (a) => {
      e.disabled || (n.value = a);
    };
    return {
      focus: n,
      activeColor: E(() => e.disabled ? "bg-gray-300 border-gray-300" : "bg-blue-500 border-blue-500"),
      inactiveColor: E(() => e.disabled ? "bg-gray-100 border-gray-200" : "bg-white border-gray-300"),
      active: r,
      handleClick: i,
      handleFocus: o
    };
  }
}), R5 = ["tabindex"], _5 = ["id", "indeterminate", "disabled"];
function L5(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), A("div", {
    class: te(["flex shrink-0 justify-center items-center text-white focus:outline-none", e.disabled ? "cursor-not-allowed" : "cursor-pointer"]),
    tabindex: e.disabled ? -1 : 0,
    onClick: t[1] || (t[1] = (...s) => e.handleClick && e.handleClick(...s)),
    onKeydown: [
      t[2] || (t[2] = Re((s) => e.active = !e.active, ["space"])),
      t[3] || (t[3] = Re((s) => e.active = !e.active, ["enter"]))
    ],
    onFocus: t[4] || (t[4] = (s) => e.handleFocus(!0)),
    onBlur: t[5] || (t[5] = (s) => e.handleFocus(!1))
  }, [
    Jt(G("input", {
      id: e.id,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.active = s),
      indeterminate: e.indeterminate,
      type: "checkbox",
      hidden: "",
      disabled: e.disabled
    }, null, 8, _5), [
      [r4, e.active]
    ]),
    G("div", {
      class: te(["flex shrink-0 justify-center items-center h-5 w-5 border rounded ease-out duration-100 transition-colors", {
        [e.activeColor]: e.active,
        [e.inactiveColor]: !e.active,
        "ring-offset-2 ring-2 ring-blue-500 outline-none": e.focus
      }])
    }, [
      e.indeterminate ? (k(), ge(a, {
        key: 0,
        name: "minus",
        class: "pointer-events-none",
        size: "xs"
      })) : e.active ? (k(), ge(a, {
        key: 1,
        name: "check",
        class: "pointer-events-none",
        size: "xs"
      })) : K("", !0)
    ], 2)
  ], 42, R5);
}
const F5 = /* @__PURE__ */ Je(I5, [["render", L5]]), B5 = new Intl.NumberFormat("de-DE"), z5 = $e({
  name: "DsDataButton",
  components: {
    DsIcon: Ue
  },
  props: {
    /**
     * The number that should be displayed in the button.
     */
    value: {
      type: Number,
      default: 0
    },
    /**
     * Contains a URL which renders this button as a link tag instead.
     */
    href: {
      type: String,
      default: "",
      required: !1
    }
  },
  setup(e) {
    const t = E(() => e.href.length > 0);
    return {
      format: (n) => B5.format(n),
      isLink: t,
      type: E(() => t.value ? {
        component: "a",
        attributes: {
          href: e.href,
          target: "_blank",
          rel: "noreferrer noopener"
        }
      } : {
        component: "button",
        attributes: {
          type: "button"
        }
      })
    };
  }
}), V5 = { class: "font-medium text-blue-700 text-sm leading-none" }, H5 = ["textContent"];
function j5(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), ge(Qn(e.type.component), $t(e.type.attributes, { class: "p-3 text-left rounded flex justify-between items-center cursor-pointer transition-colors bg-blue-100 text-blue-800 hover:bg-blue-200" }), {
    default: de(() => [
      G("div", null, [
        G("div", V5, [
          se(e.$slots, "default")
        ]),
        G("div", {
          class: "font-semibold text-2xl mt-1.5 tracking-tight leading-none",
          textContent: Te(e.format(e.value))
        }, null, 8, H5)
      ]),
      e.isLink ? (k(), ge(a, {
        key: 0,
        name: "external-link",
        class: "ml-2 text-blue-500"
      })) : K("", !0)
    ]),
    _: 3
  }, 16);
}
const VV = /* @__PURE__ */ Je(z5, [["render", j5]]);
var W5 = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function w0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ni = {};
Object.defineProperty(ni, "__esModule", {
  value: !0
});
ni.default = ni.reformatDate = d2 = ni.parseDate = ni.formatDate = void 0;
function U5(e, t) {
  return K5(e) || Y5(e, t) || q5();
}
function q5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function Y5(e, t) {
  var n = [], r = !0, i = !1, o = void 0;
  try {
    for (var a = e[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
      ;
  } catch (l) {
    i = !0, o = l;
  } finally {
    try {
      !r && a.return != null && a.return();
    } finally {
      if (i) throw o;
    }
  }
  return n;
}
function K5(e) {
  if (Array.isArray(e)) return e;
}
var G5 = /([0-3]?[\d])\.?([01]?[\d])\.?([\d]{2,4})/, wp = function(t) {
  return "0".concat(t).slice(-2);
}, s2 = function(t) {
  return t == null ? "" : "".concat(wp(t.getDate()), ".").concat(wp(t.getMonth() + 1), ".").concat(t.getFullYear());
};
ni.formatDate = s2;
var l2 = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.currentCenturyThreshold, i = r === void 0 ? 20 : r, o = t.match(G5);
  if (o === null)
    return null;
  var a = U5(o, 4), s = a[1], l = a[2], d = a[3];
  if (parseInt(s, 10) === 0 || parseInt(l, 10) === 0)
    return null;
  var u;
  if (d.length === 4)
    u = d;
  else {
    var c = d.substr(d.length - 2, 2), f = (/* @__PURE__ */ new Date()).getFullYear(), h = Math.floor(f / 100);
    c > f % 100 + i && (h -= 1), u = h + c;
  }
  return new Date(u, l - 1, s);
}, d2 = ni.parseDate = l2, u2 = function(t) {
  var n = l2(t);
  return n !== null ? s2(n) : t;
};
ni.reformatDate = u2;
var J5 = u2;
ni.default = J5;
function Ve(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function ct(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ir(e, t) {
  const n = Ve(e);
  return isNaN(t) ? ct(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function sr(e, t) {
  const n = Ve(e);
  if (isNaN(t)) return ct(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), i = ct(e, n.getTime());
  i.setMonth(n.getMonth() + t + 1, 0);
  const o = i.getDate();
  return r >= o ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), n);
}
function c2(e, t) {
  const {
    years: n = 0,
    months: r = 0,
    weeks: i = 0,
    days: o = 0,
    hours: a = 0,
    minutes: s = 0,
    seconds: l = 0
  } = t, d = Ve(e), u = r || n ? sr(d, r + n * 12) : d, c = o || i ? ir(u, o + i * 7) : u, f = s + a * 60, p = (l + f * 60) * 1e3;
  return ct(e, c.getTime() + p);
}
function X5(e, t) {
  const n = +Ve(e);
  return ct(e, n + t);
}
const f2 = 6048e5, Q5 = 864e5, Z5 = 6e4, p2 = 36e5, e9 = 1e3;
function t9(e, t) {
  return X5(e, t * p2);
}
let n9 = {};
function $o() {
  return n9;
}
function cr(e, t) {
  var s, l, d, u, c, f, h, p;
  const n = $o(), r = (p = (h = (u = (d = t == null ? void 0 : t.weekStartsOn) != null ? d : (l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) != null ? u : n.weekStartsOn) != null ? h : (f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) != null ? p : 0, i = Ve(e), o = i.getDay(), a = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function Ko(e) {
  return cr(e, { weekStartsOn: 1 });
}
function h2(e) {
  const t = Ve(e), n = t.getFullYear(), r = ct(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Ko(r), o = ct(e, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Ko(o);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function kp(e) {
  const t = Ve(e);
  return t.setHours(0, 0, 0, 0), t;
}
function al(e) {
  const t = Ve(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function m2(e, t) {
  const n = kp(e), r = kp(t), i = +n - al(n), o = +r - al(r);
  return Math.round((i - o) / Q5);
}
function r9(e) {
  const t = h2(e), n = ct(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Ko(n);
}
function i9(e, t) {
  const n = t * 3;
  return sr(e, n);
}
function k0(e, t) {
  return sr(e, t * 12);
}
function g2(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Pa(e) {
  if (!g2(e) && typeof e != "number")
    return !1;
  const t = Ve(e);
  return !isNaN(Number(t));
}
function xp(e) {
  const t = Ve(e);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function v2(e, t) {
  const n = Ve(e.start), r = Ve(e.end);
  let i = +n > +r;
  const o = i ? +n : +r, a = i ? r : n;
  a.setHours(0, 0, 0, 0);
  let s = 1;
  const l = [];
  for (; +a <= o; )
    l.push(Ve(a)), a.setDate(a.getDate() + s), a.setHours(0, 0, 0, 0);
  return i ? l.reverse() : l;
}
function Qi(e) {
  const t = Ve(e), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function o9(e, t) {
  const n = Ve(e.start), r = Ve(e.end);
  let i = +n > +r;
  const o = i ? +Qi(n) : +Qi(r);
  let a = Qi(i ? r : n), s = 1;
  const l = [];
  for (; +a <= o; )
    l.push(Ve(a)), a = i9(a, s);
  return i ? l.reverse() : l;
}
function a9(e) {
  const t = Ve(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function y2(e) {
  const t = Ve(e), n = ct(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function b2(e, t) {
  var s, l, d, u, c, f, h, p;
  const n = $o(), r = (p = (h = (u = (d = t == null ? void 0 : t.weekStartsOn) != null ? d : (l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) != null ? u : n.weekStartsOn) != null ? h : (f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) != null ? p : 0, i = Ve(e), o = i.getDay(), a = (o < r ? -7 : 0) + 6 - (o - r);
  return i.setDate(i.getDate() + a), i.setHours(23, 59, 59, 999), i;
}
function Sp(e) {
  const t = Ve(e), n = t.getMonth(), r = n - n % 3 + 3;
  return t.setMonth(r, 0), t.setHours(23, 59, 59, 999), t;
}
const s9 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, l9 = (e, t, n) => {
  let r;
  const i = s9[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function eu(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const d9 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, u9 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, c9 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, f9 = {
  date: eu({
    formats: d9,
    defaultWidth: "full"
  }),
  time: eu({
    formats: u9,
    defaultWidth: "full"
  }),
  dateTime: eu({
    formats: c9,
    defaultWidth: "full"
  })
}, p9 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, h9 = (e, t, n, r) => p9[e];
function va(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[a];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[o];
  };
}
const m9 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, g9 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, v9 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, y9 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, b9 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, $9 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, w9 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, k9 = {
  ordinalNumber: w9,
  era: va({
    values: m9,
    defaultWidth: "wide"
  }),
  quarter: va({
    values: g9,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: va({
    values: v9,
    defaultWidth: "wide"
  }),
  day: va({
    values: y9,
    defaultWidth: "wide"
  }),
  dayPeriod: va({
    values: b9,
    defaultWidth: "wide",
    formattingValues: $9,
    defaultFormattingWidth: "wide"
  })
};
function ya(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    const a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? S9(s, (c) => c.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      x9(s, (c) => c.test(a))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(d)
    ) : d;
    const u = t.slice(a.length);
    return { value: d, rest: u };
  };
}
function x9(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function S9(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function C9(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(i.length);
    return { value: a, rest: s };
  };
}
const T9 = /^(\d+)(th|st|nd|rd)?/i, M9 = /\d+/i, O9 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, E9 = {
  any: [/^b/i, /^(a|c)/i]
}, D9 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, A9 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, P9 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, N9 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, I9 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, R9 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, _9 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, L9 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, F9 = {
  ordinalNumber: C9({
    matchPattern: T9,
    parsePattern: M9,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ya({
    matchPatterns: O9,
    defaultMatchWidth: "wide",
    parsePatterns: E9,
    defaultParseWidth: "any"
  }),
  quarter: ya({
    matchPatterns: D9,
    defaultMatchWidth: "wide",
    parsePatterns: A9,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ya({
    matchPatterns: P9,
    defaultMatchWidth: "wide",
    parsePatterns: N9,
    defaultParseWidth: "any"
  }),
  day: ya({
    matchPatterns: I9,
    defaultMatchWidth: "wide",
    parsePatterns: R9,
    defaultParseWidth: "any"
  }),
  dayPeriod: ya({
    matchPatterns: _9,
    defaultMatchWidth: "any",
    parsePatterns: L9,
    defaultParseWidth: "any"
  })
}, $2 = {
  code: "en-US",
  formatDistance: l9,
  formatLong: f9,
  formatRelative: h9,
  localize: k9,
  match: F9,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function B9(e) {
  const t = Ve(e);
  return m2(t, y2(t)) + 1;
}
function x0(e) {
  const t = Ve(e), n = +Ko(t) - +r9(t);
  return Math.round(n / f2) + 1;
}
function S0(e, t) {
  var u, c, f, h, p, m, g, v;
  const n = Ve(e), r = n.getFullYear(), i = $o(), o = (v = (g = (h = (f = t == null ? void 0 : t.firstWeekContainsDate) != null ? f : (c = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) != null ? h : i.firstWeekContainsDate) != null ? g : (m = (p = i.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) != null ? v : 1, a = ct(e, 0);
  a.setFullYear(r + 1, 0, o), a.setHours(0, 0, 0, 0);
  const s = cr(a, t), l = ct(e, 0);
  l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0);
  const d = cr(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= d.getTime() ? r : r - 1;
}
function z9(e, t) {
  var s, l, d, u, c, f, h, p;
  const n = $o(), r = (p = (h = (u = (d = t == null ? void 0 : t.firstWeekContainsDate) != null ? d : (l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) != null ? u : n.firstWeekContainsDate) != null ? h : (f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) != null ? p : 1, i = S0(e, t), o = ct(e, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), cr(o, t);
}
function C0(e, t) {
  const n = Ve(e), r = +cr(n, t) - +z9(n, t);
  return Math.round(r / f2) + 1;
}
function ht(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const mi = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return ht(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ht(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ht(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ht(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ht(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ht(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ht(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return ht(i, t.length);
  }
}, Mo = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Cp = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return mi.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = S0(e, r), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const a = o % 100;
      return ht(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : ht(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = h2(e);
    return ht(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ht(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return ht(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return ht(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return mi.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return ht(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = C0(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : ht(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = x0(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ht(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : mi.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = B9(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ht(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return ht(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return ht(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return ht(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = Mo.noon : r === 0 ? i = Mo.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = Mo.evening : r >= 12 ? i = Mo.afternoon : r >= 4 ? i = Mo.morning : i = Mo.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return mi.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : mi.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ht(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ht(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : mi.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : mi.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return mi.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return Mp(r);
      case "XXXX":
      case "XX":
        return Ui(r);
      case "XXXXX":
      case "XXX":
      default:
        return Ui(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Mp(r);
      case "xxxx":
      case "xx":
        return Ui(r);
      case "xxxxx":
      case "xxx":
      default:
        return Ui(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Tp(r, ":");
      case "OOOO":
      default:
        return "GMT" + Ui(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Tp(r, ":");
      case "zzzz":
      default:
        return "GMT" + Ui(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return ht(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return ht(r, t.length);
  }
};
function Tp(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + t + ht(o, 2);
}
function Mp(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ht(Math.abs(e) / 60, 2) : Ui(e, t);
}
function Ui(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = ht(Math.trunc(r / 60), 2), o = ht(r % 60, 2);
  return n + i + t + o;
}
const Op = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, w2 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, V9 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return Op(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Op(r, t)).replace("{{time}}", w2(i, t));
}, sc = {
  p: w2,
  P: V9
}, H9 = /^D+$/, j9 = /^Y+$/, W9 = ["D", "DD", "YY", "YYYY"];
function k2(e) {
  return H9.test(e);
}
function x2(e) {
  return j9.test(e);
}
function lc(e, t, n) {
  const r = U9(e, t, n);
  if (console.warn(r), W9.includes(e)) throw new RangeError(r);
}
function U9(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const q9 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Y9 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, K9 = /^'([^]*?)'?$/, G9 = /''/g, J9 = /[a-zA-Z]/;
function _r(e, t, n) {
  var u, c, f, h, p, m, g, v, b, x, y, C, $, O, z, P, U, ie;
  const r = $o(), i = (c = (u = n == null ? void 0 : n.locale) != null ? u : r.locale) != null ? c : $2, o = (x = (b = (m = (p = n == null ? void 0 : n.firstWeekContainsDate) != null ? p : (h = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) != null ? m : r.firstWeekContainsDate) != null ? b : (v = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) != null ? x : 1, a = (ie = (U = (O = ($ = n == null ? void 0 : n.weekStartsOn) != null ? $ : (C = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : C.weekStartsOn) != null ? O : r.weekStartsOn) != null ? U : (P = (z = r.locale) == null ? void 0 : z.options) == null ? void 0 : P.weekStartsOn) != null ? ie : 0, s = Ve(e);
  if (!Pa(s))
    throw new RangeError("Invalid time value");
  let l = t.match(Y9).map((W) => {
    const H = W[0];
    if (H === "p" || H === "P") {
      const _ = sc[H];
      return _(W, i.formatLong);
    }
    return W;
  }).join("").match(q9).map((W) => {
    if (W === "''")
      return { isToken: !1, value: "'" };
    const H = W[0];
    if (H === "'")
      return { isToken: !1, value: X9(W) };
    if (Cp[H])
      return { isToken: !0, value: W };
    if (H.match(J9))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + H + "`"
      );
    return { isToken: !1, value: W };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const d = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: i
  };
  return l.map((W) => {
    if (!W.isToken) return W.value;
    const H = W.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && x2(H) || !(n != null && n.useAdditionalDayOfYearTokens) && k2(H)) && lc(H, t, String(e));
    const _ = Cp[H[0]];
    return _(s, H, i.localize, d);
  }).join("");
}
function X9(e) {
  const t = e.match(K9);
  return t ? t[1].replace(G9, "'") : e;
}
function Q9(e) {
  return Ve(e).getDay();
}
function Z9(e) {
  const t = Ve(e), n = t.getFullYear(), r = t.getMonth(), i = ct(e, 0);
  return i.setFullYear(n, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function e6() {
  return Object.assign({}, $o());
}
function lr(e) {
  return Ve(e).getHours();
}
function t6(e) {
  let n = Ve(e).getDay();
  return n === 0 && (n = 7), n;
}
function Lr(e) {
  return Ve(e).getMinutes();
}
function at(e) {
  return Ve(e).getMonth();
}
function Go(e) {
  return Ve(e).getSeconds();
}
function nt(e) {
  return Ve(e).getFullYear();
}
function Jo(e, t) {
  const n = Ve(e), r = Ve(t);
  return n.getTime() > r.getTime();
}
function qa(e, t) {
  const n = Ve(e), r = Ve(t);
  return +n < +r;
}
function Bo(e, t) {
  const n = Ve(e), r = Ve(t);
  return +n == +r;
}
function n6(e, t) {
  const n = t instanceof Date ? ct(t, 0) : new t(0);
  return n.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
const r6 = 10;
class S2 {
  constructor() {
    Ne(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class i6 extends S2 {
  constructor(t, n, r, i, o) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = i, o && (this.subPriority = o);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class o6 extends S2 {
  constructor() {
    super(...arguments);
    Ne(this, "priority", r6);
    Ne(this, "subPriority", -1);
  }
  set(n, r) {
    return r.timestampIsSet ? n : ct(n, n6(n, Date));
  }
}
class ft {
  run(t, n, r, i) {
    const o = this.parse(t, n, r, i);
    return o ? {
      setter: new i6(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class a6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 140);
    Ne(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return i.era(n, { width: "wide" }) || i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
    }
  }
  set(n, r, i) {
    return r.era = i, n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const zt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Mr = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Vt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ot(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Or(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, o = n[3] ? parseInt(n[3], 10) : 0, a = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (i * p2 + o * Z5 + a * e9),
    rest: t.slice(n[0].length)
  };
}
function C2(e) {
  return Ot(zt.anyDigitsSigned, e);
}
function Rt(e, t) {
  switch (e) {
    case 1:
      return Ot(zt.singleDigit, t);
    case 2:
      return Ot(zt.twoDigits, t);
    case 3:
      return Ot(zt.threeDigits, t);
    case 4:
      return Ot(zt.fourDigits, t);
    default:
      return Ot(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function sl(e, t) {
  switch (e) {
    case 1:
      return Ot(zt.singleDigitSigned, t);
    case 2:
      return Ot(zt.twoDigitsSigned, t);
    case 3:
      return Ot(zt.threeDigitsSigned, t);
    case 4:
      return Ot(zt.fourDigitsSigned, t);
    default:
      return Ot(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function T0(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function T2(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let i;
  if (r <= 50)
    i = e || 100;
  else {
    const o = r + 50, a = Math.trunc(o / 100) * 100, s = e >= o % 100;
    i = e + a - (s ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function M2(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class s6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 130);
    Ne(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, i) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return Vt(Rt(4, n), o);
      case "yo":
        return Vt(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          o
        );
      default:
        return Vt(Rt(r.length, n), o);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, i) {
    const o = n.getFullYear();
    if (i.isTwoDigitYear) {
      const s = T2(
        i.year,
        o
      );
      return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const a = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class l6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 130);
    Ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return Vt(Rt(4, n), o);
      case "Yo":
        return Vt(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          o
        );
      default:
        return Vt(Rt(r.length, n), o);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, i, o) {
    const a = S0(n, o);
    if (i.isTwoDigitYear) {
      const l = T2(
        i.year,
        a
      );
      return n.setFullYear(
        l,
        0,
        o.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), cr(n, o);
    }
    const s = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(s, 0, o.firstWeekContainsDate), n.setHours(0, 0, 0, 0), cr(n, o);
  }
}
class d6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 130);
    Ne(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return sl(r === "R" ? 4 : r.length, n);
  }
  set(n, r, i) {
    const o = ct(n, 0);
    return o.setFullYear(i, 0, 4), o.setHours(0, 0, 0, 0), Ko(o);
  }
}
class u6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 130);
    Ne(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return sl(r === "u" ? 4 : r.length, n);
  }
  set(n, r, i) {
    return n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class c6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 120);
    Ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "Q":
      case "QQ":
        return Rt(r.length, n);
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class f6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 120);
    Ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "q":
      case "qq":
        return Rt(r.length, n);
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class p6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Ne(this, "priority", 110);
  }
  parse(n, r, i) {
    const o = (a) => a - 1;
    switch (r) {
      case "M":
        return Vt(
          Ot(zt.month, n),
          o
        );
      case "MM":
        return Vt(Rt(2, n), o);
      case "Mo":
        return Vt(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" }) || i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class h6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 110);
    Ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    const o = (a) => a - 1;
    switch (r) {
      case "L":
        return Vt(
          Ot(zt.month, n),
          o
        );
      case "LL":
        return Vt(Rt(2, n), o);
      case "Lo":
        return Vt(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" }) || i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function m6(e, t, n) {
  const r = Ve(e), i = C0(r, n) - t;
  return r.setDate(r.getDate() - i * 7), r;
}
class g6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 100);
    Ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "w":
        return Ot(zt.week, n);
      case "wo":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, i, o) {
    return cr(m6(n, i, o), o);
  }
}
function v6(e, t) {
  const n = Ve(e), r = x0(n) - t;
  return n.setDate(n.getDate() - r * 7), n;
}
class y6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 100);
    Ne(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "I":
        return Ot(zt.week, n);
      case "Io":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, i) {
    return Ko(v6(n, i));
  }
}
const b6 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $6 = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class w6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 90);
    Ne(this, "subPriority", 1);
    Ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "d":
        return Ot(zt.date, n);
      case "do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    const i = n.getFullYear(), o = M2(i), a = n.getMonth();
    return o ? r >= 1 && r <= $6[a] : r >= 1 && r <= b6[a];
  }
  set(n, r, i) {
    return n.setDate(i), n.setHours(0, 0, 0, 0), n;
  }
}
class k6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 90);
    Ne(this, "subpriority", 1);
    Ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "D":
      case "DD":
        return Ot(zt.dayOfYear, n);
      case "Do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    const i = n.getFullYear();
    return M2(i) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, i) {
    return n.setMonth(0, i), n.setHours(0, 0, 0, 0), n;
  }
}
function M0(e, t, n) {
  var c, f, h, p, m, g, v, b;
  const r = $o(), i = (b = (v = (p = (h = n == null ? void 0 : n.weekStartsOn) != null ? h : (f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) != null ? p : r.weekStartsOn) != null ? v : (g = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) != null ? b : 0, o = Ve(e), a = o.getDay(), l = (t % 7 + 7) % 7, d = 7 - i, u = t < 0 || t > 6 ? t - (a + d) % 7 : (l + d) % 7 - (a + d) % 7;
  return ir(o, u);
}
class x6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 90);
    Ne(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, i, o) {
    return n = M0(n, i, o), n.setHours(0, 0, 0, 0), n;
  }
}
class S6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 90);
    Ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i, o) {
    const a = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + o.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "e":
      case "ee":
        return Vt(Rt(r.length, n), a);
      case "eo":
        return Vt(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, i, o) {
    return n = M0(n, i, o), n.setHours(0, 0, 0, 0), n;
  }
}
class C6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 90);
    Ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, i, o) {
    const a = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + o.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      case "c":
      case "cc":
        return Vt(Rt(r.length, n), a);
      case "co":
        return Vt(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return i.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return i.day(n, { width: "wide", context: "standalone" }) || i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, i, o) {
    return n = M0(n, i, o), n.setHours(0, 0, 0, 0), n;
  }
}
function T6(e, t) {
  const n = Ve(e), r = t6(n), i = t - r;
  return ir(n, i);
}
class M6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 90);
    Ne(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    const o = (a) => a === 0 ? 7 : a;
    switch (r) {
      case "i":
      case "ii":
        return Rt(r.length, n);
      case "io":
        return i.ordinalNumber(n, { unit: "day" });
      case "iii":
        return Vt(
          i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return Vt(
          i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return Vt(
          i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return Vt(
          i.day(n, {
            width: "wide",
            context: "formatting"
          }) || i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, i) {
    return n = T6(n, i), n.setHours(0, 0, 0, 0), n;
  }
}
class O6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 80);
    Ne(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, i) {
    return n.setHours(T0(i), 0, 0, 0), n;
  }
}
class E6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 80);
    Ne(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, i) {
    return n.setHours(T0(i), 0, 0, 0), n;
  }
}
class D6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 80);
    Ne(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, i) {
    return n.setHours(T0(i), 0, 0, 0), n;
  }
}
class A6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 70);
    Ne(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "h":
        return Ot(zt.hour12h, n);
      case "ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, i) {
    const o = n.getHours() >= 12;
    return o && i < 12 ? n.setHours(i + 12, 0, 0, 0) : !o && i === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class P6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 70);
    Ne(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "H":
        return Ot(zt.hour23h, n);
      case "Ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, i) {
    return n.setHours(i, 0, 0, 0), n;
  }
}
class N6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 70);
    Ne(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "K":
        return Ot(zt.hour11h, n);
      case "Ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, i) {
    return n.getHours() >= 12 && i < 12 ? n.setHours(i + 12, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class I6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 70);
    Ne(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "k":
        return Ot(zt.hour24h, n);
      case "ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, i) {
    const o = i <= 24 ? i % 24 : i;
    return n.setHours(o, 0, 0, 0), n;
  }
}
class R6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 60);
    Ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "m":
        return Ot(zt.minute, n);
      case "mo":
        return i.ordinalNumber(n, { unit: "minute" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, i) {
    return n.setMinutes(i, 0, 0), n;
  }
}
class _6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 50);
    Ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "s":
        return Ot(zt.second, n);
      case "so":
        return i.ordinalNumber(n, { unit: "second" });
      default:
        return Rt(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, i) {
    return n.setSeconds(i, 0), n;
  }
}
class L6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 30);
    Ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const i = (o) => Math.trunc(o * Math.pow(10, -r.length + 3));
    return Vt(Rt(r.length, n), i);
  }
  set(n, r, i) {
    return n.setMilliseconds(i), n;
  }
}
class F6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 10);
    Ne(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return Or(
          Mr.basicOptionalMinutes,
          n
        );
      case "XX":
        return Or(Mr.basic, n);
      case "XXXX":
        return Or(
          Mr.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Or(
          Mr.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Or(Mr.extended, n);
    }
  }
  set(n, r, i) {
    return r.timestampIsSet ? n : ct(
      n,
      n.getTime() - al(n) - i
    );
  }
}
class B6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 10);
    Ne(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return Or(
          Mr.basicOptionalMinutes,
          n
        );
      case "xx":
        return Or(Mr.basic, n);
      case "xxxx":
        return Or(
          Mr.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Or(
          Mr.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Or(Mr.extended, n);
    }
  }
  set(n, r, i) {
    return r.timestampIsSet ? n : ct(
      n,
      n.getTime() - al(n) - i
    );
  }
}
class z6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 40);
    Ne(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return C2(n);
  }
  set(n, r, i) {
    return [ct(n, i * 1e3), { timestampIsSet: !0 }];
  }
}
class V6 extends ft {
  constructor() {
    super(...arguments);
    Ne(this, "priority", 20);
    Ne(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return C2(n);
  }
  set(n, r, i) {
    return [ct(n, i), { timestampIsSet: !0 }];
  }
}
const H6 = {
  G: new a6(),
  y: new s6(),
  Y: new l6(),
  R: new d6(),
  u: new u6(),
  Q: new c6(),
  q: new f6(),
  M: new p6(),
  L: new h6(),
  w: new g6(),
  I: new y6(),
  d: new w6(),
  D: new k6(),
  E: new x6(),
  e: new S6(),
  c: new C6(),
  i: new M6(),
  a: new O6(),
  b: new E6(),
  B: new D6(),
  h: new A6(),
  H: new P6(),
  K: new N6(),
  k: new I6(),
  m: new R6(),
  s: new _6(),
  S: new L6(),
  X: new F6(),
  x: new B6(),
  t: new z6(),
  T: new V6()
}, j6 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, W6 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, U6 = /^'([^]*?)'?$/, q6 = /''/g, Y6 = /\S/, K6 = /[a-zA-Z]/;
function dc(e, t, n, r) {
  var m, g, v, b, x, y, C, $, O, z, P, U, ie, W, H, _, T, M;
  const i = e6(), o = (g = (m = r == null ? void 0 : r.locale) != null ? m : i.locale) != null ? g : $2, a = (z = (O = (y = (x = r == null ? void 0 : r.firstWeekContainsDate) != null ? x : (b = (v = r == null ? void 0 : r.locale) == null ? void 0 : v.options) == null ? void 0 : b.firstWeekContainsDate) != null ? y : i.firstWeekContainsDate) != null ? O : ($ = (C = i.locale) == null ? void 0 : C.options) == null ? void 0 : $.firstWeekContainsDate) != null ? z : 1, s = (M = (T = (W = (ie = r == null ? void 0 : r.weekStartsOn) != null ? ie : (U = (P = r == null ? void 0 : r.locale) == null ? void 0 : P.options) == null ? void 0 : U.weekStartsOn) != null ? W : i.weekStartsOn) != null ? T : (_ = (H = i.locale) == null ? void 0 : H.options) == null ? void 0 : _.weekStartsOn) != null ? M : 0;
  if (t === "")
    return e === "" ? Ve(n) : ct(n, NaN);
  const l = {
    firstWeekContainsDate: a,
    weekStartsOn: s,
    locale: o
  }, d = [new o6()], u = t.match(W6).map((V) => {
    const Q = V[0];
    if (Q in sc) {
      const ue = sc[Q];
      return ue(V, o.formatLong);
    }
    return V;
  }).join("").match(j6), c = [];
  for (let V of u) {
    !(r != null && r.useAdditionalWeekYearTokens) && x2(V) && lc(V, t, e), !(r != null && r.useAdditionalDayOfYearTokens) && k2(V) && lc(V, t, e);
    const Q = V[0], ue = H6[Q];
    if (ue) {
      const { incompatibleTokens: oe } = ue;
      if (Array.isArray(oe)) {
        const ce = c.find(
          (S) => oe.includes(S.token) || S.token === Q
        );
        if (ce)
          throw new RangeError(
            `The format string mustn't contain \`${ce.fullToken}\` and \`${V}\` at the same time`
          );
      } else if (ue.incompatibleTokens === "*" && c.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${V}\` and any other token at the same time`
        );
      c.push({ token: Q, fullToken: V });
      const Y = ue.run(
        e,
        V,
        o.match,
        l
      );
      if (!Y)
        return ct(n, NaN);
      d.push(Y.setter), e = Y.rest;
    } else {
      if (Q.match(K6))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + Q + "`"
        );
      if (V === "''" ? V = "'" : Q === "'" && (V = G6(V)), e.indexOf(V) === 0)
        e = e.slice(V.length);
      else
        return ct(n, NaN);
    }
  }
  if (e.length > 0 && Y6.test(e))
    return ct(n, NaN);
  const f = d.map((V) => V.priority).sort((V, Q) => Q - V).filter((V, Q, ue) => ue.indexOf(V) === Q).map(
    (V) => d.filter((Q) => Q.priority === V).sort((Q, ue) => ue.subPriority - Q.subPriority)
  ).map((V) => V[0]);
  let h = Ve(n);
  if (isNaN(h.getTime()))
    return ct(n, NaN);
  const p = {};
  for (const V of f) {
    if (!V.validate(h, l))
      return ct(n, NaN);
    const Q = V.set(h, p, l);
    Array.isArray(Q) ? (h = Q[0], Object.assign(p, Q[1])) : h = Q;
  }
  return ct(n, h);
}
function G6(e) {
  return e.match(U6)[1].replace(q6, "'");
}
function Ep(e, t) {
  const n = Qi(e), r = Qi(t);
  return +n == +r;
}
function J6(e, t) {
  return ir(e, -t);
}
function O2(e, t) {
  const n = Ve(e), r = n.getFullYear(), i = n.getDate(), o = ct(e, 0);
  o.setFullYear(r, t, 15), o.setHours(0, 0, 0, 0);
  const a = Z9(o);
  return n.setMonth(t, Math.min(i, a)), n;
}
function bt(e, t) {
  let n = Ve(e);
  return isNaN(+n) ? ct(e, NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = O2(n, t.month)), t.date != null && n.setDate(t.date), t.hours != null && n.setHours(t.hours), t.minutes != null && n.setMinutes(t.minutes), t.seconds != null && n.setSeconds(t.seconds), t.milliseconds != null && n.setMilliseconds(t.milliseconds), n);
}
function E2(e, t) {
  const n = Ve(e);
  return n.setHours(t), n;
}
function O0(e, t) {
  const n = Ve(e);
  return n.setMilliseconds(t), n;
}
function D2(e, t) {
  const n = Ve(e);
  return n.setMinutes(t), n;
}
function E0(e, t) {
  const n = Ve(e);
  return n.setSeconds(t), n;
}
function Pr(e, t) {
  const n = Ve(e);
  return isNaN(+n) ? ct(e, NaN) : (n.setFullYear(t), n);
}
function Xo(e, t) {
  return sr(e, -t);
}
function X6(e, t) {
  const {
    years: n = 0,
    months: r = 0,
    weeks: i = 0,
    days: o = 0,
    hours: a = 0,
    minutes: s = 0,
    seconds: l = 0
  } = t, d = Xo(e, r + n * 12), u = J6(d, o + i * 7), c = s + a * 60, h = (l + c * 60) * 1e3;
  return ct(e, u.getTime() - h);
}
function A2(e, t) {
  return k0(e, -t);
}
function fa() {
  return k(), A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      G("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      G("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      G("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      G("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
fa.compatConfig = {
  MODE: 3
};
function P2() {
  return k(), A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      G("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      G("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
P2.compatConfig = {
  MODE: 3
};
function D0() {
  return k(), A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      G("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
D0.compatConfig = {
  MODE: 3
};
function A0() {
  return k(), A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      G("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
A0.compatConfig = {
  MODE: 3
};
function P0() {
  return k(), A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      G("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      G("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
P0.compatConfig = {
  MODE: 3
};
function N0() {
  return k(), A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      G("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
N0.compatConfig = {
  MODE: 3
};
function I0() {
  return k(), A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      G("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
I0.compatConfig = {
  MODE: 3
};
const Fr = (e, t) => t ? new Date(e.toLocaleString("en-US", { timeZone: t })) : new Date(e), N2 = (e, t) => uc(e, t) || he(), Q6 = (e, t) => t.dateInTz ? Fr(new Date(e), t.dateInTz) : he(e), uc = (e, t) => {
  if (!e)
    return null;
  if (!t)
    return he(e);
  const n = he(e);
  return t.exactMatch ? Q6(e, t) : Fr(n, t.timezone);
}, Z6 = (e) => {
  if (!e)
    return 0;
  const t = /* @__PURE__ */ new Date(), n = new Date(t.toLocaleString("en-US", { timeZone: "UTC" })), r = new Date(t.toLocaleString("en-US", { timeZone: e })), i = r.getTimezoneOffset() / 60;
  return (+n - +r) / (1e3 * 60 * 60) - i;
};
function Dp(e) {
  return (t) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function e8(e) {
  return (t) => _r(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "EEEEEE", { locale: e });
}
const t8 = (e, t, n) => {
  const r = [1, 2, 3, 4, 5, 6, 7];
  let i;
  if (e !== null)
    try {
      i = r.map(e8(e));
    } catch {
      i = r.map(Dp(t));
    }
  else
    i = r.map(Dp(t));
  const o = i.slice(0, n), a = i.slice(n + 1, i.length);
  return [i[n]].concat(...a).concat(...o);
}, R0 = (e, t, n) => {
  const r = [];
  for (let i = +e[0]; i <= +e[1]; i++)
    r.push({ value: +i, text: L2(i, t) });
  return n ? r.reverse() : r;
}, I2 = (e, t, n) => {
  const r = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((o) => {
    const a = o < 10 ? `0${o}` : o;
    return /* @__PURE__ */ new Date(`2017-${a}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const o = n === "long" ? "MMMM" : "MMM";
      return r.map((a, s) => {
        const l = _r(Fr(a, "UTC"), o, { locale: e });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: s
        };
      });
    } catch {
    }
  const i = new Intl.DateTimeFormat(t, { month: n, timeZone: "UTC" });
  return r.map((o, a) => {
    const s = i.format(o);
    return {
      text: s.charAt(0).toUpperCase() + s.substring(1),
      value: a
    };
  });
}, n8 = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], Gt = (e) => {
  const t = D(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, r8 = (e) => ({ type: "dot", ...e != null ? e : {} }), R2 = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, _0 = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Zt = (e) => e, Ap = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, Pp = (e) => e === null, _2 = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, i8 = (e) => {
  const t = [], n = (r) => r.filter((i) => i);
  for (let r = 0; r < e.length; r += 3) {
    const i = [e[r], e[r + 1], e[r + 2]];
    t.push(n(i));
  }
  return t;
}, Ya = (e, t, n) => {
  const r = n != null, i = t != null;
  if (!r && !i)
    return !1;
  const o = +n, a = +t;
  return r && i ? +e > o || +e < a : r ? +e > o : i ? +e < a : !1;
}, Qo = (e, t) => i8(e).map((n) => n.map((r) => {
  const { active: i, disabled: o, isBetween: a, highlighted: s } = t(r);
  return {
    ...r,
    active: i,
    disabled: o,
    className: {
      dp__overlay_cell_active: i,
      dp__overlay_cell: !i,
      dp__overlay_cell_disabled: o,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: o && i,
      dp__cell_in_between: a,
      "dp--highlighted": s
    }
  };
})), Ei = (e, t, n = !1) => {
  e && t.allowStopPropagation && (n && e.stopImmediatePropagation(), e.stopPropagation());
}, o8 = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function a8(e, t) {
  let n = [...document.querySelectorAll(o8())];
  n = n.filter((i) => !e.contains(i) || i.hasAttribute("data-datepicker-instance"));
  const r = n.indexOf(e);
  if (r >= 0 && (t ? r - 1 >= 0 : r + 1 <= n.length))
    return n[r + (t ? -1 : 1)];
}
const s8 = (e, t) => e == null ? void 0 : e.querySelector(`[data-dp-element="${t}"]`), L2 = (e, t) => new Intl.NumberFormat(t, { useGrouping: !1, style: "decimal" }).format(e), L0 = (e) => _r(e, "dd-MM-yyyy"), tu = (e) => Array.isArray(e), ll = (e, t) => t.get(L0(e)), l8 = (e, t) => e ? t ? t instanceof Map ? !!ll(e, t) : t(he(e)) : !1 : !0, Np = (e, t, n, r, i, o) => {
  const a = dc(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: o });
  return Pa(a) && g2(a) ? r || i ? a : bt(a, {
    hours: +n.hours,
    minutes: +(n == null ? void 0 : n.minutes),
    seconds: +(n == null ? void 0 : n.seconds),
    milliseconds: 0
  }) : null;
}, d8 = (e, t, n, r, i, o) => {
  const a = Array.isArray(n) ? n[0] : n;
  if (typeof t == "string")
    return Np(e, t, a, r, i, o);
  if (Array.isArray(t)) {
    let s = null;
    for (const l of t)
      if (s = Np(e, l, a, r, i, o), s)
        break;
    return s;
  }
  return typeof t == "function" ? t(e) : null;
}, he = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), u8 = (e, t, n) => {
  if (t) {
    const i = (e.getMonth() + 1).toString().padStart(2, "0"), o = e.getDate().toString().padStart(2, "0"), a = e.getHours().toString().padStart(2, "0"), s = e.getMinutes().toString().padStart(2, "0"), l = n ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${i}-${o}T${a}:${s}:${l}.000Z`;
  }
  const r = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(r).toISOString();
}, Fn = (e) => {
  let t = he(JSON.parse(JSON.stringify(e)));
  return t = E2(t, 0), t = D2(t, 0), t = E0(t, 0), t = O0(t, 0), t;
}, Di = (e, t, n, r) => {
  let i = e ? he(e) : he();
  return (t || t === 0) && (i = E2(i, +t)), (n || n === 0) && (i = D2(i, +n)), (r || r === 0) && (i = E0(i, +r)), O0(i, 0);
}, Pt = (e, t) => !e || !t ? !1 : qa(Fn(e), Fn(t)), st = (e, t) => !e || !t ? !1 : Bo(Fn(e), Fn(t)), Bt = (e, t) => !e || !t ? !1 : Jo(Fn(e), Fn(t)), pd = (e, t, n) => e != null && e[0] && e != null && e[1] ? Bt(n, e[0]) && Pt(n, e[1]) : e != null && e[0] && t ? Bt(n, e[0]) && Pt(n, t) || Pt(n, e[0]) && Bt(n, t) : !1, or = (e) => {
  const t = bt(new Date(e), { date: 1 });
  return Fn(t);
}, nu = (e, t, n) => t && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((r) => r === t ? [r, n] : [r, isNaN(+e[r]) ? void 0 : +e[r]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, no = (e) => ({
  hours: lr(e),
  minutes: Lr(e),
  seconds: Go(e)
}), F2 = (e, t) => {
  if (t) {
    const n = nt(he(t));
    if (n > e)
      return 12;
    if (n === e)
      return at(he(t));
  }
}, B2 = (e, t) => {
  if (t) {
    const n = nt(he(t));
    return n < e ? -1 : n === e ? at(he(t)) : void 0;
  }
}, Zo = (e) => {
  if (e)
    return nt(he(e));
}, z2 = (e, t) => {
  const n = Bt(e, t) ? t : e, r = Bt(t, e) ? t : e;
  return v2({ start: n, end: r });
}, c8 = (e) => {
  const t = sr(e, 1);
  return { month: at(t), year: nt(t) };
}, Qr = (e, t) => {
  const n = cr(e, { weekStartsOn: +t }), r = b2(e, { weekStartsOn: +t });
  return [n, r];
}, V2 = (e, t) => {
  const n = {
    hours: lr(he()),
    minutes: Lr(he()),
    seconds: t ? Go(he()) : 0
  };
  return Object.assign(n, e);
}, Ci = (e, t, n) => [bt(he(e), { date: 1 }), bt(he(), { month: t, year: n, date: 1 })], ri = (e, t, n) => {
  let r = e ? he(e) : he();
  return (t || t === 0) && (r = O2(r, t)), n && (r = Pr(r, n)), r;
}, H2 = (e, t, n, r, i) => {
  if (!r || i && !t || !i && !n)
    return !1;
  const o = i ? sr(e, 1) : Xo(e, 1), a = [at(o), nt(o)];
  return i ? !p8(...a, t) : !f8(...a, n);
}, f8 = (e, t, n) => Pt(...Ci(n, e, t)) || st(...Ci(n, e, t)), p8 = (e, t, n) => Bt(...Ci(n, e, t)) || st(...Ci(n, e, t)), j2 = (e, t, n, r, i, o, a) => {
  if (typeof t == "function" && !a)
    return t(e);
  const s = n ? { locale: n } : void 0;
  return Array.isArray(e) ? `${_r(e[0], o, s)}${i && !e[1] ? "" : r}${e[1] ? _r(e[1], o, s) : ""}` : _r(e, o, s);
}, Oo = (e) => {
  if (e)
    return null;
  throw new Error(_0.prop("partial-range"));
}, Ds = (e, t) => {
  if (t)
    return e();
  throw new Error(_0.prop("range"));
}, cc = (e) => Array.isArray(e) ? Pa(e[0]) && (e[1] ? Pa(e[1]) : !0) : e ? Pa(e) : !1, h8 = (e, t) => bt(t != null ? t : he(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), ru = (e, t, n, r) => {
  if (!e)
    return !0;
  if (r) {
    const i = n === "max" ? qa(e, t) : Jo(e, t), o = { seconds: 0, milliseconds: 0 };
    return i || Bo(bt(e, o), bt(t, o));
  }
  return n === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, iu = (e, t, n) => e ? h8(e, t) : he(n != null ? n : t), Ip = (e, t, n, r, i) => {
  if (Array.isArray(r)) {
    const a = iu(e, r[0], t), s = iu(e, r[1], t);
    return ru(r[0], a, n, !!t) && ru(r[1], s, n, !!t) && i;
  }
  const o = iu(e, r, t);
  return ru(r, o, n, !!t) && i;
}, ou = (e) => bt(he(), no(e)), m8 = (e, t) => e instanceof Map ? Array.from(e.values()).filter((n) => nt(he(n)) === t).map((n) => at(n)) : [], W2 = (e, t, n) => typeof e == "function" ? e({ month: t, year: n }) : !!e.months.find((r) => r.month === t && r.year === n), F0 = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), ba = Gn({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), U2 = () => {
  const e = (n) => {
    ba.menuFocused = n;
  }, t = (n) => {
    ba.shiftKeyInMenu !== n && (ba.shiftKeyInMenu = n);
  };
  return {
    control: E(() => ({ shiftKeyInMenu: ba.shiftKeyInMenu, menuFocused: ba.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, wt = Gn({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), au = q(null), As = q(!1), su = q(!1), lu = q(!1), du = q(!1), fn = q(0), Ft = q(0), Li = () => {
  const e = E(() => As.value ? [...wt.selectionGrid, wt.actionRow].filter((c) => c.length) : su.value ? [
    ...wt.timePicker[0],
    ...wt.timePicker[1],
    du.value ? [] : [au.value],
    wt.actionRow
  ].filter((c) => c.length) : lu.value ? [...wt.monthPicker, wt.actionRow] : [wt.monthYear, ...wt.calendar, wt.time, wt.actionRow].filter((c) => c.length)), t = (c) => {
    fn.value = c ? fn.value + 1 : fn.value - 1;
    let f = null;
    e.value[Ft.value] && (f = e.value[Ft.value][fn.value]), !f && e.value[Ft.value + (c ? 1 : -1)] ? (Ft.value = Ft.value + (c ? 1 : -1), fn.value = c ? 0 : e.value[Ft.value].length - 1) : f || (fn.value = c ? fn.value - 1 : fn.value + 1);
  }, n = (c) => {
    Ft.value === 0 && !c || Ft.value === e.value.length && c || (Ft.value = c ? Ft.value + 1 : Ft.value - 1, e.value[Ft.value] ? e.value[Ft.value] && !e.value[Ft.value][fn.value] && fn.value !== 0 && (fn.value = e.value[Ft.value].length - 1) : Ft.value = c ? Ft.value - 1 : Ft.value + 1);
  }, r = (c) => {
    let f = null;
    e.value[Ft.value] && (f = e.value[Ft.value][fn.value]), f ? f.focus({ preventScroll: !As.value }) : fn.value = c ? fn.value - 1 : fn.value + 1;
  }, i = () => {
    t(!0), r(!0);
  }, o = () => {
    t(!1), r(!1);
  }, a = () => {
    n(!1), r(!0);
  }, s = () => {
    n(!0), r(!0);
  }, l = (c, f) => {
    wt[f] = c;
  }, d = (c, f) => {
    wt[f] = c;
  }, u = () => {
    fn.value = 0, Ft.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: d,
    setTimePickerBackRef: (c) => {
      au.value = c;
    },
    setSelectionGrid: (c) => {
      As.value = c, u(), c || (wt.selectionGrid = []);
    },
    setTimePicker: (c, f = !1) => {
      su.value = c, du.value = f, u(), c || (wt.timePicker[0] = [], wt.timePicker[1] = []);
    },
    setTimePickerElements: (c, f = 0) => {
      wt.timePicker[f] = c;
    },
    arrowRight: i,
    arrowLeft: o,
    arrowUp: a,
    arrowDown: s,
    clearArrowNav: () => {
      wt.monthYear = [], wt.calendar = [], wt.time = [], wt.actionRow = [], wt.selectionGrid = [], wt.timePicker[0] = [], wt.timePicker[1] = [], As.value = !1, su.value = !1, du.value = !1, lu.value = !1, u(), au.value = null;
    },
    setMonthPicker: (c) => {
      lu.value = c, u();
    },
    refSets: wt
    // exposed for testing
  };
}, Rp = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e != null ? e : {}
}), g8 = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  ...e != null ? e : {}
}), _p = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, v8 = (e) => {
  var a;
  const t = typeof e == "object" && e, n = {
    static: !0,
    solo: !1
  };
  if (!e)
    return { ...n, count: _p(!1) };
  const r = t ? e : {}, i = t ? (a = r.count) != null ? a : !0 : e, o = _p(i);
  return Object.assign(n, r, { count: o });
}, y8 = (e, t, n) => e || (typeof n == "string" ? n : t), b8 = (e) => typeof e == "boolean" ? e ? Rp({}) : !1 : Rp(e), $8 = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...t, ...e != null ? e : {}, enabled: !0 } : { ...t, enabled: e };
}, w8 = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e != null ? e : {}
}), k8 = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e != null ? e : {}
}), x8 = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e != null ? e : {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, S8 = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, ...e != null ? e : {} }), C8 = (e) => {
  const t = {
    dates: Array.isArray(e) ? e.map((n) => he(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...t, ...e != null ? e : {} };
}, T8 = (e) => {
  var t, n;
  return typeof e == "object" ? {
    type: (t = e == null ? void 0 : e.type) != null ? t : "local",
    hideOnOffsetDates: (n = e == null ? void 0 : e.hideOnOffsetDates) != null ? n : !1
  } : {
    type: e,
    hideOnOffsetDates: !1
  };
}, M8 = (e, t) => typeof e == "object" ? { enabled: !0, ...{
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1
}, ...e } : {
  enabled: e,
  noDisabledRange: t.noDisabledRange,
  showLastInRange: t.showLastInRange,
  minMaxRawRange: t.minMaxRawRange,
  partialRange: t.partialRange,
  disableTimeRangeValidation: t.disableTimeRangeValidation,
  maxRange: t.maxRange,
  minRange: t.minRange,
  autoRange: t.autoRange,
  fixedStart: t.fixedStart,
  fixedEnd: t.fixedEnd
}, O8 = (e, t) => {
  var n, r, i;
  return e ? typeof e == "string" ? { timezone: e, exactMatch: !1, dateInTz: void 0, emitTimezone: t, convertModel: !0 } : {
    timezone: e.timezone,
    exactMatch: (n = e.exactMatch) != null ? n : !1,
    dateInTz: (r = e.dateInTz) != null ? r : void 0,
    emitTimezone: t != null ? t : e.emitTimezone,
    convertModel: (i = e.convertModel) != null ? i : !0
  } : { timezone: void 0, exactMatch: !1, emitTimezone: t };
}, uu = (e, t) => new Map(
  e.map((n) => {
    const r = N2(n, t);
    return [L0(r), r];
  })
), E8 = (e, t) => e.length ? new Map(
  e.map((n) => {
    const r = N2(n.date, t);
    return [L0(r), n];
  })
) : null, D8 = (e, t, n, r, i, o, a) => ({
  minDate: uc(e, a),
  maxDate: uc(t, a),
  disabledDates: tu(n) ? uu(n, a) : n,
  allowedDates: tu(r) ? uu(r, a) : null,
  highlight: typeof i == "object" && tu(i == null ? void 0 : i.dates) ? uu(i.dates, a) : i,
  markers: E8(o, a)
}), A8 = (e, t) => {
  var n;
  return typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: +t } : {
    enabled: !!e,
    limit: e.limit ? +e.limit : null,
    dragSelect: (n = e.dragSelect) != null ? n : !0
  };
}, Et = (e) => {
  const t = () => {
    const C = e.enableSeconds ? ":ss" : "", $ = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${$}${C}` : `hh${$}${C} aa`;
  }, n = () => {
    var C;
    return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${((C = g.value) == null ? void 0 : C.type) === "iso" ? "RR" : "ww"}-yyyy` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy";
  }, r = (C) => V2(C, e.enableSeconds), i = () => y.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [r(e.startTime[0]), r(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? r(e.startTime) : null, o = E(() => v8(e.multiCalendars)), a = E(() => i()), s = E(() => g8(e.ariaLabels)), l = E(() => w8(e.filters)), d = E(() => b8(e.transitions)), u = E(() => k8(e.actionRow)), c = E(
    () => y8(e.previewFormat, e.format, n())
  ), f = E(() => $8(e.textInput)), h = E(() => x8(e.inline)), p = E(() => S8(e.config)), m = E(() => C8(e.highlight)), g = E(() => T8(e.weekNumbers)), v = E(() => O8(e.timezone, e.emitTimezone)), b = E(() => A8(e.multiDates, e.multiDatesLimit)), x = E(
    () => D8(
      e.minDate,
      e.maxDate,
      e.disabledDates,
      e.allowedDates,
      m.value,
      e.markers,
      v.value
    )
  ), y = E(
    () => M8(e.range, {
      minMaxRawRange: !1,
      maxRange: e.maxRange,
      minRange: e.minRange,
      noDisabledRange: e.noDisabledRange,
      showLastInRange: e.showLastInRange,
      partialRange: e.partialRange,
      disableTimeRangeValidation: e.disableTimeRangeValidation,
      autoRange: e.autoRange,
      fixedStart: e.fixedStart,
      fixedEnd: e.fixedEnd
    })
  );
  return {
    defaultedTransitions: d,
    defaultedMultiCalendars: o,
    defaultedStartTime: a,
    defaultedAriaLabels: s,
    defaultedFilters: l,
    defaultedActionRow: u,
    defaultedPreviewFormat: c,
    defaultedTextInput: f,
    defaultedInline: h,
    defaultedConfig: p,
    defaultedHighlight: m,
    defaultedWeekNumbers: g,
    defaultedRange: y,
    propDates: x,
    defaultedTz: v,
    defaultedMultiDates: b,
    getDefaultPattern: n,
    getDefaultStartTime: i
  };
};
var tr = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(tr || {}), qi = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(qi || {}), ro = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(ro || {}), Cr = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Cr || {});
const P8 = ["timestamp", "date", "iso"], N8 = (e, t, n) => {
  const r = q(), { defaultedTextInput: i, defaultedRange: o, defaultedTz: a, defaultedMultiDates: s, getDefaultPattern: l } = Et(t), d = q(""), u = Ua(t, "format"), c = Ua(t, "formatLocale");
  Fe(
    r,
    () => {
      typeof t.onInternalModelChange == "function" && e("internal-model-change", r.value, ee(!0));
    },
    { deep: !0 }
  ), Fe(u, () => {
    Q();
  });
  const f = (N) => a.value.timezone && a.value.convertModel ? Fr(N, a.value.timezone) : N, h = (N) => {
    if (a.value.timezone && a.value.convertModel) {
      const Ce = Z6(a.value.timezone);
      return t9(N, Ce);
    }
    return N;
  }, p = (N, Ce, qe = !1) => j2(
    N,
    t.format,
    t.formatLocale,
    i.value.rangeSeparator,
    t.modelAuto,
    Ce != null ? Ce : l(),
    qe
  ), m = (N) => N ? t.modelType ? oe(N) : {
    hours: lr(N),
    minutes: Lr(N),
    seconds: t.enableSeconds ? Go(N) : 0
  } : null, g = (N) => t.modelType ? oe(N) : { month: at(N), year: nt(N) }, v = (N) => Array.isArray(N) ? s.value.enabled ? N.map((Ce) => b(Ce, Pr(he(), Ce))) : Ds(
    () => [
      Pr(he(), N[0]),
      N[1] ? Pr(he(), N[1]) : Oo(o.value.partialRange)
    ],
    o.value.enabled
  ) : Pr(he(), +N), b = (N, Ce) => (typeof N == "string" || typeof N == "number") && t.modelType ? ue(N) : Ce, x = (N) => Array.isArray(N) ? [
    b(
      N[0],
      Di(null, +N[0].hours, +N[0].minutes, N[0].seconds)
    ),
    b(
      N[1],
      Di(null, +N[1].hours, +N[1].minutes, N[1].seconds)
    )
  ] : b(N, Di(null, N.hours, N.minutes, N.seconds)), y = (N) => {
    const Ce = bt(he(), { date: 1 });
    return Array.isArray(N) ? s.value.enabled ? N.map((qe) => b(qe, ri(Ce, +qe.month, +qe.year))) : Ds(
      () => [
        b(N[0], ri(Ce, +N[0].month, +N[0].year)),
        b(
          N[1],
          N[1] ? ri(Ce, +N[1].month, +N[1].year) : Oo(o.value.partialRange)
        )
      ],
      o.value.enabled
    ) : b(N, ri(Ce, +N.month, +N.year));
  }, C = (N) => {
    if (Array.isArray(N))
      return N.map((Ce) => ue(Ce));
    throw new Error(_0.dateArr("multi-dates"));
  }, $ = (N) => {
    if (Array.isArray(N) && o.value.enabled) {
      const Ce = N[0], qe = N[1];
      return [
        he(Array.isArray(Ce) ? Ce[0] : null),
        he(Array.isArray(qe) ? qe[0] : null)
      ];
    }
    return he(N[0]);
  }, O = (N) => t.modelAuto ? Array.isArray(N) ? [ue(N[0]), ue(N[1])] : t.autoApply ? [ue(N)] : [ue(N), null] : Array.isArray(N) ? Ds(
    () => N[1] ? [
      ue(N[0]),
      N[1] ? ue(N[1]) : Oo(o.value.partialRange)
    ] : [ue(N[0])],
    o.value.enabled
  ) : ue(N), z = () => {
    Array.isArray(r.value) && o.value.enabled && r.value.length === 1 && r.value.push(Oo(o.value.partialRange));
  }, P = () => {
    const N = r.value;
    return [
      oe(N[0]),
      N[1] ? oe(N[1]) : Oo(o.value.partialRange)
    ];
  }, U = () => r.value[1] ? P() : oe(Zt(r.value[0])), ie = () => (r.value || []).map((N) => oe(N)), W = (N = !1) => (N || z(), t.modelAuto ? U() : s.value.enabled ? ie() : Array.isArray(r.value) ? Ds(() => P(), o.value.enabled) : oe(Zt(r.value))), H = (N) => !N || Array.isArray(N) && !N.length ? null : t.timePicker ? x(Zt(N)) : t.monthPicker ? y(Zt(N)) : t.yearPicker ? v(Zt(N)) : s.value.enabled ? C(Zt(N)) : t.weekPicker ? $(Zt(N)) : O(Zt(N)), _ = (N) => {
    const Ce = H(N);
    cc(Zt(Ce)) ? (r.value = Zt(Ce), Q()) : (r.value = null, d.value = "");
  }, T = () => {
    const N = (Ce) => _r(Ce, i.value.format);
    return `${N(r.value[0])} ${i.value.rangeSeparator} ${r.value[1] ? N(r.value[1]) : ""}`;
  }, M = () => n.value && r.value ? Array.isArray(r.value) ? T() : _r(r.value, i.value.format) : p(r.value), V = () => r.value ? s.value.enabled ? r.value.map((N) => p(N)).join("; ") : i.value.enabled && typeof i.value.format == "string" ? M() : p(r.value) : "", Q = () => {
    !t.format || typeof t.format == "string" || i.value.enabled && typeof i.value.format == "string" ? d.value = V() : d.value = t.format(r.value);
  }, ue = (N) => {
    if (t.utc) {
      const Ce = new Date(N);
      return t.utc === "preserve" ? new Date(Ce.getTime() + Ce.getTimezoneOffset() * 6e4) : Ce;
    }
    return t.modelType ? P8.includes(t.modelType) ? f(new Date(N)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? f(
      dc(N, l(), /* @__PURE__ */ new Date(), { locale: c.value })
    ) : f(
      dc(N, t.modelType, /* @__PURE__ */ new Date(), { locale: c.value })
    ) : f(new Date(N));
  }, oe = (N) => N ? t.utc ? u8(N, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +h(N) : t.modelType === "iso" ? h(N).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? p(h(N)) : p(h(N), t.modelType, !0) : h(N) : "", Y = (N, Ce = !1, qe = !1) => {
    if (qe)
      return N;
    if (e("update:model-value", N), a.value.emitTimezone && Ce) {
      const I = Array.isArray(N) ? N.map((Me) => Fr(Zt(Me), a.value.emitTimezone)) : Fr(Zt(N), a.value.emitTimezone);
      e("update:model-timezone-value", I);
    }
  }, ce = (N) => Array.isArray(r.value) ? s.value.enabled ? r.value.map((Ce) => N(Ce)) : [
    N(r.value[0]),
    r.value[1] ? N(r.value[1]) : Oo(o.value.partialRange)
  ] : N(Zt(r.value)), S = () => {
    if (Array.isArray(r.value)) {
      const N = Qr(r.value[0], t.weekStart), Ce = r.value[1] ? Qr(r.value[1], t.weekStart) : [];
      return [N.map((qe) => he(qe)), Ce.map((qe) => he(qe))];
    }
    return Qr(r.value, t.weekStart).map((N) => he(N));
  }, j = (N, Ce) => Y(Zt(ce(N)), !1, Ce), Z = (N) => {
    const Ce = S();
    return N ? Ce : e("update:model-value", S());
  }, ee = (N = !1) => (N || Q(), t.monthPicker ? j(g, N) : t.timePicker ? j(m, N) : t.yearPicker ? j(nt, N) : t.weekPicker ? Z(N) : Y(W(N), !0, N));
  return {
    inputValue: d,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? o.value.enabled ? o.value.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: _,
    formatInputValue: Q,
    emitModelValue: ee
  };
}, I8 = (e, t) => {
  const { defaultedFilters: n, propDates: r } = Et(e), { validateMonthYearInRange: i } = Fi(e), o = (u, c) => {
    let f = u;
    return n.value.months.includes(at(f)) ? (f = c ? sr(u, 1) : Xo(u, 1), o(f, c)) : f;
  }, a = (u, c) => {
    let f = u;
    return n.value.years.includes(nt(f)) ? (f = c ? k0(u, 1) : A2(u, 1), a(f, c)) : f;
  }, s = (u, c = !1) => {
    const f = bt(he(), { month: e.month, year: e.year });
    let h = u ? sr(f, 1) : Xo(f, 1);
    e.disableYearSelect && (h = Pr(h, e.year));
    let p = at(h), m = nt(h);
    n.value.months.includes(p) && (h = o(h, u), p = at(h), m = nt(h)), n.value.years.includes(m) && (h = a(h, u), m = nt(h)), i(p, m, u, e.preventMinMaxNavigation) && l(p, m, c);
  }, l = (u, c, f) => {
    t("update-month-year", { month: u, year: c, fromNav: f });
  }, d = E(() => (u) => H2(
    bt(he(), { month: e.month, year: e.year }),
    r.value.maxDate,
    r.value.minDate,
    e.preventMinMaxNavigation,
    u
  ));
  return { handleMonthYearChange: s, isDisabled: d, updateMonthYear: l };
};
var Io = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(Io || {});
const R8 = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: n,
  pickerWrapperRef: r,
  inline: i,
  emit: o,
  props: a,
  slots: s
}) => {
  const l = q({}), d = q(!1), u = q({
    top: "0",
    left: "0"
  }), c = q(!1), f = Ua(a, "teleportCenter");
  Fe(f, () => {
    u.value = JSON.parse(JSON.stringify({})), y();
  });
  const h = (T) => {
    if (a.teleport) {
      const M = T.getBoundingClientRect();
      return {
        left: M.left + window.scrollX,
        top: M.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, p = (T, M) => {
    u.value.left = `${T + M - l.value.width}px`;
  }, m = (T) => {
    u.value.left = `${T}px`;
  }, g = (T, M) => {
    a.position === Io.left && m(T), a.position === Io.right && p(T, M), a.position === Io.center && (u.value.left = `${T + M / 2 - l.value.width / 2}px`);
  }, v = (T) => {
    const { width: M, height: V } = T.getBoundingClientRect(), { top: Q, left: ue } = a.altPosition ? a.altPosition(T) : h(T);
    return { top: +Q, left: +ue, width: M, height: V };
  }, b = () => {
    u.value.left = "50%", u.value.top = "50%", u.value.transform = "translate(-50%, -50%)", u.value.position = "fixed", delete u.value.opacity;
  }, x = () => {
    const T = Gt(n), { top: M, left: V, transform: Q } = a.altPosition(T);
    u.value = { top: `${M}px`, left: `${V}px`, transform: Q != null ? Q : "" };
  }, y = (T = !0) => {
    var M;
    if (!i.value.enabled) {
      if (f.value)
        return b();
      if (a.altPosition !== null)
        return x();
      if (T) {
        const V = a.teleport ? (M = t.value) == null ? void 0 : M.$el : e.value;
        V && (l.value = V.getBoundingClientRect()), o("recalculate-position");
      }
      return ie();
    }
  }, C = ({ inputEl: T, left: M, width: V }) => {
    window.screen.width > 768 && !d.value && g(M, V), z(T);
  }, $ = (T) => {
    const { top: M, left: V, height: Q, width: ue } = v(T);
    u.value.top = `${Q + M + +a.offset}px`, c.value = !1, d.value || (u.value.left = `${V + ue / 2 - l.value.width / 2}px`), C({ inputEl: T, left: V, width: ue });
  }, O = (T) => {
    const { top: M, left: V, width: Q } = v(T);
    u.value.top = `${M - +a.offset - l.value.height}px`, c.value = !0, C({ inputEl: T, left: V, width: Q });
  }, z = (T) => {
    if (a.autoPosition) {
      const { left: M, width: V } = v(T), { left: Q, right: ue } = l.value;
      if (!d.value) {
        if (Math.abs(Q) !== Math.abs(ue)) {
          if (Q <= 0)
            return d.value = !0, m(M);
          if (ue >= document.documentElement.clientWidth)
            return d.value = !0, p(M, V);
        }
        return g(M, V);
      }
    }
  }, P = () => {
    const T = Gt(n);
    if (T) {
      const { height: M } = l.value, { top: V, height: Q } = T.getBoundingClientRect(), ue = window.innerHeight - V - Q, oe = V;
      return M <= ue ? qi.bottom : M > ue && M <= oe ? qi.top : ue >= oe ? qi.bottom : qi.top;
    }
    return qi.bottom;
  }, U = (T) => P() === qi.bottom ? $(T) : O(T), ie = () => {
    const T = Gt(n);
    if (T)
      return a.autoPosition ? U(T) : $(T);
  }, W = function(T) {
    if (T) {
      const M = T.scrollHeight > T.clientHeight, V = window.getComputedStyle(T).overflowY.indexOf("hidden") !== -1;
      return M && !V;
    }
    return !0;
  }, H = function(T) {
    return !T || T === document.body || T.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : W(T) ? T : H(T.assignedSlot ? T.assignedSlot.parentNode : T.parentNode);
  }, _ = (T) => {
    if (T)
      switch (a.position) {
        case Io.left:
          return { left: 0, transform: "translateX(0)" };
        case Io.right:
          return { left: `${T.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${T.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: c,
    menuStyle: u,
    xCorrect: d,
    setMenuPosition: y,
    getScrollableParent: H,
    shadowRender: (T, M) => {
      var V, Q, ue;
      const oe = document.createElement("div"), Y = (V = Gt(n)) == null ? void 0 : V.getBoundingClientRect();
      oe.setAttribute("id", "dp--temp-container");
      const ce = (Q = r.value) != null && Q.clientWidth ? r.value : document.body;
      ce.append(oe);
      const S = _(Y), j = nn(
        T,
        {
          ...M,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...S }
        },
        Object.fromEntries(
          Object.keys(s).filter((Z) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(Z)).map((Z) => [Z, s[Z]])
        )
      );
      fp(j, oe), l.value = (ue = j.el) == null ? void 0 : ue.getBoundingClientRect(), fp(null, oe), ce.removeChild(oe);
    }
  };
}, gi = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] }
], _8 = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], L8 = {
  all: () => gi,
  monthYear: () => gi.filter((e) => e.use.includes("month-year")),
  input: () => _8,
  timePicker: () => gi.filter((e) => e.use.includes("time")),
  action: () => gi.filter((e) => e.use.includes("action")),
  calendar: () => gi.filter((e) => e.use.includes("calendar")),
  menu: () => gi.filter((e) => e.use.includes("menu")),
  shared: () => gi.filter((e) => e.use.includes("shared")),
  yearMode: () => gi.filter((e) => e.use.includes("year-mode"))
}, Ln = (e, t, n) => {
  const r = [];
  return L8[t]().forEach((i) => {
    e[i.name] && r.push(i.name);
  }), n != null && n.length && n.forEach((i) => {
    i.slot && r.push(i.slot);
  }), r;
}, hs = (e) => {
  const t = E(() => (r) => e.value ? r ? e.value.open : e.value.close : ""), n = E(() => (r) => e.value ? r ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: n };
}, ms = (e, t) => {
  const { defaultedRange: n, defaultedTz: r } = Et(e), i = he(Fr(he(), r.value.timezone)), o = q([{ month: at(i), year: nt(i) }]), a = Gn({
    hours: n.value.enabled ? [lr(i), lr(i)] : lr(i),
    minutes: n.value.enabled ? [Lr(i), Lr(i)] : Lr(i),
    seconds: n.value.enabled ? [0, 0] : 0
  }), s = E({
    get: () => e.internalModelValue,
    set: (u) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", u);
    }
  }), l = E(
    () => (u) => o.value[u] ? o.value[u].month : 0
  ), d = E(
    () => (u) => o.value[u] ? o.value[u].year : 0
  );
  return {
    calendars: o,
    time: a,
    modelValue: s,
    month: l,
    year: d,
    today: i
  };
}, F8 = (e, t) => {
  const { defaultedMultiCalendars: n, defaultedMultiDates: r, defaultedHighlight: i, defaultedTz: o, propDates: a, defaultedRange: s } = Et(t), { isDisabled: l } = Fi(t), d = q(null), u = q(Fr(/* @__PURE__ */ new Date(), o.value.timezone)), c = (S) => {
    !S.current && t.hideOffsetDates || (d.value = S.value);
  }, f = () => {
    d.value = null;
  }, h = (S) => Array.isArray(e.value) && s.value.enabled && e.value[0] && d.value ? S ? Bt(d.value, e.value[0]) : Pt(d.value, e.value[0]) : !0, p = (S, j) => {
    const Z = () => e.value ? j ? e.value[0] || null : e.value[1] : null, ee = e.value && Array.isArray(e.value) ? Z() : null;
    return st(he(S.value), ee);
  }, m = (S) => {
    var Z;
    const j = Array.isArray(e.value) ? e.value[0] : null;
    return S ? !Pt((Z = d.value) != null ? Z : null, j) : !0;
  }, g = (S, j = !0) => (s.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !S.current ? !1 : st(he(S.value), e.value[j ? 0 : 1]) : s.value.enabled ? p(S, j) && m(j) || st(S.value, Array.isArray(e.value) ? e.value[0] : null) && h(j) : !1, v = (S, j) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const Z = st(S.value, d.value);
      return j ? Bt(e.value[0], S.value) && Z : Pt(e.value[0], S.value) && Z;
    }
    return !1;
  }, b = (S) => !e.value || t.hideOffsetDates && !S.current ? !1 : s.value.enabled ? t.modelAuto && Array.isArray(e.value) ? st(S.value, e.value[0] ? e.value[0] : u.value) : !1 : r.value.enabled && Array.isArray(e.value) ? e.value.some((j) => st(j, S.value)) : st(S.value, e.value ? e.value : u.value), x = (S) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        if (t.hideOffsetDates && !S.current)
          return !1;
        const j = ir(d.value, +s.value.autoRange), Z = Qr(he(d.value), t.weekStart);
        return t.weekPicker ? st(Z[1], he(S.value)) : st(j, he(S.value));
      }
      return !1;
    }
    return !1;
  }, y = (S) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        const j = ir(d.value, +s.value.autoRange);
        if (t.hideOffsetDates && !S.current)
          return !1;
        const Z = Qr(he(d.value), t.weekStart);
        return t.weekPicker ? Bt(S.value, Z[0]) && Pt(S.value, Z[1]) : Bt(S.value, d.value) && Pt(S.value, j);
      }
      return !1;
    }
    return !1;
  }, C = (S) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        if (t.hideOffsetDates && !S.current)
          return !1;
        const j = Qr(he(d.value), t.weekStart);
        return t.weekPicker ? st(j[0], S.value) : st(d.value, S.value);
      }
      return !1;
    }
    return !1;
  }, $ = (S) => pd(e.value, d.value, S.value), O = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, z = () => t.modelAuto ? R2(t.internalModelValue) : !0, P = (S) => {
    if (t.weekPicker)
      return !1;
    const j = s.value.enabled ? !g(S) && !g(S, !1) : !0;
    return !l(S.value) && !b(S) && !(!S.current && t.hideOffsetDates) && j;
  }, U = (S) => s.value.enabled ? t.modelAuto ? O() && b(S) : !1 : b(S), ie = (S) => i.value ? l8(S.value, a.value.highlight) : !1, W = (S) => {
    const j = l(S.value);
    return j && (typeof i.value == "function" ? !i.value(S.value, j) : !i.value.options.highlightDisabled);
  }, H = (S) => {
    var j;
    return typeof i.value == "function" ? i.value(S.value) : (j = i.value.weekdays) == null ? void 0 : j.includes(S.value.getDay());
  }, _ = (S) => (s.value.enabled || t.weekPicker) && (!(n.value.count > 0) || S.current) && z() && !(!S.current && t.hideOffsetDates) && !b(S) ? $(S) : !1, T = (S) => {
    const { isRangeStart: j, isRangeEnd: Z } = ue(S), ee = s.value.enabled ? j || Z : !1;
    return {
      dp__cell_offset: !S.current,
      dp__pointer: !t.disabled && !(!S.current && t.hideOffsetDates) && !l(S.value),
      dp__cell_disabled: l(S.value),
      dp__cell_highlight: !W(S) && (ie(S) || H(S)) && !U(S) && !ee && !C(S) && !(_(S) && t.weekPicker) && !Z,
      dp__cell_highlight_active: !W(S) && (ie(S) || H(S)) && U(S),
      dp__today: !t.noToday && st(S.value, u.value) && S.current,
      "dp--past": Pt(S.value, u.value),
      "dp--future": Bt(S.value, u.value)
    };
  }, M = (S) => ({
    dp__active_date: U(S),
    dp__date_hover: P(S)
  }), V = (S) => {
    if (e.value && !Array.isArray(e.value)) {
      const j = Qr(e.value, t.weekStart);
      return {
        ...Y(S),
        dp__range_start: st(j[0], S.value),
        dp__range_end: st(j[1], S.value),
        dp__range_between_week: Bt(S.value, j[0]) && Pt(S.value, j[1])
      };
    }
    return {
      ...Y(S)
    };
  }, Q = (S) => {
    if (e.value && Array.isArray(e.value)) {
      const j = Qr(e.value[0], t.weekStart), Z = e.value[1] ? Qr(e.value[1], t.weekStart) : [];
      return {
        ...Y(S),
        dp__range_start: st(j[0], S.value) || st(Z[0], S.value),
        dp__range_end: st(j[1], S.value) || st(Z[1], S.value),
        dp__range_between_week: Bt(S.value, j[0]) && Pt(S.value, j[1]) || Bt(S.value, Z[0]) && Pt(S.value, Z[1]),
        dp__range_between: Bt(S.value, j[1]) && Pt(S.value, Z[0])
      };
    }
    return {
      ...Y(S)
    };
  }, ue = (S) => {
    const j = n.value.count > 0 ? S.current && g(S) && z() : g(S) && z(), Z = n.value.count > 0 ? S.current && g(S, !1) && z() : g(S, !1) && z();
    return { isRangeStart: j, isRangeEnd: Z };
  }, oe = (S) => {
    const { isRangeStart: j, isRangeEnd: Z } = ue(S);
    return {
      dp__range_start: j,
      dp__range_end: Z,
      dp__range_between: _(S),
      dp__date_hover: st(S.value, d.value) && !j && !Z && !t.weekPicker,
      dp__date_hover_start: v(S, !0),
      dp__date_hover_end: v(S, !1)
    };
  }, Y = (S) => ({
    ...oe(S),
    dp__cell_auto_range: y(S),
    dp__cell_auto_range_start: C(S),
    dp__cell_auto_range_end: x(S)
  }), ce = (S) => s.value.enabled ? s.value.autoRange ? Y(S) : t.modelAuto ? { ...M(S), ...oe(S) } : t.weekPicker ? Q(S) : oe(S) : t.weekPicker ? V(S) : M(S);
  return {
    setHoverDate: c,
    clearHoverDate: f,
    getDayClassData: (S) => t.hideOffsetDates && !S.current ? {} : {
      ...T(S),
      ...ce(S),
      [t.dayClass ? t.dayClass(S.value) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName
    }
  };
}, Fi = (e) => {
  const { defaultedFilters: t, defaultedRange: n, propDates: r, defaultedMultiDates: i } = Et(e), o = (W) => r.value.disabledDates ? typeof r.value.disabledDates == "function" ? r.value.disabledDates(he(W)) : !!ll(W, r.value.disabledDates) : !1, a = (W) => {
    const H = r.value.maxDate ? Bt(W, r.value.maxDate) : !1, _ = r.value.minDate ? Pt(W, r.value.minDate) : !1, T = o(W), M = t.value.months.map((Y) => +Y).includes(at(W)), V = e.disabledWeekDays.length ? e.disabledWeekDays.some((Y) => +Y === Q9(W)) : !1, Q = c(W), ue = nt(W), oe = ue < +e.yearRange[0] || ue > +e.yearRange[1];
    return !(H || _ || T || M || oe || V || Q);
  }, s = (W, H) => Pt(...Ci(r.value.minDate, W, H)) || st(...Ci(r.value.minDate, W, H)), l = (W, H) => Bt(...Ci(r.value.maxDate, W, H)) || st(...Ci(r.value.maxDate, W, H)), d = (W, H, _) => {
    let T = !1;
    return r.value.maxDate && _ && l(W, H) && (T = !0), r.value.minDate && !_ && s(W, H) && (T = !0), T;
  }, u = (W, H, _, T) => {
    let M = !1;
    return T ? r.value.minDate && r.value.maxDate ? M = d(W, H, _) : (r.value.minDate && s(W, H) || r.value.maxDate && l(W, H)) && (M = !0) : M = !0, M;
  }, c = (W) => Array.isArray(r.value.allowedDates) && !r.value.allowedDates.length ? !0 : r.value.allowedDates ? !ll(W, r.value.allowedDates) : !1, f = (W) => !a(W), h = (W) => n.value.noDisabledRange ? !v2({ start: W[0], end: W[1] }).some((H) => f(H)) : !0, p = (W) => {
    if (W) {
      const H = nt(W);
      return H >= +e.yearRange[0] && H <= e.yearRange[1];
    }
    return !0;
  }, m = (W, H) => !!(Array.isArray(W) && W[H] && (n.value.maxRange || n.value.minRange) && p(W[H])), g = (W, H, _ = 0) => {
    if (m(H, _) && p(W)) {
      const T = m2(W, H[_]), M = z2(H[_], W), V = M.length === 1 ? 0 : M.filter((ue) => f(ue)).length, Q = Math.abs(T) - (n.value.minMaxRawRange ? 0 : V);
      if (n.value.minRange && n.value.maxRange)
        return Q >= +n.value.minRange && Q <= +n.value.maxRange;
      if (n.value.minRange)
        return Q >= +n.value.minRange;
      if (n.value.maxRange)
        return Q <= +n.value.maxRange;
    }
    return !0;
  }, v = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, b = (W) => Array.isArray(W) ? [W[0] ? ou(W[0]) : null, W[1] ? ou(W[1]) : null] : ou(W), x = (W, H, _) => W.find(
    (T) => +T.hours === lr(H) && T.minutes === "*" ? !0 : +T.minutes === Lr(H) && +T.hours === lr(H)
  ) && _, y = (W, H, _) => {
    const [T, M] = W, [V, Q] = H;
    return !x(T, V, _) && !x(M, Q, _) && _;
  }, C = (W, H) => {
    const _ = Array.isArray(H) ? H : [H];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? y(e.disabledTimes, _, W) : !_.some((T) => x(e.disabledTimes, T, W)) : W;
  }, $ = (W, H) => {
    const _ = Array.isArray(H) ? [no(H[0]), H[1] ? no(H[1]) : void 0] : no(H), T = !e.disabledTimes(_);
    return W && T;
  }, O = (W, H) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? C(H, W) : $(H, W) : H, z = (W) => {
    let H = !0;
    if (!W || v())
      return !0;
    const _ = !r.value.minDate && !r.value.maxDate ? b(W) : W;
    return (e.maxTime || r.value.maxDate) && (H = Ip(
      e.maxTime,
      r.value.maxDate,
      "max",
      Zt(_),
      H
    )), (e.minTime || r.value.minDate) && (H = Ip(
      e.minTime,
      r.value.minDate,
      "min",
      Zt(_),
      H
    )), O(W, H);
  }, P = (W) => {
    if (!e.monthPicker)
      return !0;
    let H = !0;
    const _ = he(or(W));
    if (r.value.minDate && r.value.maxDate) {
      const T = he(or(r.value.minDate)), M = he(or(r.value.maxDate));
      return Bt(_, T) && Pt(_, M) || st(_, T) || st(_, M);
    }
    if (r.value.minDate) {
      const T = he(or(r.value.minDate));
      H = Bt(_, T) || st(_, T);
    }
    if (r.value.maxDate) {
      const T = he(or(r.value.maxDate));
      H = Pt(_, T) || st(_, T);
    }
    return H;
  }, U = E(() => (W) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : z(W)), ie = E(() => (W) => e.monthPicker ? Array.isArray(W) && (n.value.enabled || i.value.enabled) ? !W.filter((H) => !P(H)).length : P(W) : !0);
  return {
    isDisabled: f,
    validateDate: a,
    validateMonthYearInRange: u,
    isDateRangeAllowed: h,
    checkMinMaxRange: g,
    isValidTime: z,
    isTimeValid: U,
    isMonthValid: ie
  };
}, hd = () => {
  const e = E(() => (r, i) => r == null ? void 0 : r.includes(i)), t = E(() => (r, i) => r.count ? r.solo ? !0 : i === 0 : !0), n = E(() => (r, i) => r.count ? r.solo ? !0 : i === r.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: n };
}, B8 = (e, t, n) => {
  const r = q(0), i = Gn({
    [ro.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [ro.calendar]: !1,
    [ro.header]: !1
  }), o = E(() => e.monthPicker || e.timePicker), a = (c) => {
    var f;
    if ((f = e.flow) != null && f.length) {
      if (!c && o.value)
        return u();
      i[c] = !0, Object.keys(i).filter((h) => !i[h]).length || u();
    }
  }, s = () => {
    var c;
    (c = e.flow) != null && c.length && r.value !== -1 && (r.value += 1, t("flow-step", r.value), u());
  }, l = () => {
    r.value = -1;
  }, d = (c, f, ...h) => {
    var p, m;
    e.flow[r.value] === c && n.value && ((m = (p = n.value)[f]) == null || m.call(p, ...h));
  }, u = () => {
    d(Cr.month, "toggleMonthPicker", !0), d(Cr.year, "toggleYearPicker", !0), d(Cr.calendar, "toggleTimePicker", !1, !0), d(Cr.time, "toggleTimePicker", !0, !0);
    const c = e.flow[r.value];
    (c === Cr.hours || c === Cr.minutes || c === Cr.seconds) && d(c, "toggleTimePicker", !0, !0, c);
  };
  return { childMount: a, updateFlowStep: s, resetFlow: l, flowStep: r };
}, md = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 }
}, vr = {
  ...md,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) }
}, z8 = {
  key: 1,
  class: "dp__input_wrap"
}, V8 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], H8 = {
  key: 2,
  class: "dp__clear_icon"
}, j8 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...md
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, {
      defaultedTextInput: o,
      defaultedAriaLabels: a,
      defaultedInline: s,
      defaultedConfig: l,
      defaultedRange: d,
      defaultedMultiDates: u,
      getDefaultPattern: c,
      getDefaultStartTime: f
    } = Et(i), { checkMinMaxRange: h } = Fi(i), p = q(), m = q(null), g = q(!1), v = q(!1), b = E(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !o.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !o.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !i.hideInputIcon,
        dp__input_valid: !!i.state,
        dp__input_invalid: i.state === !1,
        dp__input_focus: g.value || i.isMenuOpen,
        dp__input_reg: !o.value.enabled,
        [i.inputClassName]: !!i.inputClassName
      })
    ), x = () => {
      r("set-input-date", null), i.clearable && i.autoApply && (r("set-empty-date"), p.value = null);
    }, y = (M) => {
      var Q;
      const V = f();
      return d8(
        M,
        (Q = o.value.format) != null ? Q : c(),
        V != null ? V : V2({}, i.enableSeconds),
        i.inputValue,
        v.value,
        i.formatLocale
      );
    }, C = (M) => {
      const { rangeSeparator: V } = o.value, [Q, ue] = M.split(`${V}`);
      if (Q) {
        const oe = y(Q.trim()), Y = ue ? y(ue.trim()) : null;
        if (Jo(oe, Y))
          return;
        const ce = oe && Y ? [oe, Y] : [oe];
        h(Y, ce, 0) && (p.value = oe ? ce : null);
      }
    }, $ = () => {
      v.value = !0;
    }, O = (M) => {
      if (d.value.enabled)
        C(M);
      else if (u.value.enabled) {
        const V = M.split(";");
        p.value = V.map((Q) => y(Q.trim())).filter((Q) => Q);
      } else
        p.value = y(M);
    }, z = (M) => {
      var V;
      const Q = typeof M == "string" ? M : (V = M.target) == null ? void 0 : V.value;
      Q !== "" ? (o.value.openMenu && !i.isMenuOpen && r("open"), O(Q), r("set-input-date", p.value)) : x(), v.value = !1, r("update:input-value", Q);
    }, P = (M) => {
      o.value.enabled ? (O(M.target.value), o.value.enterSubmit && cc(p.value) && i.inputValue !== "" ? (r("set-input-date", p.value, !0), p.value = null) : o.value.enterSubmit && i.inputValue === "" && (p.value = null, r("clear"))) : W(M);
    }, U = (M) => {
      o.value.enabled && o.value.tabSubmit && O(M.target.value), o.value.tabSubmit && cc(p.value) && i.inputValue !== "" ? (r("set-input-date", p.value, !0, !0), p.value = null) : o.value.tabSubmit && i.inputValue === "" && (p.value = null, r("clear", !0));
    }, ie = () => {
      g.value = !0, r("focus"), an().then(() => {
        var M;
        o.value.enabled && o.value.selectOnFocus && ((M = m.value) == null || M.select());
      });
    }, W = (M) => {
      M.preventDefault(), Ei(M, l.value, !0), o.value.enabled && o.value.openMenu && !s.value.input && !i.isMenuOpen ? r("open") : o.value.enabled || r("toggle");
    }, H = () => {
      r("real-blur"), g.value = !1, (!i.isMenuOpen || s.value.enabled && s.value.input) && r("blur"), i.autoApply && o.value.enabled && p.value && !i.isMenuOpen && (r("set-input-date", p.value), r("select-date"), p.value = null);
    }, _ = (M) => {
      Ei(M, l.value, !0), r("clear");
    }, T = (M) => {
      if (!o.value.enabled) {
        if (M.code === "Tab")
          return;
        M.preventDefault();
      }
    };
    return t({
      focusInput: () => {
        var M;
        (M = m.value) == null || M.focus({ preventScroll: !0 });
      },
      setParsedDate: (M) => {
        p.value = M;
      }
    }), (M, V) => {
      var Q;
      return k(), A("div", { onClick: W }, [
        M.$slots.trigger && !M.$slots["dp-input"] && !D(s).enabled ? se(M.$slots, "trigger", { key: 0 }) : K("", !0),
        !M.$slots.trigger && (!D(s).enabled || D(s).input) ? (k(), A("div", z8, [
          M.$slots["dp-input"] && !M.$slots.trigger && (!D(s).enabled || D(s).enabled && D(s).input) ? se(M.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: z,
            onEnter: P,
            onTab: U,
            onClear: _,
            onBlur: H,
            onKeypress: T,
            onPaste: $,
            openMenu: () => M.$emit("open"),
            closeMenu: () => M.$emit("close"),
            toggleMenu: () => M.$emit("toggle")
          }) : K("", !0),
          M.$slots["dp-input"] ? K("", !0) : (k(), A("input", {
            key: 1,
            id: M.uid ? `dp-input-${M.uid}` : void 0,
            ref_key: "inputRef",
            ref: m,
            "data-test": "dp-input",
            name: M.name,
            class: te(b.value),
            inputmode: D(o).enabled ? "text" : "none",
            placeholder: M.placeholder,
            disabled: M.disabled,
            readonly: M.readonly,
            required: M.required,
            value: e.inputValue,
            autocomplete: M.autocomplete,
            "aria-label": (Q = D(a)) == null ? void 0 : Q.input,
            "aria-disabled": M.disabled || void 0,
            "aria-invalid": M.state === !1 ? !0 : void 0,
            onInput: z,
            onKeydown: [
              Re(P, ["enter"]),
              Re(U, ["tab"]),
              T
            ],
            onBlur: H,
            onFocus: ie,
            onKeypress: T,
            onPaste: $
          }, null, 42, V8)),
          G("div", {
            onClick: V[2] || (V[2] = (ue) => r("toggle"))
          }, [
            M.$slots["input-icon"] && !M.hideInputIcon ? (k(), A("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: V[0] || (V[0] = (ue) => r("toggle"))
            }, [
              se(M.$slots, "input-icon")
            ])) : K("", !0),
            !M.$slots["input-icon"] && !M.hideInputIcon && !M.$slots["dp-input"] ? (k(), ge(D(fa), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: V[1] || (V[1] = (ue) => r("toggle"))
            })) : K("", !0)
          ]),
          M.$slots["clear-icon"] && e.inputValue && M.clearable && !M.disabled && !M.readonly ? (k(), A("span", H8, [
            se(M.$slots, "clear-icon", { clear: _ })
          ])) : K("", !0),
          M.clearable && !M.$slots["clear-icon"] && e.inputValue && !M.disabled && !M.readonly ? (k(), ge(D(P2), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: V[3] || (V[3] = Ge((ue) => _(ue), ["prevent"]))
          })) : K("", !0)
        ])) : K("", !0)
      ]);
    };
  }
}), W8 = ["title"], U8 = ["disabled"], q8 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...vr
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const n = t, r = e, {
      defaultedActionRow: i,
      defaultedPreviewFormat: o,
      defaultedMultiCalendars: a,
      defaultedTextInput: s,
      defaultedInline: l,
      defaultedRange: d,
      defaultedMultiDates: u,
      getDefaultPattern: c
    } = Et(r), { isTimeValid: f, isMonthValid: h } = Fi(r), { buildMatrix: p } = Li(), m = q(null), g = q(null), v = q(!1), b = q({}), x = q(null), y = q(null);
    ot(() => {
      r.arrowNavigation && p([Gt(m), Gt(g)], "actionRow"), C(), window.addEventListener("resize", C);
    }), hr(() => {
      window.removeEventListener("resize", C);
    });
    const C = () => {
      v.value = !1, setTimeout(() => {
        var T, M;
        const V = (T = x.value) == null ? void 0 : T.getBoundingClientRect(), Q = (M = y.value) == null ? void 0 : M.getBoundingClientRect();
        V && Q && (b.value.maxWidth = `${Q.width - V.width - 20}px`), v.value = !0;
      }, 0);
    }, $ = E(() => d.value.enabled && !d.value.partialRange && r.internalModelValue ? r.internalModelValue.length === 2 : !0), O = E(
      () => !f.value(r.internalModelValue) || !h.value(r.internalModelValue) || !$.value
    ), z = () => {
      const T = o.value;
      return r.timePicker || r.monthPicker, T(Zt(r.internalModelValue));
    }, P = () => {
      const T = r.internalModelValue;
      return a.value.count > 0 ? `${U(T[0])} - ${U(T[1])}` : [U(T[0]), U(T[1])];
    }, U = (T) => j2(
      T,
      o.value,
      r.formatLocale,
      s.value.rangeSeparator,
      r.modelAuto,
      c()
    ), ie = E(() => !r.internalModelValue || !r.menuMount ? "" : typeof o.value == "string" ? Array.isArray(r.internalModelValue) ? r.internalModelValue.length === 2 && r.internalModelValue[1] ? P() : u.value.enabled ? r.internalModelValue.map((T) => `${U(T)}`) : r.modelAuto ? `${U(r.internalModelValue[0])}` : `${U(r.internalModelValue[0])} -` : U(r.internalModelValue) : z()), W = () => u.value.enabled ? "; " : " - ", H = E(
      () => Array.isArray(ie.value) ? ie.value.join(W()) : ie.value
    ), _ = () => {
      f.value(r.internalModelValue) && h.value(r.internalModelValue) && $.value ? n("select-date") : n("invalid-select");
    };
    return (T, M) => (k(), A("div", {
      ref_key: "actionRowRef",
      ref: y,
      class: "dp__action_row"
    }, [
      T.$slots["action-row"] ? se(T.$slots, "action-row", tn($t({ key: 0 }, {
        internalModelValue: T.internalModelValue,
        disabled: O.value,
        selectDate: () => T.$emit("select-date"),
        closePicker: () => T.$emit("close-picker")
      }))) : (k(), A(Ie, { key: 1 }, [
        D(i).showPreview ? (k(), A("div", {
          key: 0,
          class: "dp__selection_preview",
          title: H.value,
          style: mt(b.value)
        }, [
          T.$slots["action-preview"] && v.value ? se(T.$slots, "action-preview", {
            key: 0,
            value: T.internalModelValue
          }) : K("", !0),
          !T.$slots["action-preview"] && v.value ? (k(), A(Ie, { key: 1 }, [
            it(Te(H.value), 1)
          ], 64)) : K("", !0)
        ], 12, W8)) : K("", !0),
        G("div", {
          ref_key: "actionBtnContainer",
          ref: x,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          T.$slots["action-buttons"] ? se(T.$slots, "action-buttons", {
            key: 0,
            value: T.internalModelValue
          }) : K("", !0),
          T.$slots["action-buttons"] ? K("", !0) : (k(), A(Ie, { key: 1 }, [
            !D(l).enabled && D(i).showCancel ? (k(), A("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: m,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: M[0] || (M[0] = (V) => T.$emit("close-picker")),
              onKeydown: [
                M[1] || (M[1] = Re((V) => T.$emit("close-picker"), ["enter"])),
                M[2] || (M[2] = Re((V) => T.$emit("close-picker"), ["space"]))
              ]
            }, Te(T.cancelText), 545)) : K("", !0),
            D(i).showNow ? (k(), A("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: M[3] || (M[3] = (V) => T.$emit("select-now")),
              onKeydown: [
                M[4] || (M[4] = Re((V) => T.$emit("select-now"), ["enter"])),
                M[5] || (M[5] = Re((V) => T.$emit("select-now"), ["space"]))
              ]
            }, Te(T.nowButtonLabel), 33)) : K("", !0),
            D(i).showSelect ? (k(), A("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: g,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: O.value,
              "data-test": "select-button",
              onKeydown: [
                Re(_, ["enter"]),
                Re(_, ["space"])
              ],
              onClick: _
            }, Te(T.selectText), 41, U8)) : K("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Y8 = ["onKeydown"], K8 = { class: "dp__selection_grid_header" }, G8 = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], J8 = ["aria-label"], gs = /* @__PURE__ */ $e({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: n }) {
    const { setSelectionGrid: r, buildMultiLevelMatrix: i, setMonthPicker: o } = Li(), a = n, s = e, { defaultedAriaLabels: l, defaultedTextInput: d, defaultedConfig: u } = Et(
      s
    ), { hideNavigationButtons: c } = hd(), f = q(!1), h = q(null), p = q(null), m = q([]), g = q(), v = q(null), b = q(0), x = q(null);
    Bm(() => {
      h.value = null;
    }), ot(() => {
      an().then(() => ie()), s.noOverlayFocus || C(), y(!0);
    }), hr(() => y(!1));
    const y = (oe) => {
      var Y;
      s.arrowNavigation && ((Y = s.headerRefs) != null && Y.length ? o(oe) : r(oe));
    }, C = () => {
      var oe;
      const Y = Gt(p);
      Y && (d.value.enabled || (h.value ? (oe = h.value) == null || oe.focus({ preventScroll: !0 }) : Y.focus({ preventScroll: !0 })), f.value = Y.clientHeight < Y.scrollHeight);
    }, $ = E(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !s.useRelative,
        "dp--overlay-relative": s.useRelative
      })
    ), O = E(
      () => s.useRelative ? { height: `${s.height}px`, width: "260px" } : void 0
    ), z = E(() => ({
      dp__overlay_col: !0
    })), P = E(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: f.value,
        dp__button_bottom: s.isLast
      })
    ), U = E(() => {
      var oe, Y;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((oe = s.items) == null ? void 0 : oe.length) <= 6,
        dp__container_block: ((Y = s.items) == null ? void 0 : Y.length) > 6
      };
    });
    Fe(
      () => s.items,
      () => ie(!1),
      { deep: !0 }
    );
    const ie = (oe = !0) => {
      an().then(() => {
        const Y = Gt(h), ce = Gt(p), S = Gt(v), j = Gt(x), Z = S ? S.getBoundingClientRect().height : 0;
        ce && (ce.getBoundingClientRect().height ? b.value = ce.getBoundingClientRect().height - Z : b.value = u.value.modeHeight - Z), Y && j && oe && (j.scrollTop = Y.offsetTop - j.offsetTop - (b.value / 2 - Y.getBoundingClientRect().height) - Z);
      });
    }, W = (oe) => {
      oe.disabled || a("selected", oe.value);
    }, H = () => {
      a("toggle"), a("reset-flow");
    }, _ = () => {
      s.escClose && H();
    }, T = (oe, Y, ce, S) => {
      oe && ((Y.active || Y.value === s.focusValue) && (h.value = oe), s.arrowNavigation && (Array.isArray(m.value[ce]) ? m.value[ce][S] = oe : m.value[ce] = [oe], M()));
    }, M = () => {
      var oe, Y;
      const ce = (oe = s.headerRefs) != null && oe.length ? [s.headerRefs].concat(m.value) : m.value.concat([s.skipButtonRef ? [] : [v.value]]);
      i(Zt(ce), (Y = s.headerRefs) != null && Y.length ? "monthPicker" : "selectionGrid");
    }, V = (oe) => {
      s.arrowNavigation || Ei(oe, u.value, !0);
    }, Q = (oe) => {
      g.value = oe, a("hover-value", oe);
    }, ue = () => {
      var oe;
      if (H(), !s.isLast) {
        const Y = s8((oe = s.menuWrapRef) != null ? oe : null, "action-row");
        if (Y) {
          const ce = _2(Y);
          ce == null || ce.focus();
        }
      }
    };
    return t({ focusGrid: C }), (oe, Y) => {
      var ce;
      return k(), A("div", {
        ref_key: "gridWrapRef",
        ref: p,
        class: te($.value),
        style: mt(O.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [
          Re(Ge(_, ["prevent"]), ["esc"]),
          Y[0] || (Y[0] = Re(Ge((S) => V(S), ["prevent"]), ["left"])),
          Y[1] || (Y[1] = Re(Ge((S) => V(S), ["prevent"]), ["up"])),
          Y[2] || (Y[2] = Re(Ge((S) => V(S), ["prevent"]), ["down"])),
          Y[3] || (Y[3] = Re(Ge((S) => V(S), ["prevent"]), ["right"]))
        ]
      }, [
        G("div", {
          ref_key: "containerRef",
          ref: x,
          class: te(U.value),
          role: "grid",
          style: mt({ "--dp-overlay-height": `${b.value}px` })
        }, [
          G("div", K8, [
            se(oe.$slots, "header")
          ]),
          oe.$slots.overlay ? se(oe.$slots, "overlay", { key: 0 }) : (k(!0), A(Ie, { key: 1 }, Ze(oe.items, (S, j) => (k(), A("div", {
            key: j,
            class: te(["dp__overlay_row", { dp__flex_row: oe.items.length >= 3 }]),
            role: "row"
          }, [
            (k(!0), A(Ie, null, Ze(S, (Z, ee) => (k(), A("div", {
              key: Z.value,
              ref_for: !0,
              ref: (N) => T(N, Z, j, ee),
              role: "gridcell",
              class: te(z.value),
              "aria-selected": Z.active || void 0,
              "aria-disabled": Z.disabled || void 0,
              tabindex: "0",
              "data-test": Z.text,
              onClick: (N) => W(Z),
              onKeydown: [
                Re(Ge((N) => W(Z), ["prevent"]), ["enter"]),
                Re(Ge((N) => W(Z), ["prevent"]), ["space"])
              ],
              onMouseover: (N) => Q(Z.value)
            }, [
              G("div", {
                class: te(Z.className)
              }, [
                oe.$slots.item ? se(oe.$slots, "item", {
                  key: 0,
                  item: Z
                }) : K("", !0),
                oe.$slots.item ? K("", !0) : (k(), A(Ie, { key: 1 }, [
                  it(Te(Z.text), 1)
                ], 64))
              ], 2)
            ], 42, G8))), 128))
          ], 2))), 128))
        ], 6),
        oe.$slots["button-icon"] ? Jt((k(), A("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: v,
          type: "button",
          "aria-label": (ce = D(l)) == null ? void 0 : ce.toggleOverlay,
          class: te(P.value),
          tabindex: "0",
          onClick: H,
          onKeydown: [
            Re(H, ["enter"]),
            Re(ue, ["tab"])
          ]
        }, [
          se(oe.$slots, "button-icon")
        ], 42, J8)), [
          [Cn, !D(c)(oe.hideNavigation, oe.type)]
        ]) : K("", !0)
      ], 46, Y8);
    };
  }
}), gd = /* @__PURE__ */ $e({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const t = e, n = E(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), r = E(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (i, o) => (k(), A("div", {
      class: te({
        dp__menu_inner: !i.stretch,
        "dp--menu--inner-stretched": i.stretch,
        dp__flex_display: i.multiCalendars > 0,
        "dp--flex-display-collapsed": i.collapse
      })
    }, [
      (k(!0), A(Ie, null, Ze(n.value, (a, s) => (k(), A("div", {
        key: a,
        class: te(r.value)
      }, [
        se(i.$slots, "default", {
          instance: a,
          index: s
        })
      ], 2))), 128))
    ], 2));
  }
}), X8 = ["aria-label", "aria-disabled"], Na = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const n = t, r = q(null);
    return ot(() => n("set-ref", r)), (i, o) => (k(), A("button", {
      ref_key: "elRef",
      ref: r,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": i.ariaLabel,
      "aria-disabled": i.disabled || void 0,
      onClick: o[0] || (o[0] = (a) => i.$emit("activate")),
      onKeydown: [
        o[1] || (o[1] = Re(Ge((a) => i.$emit("activate"), ["prevent"]), ["enter"])),
        o[2] || (o[2] = Re(Ge((a) => i.$emit("activate"), ["prevent"]), ["space"]))
      ]
    }, [
      G("span", {
        class: te(["dp__inner_nav", { dp__inner_nav_disabled: i.disabled }])
      }, [
        se(i.$slots, "default")
      ], 2)
    ], 40, X8));
  }
}), Q8 = { class: "dp--year-mode-picker" }, Z8 = ["aria-label", "data-test"], q2 = /* @__PURE__ */ $e({
  __name: "YearModePicker",
  props: {
    ...vr,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const n = t, r = e, { showRightIcon: i, showLeftIcon: o } = hd(), { defaultedConfig: a, defaultedMultiCalendars: s, defaultedAriaLabels: l, defaultedTransitions: d } = Et(r), { showTransition: u, transitionName: c } = hs(d), f = (m = !1, g) => {
      n("toggle-year-picker", { flow: m, show: g });
    }, h = (m) => {
      n("year-select", m);
    }, p = (m = !1) => {
      n("handle-year", m);
    };
    return (m, g) => {
      var v, b, x;
      return k(), A("div", Q8, [
        D(o)(D(s), e.instance) ? (k(), ge(Na, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (v = D(l)) == null ? void 0 : v.prevYear,
          disabled: e.isDisabled(!1),
          onActivate: g[0] || (g[0] = (y) => p(!1))
        }, {
          default: de(() => [
            m.$slots["arrow-left"] ? se(m.$slots, "arrow-left", { key: 0 }) : K("", !0),
            m.$slots["arrow-left"] ? K("", !0) : (k(), ge(D(D0), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : K("", !0),
        G("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (b = D(l)) == null ? void 0 : b.openYearsOverlay,
          "data-test": `year-mode-btn-${e.instance}`,
          onClick: g[1] || (g[1] = () => f(!1)),
          onKeydown: g[2] || (g[2] = Re(() => f(!1), ["enter"]))
        }, [
          m.$slots.year ? se(m.$slots, "year", {
            key: 0,
            year: e.year
          }) : K("", !0),
          m.$slots.year ? K("", !0) : (k(), A(Ie, { key: 1 }, [
            it(Te(e.year), 1)
          ], 64))
        ], 40, Z8),
        D(i)(D(s), e.instance) ? (k(), ge(Na, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (x = D(l)) == null ? void 0 : x.nextYear,
          disabled: e.isDisabled(!0),
          onActivate: g[3] || (g[3] = (y) => p(!0))
        }, {
          default: de(() => [
            m.$slots["arrow-right"] ? se(m.$slots, "arrow-right", { key: 0 }) : K("", !0),
            m.$slots["arrow-right"] ? K("", !0) : (k(), ge(D(A0), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : K("", !0),
        fe(ur, {
          name: D(c)(e.showYearPicker),
          css: D(u)
        }, {
          default: de(() => [
            e.showYearPicker ? (k(), ge(gs, {
              key: 0,
              items: e.items,
              "text-input": m.textInput,
              "esc-close": m.escClose,
              config: m.config,
              "is-last": m.autoApply && !D(a).keepActionRow,
              "hide-navigation": m.hideNavigation,
              "aria-labels": m.ariaLabels,
              type: "year",
              onToggle: f,
              onSelected: g[4] || (g[4] = (y) => h(y))
            }, qt({
              "button-icon": de(() => [
                m.$slots["calendar-icon"] ? se(m.$slots, "calendar-icon", { key: 0 }) : K("", !0),
                m.$slots["calendar-icon"] ? K("", !0) : (k(), ge(D(fa), { key: 1 }))
              ]),
              _: 2
            }, [
              m.$slots["year-overlay-value"] ? {
                name: "item",
                fn: de(({ item: y }) => [
                  se(m.$slots, "year-overlay-value", {
                    text: y.text,
                    value: y.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels"])) : K("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), B0 = (e, t, n) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((r) => st(e, r))) {
      const r = t.value.filter((i) => !st(i, e));
      t.value = r.length ? r : null;
    } else
      (n && +n > t.value.length || !n) && t.value.push(e);
  else
    t.value = [e];
}, z0 = (e, t, n) => {
  let r = e.value ? e.value.slice() : [];
  return r.length === 2 && r[1] !== null && (r = []), r.length ? Pt(t, r[0]) ? (r.unshift(t), n("range-start", r[0]), n("range-start", r[1])) : (r[1] = t, n("range-end", t)) : (r = [t], n("range-start", t)), r;
}, vd = (e, t, n, r) => {
  e && (e[0] && e[1] && n && t("auto-apply"), e[0] && !e[1] && r && n && t("auto-apply"));
}, Y2 = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => Fr(he(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Fr(he(e.value), e.timezone));
}, K2 = (e, t, n, r) => Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && r.value.partialRange) ? r.value.fixedStart && (Bt(e, t.value[0]) || st(e, t.value[0])) ? [t.value[0], e] : r.value.fixedEnd && (Pt(e, t.value[1]) || st(e, t.value[1])) ? [e, t.value[1]] : (n("invalid-fixed-range", e), t.value) : [], G2 = ({
  multiCalendars: e,
  highlight: t,
  propDates: n,
  calendars: r,
  modelValue: i,
  props: o,
  filters: a,
  year: s,
  month: l,
  emit: d
}) => {
  const u = E(() => R0(o.yearRange, o.locale, o.reverseYears)), c = q([!1]), f = E(() => ($, O) => {
    const z = bt(or(/* @__PURE__ */ new Date()), {
      month: l.value($),
      year: s.value($)
    });
    return H2(
      z,
      n.value.maxDate,
      n.value.minDate,
      o.preventMinMaxNavigation,
      O
    );
  }), h = () => {
    for (let $ = 0; $ < e.value.count; $++)
      if ($ === 0)
        r.value[$] = r.value[0];
      else {
        const O = bt(he(), r.value[$ - 1]);
        r.value[$] = { month: at(O), year: nt(k0(O, 1)) };
      }
  }, p = ($) => {
    if (!$)
      return h();
    const O = bt(he(), r.value[$]);
    return r.value[0].year = nt(A2(O, e.value.count - 1)), h();
  }, m = ($) => o.focusStartDate ? $[0] : $[1] ? $[1] : $[0], g = () => {
    if (i.value) {
      const $ = Array.isArray(i.value) ? m(i.value) : i.value;
      r.value[0] = { month: at($), year: nt($) };
    }
  };
  ot(() => {
    g(), e.value.count && h();
  });
  const v = ($, O) => {
    r.value[O].year = $, d("update-month-year", { instance: O, year: $, month: r.value[O].month }), e.value.count && !e.value.solo && p(O);
  }, b = E(() => ($) => Qo(u.value, (O) => {
    var z;
    const P = s.value($) === O.value, U = Ya(
      O.value,
      Zo(n.value.minDate),
      Zo(n.value.maxDate)
    ) || ((z = a.value.years) == null ? void 0 : z.includes(s.value($))), ie = F0(t.value, O.value);
    return { active: P, disabled: U, highlighted: ie };
  })), x = ($, O) => {
    v($, O), C(O);
  }, y = ($, O = !1) => {
    if (!f.value($, O)) {
      const z = O ? s.value($) + 1 : s.value($) - 1;
      v(z, $);
    }
  }, C = ($, O = !1, z) => {
    O || d("reset-flow"), z !== void 0 ? c.value[$] = z : c.value[$] = !c.value[$], c.value || d("overlay-closed");
  };
  return {
    isDisabled: f,
    groupedYears: b,
    showYearPicker: c,
    selectYear: v,
    toggleYearPicker: C,
    handleYearSelect: x,
    handleYear: y
  };
}, e7 = (e, t) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: r,
    defaultedTransitions: i,
    defaultedConfig: o,
    defaultedRange: a,
    defaultedHighlight: s,
    propDates: l,
    defaultedTz: d,
    defaultedFilters: u,
    defaultedMultiDates: c
  } = Et(e), { modelValue: f, year: h, month: p, calendars: m } = ms(e, t), g = E(() => I2(e.formatLocale, e.locale, e.monthNameFormat)), v = q(null), { checkMinMaxRange: b } = Fi(e), {
    selectYear: x,
    groupedYears: y,
    showYearPicker: C,
    toggleYearPicker: $,
    handleYearSelect: O,
    handleYear: z,
    isDisabled: P
  } = G2({
    modelValue: f,
    multiCalendars: n,
    highlight: s,
    calendars: m,
    year: h,
    propDates: l,
    month: p,
    filters: u,
    props: e,
    emit: t
  });
  ot(() => {
    e.startDate && (f.value && e.focusStartDate || !f.value) && x(nt(he(e.startDate)), 0);
  });
  const U = (S) => S ? { month: at(S), year: nt(S) } : { month: null, year: null }, ie = () => f.value ? Array.isArray(f.value) ? f.value.map((S) => U(S)) : U(f.value) : U(), W = (S, j) => {
    const Z = m.value[S], ee = ie();
    return Array.isArray(ee) ? ee.some((N) => N.year === (Z == null ? void 0 : Z.year) && N.month === j) : (Z == null ? void 0 : Z.year) === ee.year && j === ee.month;
  }, H = (S, j, Z) => {
    var ee, N;
    const Ce = ie();
    return Array.isArray(Ce) ? h.value(j) === ((ee = Ce[Z]) == null ? void 0 : ee.year) && S === ((N = Ce[Z]) == null ? void 0 : N.month) : !1;
  }, _ = (S, j) => {
    if (a.value.enabled) {
      const Z = ie();
      if (Array.isArray(f.value) && Array.isArray(Z)) {
        const ee = H(S, j, 0) || H(S, j, 1), N = ri(or(he()), S, h.value(j));
        return pd(f.value, v.value, N) && !ee;
      }
      return !1;
    }
    return !1;
  }, T = E(() => (S) => Qo(g.value, (j) => {
    var Z;
    const ee = W(S, j.value), N = Ya(
      j.value,
      F2(h.value(S), l.value.minDate),
      B2(h.value(S), l.value.maxDate)
    ) || m8(l.value.disabledDates, h.value(S)).includes(j.value) || ((Z = u.value.months) == null ? void 0 : Z.includes(j.value)), Ce = _(j.value, S), qe = W2(s.value, j.value, h.value(S));
    return { active: ee, disabled: N, isBetween: Ce, highlighted: qe };
  })), M = (S, j) => ri(or(he()), S, h.value(j)), V = (S, j) => {
    const Z = f.value ? f.value : or(/* @__PURE__ */ new Date());
    f.value = ri(Z, S, h.value(j)), t("auto-apply"), t("update-flow-step");
  }, Q = (S, j) => {
    const Z = M(S, j);
    a.value.fixedEnd || a.value.fixedStart ? f.value = K2(Z, f, t, a) : f.value ? b(Z, f.value) && (f.value = z0(f, M(S, j), t)) : f.value = [M(S, j)], an().then(() => {
      vd(f.value, t, e.autoApply, e.modelAuto);
    });
  }, ue = (S, j) => {
    B0(M(S, j), f, c.value.limit), t("auto-apply", !0);
  }, oe = (S, j) => (m.value[j].month = S, ce(j, m.value[j].year, S), c.value.enabled ? ue(S, j) : a.value.enabled ? Q(S, j) : V(S, j)), Y = (S, j) => {
    x(S, j), ce(j, S, null);
  }, ce = (S, j, Z) => {
    let ee = Z;
    if (!ee && ee !== 0) {
      const N = ie();
      ee = Array.isArray(N) ? N[S].month : N.month;
    }
    t("update-month-year", { instance: S, year: j, month: ee });
  };
  return {
    groupedMonths: T,
    groupedYears: y,
    year: h,
    isDisabled: P,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: r,
    defaultedTransitions: i,
    defaultedConfig: o,
    showYearPicker: C,
    modelValue: f,
    presetDate: (S, j) => {
      Y2({
        value: S,
        modelValue: f,
        range: a.value.enabled,
        timezone: j ? void 0 : d.value.timezone
      }), t("auto-apply");
    },
    setHoverDate: (S, j) => {
      v.value = M(S, j);
    },
    selectMonth: oe,
    selectYear: Y,
    toggleYearPicker: $,
    handleYearSelect: O,
    handleYear: z,
    getModelMonthYear: ie
  };
}, t7 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...vr
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = ci(), o = Ln(i, "yearMode"), a = e;
    ot(() => {
      a.shadow || r("mount", null);
    });
    const {
      groupedMonths: s,
      groupedYears: l,
      year: d,
      isDisabled: u,
      defaultedMultiCalendars: c,
      defaultedConfig: f,
      showYearPicker: h,
      modelValue: p,
      presetDate: m,
      setHoverDate: g,
      selectMonth: v,
      selectYear: b,
      toggleYearPicker: x,
      handleYearSelect: y,
      handleYear: C,
      getModelMonthYear: $
    } = e7(a, r);
    return t({ getSidebarProps: () => ({
      modelValue: p,
      year: d,
      getModelMonthYear: $,
      selectMonth: v,
      selectYear: b,
      handleYear: C
    }), presetDate: m, toggleYearPicker: (O) => x(0, O) }), (O, z) => (k(), ge(gd, {
      "multi-calendars": D(c).count,
      collapse: O.collapse,
      stretch: ""
    }, {
      default: de(({ instance: P }) => [
        O.$slots["top-extra"] ? se(O.$slots, "top-extra", {
          key: 0,
          value: O.internalModelValue
        }) : K("", !0),
        O.$slots["month-year"] ? se(O.$slots, "month-year", tn($t({ key: 1 }, {
          year: D(d),
          months: D(s)(P),
          years: D(l)(P),
          selectMonth: D(v),
          selectYear: D(b),
          instance: P
        }))) : (k(), ge(gs, {
          key: 2,
          items: D(s)(P),
          "arrow-navigation": O.arrowNavigation,
          "is-last": O.autoApply && !D(f).keepActionRow,
          "esc-close": O.escClose,
          height: D(f).modeHeight,
          config: O.config,
          "no-overlay-focus": !!(O.noOverlayFocus || O.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (U) => D(v)(U, P),
          onHoverValue: (U) => D(g)(U, P)
        }, qt({
          header: de(() => [
            fe(q2, $t(O.$props, {
              items: D(l)(P),
              instance: P,
              "show-year-picker": D(h)[P],
              year: D(d)(P),
              "is-disabled": (U) => D(u)(P, U),
              onHandleYear: (U) => D(C)(P, U),
              onYearSelect: (U) => D(y)(U, P),
              onToggleYearPicker: (U) => D(x)(P, U == null ? void 0 : U.flow, U == null ? void 0 : U.show)
            }), qt({ _: 2 }, [
              Ze(D(o), (U, ie) => ({
                name: U,
                fn: de((W) => [
                  se(O.$slots, U, tn(Sn(W)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          O.$slots["month-overlay-value"] ? {
            name: "item",
            fn: de(({ item: U }) => [
              se(O.$slots, "month-overlay-value", {
                text: U.text,
                value: U.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), n7 = (e, t) => {
  const { modelValue: n } = ms(e, t), r = q(null), { defaultedHighlight: i, defaultedMultiDates: o, defaultedFilters: a, defaultedRange: s, propDates: l } = Et(e), d = q();
  ot(() => {
    e.startDate && (n.value && e.focusStartDate || !n.value) && (d.value = nt(he(e.startDate)));
  });
  const u = (p) => Array.isArray(n.value) ? n.value.some((m) => nt(m) === p) : n.value ? nt(n.value) === p : !1, c = (p) => s.value.enabled && Array.isArray(n.value) ? pd(n.value, r.value, h(p)) : !1, f = E(() => Qo(R0(e.yearRange, e.locale, e.reverseYears), (p) => {
    const m = u(p.value), g = Ya(
      p.value,
      Zo(l.value.minDate),
      Zo(l.value.maxDate)
    ) || a.value.years.includes(p.value), v = c(p.value) && !m, b = F0(i.value, p.value);
    return { active: m, disabled: g, isBetween: v, highlighted: b };
  })), h = (p) => Pr(or(/* @__PURE__ */ new Date()), p);
  return {
    groupedYears: f,
    modelValue: n,
    focusYear: d,
    setHoverValue: (p) => {
      r.value = Pr(or(/* @__PURE__ */ new Date()), p);
    },
    selectYear: (p) => {
      var m;
      if (t("update-month-year", { instance: 0, year: p }), o.value.enabled)
        return n.value ? Array.isArray(n.value) && (((m = n.value) == null ? void 0 : m.map((g) => nt(g))).includes(p) ? n.value = n.value.filter((g) => nt(g) !== p) : n.value.push(Pr(Fn(he()), p))) : n.value = [Pr(Fn(he()), p)], t("auto-apply", !0);
      s.value.enabled ? (n.value = z0(n, h(p), t), an().then(() => {
        vd(n.value, t, e.autoApply, e.modelAuto);
      })) : (n.value = h(p), t("auto-apply"));
    }
  };
}, r7 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...vr
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, { groupedYears: o, modelValue: a, focusYear: s, selectYear: l, setHoverValue: d } = n7(i, r), { defaultedConfig: u } = Et(i);
    return t({ getSidebarProps: () => ({
      modelValue: a,
      selectYear: l
    }) }), (c, f) => (k(), A("div", null, [
      c.$slots["top-extra"] ? se(c.$slots, "top-extra", {
        key: 0,
        value: c.internalModelValue
      }) : K("", !0),
      c.$slots["month-year"] ? se(c.$slots, "month-year", tn($t({ key: 1 }, {
        years: D(o),
        selectYear: D(l)
      }))) : (k(), ge(gs, {
        key: 2,
        items: D(o),
        "is-last": c.autoApply && !D(u).keepActionRow,
        height: D(u).modeHeight,
        config: c.config,
        "no-overlay-focus": !!(c.noOverlayFocus || c.textInput),
        "focus-value": D(s),
        type: "year",
        "use-relative": "",
        onSelected: D(l),
        onHoverValue: D(d)
      }, qt({ _: 2 }, [
        c.$slots["year-overlay-value"] ? {
          name: "item",
          fn: de(({ item: h }) => [
            se(c.$slots, "year-overlay-value", {
              text: h.text,
              value: h.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), i7 = {
  key: 0,
  class: "dp__time_input"
}, o7 = ["data-test", "aria-label", "onKeydown", "onClick"], a7 = /* @__PURE__ */ G("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), s7 = /* @__PURE__ */ G("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), l7 = ["aria-label", "disabled", "data-test", "onKeydown", "onClick"], d7 = ["data-test", "aria-label", "onKeydown", "onClick"], u7 = /* @__PURE__ */ G("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), c7 = /* @__PURE__ */ G("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), f7 = { key: 0 }, p7 = ["aria-label", "onKeydown"], h7 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...vr
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, { setTimePickerElements: o, setTimePickerBackRef: a } = Li(), { defaultedAriaLabels: s, defaultedTransitions: l, defaultedFilters: d, defaultedConfig: u, defaultedRange: c } = Et(i), { transitionName: f, showTransition: h } = hs(l), p = Gn({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), m = q("AM"), g = q(null), v = q([]);
    ot(() => {
      r("mounted");
    });
    const b = (I) => bt(/* @__PURE__ */ new Date(), {
      hours: I.hours,
      minutes: I.minutes,
      seconds: i.enableSeconds ? I.seconds : 0,
      milliseconds: 0
    }), x = E(
      () => (I) => T(I, i[I]) || C(I, i[I])
    ), y = E(() => ({ hours: i.hours, minutes: i.minutes, seconds: i.seconds })), C = (I, Me) => c.value.enabled && !c.value.disableTimeRangeValidation ? !i.validateTime(I, Me) : !1, $ = (I, Me) => {
      if (c.value.enabled && !c.value.disableTimeRangeValidation) {
        const Ye = Me ? +i[`${I}Increment`] : -+i[`${I}Increment`], ke = i[I] + Ye;
        return !i.validateTime(I, ke);
      }
      return !1;
    }, O = E(() => (I) => !oe(+i[I] + +i[`${I}Increment`], I) || $(I, !0)), z = E(() => (I) => !oe(+i[I] - +i[`${I}Increment`], I) || $(I, !1)), P = (I, Me) => c2(bt(he(), I), Me), U = (I, Me) => X6(bt(he(), I), Me), ie = E(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !i.timePickerInline,
        dp__time_col_reg_block: !i.enableSeconds && i.is24 && !i.timePickerInline,
        dp__time_col_reg_inline: !i.enableSeconds && i.is24 && i.timePickerInline,
        dp__time_col_reg_with_button: !i.enableSeconds && !i.is24,
        dp__time_col_sec: i.enableSeconds && i.is24,
        dp__time_col_sec_with_button: i.enableSeconds && !i.is24
      })
    ), W = E(() => {
      const I = [{ type: "hours" }];
      return i.enableMinutes && I.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), i.enableSeconds && I.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), I;
    }), H = E(() => W.value.filter((I) => !I.separator)), _ = E(() => (I) => {
      if (I === "hours") {
        const Me = Z(+i.hours);
        return { text: Me < 10 ? `0${Me}` : `${Me}`, value: Me };
      }
      return { text: i[I] < 10 ? `0${i[I]}` : `${i[I]}`, value: i[I] };
    }), T = (I, Me) => {
      var Ye;
      if (!i.disabledTimesConfig)
        return !1;
      const ke = i.disabledTimesConfig(i.order, I === "hours" ? Me : void 0);
      return ke[I] ? !!((Ye = ke[I]) != null && Ye.includes(Me)) : !0;
    }, M = (I, Me) => Me !== "hours" || m.value === "AM" ? I : I + 12, V = (I) => {
      const Me = i.is24 ? 24 : 12, Ye = I === "hours" ? Me : 60, ke = +i[`${I}GridIncrement`], je = I === "hours" && !i.is24 ? ke : 0, re = [];
      for (let le = je; le < Ye; le += ke)
        re.push({ value: i.is24 ? le : M(le, I), text: le < 10 ? `0${le}` : `${le}` });
      return I === "hours" && !i.is24 && re.push({ value: 0, text: "12" }), Qo(re, (le) => ({ active: !1, disabled: d.value.times[I].includes(le.value) || !oe(le.value, I) || T(I, le.value) || C(I, le.value) }));
    }, Q = (I) => I >= 0 ? I : 59, ue = (I) => I >= 0 ? I : 23, oe = (I, Me) => {
      const Ye = i.minTime ? b(nu(i.minTime)) : null, ke = i.maxTime ? b(nu(i.maxTime)) : null, je = b(
        nu(
          y.value,
          Me,
          Me === "minutes" || Me === "seconds" ? Q(I) : ue(I)
        )
      );
      return Ye && ke ? (qa(je, ke) || Bo(je, ke)) && (Jo(je, Ye) || Bo(je, Ye)) : Ye ? Jo(je, Ye) || Bo(je, Ye) : ke ? qa(je, ke) || Bo(je, ke) : !0;
    }, Y = (I) => i[`no${I[0].toUpperCase() + I.slice(1)}Overlay`], ce = (I) => {
      Y(I) || (p[I] = !p[I], p[I] || r("overlay-closed"));
    }, S = (I) => I === "hours" ? lr : I === "minutes" ? Lr : Go, j = (I, Me = !0) => {
      const Ye = Me ? P : U, ke = Me ? +i[`${I}Increment`] : -+i[`${I}Increment`];
      oe(+i[I] + ke, I) && r(
        `update:${I}`,
        S(I)(Ye({ [I]: +i[I] }, { [I]: +i[`${I}Increment`] }))
      );
    }, Z = (I) => i.is24 ? I : (I >= 12 ? m.value = "PM" : m.value = "AM", n8(I)), ee = () => {
      m.value === "PM" ? (m.value = "AM", r("update:hours", i.hours - 12)) : (m.value = "PM", r("update:hours", i.hours + 12)), r("am-pm-change", m.value);
    }, N = (I) => {
      p[I] = !0;
    }, Ce = (I, Me, Ye) => {
      if (I && i.arrowNavigation) {
        Array.isArray(v.value[Me]) ? v.value[Me][Ye] = I : v.value[Me] = [I];
        const ke = v.value.reduce(
          (je, re) => re.map((le, Ke) => [...je[Ke] || [], re[Ke]]),
          []
        );
        a(i.closeTimePickerBtn), g.value && (ke[1] = ke[1].concat(g.value)), o(ke, i.order);
      }
    }, qe = (I, Me) => (ce(I), r(`update:${I}`, Me));
    return t({ openChildCmp: N }), (I, Me) => {
      var Ye;
      return I.disabled ? K("", !0) : (k(), A("div", i7, [
        (k(!0), A(Ie, null, Ze(W.value, (ke, je) => {
          var re, le, Ke;
          return k(), A("div", {
            key: je,
            class: te(ie.value)
          }, [
            ke.separator ? (k(), A(Ie, { key: 0 }, [
              it(" : ")
            ], 64)) : (k(), A(Ie, { key: 1 }, [
              G("button", {
                ref_for: !0,
                ref: (We) => Ce(We, je, 0),
                type: "button",
                class: te({
                  dp__btn: !0,
                  dp__inc_dec_button: !I.timePickerInline,
                  dp__inc_dec_button_inline: I.timePickerInline,
                  dp__tp_inline_btn_top: I.timePickerInline,
                  dp__inc_dec_button_disabled: O.value(ke.type)
                }),
                "data-test": `${ke.type}-time-inc-btn-${i.order}`,
                "aria-label": (re = D(s)) == null ? void 0 : re.incrementValue(ke.type),
                tabindex: "0",
                onKeydown: [
                  Re(Ge((We) => j(ke.type), ["prevent"]), ["enter"]),
                  Re(Ge((We) => j(ke.type), ["prevent"]), ["space"])
                ],
                onClick: (We) => j(ke.type)
              }, [
                i.timePickerInline ? (k(), A(Ie, { key: 1 }, [
                  a7,
                  s7
                ], 64)) : (k(), A(Ie, { key: 0 }, [
                  I.$slots["arrow-up"] ? se(I.$slots, "arrow-up", { key: 0 }) : K("", !0),
                  I.$slots["arrow-up"] ? K("", !0) : (k(), ge(D(N0), { key: 1 }))
                ], 64))
              ], 42, o7),
              G("button", {
                ref_for: !0,
                ref: (We) => Ce(We, je, 1),
                type: "button",
                "aria-label": (le = D(s)) == null ? void 0 : le.openTpOverlay(ke.type),
                class: te({
                  dp__time_display: !0,
                  dp__time_display_block: !I.timePickerInline,
                  dp__time_display_inline: I.timePickerInline,
                  "dp--time-invalid": x.value(ke.type),
                  "dp--time-overlay-btn": !x.value(ke.type)
                }),
                disabled: Y(ke.type),
                tabindex: "0",
                "data-test": `${ke.type}-toggle-overlay-btn-${i.order}`,
                onKeydown: [
                  Re(Ge((We) => ce(ke.type), ["prevent"]), ["enter"]),
                  Re(Ge((We) => ce(ke.type), ["prevent"]), ["space"])
                ],
                onClick: (We) => ce(ke.type)
              }, [
                I.$slots[ke.type] ? se(I.$slots, ke.type, {
                  key: 0,
                  text: _.value(ke.type).text,
                  value: _.value(ke.type).value
                }) : K("", !0),
                I.$slots[ke.type] ? K("", !0) : (k(), A(Ie, { key: 1 }, [
                  it(Te(_.value(ke.type).text), 1)
                ], 64))
              ], 42, l7),
              G("button", {
                ref_for: !0,
                ref: (We) => Ce(We, je, 2),
                type: "button",
                class: te({
                  dp__btn: !0,
                  dp__inc_dec_button: !I.timePickerInline,
                  dp__inc_dec_button_inline: I.timePickerInline,
                  dp__tp_inline_btn_bottom: I.timePickerInline,
                  dp__inc_dec_button_disabled: z.value(ke.type)
                }),
                "data-test": `${ke.type}-time-dec-btn-${i.order}`,
                "aria-label": (Ke = D(s)) == null ? void 0 : Ke.decrementValue(ke.type),
                tabindex: "0",
                onKeydown: [
                  Re(Ge((We) => j(ke.type, !1), ["prevent"]), ["enter"]),
                  Re(Ge((We) => j(ke.type, !1), ["prevent"]), ["space"])
                ],
                onClick: (We) => j(ke.type, !1)
              }, [
                i.timePickerInline ? (k(), A(Ie, { key: 1 }, [
                  u7,
                  c7
                ], 64)) : (k(), A(Ie, { key: 0 }, [
                  I.$slots["arrow-down"] ? se(I.$slots, "arrow-down", { key: 0 }) : K("", !0),
                  I.$slots["arrow-down"] ? K("", !0) : (k(), ge(D(I0), { key: 1 }))
                ], 64))
              ], 42, d7)
            ], 64))
          ], 2);
        }), 128)),
        I.is24 ? K("", !0) : (k(), A("div", f7, [
          I.$slots["am-pm-button"] ? se(I.$slots, "am-pm-button", {
            key: 0,
            toggle: ee,
            value: m.value
          }) : K("", !0),
          I.$slots["am-pm-button"] ? K("", !0) : (k(), A("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: g,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (Ye = D(s)) == null ? void 0 : Ye.amPmButton,
            tabindex: "0",
            onClick: ee,
            onKeydown: [
              Re(Ge(ee, ["prevent"]), ["enter"]),
              Re(Ge(ee, ["prevent"]), ["space"])
            ]
          }, Te(m.value), 41, p7))
        ])),
        (k(!0), A(Ie, null, Ze(H.value, (ke, je) => (k(), ge(ur, {
          key: je,
          name: D(f)(p[ke.type]),
          css: D(h)
        }, {
          default: de(() => [
            p[ke.type] ? (k(), ge(gs, {
              key: 0,
              items: V(ke.type),
              "is-last": I.autoApply && !D(u).keepActionRow,
              "esc-close": I.escClose,
              type: ke.type,
              "text-input": I.textInput,
              config: I.config,
              "arrow-navigation": I.arrowNavigation,
              "aria-labels": I.ariaLabels,
              onSelected: (re) => qe(ke.type, re),
              onToggle: (re) => ce(ke.type),
              onResetFlow: Me[0] || (Me[0] = (re) => I.$emit("reset-flow"))
            }, qt({
              "button-icon": de(() => [
                I.$slots["clock-icon"] ? se(I.$slots, "clock-icon", { key: 0 }) : K("", !0),
                I.$slots["clock-icon"] ? K("", !0) : (k(), ge(Qn(I.timePickerInline ? D(fa) : D(P0)), { key: 1 }))
              ]),
              _: 2
            }, [
              I.$slots[`${ke.type}-overlay-value`] ? {
                name: "item",
                fn: de(({ item: re }) => [
                  se(I.$slots, `${ke.type}-overlay-value`, {
                    text: re.text,
                    value: re.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "onSelected", "onToggle"])) : K("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), m7 = { class: "dp--tp-wrap" }, g7 = ["aria-label", "tabindex"], v7 = ["tabindex"], y7 = ["aria-label"], J2 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...vr
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, { buildMatrix: o, setTimePicker: a } = Li(), s = ci(), { defaultedTransitions: l, defaultedAriaLabels: d, defaultedTextInput: u, defaultedConfig: c, defaultedRange: f } = Et(i), { transitionName: h, showTransition: p } = hs(l), { hideNavigationButtons: m } = hd(), g = q(null), v = q(null), b = q([]), x = q(null);
    ot(() => {
      r("mount"), !i.timePicker && i.arrowNavigation ? o([Gt(g.value)], "time") : a(!0, i.timePicker);
    });
    const y = E(() => f.value.enabled && i.modelAuto ? R2(i.internalModelValue) : !0), C = q(!1), $ = (M) => ({
      hours: Array.isArray(i.hours) ? i.hours[M] : i.hours,
      minutes: Array.isArray(i.minutes) ? i.minutes[M] : i.minutes,
      seconds: Array.isArray(i.seconds) ? i.seconds[M] : i.seconds
    }), O = E(() => {
      const M = [];
      if (f.value.enabled)
        for (let V = 0; V < 2; V++)
          M.push($(V));
      else
        M.push($(0));
      return M;
    }), z = (M, V = !1, Q = "") => {
      V || r("reset-flow"), C.value = M, r(M ? "overlay-opened" : "overlay-closed"), i.arrowNavigation && a(M), an(() => {
        Q !== "" && b.value[0] && b.value[0].openChildCmp(Q);
      });
    }, P = E(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: i.autoApply && !c.value.keepActionRow
    })), U = Ln(s, "timePicker"), ie = (M, V, Q) => f.value.enabled ? V === 0 ? [M, O.value[1][Q]] : [O.value[0][Q], M] : M, W = (M) => {
      r("update:hours", M);
    }, H = (M) => {
      r("update:minutes", M);
    }, _ = (M) => {
      r("update:seconds", M);
    }, T = () => {
      if (x.value && !u.value.enabled && !i.noOverlayFocus) {
        const M = _2(x.value);
        M && M.focus({ preventScroll: !0 });
      }
    };
    return t({ toggleTimePicker: z }), (M, V) => {
      var Q;
      return k(), A("div", m7, [
        !M.timePicker && !M.timePickerInline ? Jt((k(), A("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: g,
          type: "button",
          class: te(P.value),
          "aria-label": (Q = D(d)) == null ? void 0 : Q.openTimePicker,
          tabindex: M.noOverlayFocus ? void 0 : 0,
          "data-test": "open-time-picker-btn",
          onKeydown: [
            V[0] || (V[0] = Re((ue) => z(!0), ["enter"])),
            V[1] || (V[1] = Re((ue) => z(!0), ["space"]))
          ],
          onClick: V[2] || (V[2] = (ue) => z(!0))
        }, [
          M.$slots["clock-icon"] ? se(M.$slots, "clock-icon", { key: 0 }) : K("", !0),
          M.$slots["clock-icon"] ? K("", !0) : (k(), ge(D(P0), { key: 1 }))
        ], 42, g7)), [
          [Cn, !D(m)(M.hideNavigation, "time")]
        ]) : K("", !0),
        fe(ur, {
          name: D(h)(C.value),
          css: D(p) && !M.timePickerInline
        }, {
          default: de(() => {
            var ue;
            return [
              C.value || M.timePicker || M.timePickerInline ? (k(), A("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: x,
                class: te({
                  dp__overlay: !M.timePickerInline,
                  "dp--overlay-absolute": !i.timePicker && !M.timePickerInline,
                  "dp--overlay-relative": i.timePicker
                }),
                style: mt(M.timePicker ? { height: `${D(c).modeHeight}px` } : void 0),
                tabindex: M.timePickerInline ? void 0 : 0
              }, [
                G("div", {
                  class: te(
                    M.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  M.$slots["time-picker-overlay"] ? se(M.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: W,
                    setMinutes: H,
                    setSeconds: _
                  }) : K("", !0),
                  M.$slots["time-picker-overlay"] ? K("", !0) : (k(), A("div", {
                    key: 1,
                    class: te(M.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (k(!0), A(Ie, null, Ze(O.value, (oe, Y) => Jt((k(), ge(h7, $t({
                      key: Y,
                      ref_for: !0
                    }, {
                      ...M.$props,
                      order: Y,
                      hours: oe.hours,
                      minutes: oe.minutes,
                      seconds: oe.seconds,
                      closeTimePickerBtn: v.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: Y === 0 ? M.fixedStart : M.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: b,
                      "validate-time": (ce, S) => e.validateTime(ce, ie(S, Y, ce)),
                      "onUpdate:hours": (ce) => W(ie(ce, Y, "hours")),
                      "onUpdate:minutes": (ce) => H(ie(ce, Y, "minutes")),
                      "onUpdate:seconds": (ce) => _(ie(ce, Y, "seconds")),
                      onMounted: T,
                      onOverlayClosed: T,
                      onAmPmChange: V[3] || (V[3] = (ce) => M.$emit("am-pm-change", ce))
                    }), qt({ _: 2 }, [
                      Ze(D(U), (ce, S) => ({
                        name: ce,
                        fn: de((j) => [
                          se(M.$slots, ce, $t({ ref_for: !0 }, j))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Cn, Y === 0 ? !0 : y.value]
                    ])), 128))
                  ], 2)),
                  !M.timePicker && !M.timePickerInline ? Jt((k(), A("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: v,
                    type: "button",
                    class: te(P.value),
                    "aria-label": (ue = D(d)) == null ? void 0 : ue.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      V[4] || (V[4] = Re((oe) => z(!1), ["enter"])),
                      V[5] || (V[5] = Re((oe) => z(!1), ["space"]))
                    ],
                    onClick: V[6] || (V[6] = (oe) => z(!1))
                  }, [
                    M.$slots["calendar-icon"] ? se(M.$slots, "calendar-icon", { key: 0 }) : K("", !0),
                    M.$slots["calendar-icon"] ? K("", !0) : (k(), ge(D(fa), { key: 1 }))
                  ], 42, y7)), [
                    [Cn, !D(m)(M.hideNavigation, "time")]
                  ]) : K("", !0)
                ], 2)
              ], 14, v7)) : K("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), X2 = (e, t, n, r) => {
  const { defaultedRange: i } = Et(e), o = (x, y) => Array.isArray(t[x]) ? t[x][y] : t[x], a = (x) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[x] : t.seconds : 0, s = (x, y) => x ? y !== void 0 ? Di(x, o("hours", y), o("minutes", y), a(y)) : Di(x, t.hours, t.minutes, a()) : E0(he(), a(y)), l = (x, y) => {
    t[x] = y;
  }, d = E(() => e.modelAuto && i.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : i.value.enabled), u = (x, y) => {
    const C = Object.fromEntries(
      Object.keys(t).map(($) => $ === x ? [$, y] : [$, t[$]].slice())
    );
    if (d.value && !i.value.disableTimeRangeValidation) {
      const $ = (z) => n.value ? Di(
        n.value[z],
        C.hours[z],
        C.minutes[z],
        C.seconds[z]
      ) : null, O = (z) => O0(n.value[z], 0);
      return !(st($(0), $(1)) && (Jo($(0), O(1)) || qa($(1), O(0))));
    }
    return !0;
  }, c = (x, y) => {
    u(x, y) && (l(x, y), r && r());
  }, f = (x) => {
    c("hours", x);
  }, h = (x) => {
    c("minutes", x);
  }, p = (x) => {
    c("seconds", x);
  }, m = (x, y, C, $) => {
    y && f(x), !y && !C && h(x), C && p(x), n.value && $(n.value);
  }, g = (x) => {
    if (x) {
      const y = Array.isArray(x), C = y ? [+x[0].hours, +x[1].hours] : +x.hours, $ = y ? [+x[0].minutes, +x[1].minutes] : +x.minutes, O = y ? [+x[0].seconds, +x[1].seconds] : +x.seconds;
      l("hours", C), l("minutes", $), e.enableSeconds && l("seconds", O);
    }
  }, v = (x, y) => {
    const C = {
      hours: Array.isArray(t.hours) ? t.hours[x] : t.hours,
      disabledArr: []
    };
    return (y || y === 0) && (C.hours = y), Array.isArray(e.disabledTimes) && (C.disabledArr = i.value.enabled && Array.isArray(e.disabledTimes[x]) ? e.disabledTimes[x] : e.disabledTimes), C;
  }, b = E(() => (x, y) => {
    var $, O;
    var C;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: z, hours: P } = v(x, y), U = z.filter((ie) => +ie.hours === P);
      return ((C = U[0]) == null ? void 0 : C.minutes) === "*" ? { hours: [P], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: ($ = U == null ? void 0 : U.map((ie) => +ie.minutes)) != null ? $ : [],
        seconds: (O = U == null ? void 0 : U.map((ie) => ie.seconds ? +ie.seconds : void 0)) != null ? O : []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: f,
    updateMinutes: h,
    updateSeconds: p,
    getSetDateTime: s,
    updateTimeValues: m,
    getSecondsValue: a,
    assignStartTime: g,
    validateTime: u,
    disabledTimesConfig: b
  };
}, b7 = (e, t) => {
  const { modelValue: n, time: r } = ms(e, t), { defaultedStartTime: i, defaultedRange: o } = Et(e), { updateTimeValues: a, getSetDateTime: s, setTime: l, assignStartTime: d, disabledTimesConfig: u, validateTime: c } = X2(e, r, n, f);
  function f() {
    t("update-flow-step");
  }
  const h = (y) => {
    const { hours: C, minutes: $, seconds: O } = y;
    return { hours: +C, minutes: +$, seconds: O ? +O : 0 };
  }, p = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const C = h(e.startTime[0]), $ = h(e.startTime[1]);
        return [bt(he(), C), bt(he(), $)];
      }
      const y = h(e.startTime);
      return bt(he(), y);
    }
    return o.value.enabled ? [null, null] : null;
  }, m = () => {
    if (o.value.enabled) {
      const [y, C] = p();
      n.value = [s(y, 0), s(C, 1)];
    } else
      n.value = s(p());
  }, g = (y) => Array.isArray(y) ? [no(he(y[0])), no(he(y[1]))] : [no(y != null ? y : he())], v = (y, C, $) => {
    l("hours", y), l("minutes", C), l("seconds", e.enableSeconds ? $ : 0);
  }, b = () => {
    const [y, C] = g(n.value);
    return o.value.enabled ? v(
      [y.hours, C.hours],
      [y.minutes, C.minutes],
      [y.seconds, C.seconds]
    ) : v(y.hours, y.minutes, y.seconds);
  };
  ot(() => {
    if (!e.shadow)
      return d(i.value), n.value ? b() : m();
  });
  const x = () => {
    Array.isArray(n.value) ? n.value = n.value.map((y, C) => y && s(y, C)) : n.value = s(n.value), t("time-update");
  };
  return {
    modelValue: n,
    time: r,
    disabledTimesConfig: u,
    updateTime: (y, C = !0, $ = !1) => {
      a(y, C, $, x);
    },
    validateTime: c
  };
}, $7 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...vr
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, o = ci(), a = Ln(o, "timePicker"), s = q(null), { time: l, modelValue: d, disabledTimesConfig: u, updateTime: c, validateTime: f } = b7(i, r);
    return ot(() => {
      i.shadow || r("mount", null);
    }), t({ getSidebarProps: () => ({
      modelValue: d,
      time: l,
      updateTime: c
    }), toggleTimePicker: (h, p = !1, m = "") => {
      var g;
      (g = s.value) == null || g.toggleTimePicker(h, p, m);
    } }), (h, p) => (k(), ge(gd, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: de(() => [
        fe(J2, $t({
          ref_key: "tpRef",
          ref: s
        }, h.$props, {
          hours: D(l).hours,
          minutes: D(l).minutes,
          seconds: D(l).seconds,
          "internal-model-value": h.internalModelValue,
          "disabled-times-config": D(u),
          "validate-time": D(f),
          "onUpdate:hours": p[0] || (p[0] = (m) => D(c)(m)),
          "onUpdate:minutes": p[1] || (p[1] = (m) => D(c)(m, !1)),
          "onUpdate:seconds": p[2] || (p[2] = (m) => D(c)(m, !1, !0)),
          onAmPmChange: p[3] || (p[3] = (m) => h.$emit("am-pm-change", m)),
          onResetFlow: p[4] || (p[4] = (m) => h.$emit("reset-flow"))
        }), qt({ _: 2 }, [
          Ze(D(a), (m, g) => ({
            name: m,
            fn: de((v) => [
              se(h.$slots, m, tn(Sn(v)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), w7 = { class: "dp--header-wrap" }, k7 = {
  key: 0,
  class: "dp__month_year_wrap"
}, x7 = { key: 0 }, S7 = { class: "dp__month_year_wrap" }, C7 = ["aria-label", "data-test", "onClick", "onKeydown"], T7 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...vr
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, {
      defaultedTransitions: o,
      defaultedAriaLabels: a,
      defaultedMultiCalendars: s,
      defaultedFilters: l,
      defaultedConfig: d,
      defaultedHighlight: u,
      propDates: c
    } = Et(i), { transitionName: f, showTransition: h } = hs(o), { buildMatrix: p } = Li(), { handleMonthYearChange: m, isDisabled: g, updateMonthYear: v } = I8(i, r), { showLeftIcon: b, showRightIcon: x } = hd(), y = q(!1), C = q(!1), $ = q([null, null, null, null]);
    ot(() => {
      r("mount");
    });
    const O = (Y) => ({
      get: () => i[Y],
      set: (ce) => {
        const S = Y === tr.month ? tr.year : tr.month;
        r("update-month-year", { [Y]: ce, [S]: i[S] }), Y === tr.month ? T(!0) : M(!0);
      }
    }), z = E(O(tr.month)), P = E(O(tr.year)), U = E(() => (Y) => ({
      month: i.month,
      year: i.year,
      items: Y === tr.month ? i.months : i.years,
      instance: i.instance,
      updateMonthYear: v,
      toggle: Y === tr.month ? T : M
    })), ie = E(() => i.months.find((ce) => ce.value === i.month) || { text: "", value: 0 }), W = E(() => Qo(i.months, (Y) => {
      const ce = i.month === Y.value, S = Ya(
        Y.value,
        F2(i.year, c.value.minDate),
        B2(i.year, c.value.maxDate)
      ) || l.value.months.includes(Y.value), j = W2(u.value, Y.value, i.year);
      return { active: ce, disabled: S, highlighted: j };
    })), H = E(() => Qo(i.years, (Y) => {
      const ce = i.year === Y.value, S = Ya(
        Y.value,
        Zo(c.value.minDate),
        Zo(c.value.maxDate)
      ) || l.value.years.includes(Y.value), j = F0(u.value, Y.value);
      return { active: ce, disabled: S, highlighted: j };
    })), _ = (Y, ce) => {
      ce !== void 0 ? Y.value = ce : Y.value = !Y.value, Y.value || r("overlay-closed");
    }, T = (Y = !1, ce) => {
      V(Y), _(y, ce);
    }, M = (Y = !1, ce) => {
      V(Y), _(C, ce);
    }, V = (Y) => {
      Y || r("reset-flow");
    }, Q = (Y, ce) => {
      i.arrowNavigation && ($.value[ce] = Gt(Y), p($.value, "monthYear"));
    }, ue = E(() => {
      var Y, ce;
      return [
        {
          type: tr.month,
          index: 1,
          toggle: T,
          modelValue: z.value,
          updateModelValue: (S) => z.value = S,
          text: ie.value.text,
          showSelectionGrid: y.value,
          items: W.value,
          ariaLabel: (Y = a.value) == null ? void 0 : Y.openMonthsOverlay
        },
        {
          type: tr.year,
          index: 2,
          toggle: M,
          modelValue: P.value,
          updateModelValue: (S) => P.value = S,
          text: L2(i.year, i.locale),
          showSelectionGrid: C.value,
          items: H.value,
          ariaLabel: (ce = a.value) == null ? void 0 : ce.openYearsOverlay
        }
      ];
    }), oe = E(() => i.disableYearSelect ? [ue.value[0]] : i.yearFirst ? [...ue.value].reverse() : ue.value);
    return t({
      toggleMonthPicker: T,
      toggleYearPicker: M,
      handleMonthYearChange: m
    }), (Y, ce) => {
      var S, j, Z;
      return k(), A("div", w7, [
        Y.$slots["month-year"] ? (k(), A("div", k7, [
          se(Y.$slots, "month-year", tn(Sn({ month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: D(v), handleMonthYearChange: D(m), instance: e.instance })))
        ])) : (k(), A(Ie, { key: 1 }, [
          Y.$slots["top-extra"] ? (k(), A("div", x7, [
            se(Y.$slots, "top-extra", { value: Y.internalModelValue })
          ])) : K("", !0),
          G("div", S7, [
            D(b)(D(s), e.instance) && !Y.vertical ? (k(), ge(Na, {
              key: 0,
              "aria-label": (S = D(a)) == null ? void 0 : S.prevMonth,
              disabled: D(g)(!1),
              onActivate: ce[0] || (ce[0] = (ee) => D(m)(!1, !0)),
              onSetRef: ce[1] || (ce[1] = (ee) => Q(ee, 0))
            }, {
              default: de(() => [
                Y.$slots["arrow-left"] ? se(Y.$slots, "arrow-left", { key: 0 }) : K("", !0),
                Y.$slots["arrow-left"] ? K("", !0) : (k(), ge(D(D0), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : K("", !0),
            G("div", {
              class: te(["dp__month_year_wrap", {
                dp__year_disable_select: Y.disableYearSelect
              }])
            }, [
              (k(!0), A(Ie, null, Ze(oe.value, (ee, N) => (k(), A(Ie, {
                key: ee.type
              }, [
                G("button", {
                  ref_for: !0,
                  ref: (Ce) => Q(Ce, N + 1),
                  type: "button",
                  class: "dp__btn dp__month_year_select",
                  tabindex: "0",
                  "aria-label": ee.ariaLabel,
                  "data-test": `${ee.type}-toggle-overlay-${e.instance}`,
                  onClick: ee.toggle,
                  onKeydown: [
                    Re(Ge(ee.toggle, ["prevent"]), ["enter"]),
                    Re(Ge(ee.toggle, ["prevent"]), ["space"])
                  ]
                }, [
                  Y.$slots[ee.type] ? se(Y.$slots, ee.type, {
                    key: 0,
                    text: ee.text,
                    value: i[ee.type]
                  }) : K("", !0),
                  Y.$slots[ee.type] ? K("", !0) : (k(), A(Ie, { key: 1 }, [
                    it(Te(ee.text), 1)
                  ], 64))
                ], 40, C7),
                fe(ur, {
                  name: D(f)(ee.showSelectionGrid),
                  css: D(h)
                }, {
                  default: de(() => [
                    ee.showSelectionGrid ? (k(), ge(gs, {
                      key: 0,
                      items: ee.items,
                      "arrow-navigation": Y.arrowNavigation,
                      "hide-navigation": Y.hideNavigation,
                      "is-last": Y.autoApply && !D(d).keepActionRow,
                      "skip-button-ref": !1,
                      config: Y.config,
                      type: ee.type,
                      "header-refs": [],
                      "esc-close": Y.escClose,
                      "menu-wrap-ref": Y.menuWrapRef,
                      "text-input": Y.textInput,
                      "aria-labels": Y.ariaLabels,
                      onSelected: ee.updateModelValue,
                      onToggle: ee.toggle
                    }, qt({
                      "button-icon": de(() => [
                        Y.$slots["calendar-icon"] ? se(Y.$slots, "calendar-icon", { key: 0 }) : K("", !0),
                        Y.$slots["calendar-icon"] ? K("", !0) : (k(), ge(D(fa), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      Y.$slots[`${ee.type}-overlay-value`] ? {
                        name: "item",
                        fn: de(({ item: Ce }) => [
                          se(Y.$slots, `${ee.type}-overlay-value`, {
                            text: Ce.text,
                            value: Ce.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      Y.$slots[`${ee.type}-overlay`] ? {
                        name: "overlay",
                        fn: de(() => [
                          se(Y.$slots, `${ee.type}-overlay`, $t({ ref_for: !0 }, U.value(ee.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      Y.$slots[`${ee.type}-overlay-header`] ? {
                        name: "header",
                        fn: de(() => [
                          se(Y.$slots, `${ee.type}-overlay-header`, {
                            toggle: ee.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "onSelected", "onToggle"])) : K("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            D(b)(D(s), e.instance) && Y.vertical ? (k(), ge(Na, {
              key: 1,
              "aria-label": (j = D(a)) == null ? void 0 : j.prevMonth,
              disabled: D(g)(!1),
              onActivate: ce[2] || (ce[2] = (ee) => D(m)(!1, !0))
            }, {
              default: de(() => [
                Y.$slots["arrow-up"] ? se(Y.$slots, "arrow-up", { key: 0 }) : K("", !0),
                Y.$slots["arrow-up"] ? K("", !0) : (k(), ge(D(N0), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : K("", !0),
            D(x)(D(s), e.instance) ? (k(), ge(Na, {
              key: 2,
              ref: "rightIcon",
              disabled: D(g)(!0),
              "aria-label": (Z = D(a)) == null ? void 0 : Z.nextMonth,
              onActivate: ce[3] || (ce[3] = (ee) => D(m)(!0, !0)),
              onSetRef: ce[4] || (ce[4] = (ee) => Q(ee, Y.disableYearSelect ? 2 : 3))
            }, {
              default: de(() => [
                Y.$slots[Y.vertical ? "arrow-down" : "arrow-right"] ? se(Y.$slots, Y.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : K("", !0),
                Y.$slots[Y.vertical ? "arrow-down" : "arrow-right"] ? K("", !0) : (k(), ge(Qn(Y.vertical ? D(I0) : D(A0)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label"])) : K("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), M7 = ["aria-label"], O7 = {
  class: "dp__calendar_header",
  role: "row"
}, E7 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, D7 = ["aria-label"], A7 = /* @__PURE__ */ G("div", { class: "dp__calendar_header_separator" }, null, -1), P7 = ["aria-label"], N7 = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, I7 = { class: "dp__cell_inner" }, R7 = ["id", "aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], _7 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...vr
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, { buildMultiLevelMatrix: o } = Li(), {
      defaultedTransitions: a,
      defaultedConfig: s,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: d,
      defaultedWeekNumbers: u,
      defaultedMultiDates: c
    } = Et(i), f = q(null), h = q({
      bottom: "",
      left: "",
      transform: ""
    }), p = q([]), m = q(null), g = q(!0), v = q(""), b = q({ startX: 0, endX: 0, startY: 0, endY: 0 }), x = q([]), y = q({ left: "50%" }), C = q(!1), $ = E(() => i.calendar ? i.calendar(i.mappedDates) : i.mappedDates), O = E(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames(i.locale, +i.weekStart) : t8(i.formatLocale, i.locale, +i.weekStart));
    ot(() => {
      r("mount", { cmp: "calendar", refs: p }), s.value.noSwipe || m.value && (m.value.addEventListener("touchstart", ue, { passive: !1 }), m.value.addEventListener("touchend", oe, { passive: !1 }), m.value.addEventListener("touchmove", Y, { passive: !1 })), i.monthChangeOnScroll && m.value && m.value.addEventListener("wheel", j, { passive: !1 });
    });
    const z = (I) => I ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", P = (I, Me) => {
      if (i.transitions) {
        const Ye = Fn(ri(he(), i.month, i.year));
        v.value = Bt(Fn(ri(he(), I, Me)), Ye) ? a.value[z(!0)] : a.value[z(!1)], g.value = !1, an(() => {
          g.value = !0;
        });
      }
    }, U = E(
      () => ({
        [i.calendarClassName]: !!i.calendarClassName
      })
    ), ie = E(() => (I) => {
      const Me = r8(I);
      return {
        dp__marker_dot: Me.type === "dot",
        dp__marker_line: Me.type === "line"
      };
    }), W = E(() => (I) => st(I, f.value)), H = E(() => ({
      dp__calendar: !0,
      dp__calendar_next: d.value.count > 0 && i.instance !== 0
    })), _ = E(() => (I) => i.hideOffsetDates ? I.current : !0), T = (I) => _r(I, "yyyy-MM-dd"), M = async (I, Me, Ye) => {
      const ke = Gt(p.value[Me][Ye]);
      if (ke) {
        const { width: je, height: re } = ke.getBoundingClientRect();
        f.value = I.value;
        let le = { left: `${je / 2}px` }, Ke = -50;
        if (await an(), x.value[0]) {
          const { left: We, width: Tt } = x.value[0].getBoundingClientRect();
          We < 0 && (le = { left: "0" }, Ke = 0, y.value.left = `${je / 2}px`), window.innerWidth < We + Tt && (le = { right: "0" }, Ke = 0, y.value.left = `${Tt - je / 2}px`);
        }
        h.value = {
          bottom: `${re}px`,
          ...le,
          transform: `translateX(${Ke}%)`
        }, r("tooltip-open", I.marker);
      }
    }, V = async (I, Me, Ye) => {
      var ke, je;
      if (C.value && c.value.enabled && c.value.dragSelect)
        return r("select-date", I);
      r("set-hover-date", I), (je = (ke = I.marker) == null ? void 0 : ke.tooltip) != null && je.length && await M(I, Me, Ye);
    }, Q = (I) => {
      f.value && (f.value = null, h.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), r("tooltip-close", I.marker));
    }, ue = (I) => {
      b.value.startX = I.changedTouches[0].screenX, b.value.startY = I.changedTouches[0].screenY;
    }, oe = (I) => {
      b.value.endX = I.changedTouches[0].screenX, b.value.endY = I.changedTouches[0].screenY, ce();
    }, Y = (I) => {
      i.vertical && !i.inline && I.preventDefault();
    }, ce = () => {
      const I = i.vertical ? "Y" : "X";
      Math.abs(b.value[`start${I}`] - b.value[`end${I}`]) > 10 && r("handle-swipe", b.value[`start${I}`] > b.value[`end${I}`] ? "right" : "left");
    }, S = (I, Me, Ye) => {
      I && (Array.isArray(p.value[Me]) ? p.value[Me][Ye] = I : p.value[Me] = [I]), i.arrowNavigation && o(p.value, "calendar");
    }, j = (I) => {
      i.monthChangeOnScroll && (I.preventDefault(), r("handle-scroll", I));
    }, Z = (I) => u.value.type === "local" ? C0(I.value, { weekStartsOn: +i.weekStart }) : u.value.type === "iso" ? x0(I.value) : typeof u.value.type == "function" ? u.value.type(I.value) : "", ee = (I) => {
      const Me = I[0];
      return u.value.hideOnOffsetDates ? I.some((Ye) => Ye.current) ? Z(Me) : "" : Z(Me);
    }, N = (I, Me) => {
      c.value.enabled || (Ei(I, s.value), r("select-date", Me));
    }, Ce = (I) => {
      Ei(I, s.value);
    }, qe = (I) => {
      c.value.enabled && c.value.dragSelect ? (C.value = !0, r("select-date", I)) : c.value.enabled && r("select-date", I);
    };
    return t({ triggerTransition: P }), (I, Me) => {
      var Ye;
      return k(), A("div", {
        class: te(H.value)
      }, [
        G("div", {
          ref_key: "calendarWrapRef",
          ref: m,
          role: "grid",
          class: te(U.value),
          "aria-label": (Ye = D(l)) == null ? void 0 : Ye.calendarWrap
        }, [
          G("div", O7, [
            I.weekNumbers ? (k(), A("div", E7, Te(I.weekNumName), 1)) : K("", !0),
            (k(!0), A(Ie, null, Ze(O.value, (ke, je) => {
              var re, le;
              return k(), A("div", {
                key: je,
                class: "dp__calendar_header_item",
                role: "gridcell",
                "data-test": "calendar-header",
                "aria-label": (le = (re = D(l)) == null ? void 0 : re.weekDay) == null ? void 0 : le.call(re, je)
              }, [
                I.$slots["calendar-header"] ? se(I.$slots, "calendar-header", {
                  key: 0,
                  day: ke,
                  index: je
                }) : K("", !0),
                I.$slots["calendar-header"] ? K("", !0) : (k(), A(Ie, { key: 1 }, [
                  it(Te(ke), 1)
                ], 64))
              ], 8, D7);
            }), 128))
          ]),
          A7,
          fe(ur, {
            name: v.value,
            css: !!I.transitions
          }, {
            default: de(() => {
              var ke;
              return [
                g.value ? (k(), A("div", {
                  key: 0,
                  class: "dp__calendar",
                  role: "rowgroup",
                  "aria-label": ((ke = D(l)) == null ? void 0 : ke.calendarDays) || void 0,
                  onMouseleave: Me[1] || (Me[1] = (je) => C.value = !1)
                }, [
                  (k(!0), A(Ie, null, Ze($.value, (je, re) => (k(), A("div", {
                    key: re,
                    class: "dp__calendar_row",
                    role: "row"
                  }, [
                    I.weekNumbers ? (k(), A("div", N7, [
                      G("div", I7, Te(ee(je.days)), 1)
                    ])) : K("", !0),
                    (k(!0), A(Ie, null, Ze(je.days, (le, Ke) => {
                      var xt;
                      var We, Tt, Oe;
                      return k(), A("div", {
                        id: T(le.value),
                        ref_for: !0,
                        ref: (lt) => S(lt, re, Ke),
                        key: Ke + re,
                        role: "gridcell",
                        class: "dp__calendar_item",
                        "aria-selected": (xt = le.classData.dp__active_date || le.classData.dp__range_start || le.classData.dp__range_start) != null ? xt : void 0,
                        "aria-disabled": le.classData.dp__cell_disabled || void 0,
                        "aria-label": (Tt = (We = D(l)) == null ? void 0 : We.day) == null ? void 0 : Tt.call(We, le),
                        tabindex: "0",
                        "data-test": le.value,
                        onClick: Ge((lt) => N(lt, le), ["prevent"]),
                        onKeydown: [
                          Re((lt) => I.$emit("select-date", le), ["enter"]),
                          Re((lt) => I.$emit("handle-space", le), ["space"])
                        ],
                        onMouseenter: (lt) => V(le, re, Ke),
                        onMouseleave: (lt) => Q(le),
                        onMousedown: (lt) => qe(le),
                        onMouseup: Me[0] || (Me[0] = (lt) => C.value = !1)
                      }, [
                        G("div", {
                          class: te(["dp__cell_inner", le.classData])
                        }, [
                          I.$slots.day && _.value(le) ? se(I.$slots, "day", {
                            key: 0,
                            day: +le.text,
                            date: le.value
                          }) : K("", !0),
                          I.$slots.day ? K("", !0) : (k(), A(Ie, { key: 1 }, [
                            it(Te(le.text), 1)
                          ], 64)),
                          le.marker && _.value(le) ? (k(), A(Ie, { key: 2 }, [
                            I.$slots.marker ? se(I.$slots, "marker", {
                              key: 0,
                              marker: le.marker,
                              day: +le.text,
                              date: le.value
                            }) : (k(), A("div", {
                              key: 1,
                              class: te(ie.value(le.marker)),
                              style: mt(le.marker.color ? { backgroundColor: le.marker.color } : {})
                            }, null, 6))
                          ], 64)) : K("", !0),
                          W.value(le.value) ? (k(), A("div", {
                            key: 3,
                            ref_for: !0,
                            ref_key: "activeTooltip",
                            ref: x,
                            class: "dp__marker_tooltip",
                            style: mt(h.value)
                          }, [
                            (Oe = le.marker) != null && Oe.tooltip ? (k(), A("div", {
                              key: 0,
                              class: "dp__tooltip_content",
                              onClick: Ce
                            }, [
                              (k(!0), A(Ie, null, Ze(le.marker.tooltip, (lt, Yt) => (k(), A("div", {
                                key: Yt,
                                class: "dp__tooltip_text"
                              }, [
                                I.$slots["marker-tooltip"] ? se(I.$slots, "marker-tooltip", {
                                  key: 0,
                                  tooltip: lt,
                                  day: le.value
                                }) : K("", !0),
                                I.$slots["marker-tooltip"] ? K("", !0) : (k(), A(Ie, { key: 1 }, [
                                  G("div", {
                                    class: "dp__tooltip_mark",
                                    style: mt(lt.color ? { backgroundColor: lt.color } : {})
                                  }, null, 4),
                                  G("div", null, Te(lt.text), 1)
                                ], 64))
                              ]))), 128)),
                              G("div", {
                                class: "dp__arrow_bottom_tp",
                                style: mt(y.value)
                              }, null, 4)
                            ])) : K("", !0)
                          ], 4)) : K("", !0)
                        ], 2)
                      ], 40, R7);
                    }), 128))
                  ]))), 128))
                ], 40, P7)) : K("", !0)
              ];
            }),
            _: 3
          }, 8, ["name", "css"])
        ], 10, M7)
      ], 2);
    };
  }
}), Lp = (e) => Array.isArray(e), L7 = (e, t, n, r) => {
  const i = q([]), o = q(/* @__PURE__ */ new Date()), a = q(), { modelValue: s, calendars: l, time: d, today: u } = ms(e, t), {
    defaultedMultiCalendars: c,
    defaultedStartTime: f,
    defaultedRange: h,
    defaultedConfig: p,
    defaultedTz: m,
    propDates: g,
    defaultedMultiDates: v
  } = Et(e), { validateMonthYearInRange: b, isDisabled: x, isDateRangeAllowed: y, checkMinMaxRange: C } = Fi(e), { updateTimeValues: $, getSetDateTime: O, setTime: z, assignStartTime: P, validateTime: U, disabledTimesConfig: ie } = X2(e, d, s, r), W = E(
    () => (R) => l.value[R] ? l.value[R].month : 0
  ), H = E(
    () => (R) => l.value[R] ? l.value[R].year : 0
  ), _ = (R) => !p.value.keepViewOnOffsetClick || R ? !0 : !a.value, T = (R, F, ae, pe = !1) => {
    var we, dt;
    _(pe) && (l.value[R] || (l.value[R] = { month: 0, year: 0 }), l.value[R].month = Pp(F) ? (we = l.value[R]) == null ? void 0 : we.month : F, l.value[R].year = Pp(ae) ? (dt = l.value[R]) == null ? void 0 : dt.year : ae);
  }, M = () => {
    e.autoApply && t("select-date");
  };
  Fe(
    s,
    (R, F) => {
      JSON.stringify(R) !== JSON.stringify(F) && ue();
    },
    { deep: !0 }
  ), ot(() => {
    e.shadow || (s.value || (I(), f.value && P(f.value)), ue(!0), e.focusStartDate && e.startDate && I());
  });
  const V = E(() => {
    var R;
    return (R = e.flow) != null && R.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), Q = () => {
    e.autoApply && V.value && t("auto-apply");
  }, ue = (R = !1) => {
    if (s.value)
      return Array.isArray(s.value) ? (i.value = s.value, ee(R)) : ce(s.value, R);
    if (c.value.count && R && !e.startDate)
      return Y(he(), R);
  }, oe = () => {
    var R;
    return Array.isArray(s.value) && h.value.enabled ? at(s.value[0]) === at((R = s.value[1]) != null ? R : s.value[0]) : !1;
  }, Y = (R, F = !1) => {
    if ((!c.value.count || !c.value.static || F) && T(0, at(R), nt(R)), c.value.count && (!c.value.solo || !s.value || oe()))
      for (let ae = 1; ae < c.value.count; ae++) {
        const pe = bt(he(), { month: W.value(ae - 1), year: H.value(ae - 1) }), we = c2(pe, { months: 1 });
        l.value[ae] = { month: at(we), year: nt(we) };
      }
  }, ce = (R, F) => {
    Y(R), z("hours", lr(R)), z("minutes", Lr(R)), z("seconds", Go(R)), c.value.count && F && qe();
  }, S = (R) => {
    if (c.value.count) {
      if (c.value.solo)
        return 0;
      const F = at(R[0]), ae = at(R[1]);
      return Math.abs(ae - F) < c.value.count ? 0 : 1;
    }
    return 1;
  }, j = (R, F) => {
    R[1] && h.value.showLastInRange ? Y(R[S(R)], F) : Y(R[0], F);
    const ae = (pe, we) => [
      pe(R[0]),
      R[1] ? pe(R[1]) : d[we][1]
    ];
    z("hours", ae(lr, "hours")), z("minutes", ae(Lr, "minutes")), z("seconds", ae(Go, "seconds"));
  }, Z = (R, F) => {
    if ((h.value.enabled || e.weekPicker) && !v.value.enabled)
      return j(R, F);
    if (v.value.enabled && F) {
      const ae = R[R.length - 1];
      return ce(ae, F);
    }
  }, ee = (R) => {
    const F = s.value;
    Z(F, R), c.value.count && c.value.solo && qe();
  }, N = (R, F) => {
    const ae = bt(he(), { month: W.value(F), year: H.value(F) }), pe = R < 0 ? sr(ae, 1) : Xo(ae, 1);
    b(at(pe), nt(pe), R < 0, e.preventMinMaxNavigation) && (T(F, at(pe), nt(pe)), t("update-month-year", { instance: F, month: at(pe), year: nt(pe) }), c.value.count && !c.value.solo && Ce(F), n());
  }, Ce = (R) => {
    for (let F = R - 1; F >= 0; F--) {
      const ae = Xo(bt(he(), { month: W.value(F + 1), year: H.value(F + 1) }), 1);
      T(F, at(ae), nt(ae));
    }
    for (let F = R + 1; F <= c.value.count - 1; F++) {
      const ae = sr(bt(he(), { month: W.value(F - 1), year: H.value(F - 1) }), 1);
      T(F, at(ae), nt(ae));
    }
  }, qe = () => {
    if (Array.isArray(s.value) && s.value.length === 2) {
      const R = he(
        he(s.value[1] ? s.value[1] : sr(s.value[0], 1))
      ), [F, ae] = [at(s.value[0]), nt(s.value[0])], [pe, we] = [at(s.value[1]), nt(s.value[1])];
      (F !== pe || F === pe && ae !== we) && c.value.solo && T(1, at(R), nt(R));
    } else
      s.value && !Array.isArray(s.value) && (T(0, at(s.value), nt(s.value)), Y(he()));
  }, I = () => {
    e.startDate && (T(0, at(he(e.startDate)), nt(he(e.startDate))), c.value.count && Ce(0));
  }, Me = (R, F) => {
    if (e.monthChangeOnScroll) {
      const ae = (/* @__PURE__ */ new Date()).getTime() - o.value.getTime(), pe = Math.abs(R.deltaY);
      let we = 500;
      pe > 1 && (we = 100), pe > 100 && (we = 0), ae > we && (o.value = /* @__PURE__ */ new Date(), N(e.monthChangeOnScroll !== "inverse" ? -R.deltaY : R.deltaY, F));
    }
  }, Ye = (R, F, ae = !1) => {
    e.monthChangeOnArrows && e.vertical === ae && ke(R, F);
  }, ke = (R, F) => {
    N(R === "right" ? -1 : 1, F);
  }, je = (R) => {
    if (g.value.markers)
      return ll(R.value, g.value.markers);
  }, re = (R, F) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [R == 0, !0];
      case "fair":
        return [R == 0 || F > R, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, le = (R, F, ae, pe) => {
    if (e.sixWeeks && R.length < 6) {
      const we = 6 - R.length, dt = (F.getDay() + 7 - pe) % 7, ut = 6 - (ae.getDay() + 7 - pe) % 7, [gt, Vn] = re(dt, ut);
      for (let jt = 1; jt <= we; jt++)
        if (Vn ? !!(jt % 2) == gt : gt) {
          const Dt = R[0].days[0], br = Ke(ir(Dt.value, -7), at(F));
          R.unshift({ days: br });
        } else {
          const Dt = R[R.length - 1], br = Dt.days[Dt.days.length - 1], $r = Ke(ir(br.value, 1), at(F));
          R.push({ days: $r });
        }
    }
    return R;
  }, Ke = (R, F) => {
    const ae = he(R), pe = [];
    for (let we = 0; we < 7; we++) {
      const dt = ir(ae, we), ut = at(dt) !== F;
      pe.push({
        text: e.hideOffsetDates && ut ? "" : dt.getDate(),
        value: dt,
        current: !ut,
        classData: {}
      });
    }
    return pe;
  }, We = (R, F) => {
    const ae = [], pe = new Date(F, R), we = new Date(F, R + 1, 0), dt = e.weekStart, ut = cr(pe, { weekStartsOn: dt }), gt = (Vn) => {
      const jt = Ke(Vn, R);
      if (ae.push({ days: jt }), !ae[ae.length - 1].days.some(
        (Dt) => st(Fn(Dt.value), Fn(we))
      )) {
        const Dt = ir(Vn, 7);
        gt(Dt);
      }
    };
    return gt(ut), le(ae, pe, we, dt);
  }, Tt = (R) => {
    const F = Di(he(R.value), d.hours, d.minutes, Ht());
    t("date-update", F), v.value.enabled ? B0(F, s, v.value.limit) : s.value = F, r(), an().then(() => {
      Q();
    });
  }, Oe = (R) => h.value.noDisabledRange ? z2(i.value[0], R).some((F) => x(F)) : !1, xt = () => {
    i.value = s.value ? s.value.slice() : [], i.value.length === 2 && !(h.value.fixedStart || h.value.fixedEnd) && (i.value = []);
  }, lt = (R, F) => {
    const ae = [
      he(R.value),
      ir(he(R.value), +h.value.autoRange)
    ];
    y(ae) ? (F && Yt(R.value), i.value = ae) : t("invalid-date", R.value);
  }, Yt = (R) => {
    const F = at(he(R)), ae = nt(he(R));
    if (T(0, F, ae), c.value.count > 0)
      for (let pe = 1; pe < c.value.count; pe++) {
        const we = c8(
          bt(he(R), { year: W.value(pe - 1), month: H.value(pe - 1) })
        );
        T(pe, we.month, we.year);
      }
  }, er = (R) => {
    if (Oe(R.value) || !C(R.value, s.value, h.value.fixedStart ? 0 : 1))
      return t("invalid-date", R.value);
    i.value = K2(he(R.value), s, t, h);
  }, Pn = (R, F) => {
    if (xt(), h.value.autoRange)
      return lt(R, F);
    if (h.value.fixedStart || h.value.fixedEnd)
      return er(R);
    i.value[0] ? C(he(R.value), s.value) && !Oe(R.value) ? Pt(he(R.value), he(i.value[0])) ? (i.value.unshift(he(R.value)), t("range-end", i.value[0])) : (i.value[1] = he(R.value), t("range-end", i.value[1])) : (e.autoApply && t("auto-apply-invalid", R.value), t("invalid-date", R.value)) : (i.value[0] = he(R.value), t("range-start", i.value[0]));
  }, Ht = (R = !0) => e.enableSeconds ? Array.isArray(d.seconds) ? R ? d.seconds[0] : d.seconds[1] : d.seconds : 0, Nn = (R) => {
    i.value[R] = Di(
      i.value[R],
      d.hours[R],
      d.minutes[R],
      Ht(R !== 1)
    );
  }, yr = () => {
    var R, F;
    i.value[0] && i.value[1] && +((R = i.value) == null ? void 0 : R[0]) > +((F = i.value) == null ? void 0 : F[1]) && (i.value.reverse(), t("range-start", i.value[0]), t("range-end", i.value[1]));
  }, B = () => {
    i.value.length && (i.value[0] && !i.value[1] ? Nn(0) : (Nn(0), Nn(1), r()), yr(), s.value = i.value.slice(), vd(i.value, t, e.autoApply, e.modelAuto));
  }, w = (R, F = !1) => {
    if (x(R.value) || !R.current && e.hideOffsetDates)
      return t("invalid-date", R.value);
    if (a.value = JSON.parse(JSON.stringify(R)), !h.value.enabled)
      return Tt(R);
    Lp(d.hours) && Lp(d.minutes) && !v.value.enabled && (Pn(R, F), B());
  }, ye = (R, F) => {
    var ae;
    T(R, F.month, F.year, !0), c.value.count && !c.value.solo && Ce(R), t("update-month-year", { instance: R, month: F.month, year: F.year }), n(c.value.solo ? R : void 0);
    const pe = (ae = e.flow) != null && ae.length ? e.flow[e.flowStep] : void 0;
    !F.fromNav && (pe === Cr.month || pe === Cr.year) && r();
  }, Pe = (R, F) => {
    Y2({
      value: R,
      modelValue: s,
      range: h.value.enabled,
      timezone: F ? void 0 : m.value.timezone
    }), M(), e.multiCalendars && an().then(() => ue(!0));
  }, Se = () => {
    h.value.enabled ? s.value && Array.isArray(s.value) && s.value[0] ? s.value = Pt(he(), s.value[0]) ? [he(), s.value[0]] : [s.value[0], he()] : s.value = [he()] : s.value = he(), M();
  }, J = () => {
    if (Array.isArray(s.value))
      if (v.value.enabled) {
        const R = be();
        s.value[s.value.length - 1] = O(R);
      } else
        s.value = s.value.map((R, F) => R && O(R, F));
    else
      s.value = O(s.value);
    t("time-update");
  }, be = () => Array.isArray(s.value) && s.value.length ? s.value[s.value.length - 1] : null;
  return {
    calendars: l,
    modelValue: s,
    month: W,
    year: H,
    time: d,
    disabledTimesConfig: ie,
    today: u,
    validateTime: U,
    getCalendarDays: We,
    getMarker: je,
    handleScroll: Me,
    handleSwipe: ke,
    handleArrow: Ye,
    selectDate: w,
    updateMonthYear: ye,
    presetDate: Pe,
    selectCurrentDate: Se,
    updateTime: (R, F = !0, ae = !1) => {
      $(R, F, ae, J);
    }
  };
}, F7 = { key: 0 }, B7 = /* @__PURE__ */ $e({
  __name: "DatePicker",
  props: {
    ...vr
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, {
      calendars: o,
      month: a,
      year: s,
      modelValue: l,
      time: d,
      disabledTimesConfig: u,
      today: c,
      validateTime: f,
      getCalendarDays: h,
      getMarker: p,
      handleArrow: m,
      handleScroll: g,
      handleSwipe: v,
      selectDate: b,
      updateMonthYear: x,
      presetDate: y,
      selectCurrentDate: C,
      updateTime: $
    } = L7(i, r, oe, Y), O = ci(), { setHoverDate: z, getDayClassData: P, clearHoverDate: U } = F8(l, i), { defaultedMultiCalendars: ie } = Et(i), W = q([]), H = q([]), _ = q(null), T = Ln(O, "calendar"), M = Ln(O, "monthYear"), V = Ln(O, "timePicker"), Q = (S) => {
      i.shadow || r("mount", S);
    };
    Fe(
      o,
      () => {
        i.shadow || setTimeout(() => {
          r("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const ue = E(() => (S) => h(a.value(S), s.value(S)).map((j) => ({
      ...j,
      days: j.days.map((Z) => (Z.marker = p(Z), Z.classData = P(Z), Z))
    })));
    function oe(S) {
      var j;
      S || S === 0 ? (j = H.value[S]) == null || j.triggerTransition(a.value(S), s.value(S)) : H.value.forEach((Z, ee) => Z.triggerTransition(a.value(ee), s.value(ee)));
    }
    function Y() {
      r("update-flow-step");
    }
    const ce = (S, j = !1) => {
      b(S, j), i.spaceConfirm && r("select-date");
    };
    return t({
      clearHoverDate: U,
      presetDate: y,
      selectCurrentDate: C,
      toggleMonthPicker: (S, j, Z = 0) => {
        var ee;
        (ee = W.value[Z]) == null || ee.toggleMonthPicker(S, j);
      },
      toggleYearPicker: (S, j, Z = 0) => {
        var ee;
        (ee = W.value[Z]) == null || ee.toggleYearPicker(S, j);
      },
      toggleTimePicker: (S, j, Z) => {
        var ee;
        (ee = _.value) == null || ee.toggleTimePicker(S, j, Z);
      },
      handleArrow: m,
      updateMonthYear: x,
      getSidebarProps: () => ({
        modelValue: l,
        month: a,
        year: s,
        time: d,
        updateTime: $,
        updateMonthYear: x,
        selectDate: b,
        presetDate: y
      }),
      changeMonth: (S) => {
        var j;
        (j = W.value[0]) == null || j.handleMonthYearChange(S, !0);
      },
      changeYear: (S) => {
        x(0, { month: a.value(0), year: s.value(0) + (S ? 1 : -1), fromNav: !0 });
      },
      selectWeekDate: (S) => {
        if (!i.range) {
          const j = l.value ? l.value : c, Z = S ? cr(j, { weekStartsOn: 1 }) : b2(j, { weekStartsOn: 1 });
          b({
            value: Z,
            current: at(j) === a.value(0),
            text: "",
            classData: {}
          });
        }
      }
    }), (S, j) => (k(), A(Ie, null, [
      fe(gd, {
        "multi-calendars": D(ie).count,
        collapse: S.collapse
      }, {
        default: de(({ instance: Z, index: ee }) => [
          S.disableMonthYearSelect ? K("", !0) : (k(), ge(T7, $t({
            key: 0,
            ref: (N) => {
              N && (W.value[ee] = N);
            },
            months: D(I2)(S.formatLocale, S.locale, S.monthNameFormat),
            years: D(R0)(S.yearRange, S.locale, S.reverseYears),
            month: D(a)(Z),
            year: D(s)(Z),
            instance: Z
          }, S.$props, {
            onMount: j[0] || (j[0] = (N) => Q(D(ro).header)),
            onResetFlow: j[1] || (j[1] = (N) => S.$emit("reset-flow")),
            onUpdateMonthYear: (N) => D(x)(Z, N),
            onOverlayClosed: j[2] || (j[2] = (N) => S.$emit("focus-menu"))
          }), qt({ _: 2 }, [
            Ze(D(M), (N, Ce) => ({
              name: N,
              fn: de((qe) => [
                se(S.$slots, N, tn(Sn(qe)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          fe(_7, $t({
            ref: (N) => {
              N && (H.value[ee] = N);
            },
            "mapped-dates": ue.value(Z),
            month: D(a)(Z),
            year: D(s)(Z),
            instance: Z
          }, S.$props, {
            onSelectDate: (N) => D(b)(N, Z !== 1),
            onHandleSpace: (N) => ce(N, Z !== 1),
            onSetHoverDate: j[3] || (j[3] = (N) => D(z)(N)),
            onHandleScroll: (N) => D(g)(N, Z),
            onHandleSwipe: (N) => D(v)(N, Z),
            onMount: j[4] || (j[4] = (N) => Q(D(ro).calendar)),
            onResetFlow: j[5] || (j[5] = (N) => S.$emit("reset-flow")),
            onTooltipOpen: j[6] || (j[6] = (N) => S.$emit("tooltip-open", N)),
            onTooltipClose: j[7] || (j[7] = (N) => S.$emit("tooltip-close", N))
          }), qt({ _: 2 }, [
            Ze(D(T), (N, Ce) => ({
              name: N,
              fn: de((qe) => [
                se(S.$slots, N, tn(Sn({ ...qe })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse"]),
      S.enableTimePicker ? (k(), A("div", F7, [
        S.$slots["time-picker"] ? se(S.$slots, "time-picker", tn($t({ key: 0 }, { time: D(d), updateTime: D($) }))) : (k(), ge(J2, $t({
          key: 1,
          ref_key: "timePickerRef",
          ref: _
        }, S.$props, {
          hours: D(d).hours,
          minutes: D(d).minutes,
          seconds: D(d).seconds,
          "internal-model-value": S.internalModelValue,
          "disabled-times-config": D(u),
          "validate-time": D(f),
          onMount: j[8] || (j[8] = (Z) => Q(D(ro).timePicker)),
          "onUpdate:hours": j[9] || (j[9] = (Z) => D($)(Z)),
          "onUpdate:minutes": j[10] || (j[10] = (Z) => D($)(Z, !1)),
          "onUpdate:seconds": j[11] || (j[11] = (Z) => D($)(Z, !1, !0)),
          onResetFlow: j[12] || (j[12] = (Z) => S.$emit("reset-flow")),
          onOverlayClosed: j[13] || (j[13] = (Z) => S.$emit("time-picker-close")),
          onOverlayOpened: j[14] || (j[14] = (Z) => S.$emit("time-picker-open", Z)),
          onAmPmChange: j[15] || (j[15] = (Z) => S.$emit("am-pm-change", Z))
        }), qt({ _: 2 }, [
          Ze(D(V), (Z, ee) => ({
            name: Z,
            fn: de((N) => [
              se(S.$slots, Z, tn(Sn(N)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : K("", !0)
    ], 64));
  }
}), z7 = (e, t) => {
  const n = q(), {
    defaultedMultiCalendars: r,
    defaultedConfig: i,
    defaultedHighlight: o,
    defaultedRange: a,
    propDates: s,
    defaultedFilters: l,
    defaultedMultiDates: d
  } = Et(e), { modelValue: u, year: c, month: f, calendars: h } = ms(e, t), { isDisabled: p } = Fi(e), { selectYear: m, groupedYears: g, showYearPicker: v, isDisabled: b, toggleYearPicker: x, handleYearSelect: y, handleYear: C } = G2({
    modelValue: u,
    multiCalendars: r,
    highlight: o,
    calendars: h,
    propDates: s,
    month: f,
    year: c,
    filters: l,
    props: e,
    emit: t
  }), $ = (T, M) => [T, M].map((V) => _r(V, "MMMM", { locale: e.formatLocale })).join("-"), O = E(() => (T) => u.value ? Array.isArray(u.value) ? u.value.some((M) => Ep(T, M)) : Ep(u.value, T) : !1), z = (T) => {
    if (a.value.enabled) {
      if (Array.isArray(u.value)) {
        const M = st(T, u.value[0]) || st(T, u.value[1]);
        return pd(u.value, n.value, T) && !M;
      }
      return !1;
    }
    return !1;
  }, P = (T, M) => T.quarter === xp(M) && T.year === nt(M), U = (T) => typeof o.value == "function" ? o.value({ quarter: xp(T), year: nt(T) }) : !!o.value.quarters.find((M) => P(M, T)), ie = E(() => (T) => {
    const M = bt(/* @__PURE__ */ new Date(), { year: c.value(T) });
    return o9({
      start: y2(M),
      end: a9(M)
    }).map((V) => {
      const Q = Qi(V), ue = Sp(V), oe = p(V), Y = z(Q), ce = U(Q);
      return {
        text: $(Q, ue),
        value: Q,
        active: O.value(Q),
        highlighted: ce,
        disabled: oe,
        isBetween: Y
      };
    });
  }), W = (T) => {
    B0(T, u, d.value.limit), t("auto-apply", !0);
  }, H = (T) => {
    u.value = z0(u, T, t), vd(u.value, t, e.autoApply, e.modelAuto);
  }, _ = (T) => {
    u.value = T, t("auto-apply");
  };
  return {
    defaultedConfig: i,
    defaultedMultiCalendars: r,
    groupedYears: g,
    year: c,
    isDisabled: b,
    quarters: ie,
    showYearPicker: v,
    modelValue: u,
    setHoverDate: (T) => {
      n.value = T;
    },
    selectYear: m,
    selectQuarter: (T, M, V) => {
      if (!V)
        return h.value[M].month = at(Sp(T)), d.value.enabled ? W(T) : a.value.enabled ? H(T) : _(T);
    },
    toggleYearPicker: x,
    handleYearSelect: y,
    handleYear: C
  };
}, V7 = { class: "dp--quarter-items" }, H7 = ["data-test", "disabled", "onClick", "onMouseover"], j7 = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...vr
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, o = ci(), a = Ln(o, "yearMode"), {
      defaultedMultiCalendars: s,
      defaultedConfig: l,
      groupedYears: d,
      year: u,
      isDisabled: c,
      quarters: f,
      modelValue: h,
      showYearPicker: p,
      setHoverDate: m,
      selectQuarter: g,
      toggleYearPicker: v,
      handleYearSelect: b,
      handleYear: x
    } = z7(i, r);
    return t({ getSidebarProps: () => ({
      modelValue: h,
      year: u,
      selectQuarter: g,
      handleYearSelect: b,
      handleYear: x
    }) }), (y, C) => (k(), ge(gd, {
      "multi-calendars": D(s).count,
      collapse: y.collapse,
      stretch: ""
    }, {
      default: de(({ instance: $ }) => [
        G("div", {
          class: "dp-quarter-picker-wrap",
          style: mt({ minHeight: `${D(l).modeHeight}px` })
        }, [
          y.$slots["top-extra"] ? se(y.$slots, "top-extra", {
            key: 0,
            value: y.internalModelValue
          }) : K("", !0),
          G("div", null, [
            fe(q2, $t(y.$props, {
              items: D(d)($),
              instance: $,
              "show-year-picker": D(p)[$],
              year: D(u)($),
              "is-disabled": (O) => D(c)($, O),
              onHandleYear: (O) => D(x)($, O),
              onYearSelect: (O) => D(b)(O, $),
              onToggleYearPicker: (O) => D(v)($, O == null ? void 0 : O.flow, O == null ? void 0 : O.show)
            }), qt({ _: 2 }, [
              Ze(D(a), (O, z) => ({
                name: O,
                fn: de((P) => [
                  se(y.$slots, O, tn(Sn(P)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          G("div", V7, [
            (k(!0), A(Ie, null, Ze(D(f)($), (O, z) => (k(), A("div", { key: z }, [
              G("button", {
                type: "button",
                class: te(["dp--qr-btn", {
                  "dp--qr-btn-active": O.active,
                  "dp--qr-btn-between": O.isBetween,
                  "dp--qr-btn-disabled": O.disabled,
                  "dp--highlighted": O.highlighted
                }]),
                "data-test": O.value,
                disabled: O.disabled,
                onClick: (P) => D(g)(O.value, $, O.disabled),
                onMouseover: (P) => D(m)(O.value)
              }, [
                y.$slots.quarter ? se(y.$slots, "quarter", {
                  key: 0,
                  value: O.value,
                  text: O.text
                }) : (k(), A(Ie, { key: 1 }, [
                  it(Te(O.text), 1)
                ], 64))
              ], 42, H7)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), W7 = ["id", "aria-label"], U7 = {
  key: 0,
  class: "dp--menu-load-container"
}, q7 = /* @__PURE__ */ G("span", { class: "dp--menu-loader" }, null, -1), Y7 = [
  q7
], K7 = {
  key: 0,
  class: "dp__sidebar_left"
}, G7 = ["data-test", "onClick", "onKeydown"], J7 = {
  key: 2,
  class: "dp__sidebar_right"
}, X7 = {
  key: 3,
  class: "dp__action_extra"
}, Fp = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...md,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, o = q(null), a = E(() => {
      const { openOnTop: re, ...le } = i;
      return {
        ...le,
        flowStep: z.value,
        collapse: i.collapse,
        noOverlayFocus: i.noOverlayFocus,
        menuWrapRef: o.value
      };
    }), { setMenuFocused: s, setShiftKey: l, control: d } = U2(), u = ci(), { defaultedTextInput: c, defaultedInline: f, defaultedConfig: h } = Et(i), p = q(null), m = q(0), g = q(null), v = q(!1), b = q(null);
    ot(() => {
      if (!i.shadow) {
        v.value = !0, x(), window.addEventListener("resize", x);
        const re = Gt(o);
        if (re && !c.value.enabled && !f.value.enabled && (s(!0), _()), re) {
          const le = (Ke) => {
            h.value.allowPreventDefault && Ke.preventDefault(), Ei(Ke, h.value, !0);
          };
          re.addEventListener("pointerdown", le), re.addEventListener("mousedown", le);
        }
      }
    }), hr(() => {
      window.removeEventListener("resize", x);
    });
    const x = () => {
      const re = Gt(g);
      re && (m.value = re.getBoundingClientRect().width);
    }, { arrowRight: y, arrowLeft: C, arrowDown: $, arrowUp: O } = Li(), { flowStep: z, updateFlowStep: P, childMount: U, resetFlow: ie } = B8(i, r, b), W = E(() => i.monthPicker ? t7 : i.yearPicker ? r7 : i.timePicker ? $7 : i.quarterPicker ? j7 : B7), H = E(() => {
      var We;
      var re;
      if (h.value.arrowLeft)
        return h.value.arrowLeft;
      const le = (re = o.value) == null ? void 0 : re.getBoundingClientRect(), Ke = i.getInputRect();
      return Ke.width < m.value && Ke.left <= ((We = le == null ? void 0 : le.left) != null ? We : 0) ? `${Ke.width / 2}px` : "50%";
    }), _ = () => {
      const re = Gt(o);
      re && re.focus({ preventScroll: !0 });
    }, T = E(() => {
      var re;
      return ((re = b.value) == null ? void 0 : re.getSidebarProps()) || {};
    }), M = () => {
      i.openOnTop && r("recalculate-position");
    }, V = Ln(u, "action"), Q = E(() => i.monthPicker || i.yearPicker ? Ln(u, "monthYear") : i.timePicker ? Ln(u, "timePicker") : Ln(u, "shared")), ue = E(() => i.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), oe = E(() => ({
      dp__menu_disabled: i.disabled,
      dp__menu_readonly: i.readonly,
      "dp-menu-loading": i.loading
    })), Y = E(
      () => ({
        dp__menu: !0,
        dp__menu_index: !f.value.enabled,
        dp__relative: f.value.enabled,
        [i.menuClassName]: !!i.menuClassName
      })
    ), ce = (re) => {
      Ei(re, h.value, !0);
    }, S = () => {
      i.escClose && r("close-picker");
    }, j = (re) => {
      if (i.arrowNavigation) {
        if (re === "up")
          return O();
        if (re === "down")
          return $();
        if (re === "left")
          return C();
        if (re === "right")
          return y();
      } else
        re === "left" || re === "up" ? qe("handleArrow", "left", 0, re === "up") : qe("handleArrow", "right", 0, re === "down");
    }, Z = (re) => {
      l(re.shiftKey), !i.disableMonthYearSelect && re.code === "Tab" && re.target.classList.contains("dp__menu") && d.value.shiftKeyInMenu && (re.preventDefault(), Ei(re, h.value, !0), r("close-picker"));
    }, ee = () => {
      _(), r("time-picker-close");
    }, N = (re) => {
      var le, Ke, We;
      (le = b.value) == null || le.toggleTimePicker(!1, !1), (Ke = b.value) == null || Ke.toggleMonthPicker(!1, !1, re), (We = b.value) == null || We.toggleYearPicker(!1, !1, re);
    }, Ce = (re, le = 0) => {
      var Ke, We, Tt;
      return re === "month" ? (Ke = b.value) == null ? void 0 : Ke.toggleMonthPicker(!1, !0, le) : re === "year" ? (We = b.value) == null ? void 0 : We.toggleYearPicker(!1, !0, le) : re === "time" ? (Tt = b.value) == null ? void 0 : Tt.toggleTimePicker(!0, !1) : N(le);
    }, qe = (re, ...le) => {
      var Ke, We;
      (Ke = b.value) != null && Ke[re] && ((We = b.value) == null || We[re](...le));
    }, I = () => {
      qe("selectCurrentDate");
    }, Me = (re, le) => {
      qe("presetDate", re, le);
    }, Ye = () => {
      qe("clearHoverDate");
    }, ke = (re, le) => {
      qe("updateMonthYear", re, le);
    }, je = (re) => {
      if (Z(re), re.key === "Home" || re.key === "End")
        return qe("selectWeekDate", re.key === "Home");
      if (re.key === "PageUp" || re.key === "PageDown")
        return re.shiftKey ? qe("changeYear", re.key === "PageUp") : qe("changeMonth", re.key === "PageUp");
    };
    return t({
      updateMonthYear: ke,
      switchView: Ce
    }), (re, le) => {
      var Ke, We, Tt;
      return k(), A("div", {
        id: re.uid ? `dp-menu-${re.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: o,
        tabindex: "0",
        role: "dialog",
        "aria-label": (Ke = re.ariaLabels) == null ? void 0 : Ke.menu,
        class: te(Y.value),
        style: mt({ "--dp-arrow-left": H.value }),
        onMouseleave: Ye,
        onClick: ce,
        onKeydown: [
          Re(S, ["esc"]),
          le[18] || (le[18] = Re(Ge((Oe) => j("left"), ["prevent"]), ["left"])),
          le[19] || (le[19] = Re(Ge((Oe) => j("up"), ["prevent"]), ["up"])),
          le[20] || (le[20] = Re(Ge((Oe) => j("down"), ["prevent"]), ["down"])),
          le[21] || (le[21] = Re(Ge((Oe) => j("right"), ["prevent"]), ["right"])),
          je
        ]
      }, [
        (re.disabled || re.readonly) && D(f).enabled || re.loading ? (k(), A("div", {
          key: 0,
          class: te(oe.value)
        }, [
          re.loading ? (k(), A("div", U7, Y7)) : K("", !0)
        ], 2)) : K("", !0),
        !D(f).enabled && !re.teleportCenter ? (k(), A("div", {
          key: 1,
          class: te(ue.value)
        }, null, 2)) : K("", !0),
        G("div", {
          ref_key: "innerMenuRef",
          ref: g,
          class: te({
            dp__menu_content_wrapper: ((We = re.presetDates) == null ? void 0 : We.length) || !!re.$slots["left-sidebar"] || !!re.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((Tt = re.presetDates) == null ? void 0 : Tt.length) || !!re.$slots["left-sidebar"] || !!re.$slots["right-sidebar"])
          }),
          style: mt({ "--dp-menu-width": `${m.value}px` })
        }, [
          re.$slots["left-sidebar"] ? (k(), A("div", K7, [
            se(re.$slots, "left-sidebar", tn(Sn(T.value)))
          ])) : K("", !0),
          re.presetDates.length ? (k(), A("div", {
            key: 1,
            class: te({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 })
          }, [
            (k(!0), A(Ie, null, Ze(re.presetDates, (Oe, xt) => {
              var lt;
              return k(), A(Ie, { key: xt }, [
                Oe.slot ? se(re.$slots, Oe.slot, {
                  key: 0,
                  presetDate: Me,
                  label: Oe.label,
                  value: Oe.value
                }) : (k(), A("button", {
                  key: 1,
                  type: "button",
                  style: mt(Oe.style || {}),
                  class: te(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                  "data-test": (lt = Oe.testId) != null ? lt : void 0,
                  onClick: Ge((Yt) => Me(Oe.value, Oe.noTz), ["prevent"]),
                  onKeydown: [
                    Re(Ge((Yt) => Me(Oe.value, Oe.noTz), ["prevent"]), ["enter"]),
                    Re(Ge((Yt) => Me(Oe.value, Oe.noTz), ["prevent"]), ["space"])
                  ]
                }, Te(Oe.label), 47, G7))
              ], 64);
            }), 128))
          ], 2)) : K("", !0),
          G("div", {
            ref_key: "calendarWrapperRef",
            ref: p,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (k(), ge(Qn(W.value), $t({
              ref_key: "dynCmpRef",
              ref: b
            }, a.value, {
              "flow-step": D(z),
              onMount: D(U),
              onUpdateFlowStep: D(P),
              onResetFlow: D(ie),
              onFocusMenu: _,
              onSelectDate: le[0] || (le[0] = (Oe) => re.$emit("select-date")),
              onDateUpdate: le[1] || (le[1] = (Oe) => re.$emit("date-update", Oe)),
              onTooltipOpen: le[2] || (le[2] = (Oe) => re.$emit("tooltip-open", Oe)),
              onTooltipClose: le[3] || (le[3] = (Oe) => re.$emit("tooltip-close", Oe)),
              onAutoApply: le[4] || (le[4] = (Oe) => re.$emit("auto-apply", Oe)),
              onRangeStart: le[5] || (le[5] = (Oe) => re.$emit("range-start", Oe)),
              onRangeEnd: le[6] || (le[6] = (Oe) => re.$emit("range-end", Oe)),
              onInvalidFixedRange: le[7] || (le[7] = (Oe) => re.$emit("invalid-fixed-range", Oe)),
              onTimeUpdate: le[8] || (le[8] = (Oe) => re.$emit("time-update")),
              onAmPmChange: le[9] || (le[9] = (Oe) => re.$emit("am-pm-change", Oe)),
              onTimePickerOpen: le[10] || (le[10] = (Oe) => re.$emit("time-picker-open", Oe)),
              onTimePickerClose: ee,
              onRecalculatePosition: M,
              onUpdateMonthYear: le[11] || (le[11] = (Oe) => re.$emit("update-month-year", Oe)),
              onAutoApplyInvalid: le[12] || (le[12] = (Oe) => re.$emit("auto-apply-invalid", Oe)),
              onInvalidDate: le[13] || (le[13] = (Oe) => re.$emit("invalid-date", Oe)),
              "onUpdate:internalModelValue": le[14] || (le[14] = (Oe) => re.$emit("update:internal-model-value", Oe))
            }), qt({ _: 2 }, [
              Ze(Q.value, (Oe, xt) => ({
                name: Oe,
                fn: de((lt) => [
                  se(re.$slots, Oe, tn(Sn({ ...lt })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          re.$slots["right-sidebar"] ? (k(), A("div", J7, [
            se(re.$slots, "right-sidebar", tn(Sn(T.value)))
          ])) : K("", !0),
          re.$slots["action-extra"] ? (k(), A("div", X7, [
            re.$slots["action-extra"] ? se(re.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: I
            }) : K("", !0)
          ])) : K("", !0)
        ], 6),
        !re.autoApply || D(h).keepActionRow ? (k(), ge(q8, $t({
          key: 2,
          "menu-mount": v.value
        }, a.value, {
          "calendar-width": m.value,
          onClosePicker: le[15] || (le[15] = (Oe) => re.$emit("close-picker")),
          onSelectDate: le[16] || (le[16] = (Oe) => re.$emit("select-date")),
          onInvalidSelect: le[17] || (le[17] = (Oe) => re.$emit("invalid-select")),
          onSelectNow: I
        }), qt({ _: 2 }, [
          Ze(D(V), (Oe, xt) => ({
            name: Oe,
            fn: de((lt) => [
              se(re.$slots, Oe, tn(Sn({ ...lt })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : K("", !0)
      ], 46, W7);
    };
  }
}), Q7 = typeof window < "u" ? window : void 0, cu = () => {
}, Z7 = (e) => Lm() ? (Fm(e), !0) : !1, e$ = (e, t, n, r) => {
  if (!e)
    return cu;
  let i = cu;
  const o = Fe(
    () => D(e),
    (s) => {
      i(), s && (s.addEventListener(t, n, r), i = () => {
        s.removeEventListener(t, n, r), i = cu;
      });
    },
    { immediate: !0, flush: "post" }
  ), a = () => {
    o(), i();
  };
  return Z7(a), a;
}, t$ = (e, t, n, r = {}) => {
  const { window: i = Q7, event: o = "pointerdown" } = r;
  return i ? e$(i, o, (a) => {
    const s = Gt(e), l = Gt(t);
    !s || !l || s === a.target || a.composedPath().includes(s) || a.composedPath().includes(l) || n(a);
  }, { passive: !0 }) : void 0;
}, n$ = /* @__PURE__ */ $e({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...md
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = n, i = e, o = ci(), a = q(!1), s = Ua(i, "modelValue"), l = Ua(i, "timezone"), d = q(null), u = q(null), c = q(null), f = q(!1), h = q(null), p = q(!1), m = q(!1), g = q(!1), { setMenuFocused: v, setShiftKey: b } = U2(), { clearArrowNav: x } = Li(), { validateDate: y, isValidTime: C } = Fi(i), {
      defaultedTransitions: $,
      defaultedTextInput: O,
      defaultedInline: z,
      defaultedConfig: P,
      defaultedRange: U,
      defaultedMultiDates: ie
    } = Et(i), { menuTransition: W, showTransition: H } = hs($);
    ot(() => {
      j(i.modelValue), an().then(() => {
        if (!z.value.enabled) {
          const F = oe(h.value);
          F == null || F.addEventListener("scroll", je), window == null || window.addEventListener("resize", re);
        }
      }), z.value.enabled && (a.value = !0), window == null || window.addEventListener("keyup", le), window == null || window.addEventListener("keydown", Ke);
    }), hr(() => {
      if (!z.value.enabled) {
        const F = oe(h.value);
        F == null || F.removeEventListener("scroll", je), window == null || window.removeEventListener("resize", re);
      }
      window == null || window.removeEventListener("keyup", le), window == null || window.removeEventListener("keydown", Ke);
    });
    const _ = Ln(o, "all", i.presetDates), T = Ln(o, "input");
    Fe(
      [s, l],
      () => {
        j(s.value);
      },
      { deep: !0 }
    );
    const { openOnTop: M, menuStyle: V, xCorrect: Q, setMenuPosition: ue, getScrollableParent: oe, shadowRender: Y } = R8({
      menuRef: d,
      menuRefInner: u,
      inputRef: c,
      pickerWrapperRef: h,
      inline: z,
      emit: r,
      props: i,
      slots: o
    }), {
      inputValue: ce,
      internalModelValue: S,
      parseExternalModelValue: j,
      emitModelValue: Z,
      formatInputValue: ee,
      checkBeforeEmit: N
    } = N8(r, i, f), Ce = E(
      () => ({
        dp__main: !0,
        dp__theme_dark: i.dark,
        dp__theme_light: !i.dark,
        dp__flex_display: z.value.enabled,
        "dp--flex-display-collapsed": g.value,
        dp__flex_display_with_input: z.value.input
      })
    ), qe = E(() => i.dark ? "dp__theme_dark" : "dp__theme_light"), I = E(() => i.teleport ? {
      to: typeof i.teleport == "boolean" ? "body" : i.teleport,
      disabled: !i.teleport || z.value.enabled
    } : {}), Me = E(() => ({ class: "dp__outer_menu_wrap" })), Ye = E(() => z.value.enabled && (i.timePicker || i.monthPicker || i.yearPicker || i.quarterPicker)), ke = () => {
      var F, ae;
      return (ae = (F = c.value) == null ? void 0 : F.$el) == null ? void 0 : ae.getBoundingClientRect();
    }, je = () => {
      a.value && (P.value.closeOnScroll ? Ht() : ue());
    }, re = () => {
      var F;
      a.value && ue();
      const ae = (F = u.value) == null ? void 0 : F.$el.getBoundingClientRect().width;
      g.value = document.body.offsetWidth <= ae;
    }, le = (F) => {
      F.key === "Tab" && !z.value.enabled && !i.teleport && P.value.tabOutClosesMenu && (h.value.contains(document.activeElement) || Ht()), m.value = F.shiftKey;
    }, Ke = (F) => {
      m.value = F.shiftKey;
    }, We = () => {
      !i.disabled && !i.readonly && (Y(Fp, i), ue(!1), a.value = !0, a.value && r("open"), a.value || Pn(), j(i.modelValue));
    }, Tt = () => {
      var F;
      ce.value = "", Pn(), (F = c.value) == null || F.setParsedDate(null), r("update:model-value", null), r("update:model-timezone-value", null), r("cleared"), P.value.closeOnClearValue && Ht();
    }, Oe = () => {
      const F = S.value;
      return !F || !Array.isArray(F) && y(F) ? !0 : Array.isArray(F) ? ie.value.enabled || F.length === 2 && y(F[0]) && y(F[1]) ? !0 : U.value.partialRange && !i.timePicker ? y(F[0]) : !1 : !1;
    }, xt = () => {
      N() && Oe() ? (Z(), Ht()) : r("invalid-select", S.value);
    }, lt = (F) => {
      Yt(), Z(), P.value.closeOnAutoApply && !F && Ht();
    }, Yt = () => {
      c.value && O.value.enabled && c.value.setParsedDate(S.value);
    }, er = (F = !1) => {
      i.autoApply && C(S.value) && Oe() && (U.value.enabled && Array.isArray(S.value) ? (U.value.partialRange || S.value.length === 2) && lt(F) : lt(F));
    }, Pn = () => {
      O.value.enabled || (S.value = null);
    }, Ht = () => {
      z.value.enabled || (a.value && (a.value = !1, Q.value = !1, v(!1), b(!1), x(), r("closed"), ce.value && j(s.value)), Pn(), r("blur"));
    }, Nn = (F, ae, pe = !1) => {
      if (!F) {
        S.value = null;
        return;
      }
      const we = Array.isArray(F) ? !F.some((ut) => !y(ut)) : y(F), dt = C(F);
      we && dt && (S.value = F, ae && (p.value = pe, xt(), r("text-submit")));
    }, yr = () => {
      i.autoApply && C(S.value) && Z(), Yt();
    }, B = () => a.value ? Ht() : We(), w = (F) => {
      S.value = F;
    }, ye = () => {
      O.value.enabled && (f.value = !0, ee()), r("focus");
    }, Pe = () => {
      if (O.value.enabled && (f.value = !1, j(i.modelValue), p.value)) {
        const F = a8(h.value, m.value);
        F == null || F.focus();
      }
      r("blur");
    }, Se = (F) => {
      u.value && u.value.updateMonthYear(0, {
        month: Ap(F.month),
        year: Ap(F.year)
      });
    }, J = (F) => {
      j(F != null ? F : i.modelValue);
    }, be = (F, ae) => {
      var pe;
      (pe = u.value) == null || pe.switchView(F, ae);
    }, R = (F) => P.value.onClickOutside ? P.value.onClickOutside(F) : Ht();
    return t$(d, c, () => R(Oe)), t({
      closeMenu: Ht,
      selectDate: xt,
      clearValue: Tt,
      openMenu: We,
      onScroll: je,
      formatInputValue: ee,
      // exposed for testing purposes
      updateInternalModelValue: w,
      // modify internal modelValue
      setMonthYear: Se,
      parseModel: J,
      switchView: be,
      toggleMenu: B
    }), (F, ae) => (k(), A("div", {
      ref_key: "pickerWrapperRef",
      ref: h,
      class: te(Ce.value),
      "data-datepicker-instance": ""
    }, [
      fe(j8, $t({
        ref_key: "inputRef",
        ref: c,
        "input-value": D(ce),
        "onUpdate:inputValue": ae[0] || (ae[0] = (pe) => nc(ce) ? ce.value = pe : null),
        "is-menu-open": a.value
      }, F.$props, {
        onClear: Tt,
        onOpen: We,
        onSetInputDate: Nn,
        onSetEmptyDate: D(Z),
        onSelectDate: xt,
        onToggle: B,
        onClose: Ht,
        onFocus: ye,
        onBlur: Pe,
        onRealBlur: ae[1] || (ae[1] = (pe) => f.value = !1)
      }), qt({ _: 2 }, [
        Ze(D(T), (pe, we) => ({
          name: pe,
          fn: de((dt) => [
            se(F.$slots, pe, tn(Sn(dt)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (k(), ge(Qn(F.teleport ? ca : "div"), tn(Sn(I.value)), {
        default: de(() => [
          fe(ur, {
            name: D(W)(D(M)),
            css: D(H) && !D(z).enabled
          }, {
            default: de(() => [
              a.value ? (k(), A("div", $t({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: d
              }, Me.value, {
                class: { "dp--menu-wrapper": !D(z).enabled },
                style: D(z).enabled ? void 0 : D(V)
              }), [
                fe(Fp, $t({
                  ref_key: "dpMenuRef",
                  ref: u
                }, F.$props, {
                  "internal-model-value": D(S),
                  "onUpdate:internalModelValue": ae[2] || (ae[2] = (pe) => nc(S) ? S.value = pe : null),
                  class: { [qe.value]: !0, "dp--menu-wrapper": F.teleport },
                  "open-on-top": D(M),
                  "no-overlay-focus": Ye.value,
                  collapse: g.value,
                  "get-input-rect": ke,
                  onClosePicker: Ht,
                  onSelectDate: xt,
                  onAutoApply: er,
                  onTimeUpdate: yr,
                  onFlowStep: ae[3] || (ae[3] = (pe) => F.$emit("flow-step", pe)),
                  onUpdateMonthYear: ae[4] || (ae[4] = (pe) => F.$emit("update-month-year", pe)),
                  onInvalidSelect: ae[5] || (ae[5] = (pe) => F.$emit("invalid-select", D(S))),
                  onAutoApplyInvalid: ae[6] || (ae[6] = (pe) => F.$emit("invalid-select", pe)),
                  onInvalidFixedRange: ae[7] || (ae[7] = (pe) => F.$emit("invalid-fixed-range", pe)),
                  onRecalculatePosition: D(ue),
                  onTooltipOpen: ae[8] || (ae[8] = (pe) => F.$emit("tooltip-open", pe)),
                  onTooltipClose: ae[9] || (ae[9] = (pe) => F.$emit("tooltip-close", pe)),
                  onTimePickerOpen: ae[10] || (ae[10] = (pe) => F.$emit("time-picker-open", pe)),
                  onTimePickerClose: ae[11] || (ae[11] = (pe) => F.$emit("time-picker-close", pe)),
                  onAmPmChange: ae[12] || (ae[12] = (pe) => F.$emit("am-pm-change", pe)),
                  onRangeStart: ae[13] || (ae[13] = (pe) => F.$emit("range-start", pe)),
                  onRangeEnd: ae[14] || (ae[14] = (pe) => F.$emit("range-end", pe)),
                  onDateUpdate: ae[15] || (ae[15] = (pe) => F.$emit("date-update", pe)),
                  onInvalidDate: ae[16] || (ae[16] = (pe) => F.$emit("invalid-date", pe))
                }), qt({ _: 2 }, [
                  Ze(D(_), (pe, we) => ({
                    name: pe,
                    fn: de((dt) => [
                      se(F.$slots, pe, tn(Sn({ ...dt })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "onRecalculatePosition"])
              ], 16)) : K("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), V0 = /* @__PURE__ */ (() => {
  const e = n$;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), r$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V0
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(r$).forEach(([e, t]) => {
  e !== "default" && (V0[e] = t);
});
function i$(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function o$(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument required, but only " + t.length + " present");
}
var Q2 = 6e4, Z2 = 36e5;
function fu(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
function $a(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : o;
      i = e.formattingValues[a] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[l] || e.values[s];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[d];
  };
}
function wa(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    var a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? s$(s, function(c) {
      return c.test(a);
    }) : a$(s, function(c) {
      return c.test(a);
    }), d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = n.valueCallback ? n.valueCallback(d) : d;
    var u = t.slice(a.length);
    return {
      value: d,
      rest: u
    };
  };
}
function a$(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function s$(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function l$(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r) return null;
    var i = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    var a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = t.slice(i.length);
    return {
      value: a,
      rest: s
    };
  };
}
function d$(e, t) {
  var n;
  o$(1, arguments);
  var r = i$((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var i = p$(e), o;
  if (i.date) {
    var a = h$(i.date, r);
    o = m$(a.restDateString, a.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = o.getTime(), l = 0, d;
  if (i.time && (l = g$(i.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (i.timezone) {
    if (d = v$(i.timezone), isNaN(d))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(s + l), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), c.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), c;
  }
  return new Date(s + l + d);
}
var Ps = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, u$ = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, c$ = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, f$ = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function p$(e) {
  var t = {}, n = e.split(Ps.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Ps.timeZoneDelimiter.test(t.date) && (t.date = e.split(Ps.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var i = Ps.timezone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timezone = i[1]) : t.time = r;
  }
  return t;
}
function h$(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r) return {
    year: NaN,
    restDateString: ""
  };
  var i = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? i : o * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function m$(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  var n = e.match(u$);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], i = ka(n[1]), o = ka(n[2]) - 1, a = ka(n[3]), s = ka(n[4]), l = ka(n[5]) - 1;
  if (r)
    return k$(t, s, l) ? y$(t, s, l) : /* @__PURE__ */ new Date(NaN);
  var d = /* @__PURE__ */ new Date(0);
  return !$$(t, o, a) || !w$(t, i) ? /* @__PURE__ */ new Date(NaN) : (d.setUTCFullYear(t, o, Math.max(i, a)), d);
}
function ka(e) {
  return e ? parseInt(e) : 1;
}
function g$(e) {
  var t = e.match(c$);
  if (!t) return NaN;
  var n = pu(t[1]), r = pu(t[2]), i = pu(t[3]);
  return x$(n, r, i) ? n * Z2 + r * Q2 + i * 1e3 : NaN;
}
function pu(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function v$(e) {
  if (e === "Z") return 0;
  var t = e.match(f$);
  if (!t) return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return S$(r, i) ? n * (r * Z2 + i * Q2) : NaN;
}
function y$(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var i = r.getUTCDay() || 7, o = (t - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
var b$ = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function eg(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function $$(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (b$[t] || (eg(e) ? 29 : 28));
}
function w$(e, t) {
  return t >= 1 && t <= (eg(e) ? 366 : 365);
}
function k$(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function x$(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function S$(e, t) {
  return t >= 0 && t <= 59;
}
var Bp = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, C$ = function(t, n, r) {
  var i, o = r != null && r.addSuffix ? Bp[t].withPreposition : Bp[t].standalone;
  return typeof o == "string" ? i = o : n === 1 ? i = o.one : i = o.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : "vor " + i : i;
}, T$ = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, M$ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, O$ = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, E$ = {
  date: fu({
    formats: T$,
    defaultWidth: "full"
  }),
  time: fu({
    formats: M$,
    defaultWidth: "full"
  }),
  dateTime: fu({
    formats: O$,
    defaultWidth: "full"
  })
}, D$ = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, A$ = function(t, n, r, i) {
  return D$[t];
}, P$ = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, N$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, fc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, I$ = {
  narrow: fc.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: fc.wide
}, R$ = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, _$ = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, L$ = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, F$ = function(t) {
  var n = Number(t);
  return n + ".";
}, B$ = {
  ordinalNumber: F$,
  era: $a({
    values: P$,
    defaultWidth: "wide"
  }),
  quarter: $a({
    values: N$,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: $a({
    values: fc,
    formattingValues: I$,
    defaultWidth: "wide"
  }),
  day: $a({
    values: R$,
    defaultWidth: "wide"
  }),
  dayPeriod: $a({
    values: _$,
    defaultWidth: "wide",
    formattingValues: L$,
    defaultFormattingWidth: "wide"
  })
}, z$ = /^(\d+)(\.)?/i, V$ = /\d+/i, H$ = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, j$ = {
  any: [/^v/i, /^n/i]
}, W$ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, U$ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, q$ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, Y$ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, K$ = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, G$ = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, J$ = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, X$ = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, Q$ = {
  ordinalNumber: l$({
    matchPattern: z$,
    parsePattern: V$,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: wa({
    matchPatterns: H$,
    defaultMatchWidth: "wide",
    parsePatterns: j$,
    defaultParseWidth: "any"
  }),
  quarter: wa({
    matchPatterns: W$,
    defaultMatchWidth: "wide",
    parsePatterns: U$,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: wa({
    matchPatterns: q$,
    defaultMatchWidth: "wide",
    parsePatterns: Y$,
    defaultParseWidth: "any"
  }),
  day: wa({
    matchPatterns: K$,
    defaultMatchWidth: "wide",
    parsePatterns: G$,
    defaultParseWidth: "any"
  }),
  dayPeriod: wa({
    matchPatterns: J$,
    defaultMatchWidth: "wide",
    parsePatterns: X$,
    defaultParseWidth: "any"
  })
}, Z$ = {
  code: "de",
  formatDistance: C$,
  formatLong: E$,
  formatRelative: A$,
  localize: B$,
  match: Q$,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const ew = { class: "ds-datepicker" }, tw = ["type", "value", "disabled", "onInput", "onBlur", "onKeydown"], nw = /* @__PURE__ */ $e({
  __name: "DsDatepicker",
  props: {
    modelValue: {},
    datepickerConfig: { default: void 0 },
    style: { default: () => ({}) },
    id: { default: void 0 },
    typeable: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = ci(), o = q(null), a = q(!1);
    a0(() => {
      if (i.default) {
        const u = i.default();
        a.value = u.findIndex((c) => c.type !== i4) !== -1;
      }
    });
    const s = E({
      get: () => {
        var u, c;
        return (c = (u = n.modelValue) == null ? void 0 : u.toISOString()) != null ? c : "";
      },
      set: (u) => {
        r("update:modelValue", d$(u));
      }
    }), l = (u) => {
      const c = d2(u);
      return c !== null ? c : n.modelValue;
    }, d = E(() => ({
      ...n.style,
      hidden: a.value,
      "bg-gray-50": n.disabled
    }));
    return (u, c) => {
      var f, h, p, m, g, v, b, x, y, C, $, O, z;
      return k(), A("div", ew, [
        fe(D(V0), {
          id: u.id,
          ref_key: "datepicker",
          ref: o,
          "model-value": u.modelValue,
          "auto-apply": "",
          "hide-input-icon": "",
          format: (f = u.datepickerConfig) != null && f.enableTime ? "dd.MM.yyyy H:mm" : "dd.MM.yyyy",
          "format-locale": D(Z$),
          "text-input": u.typeable && !a.value ? {
            format: (P) => l(P)
          } : !1,
          "min-date": (h = u.datepickerConfig) == null ? void 0 : h.lowerLimit,
          "max-date": (p = u.datepickerConfig) == null ? void 0 : p.upperLimit,
          position: (g = (m = u.datepickerConfig) == null ? void 0 : m.position) != null ? g : "left",
          offset: (b = (v = u.datepickerConfig) == null ? void 0 : v.offset) != null ? b : 5,
          teleport: (y = (x = u.datepickerConfig) == null ? void 0 : x.teleport) != null ? y : !0,
          "prevent-min-max-navigation": ($ = (C = u.datepickerConfig) == null ? void 0 : C.preventMinMaxNav) != null ? $ : !1,
          disabled: u.disabled,
          clearable: !1,
          "enable-time-picker": (z = (O = u.datepickerConfig) == null ? void 0 : O.enableTime) != null ? z : !1,
          "onUpdate:modelValue": c[0] || (c[0] = (P) => r("update:modelValue", P || null))
        }, qt({ _: 2 }, [
          a.value ? {
            name: "trigger",
            fn: de(() => [
              se(u.$slots, "default", { disabled: u.disabled })
            ]),
            key: "0"
          } : {
            name: "dp-input",
            fn: de(({ value: P, onInput: U, onBlur: ie, onTab: W, onEnter: H }) => [
              G("input", {
                class: te(["block w-full min-w-0 border rounded sm:leading-5 focus:outline-none text-left font-sans", d.value]),
                type: u.typeable && !a.value ? "text" : "button",
                value: P,
                disabled: u.disabled,
                onInput: U,
                onBlur: ie,
                onKeydown: [
                  Re(W, ["tab"]),
                  Re(H, ["enter"])
                ]
              }, null, 42, tw)
            ]),
            key: "1"
          }
        ]), 1032, ["id", "model-value", "format", "format-locale", "text-input", "min-date", "max-date", "position", "offset", "teleport", "prevent-min-max-navigation", "disabled", "enable-time-picker"]),
        Jt(G("input", {
          "onUpdate:modelValue": c[1] || (c[1] = (P) => s.value = P),
          hidden: ""
        }, null, 512), [
          [
            s0,
            s.value,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]);
    };
  }
});
var tg = typeof global == "object" && global && global.Object === Object && global, rw = typeof self == "object" && self && self.Object === Object && self, Wr = tg || rw || Function("return this")(), zr = Wr.Symbol, ng = Object.prototype, iw = ng.hasOwnProperty, ow = ng.toString, xa = zr ? zr.toStringTag : void 0;
function aw(e) {
  var t = iw.call(e, xa), n = e[xa];
  try {
    e[xa] = void 0;
    var r = !0;
  } catch {
  }
  var i = ow.call(e);
  return r && (t ? e[xa] = n : delete e[xa]), i;
}
var sw = Object.prototype, lw = sw.toString;
function dw(e) {
  return lw.call(e);
}
var uw = "[object Null]", cw = "[object Undefined]", zp = zr ? zr.toStringTag : void 0;
function wo(e) {
  return e == null ? e === void 0 ? cw : uw : zp && zp in Object(e) ? aw(e) : dw(e);
}
function fo(e) {
  return e != null && typeof e == "object";
}
var fw = "[object Symbol]";
function ea(e) {
  return typeof e == "symbol" || fo(e) && wo(e) == fw;
}
function Ys(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var En = Array.isArray, pw = 1 / 0, Vp = zr ? zr.prototype : void 0, Hp = Vp ? Vp.toString : void 0;
function rg(e) {
  if (typeof e == "string")
    return e;
  if (En(e))
    return Ys(e, rg) + "";
  if (ea(e))
    return Hp ? Hp.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -pw ? "-0" : t;
}
var hw = /\s/;
function mw(e) {
  for (var t = e.length; t-- && hw.test(e.charAt(t)); )
    ;
  return t;
}
var gw = /^\s+/;
function vw(e) {
  return e && e.slice(0, mw(e) + 1).replace(gw, "");
}
function yn(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var jp = NaN, yw = /^[-+]0x[0-9a-f]+$/i, bw = /^0b[01]+$/i, $w = /^0o[0-7]+$/i, ww = parseInt;
function Wp(e) {
  if (typeof e == "number")
    return e;
  if (ea(e))
    return jp;
  if (yn(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = yn(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = vw(e);
  var n = bw.test(e);
  return n || $w.test(e) ? ww(e.slice(2), n ? 2 : 8) : yw.test(e) ? jp : +e;
}
function yd(e) {
  return e;
}
var kw = "[object AsyncFunction]", xw = "[object Function]", Sw = "[object GeneratorFunction]", Cw = "[object Proxy]";
function ig(e) {
  if (!yn(e))
    return !1;
  var t = wo(e);
  return t == xw || t == Sw || t == kw || t == Cw;
}
var hu = Wr["__core-js_shared__"], Up = function() {
  var e = /[^.]+$/.exec(hu && hu.keys && hu.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Tw(e) {
  return !!Up && Up in e;
}
var Mw = Function.prototype, Ow = Mw.toString;
function ko(e) {
  if (e != null) {
    try {
      return Ow.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Ew = /[\\^$.*+?()[\]{}|]/g, Dw = /^\[object .+?Constructor\]$/, Aw = Function.prototype, Pw = Object.prototype, Nw = Aw.toString, Iw = Pw.hasOwnProperty, Rw = RegExp(
  "^" + Nw.call(Iw).replace(Ew, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function _w(e) {
  if (!yn(e) || Tw(e))
    return !1;
  var t = ig(e) ? Rw : Dw;
  return t.test(ko(e));
}
function Lw(e, t) {
  return e == null ? void 0 : e[t];
}
function xo(e, t) {
  var n = Lw(e, t);
  return _w(n) ? n : void 0;
}
var pc = xo(Wr, "WeakMap");
function Fw(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Bw = 800, zw = 16, Vw = Date.now;
function Hw(e) {
  var t = 0, n = 0;
  return function() {
    var r = Vw(), i = zw - (r - n);
    if (n = r, i > 0) {
      if (++t >= Bw)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function jw(e) {
  return function() {
    return e;
  };
}
var dl = function() {
  try {
    var e = xo(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Ww = dl ? function(e, t) {
  return dl(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: jw(t),
    writable: !0
  });
} : yd, Uw = Hw(Ww);
function qw(e, t, n, r) {
  for (var i = e.length, o = n + -1; ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
var Yw = 9007199254740991, Kw = /^(?:0|[1-9]\d*)$/;
function H0(e, t) {
  var n = typeof e;
  return t = t == null ? Yw : t, !!t && (n == "number" || n != "symbol" && Kw.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Gw(e, t, n) {
  t == "__proto__" && dl ? dl(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function j0(e, t) {
  return e === t || e !== e && t !== t;
}
var qp = Math.max;
function Jw(e, t, n) {
  return t = qp(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = qp(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), Fw(e, this, s);
  };
}
function Xw(e, t) {
  return Uw(Jw(e, t, yd), e + "");
}
var Qw = 9007199254740991;
function W0(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Qw;
}
function vs(e) {
  return e != null && W0(e.length) && !ig(e);
}
function Yp(e, t, n) {
  if (!yn(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? vs(n) && H0(t, n.length) : r == "string" && t in n) ? j0(n[t], e) : !1;
}
var Zw = Object.prototype;
function og(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Zw;
  return e === n;
}
function ek(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var tk = "[object Arguments]";
function Kp(e) {
  return fo(e) && wo(e) == tk;
}
var ag = Object.prototype, nk = ag.hasOwnProperty, rk = ag.propertyIsEnumerable, bd = Kp(/* @__PURE__ */ function() {
  return arguments;
}()) ? Kp : function(e) {
  return fo(e) && nk.call(e, "callee") && !rk.call(e, "callee");
};
function ik() {
  return !1;
}
var sg = typeof exports == "object" && exports && !exports.nodeType && exports, Gp = sg && typeof module == "object" && module && !module.nodeType && module, ok = Gp && Gp.exports === sg, Jp = ok ? Wr.Buffer : void 0, ak = Jp ? Jp.isBuffer : void 0, ul = ak || ik, sk = "[object Arguments]", lk = "[object Array]", dk = "[object Boolean]", uk = "[object Date]", ck = "[object Error]", fk = "[object Function]", pk = "[object Map]", hk = "[object Number]", mk = "[object Object]", gk = "[object RegExp]", vk = "[object Set]", yk = "[object String]", bk = "[object WeakMap]", $k = "[object ArrayBuffer]", wk = "[object DataView]", kk = "[object Float32Array]", xk = "[object Float64Array]", Sk = "[object Int8Array]", Ck = "[object Int16Array]", Tk = "[object Int32Array]", Mk = "[object Uint8Array]", Ok = "[object Uint8ClampedArray]", Ek = "[object Uint16Array]", Dk = "[object Uint32Array]", kt = {};
kt[kk] = kt[xk] = kt[Sk] = kt[Ck] = kt[Tk] = kt[Mk] = kt[Ok] = kt[Ek] = kt[Dk] = !0;
kt[sk] = kt[lk] = kt[$k] = kt[dk] = kt[wk] = kt[uk] = kt[ck] = kt[fk] = kt[pk] = kt[hk] = kt[mk] = kt[gk] = kt[vk] = kt[yk] = kt[bk] = !1;
function Ak(e) {
  return fo(e) && W0(e.length) && !!kt[wo(e)];
}
function lg(e) {
  return function(t) {
    return e(t);
  };
}
var dg = typeof exports == "object" && exports && !exports.nodeType && exports, Ia = dg && typeof module == "object" && module && !module.nodeType && module, Pk = Ia && Ia.exports === dg, mu = Pk && tg.process, Xp = function() {
  try {
    var e = Ia && Ia.require && Ia.require("util").types;
    return e || mu && mu.binding && mu.binding("util");
  } catch {
  }
}(), Qp = Xp && Xp.isTypedArray, U0 = Qp ? lg(Qp) : Ak, Nk = Object.prototype, Ik = Nk.hasOwnProperty;
function Rk(e, t) {
  var n = En(e), r = !n && bd(e), i = !n && !r && ul(e), o = !n && !r && !i && U0(e), a = n || r || i || o, s = a ? ek(e.length, String) : [], l = s.length;
  for (var d in e)
    Ik.call(e, d) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    H0(d, l))) && s.push(d);
  return s;
}
function _k(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Lk = _k(Object.keys, Object), Fk = Object.prototype, Bk = Fk.hasOwnProperty;
function ug(e) {
  if (!og(e))
    return Lk(e);
  var t = [];
  for (var n in Object(e))
    Bk.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function q0(e) {
  return vs(e) ? Rk(e) : ug(e);
}
var zk = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Vk = /^\w*$/;
function Y0(e, t) {
  if (En(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || ea(e) ? !0 : Vk.test(e) || !zk.test(e) || t != null && e in Object(t);
}
var Ka = xo(Object, "create");
function Hk() {
  this.__data__ = Ka ? Ka(null) : {}, this.size = 0;
}
function jk(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Wk = "__lodash_hash_undefined__", Uk = Object.prototype, qk = Uk.hasOwnProperty;
function Yk(e) {
  var t = this.__data__;
  if (Ka) {
    var n = t[e];
    return n === Wk ? void 0 : n;
  }
  return qk.call(t, e) ? t[e] : void 0;
}
var Kk = Object.prototype, Gk = Kk.hasOwnProperty;
function Jk(e) {
  var t = this.__data__;
  return Ka ? t[e] !== void 0 : Gk.call(t, e);
}
var Xk = "__lodash_hash_undefined__";
function Qk(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Ka && t === void 0 ? Xk : t, this;
}
function po(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
po.prototype.clear = Hk;
po.prototype.delete = jk;
po.prototype.get = Yk;
po.prototype.has = Jk;
po.prototype.set = Qk;
function Zk() {
  this.__data__ = [], this.size = 0;
}
function $d(e, t) {
  for (var n = e.length; n--; )
    if (j0(e[n][0], t))
      return n;
  return -1;
}
var ex = Array.prototype, tx = ex.splice;
function nx(e) {
  var t = this.__data__, n = $d(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : tx.call(t, n, 1), --this.size, !0;
}
function rx(e) {
  var t = this.__data__, n = $d(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function ix(e) {
  return $d(this.__data__, e) > -1;
}
function ox(e, t) {
  var n = this.__data__, r = $d(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function pi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
pi.prototype.clear = Zk;
pi.prototype.delete = nx;
pi.prototype.get = rx;
pi.prototype.has = ix;
pi.prototype.set = ox;
var Ga = xo(Wr, "Map");
function ax() {
  this.size = 0, this.__data__ = {
    hash: new po(),
    map: new (Ga || pi)(),
    string: new po()
  };
}
function sx(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function wd(e, t) {
  var n = e.__data__;
  return sx(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function lx(e) {
  var t = wd(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function dx(e) {
  return wd(this, e).get(e);
}
function ux(e) {
  return wd(this, e).has(e);
}
function cx(e, t) {
  var n = wd(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function hi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
hi.prototype.clear = ax;
hi.prototype.delete = lx;
hi.prototype.get = dx;
hi.prototype.has = ux;
hi.prototype.set = cx;
var fx = "Expected a function";
function K0(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(fx);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (K0.Cache || hi)(), n;
}
K0.Cache = hi;
var px = 500;
function hx(e) {
  var t = K0(e, function(r) {
    return n.size === px && n.clear(), r;
  }), n = t.cache;
  return t;
}
var mx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, gx = /\\(\\)?/g, vx = hx(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(mx, function(n, r, i, o) {
    t.push(i ? o.replace(gx, "$1") : r || n);
  }), t;
});
function G0(e) {
  return e == null ? "" : rg(e);
}
function cg(e, t) {
  return En(e) ? e : Y0(e, t) ? [e] : vx(G0(e));
}
var yx = 1 / 0;
function kd(e) {
  if (typeof e == "string" || ea(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -yx ? "-0" : t;
}
function J0(e, t) {
  t = cg(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[kd(t[n++])];
  return n && n == r ? e : void 0;
}
function cl(e, t, n) {
  var r = e == null ? void 0 : J0(e, t);
  return r === void 0 ? n : r;
}
function fg(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var Zp = zr ? zr.isConcatSpreadable : void 0;
function bx(e) {
  return En(e) || bd(e) || !!(Zp && e && e[Zp]);
}
function $x(e, t, n, r, i) {
  var o = -1, a = e.length;
  for (n || (n = bx), i || (i = []); ++o < a; ) {
    var s = e[o];
    n(s) ? fg(i, s) : i[i.length] = s;
  }
  return i;
}
function wx() {
  this.__data__ = new pi(), this.size = 0;
}
function kx(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function xx(e) {
  return this.__data__.get(e);
}
function Sx(e) {
  return this.__data__.has(e);
}
var Cx = 200;
function Tx(e, t) {
  var n = this.__data__;
  if (n instanceof pi) {
    var r = n.__data__;
    if (!Ga || r.length < Cx - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new hi(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function ai(e) {
  var t = this.__data__ = new pi(e);
  this.size = t.size;
}
ai.prototype.clear = wx;
ai.prototype.delete = kx;
ai.prototype.get = xx;
ai.prototype.has = Sx;
ai.prototype.set = Tx;
function Mx(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
function Ox() {
  return [];
}
var Ex = Object.prototype, Dx = Ex.propertyIsEnumerable, eh = Object.getOwnPropertySymbols, Ax = eh ? function(e) {
  return e == null ? [] : (e = Object(e), Mx(eh(e), function(t) {
    return Dx.call(e, t);
  }));
} : Ox;
function Px(e, t, n) {
  var r = t(e);
  return En(e) ? r : fg(r, n(e));
}
function th(e) {
  return Px(e, q0, Ax);
}
var hc = xo(Wr, "DataView"), mc = xo(Wr, "Promise"), gc = xo(Wr, "Set"), nh = "[object Map]", Nx = "[object Object]", rh = "[object Promise]", ih = "[object Set]", oh = "[object WeakMap]", ah = "[object DataView]", Ix = ko(hc), Rx = ko(Ga), _x = ko(mc), Lx = ko(gc), Fx = ko(pc), Zr = wo;
(hc && Zr(new hc(new ArrayBuffer(1))) != ah || Ga && Zr(new Ga()) != nh || mc && Zr(mc.resolve()) != rh || gc && Zr(new gc()) != ih || pc && Zr(new pc()) != oh) && (Zr = function(e) {
  var t = wo(e), n = t == Nx ? e.constructor : void 0, r = n ? ko(n) : "";
  if (r)
    switch (r) {
      case Ix:
        return ah;
      case Rx:
        return nh;
      case _x:
        return rh;
      case Lx:
        return ih;
      case Fx:
        return oh;
    }
  return t;
});
var sh = Wr.Uint8Array, Bx = "__lodash_hash_undefined__";
function zx(e) {
  return this.__data__.set(e, Bx), this;
}
function Vx(e) {
  return this.__data__.has(e);
}
function fl(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new hi(); ++t < n; )
    this.add(e[t]);
}
fl.prototype.add = fl.prototype.push = zx;
fl.prototype.has = Vx;
function Hx(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function jx(e, t) {
  return e.has(t);
}
var Wx = 1, Ux = 2;
function pg(e, t, n, r, i, o) {
  var a = n & Wx, s = e.length, l = t.length;
  if (s != l && !(a && l > s))
    return !1;
  var d = o.get(e), u = o.get(t);
  if (d && u)
    return d == t && u == e;
  var c = -1, f = !0, h = n & Ux ? new fl() : void 0;
  for (o.set(e, t), o.set(t, e); ++c < s; ) {
    var p = e[c], m = t[c];
    if (r)
      var g = a ? r(m, p, c, t, e, o) : r(p, m, c, e, t, o);
    if (g !== void 0) {
      if (g)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!Hx(t, function(v, b) {
        if (!jx(h, b) && (p === v || i(p, v, n, r, o)))
          return h.push(b);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === m || i(p, m, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), f;
}
function qx(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function Yx(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Kx = 1, Gx = 2, Jx = "[object Boolean]", Xx = "[object Date]", Qx = "[object Error]", Zx = "[object Map]", eS = "[object Number]", tS = "[object RegExp]", nS = "[object Set]", rS = "[object String]", iS = "[object Symbol]", oS = "[object ArrayBuffer]", aS = "[object DataView]", lh = zr ? zr.prototype : void 0, gu = lh ? lh.valueOf : void 0;
function sS(e, t, n, r, i, o, a) {
  switch (n) {
    case aS:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case oS:
      return !(e.byteLength != t.byteLength || !o(new sh(e), new sh(t)));
    case Jx:
    case Xx:
    case eS:
      return j0(+e, +t);
    case Qx:
      return e.name == t.name && e.message == t.message;
    case tS:
    case rS:
      return e == t + "";
    case Zx:
      var s = qx;
    case nS:
      var l = r & Kx;
      if (s || (s = Yx), e.size != t.size && !l)
        return !1;
      var d = a.get(e);
      if (d)
        return d == t;
      r |= Gx, a.set(e, t);
      var u = pg(s(e), s(t), r, i, o, a);
      return a.delete(e), u;
    case iS:
      if (gu)
        return gu.call(e) == gu.call(t);
  }
  return !1;
}
var lS = 1, dS = Object.prototype, uS = dS.hasOwnProperty;
function cS(e, t, n, r, i, o) {
  var a = n & lS, s = th(e), l = s.length, d = th(t), u = d.length;
  if (l != u && !a)
    return !1;
  for (var c = l; c--; ) {
    var f = s[c];
    if (!(a ? f in t : uS.call(t, f)))
      return !1;
  }
  var h = o.get(e), p = o.get(t);
  if (h && p)
    return h == t && p == e;
  var m = !0;
  o.set(e, t), o.set(t, e);
  for (var g = a; ++c < l; ) {
    f = s[c];
    var v = e[f], b = t[f];
    if (r)
      var x = a ? r(b, v, f, t, e, o) : r(v, b, f, e, t, o);
    if (!(x === void 0 ? v === b || i(v, b, n, r, o) : x)) {
      m = !1;
      break;
    }
    g || (g = f == "constructor");
  }
  if (m && !g) {
    var y = e.constructor, C = t.constructor;
    y != C && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof C == "function" && C instanceof C) && (m = !1);
  }
  return o.delete(e), o.delete(t), m;
}
var fS = 1, dh = "[object Arguments]", uh = "[object Array]", Ns = "[object Object]", pS = Object.prototype, ch = pS.hasOwnProperty;
function hS(e, t, n, r, i, o) {
  var a = En(e), s = En(t), l = a ? uh : Zr(e), d = s ? uh : Zr(t);
  l = l == dh ? Ns : l, d = d == dh ? Ns : d;
  var u = l == Ns, c = d == Ns, f = l == d;
  if (f && ul(e)) {
    if (!ul(t))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return o || (o = new ai()), a || U0(e) ? pg(e, t, n, r, i, o) : sS(e, t, l, n, r, i, o);
  if (!(n & fS)) {
    var h = u && ch.call(e, "__wrapped__"), p = c && ch.call(t, "__wrapped__");
    if (h || p) {
      var m = h ? e.value() : e, g = p ? t.value() : t;
      return o || (o = new ai()), i(m, g, n, r, o);
    }
  }
  return f ? (o || (o = new ai()), cS(e, t, n, r, i, o)) : !1;
}
function X0(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !fo(e) && !fo(t) ? e !== e && t !== t : hS(e, t, n, r, X0, i);
}
var mS = 1, gS = 2;
function vS(e, t, n, r) {
  var i = n.length, o = i;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var a = n[i];
    if (a[2] ? a[1] !== e[a[0]] : !(a[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    a = n[i];
    var s = a[0], l = e[s], d = a[1];
    if (a[2]) {
      if (l === void 0 && !(s in e))
        return !1;
    } else {
      var u = new ai(), c;
      if (!(c === void 0 ? X0(d, l, mS | gS, r, u) : c))
        return !1;
    }
  }
  return !0;
}
function hg(e) {
  return e === e && !yn(e);
}
function yS(e) {
  for (var t = q0(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, hg(i)];
  }
  return t;
}
function mg(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function bS(e) {
  var t = yS(e);
  return t.length == 1 && t[0][2] ? mg(t[0][0], t[0][1]) : function(n) {
    return n === e || vS(n, e, t);
  };
}
function $S(e, t) {
  return e != null && t in Object(e);
}
function wS(e, t, n) {
  t = cg(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var a = kd(t[r]);
    if (!(o = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && W0(i) && H0(a, i) && (En(e) || bd(e)));
}
function kS(e, t) {
  return e != null && wS(e, t, $S);
}
var xS = 1, SS = 2;
function CS(e, t) {
  return Y0(e) && hg(t) ? mg(kd(e), t) : function(n) {
    var r = cl(n, e);
    return r === void 0 && r === t ? kS(n, e) : X0(t, r, xS | SS);
  };
}
function TS(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function MS(e) {
  return function(t) {
    return J0(t, e);
  };
}
function OS(e) {
  return Y0(e) ? TS(kd(e)) : MS(e);
}
function xd(e) {
  return typeof e == "function" ? e : e == null ? yd : typeof e == "object" ? En(e) ? CS(e[0], e[1]) : bS(e) : OS(e);
}
function ES(e, t, n, r) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; ) {
    var a = e[i];
    t(r, a, n(a), e);
  }
  return r;
}
function DS(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var l = a[++i];
      if (n(o[l], l, o) === !1)
        break;
    }
    return t;
  };
}
var AS = DS();
function PS(e, t) {
  return e && AS(e, t, q0);
}
function NS(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!vs(n))
      return e(n, r);
    for (var i = n.length, o = -1, a = Object(n); ++o < i && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var gg = NS(PS);
function IS(e, t, n, r) {
  return gg(e, function(i, o, a) {
    t(r, i, n(i), a);
  }), r;
}
function RS(e, t) {
  return function(n, r) {
    var i = En(n) ? ES : IS, o = t ? t() : {};
    return i(n, e, xd(r), o);
  };
}
var vu = function() {
  return Wr.Date.now();
}, _S = "Expected a function", LS = Math.max, FS = Math.min;
function Q0(e, t, n) {
  var r, i, o, a, s, l, d = 0, u = !1, c = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(_S);
  t = Wp(t) || 0, yn(n) && (u = !!n.leading, c = "maxWait" in n, o = c ? LS(Wp(n.maxWait) || 0, t) : o, f = "trailing" in n ? !!n.trailing : f);
  function h($) {
    var O = r, z = i;
    return r = i = void 0, d = $, a = e.apply(z, O), a;
  }
  function p($) {
    return d = $, s = setTimeout(v, t), u ? h($) : a;
  }
  function m($) {
    var O = $ - l, z = $ - d, P = t - O;
    return c ? FS(P, o - z) : P;
  }
  function g($) {
    var O = $ - l, z = $ - d;
    return l === void 0 || O >= t || O < 0 || c && z >= o;
  }
  function v() {
    var $ = vu();
    if (g($))
      return b($);
    s = setTimeout(v, m($));
  }
  function b($) {
    return s = void 0, f && r ? h($) : (r = i = void 0, a);
  }
  function x() {
    s !== void 0 && clearTimeout(s), d = 0, r = l = i = s = void 0;
  }
  function y() {
    return s === void 0 ? a : b(vu());
  }
  function C() {
    var $ = vu(), O = g($);
    if (r = arguments, i = this, l = $, O) {
      if (s === void 0)
        return p(l);
      if (c)
        return clearTimeout(s), s = setTimeout(v, t), h(l);
    }
    return s === void 0 && (s = setTimeout(v, t)), a;
  }
  return C.cancel = x, C.flush = y, C;
}
var vg = /[\\^$.*+?()[\]{}|]/g, BS = RegExp(vg.source);
function zS(e) {
  return e = G0(e), e && BS.test(e) ? e.replace(vg, "\\$&") : e;
}
function VS(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = 0;
  return qw(e, xd(t), i);
}
function HS(e, t) {
  var n = -1, r = vs(e) ? Array(e.length) : [];
  return gg(e, function(i, o, a) {
    r[++n] = t(i, o, a);
  }), r;
}
var jS = Object.prototype, WS = jS.hasOwnProperty, US = RS(function(e, t, n) {
  WS.call(e, n) ? e[n].push(t) : Gw(e, n, [t]);
}), qS = "[object String]";
function YS(e) {
  return typeof e == "string" || !En(e) && fo(e) && wo(e) == qS;
}
var KS = "[object Map]", GS = "[object Set]", JS = Object.prototype, XS = JS.hasOwnProperty;
function QS(e) {
  if (e == null)
    return !0;
  if (vs(e) && (En(e) || typeof e == "string" || typeof e.splice == "function" || ul(e) || U0(e) || bd(e)))
    return !e.length;
  var t = Zr(e);
  if (t == KS || t == GS)
    return !e.size;
  if (og(e))
    return !ug(e).length;
  for (var n in e)
    if (XS.call(e, n))
      return !1;
  return !0;
}
function ZS(e, t) {
  for (var n, r = -1, i = e.length; ++r < i; ) {
    var o = t(e[r]);
    o !== void 0 && (n = n === void 0 ? o : n + o);
  }
  return n;
}
function eC(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
function tC(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, i = e === e, o = ea(e), a = t !== void 0, s = t === null, l = t === t, d = ea(t);
    if (!s && !d && !o && e > t || o && a && l && !s && !d || r && a && l || !n && l || !i)
      return 1;
    if (!r && !o && !d && e < t || d && n && i && !r && !o || s && n && i || !a && i || !l)
      return -1;
  }
  return 0;
}
function nC(e, t, n) {
  for (var r = -1, i = e.criteria, o = t.criteria, a = i.length, s = n.length; ++r < a; ) {
    var l = tC(i[r], o[r]);
    if (l) {
      if (r >= s)
        return l;
      var d = n[r];
      return l * (d == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
function rC(e, t, n) {
  t.length ? t = Ys(t, function(o) {
    return En(o) ? function(a) {
      return J0(a, o.length === 1 ? o[0] : o);
    } : o;
  }) : t = [yd];
  var r = -1;
  t = Ys(t, lg(xd));
  var i = HS(e, function(o, a, s) {
    var l = Ys(t, function(d) {
      return d(o);
    });
    return { criteria: l, index: ++r, value: o };
  });
  return eC(i, function(o, a) {
    return nC(o, a, n);
  });
}
var iC = Xw(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && Yp(e, t[0], t[1]) ? t = [] : n > 2 && Yp(t[0], t[1], t[2]) && (t = [t[0]]), rC(e, $x(t), []);
});
function fh(e, t) {
  return e && e.length ? ZS(e, xd(t)) : 0;
}
var oC = "Expected a function";
function aC(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(oC);
  return yn(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Q0(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
var sC = 0;
function lC(e) {
  var t = ++sC;
  return G0(e) + t;
}
const ph = async () => {
}, hh = (e) => {
  const t = q(!1);
  return { isLoading: t, call: async () => {
    if (!t.value)
      try {
        t.value = !0, await e();
      } finally {
        t.value = !1;
      }
  } };
}, Z0 = $e({
  name: "DsVirtualList",
  props: {
    disabled: {
      type: Boolean
    },
    /**
     * The type of element of the outer container
     */
    outerContainerEl: {
      type: String,
      default: "div"
    },
    /**
     * The class of element of the outer container
     */
    outerContainerClass: {
      type: String,
      default: "vue-virtualized-list__scroll"
    },
    /**
     * The style of element of the outer container
     */
    outerContainerStyle: {
      type: Object,
      default: () => ({})
    },
    /**
     * The type of element of the inner container
     */
    innerContainerEl: {
      type: String,
      default: "div"
    },
    /**
     * The class of element of the inner container
     */
    innerContainerClass: {
      type: String,
      default: "vue-virtualized-list"
    },
    /**
     * The style of element of the inner container
     */
    innerContainerStyle: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      required: !0
    },
    itemHeight: {
      type: Number,
      required: !0
    },
    itemClass: {
      type: String,
      default: "vue-virtualized-list__row"
    },
    buffer: {
      type: Number,
      default: 5
    },
    /**
     * The number of miliseconds to wait between view updates
     * when scrolling fast through the list.
     */
    scrollThrottle: {
      type: Number,
      default: 25
    },
    /**
     * The offset for emitting the load events in pixels.
     */
    loadEventOffset: {
      type: Number,
      default: 300
    },
    loadPreviousHandler: {
      type: Function,
      default: ph
    },
    loadNextHandler: {
      type: Function,
      default: ph
    }
  },
  setup(e, t) {
    const n = q(), r = q(0), i = q(0), o = q(0), a = hh(e.loadPreviousHandler), s = hh(e.loadNextHandler), l = () => {
      n.value && (r.value = Math.floor(o.value / e.itemHeight), i.value = r.value + Math.ceil(
        n.value.clientHeight / e.itemHeight
      ));
    }, d = aC((h) => {
      if (!n.value || !h)
        return;
      const p = h.target;
      if (o.value = p.scrollTop, l(), p.scrollTop <= e.loadEventOffset) {
        a.call();
        return;
      }
      p.scrollTop + p.clientHeight >= p.scrollHeight - e.loadEventOffset && s.call();
    }, e.scrollThrottle);
    ot(() => {
      n.value !== void 0 && (r.value = 0, i.value = Math.floor(
        n.value.clientHeight / e.itemHeight
      ), n.value.addEventListener("scroll", d, !1));
    }), Fe(() => e.items.length, async () => {
      await an(), l();
    });
    const u = E(() => Math.max(0, r.value - e.buffer)), c = E(() => Math.min(e.items.length, i.value + e.buffer)), f = () => {
      const h = t.slots.default;
      return h === void 0 ? [] : e.disabled ? e.items.map((p, m) => h({ item: p, index: m })) : e.items.slice(u.value, c.value).map((p, m) => nn("div", {
        key: m + u.value,
        class: e.itemClass,
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          top: `${(u.value + m) * e.itemHeight}px`
        }
      }, h({ item: p, index: m })));
    };
    return Fe(() => e.itemHeight, async () => {
      await an(), d();
    }), () => nn(e.outerContainerEl, {
      ref: n,
      class: [e.outerContainerClass, "h-full", "overflow-auto", "block"],
      style: e.outerContainerStyle
    }, [
      t.slots.before !== void 0 && t.slots.before(),
      nn(e.innerContainerEl, {
        class: [e.innerContainerClass, "relative", "block"],
        style: {
          ...e.disabled ? {} : {
            height: `${e.items.length * e.itemHeight}px`
          },
          ...e.innerContainerStyle
        }
      }, f()),
      t.slots.after !== void 0 && t.slots.after()
    ]);
  }
}), dC = (e, t, n = []) => {
  const r = US(e, t), i = iC(Object.keys(r), (a) => {
    const s = n == null ? void 0 : n.indexOf(a);
    return s === -1 ? Number.MAX_VALUE : s;
  });
  let o = 0;
  return i.reduce((a, s) => {
    const l = r[s].map((d) => ({
      index: o++,
      data: d,
      isGroup: !1
    }));
    return a.push(
      {
        index: -1,
        data: s,
        isGroup: !0
      },
      ...l
    ), a;
  }, []);
}, uC = (e, t, n = []) => t ? dC(e, t, n) : e.map((r, i) => ({
  index: i,
  data: r,
  isGroup: !1
})), cC = $e({
  components: {
    DsVirtualList: Z0
  },
  props: {
    items: {
      type: Array,
      required: !0
    },
    groupKey: {
      type: String,
      default: ""
    },
    groupKeyOrder: {
      type: Array,
      default: () => []
    },
    groupWithDividers: {
      type: Boolean
    },
    width: {
      type: Number,
      required: !0
    },
    listClass: {
      type: String,
      default: ""
    },
    itemClass: {
      type: String,
      default: ""
    },
    /**
     * The number of pixels between the selected element
     * and the border while scrolling with keyboard.
     */
    scrollYMargin: {
      type: Number,
      default: 0
    },
    keepOpenOnSelect: {
      type: Boolean
    },
    preselectFirstValue: {
      type: Boolean
    },
    /**
     * Virtualize dropdown list. Does not work for grouped dropdowns at the moment.
     */
    virtualized: {
      type: Boolean
    },
    /**
     * Only needed if virtualized. Defines the height of each item.
     */
    itemHeight: {
      type: Number,
      default: 0
    },
    /**
     * Disable maximum height of dropdown item list (max-height: 16rem).
     */
    disableMaxHeight: {
      type: Boolean
    }
  },
  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    select: (e) => !0,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isOverflowing: (e) => !0
  },
  setup(e, t) {
    const n = E(() => uC(
      e.items,
      e.groupKey,
      e.groupKeyOrder
    )), r = q(), i = E(() => {
      if (r.value !== void 0)
        return r.value.$el;
    }), o = [];
    Bm(() => {
      o.length = 0;
    });
    const a = q(e.preselectFirstValue ? 0 : -1), s = E(() => {
      var f;
      const c = o[a.value];
      return e.virtualized ? (f = c == null ? void 0 : c.parentElement) != null ? f : void 0 : c;
    }), l = () => {
      const c = s.value;
      if (!c)
        return;
      const f = i.value.scrollTop + i.value.clientHeight, h = c.offsetTop + c.clientHeight;
      (h > f - e.scrollYMargin * 2 || h < i.value.scrollTop) && (i.value.scrollTop = h - i.value.clientHeight + e.scrollYMargin * 2);
    }, d = () => {
      const c = s.value;
      c && (i.value.scrollTop > c.offsetTop || i.value.scrollTop + i.value.clientHeight < c.offsetTop) && (i.value.scrollTop = c.offsetTop);
    }, u = () => {
      if (a.value < 0)
        return;
      const c = n.value.reduce((h, p) => ({
        ...h,
        [p.index]: p.data
      }), {}), f = e.items.findIndex(
        (h) => h === c[a.value]
      );
      t.emit("select", f), e.preselectFirstValue && !e.keepOpenOnSelect && (a.value = 0);
    };
    return Fe(() => n.value.length, () => {
      a.value = 0;
    }), $0(i, (c) => {
      const f = c[0], { clientHeight: h, scrollHeight: p } = f.target;
      t.emit("isOverflowing", p > h);
    }), {
      scrollContainerWrapper: r,
      entryRefs: o,
      selectedIndex: a,
      dropdownItems: n,
      emitSelectedIndex: u,
      selectNext: () => {
        a.value >= e.items.length - 1 || (a.value += 1, l());
      },
      selectPrevious: () => {
        a.value <= 0 || (a.value -= 1, d());
      },
      select: (c) => {
        a.value = c, d();
      },
      selectAndEmitIndex(c) {
        a.value = c, u();
      },
      setItemEntryRef(c, f) {
        o[f] = c;
      }
    };
  }
}), fC = {
  key: 0,
  class: "px-2 pt-1 mt-1 border-gray-300 border-t"
}, pC = ["textContent"], hC = ["onClick"], mC = ["textContent"];
function gC(e, t, n, r, i, o) {
  const a = Be("DsVirtualList");
  return k(), A("div", {
    class: "flex flex-col bg-white border border-gray-300 rounded shadow-lg overflow-hidden",
    style: mt({ width: `${e.width}px` }),
    onKeydown: [
      t[0] || (t[0] = Re(Ge((...s) => e.selectNext && e.selectNext(...s), ["prevent"]), ["down"])),
      t[1] || (t[1] = Re(Ge((...s) => e.selectPrevious && e.selectPrevious(...s), ["prevent"]), ["up"])),
      t[2] || (t[2] = Re(Ge((...s) => e.emitSelectedIndex && e.emitSelectedIndex(...s), ["prevent"]), ["enter"]))
    ]
  }, [
    se(e.$slots, "extra"),
    fe(a, {
      ref: "scrollContainerWrapper",
      disabled: !e.virtualized,
      style: mt(e.disableMaxHeight ? "" : "max-height: 16rem"),
      items: e.dropdownItems,
      "item-height": e.itemHeight,
      "inner-container-class": e.listClass
    }, qt({ _: 2 }, [
      e.dropdownItems.length === 0 ? {
        name: "after",
        fn: de(() => [
          se(e.$slots, "no-items")
        ]),
        key: "0"
      } : {
        name: "default",
        fn: de(({ item: s }) => [
          e.groupWithDividers && s.isGroup && s !== e.dropdownItems[0] ? (k(), A("div", fC)) : !e.groupWithDividers && s.isGroup ? (k(), A("div", {
            key: 1,
            class: te(["px-2 py-1 mt-1 text-xs text-gray-500", {
              capitalize: s.data.split(" ").length === 1
            }]),
            textContent: Te(s.data)
          }, null, 10, pC)) : s.isGroup ? K("", !0) : (k(), A("button", {
            key: 2,
            ref: (l) => e.setItemEntryRef(l, s.index),
            class: te([{
              "bg-gray-100": s.index === e.selectedIndex,
              [e.itemClass]: !0,
              "pl-4": e.groupKey !== "" && !e.groupWithDividers
            }, "w-full py-1 text-sm text-left focus:outline-none hover:bg-gray-100"]),
            tabindex: "-1",
            onClick: Ge((l) => e.selectAndEmitIndex(s.index), ["stop"])
          }, [
            se(e.$slots, "item", {
              item: s.data,
              index: s.index
            }, () => [
              G("div", {
                class: "px-2",
                textContent: Te(`${s.data}`)
              }, null, 8, mC)
            ])
          ], 10, hC))
        ]),
        key: "1"
      }
    ]), 1032, ["disabled", "style", "items", "item-height", "inner-container-class"])
  ], 36);
}
const vC = /* @__PURE__ */ Je(cC, [["render", gC]]);
var Tn = "top", Jn = "bottom", Xn = "right", Mn = "left", ef = "auto", ys = [Tn, Jn, Xn, Mn], ta = "start", Ja = "end", yC = "clippingParents", yg = "viewport", Sa = "popper", bC = "reference", mh = /* @__PURE__ */ ys.reduce(function(e, t) {
  return e.concat([t + "-" + ta, t + "-" + Ja]);
}, []), bg = /* @__PURE__ */ [].concat(ys, [ef]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ta, t + "-" + Ja]);
}, []), $C = "beforeRead", wC = "read", kC = "afterRead", xC = "beforeMain", SC = "main", CC = "afterMain", TC = "beforeWrite", MC = "write", OC = "afterWrite", EC = [$C, wC, kC, xC, SC, CC, TC, MC, OC];
function Vr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Bn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ho(e) {
  var t = Bn(e).Element;
  return e instanceof t || e instanceof Element;
}
function Yn(e) {
  var t = Bn(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function tf(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = Bn(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function DC(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, o = t.elements[n];
    !Yn(o) || !Vr(o) || (Object.assign(o.style, r), Object.keys(i).forEach(function(a) {
      var s = i[a];
      s === !1 ? o.removeAttribute(a) : o.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function AC(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], o = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = a.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !Yn(i) || !Vr(i) || (Object.assign(i.style, s), Object.keys(o).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const $g = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: DC,
  effect: AC,
  requires: ["computeStyles"]
};
function Br(e) {
  return e.split("-")[0];
}
var io = Math.max, pl = Math.min, na = Math.round;
function vc() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function wg() {
  return !/^((?!chrome|android).)*safari/i.test(vc());
}
function ra(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, o = 1;
  t && Yn(e) && (i = e.offsetWidth > 0 && na(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && na(r.height) / e.offsetHeight || 1);
  var a = ho(e) ? Bn(e) : window, s = a.visualViewport, l = !wg() && n, d = (r.left + (l && s ? s.offsetLeft : 0)) / i, u = (r.top + (l && s ? s.offsetTop : 0)) / o, c = r.width / i, f = r.height / o;
  return {
    width: c,
    height: f,
    top: u,
    right: d + c,
    bottom: u + f,
    left: d,
    x: d,
    y: u
  };
}
function nf(e) {
  var t = ra(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function kg(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && tf(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function di(e) {
  return Bn(e).getComputedStyle(e);
}
function PC(e) {
  return ["table", "td", "th"].indexOf(Vr(e)) >= 0;
}
function Bi(e) {
  return ((ho(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Sd(e) {
  return Vr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (tf(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Bi(e)
  );
}
function gh(e) {
  return !Yn(e) || // https://github.com/popperjs/popper-core/issues/837
  di(e).position === "fixed" ? null : e.offsetParent;
}
function NC(e) {
  var t = /firefox/i.test(vc()), n = /Trident/i.test(vc());
  if (n && Yn(e)) {
    var r = di(e);
    if (r.position === "fixed")
      return null;
  }
  var i = Sd(e);
  for (tf(i) && (i = i.host); Yn(i) && ["html", "body"].indexOf(Vr(i)) < 0; ) {
    var o = di(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function bs(e) {
  for (var t = Bn(e), n = gh(e); n && PC(n) && di(n).position === "static"; )
    n = gh(n);
  return n && (Vr(n) === "html" || Vr(n) === "body" && di(n).position === "static") ? t : n || NC(e) || t;
}
function rf(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ra(e, t, n) {
  return io(e, pl(t, n));
}
function IC(e, t, n) {
  var r = Ra(e, t, n);
  return r > n ? n : r;
}
function xg() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Sg(e) {
  return Object.assign({}, xg(), e);
}
function Cg(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var RC = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Sg(typeof t != "number" ? t : Cg(t, ys));
};
function _C(e) {
  var t, n = e.state, r = e.name, i = e.options, o = n.elements.arrow, a = n.modifiersData.popperOffsets, s = Br(n.placement), l = rf(s), d = [Mn, Xn].indexOf(s) >= 0, u = d ? "height" : "width";
  if (!(!o || !a)) {
    var c = RC(i.padding, n), f = nf(o), h = l === "y" ? Tn : Mn, p = l === "y" ? Jn : Xn, m = n.rects.reference[u] + n.rects.reference[l] - a[l] - n.rects.popper[u], g = a[l] - n.rects.reference[l], v = bs(o), b = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, x = m / 2 - g / 2, y = c[h], C = b - f[u] - c[p], $ = b / 2 - f[u] / 2 + x, O = Ra(y, $, C), z = l;
    n.modifiersData[r] = (t = {}, t[z] = O, t.centerOffset = O - $, t);
  }
}
function LC(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || kg(t.elements.popper, i) && (t.elements.arrow = i));
}
const FC = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: _C,
  effect: LC,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ia(e) {
  return e.split("-")[1];
}
var BC = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function zC(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: na(n * i) / i || 0,
    y: na(r * i) / i || 0
  };
}
function vh(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, o = e.variation, a = e.offsets, s = e.position, l = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, c = e.isFixed, f = a.x, h = f === void 0 ? 0 : f, p = a.y, m = p === void 0 ? 0 : p, g = typeof u == "function" ? u({
    x: h,
    y: m
  }) : {
    x: h,
    y: m
  };
  h = g.x, m = g.y;
  var v = a.hasOwnProperty("x"), b = a.hasOwnProperty("y"), x = Mn, y = Tn, C = window;
  if (d) {
    var $ = bs(n), O = "clientHeight", z = "clientWidth";
    if ($ === Bn(n) && ($ = Bi(n), di($).position !== "static" && s === "absolute" && (O = "scrollHeight", z = "scrollWidth")), $ = $, i === Tn || (i === Mn || i === Xn) && o === Ja) {
      y = Jn;
      var P = c && $ === C && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        $[O]
      );
      m -= P - r.height, m *= l ? 1 : -1;
    }
    if (i === Mn || (i === Tn || i === Jn) && o === Ja) {
      x = Xn;
      var U = c && $ === C && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        $[z]
      );
      h -= U - r.width, h *= l ? 1 : -1;
    }
  }
  var ie = Object.assign({
    position: s
  }, d && BC), W = u === !0 ? zC({
    x: h,
    y: m
  }, Bn(n)) : {
    x: h,
    y: m
  };
  if (h = W.x, m = W.y, l) {
    var H;
    return Object.assign({}, ie, (H = {}, H[y] = b ? "0" : "", H[x] = v ? "0" : "", H.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", H));
  }
  return Object.assign({}, ie, (t = {}, t[y] = b ? m + "px" : "", t[x] = v ? h + "px" : "", t.transform = "", t));
}
function VC(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, o = n.adaptive, a = o === void 0 ? !0 : o, s = n.roundOffsets, l = s === void 0 ? !0 : s, d = {
    placement: Br(t.placement),
    variation: ia(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, vh(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, vh(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const HC = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: VC,
  data: {}
};
var Is = {
  passive: !0
};
function jC(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, o = i === void 0 ? !0 : i, a = r.resize, s = a === void 0 ? !0 : a, l = Bn(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && d.forEach(function(u) {
    u.addEventListener("scroll", n.update, Is);
  }), s && l.addEventListener("resize", n.update, Is), function() {
    o && d.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Is);
    }), s && l.removeEventListener("resize", n.update, Is);
  };
}
const WC = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: jC,
  data: {}
};
var UC = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ks(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return UC[t];
  });
}
var qC = {
  start: "end",
  end: "start"
};
function yh(e) {
  return e.replace(/start|end/g, function(t) {
    return qC[t];
  });
}
function of(e) {
  var t = Bn(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function af(e) {
  return ra(Bi(e)).left + of(e).scrollLeft;
}
function YC(e, t) {
  var n = Bn(e), r = Bi(e), i = n.visualViewport, o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    var d = wg();
    (d || !d && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s + af(e),
    y: l
  };
}
function KC(e) {
  var t, n = Bi(e), r = of(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, o = io(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), a = io(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -r.scrollLeft + af(e), l = -r.scrollTop;
  return di(i || n).direction === "rtl" && (s += io(n.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function sf(e) {
  var t = di(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function Tg(e) {
  return ["html", "body", "#document"].indexOf(Vr(e)) >= 0 ? e.ownerDocument.body : Yn(e) && sf(e) ? e : Tg(Sd(e));
}
function _a(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Tg(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = Bn(r), a = i ? [o].concat(o.visualViewport || [], sf(r) ? r : []) : r, s = t.concat(a);
  return i ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(_a(Sd(a)))
  );
}
function yc(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function GC(e, t) {
  var n = ra(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function bh(e, t, n) {
  return t === yg ? yc(YC(e, n)) : ho(t) ? GC(t, n) : yc(KC(Bi(e)));
}
function JC(e) {
  var t = _a(Sd(e)), n = ["absolute", "fixed"].indexOf(di(e).position) >= 0, r = n && Yn(e) ? bs(e) : e;
  return ho(r) ? t.filter(function(i) {
    return ho(i) && kg(i, r) && Vr(i) !== "body";
  }) : [];
}
function XC(e, t, n, r) {
  var i = t === "clippingParents" ? JC(e) : [].concat(t), o = [].concat(i, [n]), a = o[0], s = o.reduce(function(l, d) {
    var u = bh(e, d, r);
    return l.top = io(u.top, l.top), l.right = pl(u.right, l.right), l.bottom = pl(u.bottom, l.bottom), l.left = io(u.left, l.left), l;
  }, bh(e, a, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Mg(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? Br(r) : null, o = r ? ia(r) : null, a = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (i) {
    case Tn:
      l = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Jn:
      l = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Xn:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Mn:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var d = i ? rf(i) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (o) {
      case ta:
        l[d] = l[d] - (t[u] / 2 - n[u] / 2);
        break;
      case Ja:
        l[d] = l[d] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Xa(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, o = n.strategy, a = o === void 0 ? e.strategy : o, s = n.boundary, l = s === void 0 ? yC : s, d = n.rootBoundary, u = d === void 0 ? yg : d, c = n.elementContext, f = c === void 0 ? Sa : c, h = n.altBoundary, p = h === void 0 ? !1 : h, m = n.padding, g = m === void 0 ? 0 : m, v = Sg(typeof g != "number" ? g : Cg(g, ys)), b = f === Sa ? bC : Sa, x = e.rects.popper, y = e.elements[p ? b : f], C = XC(ho(y) ? y : y.contextElement || Bi(e.elements.popper), l, u, a), $ = ra(e.elements.reference), O = Mg({
    reference: $,
    element: x,
    strategy: "absolute",
    placement: i
  }), z = yc(Object.assign({}, x, O)), P = f === Sa ? z : $, U = {
    top: C.top - P.top + v.top,
    bottom: P.bottom - C.bottom + v.bottom,
    left: C.left - P.left + v.left,
    right: P.right - C.right + v.right
  }, ie = e.modifiersData.offset;
  if (f === Sa && ie) {
    var W = ie[i];
    Object.keys(U).forEach(function(H) {
      var _ = [Xn, Jn].indexOf(H) >= 0 ? 1 : -1, T = [Tn, Jn].indexOf(H) >= 0 ? "y" : "x";
      U[H] += W[T] * _;
    });
  }
  return U;
}
function QC(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, o = n.rootBoundary, a = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, d = l === void 0 ? bg : l, u = ia(r), c = u ? s ? mh : mh.filter(function(p) {
    return ia(p) === u;
  }) : ys, f = c.filter(function(p) {
    return d.indexOf(p) >= 0;
  });
  f.length === 0 && (f = c);
  var h = f.reduce(function(p, m) {
    return p[m] = Xa(e, {
      placement: m,
      boundary: i,
      rootBoundary: o,
      padding: a
    })[Br(m)], p;
  }, {});
  return Object.keys(h).sort(function(p, m) {
    return h[p] - h[m];
  });
}
function ZC(e) {
  if (Br(e) === ef)
    return [];
  var t = Ks(e);
  return [yh(e), t, yh(t)];
}
function eT(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, o = i === void 0 ? !0 : i, a = n.altAxis, s = a === void 0 ? !0 : a, l = n.fallbackPlacements, d = n.padding, u = n.boundary, c = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, m = n.allowedAutoPlacements, g = t.options.placement, v = Br(g), b = v === g, x = l || (b || !p ? [Ks(g)] : ZC(g)), y = [g].concat(x).reduce(function(j, Z) {
      return j.concat(Br(Z) === ef ? QC(t, {
        placement: Z,
        boundary: u,
        rootBoundary: c,
        padding: d,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : Z);
    }, []), C = t.rects.reference, $ = t.rects.popper, O = /* @__PURE__ */ new Map(), z = !0, P = y[0], U = 0; U < y.length; U++) {
      var ie = y[U], W = Br(ie), H = ia(ie) === ta, _ = [Tn, Jn].indexOf(W) >= 0, T = _ ? "width" : "height", M = Xa(t, {
        placement: ie,
        boundary: u,
        rootBoundary: c,
        altBoundary: f,
        padding: d
      }), V = _ ? H ? Xn : Mn : H ? Jn : Tn;
      C[T] > $[T] && (V = Ks(V));
      var Q = Ks(V), ue = [];
      if (o && ue.push(M[W] <= 0), s && ue.push(M[V] <= 0, M[Q] <= 0), ue.every(function(j) {
        return j;
      })) {
        P = ie, z = !1;
        break;
      }
      O.set(ie, ue);
    }
    if (z)
      for (var oe = p ? 3 : 1, Y = function(Z) {
        var ee = y.find(function(N) {
          var Ce = O.get(N);
          if (Ce)
            return Ce.slice(0, Z).every(function(qe) {
              return qe;
            });
        });
        if (ee)
          return P = ee, "break";
      }, ce = oe; ce > 0; ce--) {
        var S = Y(ce);
        if (S === "break") break;
      }
    t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
  }
}
const tT = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: eT,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function $h(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function wh(e) {
  return [Tn, Xn, Jn, Mn].some(function(t) {
    return e[t] >= 0;
  });
}
function nT(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, o = t.modifiersData.preventOverflow, a = Xa(t, {
    elementContext: "reference"
  }), s = Xa(t, {
    altBoundary: !0
  }), l = $h(a, r), d = $h(s, i, o), u = wh(l), c = wh(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: c
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": c
  });
}
const rT = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: nT
};
function iT(e, t, n) {
  var r = Br(e), i = [Mn, Tn].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = o[0], s = o[1];
  return a = a || 0, s = (s || 0) * i, [Mn, Xn].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function oT(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, o = i === void 0 ? [0, 0] : i, a = bg.reduce(function(u, c) {
    return u[c] = iT(c, t.rects, o), u;
  }, {}), s = a[t.placement], l = s.x, d = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += d), t.modifiersData[r] = a;
}
const aT = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: oT
};
function sT(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Mg({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const lT = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: sT,
  data: {}
};
function dT(e) {
  return e === "x" ? "y" : "x";
}
function uT(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, o = i === void 0 ? !0 : i, a = n.altAxis, s = a === void 0 ? !1 : a, l = n.boundary, d = n.rootBoundary, u = n.altBoundary, c = n.padding, f = n.tether, h = f === void 0 ? !0 : f, p = n.tetherOffset, m = p === void 0 ? 0 : p, g = Xa(t, {
    boundary: l,
    rootBoundary: d,
    padding: c,
    altBoundary: u
  }), v = Br(t.placement), b = ia(t.placement), x = !b, y = rf(v), C = dT(y), $ = t.modifiersData.popperOffsets, O = t.rects.reference, z = t.rects.popper, P = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, U = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), ie = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, W = {
    x: 0,
    y: 0
  };
  if ($) {
    if (o) {
      var H, _ = y === "y" ? Tn : Mn, T = y === "y" ? Jn : Xn, M = y === "y" ? "height" : "width", V = $[y], Q = V + g[_], ue = V - g[T], oe = h ? -z[M] / 2 : 0, Y = b === ta ? O[M] : z[M], ce = b === ta ? -z[M] : -O[M], S = t.elements.arrow, j = h && S ? nf(S) : {
        width: 0,
        height: 0
      }, Z = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : xg(), ee = Z[_], N = Z[T], Ce = Ra(0, O[M], j[M]), qe = x ? O[M] / 2 - oe - Ce - ee - U.mainAxis : Y - Ce - ee - U.mainAxis, I = x ? -O[M] / 2 + oe + Ce + N + U.mainAxis : ce + Ce + N + U.mainAxis, Me = t.elements.arrow && bs(t.elements.arrow), Ye = Me ? y === "y" ? Me.clientTop || 0 : Me.clientLeft || 0 : 0, ke = (H = ie == null ? void 0 : ie[y]) != null ? H : 0, je = V + qe - ke - Ye, re = V + I - ke, le = Ra(h ? pl(Q, je) : Q, V, h ? io(ue, re) : ue);
      $[y] = le, W[y] = le - V;
    }
    if (s) {
      var Ke, We = y === "x" ? Tn : Mn, Tt = y === "x" ? Jn : Xn, Oe = $[C], xt = C === "y" ? "height" : "width", lt = Oe + g[We], Yt = Oe - g[Tt], er = [Tn, Mn].indexOf(v) !== -1, Pn = (Ke = ie == null ? void 0 : ie[C]) != null ? Ke : 0, Ht = er ? lt : Oe - O[xt] - z[xt] - Pn + U.altAxis, Nn = er ? Oe + O[xt] + z[xt] - Pn - U.altAxis : Yt, yr = h && er ? IC(Ht, Oe, Nn) : Ra(h ? Ht : lt, Oe, h ? Nn : Yt);
      $[C] = yr, W[C] = yr - Oe;
    }
    t.modifiersData[r] = W;
  }
}
const cT = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: uT,
  requiresIfExists: ["offset"]
};
function fT(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function pT(e) {
  return e === Bn(e) || !Yn(e) ? of(e) : fT(e);
}
function hT(e) {
  var t = e.getBoundingClientRect(), n = na(t.width) / e.offsetWidth || 1, r = na(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function mT(e, t, n) {
  n === void 0 && (n = !1);
  var r = Yn(t), i = Yn(t) && hT(t), o = Bi(t), a = ra(e, i, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Vr(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  sf(o)) && (s = pT(t)), Yn(t) ? (l = ra(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : o && (l.x = af(o))), {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function gT(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function i(o) {
    n.add(o.name);
    var a = [].concat(o.requires || [], o.requiresIfExists || []);
    a.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && i(l);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || i(o);
  }), r;
}
function vT(e) {
  var t = gT(e);
  return EC.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function yT(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function bT(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var kh = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function xh() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function $T(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, o = i === void 0 ? kh : i;
  return function(s, l, d) {
    d === void 0 && (d = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, kh, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, c = [], f = !1, h = {
      state: u,
      setOptions: function(v) {
        var b = typeof v == "function" ? v(u.options) : v;
        m(), u.options = Object.assign({}, o, u.options, b), u.scrollParents = {
          reference: ho(s) ? _a(s) : s.contextElement ? _a(s.contextElement) : [],
          popper: _a(l)
        };
        var x = vT(bT([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = x.filter(function(y) {
          return y.enabled;
        }), p(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var v = u.elements, b = v.reference, x = v.popper;
          if (xh(b, x)) {
            u.rects = {
              reference: mT(b, bs(x), u.options.strategy === "fixed"),
              popper: nf(x)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(U) {
              return u.modifiersData[U.name] = Object.assign({}, U.data);
            });
            for (var y = 0; y < u.orderedModifiers.length; y++) {
              if (u.reset === !0) {
                u.reset = !1, y = -1;
                continue;
              }
              var C = u.orderedModifiers[y], $ = C.fn, O = C.options, z = O === void 0 ? {} : O, P = C.name;
              typeof $ == "function" && (u = $({
                state: u,
                options: z,
                name: P,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: yT(function() {
        return new Promise(function(g) {
          h.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!xh(s, l))
      return h;
    h.setOptions(d).then(function(g) {
      !f && d.onFirstUpdate && d.onFirstUpdate(g);
    });
    function p() {
      u.orderedModifiers.forEach(function(g) {
        var v = g.name, b = g.options, x = b === void 0 ? {} : b, y = g.effect;
        if (typeof y == "function") {
          var C = y({
            state: u,
            name: v,
            instance: h,
            options: x
          }), $ = function() {
          };
          c.push(C || $);
        }
      });
    }
    function m() {
      c.forEach(function(g) {
        return g();
      }), c = [];
    }
    return h;
  };
}
var wT = [WC, lT, HC, $g, aT, tT, cT, FC, rT], lf = /* @__PURE__ */ $T({
  defaultModifiers: wT
}), zo = /* @__PURE__ */ ((e) => (e.White = "white", e.HighContrast = "highContrast", e))(zo || {});
const kT = $e({
  name: "DsPopover",
  props: {
    show: {
      type: Boolean
    },
    reference: {
      type: Object,
      default: null
    },
    /**
     * Possible placements: https://popper.js.org/docs/v2/constructors/#options
     * 
     * If you want to use arrows, you can only use the base placements (`top`, `bottom`, `left`, `right`).
     */
    placement: {
      type: String,
      default: "bottom"
    },
    offset: {
      type: Array,
      default: () => [0, 5]
    },
    variant: {
      type: String,
      default: zo.HighContrast
    },
    noArrow: {
      type: Boolean
    },
    size: {
      type: String,
      default: "base"
    },
    noMaxWidth: {
      type: Boolean
    }
  },
  emits: ["clickOutside"],
  setup(e, t) {
    const n = q(), r = q(), i = E(
      () => {
        var d, u;
        return (u = (d = e.reference) != null ? d : r.value) != null ? u : null;
      }
    ), o = q();
    ps(() => {
      n.value === void 0 || i.value === null || e.show && o.value === void 0 && (o.value = lf(
        i.value,
        n.value,
        {
          placement: e.placement,
          modifiers: [
            {
              name: "offset",
              options: {
                offset: e.offset
              }
            }
          ]
        }
      ));
    }), S5(n, (d) => {
      e.show && t.emit("clickOutside", d);
    });
    const a = () => {
      o.value !== void 0 && (o.value.destroy(), o.value = void 0);
    };
    bo(a);
    const s = E(() => {
      const d = [];
      return e.variant === zo.HighContrast && d.push("bg-gray-800 text-white"), e.variant === zo.White && d.push("bg-white shadow-md border"), d.join(" ");
    }), l = E(() => {
      const d = e.placement === "top" || e.placement === "bottom" ? "y" : "x";
      return {
        "enter-from-class": `opacity-0 transform -translate-${d}-1`,
        "enter-to-class": `opacity-100 transform translate-${d}-0`,
        "leave-from-class": `opacity-100 transform translate-${d}-0`,
        "leave-to-class": `opacity-0 transform -translate-${d}-1`
      };
    });
    return {
      content: n,
      localReference: r,
      destroy: a,
      computedToolTipStyle: s,
      PopoverVariant: zo,
      transitionClasses: l
    };
  }
}), xT = {
  ref: "content",
  role: "tooltip",
  class: "z-[1000]"
}, ST = {
  key: 0,
  ref: "localReference"
};
function CT(e, t, n, r, i, o) {
  return k(), A(Ie, null, [
    (k(), ge(ca, { to: "body" }, [
      G("div", xT, [
        fe(ur, {
          "enter-active-class": "ease-out duration-100",
          "enter-from-class": e.transitionClasses["enter-from-class"],
          "enter-to-class": e.transitionClasses["enter-to-class"],
          "leave-active-class": "ease-in duration-75",
          "leave-from-class": e.transitionClasses["leave-from-class"],
          "leave-to-class": e.transitionClasses["leave-to-class"],
          onAfterLeave: e.destroy
        }, {
          default: de(() => [
            e.show ? se(e.$slots, "template", { key: 0 }, () => [
              G("div", {
                class: te(["rounded-md p-1 px-3 relative", {
                  [e.computedToolTipStyle]: !0,
                  "text-sm": e.size === "sm",
                  "text-lg": e.size === "lg",
                  "max-w-xs": !e.noMaxWidth,
                  "arrow-container": !e.noArrow
                }])
              }, [
                e.noArrow ? K("", !0) : (k(), A("div", {
                  key: 0,
                  class: te(["arrow pointer-events-none", {
                    "arrow-white": e.variant === e.PopoverVariant.White,
                    "arrow-small": e.size === "sm",
                    "arrow-large": e.size === "lg"
                  }])
                }, null, 2)),
                G("div", null, [
                  se(e.$slots, "content", {}, void 0, !0)
                ])
              ], 2)
            ], !0) : K("", !0)
          ]),
          _: 3
        }, 8, ["enter-from-class", "enter-to-class", "leave-from-class", "leave-to-class", "onAfterLeave"])
      ], 512)
    ])),
    e.reference === null ? (k(), A("div", ST, [
      se(e.$slots, "default", {}, void 0, !0)
    ], 512)) : K("", !0)
  ], 64);
}
const df = /* @__PURE__ */ Je(kT, [["render", CT], ["__scopeId", "data-v-c06796f7"]]), TT = $e({
  components: {
    DsPopover: df,
    DropdownBase: vC
  },
  props: {
    /**
     * The items displayed in the popover. Can either be strings or objects.
     */
    items: {
      type: Array,
      required: !0
    },
    /**
     * The key of the item objects, that should be used to group the items.
     */
    groupKey: {
      type: String,
      default: ""
    },
    /**
     * An optional group key, useful to specify the order of the groups.
     * */
    groupKeyOrder: {
      type: Array,
      default: () => []
    },
    /**
     * If the groups should be seperated with dividers instead of group labels
     * */
    groupWithDividers: {
      type: Boolean
    },
    buttonClass: {
      type: [String, Object],
      default: ""
    },
    listClass: {
      type: String,
      default: ""
    },
    itemClass: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    /**
     * Turns the button of the dropdown into a div, making it unfocusable.
     */
    unfocusable: {
      type: Boolean
    },
    /**
     * Possible placements: https://popper.js.org/docs/v2/constructors/#options
     */
    placement: {
      type: String,
      default: "bottom"
    },
    /**
     * The width of the popover.
     */
    width: {
      type: Number,
      default: null
    },
    /**
     * The number of pixels between the selected element
     * and the border while scrolling with keyboard.
     */
    scrollYMargin: {
      type: Number,
      default: 0
    },
    /**
     * If this is true, the dropdown will stay open on selecting a value.
     */
    keepOpenOnSelect: {
      type: Boolean
    },
    /**
     * If this is true, the first value in the list will be selected on opening.
     */
    preselectFirstValue: {
      type: Boolean
    },
    /**
     * The id of the Dropdown.
     * The corresponding popover will have the same id, suffixed with -dropdown.
     * This is useful for testing purposes.
     */
    id: {
      type: String,
      default: void 0
    },
    /**
     * Virtualize dropdown list. Does not work for grouped dropdowns at the moment.
     */
    virtualized: {
      type: Boolean
    },
    /**
     * Only needed if virtualized. Defines the height of each item.
     */
    itemHeight: {
      type: Number,
      default: 0
    },
    /**
     * Disable maximum height of dropdown item list (max-height: 16rem).
     */
    disableMaxHeight: {
      type: Boolean
    },
    /**
     * Disable toggle execution when the handling of the open state is handeld by some external logic (e.g. Typeahead).
     */
    dontToggleOnContainerFocus: {
      type: Boolean
    },
    preventCloseOnButtonFocus: {
      type: Boolean
    }
  },
  emits: {
    open: () => !0,
    close: () => !0,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    select: (e) => !0,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isOverflowing: (e) => !0
  },
  setup(e, t) {
    const n = q(), r = q(), i = q(), { width: o } = E5(r), a = E(() => {
      var c;
      return (c = e.width) != null ? c : o.value;
    }), s = q(!1), l = () => {
      s.value = !0, t.emit("open");
    }, d = (c) => {
      var f;
      c !== void 0 && ((f = n.value) != null && f.contains(c.target)) || (s.value = !1, t.emit("close"));
    };
    return {
      dropdown: i,
      button: n,
      wrapper: r,
      dropdownWidth: a,
      close: d,
      open: l,
      isOpen: s,
      setValue: (c) => {
        var f;
        t.emit("select", c), (f = n.value) == null || f.focus(), e.keepOpenOnSelect || d();
      },
      toggle() {
        if (!(e.disabled || e.dontToggleOnContainerFocus)) {
          if (s.value) {
            d();
            return;
          }
          l();
        }
      },
      focusButtonAndClose(c) {
        var f;
        !e.preventCloseOnButtonFocus && s.value && (c == null || c.preventDefault(), (f = n.value) == null || f.focus(), d());
      },
      selectNext(c) {
        var f;
        s.value && (c == null || c.preventDefault(), (f = i.value) == null || f.selectNext());
      },
      selectPrevious(c) {
        var f;
        s.value && (c == null || c.preventDefault(), (f = i.value) == null || f.selectPrevious());
      },
      selectIfOpen(c) {
        var f;
        s.value && (c == null || c.preventDefault(), (f = i.value) == null || f.emitSelectedIndex());
      },
      dropdownId: E(() => e.id === void 0 ? void 0 : `${e.id}-dropdown`)
    };
  }
}), MT = { ref: "wrapper" };
function OT(e, t, n, r, i, o) {
  const a = Be("DropdownBase"), s = Be("DsPopover");
  return k(), A("div", MT, [
    fe(s, {
      show: e.isOpen,
      placement: e.placement,
      onClickOutside: e.close
    }, {
      template: de(() => [
        fe(a, {
          id: e.dropdownId,
          ref: "dropdown",
          items: e.items,
          width: e.dropdownWidth,
          "list-class": e.listClass,
          "item-class": e.itemClass,
          "scroll-y-margin": e.scrollYMargin,
          "preselect-first-value": e.preselectFirstValue,
          "keep-open-on-select": e.keepOpenOnSelect,
          "group-key": e.groupKey,
          "group-key-order": e.groupKeyOrder,
          "group-with-dividers": e.groupWithDividers,
          virtualized: e.virtualized,
          "item-height": e.itemHeight,
          "disable-max-height": e.disableMaxHeight,
          onKeydown: [
            Re(e.focusButtonAndClose, ["tab"]),
            Re(e.focusButtonAndClose, ["esc"])
          ],
          onSelect: e.setValue,
          onIsOverflowing: t[0] || (t[0] = (l) => e.$emit("isOverflowing", l))
        }, {
          extra: de(() => [
            se(e.$slots, "extra", {}, void 0, !0)
          ]),
          item: de(({ item: l, index: d }) => [
            se(e.$slots, "item", {
              item: l,
              index: d
            }, void 0, !0)
          ]),
          "no-items": de(() => [
            se(e.$slots, "no-items", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["id", "items", "width", "list-class", "item-class", "scroll-y-margin", "preselect-first-value", "keep-open-on-select", "group-key", "group-key-order", "group-with-dividers", "virtualized", "item-height", "disable-max-height", "onKeydown", "onSelect"])
      ]),
      default: de(() => [
        (k(), ge(Qn(e.unfocusable ? "div" : "button"), {
          id: e.id,
          ref: "button",
          type: "button",
          class: te(e.buttonClass),
          disabled: e.disabled,
          onClick: Ge(e.toggle, ["stop"]),
          onKeydown: [
            Re(e.focusButtonAndClose, ["tab"]),
            Re(e.focusButtonAndClose, ["esc"]),
            Re(e.selectNext, ["down"]),
            Re(e.selectPrevious, ["up"]),
            Re(e.selectIfOpen, ["enter"])
          ]
        }, {
          default: de(() => [
            se(e.$slots, "button", {
              isOpen: e.isOpen,
              open: e.open,
              close: e.close
            }, void 0, !0)
          ]),
          _: 3
        }, 40, ["id", "class", "disabled", "onClick", "onKeydown"]))
      ]),
      _: 3
    }, 8, ["show", "placement", "onClickOutside"])
  ], 512);
}
const Cd = /* @__PURE__ */ Je(TT, [["render", OT], ["__scopeId", "data-v-d9449d22"]]), ET = ["textContent"], DT = /* @__PURE__ */ $e({
  __name: "ListboxItem",
  props: {
    label: {},
    highlight: { type: Boolean },
    indentation: { default: 0 }
  },
  emits: ["click"],
  setup(e) {
    return (t, n) => (k(), A("div", {
      class: te(["py-1 px-2 leading-tight hover:bg-gray-200 cursor-pointer", {
        "bg-gray-200": t.highlight,
        [`pl-${t.indentation * 3}`]: t.indentation > 0
      }]),
      onClick: n[0] || (n[0] = (r) => t.$emit("click")),
      textContent: Te(t.label)
    }, null, 10, ET));
  }
}), AT = $e({
  name: "DsFormGroupLabel",
  props: {
    hasLabel: {
      type: Boolean,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    labelFor: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean
    }
  },
  setup(e) {
    return {
      labelElement: E(() => e.labelFor !== "" ? "label" : "div")
    };
  }
}), PT = {
  key: 0,
  class: "text-red-500"
};
function NT(e, t, n, r, i, o) {
  return e.hasLabel ? (k(), ge(Qn(e.labelElement), {
    key: 0,
    for: e.labelElement === "label" ? e.labelFor : void 0,
    class: te(["font-medium text-gray-700 text-sm flex justify-between items-center", {
      "cursor-pointer select-none": e.labelElement === "label"
    }])
  }, {
    default: de(() => [
      G("div", null, [
        it(Te(e.label) + " ", 1),
        e.required ? (k(), A("span", PT, " * ")) : K("", !0)
      ])
    ]),
    _: 1
  }, 8, ["for", "class"])) : K("", !0);
}
const IT = /* @__PURE__ */ Je(AT, [["render", NT]]), RT = $e({
  name: "DsFieldError",
  setup(e, t) {
    return () => {
      const n = t.slots.default !== void 0 ? t.slots.default() : "";
      return nn("div", {
        class: "text-red-500 text-xs font-medium"
      }, n);
    };
  }
}), Og = Symbol("DsFormState"), _T = () => Zn(Og, {
  validation: {}
}), LT = (e) => {
  mr(Og, e);
}, Eg = Symbol("DsFormState"), FT = () => Zn(Eg, {
  validation: []
}), BT = (e) => {
  mr(Eg, e);
}, zT = $e({
  name: "DsForm",
  props: {
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    wrappingElement: {
      type: String,
      default: "form"
    }
  },
  setup(e) {
    const t = Gn({
      validation: {}
    });
    Fe(() => e.validationErrors, (n) => {
      t.validation = n;
    }, { immediate: !0 }), LT(t);
  }
});
function VT(e, t, n, r, i, o) {
  return k(), ge(Qn(e.wrappingElement), null, {
    default: de(() => [
      se(e.$slots, "default")
    ]),
    _: 3
  });
}
const HV = /* @__PURE__ */ Je(zT, [["render", VT]]), HT = $e({
  name: "DsFormGroup",
  components: {
    DsFieldError: RT,
    DsFormGroupLabel: IT
  },
  props: {
    /**
     * Contains the text displayed above the content/form field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * If you provide a label-for id, the label will be rendered
     * as an actual <label> serving usual click behaviour.
     */
    labelFor: {
      type: String,
      default: ""
    },
    /**
     * Contains a small text displayed below the content/form field.
     */
    help: {
      type: String,
      default: ""
    },
    /**
     * Marks if the form field is required by appending a star (*) to the label
     */
    required: {
      type: Boolean
    },
    validationName: {
      type: String,
      default: ""
    },
    /**
     * Used to render a component inline with the form group label
     */
    inline: {
      type: Boolean
    },
    /**
     * Same as the `inline` flag but in reversed order (label -> input)
     */
    inlineReverse: {
      type: Boolean
    }
  },
  setup(e, t) {
    const n = _T(), r = Gn({
      validation: []
    }), i = E(() => {
      var o;
      return (o = n.validation[e.validationName]) != null ? o : [];
    });
    return Fe(i, (o) => {
      r.validation = o;
    }, { immediate: !0 }), BT(r), {
      hasLabel: "default" in t.slots,
      inlineHelpStyle: E(() => {
        if (e.help.length > 0 && e.inline)
          return {
            marginLeft: 0,
            flexBasis: "100%"
          };
      }),
      isInline: E(() => e.inline || e.inlineReverse),
      validationErrors: i,
      hasValidationError: E(() => i.value.length > 0)
    };
  }
}), jT = { class: "flex min-w-0 flex-col space-y-1" }, WT = {
  key: 3,
  class: "mt-2"
};
function UT(e, t, n, r, i, o) {
  const a = Be("DsFormGroupLabel"), s = Be("DsFieldError");
  return k(), A("div", jT, [
    e.isInline ? (k(), A("div", {
      key: 0,
      class: te(["flex space-x-2", {
        "flex-row": e.inline,
        "flex-row-reverse space-x-reverse": e.inlineReverse
      }])
    }, [
      se(e.$slots, "default"),
      fe(a, {
        "has-label": e.hasLabel,
        label: e.label,
        "label-for": e.labelFor,
        required: e.required
      }, null, 8, ["has-label", "label", "label-for", "required"])
    ], 2)) : (k(), A(Ie, { key: 1 }, [
      fe(a, {
        "has-label": e.hasLabel,
        label: e.label,
        "label-for": e.labelFor,
        required: e.required
      }, null, 8, ["has-label", "label", "label-for", "required"]),
      se(e.$slots, "default")
    ], 64)),
    e.help.length > 0 ? (k(), A("div", {
      key: 2,
      class: te(["text-gray-600 text-xs", {
        "mt-2": e.isInline,
        "text-right": e.inlineReverse
      }]),
      style: mt(e.inlineHelpStyle)
    }, Te(e.help), 7)) : K("", !0),
    e.hasValidationError ? (k(), A("div", WT, [
      (k(!0), A(Ie, null, Ze(e.validationErrors, (l) => (k(), ge(s, { key: l }, {
        default: de(() => [
          it(Te(l), 1)
        ]),
        _: 2
      }, 1024))), 128))
    ])) : K("", !0)
  ]);
}
const qT = /* @__PURE__ */ Je(HT, [["render", UT]]);
var YT = Object.defineProperty, KT = (e, t, n) => t in e ? YT(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, hl = (e, t, n) => KT(e, typeof t != "symbol" ? t + "" : t, n);
const Sh = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, Ch = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), Th = (e, t, n) => {
  var i;
  var r;
  return new Intl.NumberFormat((i = (r = n.number) == null ? void 0 : r.locale) != null ? i : "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, GT = (e, t = !0, n) => {
  var g, v, b;
  var r, i, o, a;
  const s = ((r = n.number) == null ? void 0 : r.unsigned) == null && e.startsWith("-") ? "-" : "", l = (g = (i = n.number) == null ? void 0 : i.fraction) != null ? g : 0;
  let d = Th(0, l, n);
  const u = d.formatToParts(1000.12), c = (v = (o = u.find((x) => x.type === "group")) == null ? void 0 : o.value) != null ? v : " ", f = (b = (a = u.find((x) => x.type === "decimal")) == null ? void 0 : a.value) != null ? b : ".", h = Ch(e, c, f);
  if (Number.isNaN(parseFloat(h))) return s;
  const p = h.split(".");
  if (p[1] != null && p[1].length >= 1) {
    const x = p[1].length <= l ? p[1].length : l;
    d = Th(x, l, n);
  }
  let m = d.format(parseFloat(h));
  return t ? l > 0 && h.endsWith(".") && !h.slice(0, -1).includes(".") && (m += f) : m = Ch(m, c, f), s + m;
};
let JT = class {
  constructor(t = {}) {
    var r;
    hl(this, "opts", {}), hl(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...Sh, ...n.tokens };
      for (const i of Object.values(n.tokens))
        typeof i.pattern == "string" && (i.pattern = new RegExp(i.pattern));
    } else
      n.tokens = Sh;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((i, o) => i.length - o.length) : n.mask = (r = n.mask[0]) != null ? r : ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(t, this.findMask(t));
  }
  unmasked(t) {
    return this.process(t, this.findMask(t), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(t);
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(t, n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    var i, o;
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, (i = n.slice(-1).pop()) != null ? i : "", !1);
    return (o = n.find((a) => this.process(t, a, !1).length >= r.length)) != null ? o : "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((i, o) => {
      i === "!" && t[o - 1] !== "!" ? r.push(o - r.length) : n.push(i);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return GT(t, r, this.opts);
    if (n == null) return t;
    const i = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(i)) return this.memo.get(i);
    const { mask: o, escaped: a } = this.escapeMask(n), s = [], l = this.opts.tokens != null ? this.opts.tokens : {}, d = this.isReversed() ? -1 : 1, u = this.isReversed() ? "unshift" : "push", c = this.isReversed() ? 0 : o.length - 1, f = this.isReversed() ? () => g > -1 && v > -1 : () => g < o.length && v < t.length, h = (x) => !this.isReversed() && x <= c || this.isReversed() && x >= c;
    let p, m = -1, g = this.isReversed() ? o.length - 1 : 0, v = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const x = o.charAt(g), y = l[x], C = (y == null ? void 0 : y.transform) != null ? y.transform(t.charAt(v)) : t.charAt(v);
      if (!a.includes(g) && y != null ? (C.match(y.pattern) != null ? (s[u](C), y.repeated ? (m === -1 ? m = g : g === c && g !== m && (g = m - d), c === m && (g -= d)) : y.multiple && (b = !0, g -= d), g += d) : y.multiple ? b && (g += d, v -= d, b = !1) : C === p ? p = void 0 : y.optional && (g += d, v -= d), v += d) : (r && !this.isEager() && s[u](x), C === x && !this.isEager() ? v += d : p = x, this.isEager() || (g += d)), this.isEager())
        for (; h(g) && (l[o.charAt(g)] == null || a.includes(g)); ) {
          if (r) {
            if (s[u](o.charAt(g)), t.charAt(v) === o.charAt(g)) {
              g += d, v += d;
              continue;
            }
          } else o.charAt(g) === t.charAt(v) && (v += d);
          g += d;
        }
    }
    return this.memo.set(i, s.join("")), this.memo.get(i);
  }
};
const Dg = (e) => JSON.parse(e.replaceAll("'", '"')), XT = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = QT(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = Rs(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = Rs(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = Rs(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = ZT(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = Rs(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, Rs = (e) => e !== "" ? !!JSON.parse(e) : !0, QT = (e) => e.startsWith("[") && e.endsWith("]") ? Dg(e) : e, ZT = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Dg(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
};
class eM {
  constructor(t, n = {}) {
    hl(this, "items", /* @__PURE__ */ new Map()), hl(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const i = r.target, o = this.items.get(i), a = "inputType" in r && r.inputType.startsWith("delete"), s = o.isEager(), l = a && s && o.unmasked(i.value) === "" ? "" : i.value;
      this.fixCursor(i, a, () => this.setValue(i, l));
    }), this.options = n, this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    t.value !== "" && t.value !== this.processInput(t).masked && this.setValue(t, t.value);
  }
  destroy() {
    for (const t of this.items.keys())
      t.removeEventListener("input", this.onInput);
    this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      this.items.has(r) || r.addEventListener("input", this.onInput, { capture: !0 });
      const i = new JT(XT(r, n));
      this.items.set(r, i), queueMicrotask(() => this.updateValue(r)), r.selectionStart === null && i.isEager() && console.warn("Maska: input of `%s` type is not supported", r.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: i, ...o } = t;
    return o;
  }
  fixCursor(t, n, r) {
    const i = t.selectionStart, o = t.value;
    if (r(), i === null || i === o.length && !n) return;
    const a = t.value, s = o.slice(0, i), l = a.slice(0, i), d = this.processInput(t, s).unmasked, u = this.processInput(t, l).unmasked;
    let c = i;
    s !== l && (c += n ? a.length - o.length : d.length - u.length), t.setSelectionRange(c, c);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((i) => i(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked }));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    let i = n != null ? n : t.value;
    this.options.preProcess != null && (i = this.options.preProcess(i));
    let o = r.masked(i);
    return this.options.postProcess != null && (o = this.options.postProcess(o)), {
      masked: o,
      unmasked: r.unmasked(i),
      completed: r.completed(i)
    };
  }
}
const yu = /* @__PURE__ */ new WeakMap(), tM = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, nM = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || (r == null ? void 0 : r.type) === "file") return;
  let i = {};
  if (t.value != null && (i = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const o = (a) => {
      const s = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      tM(t, s);
    };
    i.onMaska = i.onMaska == null ? o : Array.isArray(i.onMaska) ? [...i.onMaska, o] : [i.onMaska, o];
  }
  yu.has(r) ? (n = yu.get(r)) == null || n.update(i) : yu.set(r, new eM(r, i));
}, rM = $e({
  name: "DsLoadingState",
  components: { DsIcon: Ue },
  props: {
    isLoading: {
      type: Boolean
    },
    inlineBorder: {
      type: Boolean
    },
    opaque: {
      type: Boolean
    }
  }
}), iM = {
  "inline-border": "_inline-border_1xd73_2"
};
function oM(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return e.isLoading ? (k(), A("div", {
    key: 0,
    class: te(["absolute top-0 left-0 w-full h-full bg-white flex items-center justify-center rounded z-50 cursor-default", {
      [e.$style["inline-border"]]: e.inlineBorder,
      "bg-opacity-80": !e.opaque
    }]),
    onClick: t[0] || (t[0] = Ge(() => {
    }, ["stop"]))
  }, [
    fe(a, {
      name: "spinner-third",
      class: "text-gray-700",
      spin: ""
    })
  ], 2)) : K("", !0);
}
const aM = {
  $style: iM
}, $s = /* @__PURE__ */ Je(rM, [["render", oM], ["__cssModules", aM]]), ml = {
  sm: "px-2 h-6 sm:text-sm",
  base: "py-1 px-3 h-8 sm:text-sm",
  lg: "py-2 px-3 h-10 text-lg"
}, sM = $e({
  name: "DsInput",
  components: {
    DsLoadingState: $s,
    DsDatepicker: nw,
    DsIcon: Ue
  },
  directives: {
    maska: nM
  },
  props: {
    disabled: {
      type: Boolean
    },
    icon: {
      type: String,
      default: "",
      required: !1
    },
    /**
     * Type 'date' uses undefined for no selected date.
     */
    modelValue: {
      type: [String, Number, Date, null],
      default: void 0,
      required: !1
    },
    type: {
      type: String,
      default: "default"
    },
    name: {
      type: String,
      default: "",
      required: !1
    },
    align: {
      type: String,
      default: "left"
    },
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Sets the field type for autocompletion. Set to `off` by default.
     */
    autocomplete: {
      type: String,
      default: "off"
    },
    autofocus: {
      type: Boolean
    },
    /**
     * Indicates if this input form should have no border or shadow styling.
     * Use this for embedding in other components.
     */
    inline: {
      type: Boolean
    },
    size: {
      type: String,
      default: "base"
    },
    /**
     * If the value should be updated immediately on every change,
     * activate the `immediate` mode (opposite of the `lazy` modifier).
     */
    immediate: {
      type: Boolean
    },
    datepickerConfig: {
      type: Object,
      default: null
    },
    /**
     * If you want to apply a mask, provide the pre-defined mask with
     * this property.
     * Additionally, you may also provide a label which could be displayed
     * left or right.
     */
    mask: {
      type: [
        String,
        Object
      ],
      default: void 0
    },
    /**
     * Optional prefix
     */
    prefix: {
      type: [String, null],
      default: null
    },
    /**
     * Defines the minimum width the prefix has
     */
    minPrefixWidth: {
      type: [String, null],
      default: null
    },
    /**
     * Optional suffix
     */
    suffix: {
      type: [String, null],
      default: null
    },
    /**
     * Defines the minimum width the suffix has
     */
    minSuffixWidth: {
      type: [String, null],
      default: null
    },
    isLoading: {
      type: Boolean
    },
    id: {
      type: String,
      default: void 0
    },
    min: {
      type: Number,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    step: {
      type: Number,
      default: void 0
    },
    selectOnClick: {
      type: Boolean
    }
  },
  emits: [
    "update:modelValue",
    "blur",
    "focus"
  ],
  setup(e, t) {
    const n = FT(), r = E(() => n.validation.length > 0), i = q(), o = q(null), a = q(null), s = q(!1), l = E({
      get: () => e.modelValue,
      set: (v) => {
        let b;
        e.type === "number" && typeof v == "string" ? b = Number.parseInt(v, 10) : b = v, t.emit("update:modelValue", b);
      }
    }), d = q(""), u = (v) => {
      if (!(v.target instanceof HTMLInputElement))
        throw new Error("event target must be type of HTMLInputElement");
      const b = v.target;
      let x = b.value;
      e.type === "number" && (e.min !== void 0 && Number(x) < e.min && (x = e.min.toString()), e.max !== void 0 && Number(x) > e.max && (x = e.max.toString()), b.value = x), l.value = x;
    }, c = () => {
      var v, b;
      i.value !== void 0 && ((v = i.value) != null && v) && ((b = l.value) != null && b) && (i.value.type = "text", i.value.select(), i.value.type = "number");
    }, f = (v) => {
      d.value = v.detail.unmasked, e.immediate && u(v);
    }, h = E(() => r.value ? "exclamation-circle" : e.type === "date" ? "calendar" : ""), p = E(() => {
      if (e.prefix === null || o.value === null)
        return;
      const v = `${o.value.clientWidth}px`;
      return e.minPrefixWidth !== null ? `max(${e.minPrefixWidth}, ${v})` : v;
    }), m = E(() => {
      if (e.suffix === null || a.value === null)
        return;
      const v = `${a.value.clientWidth}px`;
      return e.minSuffixWidth !== null ? `max(${e.minSuffixWidth}, ${v})` : v;
    }), g = E(() => ({
      "text-center": e.align === "center",
      "text-right": e.align === "right",
      "bg-gray-100 border-gray-200 text-gray-500": e.disabled,
      "bg-white focus:border-blue-500 focus:shadow-outline-blue text-gray-900": !e.disabled,
      "border-gray-300": !e.inline && !e.disabled,
      "border-transparent": e.inline,
      "pl-8": e.icon !== "",
      "pr-8": h.value !== "",
      [ml[e.size]]: !0,
      "shadow-sm": !e.disabled && !e.inline
    }));
    return ot(() => {
      e.autofocus && i.value instanceof HTMLInputElement && i.value !== document.activeElement && i.value.focus();
    }), {
      input: i,
      isInvalid: r,
      sharedClasses: g,
      prefixRef: o,
      suffixRef: a,
      prefixWidth: p,
      suffixWidth: m,
      showPassword: s,
      typeIcon: h,
      sizeClasses: E(() => ml[e.size]),
      valueProxy: l,
      focus() {
        var v;
        (v = i.value) == null || v.focus();
      },
      emitBlur(v) {
        t.emit("blur", v);
      },
      emitFocus(v) {
        t.emit("focus", v);
      },
      inputType: E(() => e.type === "default" || s.value ? "text" : e.type),
      eventListener: E(() => {
        if (e.mask !== void 0) {
          const b = {};
          return b.maska = f, e.immediate || (b.change = u), b;
        }
        let v = {};
        return e.type === "number" && e.selectOnClick && (v = {
          focus: c
        }), e.immediate ? { ...v, input: u } : { ...v, change: u };
      }),
      preventInputSelection: (v) => {
        v.detail > 1 && v.preventDefault();
      },
      valueProxyDate: E({
        get: () => l.value === void 0 || l.value === null ? null : l.value,
        set: (v) => {
          l.value = v != null ? v : void 0;
        }
      }),
      loadingStateTextSize: E(() => {
        switch (e.size) {
          case "sm":
            return "text-sm";
          case "lg":
            return "text-xl";
          default:
            return "text-lg";
        }
      })
    };
  }
}), lM = "_extension_vk470_2", dM = "_prefix_vk470_6", uM = "_suffix_vk470_13", cM = {
  extension: lM,
  prefix: dM,
  suffix: uM
}, fM = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-2 leading-none text-gray-500 pointer-events-none"
}, pM = ["id", "value", "type", "min", "max", "step", "readonly", "placeholder", "name", "autofocus", "autocomplete"];
function hM(e, t, n, r, i, o) {
  var u;
  const a = Be("DsLoadingState"), s = Be("DsIcon"), l = Be("DsDatepicker"), d = o4("maska");
  return k(), A("div", {
    class: te(["relative rounded", {
      "flex flex-row bg-white text-gray-900": e.mask !== void 0
    }])
  }, [
    fe(a, {
      "is-loading": e.isLoading,
      "inline-border": !e.inline,
      class: te(e.loadingStateTextSize)
    }, null, 8, ["is-loading", "inline-border", "class"]),
    e.icon !== "" ? (k(), A("div", fM, [
      fe(s, {
        name: e.icon,
        class: "w-4 h-4",
        "fixed-width": ""
      }, null, 8, ["name"])
    ])) : K("", !0),
    e.prefix !== null ? (k(), A("div", {
      key: 1,
      ref: "prefixRef",
      class: te({
        [e.sizeClasses]: !0,
        "absolute flex items-center rounded bg-gray-100 select-none border-gray-300 shadow-sm text-gray-900": !0,
        [e.$style.prefix]: !0,
        [e.$style.extension]: !0
      }),
      style: mt({ width: e.prefixWidth })
    }, Te(e.prefix), 7)) : K("", !0),
    e.suffix !== null ? (k(), A("div", {
      key: 2,
      ref: "suffixRef",
      class: te({
        [e.sizeClasses]: !0,
        "absolute flex items-center rounded bg-gray-100 select-none border-gray-300 shadow-sm text-gray-900": !0,
        [e.$style.suffix]: !0,
        [e.$style.extension]: !0
      }),
      style: mt({ width: e.suffixWidth })
    }, Te(e.suffix), 7)) : K("", !0),
    e.inputType === "date" && (e.valueProxy === void 0 || e.valueProxy === null || e.valueProxy instanceof Date) ? (k(), ge(l, {
      key: 3,
      id: e.id,
      modelValue: e.valueProxyDate,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => e.valueProxyDate = c),
      style: mt(e.sharedClasses),
      "datepicker-config": e.datepickerConfig,
      disabled: e.disabled,
      typeable: ""
    }, null, 8, ["id", "modelValue", "style", "datepicker-config", "disabled"])) : Jt((k(), A("input", $t({
      key: 4,
      id: e.id,
      ref: "input",
      value: e.valueProxy,
      type: e.inputType,
      min: e.inputType === "number" ? e.min : void 0,
      max: e.inputType === "number" ? e.max : void 0,
      step: e.inputType === "number" ? e.step : void 0,
      readonly: e.disabled,
      class: [{
        "tabular-nums": e.type === "number",
        ...e.sharedClasses,
        "pr-8": e.inputType === "password" || e.showPassword
      }, "block w-full min-w-0 border rounded sm:leading-5 focus:outline-none"],
      placeholder: e.placeholder,
      style: {
        paddingLeft: e.prefix !== null ? `calc(${e.prefixWidth} + ${e.size === "sm" ? "0.5rem" : "0.75rem"})` : void 0,
        paddingRight: e.suffix !== null ? `calc(${e.suffixWidth} + ${e.size === "sm" ? "0.5rem" : "0.75rem"})` : void 0,
        fontWeight: "inherit"
      },
      name: e.name,
      autofocus: e.autofocus,
      autocomplete: e.autocomplete
    }, a4({
      ...e.eventListener
    }, !0), {
      onBlur: t[1] || (t[1] = (...c) => e.emitBlur && e.emitBlur(...c)),
      onFocus: t[2] || (t[2] = (...c) => e.emitFocus && e.emitFocus(...c))
    }), null, 16, pM)), [
      [d, e.mask]
    ]),
    e.inputType === "password" || e.showPassword ? (k(), A("div", {
      key: 5,
      style: mt({ right: e.suffixWidth }),
      class: "absolute inset-y-0 right-0 pr-2 flex items-center cursor-pointer text-gray-500",
      onClick: t[3] || (t[3] = (c) => e.showPassword = !e.showPassword),
      onMousedown: t[4] || (t[4] = (...c) => e.preventInputSelection && e.preventInputSelection(...c))
    }, [
      fe(s, {
        name: e.showPassword ? "eye-slash" : "eye",
        "fixed-width": ""
      }, null, 8, ["name"])
    ], 36)) : K("", !0),
    e.typeIcon !== "" ? (k(), A("div", {
      key: 6,
      class: te([{
        "text-red-500": e.isInvalid,
        "text-gray-500": !e.isInvalid
      }, "absolute inset-y-0 right-0 flex items-center pr-2 leading-none text-gray-500 pointer-events-none"]),
      style: mt({ right: `calc(${(u = e.suffixWidth) != null ? u : "0px"} + ${e.inputType === "number" ? "1.75rem" : "0px"})` })
    }, [
      fe(s, {
        name: e.typeIcon,
        variant: "regular",
        class: te(["w-4 h-4", { "-mt-0.5": e.type === "date" }]),
        "fixed-width": ""
      }, null, 8, ["name", "class"])
    ], 6)) : K("", !0)
  ], 2);
}
const mM = {
  $style: cM
}, pa = /* @__PURE__ */ Je(sM, [["render", hM], ["__cssModules", mM]]), gM = "text-gray-700 mb-1", vM = "border rounded border-blue-200 overflow-auto max-h-full", yM = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-md"
}, bM = $e({
  name: "DsDualListbox",
  components: {
    DsCheckbox: F5,
    DsFormGroup: qT,
    DsVirtualList: Z0,
    DsButton: gr,
    DsInput: pa,
    ListboxItem: DT
  },
  props: {
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    filter: {
      type: String,
      default: void 0
    },
    filterGroups: {
      type: Array,
      default: () => []
    },
    labelKey: {
      type: String,
      default: "label"
    },
    sourceLabel: {
      type: String,
      default: ""
    },
    selectionLabel: {
      type: String,
      default: ""
    },
    headerSize: {
      type: String,
      default: "md"
    },
    itemSize: {
      type: String,
      default: "md"
    },
    sourceClass: {
      type: String,
      default: ""
    },
    selectionClass: {
      type: String,
      default: ""
    },
    reduce: {
      type: Function,
      default: (e) => e
    },
    groupSelect: {
      type: Function,
      default: void 0
    },
    itemHeight: {
      type: Number,
      default: 28
    },
    innerContainerClass: {
      type: String,
      default: void 0
    },
    virtualized: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = q(""), r = q({}), i = q(/* @__PURE__ */ new Set()), o = q(/* @__PURE__ */ new Set()), a = il([]), s = il([]), l = E(
      () => e.options.reduce(
        (v, b) => (e.modelValue.some(
          (y) => d(y, b)
        ) ? v.selection.push(b) : v.source.push(b), v),
        { source: [], selection: [] }
      )
    );
    Fe(() => e.filterGroups, () => {
      r.value = e.filterGroups.reduce((v, b) => (v[b.label] = !1, v), {});
    }, { immediate: !0 }), Fe([l, n, r], ([v, b]) => {
      a.value = u(v.source, b), s.value = u(v.selection, b);
    }, { immediate: !0, deep: !0 }), Fe(() => e.modelValue, () => {
      i.value.clear(), o.value.clear();
    });
    function d(v, b) {
      return JSON.stringify(v) === JSON.stringify(e.reduce(b));
    }
    function u(v, b) {
      const { filter: x, filterGroups: y } = e, C = y.filter((z) => r.value[z.label] === !0), $ = v.filter((z) => C.length === 0 || C.some((P) => P.filterFunction(z)));
      if (!x || b.length === 0)
        return $;
      const O = b.toLowerCase();
      return $.filter((z) => {
        var U;
        const P = (U = z[x]) == null ? void 0 : U.toLowerCase();
        return P && P.includes(O);
      });
    }
    function c(v, b, x) {
      const { id: y } = v, C = b.has(y) ? "delete" : "add";
      b[C](y);
      const { groupSelect: $ } = e;
      $ !== void 0 && x.filter((O) => $(v, O)).map(({ id: O }) => b[C](O));
    }
    function f() {
      g([
        ...l.value.selection,
        ...l.value.source.filter((v) => i.value.has(v.id))
      ]);
    }
    function h() {
      g([
        ...a.value,
        ...l.value.selection
      ]);
    }
    function p() {
      g(
        l.value.selection.filter((v) => !o.value.has(v.id))
      );
    }
    function m() {
      g(
        l.value.selection.filter((v) => !s.value.some((b) => b.id === v.id))
      );
    }
    function g(v) {
      t("update:modelValue", v.map((b) => e.reduce(b)));
    }
    return {
      headerClasses: gM,
      listboxClasses: vM,
      textSizeMap: yM,
      query: n,
      sourceMarked: i,
      selectionMarked: o,
      items: l,
      filteredSourceItems: a,
      filteredSelectionItems: s,
      filterItems: u,
      mark: c,
      select: f,
      selectAll: h,
      deselect: p,
      deselectAll: m,
      updateModelValue: g,
      groupFilter: r
    };
  }
}), $M = { class: "listbox-grid listbox-grid-default" }, wM = {
  key: 0,
  class: "group-filters flex items-center gap-5 mb-2",
  "data-test": "group-filters"
}, kM = { class: "flex flex-col" }, xM = ["textContent"], SM = { class: "listbox-buttons flex flex-col m-3 justify-center" };
function CM(e, t, n, r, i, o) {
  const a = Be("DsCheckbox"), s = Be("DsFormGroup"), l = Be("DsInput"), d = Be("ListboxItem"), u = Be("DsVirtualList"), c = Be("DsButton");
  return k(), A("div", $M, [
    e.filterGroups.length > 0 ? (k(), A("div", wM, [
      se(e.$slots, "group-filter-label", {}, void 0, !0),
      (k(!0), A(Ie, null, Ze(e.filterGroups, (f) => (k(), ge(s, {
        key: f.label,
        label: f.label,
        inline: "",
        class: "whitespace-nowrap"
      }, {
        default: de(() => [
          G("div", kM, [
            fe(a, {
              modelValue: e.groupFilter[f.label],
              "onUpdate:modelValue": (h) => e.groupFilter[f.label] = h
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _: 2
      }, 1032, ["label"]))), 128))
    ])) : K("", !0),
    e.filter ? (k(), ge(l, {
      key: 1,
      modelValue: e.query,
      "onUpdate:modelValue": t[0] || (t[0] = (f) => e.query = f),
      placeholder: "Einträge filtern...",
      immediate: "",
      class: "filter-bar mb-2"
    }, null, 8, ["modelValue"])) : K("", !0),
    (k(!0), A(Ie, null, Ze([
      [e.sourceLabel, "header-source"],
      [e.selectionLabel, "header-selection"]
    ], ([f, h], p) => (k(), A(Ie, null, [
      f.length > 0 ? (k(), A("div", {
        key: p,
        class: te([h, e.headerClasses, e.textSizeMap[e.headerSize]]),
        textContent: Te(f)
      }, null, 10, xM)) : K("", !0)
    ], 64))), 256)),
    G("div", {
      "data-test": "dlb-left",
      class: te(["listbox-source", e.listboxClasses, e.textSizeMap[e.itemSize], e.sourceClass])
    }, [
      fe(u, {
        items: e.filteredSourceItems,
        "item-height": e.itemHeight,
        "inner-container-class": e.innerContainerClass,
        disabled: !e.virtualized
      }, {
        default: de(({ item: f }) => [
          se(e.$slots, "default", {
            item: f,
            highlight: e.sourceMarked.has(f.id),
            mark: () => e.mark(f, e.sourceMarked, e.items.source)
          }, () => [
            fe(d, {
              label: f[e.labelKey].toString(),
              highlight: e.sourceMarked.has(f.id),
              indentation: f.depth,
              onClick: (h) => e.mark(f, e.sourceMarked, e.items.source)
            }, null, 8, ["label", "highlight", "indentation", "onClick"])
          ], !0)
        ]),
        _: 3
      }, 8, ["items", "item-height", "inner-container-class", "disabled"])
    ], 2),
    G("div", SM, [
      fe(c, {
        icon: "angles-right",
        disabled: e.items.source.length === 0 || e.query.length > 0,
        onClick: e.selectAll
      }, null, 8, ["disabled", "onClick"]),
      fe(c, {
        icon: "angle-right",
        class: "my-2",
        disabled: e.sourceMarked.size === 0,
        onClick: e.select
      }, null, 8, ["disabled", "onClick"]),
      fe(c, {
        icon: "angle-left",
        class: "my-2",
        disabled: e.selectionMarked.size === 0,
        onClick: e.deselect
      }, null, 8, ["disabled", "onClick"]),
      fe(c, {
        icon: "angles-left",
        disabled: e.items.selection.length === 0 || e.query.length > 0,
        onClick: e.deselectAll
      }, null, 8, ["disabled", "onClick"])
    ]),
    G("div", {
      "data-test": "dlb-right",
      class: te(["listbox-selection", e.listboxClasses, e.textSizeMap[e.itemSize], e.selectionClass])
    }, [
      fe(u, {
        items: e.filteredSelectionItems,
        "item-height": e.itemHeight,
        "inner-container-class": e.innerContainerClass,
        disabled: !e.virtualized
      }, {
        default: de(({ item: f }) => [
          se(e.$slots, "default", {
            item: f,
            highlight: e.selectionMarked.has(f.id),
            mark: () => e.mark(f, e.selectionMarked, e.items.selection)
          }, () => [
            fe(d, {
              label: f[e.labelKey].toString(),
              highlight: e.selectionMarked.has(f.id),
              indentation: f.depth,
              onClick: (h) => e.mark(f, e.selectionMarked, e.items.selection)
            }, null, 8, ["label", "highlight", "indentation", "onClick"])
          ], !0)
        ]),
        _: 3
      }, 8, ["items", "item-height", "inner-container-class", "disabled"])
    ], 2)
  ]);
}
const WV = /* @__PURE__ */ Je(bM, [["render", CM], ["__scopeId", "data-v-46b378f7"]]);
function dn(e) {
  this.content = e;
}
dn.prototype = {
  constructor: dn,
  find: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      if (this.content[t] === e) return t;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var t = this.find(e);
    return t == -1 ? void 0 : this.content[t + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, t, n) {
    var r = n && n != e ? this.remove(n) : this, i = r.find(e), o = r.content.slice();
    return i == -1 ? o.push(n || e, t) : (o[i + 1] = t, n && (o[i] = n)), new dn(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var t = this.find(e);
    if (t == -1) return this;
    var n = this.content.slice();
    return n.splice(t, 2), new dn(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, t) {
    return new dn([e, t].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, t) {
    var n = this.remove(e).content.slice();
    return n.push(e, t), new dn(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, t, n) {
    var r = this.remove(t), i = r.content.slice(), o = r.find(e);
    return i.splice(o == -1 ? i.length : o, 0, t, n), new dn(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      e(this.content[t], this.content[t + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = dn.from(e), e.size ? new dn(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = dn.from(e), e.size ? new dn(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var t = this;
    e = dn.from(e);
    for (var n = 0; n < e.content.length; n += 2)
      t = t.remove(e.content[n]);
    return t;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(t, n) {
      e[t] = n;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
dn.from = function(e) {
  if (e instanceof dn) return e;
  var t = [];
  if (e) for (var n in e) t.push(n, e[n]);
  return new dn(t);
};
function Ag(e, t, n) {
  for (let r = 0; ; r++) {
    if (r == e.childCount || r == t.childCount)
      return e.childCount == t.childCount ? null : n;
    let i = e.child(r), o = t.child(r);
    if (i == o) {
      n += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(o))
      return n;
    if (i.isText && i.text != o.text) {
      for (let a = 0; i.text[a] == o.text[a]; a++)
        n++;
      return n;
    }
    if (i.content.size || o.content.size) {
      let a = Ag(i.content, o.content, n + 1);
      if (a != null)
        return a;
    }
    n += i.nodeSize;
  }
}
function Pg(e, t, n, r) {
  for (let i = e.childCount, o = t.childCount; ; ) {
    if (i == 0 || o == 0)
      return i == o ? null : { a: n, b: r };
    let a = e.child(--i), s = t.child(--o), l = a.nodeSize;
    if (a == s) {
      n -= l, r -= l;
      continue;
    }
    if (!a.sameMarkup(s))
      return { a: n, b: r };
    if (a.isText && a.text != s.text) {
      let d = 0, u = Math.min(a.text.length, s.text.length);
      for (; d < u && a.text[a.text.length - d - 1] == s.text[s.text.length - d - 1]; )
        d++, n--, r--;
      return { a: n, b: r };
    }
    if (a.content.size || s.content.size) {
      let d = Pg(a.content, s.content, n - 1, r - 1);
      if (d)
        return d;
    }
    n -= l, r -= l;
  }
}
class ve {
  /**
  @internal
  */
  constructor(t, n) {
    if (this.content = t, this.size = n || 0, n == null)
      for (let r = 0; r < t.length; r++)
        this.size += t[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, n, r, i = 0, o) {
    for (let a = 0, s = 0; s < n; a++) {
      let l = this.content[a], d = s + l.nodeSize;
      if (d > t && r(l, i + s, o || null, a) !== !1 && l.content.size) {
        let u = s + 1;
        l.nodesBetween(Math.max(0, t - u), Math.min(l.content.size, n - u), r, i + u);
      }
      s = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, n, r, i) {
    let o = "", a = !0;
    return this.nodesBetween(t, n, (s, l) => {
      let d = s.isText ? s.text.slice(Math.max(t, l) - l, n - l) : s.isLeaf ? i ? typeof i == "function" ? i(s) : i : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && d || s.isTextblock) && r && (a ? a = !1 : o += r), o += d;
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let n = this.lastChild, r = t.firstChild, i = this.content.slice(), o = 0;
    for (n.isText && n.sameMarkup(r) && (i[i.length - 1] = n.withText(n.text + r.text), o = 1); o < t.content.length; o++)
      i.push(t.content[o]);
    return new ve(i, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, n = this.size) {
    if (t == 0 && n == this.size)
      return this;
    let r = [], i = 0;
    if (n > t)
      for (let o = 0, a = 0; a < n; o++) {
        let s = this.content[o], l = a + s.nodeSize;
        l > t && ((a < t || l > n) && (s.isText ? s = s.cut(Math.max(0, t - a), Math.min(s.text.length, n - a)) : s = s.cut(Math.max(0, t - a - 1), Math.min(s.content.size, n - a - 1))), r.push(s), i += s.nodeSize), a = l;
      }
    return new ve(r, i);
  }
  /**
  @internal
  */
  cutByIndex(t, n) {
    return t == n ? ve.empty : t == 0 && n == this.content.length ? this : new ve(this.content.slice(t, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, n) {
    let r = this.content[t];
    if (r == n)
      return this;
    let i = this.content.slice(), o = this.size + n.nodeSize - r.nodeSize;
    return i[t] = n, new ve(i, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new ve([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new ve(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(t.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let n = this.content[t];
    if (!n)
      throw new RangeError("Index " + t + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let i = this.content[n];
      t(i, r, n), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, n = 0) {
    return Ag(this, t, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, n = this.size, r = t.size) {
    return Pg(this, t, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. (Not public.)
  */
  findIndex(t, n = -1) {
    if (t == 0)
      return _s(0, t);
    if (t == this.size)
      return _s(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let r = 0, i = 0; ; r++) {
      let o = this.child(r), a = i + o.nodeSize;
      if (a >= t)
        return a == t || n > 0 ? _s(r + 1, a) : _s(r, i);
      i = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return ve.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new ve(n.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return ve.empty;
    let n, r = 0;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      r += o.nodeSize, i && o.isText && t[i - 1].sameMarkup(o) ? (n || (n = t.slice(0, i)), n[n.length - 1] = o.withText(n[n.length - 1].text + o.text)) : n && n.push(o);
    }
    return new ve(n || t, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return ve.empty;
    if (t instanceof ve)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new ve([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
ve.empty = new ve([], 0);
const bu = { index: 0, offset: 0 };
function _s(e, t) {
  return bu.index = e, bu.offset = t, bu;
}
function gl(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let n = Array.isArray(e);
  if (Array.isArray(t) != n)
    return !1;
  if (n) {
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!gl(e[r], t[r]))
        return !1;
  } else {
    for (let r in e)
      if (!(r in t) || !gl(e[r], t[r]))
        return !1;
    for (let r in t)
      if (!(r in e))
        return !1;
  }
  return !0;
}
let vt = class bc {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let n, r = !1;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      if (this.eq(o))
        return t;
      if (this.type.excludes(o.type))
        n || (n = t.slice(0, i));
      else {
        if (o.type.excludes(this.type))
          return t;
        !r && o.type.rank > this.type.rank && (n || (n = t.slice(0, i)), n.push(this), r = !0), n && n.push(o);
      }
    }
    return n || (n = t.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return t.slice(0, n).concat(t.slice(n + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && gl(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = t.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    return r.create(n.attrs);
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, n) {
    if (t == n)
      return !0;
    if (t.length != n.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!t[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return bc.none;
    if (t instanceof bc)
      return [t];
    let n = t.slice();
    return n.sort((r, i) => r.type.rank - i.type.rank), n;
  }
};
vt.none = [];
class vl extends Error {
}
class Ae {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, n, r) {
    this.content = t, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, n) {
    let r = Ig(this.content, t + this.openStart, n);
    return r && new Ae(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, n) {
    return new Ae(Ng(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return Ae.empty;
    let r = n.openStart || 0, i = n.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Ae(ve.fromJSON(t, n.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, n = !0) {
    let r = 0, i = 0;
    for (let o = t.firstChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.firstChild)
      r++;
    for (let o = t.lastChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.lastChild)
      i++;
    return new Ae(t, r, i);
  }
}
Ae.empty = new Ae(ve.empty, 0, 0);
function Ng(e, t, n) {
  let { index: r, offset: i } = e.findIndex(t), o = e.maybeChild(r), { index: a, offset: s } = e.findIndex(n);
  if (i == t || o.isText) {
    if (s != n && !e.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (r != a)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(r, o.copy(Ng(o.content, t - i - 1, n - i - 1)));
}
function Ig(e, t, n, r) {
  let { index: i, offset: o } = e.findIndex(t), a = e.maybeChild(i);
  if (o == t || a.isText)
    return e.cut(0, t).append(n).append(e.cut(t));
  let s = Ig(a.content, t - o - 1, n);
  return s && e.replaceChild(i, a.copy(s));
}
function TM(e, t, n) {
  if (n.openStart > e.depth)
    throw new vl("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != t.depth - n.openEnd)
    throw new vl("Inconsistent open depths");
  return Rg(e, t, n, 0);
}
function Rg(e, t, n, r) {
  let i = e.index(r), o = e.node(r);
  if (i == t.index(r) && r < e.depth - n.openStart) {
    let a = Rg(e, t, n, r + 1);
    return o.copy(o.content.replaceChild(i, a));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && e.depth == r && t.depth == r) {
      let a = e.parent, s = a.content;
      return ao(a, s.cut(0, e.parentOffset).append(n.content).append(s.cut(t.parentOffset)));
    } else {
      let { start: a, end: s } = MM(n, e);
      return ao(o, Lg(e, a, s, t, r));
    }
  else return ao(o, yl(e, t, r));
}
function _g(e, t) {
  if (!t.type.compatibleContent(e.type))
    throw new vl("Cannot join " + t.type.name + " onto " + e.type.name);
}
function $c(e, t, n) {
  let r = e.node(n);
  return _g(r, t.node(n)), r;
}
function oo(e, t) {
  let n = t.length - 1;
  n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function La(e, t, n, r) {
  let i = (t || e).node(n), o = 0, a = t ? t.index(n) : i.childCount;
  e && (o = e.index(n), e.depth > n ? o++ : e.textOffset && (oo(e.nodeAfter, r), o++));
  for (let s = o; s < a; s++)
    oo(i.child(s), r);
  t && t.depth == n && t.textOffset && oo(t.nodeBefore, r);
}
function ao(e, t) {
  return e.type.checkContent(t), e.copy(t);
}
function Lg(e, t, n, r, i) {
  let o = e.depth > i && $c(e, t, i + 1), a = r.depth > i && $c(n, r, i + 1), s = [];
  return La(null, e, i, s), o && a && t.index(i) == n.index(i) ? (_g(o, a), oo(ao(o, Lg(e, t, n, r, i + 1)), s)) : (o && oo(ao(o, yl(e, t, i + 1)), s), La(t, n, i, s), a && oo(ao(a, yl(n, r, i + 1)), s)), La(r, null, i, s), new ve(s);
}
function yl(e, t, n) {
  let r = [];
  if (La(null, e, n, r), e.depth > n) {
    let i = $c(e, t, n + 1);
    oo(ao(i, yl(e, t, n + 1)), r);
  }
  return La(t, null, n, r), new ve(r);
}
function MM(e, t) {
  let n = t.depth - e.openStart, i = t.node(n).copy(e.content);
  for (let o = n - 1; o >= 0; o--)
    i = t.node(o).copy(ve.from(i));
  return {
    start: i.resolveNoCache(e.openStart + n),
    end: i.resolveNoCache(i.content.size - e.openEnd - n)
  };
}
class Qa {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(t) {
    return t == null ? this.depth : t < 0 ? this.depth + t : t;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(t) {
    return this.path[this.resolveDepth(t) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(t) {
    return this.path[this.resolveDepth(t) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(t) {
    return t = this.resolveDepth(t), this.index(t) + (t == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(t) {
    return t = this.resolveDepth(t), t == 0 ? 0 : this.path[t * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(t) {
    return t = this.resolveDepth(t), this.start(t) + this.node(t).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position before the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position after the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1] + this.path[t * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let t = this.parent, n = this.index(this.depth);
    if (n == t.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = t.child(n);
    return r ? t.child(n).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let t = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(t).cut(0, n) : t == 0 ? null : this.parent.child(t - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(t, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], i = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let o = 0; o < t; o++)
      i += r.child(o).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let t = this.parent, n = this.index();
    if (t.content.size == 0)
      return vt.none;
    if (this.textOffset)
      return t.child(n).marks;
    let r = t.maybeChild(n - 1), i = t.maybeChild(n);
    if (!r) {
      let s = r;
      r = i, i = s;
    }
    let o = r.marks;
    for (var a = 0; a < o.length; a++)
      o[a].type.spec.inclusive === !1 && (!i || !o[a].isInSet(i.marks)) && (o = o[a--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(t) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, i = t.parent.maybeChild(t.index());
    for (var o = 0; o < r.length; o++)
      r[o].type.spec.inclusive === !1 && (!i || !r[o].isInSet(i.marks)) && (r = r[o--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(t) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= t && this.end(n) >= t)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(t = this, n) {
    if (t.pos < this.pos)
      return t.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == t.pos ? 1 : 0); r >= 0; r--)
      if (t.pos <= this.end(r) && (!n || n(this.node(r))))
        return new bl(this, t, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(t) {
    return this.pos - this.parentOffset == t.pos - t.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(t) {
    return t.pos > this.pos ? t : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(t) {
    return t.pos < this.pos ? t : this;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 1; n <= this.depth; n++)
      t += (t ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return t + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(t, n) {
    if (!(n >= 0 && n <= t.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], i = 0, o = n;
    for (let a = t; ; ) {
      let { index: s, offset: l } = a.content.findIndex(o), d = o - l;
      if (r.push(a, s, i + l), !d || (a = a.child(s), a.isText))
        break;
      o = d - 1, i += l + 1;
    }
    return new Qa(n, r, o);
  }
  /**
  @internal
  */
  static resolveCached(t, n) {
    for (let i = 0; i < $u.length; i++) {
      let o = $u[i];
      if (o.pos == n && o.doc == t)
        return o;
    }
    let r = $u[wu] = Qa.resolve(t, n);
    return wu = (wu + 1) % OM, r;
  }
}
let $u = [], wu = 0, OM = 12;
class bl {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const EM = /* @__PURE__ */ Object.create(null);
let so = class wc {
  /**
  @internal
  */
  constructor(t, n, r, i = vt.none) {
    this.type = t, this.attrs = n, this.marks = i, this.content = r || ve.empty;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(t) {
    return this.content.child(t);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content.maybeChild(t);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    this.content.forEach(t);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(t, n, r, i = 0) {
    this.content.nodesBetween(t, n, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(t) {
    this.nodesBetween(0, this.content.size, t);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(t, n, r, i) {
    return this.content.textBetween(t, n, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(t) {
    return this == t || this.sameMarkup(t) && this.content.eq(t.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(t) {
    return this.hasMarkup(t.type, t.attrs, t.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(t, n, r) {
    return this.type == t && gl(this.attrs, n || t.defaultAttrs || EM) && vt.sameSet(this.marks, r || vt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(t = null) {
    return t == this.content ? this : new wc(this.type, this.attrs, t, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(t) {
    return t == this.marks ? this : new wc(this.type, this.attrs, this.content, t);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(t, n = this.content.size) {
    return t == 0 && n == this.content.size ? this : this.copy(this.content.cut(t, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(t, n = this.content.size, r = !1) {
    if (t == n)
      return Ae.empty;
    let i = this.resolve(t), o = this.resolve(n), a = r ? 0 : i.sharedDepth(n), s = i.start(a), d = i.node(a).content.cut(i.pos - s, o.pos - s);
    return new Ae(d, i.depth - a, o.depth - a);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(t, n, r) {
    return TM(this.resolve(t), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(t) {
    for (let n = this; ; ) {
      let { index: r, offset: i } = n.content.findIndex(t);
      if (n = n.maybeChild(r), !n)
        return null;
      if (i == t || n.isText)
        return n;
      t -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(t) {
    let { index: n, offset: r } = this.content.findIndex(t);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(t) {
    if (t == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(t);
    if (r < t)
      return { node: this.content.child(n), index: n, offset: r };
    let i = this.content.child(n - 1);
    return { node: i, index: n - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(t) {
    return Qa.resolveCached(this, t);
  }
  /**
  @internal
  */
  resolveNoCache(t) {
    return Qa.resolve(this, t);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(t, n, r) {
    let i = !1;
    return n > t && this.nodesBetween(t, n, (o) => (r.isInSet(o.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let t = this.type.name;
    return this.content.size && (t += "(" + this.content.toStringInner() + ")"), Fg(this.marks, t);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(t) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, t);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(t, n, r = ve.empty, i = 0, o = r.childCount) {
    let a = this.contentMatchAt(t).matchFragment(r, i, o), s = a && a.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let l = i; l < o; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(t, n, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let o = this.contentMatchAt(t).matchType(r), a = o && o.matchFragment(this.content, n);
    return a ? a.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(t) {
    return t.content.size ? this.canReplace(this.childCount, this.childCount, t.content) : this.type.compatibleContent(t.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise error when they do not.
  */
  check() {
    this.type.checkContent(this.content);
    let t = vt.none;
    for (let n = 0; n < this.marks.length; n++)
      t = this.marks[n].addToSet(t);
    if (!vt.sameSet(t, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return this.content.size && (t.content = this.content.toJSON()), this.marks.length && (t.marks = this.marks.map((n) => n.toJSON())), t;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r = null;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(t.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return t.text(n.text, r);
    }
    let i = ve.fromJSON(t, n.content);
    return t.nodeType(n.type).create(n.attrs, i, r);
  }
};
so.prototype.text = void 0;
class $l extends so {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    if (super(t, n, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Fg(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(t, n) {
    return this.text.slice(t, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(t) {
    return t == this.marks ? this : new $l(this.type, this.attrs, this.text, t);
  }
  withText(t) {
    return t == this.text ? this : new $l(this.type, this.attrs, t, this.marks);
  }
  cut(t = 0, n = this.text.length) {
    return t == 0 && n == this.text.length ? this : this.withText(this.text.slice(t, n));
  }
  eq(t) {
    return this.sameMarkup(t) && this.text == t.text;
  }
  toJSON() {
    let t = super.toJSON();
    return t.text = this.text, t;
  }
}
function Fg(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    t = e[n].type.name + "(" + t + ")";
  return t;
}
class mo {
  /**
  @internal
  */
  constructor(t) {
    this.validEnd = t, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(t, n) {
    let r = new DM(t, n);
    if (r.next == null)
      return mo.empty;
    let i = Bg(r);
    r.next && r.err("Unexpected trailing text");
    let o = LM(_M(i));
    return FM(o, r), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(t) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == t)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(t, n = 0, r = t.childCount) {
    let i = this;
    for (let o = n; i && o < r; o++)
      i = i.matchType(t.child(o).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let t = 0; t < this.next.length; t++) {
      let { type: n } = this.next[t];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(t) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < t.next.length; r++)
        if (this.next[n].type == t.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(t, n = !1, r = 0) {
    let i = [this];
    function o(a, s) {
      let l = a.matchFragment(t, r);
      if (l && (!n || l.validEnd))
        return ve.from(s.map((d) => d.createAndFill()));
      for (let d = 0; d < a.next.length; d++) {
        let { type: u, next: c } = a.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && i.indexOf(c) == -1) {
          i.push(c);
          let f = o(c, s.concat(u));
          if (f)
            return f;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(t) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == t)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(t);
    return this.wrapCache.push(t, n), n;
  }
  /**
  @internal
  */
  computeWrapping(t) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), o = i.match;
      if (o.matchType(t)) {
        let a = [];
        for (let s = i; s.type; s = s.via)
          a.push(s.type);
        return a.reverse();
      }
      for (let a = 0; a < o.next.length; a++) {
        let { type: s, next: l } = o.next[a];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!i.type || l.validEnd) && (r.push({ match: s.contentMatch, type: s, via: i }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(t) {
    if (t >= this.next.length)
      throw new RangeError(`There's no ${t}th edge in this content match`);
    return this.next[t];
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    function n(r) {
      t.push(r);
      for (let i = 0; i < r.next.length; i++)
        t.indexOf(r.next[i].next) == -1 && n(r.next[i].next);
    }
    return n(this), t.map((r, i) => {
      let o = i + (r.validEnd ? "*" : " ") + " ";
      for (let a = 0; a < r.next.length; a++)
        o += (a ? ", " : "") + r.next[a].type.name + "->" + t.indexOf(r.next[a].next);
      return o;
    }).join(`
`);
  }
}
mo.empty = new mo(!0);
class DM {
  constructor(t, n) {
    this.string = t, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = t.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(t) {
    return this.next == t && (this.pos++ || !0);
  }
  err(t) {
    throw new SyntaxError(t + " (in content expression '" + this.string + "')");
  }
}
function Bg(e) {
  let t = [];
  do
    t.push(AM(e));
  while (e.eat("|"));
  return t.length == 1 ? t[0] : { type: "choice", exprs: t };
}
function AM(e) {
  let t = [];
  do
    t.push(PM(e));
  while (e.next && e.next != ")" && e.next != "|");
  return t.length == 1 ? t[0] : { type: "seq", exprs: t };
}
function PM(e) {
  let t = RM(e);
  for (; ; )
    if (e.eat("+"))
      t = { type: "plus", expr: t };
    else if (e.eat("*"))
      t = { type: "star", expr: t };
    else if (e.eat("?"))
      t = { type: "opt", expr: t };
    else if (e.eat("{"))
      t = NM(e, t);
    else
      break;
  return t;
}
function Mh(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let t = Number(e.next);
  return e.pos++, t;
}
function NM(e, t) {
  let n = Mh(e), r = n;
  return e.eat(",") && (e.next != "}" ? r = Mh(e) : r = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: t };
}
function IM(e, t) {
  let n = e.nodeTypes, r = n[t];
  if (r)
    return [r];
  let i = [];
  for (let o in n) {
    let a = n[o];
    a.groups.indexOf(t) > -1 && i.push(a);
  }
  return i.length == 0 && e.err("No node type or group '" + t + "' found"), i;
}
function RM(e) {
  if (e.eat("(")) {
    let t = Bg(e);
    return e.eat(")") || e.err("Missing closing paren"), t;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let t = IM(e, e.next).map((n) => (e.inline == null ? e.inline = n.isInline : e.inline != n.isInline && e.err("Mixing inline and block content"), { type: "name", value: n }));
    return e.pos++, t.length == 1 ? t[0] : { type: "choice", exprs: t };
  }
}
function _M(e) {
  let t = [[]];
  return i(o(e, 0), n()), t;
  function n() {
    return t.push([]) - 1;
  }
  function r(a, s, l) {
    let d = { term: l, to: s };
    return t[a].push(d), d;
  }
  function i(a, s) {
    a.forEach((l) => l.to = s);
  }
  function o(a, s) {
    if (a.type == "choice")
      return a.exprs.reduce((l, d) => l.concat(o(d, s)), []);
    if (a.type == "seq")
      for (let l = 0; ; l++) {
        let d = o(a.exprs[l], s);
        if (l == a.exprs.length - 1)
          return d;
        i(d, s = n());
      }
    else if (a.type == "star") {
      let l = n();
      return r(s, l), i(o(a.expr, l), l), [r(l)];
    } else if (a.type == "plus") {
      let l = n();
      return i(o(a.expr, s), l), i(o(a.expr, l), l), [r(l)];
    } else {
      if (a.type == "opt")
        return [r(s)].concat(o(a.expr, s));
      if (a.type == "range") {
        let l = s;
        for (let d = 0; d < a.min; d++) {
          let u = n();
          i(o(a.expr, l), u), l = u;
        }
        if (a.max == -1)
          i(o(a.expr, l), l);
        else
          for (let d = a.min; d < a.max; d++) {
            let u = n();
            r(l, u), i(o(a.expr, l), u), l = u;
          }
        return [r(l)];
      } else {
        if (a.type == "name")
          return [r(s, void 0, a.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function zg(e, t) {
  return t - e;
}
function Oh(e, t) {
  let n = [];
  return r(t), n.sort(zg);
  function r(i) {
    let o = e[i];
    if (o.length == 1 && !o[0].term)
      return r(o[0].to);
    n.push(i);
    for (let a = 0; a < o.length; a++) {
      let { term: s, to: l } = o[a];
      !s && n.indexOf(l) == -1 && r(l);
    }
  }
}
function LM(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return n(Oh(e, 0));
  function n(r) {
    let i = [];
    r.forEach((a) => {
      e[a].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let d;
        for (let u = 0; u < i.length; u++)
          i[u][0] == s && (d = i[u][1]);
        Oh(e, l).forEach((u) => {
          d || i.push([s, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let o = t[r.join(",")] = new mo(r.indexOf(e.length - 1) > -1);
    for (let a = 0; a < i.length; a++) {
      let s = i[a][1].sort(zg);
      o.next.push({ type: i[a][0], next: t[s.join(",")] || n(s) });
    }
    return o;
  }
}
function FM(e, t) {
  for (let n = 0, r = [e]; n < r.length; n++) {
    let i = r[n], o = !i.validEnd, a = [];
    for (let s = 0; s < i.next.length; s++) {
      let { type: l, next: d } = i.next[s];
      a.push(l.name), o && !(l.isText || l.hasRequiredAttrs()) && (o = !1), r.indexOf(d) == -1 && r.push(d);
    }
    o && t.err("Only non-generatable nodes (" + a.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Vg(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let r = e[n];
    if (!r.hasDefault)
      return null;
    t[n] = r.default;
  }
  return t;
}
function Hg(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let i = t && t[r];
    if (i === void 0) {
      let o = e[r];
      if (o.hasDefault)
        i = o.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = i;
  }
  return n;
}
function jg(e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let n in e)
      t[n] = new BM(e[n]);
  return t;
}
let Eh = class Wg {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.name = t, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = jg(r.attrs), this.defaultAttrs = Vg(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || t == "text"), this.isText = t == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == mo.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let t in this.attrs)
      if (this.attrs[t].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(t) {
    return this == t || this.contentMatch.compatible(t.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(t) {
    return !t && this.defaultAttrs ? this.defaultAttrs : Hg(this.attrs, t);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(t = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new so(this, this.computeAttrs(t), ve.from(n), vt.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(t = null, n, r) {
    return n = ve.from(n), this.checkContent(n), new so(this, this.computeAttrs(t), n, vt.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(t = null, n, r) {
    if (t = this.computeAttrs(t), n = ve.from(n), n.size) {
      let a = this.contentMatch.fillBefore(n);
      if (!a)
        return null;
      n = a.append(n);
    }
    let i = this.contentMatch.matchFragment(n), o = i && i.fillBefore(ve.empty, !0);
    return o ? new so(this, t, n.append(o), vt.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type with the given attributes.
  */
  validContent(t) {
    let n = this.contentMatch.matchFragment(t);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < t.childCount; r++)
      if (!this.allowsMarks(t.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(t) {
    if (!this.validContent(t))
      throw new RangeError(`Invalid content for node ${this.name}: ${t.toString().slice(0, 50)}`);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(t) {
    return this.markSet == null || this.markSet.indexOf(t) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(t) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < t.length; n++)
      if (!this.allowsMarkType(t[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(t) {
    if (this.markSet == null)
      return t;
    let n;
    for (let r = 0; r < t.length; r++)
      this.allowsMarkType(t[r].type) ? n && n.push(t[r]) : n || (n = t.slice(0, r));
    return n ? n.length ? n : vt.none : t;
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null);
    t.forEach((o, a) => r[o] = new Wg(o, n, a));
    let i = n.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
class BM {
  constructor(t) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(t, "default"), this.default = t.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Td {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.name = t, this.rank = n, this.schema = r, this.spec = i, this.attrs = jg(i.attrs), this.excluded = null;
    let o = Vg(this.attrs);
    this.instance = o ? new vt(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new vt(this, Hg(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return t.forEach((o, a) => r[o] = new Td(o, i++, n, a)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var n = 0; n < t.length; n++)
      t[n].type == this && (t = t.slice(0, n).concat(t.slice(n + 1)), n--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (t[n].type == this)
        return t[n];
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
class zM {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(t) {
    this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let i in t)
      n[i] = t[i];
    n.nodes = dn.from(t.nodes), n.marks = dn.from(t.marks || {}), this.nodes = Eh.compile(this.spec.nodes, this), this.marks = Td.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let o = this.nodes[i], a = o.spec.content || "", s = o.spec.marks;
      o.contentMatch = r[a] || (r[a] = mo.parse(a, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.markSet = s == "_" ? null : s ? Dh(this, s.split(" ")) : s == "" || !o.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let o = this.marks[i], a = o.spec.excludes;
      o.excluded = a == null ? [o] : a == "" ? [] : Dh(this, a.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(t, n = null, r, i) {
    if (typeof t == "string")
      t = this.nodeType(t);
    else if (t instanceof Eh) {
      if (t.schema != this)
        throw new RangeError("Node type from different schema used (" + t.name + ")");
    } else throw new RangeError("Invalid node type: " + t);
    return t.createChecked(n, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(t, n) {
    let r = this.nodes.text;
    return new $l(r, r.defaultAttrs, t, vt.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(t, n) {
    return typeof t == "string" && (t = this.marks[t]), t.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(t) {
    return so.fromJSON(this, t);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(t) {
    return vt.fromJSON(this, t);
  }
  /**
  @internal
  */
  nodeType(t) {
    let n = this.nodes[t];
    if (!n)
      throw new RangeError("Unknown node type: " + t);
    return n;
  }
}
function Dh(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let i = t[r], o = e.marks[i], a = o;
    if (o)
      n.push(o);
    else
      for (let s in e.marks) {
        let l = e.marks[s];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && n.push(a = l);
      }
    if (!a)
      throw new SyntaxError("Unknown mark type: '" + t[r] + "'");
  }
  return n;
}
class oa {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, n) {
    this.schema = t, this.rules = n, this.tags = [], this.styles = [], n.forEach((r) => {
      r.tag ? this.tags.push(r) : r.style && this.styles.push(r);
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let i = t.nodes[r.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, n = {}) {
    let r = new Ph(this, n, !1);
    return r.addAll(t, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, n = {}) {
    let r = new Ph(this, n, !0);
    return r.addAll(t, n.from, n.to), Ae.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(t, n, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let o = this.tags[i];
      if (jM(t, o.tag) && (o.namespace === void 0 || t.namespaceURI == o.namespace) && (!o.context || n.matchesContext(o.context))) {
        if (o.getAttrs) {
          let a = o.getAttrs(t);
          if (a === !1)
            continue;
          o.attrs = a || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, n, r, i) {
    for (let o = i ? this.styles.indexOf(i) + 1 : 0; o < this.styles.length; o++) {
      let a = this.styles[o], s = a.style;
      if (!(s.indexOf(t) != 0 || a.context && !r.matchesContext(a.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > t.length && (s.charCodeAt(t.length) != 61 || s.slice(t.length + 1) != n))) {
        if (a.getAttrs) {
          let l = a.getAttrs(n);
          if (l === !1)
            continue;
          a.attrs = l || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let n = [];
    function r(i) {
      let o = i.priority == null ? 50 : i.priority, a = 0;
      for (; a < n.length; a++) {
        let s = n[a];
        if ((s.priority == null ? 50 : s.priority) < o)
          break;
      }
      n.splice(a, 0, i);
    }
    for (let i in t.marks) {
      let o = t.marks[i].spec.parseDOM;
      o && o.forEach((a) => {
        r(a = Nh(a)), a.mark || a.ignore || a.clearMark || (a.mark = i);
      });
    }
    for (let i in t.nodes) {
      let o = t.nodes[i].spec.parseDOM;
      o && o.forEach((a) => {
        r(a = Nh(a)), a.node || a.ignore || a.mark || (a.node = i);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new oa(t, oa.schemaRules(t)));
  }
}
const Ug = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, VM = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, qg = { ol: !0, ul: !0 }, wl = 1, kl = 2, Fa = 4;
function Ah(e, t, n) {
  return t != null ? (t ? wl : 0) | (t === "full" ? kl : 0) : e && e.whitespace == "pre" ? wl | kl : n & ~Fa;
}
class Ls {
  constructor(t, n, r, i, o, a, s) {
    this.type = t, this.attrs = n, this.marks = r, this.pendingMarks = i, this.solid = o, this.options = s, this.content = [], this.activeMarks = vt.none, this.stashMarks = [], this.match = a || (s & Fa ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(ve.from(t));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(t.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & wl)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let o = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - i[0].length));
      }
    }
    let n = ve.from(this.content);
    return !t && this.match && (n = n.append(this.match.fillBefore(ve.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  popFromStashMark(t) {
    for (let n = this.stashMarks.length - 1; n >= 0; n--)
      if (t.eq(this.stashMarks[n]))
        return this.stashMarks.splice(n, 1)[0];
  }
  applyPending(t) {
    for (let n = 0, r = this.pendingMarks; n < r.length; n++) {
      let i = r[n];
      (this.type ? this.type.allowsMarkType(i.type) : UM(i.type, t)) && !i.isInSet(this.activeMarks) && (this.activeMarks = i.addToSet(this.activeMarks), this.pendingMarks = i.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !Ug.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
class Ph {
  constructor(t, n, r) {
    this.parser = t, this.options = n, this.isOpen = r, this.open = 0;
    let i = n.topNode, o, a = Ah(null, n.preserveWhitespace, 0) | (r ? Fa : 0);
    i ? o = new Ls(i.type, i.attrs, vt.none, vt.none, !0, n.topMatch || i.type.contentMatch, a) : r ? o = new Ls(null, null, vt.none, vt.none, !0, null, a) : o = new Ls(t.schema.topNodeType, null, vt.none, vt.none, !0, null, a), this.nodes = [o], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t) {
    t.nodeType == 3 ? this.addTextNode(t) : t.nodeType == 1 && this.addElement(t);
  }
  withStyleRules(t, n) {
    let r = t.getAttribute("style");
    if (!r)
      return n();
    let i = this.readStyles(WM(r));
    if (!i)
      return;
    let [o, a] = i, s = this.top;
    for (let l = 0; l < a.length; l++)
      this.removePendingMark(a[l], s);
    for (let l = 0; l < o.length; l++)
      this.addPendingMark(o[l]);
    n();
    for (let l = 0; l < o.length; l++)
      this.removePendingMark(o[l], s);
    for (let l = 0; l < a.length; l++)
      this.addPendingMark(a[l]);
  }
  addTextNode(t) {
    let n = t.nodeValue, r = this.top;
    if (r.options & kl || r.inlineContext(t) || /[^ \t\r\n\u000c]/.test(n)) {
      if (r.options & wl)
        r.options & kl ? n = n.replace(/\r\n?/g, `
`) : n = n.replace(/\r?\n|\r/g, " ");
      else if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
        let i = r.content[r.content.length - 1], o = t.previousSibling;
        (!i || o && o.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (n = n.slice(1));
      }
      n && this.insertNode(this.parser.schema.text(n)), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, n) {
    let r = t.nodeName.toLowerCase(), i;
    qg.hasOwnProperty(r) && this.parser.normalizeLists && HM(t);
    let o = this.options.ruleFromNode && this.options.ruleFromNode(t) || (i = this.parser.matchTag(t, this, n));
    if (o ? o.ignore : VM.hasOwnProperty(r))
      this.findInside(t), this.ignoreFallback(t);
    else if (!o || o.skip || o.closeParent) {
      o && o.closeParent ? this.open = Math.max(0, this.open - 1) : o && o.skip.nodeType && (t = o.skip);
      let a, s = this.top, l = this.needsBlock;
      if (Ug.hasOwnProperty(r))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), a = !0, s.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t);
        return;
      }
      o && o.skip ? this.addAll(t) : this.withStyleRules(t, () => this.addAll(t)), a && this.sync(s), this.needsBlock = l;
    } else
      this.withStyleRules(t, () => {
        this.addElementByRule(t, o, o.consuming === !1 ? i : void 0);
      });
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`));
  }
  // Called for ignored nodes
  ignoreFallback(t) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.
  readStyles(t) {
    let n = vt.none, r = vt.none;
    for (let i = 0; i < t.length; i += 2)
      for (let o = void 0; ; ) {
        let a = this.parser.matchStyle(t[i], t[i + 1], this, o);
        if (!a)
          break;
        if (a.ignore)
          return null;
        if (a.clearMark ? this.top.pendingMarks.concat(this.top.activeMarks).forEach((s) => {
          a.clearMark(s) && (r = s.addToSet(r));
        }) : n = this.parser.schema.marks[a.mark].create(a.attrs).addToSet(n), a.consuming === !1)
          o = a;
        else
          break;
      }
    return [n, r];
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, n, r) {
    let i, o, a;
    n.node ? (o = this.parser.schema.nodes[n.node], o.isLeaf ? this.insertNode(o.create(n.attrs)) || this.leafFallback(t) : i = this.enter(o, n.attrs || null, n.preserveWhitespace)) : (a = this.parser.schema.marks[n.mark].create(n.attrs), this.addPendingMark(a));
    let s = this.top;
    if (o && o.isLeaf)
      this.findInside(t);
    else if (r)
      this.addElement(t, r);
    else if (n.getContent)
      this.findInside(t), n.getContent(t, this.parser.schema).forEach((l) => this.insertNode(l));
    else {
      let l = t;
      typeof n.contentElement == "string" ? l = t.querySelector(n.contentElement) : typeof n.contentElement == "function" ? l = n.contentElement(t) : n.contentElement && (l = n.contentElement), this.findAround(t, l, !0), this.addAll(l);
    }
    i && this.sync(s) && this.open--, a && this.removePendingMark(a, s);
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, n, r) {
    let i = n || 0;
    for (let o = n ? t.childNodes[n] : t.firstChild, a = r == null ? null : t.childNodes[r]; o != a; o = o.nextSibling, ++i)
      this.findAtPoint(t, i), this.addDOM(o);
    this.findAtPoint(t, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t) {
    let n, r;
    for (let i = this.open; i >= 0; i--) {
      let o = this.nodes[i], a = o.findWrapping(t);
      if (a && (!n || n.length > a.length) && (n = a, r = o, !a.length) || o.solid)
        break;
    }
    if (!n)
      return !1;
    this.sync(r);
    for (let i = 0; i < n.length; i++)
      this.enterInner(n[i], null, !1);
    return !0;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let n = this.textblockFromContext();
      n && this.enterInner(n);
    }
    if (this.findPlace(t)) {
      this.closeExtra();
      let n = this.top;
      n.applyPending(t.type), n.match && (n.match = n.match.matchType(t.type));
      let r = n.activeMarks;
      for (let i = 0; i < t.marks.length; i++)
        (!n.type || n.type.allowsMarkType(t.marks[i].type)) && (r = t.marks[i].addToSet(r));
      return n.content.push(t.mark(r)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, n, r) {
    let i = this.findPlace(t.create(n));
    return i && this.enterInner(t, n, !0, r), i;
  }
  // Open a node of the given type
  enterInner(t, n = null, r = !1, i) {
    this.closeExtra();
    let o = this.top;
    o.applyPending(t), o.match = o.match && o.match.matchType(t);
    let a = Ah(t, i, o.options);
    o.options & Fa && o.content.length == 0 && (a |= Fa), this.nodes.push(new Ls(t, n, o.activeMarks, o.pendingMarks, r, null, a)), this.open++;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(t) {
    for (let n = this.open; n >= 0; n--)
      if (this.nodes[n] == t)
        return this.open = n, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let i = r.length - 1; i >= 0; i--)
        t += r[i].nodeSize;
      n && t++;
    }
    return t;
  }
  findAtPoint(t, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == t && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && t.nodeType == 1 && t.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(t, n, r) {
    if (t != n && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && t.nodeType == 1 && t.contains(this.find[i].node) && n.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && (this.find[n].pos = this.currentPos - (t.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = t.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), o = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), a = (s, l) => {
      for (; s >= 0; s--) {
        let d = n[s];
        if (d == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; l >= o; l--)
            if (a(s - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && i ? this.nodes[l].type : r && l >= o ? r.node(l - o).type : null;
          if (!u || u.name != d && u.groups.indexOf(d) == -1)
            return !1;
          l--;
        }
      }
      return !0;
    };
    return a(n.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let n = t.depth; n >= 0; n--) {
        let r = t.node(n).contentMatchAt(t.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
  addPendingMark(t) {
    let n = qM(t, this.top.pendingMarks);
    n && this.top.stashMarks.push(n), this.top.pendingMarks = t.addToSet(this.top.pendingMarks);
  }
  removePendingMark(t, n) {
    for (let r = this.open; r >= 0; r--) {
      let i = this.nodes[r];
      if (i.pendingMarks.lastIndexOf(t) > -1)
        i.pendingMarks = t.removeFromSet(i.pendingMarks);
      else {
        i.activeMarks = t.removeFromSet(i.activeMarks);
        let a = i.popFromStashMark(t);
        a && i.type && i.type.allowsMarkType(a.type) && (i.activeMarks = a.addToSet(i.activeMarks));
      }
      if (i == n)
        break;
    }
  }
}
function HM(e) {
  for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
    let r = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    r && qg.hasOwnProperty(r) && n ? (n.appendChild(t), t = n) : r == "li" ? n = t : r && (n = null);
  }
}
function jM(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function WM(e) {
  let t = /\s*([\w-]+)\s*:\s*([^;]+)/g, n, r = [];
  for (; n = t.exec(e); )
    r.push(n[1], n[2].trim());
  return r;
}
function Nh(e) {
  let t = {};
  for (let n in e)
    t[n] = e[n];
  return t;
}
function UM(e, t) {
  let n = t.schema.nodes;
  for (let r in n) {
    let i = n[r];
    if (!i.allowsMarkType(e))
      continue;
    let o = [], a = (s) => {
      o.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: d, next: u } = s.edge(l);
        if (d == t || o.indexOf(u) < 0 && a(u))
          return !0;
      }
    };
    if (a(i.contentMatch))
      return !0;
  }
}
function qM(e, t) {
  for (let n = 0; n < t.length; n++)
    if (e.eq(t[n]))
      return t[n];
}
class Nr {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, n) {
    this.nodes = t, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, n = {}, r) {
    r || (r = ku(n).createDocumentFragment());
    let i = r, o = [];
    return t.forEach((a) => {
      if (o.length || a.marks.length) {
        let s = 0, l = 0;
        for (; s < o.length && l < a.marks.length; ) {
          let d = a.marks[l];
          if (!this.marks[d.type.name]) {
            l++;
            continue;
          }
          if (!d.eq(o[s][0]) || d.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < o.length; )
          i = o.pop()[1];
        for (; l < a.marks.length; ) {
          let d = a.marks[l++], u = this.serializeMark(d, a.isInline, n);
          u && (o.push([d, i]), i.appendChild(u.dom), i = u.contentDOM || u.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(a, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(t, n) {
    let { dom: r, contentDOM: i } = Nr.renderSpec(ku(n), this.nodes[t.type.name](t));
    if (i) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, n, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, n = {}) {
    let r = this.serializeNodeInner(t, n);
    for (let i = t.marks.length - 1; i >= 0; i--) {
      let o = this.serializeMark(t.marks[i], t.isInline, n);
      o && ((o.contentDOM || o.dom).appendChild(r), r = o.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(t, n, r = {}) {
    let i = this.marks[t.type.name];
    return i && Nr.renderSpec(ku(r), i(t, n));
  }
  /**
  Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
  the spec has a hole (zero) in it, `contentDOM` will point at the
  node with the hole.
  */
  static renderSpec(t, n, r = null) {
    if (typeof n == "string")
      return { dom: t.createTextNode(n) };
    if (n.nodeType != null)
      return { dom: n };
    if (n.dom && n.dom.nodeType != null)
      return n;
    let i = n[0], o = i.indexOf(" ");
    o > 0 && (r = i.slice(0, o), i = i.slice(o + 1));
    let a, s = r ? t.createElementNS(r, i) : t.createElement(i), l = n[1], d = 1;
    if (l && typeof l == "object" && l.nodeType == null && !Array.isArray(l)) {
      d = 2;
      for (let u in l)
        if (l[u] != null) {
          let c = u.indexOf(" ");
          c > 0 ? s.setAttributeNS(u.slice(0, c), u.slice(c + 1), l[u]) : s.setAttribute(u, l[u]);
        }
    }
    for (let u = d; u < n.length; u++) {
      let c = n[u];
      if (c === 0) {
        if (u < n.length - 1 || u > d)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: s, contentDOM: s };
      } else {
        let { dom: f, contentDOM: h } = Nr.renderSpec(t, c, r);
        if (s.appendChild(f), h) {
          if (a)
            throw new RangeError("Multiple content holes");
          a = h;
        }
      }
    }
    return { dom: s, contentDOM: a };
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new Nr(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let n = Ih(t.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return Ih(t.marks);
  }
}
function Ih(e) {
  let t = {};
  for (let n in e) {
    let r = e[n].spec.toDOM;
    r && (t[n] = r);
  }
  return t;
}
function ku(e) {
  return e.document || window.document;
}
const Yg = 65535, Kg = Math.pow(2, 16);
function YM(e, t) {
  return e + t * Kg;
}
function Rh(e) {
  return e & Yg;
}
function KM(e) {
  return (e - (e & Yg)) / Kg;
}
const Gg = 1, Jg = 2, Gs = 4, Xg = 8;
class kc {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Xg) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Gg | Gs)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Jg | Gs)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Gs) > 0;
  }
}
class In {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, n = !1) {
    if (this.ranges = t, this.inverted = n, !t.length && In.empty)
      return In.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let n = 0, r = Rh(t);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        n += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + n + KM(t);
  }
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  map(t, n = 1) {
    return this._map(t, n, !0);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let i = 0, o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? i : 0);
      if (l > t)
        break;
      let d = this.ranges[s + o], u = this.ranges[s + a], c = l + d;
      if (t <= c) {
        let f = d ? t == l ? -1 : t == c ? 1 : n : n, h = l + i + (f < 0 ? 0 : u);
        if (r)
          return h;
        let p = t == (n < 0 ? l : c) ? null : YM(s / 3, t - l), m = t == l ? Jg : t == c ? Gg : Gs;
        return (n < 0 ? t != l : t != c) && (m |= Xg), new kc(h, m, p);
      }
      i += u - d;
    }
    return r ? t + i : new kc(t + i, 0, null);
  }
  /**
  @internal
  */
  touches(t, n) {
    let r = 0, i = Rh(n), o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > t)
        break;
      let d = this.ranges[s + o], u = l + d;
      if (t <= u && s == i * 3)
        return !0;
      r += this.ranges[s + a] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, o = 0; i < this.ranges.length; i += 3) {
      let a = this.ranges[i], s = a - (this.inverted ? o : 0), l = a + (this.inverted ? 0 : o), d = this.ranges[i + n], u = this.ranges[i + r];
      t(s, s + d, l, l + u), o += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new In(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? In.empty : new In(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
In.empty = new In([]);
class Wo {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t = [], n, r = 0, i = t.length) {
    this.maps = t, this.mirror = n, this.from = r, this.to = i;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, n = this.maps.length) {
    return new Wo(this.maps, this.mirror, t, n);
  }
  /**
  @internal
  */
  copy() {
    return new Wo(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, n) {
    this.to = this.maps.push(t), n != null && this.setMirror(this.maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let n = 0, r = this.maps.length; n < t.maps.length; n++) {
      let i = t.getMirror(n);
      this.appendMap(t.maps[n], i != null && i < n ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == t)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, n) {
    this.mirror || (this.mirror = []), this.mirror.push(t, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let n = t.maps.length - 1, r = this.maps.length + t.maps.length; n >= 0; n--) {
      let i = t.getMirror(n);
      this.appendMap(t.maps[n].invert(), i != null && i > n ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new Wo();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, n = 1) {
    if (this.mirror)
      return this._map(t, n, !0);
    for (let r = this.from; r < this.to; r++)
      t = this.maps[r].map(t, n);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let i = 0;
    for (let o = this.from; o < this.to; o++) {
      let a = this.maps[o], s = a.mapResult(t, n);
      if (s.recover != null) {
        let l = this.getMirror(o);
        if (l != null && l > o && l < this.to) {
          o = l, t = this.maps[l].recover(s.recover);
          continue;
        }
      }
      i |= s.delInfo, t = s.pos;
    }
    return r ? t : new kc(t, i, null);
  }
}
const xu = /* @__PURE__ */ Object.create(null);
class mn {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return In.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = xu[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, n) {
    if (t in xu)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return xu[t] = n, n.prototype.jsonID = t, n;
  }
}
class Ut {
  /**
  @internal
  */
  constructor(t, n) {
    this.doc = t, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new Ut(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new Ut(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, n, r, i) {
    try {
      return Ut.ok(t.replace(n, r, i));
    } catch (o) {
      if (o instanceof vl)
        return Ut.fail(o.message);
      throw o;
    }
  }
}
function uf(e, t, n) {
  let r = [];
  for (let i = 0; i < e.childCount; i++) {
    let o = e.child(i);
    o.content.size && (o = o.copy(uf(o.content, t, o))), o.isInline && (o = t(o, n, i)), r.push(o);
  }
  return ve.fromArray(r);
}
class Ti extends mn {
  /**
  Create a mark step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = t.resolve(this.from), i = r.node(r.sharedDepth(this.to)), o = new Ae(uf(n.content, (a, s) => !a.isAtom || !s.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), i), n.openStart, n.openEnd);
    return Ut.fromReplace(t, this.from, this.to, o);
  }
  invert() {
    return new Ir(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Ti(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof Ti && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Ti(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Ti(n.from, n.to, t.markFromJSON(n.mark));
  }
}
mn.jsonID("addMark", Ti);
class Ir extends mn {
  /**
  Create a mark-removing step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = new Ae(uf(n.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), t), n.openStart, n.openEnd);
    return Ut.fromReplace(t, this.from, this.to, r);
  }
  invert() {
    return new Ti(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Ir(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof Ir && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Ir(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Ir(n.from, n.to, t.markFromJSON(n.mark));
  }
}
mn.jsonID("removeMark", Ir);
class Mi extends mn {
  /**
  Create a node mark step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return Ut.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return Ut.fromReplace(t, this.pos, this.pos + 1, new Ae(ve.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let i = 0; i < n.marks.length; i++)
          if (!n.marks[i].isInSet(r))
            return new Mi(this.pos, n.marks[i]);
        return new Mi(this.pos, this.mark);
      }
    }
    return new aa(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Mi(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Mi(n.pos, t.markFromJSON(n.mark));
  }
}
mn.jsonID("addNodeMark", Mi);
class aa extends mn {
  /**
  Create a mark-removing step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return Ut.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return Ut.fromReplace(t, this.pos, this.pos + 1, new Ae(ve.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Mi(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new aa(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new aa(n.pos, t.markFromJSON(n.mark));
  }
}
mn.jsonID("removeNodeMark", aa);
class en extends mn {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, n, r, i = !1) {
    super(), this.from = t, this.to = n, this.slice = r, this.structure = i;
  }
  apply(t) {
    return this.structure && xc(t, this.from, this.to) ? Ut.fail("Structure replace would overwrite content") : Ut.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new In([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new en(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new en(n.pos, Math.max(n.pos, r.pos), this.slice);
  }
  merge(t) {
    if (!(t instanceof en) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let n = this.slice.size + t.slice.size == 0 ? Ae.empty : new Ae(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new en(this.from, this.to + (t.to - t.from), n, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let n = this.slice.size + t.slice.size == 0 ? Ae.empty : new Ae(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new en(t.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new en(n.from, n.to, Ae.fromJSON(t, n.slice), !!n.structure);
  }
}
mn.jsonID("replace", en);
class rn extends mn {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, n, r, i, o, a, s = !1) {
    super(), this.from = t, this.to = n, this.gapFrom = r, this.gapTo = i, this.slice = o, this.insert = a, this.structure = s;
  }
  apply(t) {
    if (this.structure && (xc(t, this.from, this.gapFrom) || xc(t, this.gapTo, this.to)))
      return Ut.fail("Structure gap-replace would overwrite content");
    let n = t.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return Ut.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? Ut.fromReplace(t, this.from, this.to, r) : Ut.fail("Content does not fit in gap");
  }
  getMap() {
    return new In([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let n = this.gapTo - this.gapFrom;
    return new rn(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1), i = t.map(this.gapFrom, -1), o = t.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || i < n.pos || o > r.pos ? null : new rn(n.pos, r.pos, i, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new rn(n.from, n.to, n.gapFrom, n.gapTo, Ae.fromJSON(t, n.slice), n.insert, !!n.structure);
  }
}
mn.jsonID("replaceAround", rn);
function xc(e, t, n) {
  let r = e.resolve(t), i = n - t, o = r.depth;
  for (; i > 0 && o > 0 && r.indexAfter(o) == r.node(o).childCount; )
    o--, i--;
  if (i > 0) {
    let a = r.node(o).maybeChild(r.indexAfter(o));
    for (; i > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, i--;
    }
  }
  return !1;
}
function GM(e, t, n, r) {
  let i = [], o = [], a, s;
  e.doc.nodesBetween(t, n, (l, d, u) => {
    if (!l.isInline)
      return;
    let c = l.marks;
    if (!r.isInSet(c) && u.type.allowsMarkType(r.type)) {
      let f = Math.max(d, t), h = Math.min(d + l.nodeSize, n), p = r.addToSet(c);
      for (let m = 0; m < c.length; m++)
        c[m].isInSet(p) || (a && a.to == f && a.mark.eq(c[m]) ? a.to = h : i.push(a = new Ir(f, h, c[m])));
      s && s.to == f ? s.to = h : o.push(s = new Ti(f, h, r));
    }
  }), i.forEach((l) => e.step(l)), o.forEach((l) => e.step(l));
}
function JM(e, t, n, r) {
  let i = [], o = 0;
  e.doc.nodesBetween(t, n, (a, s) => {
    if (!a.isInline)
      return;
    o++;
    let l = null;
    if (r instanceof Td) {
      let d = a.marks, u;
      for (; u = r.isInSet(d); )
        (l || (l = [])).push(u), d = u.removeFromSet(d);
    } else r ? r.isInSet(a.marks) && (l = [r]) : l = a.marks;
    if (l && l.length) {
      let d = Math.min(s + a.nodeSize, n);
      for (let u = 0; u < l.length; u++) {
        let c = l[u], f;
        for (let h = 0; h < i.length; h++) {
          let p = i[h];
          p.step == o - 1 && c.eq(i[h].style) && (f = p);
        }
        f ? (f.to = d, f.step = o) : i.push({ style: c, from: Math.max(s, t), to: d, step: o });
      }
    }
  }), i.forEach((a) => e.step(new Ir(a.from, a.to, a.style)));
}
function XM(e, t, n, r = n.contentMatch) {
  let i = e.doc.nodeAt(t), o = [], a = t + 1;
  for (let s = 0; s < i.childCount; s++) {
    let l = i.child(s), d = a + l.nodeSize, u = r.matchType(l.type);
    if (!u)
      o.push(new en(a, d, Ae.empty));
    else {
      r = u;
      for (let c = 0; c < l.marks.length; c++)
        n.allowsMarkType(l.marks[c].type) || e.step(new Ir(a, d, l.marks[c]));
      if (l.isText && !n.spec.code) {
        let c, f = /\r?\n|\r/g, h;
        for (; c = f.exec(l.text); )
          h || (h = new Ae(ve.from(n.schema.text(" ", n.allowedMarks(l.marks))), 0, 0)), o.push(new en(a + c.index, a + c.index + c[0].length, h));
      }
    }
    a = d;
  }
  if (!r.validEnd) {
    let s = r.fillBefore(ve.empty, !0);
    e.replace(a, a, new Ae(s, 0, 0));
  }
  for (let s = o.length - 1; s >= 0; s--)
    e.step(o[s]);
}
function QM(e, t, n) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function ha(e) {
  let n = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let r = e.depth; ; --r) {
    let i = e.$from.node(r), o = e.$from.index(r), a = e.$to.indexAfter(r);
    if (r < e.depth && i.canReplace(o, a, n))
      return r;
    if (r == 0 || i.type.spec.isolating || !QM(i, o, a))
      break;
  }
  return null;
}
function ZM(e, t, n) {
  let { $from: r, $to: i, depth: o } = t, a = r.before(o + 1), s = i.after(o + 1), l = a, d = s, u = ve.empty, c = 0;
  for (let p = o, m = !1; p > n; p--)
    m || r.index(p) > 0 ? (m = !0, u = ve.from(r.node(p).copy(u)), c++) : l--;
  let f = ve.empty, h = 0;
  for (let p = o, m = !1; p > n; p--)
    m || i.after(p + 1) < i.end(p) ? (m = !0, f = ve.from(i.node(p).copy(f)), h++) : d++;
  e.step(new rn(l, d, a, s, new Ae(u.append(f), c, h), u.size - c, !0));
}
function cf(e, t, n = null, r = e) {
  let i = eO(e, t), o = i && tO(r, t);
  return o ? i.map(_h).concat({ type: t, attrs: n }).concat(o.map(_h)) : null;
}
function _h(e) {
  return { type: e, attrs: null };
}
function eO(e, t) {
  let { parent: n, startIndex: r, endIndex: i } = e, o = n.contentMatchAt(r).findWrapping(t);
  if (!o)
    return null;
  let a = o.length ? o[0] : t;
  return n.canReplaceWith(r, i, a) ? o : null;
}
function tO(e, t) {
  let { parent: n, startIndex: r, endIndex: i } = e, o = n.child(r), a = t.contentMatch.findWrapping(o.type);
  if (!a)
    return null;
  let l = (a.length ? a[a.length - 1] : t).contentMatch;
  for (let d = r; l && d < i; d++)
    l = l.matchType(n.child(d).type);
  return !l || !l.validEnd ? null : a;
}
function nO(e, t, n) {
  let r = ve.empty;
  for (let a = n.length - 1; a >= 0; a--) {
    if (r.size) {
      let s = n[a].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = ve.from(n[a].type.create(n[a].attrs, r));
  }
  let i = t.start, o = t.end;
  e.step(new rn(i, o, i, o, new Ae(r, 0, 0), n.length, !0));
}
function rO(e, t, n, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = e.steps.length;
  e.doc.nodesBetween(t, n, (a, s) => {
    if (a.isTextblock && !a.hasMarkup(r, i) && iO(e.doc, e.mapping.slice(o).map(s), r)) {
      e.clearIncompatible(e.mapping.slice(o).map(s, 1), r);
      let l = e.mapping.slice(o), d = l.map(s, 1), u = l.map(s + a.nodeSize, 1);
      return e.step(new rn(d, u, d + 1, u - 1, new Ae(ve.from(r.create(i, null, a.marks)), 0, 0), 1, !0)), !1;
    }
  });
}
function iO(e, t, n) {
  let r = e.resolve(t), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, n);
}
function oO(e, t, n, r, i) {
  let o = e.doc.nodeAt(t);
  if (!o)
    throw new RangeError("No node at given position");
  n || (n = o.type);
  let a = n.create(r, null, i || o.marks);
  if (o.isLeaf)
    return e.replaceWith(t, t + o.nodeSize, a);
  if (!n.validContent(o.content))
    throw new RangeError("Invalid content for node type " + n.name);
  e.step(new rn(t, t + o.nodeSize, t + 1, t + o.nodeSize - 1, new Ae(ve.from(a), 0, 0), 1, !0));
}
function Uo(e, t, n = 1, r) {
  let i = e.resolve(t), o = i.depth - n, a = r && r[r.length - 1] || i.parent;
  if (o < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !a.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let d = i.depth - 1, u = n - 2; d > o; d--, u--) {
    let c = i.node(d), f = i.index(d);
    if (c.type.spec.isolating)
      return !1;
    let h = c.content.cutByIndex(f, c.childCount), p = r && r[u + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let m = r && r[u] || c;
    if (!c.canReplace(f + 1, c.childCount) || !m.type.validContent(h))
      return !1;
  }
  let s = i.indexAfter(o), l = r && r[0];
  return i.node(o).canReplaceWith(s, s, l ? l.type : i.node(o + 1).type);
}
function aO(e, t, n = 1, r) {
  let i = e.doc.resolve(t), o = ve.empty, a = ve.empty;
  for (let s = i.depth, l = i.depth - n, d = n - 1; s > l; s--, d--) {
    o = ve.from(i.node(s).copy(o));
    let u = r && r[d];
    a = ve.from(u ? u.type.create(u.attrs, a) : i.node(s).copy(a));
  }
  e.step(new en(t, t, new Ae(o.append(a), n, n), !0));
}
function zi(e, t) {
  let n = e.resolve(t), r = n.index();
  return Qg(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function Qg(e, t) {
  return !!(e && t && !e.isLeaf && e.canAppend(t));
}
function Md(e, t, n = -1) {
  let r = e.resolve(t);
  for (let i = r.depth; ; i--) {
    let o, a, s = r.index(i);
    if (i == r.depth ? (o = r.nodeBefore, a = r.nodeAfter) : n > 0 ? (o = r.node(i + 1), s++, a = r.node(i).maybeChild(s)) : (o = r.node(i).maybeChild(s - 1), a = r.node(i + 1)), o && !o.isTextblock && Qg(o, a) && r.node(i).canReplace(s, s + 1))
      return t;
    if (i == 0)
      break;
    t = n < 0 ? r.before(i) : r.after(i);
  }
}
function sO(e, t, n) {
  let r = new en(t - n, t + n, Ae.empty, !0);
  e.step(r);
}
function lO(e, t, n) {
  let r = e.resolve(t);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return t;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.index(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.before(i + 1);
      if (o > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.indexAfter(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.after(i + 1);
      if (o < r.node(i).childCount)
        return null;
    }
  return null;
}
function Zg(e, t, n) {
  let r = e.resolve(t);
  if (!n.content.size)
    return t;
  let i = n.content;
  for (let o = 0; o < n.openStart; o++)
    i = i.firstChild.content;
  for (let o = 1; o <= (n.openStart == 0 && n.size ? 2 : 1); o++)
    for (let a = r.depth; a >= 0; a--) {
      let s = a == r.depth ? 0 : r.pos <= (r.start(a + 1) + r.end(a + 1)) / 2 ? -1 : 1, l = r.index(a) + (s > 0 ? 1 : 0), d = r.node(a), u = !1;
      if (o == 1)
        u = d.canReplace(l, l, i);
      else {
        let c = d.contentMatchAt(l).findWrapping(i.firstChild.type);
        u = c && d.canReplaceWith(l, l, c[0]);
      }
      if (u)
        return s == 0 ? r.pos : s < 0 ? r.before(a + 1) : r.after(a + 1);
    }
  return null;
}
function Od(e, t, n = t, r = Ae.empty) {
  if (t == n && !r.size)
    return null;
  let i = e.resolve(t), o = e.resolve(n);
  return ev(i, o, r) ? new en(t, n, r) : new dO(i, o, r).fit();
}
function ev(e, t, n) {
  return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
class dO {
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = ve.empty;
    for (let i = 0; i <= t.depth; i++) {
      let o = t.node(i);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(t.indexAfter(i))
      });
    }
    for (let i = t.depth; i > 0; i--)
      this.placed = ve.from(t.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(t < 0 ? this.$to : r.doc.resolve(t));
    if (!i)
      return null;
    let o = this.placed, a = r.depth, s = i.depth;
    for (; a && s && o.childCount == 1; )
      o = o.firstChild.content, a--, s--;
    let l = new Ae(o, a, s);
    return t > -1 ? new rn(r.pos, t, this.$to.pos, this.$to.end(), l, n) : l.size || r.pos != this.$to.pos ? new en(r.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < t; r++) {
      let o = n.firstChild;
      if (n.childCount > 1 && (i = 0), o.type.spec.isolating && i <= r) {
        t = r;
        break;
      }
      n = o.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? t : this.unplaced.openStart; r >= 0; r--) {
        let i, o = null;
        r ? (o = Su(this.unplaced.content, r - 1).firstChild, i = o.content) : i = this.unplaced.content;
        let a = i.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: d } = this.frontier[s], u, c = null;
          if (n == 1 && (a ? d.matchType(a.type) || (c = d.fillBefore(ve.from(a), !1)) : o && l.compatibleContent(o.type)))
            return { sliceDepth: r, frontierDepth: s, parent: o, inject: c };
          if (n == 2 && a && (u = d.findWrapping(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: o, wrap: u };
          if (o && d.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, i = Su(t, n);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new Ae(t, n + 1, Math.max(r, i.size + n >= t.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, i = Su(t, n);
    if (i.childCount <= 1 && n > 0) {
      let o = t.size - n <= n + i.size;
      this.unplaced = new Ae(Ma(t, n - 1, 1), n - 1, o ? n - 1 : r);
    } else
      this.unplaced = new Ae(Ma(t, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: n, parent: r, inject: i, wrap: o }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (o)
      for (let m = 0; m < o.length; m++)
        this.openFrontierNode(o[m]);
    let a = this.unplaced, s = r ? r.content : a.content, l = a.openStart - t, d = 0, u = [], { match: c, type: f } = this.frontier[n];
    if (i) {
      for (let m = 0; m < i.childCount; m++)
        u.push(i.child(m));
      c = c.matchFragment(i);
    }
    let h = s.size + t - (a.content.size - a.openEnd);
    for (; d < s.childCount; ) {
      let m = s.child(d), g = c.matchType(m.type);
      if (!g)
        break;
      d++, (d > 1 || l == 0 || m.content.size) && (c = g, u.push(tv(m.mark(f.allowedMarks(m.marks)), d == 1 ? l : 0, d == s.childCount ? h : -1)));
    }
    let p = d == s.childCount;
    p || (h = -1), this.placed = Oa(this.placed, n, ve.from(u)), this.frontier[n].match = c, p && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, g = s; m < h; m++) {
      let v = g.lastChild;
      this.frontier.push({ type: v.type, match: v.contentMatchAt(v.childCount) }), g = v.content;
    }
    this.unplaced = p ? t == 0 ? Ae.empty : new Ae(Ma(a.content, t - 1, 1), t - 1, h < 0 ? a.openEnd : t - 1) : new Ae(Ma(a.content, t, d), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], n;
    if (!t.type.isTextblock || !Cu(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(t) {
    e: for (let n = Math.min(this.depth, t.depth); n >= 0; n--) {
      let { match: r, type: i } = this.frontier[n], o = n < t.depth && t.end(n + 1) == t.pos + (t.depth - (n + 1)), a = Cu(t, n, i, r, o);
      if (a) {
        for (let s = n - 1; s >= 0; s--) {
          let { match: l, type: d } = this.frontier[s], u = Cu(t, s, d, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: a, move: o ? t.doc.resolve(t.after(n + 1)) : t };
      }
    }
  }
  close(t) {
    let n = this.findCloseLevel(t);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Oa(this.placed, n.depth, n.fit)), t = n.move;
    for (let r = n.depth + 1; r <= t.depth; r++) {
      let i = t.node(r), o = i.type.contentMatch.fillBefore(i.content, !0, t.index(r));
      this.openFrontierNode(i.type, i.attrs, o);
    }
    return t;
  }
  openFrontierNode(t, n = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(t), this.placed = Oa(this.placed, this.depth, ve.from(t.create(n, r))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(ve.empty, !0);
    n.childCount && (this.placed = Oa(this.placed, this.frontier.length, n));
  }
}
function Ma(e, t, n) {
  return t == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(Ma(e.firstChild.content, t - 1, n)));
}
function Oa(e, t, n) {
  return t == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(Oa(e.lastChild.content, t - 1, n)));
}
function Su(e, t) {
  for (let n = 0; n < t; n++)
    e = e.firstChild.content;
  return e;
}
function tv(e, t, n) {
  if (t <= 0)
    return e;
  let r = e.content;
  return t > 1 && (r = r.replaceChild(0, tv(r.firstChild, t - 1, r.childCount == 1 ? n - 1 : 0))), t > 0 && (r = e.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(e.type.contentMatch.matchFragment(r).fillBefore(ve.empty, !0)))), e.copy(r);
}
function Cu(e, t, n, r, i) {
  let o = e.node(t), a = i ? e.indexAfter(t) : e.index(t);
  if (a == o.childCount && !n.compatibleContent(o.type))
    return null;
  let s = r.fillBefore(o.content, !0, a);
  return s && !uO(n, o.content, a) ? s : null;
}
function uO(e, t, n) {
  for (let r = n; r < t.childCount; r++)
    if (!e.allowsMarks(t.child(r).marks))
      return !0;
  return !1;
}
function cO(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function fO(e, t, n, r) {
  if (!r.size)
    return e.deleteRange(t, n);
  let i = e.doc.resolve(t), o = e.doc.resolve(n);
  if (ev(i, o, r))
    return e.step(new en(t, n, r));
  let a = rv(i, e.doc.resolve(n));
  a[a.length - 1] == 0 && a.pop();
  let s = -(i.depth + 1);
  a.unshift(s);
  for (let f = i.depth, h = i.pos - 1; f > 0; f--, h--) {
    let p = i.node(f).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    a.indexOf(f) > -1 ? s = f : i.before(f) == h && a.splice(1, 0, -f);
  }
  let l = a.indexOf(s), d = [], u = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let p = f.firstChild;
    if (d.push(p), h == r.openStart)
      break;
    f = p.content;
  }
  for (let f = u - 1; f >= 0; f--) {
    let h = d[f], p = cO(h.type);
    if (p && !h.sameMarkup(i.node(Math.abs(s) - 1)))
      u = f;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + u + 1) % (r.openStart + 1), p = d[h];
    if (p)
      for (let m = 0; m < a.length; m++) {
        let g = a[(m + l) % a.length], v = !0;
        g < 0 && (v = !1, g = -g);
        let b = i.node(g - 1), x = i.index(g - 1);
        if (b.canReplaceWith(x, x, p.type, p.marks))
          return e.replace(i.before(g), v ? o.after(g) : n, new Ae(nv(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let c = e.steps.length;
  for (let f = a.length - 1; f >= 0 && (e.replace(t, n, r), !(e.steps.length > c)); f--) {
    let h = a[f];
    h < 0 || (t = i.before(h), n = o.after(h));
  }
}
function nv(e, t, n, r, i) {
  if (t < n) {
    let o = e.firstChild;
    e = e.replaceChild(0, o.copy(nv(o.content, t + 1, n, r, o)));
  }
  if (t > r) {
    let o = i.contentMatchAt(0), a = o.fillBefore(e).append(e);
    e = a.append(o.matchFragment(a).fillBefore(ve.empty, !0));
  }
  return e;
}
function pO(e, t, n, r) {
  if (!r.isInline && t == n && e.doc.resolve(t).parent.content.size) {
    let i = lO(e.doc, t, r.type);
    i != null && (t = n = i);
  }
  e.replaceRange(t, n, new Ae(ve.from(r), 0, 0));
}
function hO(e, t, n) {
  let r = e.doc.resolve(t), i = e.doc.resolve(n), o = rv(r, i);
  for (let a = 0; a < o.length; a++) {
    let s = o[a], l = a == o.length - 1;
    if (l && s == 0 || r.node(s).type.contentMatch.validEnd)
      return e.delete(r.start(s), i.end(s));
    if (s > 0 && (l || r.node(s - 1).canReplace(r.index(s - 1), i.indexAfter(s - 1))))
      return e.delete(r.before(s), i.after(s));
  }
  for (let a = 1; a <= r.depth && a <= i.depth; a++)
    if (t - r.start(a) == r.depth - a && n > r.end(a) && i.end(a) - n != i.depth - a)
      return e.delete(r.before(a), n);
  e.delete(t, n);
}
function rv(e, t) {
  let n = [], r = Math.min(e.depth, t.depth);
  for (let i = r; i >= 0; i--) {
    let o = e.start(i);
    if (o < e.pos - (e.depth - i) || t.end(i) > t.pos + (t.depth - i) || e.node(i).type.spec.isolating || t.node(i).type.spec.isolating)
      break;
    (o == t.start(i) || i == e.depth && i == t.depth && e.parent.inlineContent && t.parent.inlineContent && i && t.start(i - 1) == o - 1) && n.push(i);
  }
  return n;
}
class qo extends mn {
  /**
  Construct an attribute step.
  */
  constructor(t, n, r) {
    super(), this.pos = t, this.attr = n, this.value = r;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return Ut.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in n.attrs)
      r[o] = n.attrs[o];
    r[this.attr] = this.value;
    let i = n.type.create(r, null, n.marks);
    return Ut.fromReplace(t, this.pos, this.pos + 1, new Ae(ve.from(i), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return In.empty;
  }
  invert(t) {
    return new qo(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new qo(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new qo(n.pos, n.attr, n.value);
  }
}
mn.jsonID("attr", qo);
class Za extends mn {
  /**
  Construct an attribute step.
  */
  constructor(t, n) {
    super(), this.attr = t, this.value = n;
  }
  apply(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in t.attrs)
      n[i] = t.attrs[i];
    n[this.attr] = this.value;
    let r = t.type.create(n, t.content, t.marks);
    return Ut.ok(r);
  }
  getMap() {
    return In.empty;
  }
  invert(t) {
    return new Za(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Za(n.attr, n.value);
  }
}
mn.jsonID("docAttr", Za);
let sa = class extends Error {
};
sa = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
};
sa.prototype = Object.create(Error.prototype);
sa.prototype.constructor = sa;
sa.prototype.name = "TransformError";
class iv {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new Wo();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let n = this.maybeStep(t);
    if (n.failed)
      throw new sa(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let n = t.apply(this.doc);
    return n.failed || this.addStep(t, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, n = t, r = Ae.empty) {
    let i = Od(this.doc, t, n, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, n, r) {
    return this.replace(t, n, new Ae(ve.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, n) {
    return this.replace(t, n, Ae.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, n) {
    return this.replaceWith(t, t, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, n, r) {
    return fO(this, t, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, n, r) {
    return pO(this, t, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, n) {
    return hO(this, t, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, n) {
    return ZM(this, t, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, n = 1) {
    return sO(this, t, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, n) {
    return nO(this, t, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, n = t, r, i = null) {
    return rO(this, t, n, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, n, r = null, i) {
    return oO(this, t, n, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(t, n, r) {
    return this.step(new qo(t, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(t, n) {
    return this.step(new Za(t, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, n) {
    return this.step(new Mi(t, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, n) {
    if (!(n instanceof vt)) {
      let r = this.doc.nodeAt(t);
      if (!r)
        throw new RangeError("No node at position " + t);
      if (n = n.isInSet(r.marks), !n)
        return this;
    }
    return this.step(new aa(t, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(t, n = 1, r) {
    return aO(this, t, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, n, r) {
    return GM(this, t, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, n, r) {
    return JM(this, t, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, n, r) {
    return XM(this, t, n, r), this;
  }
}
const Tu = /* @__PURE__ */ Object.create(null);
class rt {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, n, r) {
    this.$anchor = t, this.$head = n, this.ranges = r || [new mO(t.min(n), t.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let n = 0; n < t.length; n++)
      if (t[n].$from.pos != t[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, n = Ae.empty) {
    let r = n.content.lastChild, i = null;
    for (let s = 0; s < n.openEnd; s++)
      i = r, r = r.lastChild;
    let o = t.steps.length, a = this.ranges;
    for (let s = 0; s < a.length; s++) {
      let { $from: l, $to: d } = a[s], u = t.mapping.slice(o);
      t.replaceRange(u.map(l.pos), u.map(d.pos), s ? Ae.empty : n), s == 0 && Bh(t, o, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, n) {
    let r = t.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let { $from: a, $to: s } = i[o], l = t.mapping.slice(r), d = l.map(a.pos), u = l.map(s.pos);
      o ? t.deleteRange(d, u) : (t.replaceRangeWith(d, u, n), Bh(t, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, n, r = !1) {
    let i = t.parent.inlineContent ? new Xe(t) : Ro(t.node(0), t.parent, t.pos, t.index(), n, r);
    if (i)
      return i;
    for (let o = t.depth - 1; o >= 0; o--) {
      let a = n < 0 ? Ro(t.node(0), t.node(o), t.before(o + 1), t.index(o), n, r) : Ro(t.node(0), t.node(o), t.after(o + 1), t.index(o) + 1, n, r);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, n = 1) {
    return this.findFrom(t, n) || this.findFrom(t, -n) || new dr(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return Ro(t, t, 0, 0, 1) || new dr(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return Ro(t, t, t.content.size, t.childCount, -1) || new dr(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = Tu[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, n) {
    if (t in Tu)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return Tu[t] = n, n.prototype.jsonID = t, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Xe.between(this.$anchor, this.$head).getBookmark();
  }
}
rt.prototype.visible = !0;
class mO {
  /**
  Create a range.
  */
  constructor(t, n) {
    this.$from = t, this.$to = n;
  }
}
let Lh = !1;
function Fh(e) {
  !Lh && !e.parent.inlineContent && (Lh = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class Xe extends rt {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, n = t) {
    Fh(t), Fh(n), super(t, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return rt.near(r);
    let i = t.resolve(n.map(this.anchor));
    return new Xe(i.parent.inlineContent ? i : r, r);
  }
  replace(t, n = Ae.empty) {
    if (super.replace(t, n), n == Ae.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && t.ensureMarks(r);
    }
  }
  eq(t) {
    return t instanceof Xe && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new Ed(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Xe(t.resolve(n.anchor), t.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, n, r = n) {
    let i = t.resolve(n);
    return new this(i, r == n ? i : t.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, n, r) {
    let i = t.pos - n.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let o = rt.findFrom(n, r, !0) || rt.findFrom(n, -r, !0);
      if (o)
        n = o.$head;
      else
        return rt.near(n, r);
    }
    return t.parent.inlineContent || (i == 0 ? t = n : (t = (rt.findFrom(t, -r, !0) || rt.findFrom(t, r, !0)).$anchor, t.pos < n.pos != i < 0 && (t = n))), new Xe(t, n);
  }
}
rt.jsonID("text", Xe);
class Ed {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new Ed(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return Xe.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class He extends rt {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let n = t.nodeAfter, r = t.node(0).resolve(t.pos + n.nodeSize);
    super(t, r), this.node = n;
  }
  map(t, n) {
    let { deleted: r, pos: i } = n.mapResult(this.anchor), o = t.resolve(i);
    return r ? rt.near(o) : new He(o);
  }
  content() {
    return new Ae(ve.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof He && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new ff(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new He(t.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, n) {
    return new He(t.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
He.prototype.visible = !1;
rt.jsonID("node", He);
class ff {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: n, pos: r } = t.mapResult(this.anchor);
    return n ? new Ed(r, r) : new ff(r);
  }
  resolve(t) {
    let n = t.resolve(this.anchor), r = n.nodeAfter;
    return r && He.isSelectable(r) ? new He(n) : rt.near(n);
  }
}
class dr extends rt {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, n = Ae.empty) {
    if (n == Ae.empty) {
      t.delete(0, t.doc.content.size);
      let r = rt.atStart(t.doc);
      r.eq(t.selection) || t.setSelection(r);
    } else
      super.replace(t, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new dr(t);
  }
  map(t) {
    return new dr(t);
  }
  eq(t) {
    return t instanceof dr;
  }
  getBookmark() {
    return gO;
  }
}
rt.jsonID("all", dr);
const gO = {
  map() {
    return this;
  },
  resolve(e) {
    return new dr(e);
  }
};
function Ro(e, t, n, r, i, o = !1) {
  if (t.inlineContent)
    return Xe.create(e, n);
  for (let a = r - (i > 0 ? 0 : 1); i > 0 ? a < t.childCount : a >= 0; a += i) {
    let s = t.child(a);
    if (s.isAtom) {
      if (!o && He.isSelectable(s))
        return He.create(e, n - (i < 0 ? s.nodeSize : 0));
    } else {
      let l = Ro(e, s, n + i, i < 0 ? s.childCount : 0, i, o);
      if (l)
        return l;
    }
    n += s.nodeSize * i;
  }
  return null;
}
function Bh(e, t, n) {
  let r = e.steps.length - 1;
  if (r < t)
    return;
  let i = e.steps[r];
  if (!(i instanceof en || i instanceof rn))
    return;
  let o = e.mapping.maps[r], a;
  o.forEach((s, l, d, u) => {
    a == null && (a = u);
  }), e.setSelection(rt.near(e.doc.resolve(a), n));
}
const zh = 1, Fs = 2, Vh = 4;
class vO extends iv {
  /**
  @internal
  */
  constructor(t) {
    super(t.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = t.selection, this.storedMarks = t.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(t) {
    if (t.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = t, this.curSelectionFor = this.steps.length, this.updated = (this.updated | zh) & ~Fs, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & zh) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(t) {
    return this.storedMarks = t, this.updated |= Fs, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(t) {
    return vt.sameSet(this.storedMarks || this.selection.$from.marks(), t) || this.setStoredMarks(t), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(t) {
    return this.ensureMarks(t.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(t) {
    return this.ensureMarks(t.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Fs) > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    super.addStep(t, n), this.updated = this.updated & ~Fs, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(t) {
    return this.time = t, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(t) {
    return this.selection.replace(this, t), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(t, n = !0) {
    let r = this.selection;
    return n && (t = t.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || vt.none))), r.replaceWith(this, t), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(t, n, r) {
    let i = this.doc.type.schema;
    if (n == null)
      return t ? this.replaceSelectionWith(i.text(t), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), r = r == null ? n : r, !t)
        return this.deleteRange(n, r);
      let o = this.storedMarks;
      if (!o) {
        let a = this.doc.resolve(n);
        o = r == n ? a.marks() : a.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, i.text(t, o)), this.selection.empty || this.setSelection(rt.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(t, n) {
    return this.meta[typeof t == "string" ? t : t.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(t) {
    return this.meta[typeof t == "string" ? t : t.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let t in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Vh, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Vh) > 0;
  }
}
function Hh(e, t) {
  return !t || !e ? e : e.bind(t);
}
class Ea {
  constructor(t, n, r) {
    this.name = t, this.init = Hh(n.init, r), this.apply = Hh(n.apply, r);
  }
}
const yO = [
  new Ea("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Ea("selection", {
    init(e, t) {
      return e.selection || rt.atStart(t.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Ea("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, t, n, r) {
      return r.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Ea("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, t) {
      return e.scrolledIntoView ? t + 1 : t;
    }
  })
];
class Mu {
  constructor(t, n) {
    this.schema = t, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = yO.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Ea(r.key, r.spec.state, r));
    });
  }
}
class Vo {
  /**
  @internal
  */
  constructor(t) {
    this.config = t;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(t) {
    return this.applyTransaction(t).state;
  }
  /**
  @internal
  */
  filterTransaction(t, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, t, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(t) {
    if (!this.filterTransaction(t))
      return { state: this, transactions: [] };
    let n = [t], r = this.applyInner(t), i = null;
    for (; ; ) {
      let o = !1;
      for (let a = 0; a < this.config.plugins.length; a++) {
        let s = this.config.plugins[a];
        if (s.spec.appendTransaction) {
          let l = i ? i[a].n : 0, d = i ? i[a].state : this, u = l < n.length && s.spec.appendTransaction.call(s, l ? n.slice(l) : n, d, r);
          if (u && r.filterTransaction(u, a)) {
            if (u.setMeta("appendedTransaction", t), !i) {
              i = [];
              for (let c = 0; c < this.config.plugins.length; c++)
                i.push(c < a ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), r = r.applyInner(u), o = !0;
          }
          i && (i[a] = { state: r, n: n.length });
        }
      }
      if (!o)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(t) {
    if (!t.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new Vo(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let o = r[i];
      n[o.name] = o.apply(t, this[o.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new vO(this);
  }
  /**
  Create a new state.
  */
  static create(t) {
    let n = new Mu(t.doc ? t.doc.type.schema : t.schema, t.plugins), r = new Vo(n);
    for (let i = 0; i < n.fields.length; i++)
      r[n.fields[i].name] = n.fields[i].init(t, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(t) {
    let n = new Mu(this.schema, t.plugins), r = n.fields, i = new Vo(n);
    for (let o = 0; o < r.length; o++) {
      let a = r[o].name;
      i[a] = this.hasOwnProperty(a) ? this[a] : r[o].init(t, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(t) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), t && typeof t == "object")
      for (let r in t) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = t[r], o = i.spec.state;
        o && o.toJSON && (n[r] = o.toJSON.call(i, this[i.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(t, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!t.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new Mu(t.schema, t.plugins), o = new Vo(i);
    return i.fields.forEach((a) => {
      if (a.name == "doc")
        o.doc = so.fromJSON(t.schema, n.doc);
      else if (a.name == "selection")
        o.selection = rt.fromJSON(o.doc, n.selection);
      else if (a.name == "storedMarks")
        n.storedMarks && (o.storedMarks = n.storedMarks.map(t.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let l = r[s], d = l.spec.state;
            if (l.key == a.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              o[a.name] = d.fromJSON.call(l, t, n[s], o);
              return;
            }
          }
        o[a.name] = a.init(t, o);
      }
    }), o;
  }
}
function ov(e, t, n) {
  for (let r in e) {
    let i = e[r];
    i instanceof Function ? i = i.bind(t) : r == "handleDOMEvents" && (i = ov(i, t, {})), n[r] = i;
  }
  return n;
}
class cn {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && ov(t.props, this, this.props), this.key = t.key ? t.key.key : av("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const Ou = /* @__PURE__ */ Object.create(null);
function av(e) {
  return e in Ou ? e + "$" + ++Ou[e] : (Ou[e] = 0, e + "$");
}
class zn {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = av(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const vn = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, es = function(e) {
  let t = e.assignedSlot || e.parentNode;
  return t && t.nodeType == 11 ? t.host : t;
};
let jh = null;
const Gr = function(e, t, n) {
  let r = jh || (jh = document.createRange());
  return r.setEnd(e, n == null ? e.nodeValue.length : n), r.setStart(e, t || 0), r;
}, go = function(e, t, n, r) {
  return n && (Wh(e, t, n, r, -1) || Wh(e, t, n, r, 1));
}, bO = /^(img|br|input|textarea|hr)$/i;
function Wh(e, t, n, r, i) {
  for (; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (i < 0 ? 0 : Er(e))) {
      let o = e.parentNode;
      if (!o || o.nodeType != 1 || pf(e) || bO.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = vn(e) + (i < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (i < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      t = i < 0 ? Er(e) : 0;
    } else
      return !1;
  }
}
function Er(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function $O(e, t, n) {
  for (let r = t == 0, i = t == Er(e); r || i; ) {
    if (e == n)
      return !0;
    let o = vn(e);
    if (e = e.parentNode, !e)
      return !1;
    r = r && o == 0, i = i && o == Er(e);
  }
}
function pf(e) {
  let t;
  for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const Dd = function(e) {
  return e.focusNode && go(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function Gi(e, t) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
function wO(e) {
  let t = e.activeElement;
  for (; t && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function kO(e, t, n) {
  if (e.caretPositionFromPoint)
    try {
      let r = e.caretPositionFromPoint(t, n);
      if (r)
        return { node: r.offsetNode, offset: r.offset };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let r = e.caretRangeFromPoint(t, n);
    if (r)
      return { node: r.startContainer, offset: r.startOffset };
  }
}
const Hr = typeof navigator != "undefined" ? navigator : null, Uh = typeof document != "undefined" ? document : null, Vi = Hr && Hr.userAgent || "", Sc = /Edge\/(\d+)/.exec(Vi), sv = /MSIE \d/.exec(Vi), Cc = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Vi), On = !!(sv || Cc || Sc), Ai = sv ? document.documentMode : Cc ? +Cc[1] : Sc ? +Sc[1] : 0, fr = !On && /gecko\/(\d+)/i.test(Vi);
fr && +(/Firefox\/(\d+)/.exec(Vi) || [0, 0])[1];
const Tc = !On && /Chrome\/(\d+)/.exec(Vi), hn = !!Tc, xO = Tc ? +Tc[1] : 0, bn = !On && !!Hr && /Apple Computer/.test(Hr.vendor), la = bn && (/Mobile\/\w+/.test(Vi) || !!Hr && Hr.maxTouchPoints > 2), Wn = la || (Hr ? /Mac/.test(Hr.platform) : !1), SO = Hr ? /Win/.test(Hr.platform) : !1, nr = /Android \d/.test(Vi), ws = !!Uh && "webkitFontSmoothing" in Uh.documentElement.style, CO = ws ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function TO(e) {
  return {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function qr(e, t) {
  return typeof e == "number" ? e : e[t];
}
function MO(e) {
  let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, r = t.height / e.offsetHeight || 1;
  return {
    left: t.left,
    right: t.left + e.clientWidth * n,
    top: t.top,
    bottom: t.top + e.clientHeight * r
  };
}
function qh(e, t, n) {
  let r = e.someProp("scrollThreshold") || 0, i = e.someProp("scrollMargin") || 5, o = e.dom.ownerDocument;
  for (let a = n || e.dom; a; a = es(a)) {
    if (a.nodeType != 1)
      continue;
    let s = a, l = s == o.body, d = l ? TO(o) : MO(s), u = 0, c = 0;
    if (t.top < d.top + qr(r, "top") ? c = -(d.top - t.top + qr(i, "top")) : t.bottom > d.bottom - qr(r, "bottom") && (c = t.bottom - t.top > d.bottom - d.top ? t.top + qr(i, "top") - d.top : t.bottom - d.bottom + qr(i, "bottom")), t.left < d.left + qr(r, "left") ? u = -(d.left - t.left + qr(i, "left")) : t.right > d.right - qr(r, "right") && (u = t.right - d.right + qr(i, "right")), u || c)
      if (l)
        o.defaultView.scrollBy(u, c);
      else {
        let f = s.scrollLeft, h = s.scrollTop;
        c && (s.scrollTop += c), u && (s.scrollLeft += u);
        let p = s.scrollLeft - f, m = s.scrollTop - h;
        t = { left: t.left - p, top: t.top - m, right: t.right - p, bottom: t.bottom - m };
      }
    if (l || /^(fixed|sticky)$/.test(getComputedStyle(a).position))
      break;
  }
}
function OO(e) {
  let t = e.dom.getBoundingClientRect(), n = Math.max(0, t.top), r, i;
  for (let o = (t.left + t.right) / 2, a = n + 1; a < Math.min(innerHeight, t.bottom); a += 5) {
    let s = e.root.elementFromPoint(o, a);
    if (!s || s == e.dom || !e.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= n - 20) {
      r = s, i = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: lv(e.dom) };
}
function lv(e) {
  let t = [], n = e.ownerDocument;
  for (let r = e; r && (t.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), e != n); r = es(r))
    ;
  return t;
}
function EO({ refDOM: e, refTop: t, stack: n }) {
  let r = e ? e.getBoundingClientRect().top : 0;
  dv(n, r == 0 ? 0 : r - t);
}
function dv(e, t) {
  for (let n = 0; n < e.length; n++) {
    let { dom: r, top: i, left: o } = e[n];
    r.scrollTop != i + t && (r.scrollTop = i + t), r.scrollLeft != o && (r.scrollLeft = o);
  }
}
let Eo = null;
function DO(e) {
  if (e.setActive)
    return e.setActive();
  if (Eo)
    return e.focus(Eo);
  let t = lv(e);
  e.focus(Eo == null ? {
    get preventScroll() {
      return Eo = { preventScroll: !0 }, !0;
    }
  } : void 0), Eo || (Eo = !1, dv(t, 0));
}
function uv(e, t) {
  let n, r = 2e8, i, o = 0, a = t.top, s = t.top, l, d;
  for (let u = e.firstChild, c = 0; u; u = u.nextSibling, c++) {
    let f;
    if (u.nodeType == 1)
      f = u.getClientRects();
    else if (u.nodeType == 3)
      f = Gr(u).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let p = f[h];
      if (p.top <= a && p.bottom >= s) {
        a = Math.max(p.bottom, a), s = Math.min(p.top, s);
        let m = p.left > t.left ? p.left - t.left : p.right < t.left ? t.left - p.right : 0;
        if (m < r) {
          n = u, r = m, i = m && n.nodeType == 3 ? {
            left: p.right < t.left ? p.right : p.left,
            top: t.top
          } : t, u.nodeType == 1 && m && (o = c + (t.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > t.top && !l && p.left <= t.left && p.right >= t.left && (l = u, d = { left: Math.max(p.left, Math.min(p.right, t.left)), top: p.top });
      !n && (t.left >= p.right && t.top >= p.top || t.left >= p.left && t.top >= p.bottom) && (o = c + 1);
    }
  }
  return !n && l && (n = l, i = d, r = 0), n && n.nodeType == 3 ? AO(n, i) : !n || r && n.nodeType == 1 ? { node: e, offset: o } : uv(n, i);
}
function AO(e, t) {
  let n = e.nodeValue.length, r = document.createRange();
  for (let i = 0; i < n; i++) {
    r.setEnd(e, i + 1), r.setStart(e, i);
    let o = bi(r, 1);
    if (o.top != o.bottom && hf(t, o))
      return { node: e, offset: i + (t.left >= (o.left + o.right) / 2 ? 1 : 0) };
  }
  return { node: e, offset: 0 };
}
function hf(e, t) {
  return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function PO(e, t) {
  let n = e.parentNode;
  return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
}
function NO(e, t, n) {
  let { node: r, offset: i } = uv(t, n), o = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let a = r.getBoundingClientRect();
    o = a.left != a.right && n.left > (a.left + a.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(r, i, o);
}
function IO(e, t, n, r) {
  let i = -1;
  for (let o = t, a = !1; o != e.dom; ) {
    let s = e.docView.nearestDesc(o, !0);
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent && !a || !s.contentDOM)) {
      let l = s.dom.getBoundingClientRect();
      if (s.node.isBlock && s.parent && !a && (a = !0, l.left > r.left || l.top > r.top ? i = s.posBefore : (l.right < r.left || l.bottom < r.top) && (i = s.posAfter)), !s.contentDOM && i < 0 && !s.node.isText)
        return (s.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    }
    o = s.dom.parentNode;
  }
  return i > -1 ? i : e.docView.posFromDOM(t, n, -1);
}
function cv(e, t, n) {
  let r = e.childNodes.length;
  if (r && n.top < n.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (t.top - n.top) / (n.bottom - n.top)) - 2)), o = i; ; ) {
      let a = e.childNodes[o];
      if (a.nodeType == 1) {
        let s = a.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let d = s[l];
          if (hf(t, d))
            return cv(a, t, d);
        }
      }
      if ((o = (o + 1) % r) == i)
        break;
    }
  return e;
}
function RO(e, t) {
  let n = e.dom.ownerDocument, r, i = 0, o = kO(n, t.left, t.top);
  o && ({ node: r, offset: i } = o);
  let a = (e.root.elementFromPoint ? e.root : n).elementFromPoint(t.left, t.top), s;
  if (!a || !e.dom.contains(a.nodeType != 1 ? a.parentNode : a)) {
    let d = e.dom.getBoundingClientRect();
    if (!hf(t, d) || (a = cv(e.dom, t, d), !a))
      return null;
  }
  if (bn)
    for (let d = a; r && d; d = es(d))
      d.draggable && (r = void 0);
  if (a = PO(a, t), r) {
    if (fr && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let u = r.childNodes[i], c;
      u.nodeName == "IMG" && (c = u.getBoundingClientRect()).right <= t.left && c.bottom > t.top && i++;
    }
    let d;
    ws && i && r.nodeType == 1 && (d = r.childNodes[i - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= t.top && i--, r == e.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && t.top > r.lastChild.getBoundingClientRect().bottom ? s = e.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (s = IO(e, r, i, t));
  }
  s == null && (s = NO(e, a, t));
  let l = e.docView.nearestDesc(a, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function Yh(e) {
  return e.top < e.bottom || e.left < e.right;
}
function bi(e, t) {
  let n = e.getClientRects();
  if (n.length) {
    let r = n[t < 0 ? 0 : n.length - 1];
    if (Yh(r))
      return r;
  }
  return Array.prototype.find.call(n, Yh) || e.getBoundingClientRect();
}
const _O = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function fv(e, t, n) {
  let { node: r, offset: i, atom: o } = e.docView.domFromPos(t, n < 0 ? -1 : 1), a = ws || fr;
  if (r.nodeType == 3)
    if (a && (_O.test(r.nodeValue) || (n < 0 ? !i : i == r.nodeValue.length))) {
      let l = bi(Gr(r, i, i), n);
      if (fr && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let d = bi(Gr(r, i - 1, i - 1), -1);
        if (d.top == l.top) {
          let u = bi(Gr(r, i, i + 1), -1);
          if (u.top != l.top)
            return Ca(u, u.left < d.left);
        }
      }
      return l;
    } else {
      let l = i, d = i, u = n < 0 ? 1 : -1;
      return n < 0 && !i ? (d++, u = -1) : n >= 0 && i == r.nodeValue.length ? (l--, u = 1) : n < 0 ? l-- : d++, Ca(bi(Gr(r, l, d), u), u < 0);
    }
  if (!e.state.doc.resolve(t - (o || 0)).parent.inlineContent) {
    if (o == null && i && (n < 0 || i == Er(r))) {
      let l = r.childNodes[i - 1];
      if (l.nodeType == 1)
        return Eu(l.getBoundingClientRect(), !1);
    }
    if (o == null && i < Er(r)) {
      let l = r.childNodes[i];
      if (l.nodeType == 1)
        return Eu(l.getBoundingClientRect(), !0);
    }
    return Eu(r.getBoundingClientRect(), n >= 0);
  }
  if (o == null && i && (n < 0 || i == Er(r))) {
    let l = r.childNodes[i - 1], d = l.nodeType == 3 ? Gr(l, Er(l) - (a ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (d)
      return Ca(bi(d, 1), !1);
  }
  if (o == null && i < Er(r)) {
    let l = r.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let d = l ? l.nodeType == 3 ? Gr(l, 0, a ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (d)
      return Ca(bi(d, -1), !0);
  }
  return Ca(bi(r.nodeType == 3 ? Gr(r) : r, -n), n >= 0);
}
function Ca(e, t) {
  if (e.width == 0)
    return e;
  let n = t ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: n, right: n };
}
function Eu(e, t) {
  if (e.height == 0)
    return e;
  let n = t ? e.top : e.bottom;
  return { top: n, bottom: n, left: e.left, right: e.right };
}
function pv(e, t, n) {
  let r = e.state, i = e.root.activeElement;
  r != t && e.updateState(t), i != e.dom && e.focus();
  try {
    return n();
  } finally {
    r != t && e.updateState(r), i != e.dom && i && i.focus();
  }
}
function LO(e, t, n) {
  let r = t.selection, i = n == "up" ? r.$from : r.$to;
  return pv(e, t, () => {
    let { node: o } = e.docView.domFromPos(i.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = e.docView.nearestDesc(o, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        o = s.contentDOM || s.dom;
        break;
      }
      o = s.dom.parentNode;
    }
    let a = fv(e, i.pos, 1);
    for (let s = o.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = Gr(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < l.length; d++) {
        let u = l[d];
        if (u.bottom > u.top + 1 && (n == "up" ? a.top - u.top > (u.bottom - a.top) * 2 : u.bottom - a.bottom > (a.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const FO = /[\u0590-\u08ac]/;
function BO(e, t, n) {
  let { $head: r } = t.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, o = !i, a = i == r.parent.content.size, s = e.domSelection();
  return !FO.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? o : a : pv(e, t, () => {
    let { focusNode: l, focusOffset: d, anchorNode: u, anchorOffset: c } = e.domSelectionRange(), f = s.caretBidiLevel;
    s.modify("move", n, "character");
    let h = r.depth ? e.docView.domAfterPos(r.before()) : e.dom, { focusNode: p, focusOffset: m } = e.domSelectionRange(), g = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && d == m;
    try {
      s.collapse(u, c), l && (l != u || d != c) && s.extend && s.extend(l, d);
    } catch {
    }
    return f != null && (s.caretBidiLevel = f), g;
  });
}
let Kh = null, Gh = null, Jh = !1;
function zO(e, t, n) {
  return Kh == t && Gh == n ? Jh : (Kh = t, Gh = n, Jh = n == "up" || n == "down" ? LO(e, t, n) : BO(e, t, n));
}
const Kn = 0, Xh = 1, Zi = 2, jr = 3;
class ks {
  constructor(t, n, r, i) {
    this.parent = t, this.children = n, this.dom = r, this.contentDOM = i, this.dirty = Kn, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(t) {
    return !1;
  }
  matchesMark(t) {
    return !1;
  }
  matchesNode(t, n, r) {
    return !1;
  }
  matchesHack(t) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(t) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let t = 0;
    for (let n = 0; n < this.children.length; n++)
      t += this.children[n].size;
    return t;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let t = 0; t < this.children.length; t++)
      this.children[t].destroy();
  }
  posBeforeChild(t) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let i = this.children[n];
      if (i == t)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(t, n, r) {
    if (this.contentDOM && this.contentDOM.contains(t.nodeType == 1 ? t : t.parentNode))
      if (r < 0) {
        let o, a;
        if (t == this.contentDOM)
          o = t.childNodes[n - 1];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          o = t.previousSibling;
        }
        for (; o && !((a = o.pmViewDesc) && a.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(a) + a.size : this.posAtStart;
      } else {
        let o, a;
        if (t == this.contentDOM)
          o = t.childNodes[n];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          o = t.nextSibling;
        }
        for (; o && !((a = o.pmViewDesc) && a.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(a) : this.posAtEnd;
      }
    let i;
    if (t == this.dom && this.contentDOM)
      i = n > vn(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = t.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let o = t; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (i == null && n == t.childNodes.length)
        for (let o = t; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return (i == null ? r > 0 : i) ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(t, n = !1) {
    for (let r = !0, i = t; i; i = i.parentNode) {
      let o = this.getDesc(i), a;
      if (o && (!n || o.node))
        if (r && (a = o.nodeDOM) && !(a.nodeType == 1 ? a.contains(t.nodeType == 1 ? t : t.parentNode) : a == t))
          r = !1;
        else
          return o;
    }
  }
  getDesc(t) {
    let n = t.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(t, n, r) {
    for (let i = t; i; i = i.parentNode) {
      let o = this.getDesc(i);
      if (o)
        return o.localPosFromDOM(t, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(t) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let i = this.children[n], o = r + i.size;
      if (r == t && o != r) {
        for (; !i.border && i.children.length; )
          i = i.children[0];
        return i;
      }
      if (t < o)
        return i.descAt(t - r - i.border);
      r = o;
    }
  }
  domFromPos(t, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: t + 1 };
    let r = 0, i = 0;
    for (let o = 0; r < this.children.length; r++) {
      let a = this.children[r], s = o + a.size;
      if (s > t || a instanceof mv) {
        i = t - o;
        break;
      }
      o = s;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, n);
    for (let o; r && !(o = this.children[r - 1]).size && o instanceof hv && o.side >= 0; r--)
      ;
    if (n <= 0) {
      let o, a = !0;
      for (; o = r ? this.children[r - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); r--, a = !1)
        ;
      return o && n && a && !o.border && !o.domAtom ? o.domFromPos(o.size, n) : { node: this.contentDOM, offset: o ? vn(o.dom) + 1 : 0 };
    } else {
      let o, a = !0;
      for (; o = r < this.children.length ? this.children[r] : null, !(!o || o.dom.parentNode == this.contentDOM); r++, a = !1)
        ;
      return o && a && !o.border && !o.domAtom ? o.domFromPos(0, n) : { node: this.contentDOM, offset: o ? vn(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(t, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: t, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, o = -1;
    for (let a = r, s = 0; ; s++) {
      let l = this.children[s], d = a + l.size;
      if (i == -1 && t <= d) {
        let u = a + l.border;
        if (t >= u && n <= d - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(t, n, u);
        t = a;
        for (let c = s; c > 0; c--) {
          let f = this.children[c - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            i = vn(f.dom) + 1;
            break;
          }
          t -= f.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (d > n || s == this.children.length - 1)) {
        n = d;
        for (let u = s + 1; u < this.children.length; u++) {
          let c = this.children[u];
          if (c.size && c.dom.parentNode == this.contentDOM && !c.emptyChildAt(-1)) {
            o = vn(c.dom);
            break;
          }
          n += c.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      a = d;
    }
    return { node: this.contentDOM, from: t, to: n, fromOffset: i, toOffset: o };
  }
  emptyChildAt(t) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[t < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(t);
  }
  domAfterPos(t) {
    let { node: n, offset: r } = this.domFromPos(t, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + t);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(t, n, r, i = !1) {
    let o = Math.min(t, n), a = Math.max(t, n);
    for (let f = 0, h = 0; f < this.children.length; f++) {
      let p = this.children[f], m = h + p.size;
      if (o > h && a < m)
        return p.setSelection(t - h - p.border, n - h - p.border, r, i);
      h = m;
    }
    let s = this.domFromPos(t, t ? -1 : 1), l = n == t ? s : this.domFromPos(n, n ? -1 : 1), d = r.getSelection(), u = !1;
    if ((fr || bn) && t == n) {
      let { node: f, offset: h } = s;
      if (f.nodeType == 3) {
        if (u = !!(h && f.nodeValue[h - 1] == `
`), u && h == f.nodeValue.length)
          for (let p = f, m; p; p = p.parentNode) {
            if (m = p.nextSibling) {
              m.nodeName == "BR" && (s = l = { node: m.parentNode, offset: vn(m) + 1 });
              break;
            }
            let g = p.pmViewDesc;
            if (g && g.node && g.node.isBlock)
              break;
          }
      } else {
        let p = f.childNodes[h - 1];
        u = p && (p.nodeName == "BR" || p.contentEditable == "false");
      }
    }
    if (fr && d.focusNode && d.focusNode != l.node && d.focusNode.nodeType == 1) {
      let f = d.focusNode.childNodes[d.focusOffset];
      f && f.contentEditable == "false" && (i = !0);
    }
    if (!(i || u && bn) && go(s.node, s.offset, d.anchorNode, d.anchorOffset) && go(l.node, l.offset, d.focusNode, d.focusOffset))
      return;
    let c = !1;
    if ((d.extend || t == n) && !u) {
      d.collapse(s.node, s.offset);
      try {
        t != n && d.extend(l.node, l.offset), c = !0;
      } catch {
      }
    }
    if (!c) {
      if (t > n) {
        let h = s;
        s = l, l = h;
      }
      let f = document.createRange();
      f.setEnd(l.node, l.offset), f.setStart(s.node, s.offset), d.removeAllRanges(), d.addRange(f);
    }
  }
  ignoreMutation(t) {
    return !this.contentDOM && t.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(t, n) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let o = this.children[i], a = r + o.size;
      if (r == a ? t <= a && n >= r : t < a && n > r) {
        let s = r + o.border, l = a - o.border;
        if (t >= s && n <= l) {
          this.dirty = t == r || n == a ? Zi : Xh, t == s && n == l && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = jr : o.markDirty(t - s, n - s);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? Zi : jr;
      }
      r = a;
    }
    this.dirty = Zi;
  }
  markParentsDirty() {
    let t = 1;
    for (let n = this.parent; n; n = n.parent, t++) {
      let r = t == 1 ? Zi : Xh;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
}
class hv extends ks {
  constructor(t, n, r, i) {
    let o, a = n.type.toDOM;
    if (typeof a == "function" && (a = a(r, () => {
      if (!o)
        return i;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !n.type.spec.raw) {
      if (a.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(a), a = s;
      }
      a.contentEditable = "false", a.classList.add("ProseMirror-widget");
    }
    super(t, [], a, null), this.widget = n, this.widget = n, o = this;
  }
  matchesWidget(t) {
    return this.dirty == Kn && t.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(t) {
    let n = this.widget.spec.stopEvent;
    return n ? n(t) : !1;
  }
  ignoreMutation(t) {
    return t.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class VO extends ks {
  constructor(t, n, r, i) {
    super(t, [], n, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(t, n) {
    return t != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(t) {
    return { node: this.textDOM, offset: t };
  }
  ignoreMutation(t) {
    return t.type === "characterData" && t.target.nodeValue == t.oldValue;
  }
}
class vo extends ks {
  constructor(t, n, r, i) {
    super(t, [], r, i), this.mark = n;
  }
  static create(t, n, r, i) {
    let o = i.nodeViews[n.type.name], a = o && o(n, i, r);
    return (!a || !a.dom) && (a = Nr.renderSpec(document, n.type.spec.toDOM(n, r))), new vo(t, n, a.dom, a.contentDOM || a.dom);
  }
  parseRule() {
    return this.dirty & jr || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(t) {
    return this.dirty != jr && this.mark.eq(t);
  }
  markDirty(t, n) {
    if (super.markDirty(t, n), this.dirty != Kn) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Kn;
    }
  }
  slice(t, n, r) {
    let i = vo.create(this.parent, this.mark, !0, r), o = this.children, a = this.size;
    n < a && (o = Ec(o, n, a, r)), t > 0 && (o = Ec(o, 0, t, r));
    for (let s = 0; s < o.length; s++)
      o[s].parent = i;
    return i.children = o, i;
  }
}
class Pi extends ks {
  constructor(t, n, r, i, o, a, s, l, d) {
    super(t, [], o, a), this.node = n, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(t, n, r, i, o, a) {
    let s = o.nodeViews[n.type.name], l, d = s && s(n, o, () => {
      if (!l)
        return a;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, i), u = d && d.dom, c = d && d.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: c } = Nr.renderSpec(document, n.type.spec.toDOM(n)));
    !c && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let f = u;
    return u = yv(u, r, n), d ? l = new HO(t, n, r, i, u, c || null, f, d, o, a + 1) : n.isText ? new Ad(t, n, r, i, u, f, o) : new Pi(t, n, r, i, u, c || null, f, o, a + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let t = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (t.preserveWhitespace = "full"), !this.contentDOM)
      t.getContent = () => this.node.content;
    else if (!this.contentLost)
      t.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          t.contentElement = r.dom.parentNode;
          break;
        }
      }
      t.contentElement || (t.getContent = () => ve.empty);
    }
    return t;
  }
  matchesNode(t, n, r) {
    return this.dirty == Kn && t.eq(this.node) && Oc(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(t, n) {
    let r = this.node.inlineContent, i = n, o = t.composing ? this.localCompositionInfo(t, n) : null, a = o && o.pos > -1 ? o : null, s = o && o.pos < 0, l = new WO(this, a && a.node, t);
    YO(this.node, this.innerDeco, (d, u, c) => {
      d.spec.marks ? l.syncToMarks(d.spec.marks, r, t) : d.type.side >= 0 && !c && l.syncToMarks(u == this.node.childCount ? vt.none : this.node.child(u).marks, r, t), l.placeWidget(d, t, i);
    }, (d, u, c, f) => {
      l.syncToMarks(d.marks, r, t);
      let h;
      l.findNodeMatch(d, u, c, f) || s && t.state.selection.from > i && t.state.selection.to < i + d.nodeSize && (h = l.findIndexWithChild(o.node)) > -1 && l.updateNodeAt(d, u, c, h, t) || l.updateNextNode(d, u, c, t, f, i) || l.addNode(d, u, c, t, i), i += d.nodeSize;
    }), l.syncToMarks([], r, t), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Zi) && (a && this.protectLocalComposition(t, a), gv(this.contentDOM, this.children, t), la && KO(this.dom));
  }
  localCompositionInfo(t, n) {
    let { from: r, to: i } = t.state.selection;
    if (!(t.state.selection instanceof Xe) || r < n || i > n + this.node.content.size)
      return null;
    let o = t.domSelectionRange(), a = GO(o.focusNode, o.focusOffset);
    if (!a || !this.dom.contains(a.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = a.nodeValue, l = JO(this.node.content, s, r - n, i - n);
      return l < 0 ? null : { node: a, pos: l, text: s };
    } else
      return { node: a, pos: -1, text: "" };
  }
  protectLocalComposition(t, { node: n, pos: r, text: i }) {
    if (this.getDesc(n))
      return;
    let o = n;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let a = new VO(this, o, n, i);
    t.input.compositionNodes.push(a), this.children = Ec(this.children, r, r + i.length, t, a);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(t, n, r, i) {
    return this.dirty == jr || !t.sameMarkup(this.node) ? !1 : (this.updateInner(t, n, r, i), !0);
  }
  updateInner(t, n, r, i) {
    this.updateOuterDeco(n), this.node = t, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Kn;
  }
  updateOuterDeco(t) {
    if (Oc(t, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = vv(this.dom, this.nodeDOM, Mc(this.outerDeco, this.node, n), Mc(t, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = t;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable");
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Qh(e, t, n, r, i) {
  yv(r, t, e);
  let o = new Pi(void 0, e, t, n, r, r, r, i, 0);
  return o.contentDOM && o.updateChildren(i, 0), o;
}
class Ad extends Pi {
  constructor(t, n, r, i, o, a, s) {
    super(t, n, r, i, o, null, a, s, 0);
  }
  parseRule() {
    let t = this.nodeDOM.parentNode;
    for (; t && t != this.dom && !t.pmIsDeco; )
      t = t.parentNode;
    return { skip: t || !0 };
  }
  update(t, n, r, i) {
    return this.dirty == jr || this.dirty != Kn && !this.inParent() || !t.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != Kn || t.text != this.node.text) && t.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = t.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = t, this.dirty = Kn, !0);
  }
  inParent() {
    let t = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == t)
        return !0;
    return !1;
  }
  domFromPos(t) {
    return { node: this.nodeDOM, offset: t };
  }
  localPosFromDOM(t, n, r) {
    return t == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(t, n, r);
  }
  ignoreMutation(t) {
    return t.type != "characterData" && t.type != "selection";
  }
  slice(t, n, r) {
    let i = this.node.cut(t, n), o = document.createTextNode(i.text);
    return new Ad(this.parent, i, this.outerDeco, this.innerDeco, o, o, r);
  }
  markDirty(t, n) {
    super.markDirty(t, n), this.dom != this.nodeDOM && (t == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = jr);
  }
  get domAtom() {
    return !1;
  }
}
class mv extends ks {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(t) {
    return this.dirty == Kn && this.dom.nodeName == t;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class HO extends Pi {
  constructor(t, n, r, i, o, a, s, l, d, u) {
    super(t, n, r, i, o, a, s, d, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(t, n, r, i) {
    if (this.dirty == jr)
      return !1;
    if (this.spec.update) {
      let o = this.spec.update(t, n, r);
      return o && this.updateInner(t, n, r, i), o;
    } else return !this.contentDOM && !t.isLeaf ? !1 : super.update(t, n, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(t, n, r, i) {
    this.spec.setSelection ? this.spec.setSelection(t, n, r) : super.setSelection(t, n, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(t) {
    return this.spec.stopEvent ? this.spec.stopEvent(t) : !1;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
}
function gv(e, t, n) {
  let r = e.firstChild, i = !1;
  for (let o = 0; o < t.length; o++) {
    let a = t[o], s = a.dom;
    if (s.parentNode == e) {
      for (; s != r; )
        r = Zh(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, e.insertBefore(s, r);
    if (a instanceof vo) {
      let l = r ? r.previousSibling : e.lastChild;
      gv(a.contentDOM, a.children, n), r = l ? l.nextSibling : e.firstChild;
    }
  }
  for (; r; )
    r = Zh(r), i = !0;
  i && n.trackWrites == e && (n.trackWrites = null);
}
const Ba = function(e) {
  e && (this.nodeName = e);
};
Ba.prototype = /* @__PURE__ */ Object.create(null);
const eo = [new Ba()];
function Mc(e, t, n) {
  if (e.length == 0)
    return eo;
  let r = n ? eo[0] : new Ba(), i = [r];
  for (let o = 0; o < e.length; o++) {
    let a = e[o].type.attrs;
    if (a) {
      a.nodeName && i.push(r = new Ba(a.nodeName));
      for (let s in a) {
        let l = a[s];
        l != null && (n && i.length == 1 && i.push(r = new Ba(t.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + l : s == "style" ? r.style = (r.style ? r.style + ";" : "") + l : s != "nodeName" && (r[s] = l));
      }
    }
  }
  return i;
}
function vv(e, t, n, r) {
  if (n == eo && r == eo)
    return t;
  let i = t;
  for (let o = 0; o < r.length; o++) {
    let a = r[o], s = n[o];
    if (o) {
      let l;
      s && s.nodeName == a.nodeName && i != e && (l = i.parentNode) && l.nodeName.toLowerCase() == a.nodeName || (l = document.createElement(a.nodeName), l.pmIsDeco = !0, l.appendChild(i), s = eo[0]), i = l;
    }
    jO(i, s || eo[0], a);
  }
  return i;
}
function jO(e, t, n) {
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && e.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != t[r] && e.setAttribute(r, n[r]);
  if (t.class != n.class) {
    let r = t.class ? t.class.split(" ").filter(Boolean) : [], i = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < r.length; o++)
      i.indexOf(r[o]) == -1 && e.classList.remove(r[o]);
    for (let o = 0; o < i.length; o++)
      r.indexOf(i[o]) == -1 && e.classList.add(i[o]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (t.style != n.style) {
    if (t.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(t.style); )
        e.style.removeProperty(i[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function yv(e, t, n) {
  return vv(e, e, eo, Mc(t, n, e.nodeType != 1));
}
function Oc(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].type.eq(t[n].type))
      return !1;
  return !0;
}
function Zh(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class WO {
  constructor(t, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = t, this.preMatch = UO(t.node.content, t);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(t, n) {
    if (t != n) {
      for (let r = t; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(t, n - t), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(t, n, r) {
    let i = 0, o = this.stack.length >> 1, a = Math.min(o, t.length);
    for (; i < a && (i == o - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(t[i]) && t[i].type.spec.spanning !== !1; )
      i++;
    for (; i < o; )
      this.destroyRest(), this.top.dirty = Kn, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < t.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let d = this.top.children[l];
        if (d.matchesMark(t[o]) && !this.isLocked(d.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = vo.create(this.top, t[o], n, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(t, n, r, i) {
    let o = -1, a;
    if (i >= this.preMatch.index && (a = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && a.matchesNode(t, n, r))
      o = this.top.children.indexOf(a, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let d = this.top.children[s];
        if (d.matchesNode(t, n, r) && !this.preMatch.matched.has(d)) {
          o = s;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(t, n, r, i, o) {
    let a = this.top.children[i];
    return a.dirty == jr && a.dom == a.contentDOM && (a.dirty = Zi), a.update(t, n, r, o) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(t) {
    for (; ; ) {
      let n = t.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = t.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      t = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(t, n, r, i, o, a) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof Pi) {
        let d = this.preMatch.matched.get(l);
        if (d != null && d != o)
          return !1;
        let u = l.dom, c, f = this.isLocked(u) && !(t.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == t.text && l.dirty != jr && Oc(n, l.outerDeco));
        if (!f && l.update(t, n, r, i))
          return this.destroyBetween(this.index, s), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!f && (c = this.recreateWrapper(l, t, n, r, i, a)))
          return this.top.children[this.index] = c, c.contentDOM && (c.dirty = Zi, c.updateChildren(i, a + 1), c.dirty = Kn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(t, n, r, i, o, a) {
    if (t.dirty || n.isAtom || !t.children.length || !t.node.content.eq(n.content))
      return null;
    let s = Pi.create(this.top, n, r, i, o, a);
    if (s.contentDOM) {
      s.children = t.children, t.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return t.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(t, n, r, i, o) {
    let a = Pi.create(this.top, t, n, r, i, o);
    a.contentDOM && a.updateChildren(i, o + 1), this.top.children.splice(this.index++, 0, a), this.changed = !0;
  }
  placeWidget(t, n, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(t) && (t == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new hv(this.top, t, n, r);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let t = this.top.children[this.index - 1], n = this.top;
    for (; t instanceof vo; )
      n = t, t = n.children[n.children.length - 1];
    (!t || // Empty textblock
    !(t instanceof Ad) || /\n$/.test(t.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(t.node.text)) && ((bn || hn) && t && t.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(t, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(t))
      this.index++;
    else {
      let r = document.createElement(t);
      t == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), t == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new mv(this.top, [], r, null);
      n != this.top ? n.children.push(i) : n.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(t) {
    return this.lock && (t == this.lock || t.nodeType == 1 && t.contains(this.lock.parentNode));
  }
}
function UO(e, t) {
  let n = t, r = n.children.length, i = e.childCount, o = /* @__PURE__ */ new Map(), a = [];
  e: for (; i > 0; ) {
    let s;
    for (; ; )
      if (r) {
        let d = n.children[r - 1];
        if (d instanceof vo)
          n = d, r = d.children.length;
        else {
          s = d, r--;
          break;
        }
      } else {
        if (n == t)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let l = s.node;
    if (l) {
      if (l != e.child(i - 1))
        break;
      --i, o.set(s, i), a.push(s);
    }
  }
  return { index: i, matched: o, matches: a.reverse() };
}
function qO(e, t) {
  return e.type.side - t.type.side;
}
function YO(e, t, n, r) {
  let i = t.locals(e), o = 0;
  if (i.length == 0) {
    for (let d = 0; d < e.childCount; d++) {
      let u = e.child(d);
      r(u, i, t.forChild(o, u), d), o += u.nodeSize;
    }
    return;
  }
  let a = 0, s = [], l = null;
  for (let d = 0; ; ) {
    let u, c;
    for (; a < i.length && i[a].to == o; ) {
      let g = i[a++];
      g.widget && (u ? (c || (c = [u])).push(g) : u = g);
    }
    if (u)
      if (c) {
        c.sort(qO);
        for (let g = 0; g < c.length; g++)
          n(c[g], d, !!l);
      } else
        n(u, d, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (d < e.childCount)
      h = d, f = e.child(d++);
    else
      break;
    for (let g = 0; g < s.length; g++)
      s[g].to <= o && s.splice(g--, 1);
    for (; a < i.length && i[a].from <= o && i[a].to > o; )
      s.push(i[a++]);
    let p = o + f.nodeSize;
    if (f.isText) {
      let g = p;
      a < i.length && i[a].from < g && (g = i[a].from);
      for (let v = 0; v < s.length; v++)
        s[v].to < g && (g = s[v].to);
      g < p && (l = f.cut(g - o), f = f.cut(0, g - o), p = g, h = -1);
    } else
      for (; a < i.length && i[a].to < p; )
        a++;
    let m = f.isInline && !f.isLeaf ? s.filter((g) => !g.inline) : s.slice();
    r(f, m, t.forChild(o, f), h), o = p;
  }
}
function KO(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let t = e.style.cssText;
    e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
  }
}
function GO(e, t) {
  for (; ; ) {
    if (e.nodeType == 3)
      return e;
    if (e.nodeType == 1 && t > 0) {
      if (e.childNodes.length > t && e.childNodes[t].nodeType == 3)
        return e.childNodes[t];
      e = e.childNodes[t - 1], t = Er(e);
    } else if (e.nodeType == 1 && t < e.childNodes.length)
      e = e.childNodes[t], t = 0;
    else
      return null;
  }
}
function JO(e, t, n, r) {
  for (let i = 0, o = 0; i < e.childCount && o <= r; ) {
    let a = e.child(i++), s = o;
    if (o += a.nodeSize, !a.isText)
      continue;
    let l = a.text;
    for (; i < e.childCount; ) {
      let d = e.child(i++);
      if (o += d.nodeSize, !d.isText)
        break;
      l += d.text;
    }
    if (o >= n) {
      if (o >= r && l.slice(r - t.length - s, r - s) == t)
        return r - t.length;
      let d = s < r ? l.lastIndexOf(t, r - s - 1) : -1;
      if (d >= 0 && d + t.length + s >= n)
        return s + d;
      if (n == r && l.length >= r + t.length - s && l.slice(r - s, r - s + t.length) == t)
        return r;
    }
  }
  return -1;
}
function Ec(e, t, n, r, i) {
  let o = [];
  for (let a = 0, s = 0; a < e.length; a++) {
    let l = e[a], d = s, u = s += l.size;
    d >= n || u <= t ? o.push(l) : (d < t && o.push(l.slice(0, t - d, r)), i && (o.push(i), i = void 0), u > n && o.push(l.slice(n - d, l.size, r)));
  }
  return o;
}
function mf(e, t = null) {
  let n = e.domSelectionRange(), r = e.state.doc;
  if (!n.focusNode)
    return null;
  let i = e.docView.nearestDesc(n.focusNode), o = i && i.size == 0, a = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (a < 0)
    return null;
  let s = r.resolve(a), l, d;
  if (Dd(n)) {
    for (l = s; i && !i.node; )
      i = i.parent;
    let u = i.node;
    if (i && u.isAtom && He.isSelectable(u) && i.parent && !(u.isInline && $O(n.focusNode, n.focusOffset, i.dom))) {
      let c = i.posBefore;
      d = new He(a == c ? s : r.resolve(c));
    }
  } else {
    let u = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (u < 0)
      return null;
    l = r.resolve(u);
  }
  if (!d) {
    let u = t == "pointer" || e.state.selection.head < s.pos && !o ? 1 : -1;
    d = gf(e, l, s, u);
  }
  return d;
}
function bv(e) {
  return e.editable ? e.hasFocus() : wv(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function si(e, t = !1) {
  let n = e.state.selection;
  if ($v(e, n), !!bv(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && hn) {
      let r = e.domSelectionRange(), i = e.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && go(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      QO(e);
    else {
      let { anchor: r, head: i } = n, o, a;
      e1 && !(n instanceof Xe) && (n.$from.parent.inlineContent || (o = t1(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (a = t1(e, n.to))), e.docView.setSelection(r, i, e.root, t), e1 && (o && n1(o), a && n1(a)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && XO(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const e1 = bn || hn && xO < 63;
function t1(e, t) {
  let { node: n, offset: r } = e.docView.domFromPos(t, 0), i = r < n.childNodes.length ? n.childNodes[r] : null, o = r ? n.childNodes[r - 1] : null;
  if (bn && i && i.contentEditable == "false")
    return Du(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return Du(i);
    if (o)
      return Du(o);
  }
}
function Du(e) {
  return e.contentEditable = "true", bn && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function n1(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function XO(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let n = e.domSelectionRange(), r = n.anchorNode, i = n.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != i) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!bv(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function QO(e) {
  let t = e.domSelection(), n = document.createRange(), r = e.cursorWrapper.dom, i = r.nodeName == "IMG";
  i ? n.setEnd(r.parentNode, vn(r) + 1) : n.setEnd(r, 0), n.collapse(!1), t.removeAllRanges(), t.addRange(n), !i && !e.state.selection.visible && On && Ai <= 11 && (r.disabled = !0, r.disabled = !1);
}
function $v(e, t) {
  if (t instanceof He) {
    let n = e.docView.descAt(t.from);
    n != e.lastSelectedViewDesc && (r1(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else
    r1(e);
}
function r1(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function gf(e, t, n, r) {
  return e.someProp("createSelectionBetween", (i) => i(e, t, n)) || Xe.between(t, n, r);
}
function i1(e) {
  return e.editable && !e.hasFocus() ? !1 : wv(e);
}
function wv(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function ZO(e) {
  let t = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
  return go(t.node, t.offset, n.anchorNode, n.anchorOffset);
}
function Dc(e, t) {
  let { $anchor: n, $head: r } = e.selection, i = t > 0 ? n.max(r) : n.min(r), o = i.parent.inlineContent ? i.depth ? e.doc.resolve(t > 0 ? i.after() : i.before()) : null : i;
  return o && rt.findFrom(o, t);
}
function $i(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function o1(e, t, n) {
  let r = e.state.selection;
  if (r instanceof Xe)
    if (n.indexOf("s") > -1) {
      let { $head: i } = r, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter;
      if (!o || o.isText || !o.isLeaf)
        return !1;
      let a = e.state.doc.resolve(i.pos + o.nodeSize * (t < 0 ? -1 : 1));
      return $i(e, new Xe(r.$anchor, a));
    } else if (r.empty) {
      if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
        let i = Dc(e.state, t);
        return i && i instanceof He ? $i(e, i) : !1;
      } else if (!(Wn && n.indexOf("m") > -1)) {
        let i = r.$head, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter, a;
        if (!o || o.isText)
          return !1;
        let s = t < 0 ? i.pos - o.nodeSize : i.pos;
        return o.isAtom || (a = e.docView.descAt(s)) && !a.contentDOM ? He.isSelectable(o) ? $i(e, new He(t < 0 ? e.state.doc.resolve(i.pos - o.nodeSize) : i)) : ws ? $i(e, new Xe(e.state.doc.resolve(t < 0 ? s : s + o.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof He && r.node.isInline)
      return $i(e, new Xe(t > 0 ? r.$to : r.$from));
    {
      let i = Dc(e.state, t);
      return i ? $i(e, i) : !1;
    }
  }
}
function xl(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function za(e, t) {
  let n = e.pmViewDesc;
  return n && n.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function Do(e, t) {
  return t < 0 ? eE(e) : tE(e);
}
function eE(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let i, o, a = !1;
  for (fr && n.nodeType == 1 && r < xl(n) && za(n.childNodes[r], -1) && (a = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[r - 1];
        if (za(s, -1))
          i = n, o = --r;
        else if (s.nodeType == 3)
          n = s, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (kv(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && za(s, -1); )
          i = n.parentNode, o = vn(s), s = s.previousSibling;
        if (s)
          n = s, r = xl(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = 0;
        }
      }
    }
  a ? Ac(e, n, r) : i && Ac(e, i, o);
}
function tE(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let i = xl(n), o, a;
  for (; ; )
    if (r < i) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[r];
      if (za(s, 1))
        o = n, a = ++r;
      else
        break;
    } else {
      if (kv(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && za(s, 1); )
          o = s.parentNode, a = vn(s) + 1, s = s.nextSibling;
        if (s)
          n = s, r = 0, i = xl(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = i = 0;
        }
      }
    }
  o && Ac(e, o, a);
}
function kv(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function nE(e, t) {
  for (; e && t == e.childNodes.length && !pf(e); )
    t = vn(e) + 1, e = e.parentNode;
  for (; e && t < e.childNodes.length; ) {
    let n = e.childNodes[t];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = 0;
  }
}
function rE(e, t) {
  for (; e && !t && !pf(e); )
    t = vn(e), e = e.parentNode;
  for (; e && t; ) {
    let n = e.childNodes[t - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = e.childNodes.length;
  }
}
function Ac(e, t, n) {
  if (t.nodeType != 3) {
    let o, a;
    (a = nE(t, n)) ? (t = a, n = 0) : (o = rE(t, n)) && (t = o, n = o.nodeValue.length);
  }
  let r = e.domSelection();
  if (Dd(r)) {
    let o = document.createRange();
    o.setEnd(t, n), o.setStart(t, n), r.removeAllRanges(), r.addRange(o);
  } else r.extend && r.extend(t, n);
  e.domObserver.setCurSelection();
  let { state: i } = e;
  setTimeout(() => {
    e.state == i && si(e);
  }, 50);
}
function a1(e, t) {
  let n = e.state.doc.resolve(t);
  if (!(hn || SO) && n.parent.inlineContent) {
    let i = e.coordsAtPos(t);
    if (t > n.start()) {
      let o = e.coordsAtPos(t - 1), a = (o.top + o.bottom) / 2;
      if (a > i.top && a < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left < i.left ? "ltr" : "rtl";
    }
    if (t < n.end()) {
      let o = e.coordsAtPos(t + 1), a = (o.top + o.bottom) / 2;
      if (a > i.top && a < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function s1(e, t, n) {
  let r = e.state.selection;
  if (r instanceof Xe && !r.empty || n.indexOf("s") > -1 || Wn && n.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: o } = r;
  if (!i.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let a = Dc(e.state, t);
    if (a && a instanceof He)
      return $i(e, a);
  }
  if (!i.parent.inlineContent) {
    let a = t < 0 ? i : o, s = r instanceof dr ? rt.near(a, t) : rt.findFrom(a, t);
    return s ? $i(e, s) : !1;
  }
  return !1;
}
function l1(e, t) {
  if (!(e.state.selection instanceof Xe))
    return !0;
  let { $head: n, $anchor: r, empty: i } = e.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let o = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
  if (o && !o.isText) {
    let a = e.state.tr;
    return t < 0 ? a.delete(n.pos - o.nodeSize, n.pos) : a.delete(n.pos, n.pos + o.nodeSize), e.dispatch(a), !0;
  }
  return !1;
}
function d1(e, t, n) {
  e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function iE(e) {
  if (!bn || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (t && t.nodeType == 1 && n == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let r = t.firstChild;
    d1(e, r, "true"), setTimeout(() => d1(e, r, "false"), 20);
  }
  return !1;
}
function oE(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function aE(e, t) {
  let n = t.keyCode, r = oE(t);
  if (n == 8 || Wn && n == 72 && r == "c")
    return l1(e, -1) || Do(e, -1);
  if (n == 46 && !t.shiftKey || Wn && n == 68 && r == "c")
    return l1(e, 1) || Do(e, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || Wn && n == 66 && r == "c") {
    let i = n == 37 ? a1(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return o1(e, i, r) || Do(e, i);
  } else if (n == 39 || Wn && n == 70 && r == "c") {
    let i = n == 39 ? a1(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return o1(e, i, r) || Do(e, i);
  } else {
    if (n == 38 || Wn && n == 80 && r == "c")
      return s1(e, -1, r) || Do(e, -1);
    if (n == 40 || Wn && n == 78 && r == "c")
      return iE(e) || s1(e, 1, r) || Do(e, 1);
    if (r == (Wn ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function xv(e, t) {
  e.someProp("transformCopied", (h) => {
    t = h(t, e);
  });
  let n = [], { content: r, openStart: i, openEnd: o } = t;
  for (; i > 1 && o > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, o--;
    let h = r.firstChild;
    n.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let a = e.someProp("clipboardSerializer") || Nr.fromSchema(e.state.schema), s = Ev(), l = s.createElement("div");
  l.appendChild(a.serializeFragment(r, { document: s }));
  let d = l.firstChild, u, c = 0;
  for (; d && d.nodeType == 1 && (u = Ov[d.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let p = s.createElement(u[h]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), c++;
    }
    d = l.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${i} ${o}${c ? ` -${c}` : ""} ${JSON.stringify(n)}`);
  let f = e.someProp("clipboardTextSerializer", (h) => h(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: l, text: f };
}
function Sv(e, t, n, r, i) {
  let o = i.parent.type.spec.code, a, s;
  if (!n && !t)
    return null;
  let l = t && (r || o || !n);
  if (l) {
    if (e.someProp("transformPastedText", (f) => {
      t = f(t, o || r, e);
    }), o)
      return t ? new Ae(ve.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0) : Ae.empty;
    let c = e.someProp("clipboardTextParser", (f) => f(t, i, r, e));
    if (c)
      s = c;
    else {
      let f = i.marks(), { schema: h } = e.state, p = Nr.fromSchema(h);
      a = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let g = a.appendChild(document.createElement("p"));
        m && g.appendChild(p.serializeNode(h.text(m, f)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (c) => {
      n = c(n, e);
    }), a = dE(n), ws && uE(a);
  let d = a && a.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let c = +u[3]; c > 0; c--) {
      let f = a.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      a = f;
    }
  if (s || (s = (e.someProp("clipboardParser") || e.someProp("domParser") || oa.fromSchema(e.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(l || u),
    context: i,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !sE.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = cE(u1(s, +u[1], +u[2]), u[4]);
  else if (s = Ae.maxOpen(lE(s.content, i), !0), s.openStart || s.openEnd) {
    let c = 0, f = 0;
    for (let h = s.content.firstChild; c < s.openStart && !h.type.spec.isolating; c++, h = h.firstChild)
      ;
    for (let h = s.content.lastChild; f < s.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    s = u1(s, c, f);
  }
  return e.someProp("transformPasted", (c) => {
    s = c(s, e);
  }), s;
}
const sE = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function lE(e, t) {
  if (e.childCount < 2)
    return e;
  for (let n = t.depth; n >= 0; n--) {
    let i = t.node(n).contentMatchAt(t.index(n)), o, a = [];
    if (e.forEach((s) => {
      if (!a)
        return;
      let l = i.findWrapping(s.type), d;
      if (!l)
        return a = null;
      if (d = a.length && o.length && Tv(l, o, s, a[a.length - 1], 0))
        a[a.length - 1] = d;
      else {
        a.length && (a[a.length - 1] = Mv(a[a.length - 1], o.length));
        let u = Cv(s, l);
        a.push(u), i = i.matchType(u.type), o = l;
      }
    }), a)
      return ve.from(a);
  }
  return e;
}
function Cv(e, t, n = 0) {
  for (let r = t.length - 1; r >= n; r--)
    e = t[r].create(null, ve.from(e));
  return e;
}
function Tv(e, t, n, r, i) {
  if (i < e.length && i < t.length && e[i] == t[i]) {
    let o = Tv(e, t, n, r.lastChild, i + 1);
    if (o)
      return r.copy(r.content.replaceChild(r.childCount - 1, o));
    if (r.contentMatchAt(r.childCount).matchType(i == e.length - 1 ? n.type : e[i + 1]))
      return r.copy(r.content.append(ve.from(Cv(n, e, i + 1))));
  }
}
function Mv(e, t) {
  if (t == 0)
    return e;
  let n = e.content.replaceChild(e.childCount - 1, Mv(e.lastChild, t - 1)), r = e.contentMatchAt(e.childCount).fillBefore(ve.empty, !0);
  return e.copy(n.append(r));
}
function Pc(e, t, n, r, i, o) {
  let a = t < 0 ? e.firstChild : e.lastChild, s = a.content;
  return e.childCount > 1 && (o = 0), i < r - 1 && (s = Pc(s, t, n, r, i + 1, o)), i >= n && (s = t < 0 ? a.contentMatchAt(0).fillBefore(s, o <= i).append(s) : s.append(a.contentMatchAt(a.childCount).fillBefore(ve.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, a.copy(s));
}
function u1(e, t, n) {
  return t < e.openStart && (e = new Ae(Pc(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new Ae(Pc(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const Ov = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let c1 = null;
function Ev() {
  return c1 || (c1 = document.implementation.createHTMLDocument("title"));
}
function dE(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let n = Ev().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(e), i;
  if ((i = r && Ov[r[1].toLowerCase()]) && (e = i.map((o) => "<" + o + ">").join("") + e + i.map((o) => "</" + o + ">").reverse().join("")), n.innerHTML = e, i)
    for (let o = 0; o < i.length; o++)
      n = n.querySelector(i[o]) || n;
  return n;
}
function uE(e) {
  let t = e.querySelectorAll(hn ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), r);
  }
}
function cE(e, t) {
  if (!e.size)
    return e;
  let n = e.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: i, openStart: o, openEnd: a } = e;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let l = n.nodes[r[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = ve.from(l.create(r[s + 1], i)), o++, a++;
  }
  return new Ae(i, o, a);
}
const $n = {}, wn = {}, fE = { touchstart: !0, touchmove: !0 };
class pE {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function hE(e) {
  for (let t in $n) {
    let n = $n[t];
    e.dom.addEventListener(t, e.input.eventHandlers[t] = (r) => {
      gE(e, r) && !vf(e, r) && (e.editable || !(r.type in wn)) && n(e, r);
    }, fE[t] ? { passive: !0 } : void 0);
  }
  bn && e.dom.addEventListener("input", () => null), Nc(e);
}
function Oi(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function mE(e) {
  e.domObserver.stop();
  for (let t in e.input.eventHandlers)
    e.dom.removeEventListener(t, e.input.eventHandlers[t]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function Nc(e) {
  e.someProp("handleDOMEvents", (t) => {
    for (let n in t)
      e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (r) => vf(e, r));
  });
}
function vf(e, t) {
  return e.someProp("handleDOMEvents", (n) => {
    let r = n[t.type];
    return r ? r(e, t) || t.defaultPrevented : !1;
  });
}
function gE(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target; n != e.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(t))
      return !1;
  return !0;
}
function vE(e, t) {
  !vf(e, t) && $n[t.type] && (e.editable || !(t.type in wn)) && $n[t.type](e, t);
}
wn.keydown = (e, t) => {
  let n = t;
  if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !Av(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(nr && hn && n.keyCode == 13)))
    if (n.keyCode != 229 && e.domObserver.forceFlush(), la && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      e.input.lastIOSEnter = r, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == r && (e.someProp("handleKeyDown", (i) => i(e, Gi(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (r) => r(e, n)) || aE(e, n) ? n.preventDefault() : Oi(e, "key");
};
wn.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
wn.keypress = (e, t) => {
  let n = t;
  if (Av(e, n) || !n.charCode || n.ctrlKey && !n.altKey || Wn && n.metaKey)
    return;
  if (e.someProp("handleKeyPress", (i) => i(e, n))) {
    n.preventDefault();
    return;
  }
  let r = e.state.selection;
  if (!(r instanceof Xe) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(i) && !e.someProp("handleTextInput", (o) => o(e, r.$from.pos, r.$to.pos, i)) && e.dispatch(e.state.tr.insertText(i).scrollIntoView()), n.preventDefault();
  }
};
function Pd(e) {
  return { left: e.clientX, top: e.clientY };
}
function yE(e, t) {
  let n = t.x - e.clientX, r = t.y - e.clientY;
  return n * n + r * r < 100;
}
function yf(e, t, n, r, i) {
  if (r == -1)
    return !1;
  let o = e.state.doc.resolve(r);
  for (let a = o.depth + 1; a > 0; a--)
    if (e.someProp(t, (s) => a > o.depth ? s(e, n, o.nodeAfter, o.before(a), i, !0) : s(e, n, o.node(a), o.before(a), i, !1)))
      return !0;
  return !1;
}
function Yo(e, t, n) {
  e.focused || e.focus();
  let r = e.state.tr.setSelection(t);
  r.setMeta("pointer", !0), e.dispatch(r);
}
function bE(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.doc.resolve(t), r = n.nodeAfter;
  return r && r.isAtom && He.isSelectable(r) ? (Yo(e, new He(n)), !0) : !1;
}
function $E(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.selection, r, i;
  n instanceof He && (r = n.node);
  let o = e.state.doc.resolve(t);
  for (let a = o.depth + 1; a > 0; a--) {
    let s = a > o.depth ? o.nodeAfter : o.node(a);
    if (He.isSelectable(s)) {
      r && n.$from.depth > 0 && a >= n.$from.depth && o.before(n.$from.depth + 1) == n.$from.pos ? i = o.before(n.$from.depth) : i = o.before(a);
      break;
    }
  }
  return i != null ? (Yo(e, He.create(e.state.doc, i)), !0) : !1;
}
function wE(e, t, n, r, i) {
  return yf(e, "handleClickOn", t, n, r) || e.someProp("handleClick", (o) => o(e, t, r)) || (i ? $E(e, n) : bE(e, n));
}
function kE(e, t, n, r) {
  return yf(e, "handleDoubleClickOn", t, n, r) || e.someProp("handleDoubleClick", (i) => i(e, t, r));
}
function xE(e, t, n, r) {
  return yf(e, "handleTripleClickOn", t, n, r) || e.someProp("handleTripleClick", (i) => i(e, t, r)) || SE(e, n, r);
}
function SE(e, t, n) {
  if (n.button != 0)
    return !1;
  let r = e.state.doc;
  if (t == -1)
    return r.inlineContent ? (Yo(e, Xe.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(t);
  for (let o = i.depth + 1; o > 0; o--) {
    let a = o > i.depth ? i.nodeAfter : i.node(o), s = i.before(o);
    if (a.inlineContent)
      Yo(e, Xe.create(r, s + 1, s + 1 + a.content.size));
    else if (He.isSelectable(a))
      Yo(e, He.create(r, s));
    else
      continue;
    return !0;
  }
}
function bf(e) {
  return Sl(e);
}
const Dv = Wn ? "metaKey" : "ctrlKey";
$n.mousedown = (e, t) => {
  let n = t;
  e.input.shiftKey = n.shiftKey;
  let r = bf(e), i = Date.now(), o = "singleClick";
  i - e.input.lastClick.time < 500 && yE(n, e.input.lastClick) && !n[Dv] && (e.input.lastClick.type == "singleClick" ? o = "doubleClick" : e.input.lastClick.type == "doubleClick" && (o = "tripleClick")), e.input.lastClick = { time: i, x: n.clientX, y: n.clientY, type: o };
  let a = e.posAtCoords(Pd(n));
  a && (o == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new CE(e, a, n, !!r)) : (o == "doubleClick" ? kE : xE)(e, a.pos, a.inside, n) ? n.preventDefault() : Oi(e, "pointer"));
};
class CE {
  constructor(t, n, r, i) {
    this.view = t, this.pos = n, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!r[Dv], this.allowDefault = r.shiftKey;
    let o, a;
    if (n.inside > -1)
      o = t.state.doc.nodeAt(n.inside), a = n.inside;
    else {
      let u = t.state.doc.resolve(n.pos);
      o = u.parent, a = u.depth ? u.before() : 0;
    }
    const s = i ? null : r.target, l = s ? t.docView.nearestDesc(s, !0) : null;
    this.target = l ? l.dom : null;
    let { selection: d } = t.state;
    (r.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || d instanceof He && d.from <= a && d.to > a) && (this.mightDrag = {
      node: o,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && fr && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), Oi(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => si(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(Pd(t))), this.updateAllowDefault(t), this.allowDefault || !n ? Oi(this.view, "pointer") : wE(this.view, n.pos, n.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    bn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    hn && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (Yo(this.view, rt.near(this.view.state.doc.resolve(n.pos))), t.preventDefault()) : Oi(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), Oi(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
$n.touchstart = (e) => {
  e.input.lastTouch = Date.now(), bf(e), Oi(e, "pointer");
};
$n.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Oi(e, "pointer");
};
$n.contextmenu = (e) => bf(e);
function Av(e, t) {
  return e.composing ? !0 : bn && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const TE = nr ? 5e3 : -1;
wn.compositionstart = wn.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, n = t.selection.$from;
    if (t.selection.empty && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || n.marks(), Sl(e, !0), e.markCursor = null;
    else if (Sl(e), fr && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = e.domSelectionRange();
      for (let i = r.focusNode, o = r.focusOffset; i && i.nodeType == 1 && o != 0; ) {
        let a = o < 0 ? i.lastChild : i.childNodes[o - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          e.domSelection().collapse(a, a.nodeValue.length);
          break;
        } else
          i = a, o = -1;
      }
    }
    e.input.composing = !0;
  }
  Pv(e, TE);
};
wn.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, Pv(e, 20));
};
function Pv(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => Sl(e), t));
}
function Nv(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = ME()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function ME() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function Sl(e, t = !1) {
  if (!(nr && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), Nv(e), t || e.docView && e.docView.dirty) {
      let n = mf(e);
      return n && !n.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(n)) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function OE(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(t), e.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), e.focus();
  }, 50);
}
const ts = On && Ai < 15 || la && CO < 604;
$n.copy = wn.cut = (e, t) => {
  let n = t, r = e.state.selection, i = n.type == "cut";
  if (r.empty)
    return;
  let o = ts ? null : n.clipboardData, a = r.content(), { dom: s, text: l } = xv(e, a);
  o ? (n.preventDefault(), o.clearData(), o.setData("text/html", s.innerHTML), o.setData("text/plain", l)) : OE(e, s), i && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function EE(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function DE(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, r = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), r.parentNode && r.parentNode.removeChild(r), n ? ns(e, r.value, null, i, t) : ns(e, r.textContent, r.innerHTML, i, t);
  }, 50);
}
function ns(e, t, n, r, i) {
  let o = Sv(e, t, n, r, e.state.selection.$from);
  if (e.someProp("handlePaste", (l) => l(e, i, o || Ae.empty)))
    return !0;
  if (!o)
    return !1;
  let a = EE(o), s = a ? e.state.tr.replaceSelectionWith(a, r) : e.state.tr.replaceSelection(o);
  return e.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Iv(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t)
    return t;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
wn.paste = (e, t) => {
  let n = t;
  if (e.composing && !nr)
    return;
  let r = ts ? null : n.clipboardData, i = e.input.shiftKey && e.input.lastKeyCode != 45;
  r && ns(e, Iv(r), r.getData("text/html"), i, n) ? n.preventDefault() : DE(e, n);
};
class Rv {
  constructor(t, n, r) {
    this.slice = t, this.move = n, this.node = r;
  }
}
const _v = Wn ? "altKey" : "ctrlKey";
$n.dragstart = (e, t) => {
  let n = t, r = e.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let i = e.state.selection, o = i.empty ? null : e.posAtCoords(Pd(n)), a;
  if (!(o && o.pos >= i.from && o.pos <= (i instanceof He ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      a = He.create(e.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let u = e.docView.nearestDesc(n.target, !0);
      u && u.node.type.spec.draggable && u != e.docView && (a = He.create(e.state.doc, u.posBefore));
    }
  }
  let s = (a || e.state.selection).content(), { dom: l, text: d } = xv(e, s);
  n.dataTransfer.clearData(), n.dataTransfer.setData(ts ? "Text" : "text/html", l.innerHTML), n.dataTransfer.effectAllowed = "copyMove", ts || n.dataTransfer.setData("text/plain", d), e.dragging = new Rv(s, !n[_v], a);
};
$n.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
wn.dragover = wn.dragenter = (e, t) => t.preventDefault();
wn.drop = (e, t) => {
  let n = t, r = e.dragging;
  if (e.dragging = null, !n.dataTransfer)
    return;
  let i = e.posAtCoords(Pd(n));
  if (!i)
    return;
  let o = e.state.doc.resolve(i.pos), a = r && r.slice;
  a ? e.someProp("transformPasted", (p) => {
    a = p(a, e);
  }) : a = Sv(e, Iv(n.dataTransfer), ts ? null : n.dataTransfer.getData("text/html"), !1, o);
  let s = !!(r && !n[_v]);
  if (e.someProp("handleDrop", (p) => p(e, n, a || Ae.empty, s))) {
    n.preventDefault();
    return;
  }
  if (!a)
    return;
  n.preventDefault();
  let l = a ? Zg(e.state.doc, o.pos, a) : o.pos;
  l == null && (l = o.pos);
  let d = e.state.tr;
  if (s) {
    let { node: p } = r;
    p ? p.replace(d) : d.deleteSelection();
  }
  let u = d.mapping.map(l), c = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, f = d.doc;
  if (c ? d.replaceRangeWith(u, u, a.content.firstChild) : d.replaceRange(u, u, a), d.doc.eq(f))
    return;
  let h = d.doc.resolve(u);
  if (c && He.isSelectable(a.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(a.content.firstChild))
    d.setSelection(new He(h));
  else {
    let p = d.mapping.map(l);
    d.mapping.maps[d.mapping.maps.length - 1].forEach((m, g, v, b) => p = b), d.setSelection(gf(e, h, d.doc.resolve(p)));
  }
  e.focus(), e.dispatch(d.setMeta("uiEvent", "drop"));
};
$n.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && si(e);
  }, 20));
};
$n.blur = (e, t) => {
  let n = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
$n.beforeinput = (e, t) => {
  if (hn && nr && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: r } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != r || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (o) => o(e, Gi(8, "Backspace")))))
        return;
      let { $cursor: i } = e.state.selection;
      i && i.pos > 0 && e.dispatch(e.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in wn)
  $n[e] = wn[e];
function rs(e, t) {
  if (e == t)
    return !0;
  for (let n in e)
    if (e[n] !== t[n])
      return !1;
  for (let n in t)
    if (!(n in e))
      return !1;
  return !0;
}
class Cl {
  constructor(t, n) {
    this.toDOM = t, this.spec = n || lo, this.side = this.spec.side || 0;
  }
  map(t, n, r, i) {
    let { pos: o, deleted: a } = t.mapResult(n.from + i, this.side < 0 ? -1 : 1);
    return a ? null : new qn(o - r, o - r, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof Cl && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && rs(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}
class Ni {
  constructor(t, n) {
    this.attrs = t, this.spec = n || lo;
  }
  map(t, n, r, i) {
    let o = t.map(n.from + i, this.spec.inclusiveStart ? -1 : 1) - r, a = t.map(n.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return o >= a ? null : new qn(o, a, this);
  }
  valid(t, n) {
    return n.from < n.to;
  }
  eq(t) {
    return this == t || t instanceof Ni && rs(this.attrs, t.attrs) && rs(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof Ni;
  }
  destroy() {
  }
}
class $f {
  constructor(t, n) {
    this.attrs = t, this.spec = n || lo;
  }
  map(t, n, r, i) {
    let o = t.mapResult(n.from + i, 1);
    if (o.deleted)
      return null;
    let a = t.mapResult(n.to + i, -1);
    return a.deleted || a.pos <= o.pos ? null : new qn(o.pos - r, a.pos - r, this);
  }
  valid(t, n) {
    let { index: r, offset: i } = t.content.findIndex(n.from), o;
    return i == n.from && !(o = t.child(r)).isText && i + o.nodeSize == n.to;
  }
  eq(t) {
    return this == t || t instanceof $f && rs(this.attrs, t.attrs) && rs(this.spec, t.spec);
  }
  destroy() {
  }
}
class qn {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.from = t, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(t, n) {
    return new qn(t, n, this.type);
  }
  /**
  @internal
  */
  eq(t, n = 0) {
    return this.type.eq(t.type) && this.from + n == t.from && this.to + n == t.to;
  }
  /**
  @internal
  */
  map(t, n, r) {
    return this.type.map(t, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, n, r) {
    return new qn(t, t, new Cl(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, n, r, i) {
    return new qn(t, n, new Ni(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, n, r, i) {
    return new qn(t, n, new $f(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Ni;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Cl;
  }
}
const _o = [], lo = {};
class Kt {
  /**
  @internal
  */
  constructor(t, n) {
    this.local = t.length ? t : _o, this.children = n.length ? n : _o;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(t, n) {
    return n.length ? Tl(n, t, 0, lo) : pn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, n, r) {
    let i = [];
    return this.findInner(t == null ? 0 : t, n == null ? 1e9 : n, i, 0, r), i;
  }
  findInner(t, n, r, i, o) {
    for (let a = 0; a < this.local.length; a++) {
      let s = this.local[a];
      s.from <= n && s.to >= t && (!o || o(s.spec)) && r.push(s.copy(s.from + i, s.to + i));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < n && this.children[a + 1] > t) {
        let s = this.children[a] + 1;
        this.children[a + 2].findInner(t - s, n - s, r, i + s, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, n, r) {
    return this == pn || t.maps.length == 0 ? this : this.mapInner(t, n, 0, 0, r || lo);
  }
  /**
  @internal
  */
  mapInner(t, n, r, i, o) {
    let a;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(t, r, i);
      l && l.type.valid(n, l) ? (a || (a = [])).push(l) : o.onRemove && o.onRemove(this.local[s].spec);
    }
    return this.children.length ? AE(this.children, a || [], t, n, r, i, o) : a ? new Kt(a.sort(uo), _o) : pn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(t, n) {
    return n.length ? this == pn ? Kt.create(t, n) : this.addInner(t, n, 0) : this;
  }
  addInner(t, n, r) {
    let i, o = 0;
    t.forEach((s, l) => {
      let d = l + r, u;
      if (u = Fv(n, s, d)) {
        for (i || (i = this.children.slice()); o < i.length && i[o] < l; )
          o += 3;
        i[o] == l ? i[o + 2] = i[o + 2].addInner(s, u, d + 1) : i.splice(o, 0, l, l + s.nodeSize, Tl(u, s, d + 1, lo)), o += 3;
      }
    });
    let a = Lv(o ? Bv(n) : n, -r);
    for (let s = 0; s < a.length; s++)
      a[s].type.valid(t, a[s]) || a.splice(s--, 1);
    return new Kt(a.length ? this.local.concat(a).sort(uo) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == pn ? this : this.removeInner(t, 0);
  }
  removeInner(t, n) {
    let r = this.children, i = this.local;
    for (let o = 0; o < r.length; o += 3) {
      let a, s = r[o] + n, l = r[o + 1] + n;
      for (let u = 0, c; u < t.length; u++)
        (c = t[u]) && c.from > s && c.to < l && (t[u] = null, (a || (a = [])).push(c));
      if (!a)
        continue;
      r == this.children && (r = this.children.slice());
      let d = r[o + 2].removeInner(a, s + 1);
      d != pn ? r[o + 2] = d : (r.splice(o, 3), o -= 3);
    }
    if (i.length) {
      for (let o = 0, a; o < t.length; o++)
        if (a = t[o])
          for (let s = 0; s < i.length; s++)
            i[s].eq(a, n) && (i == this.local && (i = this.local.slice()), i.splice(s--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new Kt(i, r) : pn;
  }
  forChild(t, n) {
    if (this == pn)
      return this;
    if (n.isLeaf)
      return Kt.empty;
    let r, i;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= t) {
        this.children[s] == t && (r = this.children[s + 2]);
        break;
      }
    let o = t + 1, a = o + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < a && l.to > o && l.type instanceof Ni) {
        let d = Math.max(o, l.from) - o, u = Math.min(a, l.to) - o;
        d < u && (i || (i = [])).push(l.copy(d, u));
      }
    }
    if (i) {
      let s = new Kt(i.sort(uo), _o);
      return r ? new xi([s, r]) : s;
    }
    return r || pn;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof Kt) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(t.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != t.children[n] || this.children[n + 1] != t.children[n + 1] || !this.children[n + 2].eq(t.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return wf(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == pn)
      return _o;
    if (t.inlineContent || !this.local.some(Ni.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Ni || n.push(this.local[r]);
    return n;
  }
}
Kt.empty = new Kt([], []);
Kt.removeOverlap = wf;
const pn = Kt.empty;
class xi {
  constructor(t) {
    this.members = t;
  }
  map(t, n) {
    const r = this.members.map((i) => i.map(t, n, lo));
    return xi.from(r);
  }
  forChild(t, n) {
    if (n.isLeaf)
      return Kt.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].forChild(t, n);
      o != pn && (o instanceof xi ? r = r.concat(o.members) : r.push(o));
    }
    return xi.from(r);
  }
  eq(t) {
    if (!(t instanceof xi) || t.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(t.members[n]))
        return !1;
    return !0;
  }
  locals(t) {
    let n, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].localsInner(t);
      if (o.length)
        if (!n)
          n = o;
        else {
          r && (n = n.slice(), r = !1);
          for (let a = 0; a < o.length; a++)
            n.push(o[a]);
        }
    }
    return n ? wf(r ? n : n.sort(uo)) : _o;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return pn;
      case 1:
        return t[0];
      default:
        return new xi(t.every((n) => n instanceof Kt) ? t : t.reduce((n, r) => n.concat(r instanceof Kt ? r : r.members), []));
    }
  }
}
function AE(e, t, n, r, i, o, a) {
  let s = e.slice();
  for (let d = 0, u = o; d < n.maps.length; d++) {
    let c = 0;
    n.maps[d].forEach((f, h, p, m) => {
      let g = m - p - (h - f);
      for (let v = 0; v < s.length; v += 3) {
        let b = s[v + 1];
        if (b < 0 || f > b + u - c)
          continue;
        let x = s[v] + u - c;
        h >= x ? s[v + 1] = f <= x ? -2 : -1 : f >= u && g && (s[v] += g, s[v + 1] += g);
      }
      c += g;
    }), u = n.maps[d].map(u, -1);
  }
  let l = !1;
  for (let d = 0; d < s.length; d += 3)
    if (s[d + 1] < 0) {
      if (s[d + 1] == -2) {
        l = !0, s[d + 1] = -1;
        continue;
      }
      let u = n.map(e[d] + o), c = u - i;
      if (c < 0 || c >= r.content.size) {
        l = !0;
        continue;
      }
      let f = n.map(e[d + 1] + o, -1), h = f - i, { index: p, offset: m } = r.content.findIndex(c), g = r.maybeChild(p);
      if (g && m == c && m + g.nodeSize == h) {
        let v = s[d + 2].mapInner(n, g, u + 1, e[d] + o + 1, a);
        v != pn ? (s[d] = c, s[d + 1] = h, s[d + 2] = v) : (s[d + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let d = PE(s, e, t, n, i, o, a), u = Tl(d, r, 0, a);
    t = u.local;
    for (let c = 0; c < s.length; c += 3)
      s[c + 1] < 0 && (s.splice(c, 3), c -= 3);
    for (let c = 0, f = 0; c < u.children.length; c += 3) {
      let h = u.children[c];
      for (; f < s.length && s[f] < h; )
        f += 3;
      s.splice(f, 0, u.children[c], u.children[c + 1], u.children[c + 2]);
    }
  }
  return new Kt(t.sort(uo), s);
}
function Lv(e, t) {
  if (!t || !e.length)
    return e;
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r];
    n.push(new qn(i.from + t, i.to + t, i.type));
  }
  return n;
}
function PE(e, t, n, r, i, o, a) {
  function s(l, d) {
    for (let u = 0; u < l.local.length; u++) {
      let c = l.local[u].map(r, i, d);
      c ? n.push(c) : a.onRemove && a.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      s(l.children[u + 2], l.children[u] + d + 1);
  }
  for (let l = 0; l < e.length; l += 3)
    e[l + 1] == -1 && s(e[l + 2], t[l] + o + 1);
  return n;
}
function Fv(e, t, n) {
  if (t.isLeaf)
    return null;
  let r = n + t.nodeSize, i = null;
  for (let o = 0, a; o < e.length; o++)
    (a = e[o]) && a.from > n && a.to < r && ((i || (i = [])).push(a), e[o] = null);
  return i;
}
function Bv(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    e[n] != null && t.push(e[n]);
  return t;
}
function Tl(e, t, n, r) {
  let i = [], o = !1;
  t.forEach((s, l) => {
    let d = Fv(e, s, l + n);
    if (d) {
      o = !0;
      let u = Tl(d, s, n + l + 1, r);
      u != pn && i.push(l, l + s.nodeSize, u);
    }
  });
  let a = Lv(o ? Bv(e) : e, -n).sort(uo);
  for (let s = 0; s < a.length; s++)
    a[s].type.valid(t, a[s]) || (r.onRemove && r.onRemove(a[s].spec), a.splice(s--, 1));
  return a.length || i.length ? new Kt(a, i) : pn;
}
function uo(e, t) {
  return e.from - t.from || e.to - t.to;
}
function wf(e) {
  let t = e;
  for (let n = 0; n < t.length - 1; n++) {
    let r = t[n];
    if (r.from != r.to)
      for (let i = n + 1; i < t.length; i++) {
        let o = t[i];
        if (o.from == r.from) {
          o.to != r.to && (t == e && (t = e.slice()), t[i] = o.copy(o.from, r.to), f1(t, i + 1, o.copy(r.to, o.to)));
          continue;
        } else {
          o.from < r.to && (t == e && (t = e.slice()), t[n] = r.copy(r.from, o.from), f1(t, i, r.copy(o.from, r.to)));
          break;
        }
      }
  }
  return t;
}
function f1(e, t, n) {
  for (; t < e.length && uo(n, e[t]) > 0; )
    t++;
  e.splice(t, 0, n);
}
function Au(e) {
  let t = [];
  return e.someProp("decorations", (n) => {
    let r = n(e.state);
    r && r != pn && t.push(r);
  }), e.cursorWrapper && t.push(Kt.create(e.state.doc, [e.cursorWrapper.deco])), xi.from(t);
}
const NE = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, IE = On && Ai <= 11;
class RE {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(t) {
    this.anchorNode = t.anchorNode, this.anchorOffset = t.anchorOffset, this.focusNode = t.focusNode, this.focusOffset = t.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(t) {
    return t.anchorNode == this.anchorNode && t.anchorOffset == this.anchorOffset && t.focusNode == this.focusNode && t.focusOffset == this.focusOffset;
  }
}
class _E {
  constructor(t, n) {
    this.view = t, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new RE(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      On && Ai <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), IE && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, NE)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let t = this.observer.takeRecords();
      if (t.length) {
        for (let n = 0; n < t.length; n++)
          this.queue.push(t[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (i1(this.view)) {
      if (this.suppressingSelectionUpdates)
        return si(this.view);
      if (On && Ai <= 11 && !this.view.state.selection.empty) {
        let t = this.view.domSelectionRange();
        if (t.focusNode && go(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(t) {
    if (!t.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let o = t.focusNode; o; o = es(o))
      n.add(o);
    for (let o = t.anchorNode; o; o = es(o))
      if (n.has(o)) {
        r = o;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let t of this.observer.takeRecords())
        this.queue.push(t);
    return this.queue;
  }
  flush() {
    let { view: t } = this;
    if (!t.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = t.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && i1(t) && !this.ignoreSelectionChange(r), o = -1, a = -1, s = !1, l = [];
    if (t.editable)
      for (let u = 0; u < n.length; u++) {
        let c = this.registerMutation(n[u], l);
        c && (o = o < 0 ? c.from : Math.min(c.from, o), a = a < 0 ? c.to : Math.max(c.to, a), c.typeOver && (s = !0));
      }
    if (fr && l.length > 1) {
      let u = l.filter((c) => c.nodeName == "BR");
      if (u.length == 2) {
        let c = u[0], f = u[1];
        c.parentNode && c.parentNode.parentNode == f.parentNode ? f.remove() : c.remove();
      }
    }
    let d = null;
    o < 0 && i && t.input.lastFocus > Date.now() - 200 && Math.max(t.input.lastTouch, t.input.lastClick.time) < Date.now() - 300 && Dd(r) && (d = mf(t)) && d.eq(rt.near(t.state.doc.resolve(0), 1)) ? (t.input.lastFocus = 0, si(t), this.currentSelection.set(r), t.scrollToSelection()) : (o > -1 || i) && (o > -1 && (t.docView.markDirty(o, a), LE(t)), this.handleDOMChange(o, a, s, l), t.docView && t.docView.dirty ? t.updateState(t.state) : this.currentSelection.eq(r) || si(t), this.currentSelection.set(r));
  }
  registerMutation(t, n) {
    if (n.indexOf(t.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(t.target);
    if (t.type == "attributes" && (r == this.view.docView || t.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    t.attributeName == "style" && !t.oldValue && !t.target.getAttribute("style")) || !r || r.ignoreMutation(t))
      return null;
    if (t.type == "childList") {
      for (let u = 0; u < t.addedNodes.length; u++)
        n.push(t.addedNodes[u]);
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(t.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = t.previousSibling, o = t.nextSibling;
      if (On && Ai <= 11 && t.addedNodes.length)
        for (let u = 0; u < t.addedNodes.length; u++) {
          let { previousSibling: c, nextSibling: f } = t.addedNodes[u];
          (!c || Array.prototype.indexOf.call(t.addedNodes, c) < 0) && (i = c), (!f || Array.prototype.indexOf.call(t.addedNodes, f) < 0) && (o = f);
        }
      let a = i && i.parentNode == t.target ? vn(i) + 1 : 0, s = r.localPosFromDOM(t.target, a, -1), l = o && o.parentNode == t.target ? vn(o) : t.target.childNodes.length, d = r.localPosFromDOM(t.target, l, 1);
      return { from: s, to: d };
    } else return t.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: t.target.nodeValue == t.oldValue
    };
  }
}
let p1 = /* @__PURE__ */ new WeakMap(), h1 = !1;
function LE(e) {
  if (!p1.has(e) && (p1.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = fr, h1)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), h1 = !0;
  }
}
function FE(e) {
  let t;
  function n(l) {
    l.preventDefault(), l.stopImmediatePropagation(), t = l.getTargetRanges()[0];
  }
  e.dom.addEventListener("beforeinput", n, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", n, !0);
  let r = t.startContainer, i = t.startOffset, o = t.endContainer, a = t.endOffset, s = e.domAtPos(e.state.selection.anchor);
  return go(s.node, s.offset, o, a) && ([r, i, o, a] = [o, a, r, i]), { anchorNode: r, anchorOffset: i, focusNode: o, focusOffset: a };
}
function BE(e, t, n) {
  let { node: r, fromOffset: i, toOffset: o, from: a, to: s } = e.docView.parseRange(t, n), l = e.domSelectionRange(), d, u = l.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: l.anchorOffset }], Dd(l) || d.push({ node: l.focusNode, offset: l.focusOffset })), hn && e.input.lastKeyCode === 8)
    for (let g = o; g > i; g--) {
      let v = r.childNodes[g - 1], b = v.pmViewDesc;
      if (v.nodeName == "BR" && !b) {
        o = g;
        break;
      }
      if (!b || b.size)
        break;
    }
  let c = e.state.doc, f = e.someProp("domParser") || oa.fromSchema(e.state.schema), h = c.resolve(a), p = null, m = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: i,
    to: o,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: zE,
    context: h
  });
  if (d && d[0].pos != null) {
    let g = d[0].pos, v = d[1] && d[1].pos;
    v == null && (v = g), p = { anchor: g + a, head: v + a };
  }
  return { doc: m, sel: p, from: a, to: s };
}
function zE(e) {
  let t = e.pmViewDesc;
  if (t)
    return t.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (bn && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (e.parentNode.lastChild == e || bn && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const VE = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function HE(e, t, n, r, i) {
  let o = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, t < 0) {
    let P = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, U = mf(e, P);
    if (U && !e.state.selection.eq(U)) {
      if (hn && nr && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (W) => W(e, Gi(13, "Enter"))))
        return;
      let ie = e.state.tr.setSelection(U);
      P == "pointer" ? ie.setMeta("pointer", !0) : P == "key" && ie.scrollIntoView(), o && ie.setMeta("composition", o), e.dispatch(ie);
    }
    return;
  }
  let a = e.state.doc.resolve(t), s = a.sharedDepth(n);
  t = a.before(s + 1), n = e.state.doc.resolve(n).after(s + 1);
  let l = e.state.selection, d = BE(e, t, n), u = e.state.doc, c = u.slice(d.from, d.to), f, h;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (f = e.state.selection.to, h = "end") : (f = e.state.selection.from, h = "start"), e.input.lastKeyCode = null;
  let p = UE(c.content, d.doc.content, d.from, f, h);
  if ((la && e.input.lastIOSEnter > Date.now() - 225 || nr) && i.some((P) => P.nodeType == 1 && !VE.test(P.nodeName)) && (!p || p.endA >= p.endB) && e.someProp("handleKeyDown", (P) => P(e, Gi(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (r && l instanceof Xe && !l.empty && l.$head.sameParent(l.$anchor) && !e.composing && !(d.sel && d.sel.anchor != d.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (d.sel) {
        let P = m1(e, e.state.doc, d.sel);
        if (P && !P.eq(e.state.selection)) {
          let U = e.state.tr.setSelection(P);
          o && U.setMeta("composition", o), e.dispatch(U);
        }
      }
      return;
    }
  if (hn && e.cursorWrapper && d.sel && d.sel.anchor == e.cursorWrapper.deco.from && d.sel.head == d.sel.anchor) {
    let P = p.endB - p.start;
    d.sel = { anchor: d.sel.anchor + P, head: d.sel.anchor + P };
  }
  e.input.domChangeCount++, e.state.selection.from < e.state.selection.to && p.start == p.endB && e.state.selection instanceof Xe && (p.start > e.state.selection.from && p.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? p.start = e.state.selection.from : p.endA < e.state.selection.to && p.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (p.endB += e.state.selection.to - p.endA, p.endA = e.state.selection.to)), On && Ai <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > d.from && d.doc.textBetween(p.start - d.from - 1, p.start - d.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let m = d.doc.resolveNoCache(p.start - d.from), g = d.doc.resolveNoCache(p.endB - d.from), v = u.resolve(p.start), b = m.sameParent(g) && m.parent.inlineContent && v.end() >= p.endA, x;
  if ((la && e.input.lastIOSEnter > Date.now() - 225 && (!b || i.some((P) => P.nodeName == "DIV" || P.nodeName == "P")) || !b && m.pos < d.doc.content.size && !m.sameParent(g) && (x = rt.findFrom(d.doc.resolve(m.pos + 1), 1, !0)) && x.head == g.pos) && e.someProp("handleKeyDown", (P) => P(e, Gi(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > p.start && WE(u, p.start, p.endA, m, g) && e.someProp("handleKeyDown", (P) => P(e, Gi(8, "Backspace")))) {
    nr && hn && e.domObserver.suppressSelectionUpdates();
    return;
  }
  hn && nr && p.endB == p.start && (e.input.lastAndroidDelete = Date.now()), nr && !b && m.start() != g.start() && g.parentOffset == 0 && m.depth == g.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == p.endA && (p.endB -= 2, g = d.doc.resolveNoCache(p.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(P) {
      return P(e, Gi(13, "Enter"));
    });
  }, 20));
  let y = p.start, C = p.endA, $, O, z;
  if (b) {
    if (m.pos == g.pos)
      On && Ai <= 11 && m.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => si(e), 20)), $ = e.state.tr.delete(y, C), O = u.resolve(p.start).marksAcross(u.resolve(p.endA));
    else if (
      // Adding or removing a mark
      p.endA == p.endB && (z = jE(m.parent.content.cut(m.parentOffset, g.parentOffset), v.parent.content.cut(v.parentOffset, p.endA - v.start())))
    )
      $ = e.state.tr, z.type == "add" ? $.addMark(y, C, z.mark) : $.removeMark(y, C, z.mark);
    else if (m.parent.child(m.index()).isText && m.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let P = m.parent.textBetween(m.parentOffset, g.parentOffset);
      if (e.someProp("handleTextInput", (U) => U(e, y, C, P)))
        return;
      $ = e.state.tr.insertText(P, y, C);
    }
  }
  if ($ || ($ = e.state.tr.replace(y, C, d.doc.slice(p.start - d.from, p.endB - d.from))), d.sel) {
    let P = m1(e, $.doc, d.sel);
    P && !(hn && nr && e.composing && P.empty && (p.start != p.endB || e.input.lastAndroidDelete < Date.now() - 100) && (P.head == y || P.head == $.mapping.map(C) - 1) || On && P.empty && P.head == y) && $.setSelection(P);
  }
  O && $.ensureMarks(O), o && $.setMeta("composition", o), e.dispatch($.scrollIntoView());
}
function m1(e, t, n) {
  return Math.max(n.anchor, n.head) > t.content.size ? null : gf(e, t.resolve(n.anchor), t.resolve(n.head));
}
function jE(e, t) {
  let n = e.firstChild.marks, r = t.firstChild.marks, i = n, o = r, a, s, l;
  for (let u = 0; u < r.length; u++)
    i = r[u].removeFromSet(i);
  for (let u = 0; u < n.length; u++)
    o = n[u].removeFromSet(o);
  if (i.length == 1 && o.length == 0)
    s = i[0], a = "add", l = (u) => u.mark(s.addToSet(u.marks));
  else if (i.length == 0 && o.length == 1)
    s = o[0], a = "remove", l = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < t.childCount; u++)
    d.push(l(t.child(u)));
  if (ve.from(d).eq(e))
    return { mark: s, type: a };
}
function WE(e, t, n, r, i) {
  if (!r.parent.isTextblock || // The content must have shrunk
  n - t <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
  Pu(r, !0, !1) < i.pos)
    return !1;
  let o = e.resolve(t);
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let a = e.resolve(Pu(o, !0, !0));
  return !a.parent.isTextblock || a.pos > n || Pu(a, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(a.parent.content);
}
function Pu(e, t, n) {
  let r = e.depth, i = t ? e.end() : e.pos;
  for (; r > 0 && (t || e.indexAfter(r) == e.node(r).childCount); )
    r--, i++, t = !1;
  if (n) {
    let o = e.node(r).maybeChild(e.indexAfter(r));
    for (; o && !o.isLeaf; )
      o = o.firstChild, i++;
  }
  return i;
}
function UE(e, t, n, r, i) {
  let o = e.findDiffStart(t, n);
  if (o == null)
    return null;
  let { a, b: s } = e.findDiffEnd(t, n + e.size, n + t.size);
  if (i == "end") {
    let l = Math.max(0, o - Math.min(a, s));
    r -= a + l - o;
  }
  if (a < o && e.size < t.size) {
    let l = r <= o && r >= a ? o - r : 0;
    o -= l, o && o < t.size && g1(t.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), s = o + (s - a), a = o;
  } else if (s < o) {
    let l = r <= o && r >= s ? o - r : 0;
    o -= l, o && o < e.size && g1(e.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), a = o + (a - s), s = o;
  }
  return { start: o, endA: a, endB: s };
}
function g1(e) {
  if (e.length != 2)
    return !1;
  let t = e.charCodeAt(0), n = e.charCodeAt(1);
  return t >= 56320 && t <= 57343 && n >= 55296 && n <= 56319;
}
class qE {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(t, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new pE(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(w1), this.dispatch = this.dispatch.bind(this), this.dom = t && t.mount || document.createElement("div"), t && (t.appendChild ? t.appendChild(this.dom) : typeof t == "function" ? t(this.dom) : t.mount && (this.mounted = !0)), this.editable = b1(this), y1(this), this.nodeViews = $1(this), this.docView = Qh(this.state.doc, v1(this), Au(this), this.dom, this), this.domObserver = new _E(this, (r, i, o, a) => HE(this, r, i, o, a)), this.domObserver.start(), hE(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let t = this._props;
      this._props = {};
      for (let n in t)
        this._props[n] = t[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(t) {
    t.handleDOMEvents != this._props.handleDOMEvents && Nc(this);
    let n = this._props;
    this._props = t, t.plugins && (t.plugins.forEach(w1), this.directPlugins = t.plugins), this.updateStateInner(t.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(t) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in t)
      n[r] = t[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(t) {
    this.updateStateInner(t, this._props);
  }
  updateStateInner(t, n) {
    var r;
    let i = this.state, o = !1, a = !1;
    t.storedMarks && this.composing && (Nv(this), a = !0), this.state = t;
    let s = i.plugins != t.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let h = $1(this);
      KE(h, this.nodeViews) && (this.nodeViews = h, o = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && Nc(this), this.editable = b1(this), y1(this);
    let l = Au(this), d = v1(this), u = i.plugins != t.plugins && !i.doc.eq(t.doc) ? "reset" : t.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", c = o || !this.docView.matchesNode(t.doc, d, l);
    (c || !t.selection.eq(i.selection)) && (a = !0);
    let f = u == "preserve" && a && this.dom.style.overflowAnchor == null && OO(this);
    if (a) {
      this.domObserver.stop();
      let h = c && (On || hn) && !this.composing && !i.selection.empty && !t.selection.empty && YE(i.selection, t.selection);
      if (c) {
        let p = hn ? this.trackWrites = this.domSelectionRange().focusNode : null;
        (o || !this.docView.update(t.doc, d, l, this)) && (this.docView.updateOuterDeco([]), this.docView.destroy(), this.docView = Qh(t.doc, d, l, this.dom, this)), p && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && ZO(this)) ? si(this, h) : ($v(this, t.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(t.doc) && this.updateDraggedNode(this.dragging, i), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : f && EO(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let t = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof He) {
      let n = this.docView.domAfterPos(this.state.selection.from);
      n.nodeType == 1 && qh(this, n.getBoundingClientRect(), t);
    } else
      qh(this, this.coordsAtPos(this.state.selection.head, 1), t);
  }
  destroyPluginViews() {
    let t;
    for (; t = this.pluginViews.pop(); )
      t.destroy && t.destroy();
  }
  updatePluginViews(t) {
    if (!t || t.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, t);
      }
  }
  updateDraggedNode(t, n) {
    let r = t.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let o = r.from + (this.state.doc.content.size - n.doc.content.size);
      (o > 0 && this.state.doc.nodeAt(o)) == r.node && (i = o);
    }
    this.dragging = new Rv(t.slice, t.move, i < 0 ? void 0 : He.create(this.state.doc, i));
  }
  someProp(t, n) {
    let r = this._props && this._props[t], i;
    if (r != null && (i = n ? n(r) : r))
      return i;
    for (let a = 0; a < this.directPlugins.length; a++) {
      let s = this.directPlugins[a].props[t];
      if (s != null && (i = n ? n(s) : s))
        return i;
    }
    let o = this.state.plugins;
    if (o)
      for (let a = 0; a < o.length; a++) {
        let s = o[a].props[t];
        if (s != null && (i = n ? n(s) : s))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (On) {
      let t = this.root.activeElement;
      if (t == this.dom)
        return !0;
      if (!t || !this.dom.contains(t))
        return !1;
      for (; t && this.dom != t && this.dom.contains(t); ) {
        if (t.contentEditable == "false")
          return !1;
        t = t.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && DO(this.dom), si(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let t = this._root;
    if (t == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return t || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(t) {
    return RO(this, t);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(t, n = 1) {
    return fv(this, t, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(t, n = 0) {
    return this.docView.domFromPos(t, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(t) {
    let n = this.docView.descAt(t);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(t, n, r = -1) {
    let i = this.docView.posFromDOM(t, n, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(t, n) {
    return zO(this, n || this.state, t);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(t, n) {
    return ns(this, "", t, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(t, n) {
    return ns(this, t, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (mE(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Au(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null);
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(t) {
    return vE(this, t);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(t) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, t) : this.updateState(this.state.apply(t));
  }
  /**
  @internal
  */
  domSelectionRange() {
    return bn && this.root.nodeType === 11 && wO(this.dom.ownerDocument) == this.dom ? FE(this) : this.domSelection();
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function v1(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(e.state)), n)
      for (let r in n)
        r == "class" ? t.class += " " + n[r] : r == "style" ? t.style = (t.style ? t.style + ";" : "") + n[r] : !t[r] && r != "contenteditable" && r != "nodeName" && (t[r] = String(n[r]));
  }), t.translate || (t.translate = "no"), [qn.node(0, e.state.doc.content.size, t)];
}
function y1(e) {
  if (e.markCursor) {
    let t = document.createElement("img");
    t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = { dom: t, deco: qn.widget(e.state.selection.head, t, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function b1(e) {
  return !e.someProp("editable", (t) => t(e.state) === !1);
}
function YE(e, t) {
  let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
  return e.$anchor.start(n) != t.$anchor.start(n);
}
function $1(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(t, i) || (t[i] = r[i]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function KE(e, t) {
  let n = 0, r = 0;
  for (let i in e) {
    if (e[i] != t[i])
      return !0;
    n++;
  }
  for (let i in t)
    r++;
  return n != r;
}
function w1(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Ri = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ml = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, GE = typeof navigator != "undefined" && /Mac/.test(navigator.platform), JE = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var un = 0; un < 10; un++) Ri[48 + un] = Ri[96 + un] = String(un);
for (var un = 1; un <= 24; un++) Ri[un + 111] = "F" + un;
for (var un = 65; un <= 90; un++)
  Ri[un] = String.fromCharCode(un + 32), Ml[un] = String.fromCharCode(un);
for (var Nu in Ri) Ml.hasOwnProperty(Nu) || (Ml[Nu] = Ri[Nu]);
function XE(e) {
  var t = GE && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || JE && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? Ml : Ri)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const QE = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function ZE(e) {
  let t = e.split(/-(?!$)/), n = t[t.length - 1];
  n == "Space" && (n = " ");
  let r, i, o, a;
  for (let s = 0; s < t.length - 1; s++) {
    let l = t[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      QE ? a = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (n = "Alt-" + n), i && (n = "Ctrl-" + n), a && (n = "Meta-" + n), o && (n = "Shift-" + n), n;
}
function eD(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    t[ZE(n)] = e[n];
  return t;
}
function Iu(e, t, n = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function tD(e) {
  return new cn({ props: { handleKeyDown: zv(e) } });
}
function zv(e) {
  let t = eD(e);
  return function(n, r) {
    let i = XE(r), o, a = t[Iu(i, r)];
    if (a && a(n.state, n.dispatch, n))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let s = t[Iu(i, r, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || i.charCodeAt(0) > 127) && (o = Ri[r.keyCode]) && o != i) {
        let s = t[Iu(o, r)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const nD = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function Vv(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
const rD = (e, t, n) => {
  let r = Vv(e, n);
  if (!r)
    return !1;
  let i = kf(r);
  if (!i) {
    let a = r.blockRange(), s = a && ha(a);
    return s == null ? !1 : (t && t(e.tr.lift(a, s).scrollIntoView()), !0);
  }
  let o = i.nodeBefore;
  if (!o.type.spec.isolating && Uv(e, i, t))
    return !0;
  if (r.parent.content.size == 0 && (da(o, "end") || He.isSelectable(o))) {
    let a = Od(e.doc, r.before(), r.after(), Ae.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (t) {
        let s = e.tr.step(a);
        s.setSelection(da(o, "end") ? rt.findFrom(s.doc.resolve(s.mapping.map(i.pos, -1)), -1) : He.create(s.doc, i.pos - o.nodeSize)), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos - o.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, iD = (e, t, n) => {
  let r = Vv(e, n);
  if (!r)
    return !1;
  let i = kf(r);
  return i ? Hv(e, i, t) : !1;
}, oD = (e, t, n) => {
  let r = jv(e, n);
  if (!r)
    return !1;
  let i = xf(r);
  return i ? Hv(e, i, t) : !1;
};
function Hv(e, t, n) {
  let r = t.nodeBefore, i = r, o = t.pos - 1;
  for (; !i.isTextblock; o--) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.lastChild;
    if (!u)
      return !1;
    i = u;
  }
  let a = t.nodeAfter, s = a, l = t.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let d = Od(e.doc, o, l, Ae.empty);
  if (!d || d.from != o || d instanceof en && d.slice.size >= l - o)
    return !1;
  if (n) {
    let u = e.tr.step(d);
    u.setSelection(Xe.create(u.doc, o)), n(u.scrollIntoView());
  }
  return !0;
}
function da(e, t, n = !1) {
  for (let r = e; r; r = t == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const aD = (e, t, n) => {
  let { $head: r, empty: i } = e.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : r.parentOffset > 0)
      return !1;
    o = kf(r);
  }
  let a = o && o.nodeBefore;
  return !a || !He.isSelectable(a) ? !1 : (t && t(e.tr.setSelection(He.create(e.doc, o.pos - a.nodeSize)).scrollIntoView()), !0);
};
function kf(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function jv(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
const sD = (e, t, n) => {
  let r = jv(e, n);
  if (!r)
    return !1;
  let i = xf(r);
  if (!i)
    return !1;
  let o = i.nodeAfter;
  if (Uv(e, i, t))
    return !0;
  if (r.parent.content.size == 0 && (da(o, "start") || He.isSelectable(o))) {
    let a = Od(e.doc, r.before(), r.after(), Ae.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (t) {
        let s = e.tr.step(a);
        s.setSelection(da(o, "start") ? rt.findFrom(s.doc.resolve(s.mapping.map(i.pos)), 1) : He.create(s.doc, s.mapping.map(i.pos))), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos, i.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, lD = (e, t, n) => {
  let { $head: r, empty: i } = e.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size)
      return !1;
    o = xf(r);
  }
  let a = o && o.nodeAfter;
  return !a || !He.isSelectable(a) ? !1 : (t && t(e.tr.setSelection(He.create(e.doc, o.pos)).scrollIntoView()), !0);
};
function xf(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let n = e.node(t);
      if (e.index(t) + 1 < n.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const dD = (e, t) => {
  let n = e.selection, r = n instanceof He, i;
  if (r) {
    if (n.node.isTextblock || !zi(e.doc, n.from))
      return !1;
    i = n.from;
  } else if (i = Md(e.doc, n.from, -1), i == null)
    return !1;
  if (t) {
    let o = e.tr.join(i);
    r && o.setSelection(He.create(o.doc, i - e.doc.resolve(i).nodeBefore.nodeSize)), t(o.scrollIntoView());
  }
  return !0;
}, uD = (e, t) => {
  let n = e.selection, r;
  if (n instanceof He) {
    if (n.node.isTextblock || !zi(e.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = Md(e.doc, n.to, 1), r == null)
    return !1;
  return t && t(e.tr.join(r).scrollIntoView()), !0;
}, cD = (e, t) => {
  let { $from: n, $to: r } = e.selection, i = n.blockRange(r), o = i && ha(i);
  return o == null ? !1 : (t && t(e.tr.lift(i, o).scrollIntoView()), !0);
}, fD = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function Wv(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const pD = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let i = n.node(-1), o = n.indexAfter(-1), a = Wv(i.contentMatchAt(o));
  if (!a || !i.canReplaceWith(o, o, a))
    return !1;
  if (t) {
    let s = n.after(), l = e.tr.replaceWith(s, s, a.createAndFill());
    l.setSelection(rt.near(l.doc.resolve(s), 1)), t(l.scrollIntoView());
  }
  return !0;
}, hD = (e, t) => {
  let n = e.selection, { $from: r, $to: i } = n;
  if (n instanceof dr || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let o = Wv(i.parent.contentMatchAt(i.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (t) {
    let a = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, s = e.tr.insert(a, o.createAndFill());
    s.setSelection(Xe.create(s.doc, a + 1)), t(s.scrollIntoView());
  }
  return !0;
}, mD = (e, t) => {
  let { $cursor: n } = e.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let o = n.before();
    if (Uo(e.doc, o))
      return t && t(e.tr.split(o).scrollIntoView()), !0;
  }
  let r = n.blockRange(), i = r && ha(r);
  return i == null ? !1 : (t && t(e.tr.lift(r, i).scrollIntoView()), !0);
}, gD = (e, t) => {
  let { $from: n, to: r } = e.selection, i, o = n.sharedDepth(r);
  return o == 0 ? !1 : (i = n.before(o), t && t(e.tr.setSelection(He.create(e.doc, i))), !0);
};
function vD(e, t, n) {
  let r = t.nodeBefore, i = t.nodeAfter, o = t.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && t.parent.canReplace(o - 1, o) ? (n && n(e.tr.delete(t.pos - r.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(o, o + 1) || !(i.isTextblock || zi(e.doc, t.pos)) ? !1 : (n && n(e.tr.clearIncompatible(t.pos, r.type, r.contentMatchAt(r.childCount)).join(t.pos).scrollIntoView()), !0);
}
function Uv(e, t, n) {
  let r = t.nodeBefore, i = t.nodeAfter, o, a;
  if (r.type.spec.isolating || i.type.spec.isolating)
    return !1;
  if (vD(e, t, n))
    return !0;
  let s = t.parent.canReplace(t.index(), t.index() + 1);
  if (s && (o = (a = r.contentMatchAt(r.childCount)).findWrapping(i.type)) && a.matchType(o[0] || i.type).validEnd) {
    if (n) {
      let c = t.pos + i.nodeSize, f = ve.empty;
      for (let m = o.length - 1; m >= 0; m--)
        f = ve.from(o[m].create(null, f));
      f = ve.from(r.copy(f));
      let h = e.tr.step(new rn(t.pos - 1, c, t.pos, c, new Ae(f, 1, 0), o.length, !0)), p = c + 2 * o.length;
      zi(h.doc, p) && h.join(p), n(h.scrollIntoView());
    }
    return !0;
  }
  let l = rt.findFrom(t, 1), d = l && l.$from.blockRange(l.$to), u = d && ha(d);
  if (u != null && u >= t.depth)
    return n && n(e.tr.lift(d, u).scrollIntoView()), !0;
  if (s && da(i, "start", !0) && da(r, "end")) {
    let c = r, f = [];
    for (; f.push(c), !c.isTextblock; )
      c = c.lastChild;
    let h = i, p = 1;
    for (; !h.isTextblock; h = h.firstChild)
      p++;
    if (c.canReplace(c.childCount, c.childCount, h.content)) {
      if (n) {
        let m = ve.empty;
        for (let v = f.length - 1; v >= 0; v--)
          m = ve.from(f[v].copy(m));
        let g = e.tr.step(new rn(t.pos - f.length, t.pos + i.nodeSize, t.pos + p, t.pos + i.nodeSize - p, new Ae(m, f.length, 0), 0, !0));
        n(g.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function qv(e) {
  return function(t, n) {
    let r = t.selection, i = e < 0 ? r.$from : r.$to, o = i.depth;
    for (; i.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return i.node(o).isTextblock ? (n && n(t.tr.setSelection(Xe.create(t.doc, e < 0 ? i.start(o) : i.end(o)))), !0) : !1;
  };
}
const yD = qv(-1), bD = qv(1);
function $D(e, t = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, a = i.blockRange(o), s = a && cf(a, e, t);
    return s ? (r && r(n.tr.wrap(a, s).scrollIntoView()), !0) : !1;
  };
}
function k1(e, t = null) {
  return function(n, r) {
    let i = !1;
    for (let o = 0; o < n.selection.ranges.length && !i; o++) {
      let { $from: { pos: a }, $to: { pos: s } } = n.selection.ranges[o];
      n.doc.nodesBetween(a, s, (l, d) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(e, t)))
          if (l.type == e)
            i = !0;
          else {
            let u = n.doc.resolve(d), c = u.index();
            i = u.parent.canReplaceWith(c, c + 1, e);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let o = n.tr;
      for (let a = 0; a < n.selection.ranges.length; a++) {
        let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[a];
        o.setBlockType(s, l, e, t);
      }
      r(o.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform && os.platform() == "darwin";
function wD(e, t = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, a = i.blockRange(o), s = !1, l = a;
    if (!a)
      return !1;
    if (a.depth >= 2 && i.node(a.depth - 1).type.compatibleContent(e) && a.startIndex == 0) {
      if (i.index(a.depth - 1) == 0)
        return !1;
      let u = n.doc.resolve(a.start - 2);
      l = new bl(u, u, a.depth), a.endIndex < a.parent.childCount && (a = new bl(i, n.doc.resolve(o.end(a.depth)), a.depth)), s = !0;
    }
    let d = cf(l, e, t, a);
    return d ? (r && r(kD(n.tr, a, d, s, e).scrollIntoView()), !0) : !1;
  };
}
function kD(e, t, n, r, i) {
  let o = ve.empty;
  for (let u = n.length - 1; u >= 0; u--)
    o = ve.from(n[u].type.create(n[u].attrs, o));
  e.step(new rn(t.start - (r ? 2 : 0), t.end, t.start, t.end, new Ae(o, 0, 0), n.length, !0));
  let a = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == i && (a = u + 1);
  let s = n.length - a, l = t.start + n.length - (r ? 2 : 0), d = t.parent;
  for (let u = t.startIndex, c = t.endIndex, f = !0; u < c; u++, f = !1)
    !f && Uo(e.doc, l, s) && (e.split(l, s), l += 2 * s), l += d.child(u).nodeSize;
  return e;
}
function xD(e) {
  return function(t, n) {
    let { $from: r, $to: i } = t.selection, o = r.blockRange(i, (a) => a.childCount > 0 && a.firstChild.type == e);
    return o ? n ? r.node(o.depth - 1).type == e ? SD(t, n, e, o) : CD(t, n, o) : !0 : !1;
  };
}
function SD(e, t, n, r) {
  let i = e.tr, o = r.end, a = r.$to.end(r.depth);
  o < a && (i.step(new rn(o - 1, a, o, a, new Ae(ve.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new bl(i.doc.resolve(r.$from.pos), i.doc.resolve(a), r.depth));
  const s = ha(r);
  if (s == null)
    return !1;
  i.lift(r, s);
  let l = i.mapping.map(o, -1) - 1;
  return zi(i.doc, l) && i.join(l), t(i.scrollIntoView()), !0;
}
function CD(e, t, n) {
  let r = e.tr, i = n.parent;
  for (let h = n.end, p = n.endIndex - 1, m = n.startIndex; p > m; p--)
    h -= i.child(p).nodeSize, r.delete(h - 1, h + 1);
  let o = r.doc.resolve(n.start), a = o.nodeAfter;
  if (r.mapping.map(n.end) != n.start + o.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, l = n.endIndex == i.childCount, d = o.node(-1), u = o.index(-1);
  if (!d.canReplace(u + (s ? 0 : 1), u + 1, a.content.append(l ? ve.empty : ve.from(i))))
    return !1;
  let c = o.pos, f = c + a.nodeSize;
  return r.step(new rn(c - (s ? 1 : 0), f + (l ? 1 : 0), c + 1, f - 1, new Ae((s ? ve.empty : ve.from(i.copy(ve.empty))).append(l ? ve.empty : ve.from(i.copy(ve.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), t(r.scrollIntoView()), !0;
}
function TD(e) {
  return function(t, n) {
    let { $from: r, $to: i } = t.selection, o = r.blockRange(i, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!o)
      return !1;
    let a = o.startIndex;
    if (a == 0)
      return !1;
    let s = o.parent, l = s.child(a - 1);
    if (l.type != e)
      return !1;
    if (n) {
      let d = l.lastChild && l.lastChild.type == s.type, u = ve.from(d ? e.create() : null), c = new Ae(ve.from(e.create(null, ve.from(s.type.create(null, u)))), d ? 3 : 1, 0), f = o.start, h = o.end;
      n(t.tr.step(new rn(f - (d ? 3 : 1), h, f, h, c, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Nd(e) {
  const { state: t, transaction: n } = e;
  let { selection: r } = n, { doc: i } = n, { storedMarks: o } = n;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return o;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, o = n.storedMarks, n;
    }
  };
}
class Id {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: n, state: r } = this, { view: i } = n, { tr: o } = r, a = this.buildProps(o);
    return Object.fromEntries(Object.entries(t).map(([s, l]) => [s, (...u) => {
      const c = l(...u)(a);
      return !o.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(o), c;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: a } = i, s = [], l = !!t, d = t || o.tr, u = () => (!l && n && !d.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(d), s.every((f) => f === !0)), c = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...m) => {
        const g = this.buildProps(d, n), v = h(...m)(g);
        return s.push(v), c;
      }])),
      run: u
    };
    return c;
  }
  createCan(t) {
    const { rawCommands: n, state: r } = this, i = !1, o = t || r.tr, a = this.buildProps(o, i);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, d]) => [l, (...u) => d(...u)({ ...a, dispatch: void 0 })])),
      chain: () => this.createChain(o, i)
    };
  }
  buildProps(t, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: a } = i, s = {
      tr: t,
      editor: i,
      view: a,
      state: Nd({
        state: o,
        transaction: t
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(t, n),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, d]) => [l, (...u) => d(...u)(s)]));
      }
    };
    return s;
  }
}
class MD {
  constructor() {
    this.callbacks = {};
  }
  on(t, n) {
    return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(n), this;
  }
  emit(t, ...n) {
    const r = this.callbacks[t];
    return r && r.forEach((i) => i.apply(this, n)), this;
  }
  off(t, n) {
    const r = this.callbacks[t];
    return r && (n ? this.callbacks[t] = r.filter((i) => i !== n) : delete this.callbacks[t]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Le(e, t, n) {
  return e.config[t] === void 0 && e.parent ? Le(e.parent, t, n) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...n,
    parent: e.parent ? Le(e.parent, t, n) : null
  }) : e.config[t];
}
function Rd(e) {
  const t = e.filter((i) => i.type === "extension"), n = e.filter((i) => i.type === "node"), r = e.filter((i) => i.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Yv(e) {
  const t = [], { nodeExtensions: n, markExtensions: r } = Rd(e), i = [...n, ...r], o = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return e.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage
    }, l = Le(a, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((c) => {
        Object.entries(u.attributes).forEach(([f, h]) => {
          t.push({
            type: c,
            name: f,
            attribute: {
              ...o,
              ...h
            }
          });
        });
      });
    });
  }), i.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage
    }, l = Le(a, "addAttributes", s);
    if (!l)
      return;
    const d = l();
    Object.entries(d).forEach(([u, c]) => {
      const f = {
        ...o,
        ...c
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, t.push({
        type: a.name,
        name: u,
        attribute: f
      });
    });
  }), t;
}
function sn(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
function Ct(...e) {
  return e.filter((t) => !!t).reduce((t, n) => {
    const r = { ...t };
    return Object.entries(n).forEach(([i, o]) => {
      if (!r[i]) {
        r[i] = o;
        return;
      }
      if (i === "class") {
        const s = o ? o.split(" ") : [], l = r[i] ? r[i].split(" ") : [], d = s.filter((u) => !l.includes(u));
        r[i] = [...l, ...d].join(" ");
      } else i === "style" ? r[i] = [r[i], o].join("; ") : r[i] = o;
    }), r;
  }, {});
}
function Ic(e, t) {
  return t.filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(e.attrs) || {} : {
    [n.name]: e.attrs[n.name]
  }).reduce((n, r) => Ct(n, r), {});
}
function Kv(e) {
  return typeof e == "function";
}
function tt(e, t = void 0, ...n) {
  return Kv(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function OD(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function ED(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function x1(e, t) {
  return e.style ? e : {
    ...e,
    getAttrs: (n) => {
      const r = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (r === !1)
        return !1;
      const i = t.reduce((o, a) => {
        const s = a.attribute.parseHTML ? a.attribute.parseHTML(n) : ED(n.getAttribute(a.name));
        return s == null ? o : {
          ...o,
          [a.name]: s
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function S1(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([t, n]) => t === "attrs" && OD(n) ? !1 : n != null)
  );
}
function DD(e, t) {
  var n;
  const r = Yv(e), { nodeExtensions: i, markExtensions: o } = Rd(e), a = (n = i.find((d) => Le(d, "topNode"))) === null || n === void 0 ? void 0 : n.name, s = Object.fromEntries(i.map((d) => {
    const u = r.filter((v) => v.type === d.name), c = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      editor: t
    }, f = e.reduce((v, b) => {
      const x = Le(b, "extendNodeSchema", c);
      return {
        ...v,
        ...x ? x(d) : {}
      };
    }, {}), h = S1({
      ...f,
      content: tt(Le(d, "content", c)),
      marks: tt(Le(d, "marks", c)),
      group: tt(Le(d, "group", c)),
      inline: tt(Le(d, "inline", c)),
      atom: tt(Le(d, "atom", c)),
      selectable: tt(Le(d, "selectable", c)),
      draggable: tt(Le(d, "draggable", c)),
      code: tt(Le(d, "code", c)),
      defining: tt(Le(d, "defining", c)),
      isolating: tt(Le(d, "isolating", c)),
      attrs: Object.fromEntries(u.map((v) => {
        var b;
        return [v.name, { default: (b = v == null ? void 0 : v.attribute) === null || b === void 0 ? void 0 : b.default }];
      }))
    }), p = tt(Le(d, "parseHTML", c));
    p && (h.parseDOM = p.map((v) => x1(v, u)));
    const m = Le(d, "renderHTML", c);
    m && (h.toDOM = (v) => m({
      node: v,
      HTMLAttributes: Ic(v, u)
    }));
    const g = Le(d, "renderText", c);
    return g && (h.toText = g), [d.name, h];
  })), l = Object.fromEntries(o.map((d) => {
    const u = r.filter((g) => g.type === d.name), c = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      editor: t
    }, f = e.reduce((g, v) => {
      const b = Le(v, "extendMarkSchema", c);
      return {
        ...g,
        ...b ? b(d) : {}
      };
    }, {}), h = S1({
      ...f,
      inclusive: tt(Le(d, "inclusive", c)),
      excludes: tt(Le(d, "excludes", c)),
      group: tt(Le(d, "group", c)),
      spanning: tt(Le(d, "spanning", c)),
      code: tt(Le(d, "code", c)),
      attrs: Object.fromEntries(u.map((g) => {
        var v;
        return [g.name, { default: (v = g == null ? void 0 : g.attribute) === null || v === void 0 ? void 0 : v.default }];
      }))
    }), p = tt(Le(d, "parseHTML", c));
    p && (h.parseDOM = p.map((g) => x1(g, u)));
    const m = Le(d, "renderHTML", c);
    return m && (h.toDOM = (g) => m({
      mark: g,
      HTMLAttributes: Ic(g, u)
    })), [d.name, h];
  }));
  return new zM({
    topNode: a,
    nodes: s,
    marks: l
  });
}
function Ru(e, t) {
  return t.nodes[e] || t.marks[e] || null;
}
function C1(e, t) {
  return Array.isArray(t) ? t.some((n) => (typeof n == "string" ? n : n.name) === e.name) : t;
}
const AD = (e, t = 500) => {
  let n = "";
  const r = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, r - t), r, (i, o, a, s) => {
    var l, d;
    const u = ((d = (l = i.type.spec).toText) === null || d === void 0 ? void 0 : d.call(l, {
      node: i,
      pos: o,
      parent: a,
      index: s
    })) || i.textContent || "%leaf%";
    n += u.slice(0, Math.max(0, r - o));
  }), n;
};
function Sf(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class _d {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const PD = (e, t) => {
  if (Sf(t))
    return t.exec(e);
  const n = t(e);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = e, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function Bs(e) {
  var t;
  const { editor: n, from: r, to: i, text: o, rules: a, plugin: s } = e, { view: l } = n;
  if (l.composing)
    return !1;
  const d = l.state.doc.resolve(r);
  if (
    // check for code node
    d.parent.type.spec.code || !((t = d.nodeBefore || d.nodeAfter) === null || t === void 0) && t.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let u = !1;
  const c = AD(d) + o;
  return a.forEach((f) => {
    if (u)
      return;
    const h = PD(c, f.find);
    if (!h)
      return;
    const p = l.state.tr, m = Nd({
      state: l.state,
      transaction: p
    }), g = {
      from: r - (h[0].length - o.length),
      to: i
    }, { commands: v, chain: b, can: x } = new Id({
      editor: n,
      state: m
    });
    f.handler({
      state: m,
      range: g,
      match: h,
      commands: v,
      chain: b,
      can: x
    }) === null || !p.steps.length || (p.setMeta(s, {
      transform: p,
      from: r,
      to: i,
      text: o
    }), l.dispatch(p), u = !0);
  }), u;
}
function ND(e) {
  const { editor: t, rules: n } = e, r = new cn({
    state: {
      init() {
        return null;
      },
      apply(i, o) {
        const a = i.getMeta(r);
        if (a)
          return a;
        const s = i.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          const { from: d, text: u } = s, c = d + u.length;
          Bs({
            editor: t,
            from: d,
            to: c,
            text: u,
            rules: n,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : o;
      }
    },
    props: {
      handleTextInput(i, o, a, s) {
        return Bs({
          editor: t,
          from: o,
          to: a,
          text: s,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: o } = i.state.selection;
          o && Bs({
            editor: t,
            from: o.pos,
            to: o.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, o) {
        if (o.key !== "Enter")
          return !1;
        const { $cursor: a } = i.state.selection;
        return a ? Bs({
          editor: t,
          from: a.pos,
          to: a.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function ID(e) {
  return typeof e == "number";
}
class RD {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const _D = (e, t, n) => {
  if (Sf(t))
    return [...e.matchAll(t)];
  const r = t(e, n);
  return r ? r.map((i) => {
    const o = [i.text];
    return o.index = i.index, o.input = e, o.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), o.push(i.replaceWith)), o;
  }) : [];
};
function LD(e) {
  const { editor: t, state: n, from: r, to: i, rule: o, pasteEvent: a, dropEvent: s } = e, { commands: l, chain: d, can: u } = new Id({
    editor: t,
    state: n
  }), c = [];
  return n.doc.nodesBetween(r, i, (h, p) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const m = Math.max(r, p), g = Math.min(i, p + h.content.size), v = h.textBetween(m - p, g - p, void 0, "￼");
    _D(v, o.find, a).forEach((x) => {
      if (x.index === void 0)
        return;
      const y = m + x.index + 1, C = y + x[0].length, $ = {
        from: n.tr.mapping.map(y),
        to: n.tr.mapping.map(C)
      }, O = o.handler({
        state: n,
        range: $,
        match: x,
        commands: l,
        chain: d,
        can: u,
        pasteEvent: a,
        dropEvent: s
      });
      c.push(O);
    });
  }), c.every((h) => h !== null);
}
const FD = (e) => {
  var t;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (t = n.clipboardData) === null || t === void 0 || t.setData("text/html", e), n;
};
function BD(e) {
  const { editor: t, rules: n } = e;
  let r = null, i = !1, o = !1, a = typeof ClipboardEvent != "undefined" ? new ClipboardEvent("paste") : null, s = typeof DragEvent != "undefined" ? new DragEvent("drop") : null;
  const l = ({ state: u, from: c, to: f, rule: h, pasteEvt: p }) => {
    const m = u.tr, g = Nd({
      state: u,
      transaction: m
    });
    if (!(!LD({
      editor: t,
      state: g,
      from: Math.max(c - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: s
    }) || !m.steps.length))
      return s = typeof DragEvent != "undefined" ? new DragEvent("drop") : null, a = typeof ClipboardEvent != "undefined" ? new ClipboardEvent("paste") : null, m;
  };
  return n.map((u) => new cn({
    // we register a global drag handler to track the current drag source element
    view(c) {
      const f = (h) => {
        var p;
        r = !((p = c.dom.parentElement) === null || p === void 0) && p.contains(h.target) ? c.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", f), {
        destroy() {
          window.removeEventListener("dragstart", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (c, f) => (o = r === c.dom.parentElement, s = f, !1),
        paste: (c, f) => {
          var h;
          const p = (h = f.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return a = f, i = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (c, f, h) => {
      const p = c[0], m = p.getMeta("uiEvent") === "paste" && !i, g = p.getMeta("uiEvent") === "drop" && !o, v = p.getMeta("applyPasteRules"), b = !!v;
      if (!m && !g && !b)
        return;
      if (b) {
        const { from: C, text: $ } = v, O = C + $.length, z = FD($);
        return l({
          rule: u,
          state: h,
          from: C,
          to: { b: O },
          pasteEvt: z
        });
      }
      const x = f.doc.content.findDiffStart(h.doc.content), y = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!ID(x) || !y || x === y.b))
        return l({
          rule: u,
          state: h,
          from: x,
          to: y,
          pasteEvt: a
        });
    }
  }));
}
function zD(e) {
  const t = e.filter((n, r) => e.indexOf(n) !== r);
  return [...new Set(t)];
}
class Ho {
  constructor(t, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = Ho.resolve(t), this.schema = DD(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(t) {
    const n = Ho.sort(Ho.flatten(t)), r = zD(n.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(t) {
    return t.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, i = Le(n, "addExtensions", r);
      return i ? [n, ...this.flatten(i())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(t) {
    return t.sort((r, i) => {
      const o = Le(r, "priority") || 100, a = Le(i, "priority") || 100;
      return o > a ? -1 : o < a ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((t, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: Ru(n.name, this.schema)
      }, i = Le(n, "addCommands", r);
      return i ? {
        ...t,
        ...i()
      } : t;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: t } = this, n = Ho.sort([...this.extensions].reverse()), r = [], i = [], o = n.map((a) => {
      const s = {
        name: a.name,
        options: a.options,
        storage: a.storage,
        editor: t,
        type: Ru(a.name, this.schema)
      }, l = [], d = Le(a, "addKeyboardShortcuts", s);
      let u = {};
      if (a.type === "mark" && a.config.exitable && (u.ArrowRight = () => Dn.handleExit({ editor: t, mark: a })), d) {
        const m = Object.fromEntries(Object.entries(d()).map(([g, v]) => [g, () => v({ editor: t })]));
        u = { ...u, ...m };
      }
      const c = tD(u);
      l.push(c);
      const f = Le(a, "addInputRules", s);
      C1(a, t.options.enableInputRules) && f && r.push(...f());
      const h = Le(a, "addPasteRules", s);
      C1(a, t.options.enablePasteRules) && h && i.push(...h());
      const p = Le(a, "addProseMirrorPlugins", s);
      if (p) {
        const m = p();
        l.push(...m);
      }
      return l;
    }).flat();
    return [
      ND({
        editor: t,
        rules: r
      }),
      ...BD({
        editor: t,
        rules: i
      }),
      ...o
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Yv(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: t } = this, { nodeExtensions: n } = Rd(this.extensions);
    return Object.fromEntries(n.filter((r) => !!Le(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((l) => l.type === r.name), o = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: t,
        type: sn(r.name, this.schema)
      }, a = Le(r, "addNodeView", o);
      if (!a)
        return [];
      const s = (l, d, u, c) => {
        const f = Ic(l, i);
        return a()({
          editor: t,
          node: l,
          getPos: u,
          decorations: c,
          HTMLAttributes: f,
          extension: r
        });
      };
      return [r.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((t) => {
      var n;
      this.editor.extensionStorage[t.name] = t.storage;
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: Ru(t.name, this.schema)
      };
      t.type === "mark" && (!((n = tt(Le(t, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(t.name);
      const i = Le(t, "onBeforeCreate", r), o = Le(t, "onCreate", r), a = Le(t, "onUpdate", r), s = Le(t, "onSelectionUpdate", r), l = Le(t, "onTransaction", r), d = Le(t, "onFocus", r), u = Le(t, "onBlur", r), c = Le(t, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), o && this.editor.on("create", o), a && this.editor.on("update", a), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), d && this.editor.on("focus", d), u && this.editor.on("blur", u), c && this.editor.on("destroy", c);
    });
  }
}
function VD(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function _u(e) {
  return VD(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function Ld(e, t) {
  const n = { ...e };
  return _u(e) && _u(t) && Object.keys(t).forEach((r) => {
    _u(t[r]) ? r in e ? n[r] = Ld(e[r], t[r]) : Object.assign(n, { [r]: t[r] }) : Object.assign(n, { [r]: t[r] });
  }), n;
}
class Xt {
  constructor(t = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = tt(Le(this, "addOptions", {
      name: this.name
    }))), this.storage = tt(Le(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Xt(t);
  }
  configure(t = {}) {
    const n = this.extend();
    return n.parent = this.parent, n.options = Ld(this.options, t), n.storage = tt(Le(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(t = {}) {
    const n = new Xt({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = tt(Le(n, "addOptions", {
      name: n.name
    })), n.storage = tt(Le(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function Gv(e, t, n) {
  const { from: r, to: i } = t, { blockSeparator: o = `

`, textSerializers: a = {} } = n || {};
  let s = "";
  return e.nodesBetween(r, i, (l, d, u, c) => {
    var f;
    l.isBlock && d > r && (s += o);
    const h = a == null ? void 0 : a[l.type.name];
    if (h)
      return u && (s += h({
        node: l,
        pos: d,
        parent: u,
        index: c,
        range: t
      })), !1;
    l.isText && (s += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, d) - d, i - d));
  }), s;
}
function Jv(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, n]) => [t, n.spec.toText]));
}
const HD = Xt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new cn({
        key: new zn("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: n } = e, { doc: r, selection: i } = t, { ranges: o } = i, a = Math.min(...o.map((u) => u.$from.pos)), s = Math.max(...o.map((u) => u.$to.pos)), l = Jv(n);
            return Gv(r, { from: a, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), jD = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var n;
  e.isDestroyed || (t.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), WD = (e = !1) => ({ commands: t }) => t.setContent("", e), UD = () => ({ state: e, tr: t, dispatch: n }) => {
  const { selection: r } = t, { ranges: i } = r;
  return n && i.forEach(({ $from: o, $to: a }) => {
    e.doc.nodesBetween(o.pos, a.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: d, mapping: u } = t, c = d.resolve(u.map(l)), f = d.resolve(u.map(l + s.nodeSize)), h = c.blockRange(f);
      if (!h)
        return;
      const p = ha(h);
      if (s.type.isTextblock) {
        const { defaultType: m } = c.parent.contentMatchAt(c.index());
        t.setNodeMarkup(h.start, m);
      }
      (p || p === 0) && t.lift(h, p);
    });
  }), !0;
}, qD = (e) => (t) => e(t), YD = () => ({ state: e, dispatch: t }) => hD(e, t), KD = (e, t) => ({ editor: n, tr: r }) => {
  const { state: i } = n, o = i.doc.slice(e.from, e.to);
  r.deleteRange(e.from, e.to);
  const a = r.mapping.map(t);
  return r.insert(a, o.content), r.setSelection(new Xe(r.doc.resolve(a - 1))), !0;
}, GD = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = e.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === r.type) {
      if (t) {
        const s = i.before(o), l = i.after(o);
        e.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, JD = (e) => ({ tr: t, state: n, dispatch: r }) => {
  const i = sn(e, n.schema), o = t.selection.$anchor;
  for (let a = o.depth; a > 0; a -= 1)
    if (o.node(a).type === i) {
      if (r) {
        const l = o.before(a), d = o.after(a);
        t.delete(l, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, XD = (e) => ({ tr: t, dispatch: n }) => {
  const { from: r, to: i } = e;
  return n && t.delete(r, i), !0;
}, QD = () => ({ state: e, dispatch: t }) => nD(e, t), ZD = () => ({ commands: e }) => e.keyboardShortcut("Enter"), eA = () => ({ state: e, dispatch: t }) => pD(e, t);
function Ol(e, t, n = { strict: !0 }) {
  const r = Object.keys(t);
  return r.length ? r.every((i) => n.strict ? t[i] === e[i] : Sf(t[i]) ? t[i].test(e[i]) : t[i] === e[i]) : !0;
}
function Rc(e, t, n = {}) {
  return e.find((r) => r.type === t && Ol(r.attrs, n));
}
function tA(e, t, n = {}) {
  return !!Rc(e, t, n);
}
function Cf(e, t, n = {}) {
  if (!e || !t)
    return;
  let r = e.parent.childAfter(e.parentOffset);
  if (e.parentOffset === r.offset && r.offset !== 0 && (r = e.parent.childBefore(e.parentOffset)), !r.node)
    return;
  const i = Rc([...r.node.marks], t, n);
  if (!i)
    return;
  let o = r.index, a = e.start() + r.offset, s = o + 1, l = a + r.node.nodeSize;
  for (Rc([...r.node.marks], t, n); o > 0 && i.isInSet(e.parent.child(o - 1).marks); )
    o -= 1, a -= e.parent.child(o).nodeSize;
  for (; s < e.parent.childCount && tA([...e.parent.child(s).marks], t, n); )
    l += e.parent.child(s).nodeSize, s += 1;
  return {
    from: a,
    to: l
  };
}
function Hi(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
const nA = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const o = Hi(e, r.schema), { doc: a, selection: s } = n, { $from: l, from: d, to: u } = s;
  if (i) {
    const c = Cf(l, o, t);
    if (c && c.from <= d && c.to >= u) {
      const f = Xe.create(a, c.from, c.to);
      n.setSelection(f);
    }
  }
  return !0;
}, rA = (e) => (t) => {
  const n = typeof e == "function" ? e(t) : e;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](t))
      return !0;
  return !1;
};
function Tf(e) {
  return e instanceof Xe;
}
function ii(e = 0, t = 0, n = 0) {
  return Math.min(Math.max(e, t), n);
}
function Xv(e, t = null) {
  if (!t)
    return null;
  const n = rt.atStart(e), r = rt.atEnd(e);
  if (t === "start" || t === !0)
    return n;
  if (t === "end")
    return r;
  const i = n.from, o = r.to;
  return t === "all" ? Xe.create(e, ii(0, i, o), ii(e.content.size, i, o)) : Xe.create(e, ii(t, i, o), ii(t, i, o));
}
function Mf() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const iA = (e = null, t = {}) => ({ editor: n, view: r, tr: i, dispatch: o }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const a = () => {
    Mf() && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), t != null && t.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && e === null || e === !1)
    return !0;
  if (o && e === null && !Tf(n.state.selection))
    return a(), !0;
  const s = Xv(i.doc, e) || n.state.selection, l = n.state.selection.eq(s);
  return o && (l || i.setSelection(s), l && i.storedMarks && i.setStoredMarks(i.storedMarks), a()), !0;
}, oA = (e, t) => (n) => e.every((r, i) => t(r, { ...n, index: i })), aA = (e, t) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, e, t), Qv = (e) => {
  const t = e.childNodes;
  for (let n = t.length - 1; n >= 0; n -= 1) {
    const r = t[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? e.removeChild(r) : r.nodeType === 1 && Qv(r);
  }
  return e;
};
function T1(e) {
  const t = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(t, "text/html").body;
  return Qv(n);
}
function El(e, t, n) {
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof e == "object" && e !== null, i = typeof e == "string";
  if (r)
    try {
      return Array.isArray(e) && e.length > 0 ? ve.fromArray(e.map((a) => t.nodeFromJSON(a))) : t.nodeFromJSON(e);
    } catch (o) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", o), El("", t, n);
    }
  if (i) {
    const o = oa.fromSchema(t);
    return n.slice ? o.parseSlice(T1(e), n.parseOptions).content : o.parse(T1(e), n.parseOptions);
  }
  return El("", t, n);
}
function sA(e, t, n) {
  const r = e.steps.length - 1;
  if (r < t)
    return;
  const i = e.steps[r];
  if (!(i instanceof en || i instanceof rn))
    return;
  const o = e.mapping.maps[r];
  let a = 0;
  o.forEach((s, l, d, u) => {
    a === 0 && (a = u);
  }), e.setSelection(rt.near(e.doc.resolve(a), n));
}
const lA = (e) => e.toString().startsWith("<"), dA = (e, t, n) => ({ tr: r, dispatch: i, editor: o }) => {
  if (i) {
    n = {
      parseOptions: {},
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    const a = El(t, o.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...n.parseOptions
      }
    });
    if (a.toString() === "<>")
      return !0;
    let { from: s, to: l } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, d = !0, u = !0;
    if ((lA(a) ? a : [a]).forEach((h) => {
      h.check(), d = d ? h.isText && h.marks.length === 0 : !1, u = u ? h.isBlock : !1;
    }), s === l && u) {
      const { parent: h } = r.doc.resolve(s);
      h.isTextblock && !h.type.spec.code && !h.childCount && (s -= 1, l += 1);
    }
    let f;
    d ? (Array.isArray(t) ? f = t.map((h) => h.text || "").join("") : typeof t == "object" && t && t.text ? f = t.text : f = t, r.insertText(f, s, l)) : (f = a, r.replaceWith(s, l, f)), n.updateSelection && sA(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: s, text: f }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: s, text: f });
  }
  return !0;
}, uA = () => ({ state: e, dispatch: t }) => dD(e, t), cA = () => ({ state: e, dispatch: t }) => uD(e, t), fA = () => ({ state: e, dispatch: t }) => rD(e, t), pA = () => ({ state: e, dispatch: t }) => sD(e, t), hA = () => ({ tr: e, state: t, dispatch: n }) => {
  try {
    const r = Md(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (e.join(r, 2), n && n(e), !0);
  } catch {
    return !1;
  }
}, mA = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = Md(e.doc, e.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, gA = () => ({ state: e, dispatch: t }) => iD(e, t), vA = () => ({ state: e, dispatch: t }) => oD(e, t);
function Zv() {
  return typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : !1;
}
function yA(e) {
  const t = e.split(/-(?!$)/);
  let n = t[t.length - 1];
  n === "Space" && (n = " ");
  let r, i, o, a;
  for (let s = 0; s < t.length - 1; s += 1) {
    const l = t[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      Mf() || Zv() ? a = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), a && (n = `Meta-${n}`), o && (n = `Shift-${n}`), n;
}
const bA = (e) => ({ editor: t, view: n, tr: r, dispatch: i }) => {
  const o = yA(e).split(/-(?!$)/), a = o.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), s = new KeyboardEvent("keydown", {
    key: a === "Space" ? " " : a,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = t.captureTransaction(() => {
    n.someProp("handleKeyDown", (d) => d(n, s));
  });
  return l == null || l.steps.forEach((d) => {
    const u = d.map(r.mapping);
    u && i && r.maybeStep(u);
  }), !0;
};
function is(e, t, n = {}) {
  const { from: r, to: i, empty: o } = e.selection, a = t ? sn(t, e.schema) : null, s = [];
  e.doc.nodesBetween(r, i, (c, f) => {
    if (c.isText)
      return;
    const h = Math.max(r, f), p = Math.min(i, f + c.nodeSize);
    s.push({
      node: c,
      from: h,
      to: p
    });
  });
  const l = i - r, d = s.filter((c) => a ? a.name === c.node.type.name : !0).filter((c) => Ol(c.node.attrs, n, { strict: !1 }));
  return o ? !!d.length : d.reduce((c, f) => c + f.to - f.from, 0) >= l;
}
const $A = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = sn(e, n.schema);
  return is(n, i, t) ? cD(n, r) : !1;
}, wA = () => ({ state: e, dispatch: t }) => mD(e, t), kA = (e) => ({ state: t, dispatch: n }) => {
  const r = sn(e, t.schema);
  return xD(r)(t, n);
}, xA = () => ({ state: e, dispatch: t }) => fD(e, t);
function Fd(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function M1(e, t) {
  const n = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((r, i) => (n.includes(i) || (r[i] = e[i]), r), {});
}
const SA = (e, t) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, a = null;
  const s = Fd(typeof e == "string" ? e : e.name, r.schema);
  return s ? (s === "node" && (o = sn(e, r.schema)), s === "mark" && (a = Hi(e, r.schema)), i && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (d, u) => {
      o && o === d.type && n.setNodeMarkup(u, void 0, M1(d.attrs, t)), a && d.marks.length && d.marks.forEach((c) => {
        a === c.type && n.addMark(u, u + d.nodeSize, a.create(M1(c.attrs, t)));
      });
    });
  }), !0) : !1;
}, CA = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), TA = () => ({ tr: e, commands: t }) => t.setTextSelection({
  from: 0,
  to: e.doc.content.size
}), MA = () => ({ state: e, dispatch: t }) => aD(e, t), OA = () => ({ state: e, dispatch: t }) => lD(e, t), EA = () => ({ state: e, dispatch: t }) => gD(e, t), DA = () => ({ state: e, dispatch: t }) => bD(e, t), AA = () => ({ state: e, dispatch: t }) => yD(e, t);
function ey(e, t, n = {}) {
  return El(e, t, { slice: !1, parseOptions: n });
}
const PA = (e, t = !1, n = {}) => ({ tr: r, editor: i, dispatch: o }) => {
  const { doc: a } = r, s = ey(e, i.schema, n);
  return o && r.replaceWith(0, a.content.size, s).setMeta("preventUpdate", !t), !0;
};
function xs(e, t) {
  const n = Hi(t, e.schema), { from: r, to: i, empty: o } = e.selection, a = [];
  o ? (e.storedMarks && a.push(...e.storedMarks), a.push(...e.selection.$head.marks())) : e.doc.nodesBetween(r, i, (l) => {
    a.push(...l.marks);
  });
  const s = a.find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function NA(e, t) {
  const n = new iv(e);
  return t.forEach((r) => {
    r.steps.forEach((i) => {
      n.step(i);
    });
  }), n;
}
function IA(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function RA(e, t, n) {
  const r = [];
  return e.nodesBetween(t.from, t.to, (i, o) => {
    n(i) && r.push({
      node: i,
      pos: o
    });
  }), r;
}
function _A(e, t) {
  for (let n = e.depth; n > 0; n -= 1) {
    const r = e.node(n);
    if (t(r))
      return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: r
      };
  }
}
function Of(e) {
  return (t) => _A(t.$from, e);
}
function LA(e, t) {
  const n = Nr.fromSchema(t).serializeFragment(e), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(n), i.innerHTML;
}
function FA(e, t) {
  const n = {
    from: 0,
    to: e.content.size
  };
  return Gv(e, n, t);
}
function BA(e, t) {
  const n = sn(t, e.schema), { from: r, to: i } = e.selection, o = [];
  e.doc.nodesBetween(r, i, (s) => {
    o.push(s);
  });
  const a = o.reverse().find((s) => s.type.name === n.name);
  return a ? { ...a.attrs } : {};
}
function ty(e, t) {
  const n = Fd(typeof t == "string" ? t : t.name, e.schema);
  return n === "node" ? BA(e, t) : n === "mark" ? xs(e, t) : {};
}
function zA(e, t = JSON.stringify) {
  const n = {};
  return e.filter((r) => {
    const i = t(r);
    return Object.prototype.hasOwnProperty.call(n, i) ? !1 : n[i] = !0;
  });
}
function VA(e) {
  const t = zA(e);
  return t.length === 1 ? t : t.filter((n, r) => !t.filter((o, a) => a !== r).some((o) => n.oldRange.from >= o.oldRange.from && n.oldRange.to <= o.oldRange.to && n.newRange.from >= o.newRange.from && n.newRange.to <= o.newRange.to));
}
function HA(e) {
  const { mapping: t, steps: n } = e, r = [];
  return t.maps.forEach((i, o) => {
    const a = [];
    if (i.ranges.length)
      i.forEach((s, l) => {
        a.push({ from: s, to: l });
      });
    else {
      const { from: s, to: l } = n[o];
      if (s === void 0 || l === void 0)
        return;
      a.push({ from: s, to: l });
    }
    a.forEach(({ from: s, to: l }) => {
      const d = t.slice(o).map(s, -1), u = t.slice(o).map(l), c = t.invert().map(d, -1), f = t.invert().map(u);
      r.push({
        oldRange: {
          from: c,
          to: f
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), VA(r);
}
function Ef(e, t, n) {
  const r = [];
  return e === t ? n.resolve(e).marks().forEach((i) => {
    const o = n.resolve(e - 1), a = Cf(o, i.type);
    a && r.push({
      mark: i,
      ...a
    });
  }) : n.nodesBetween(e, t, (i, o) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(...i.marks.map((a) => ({
      from: o,
      to: o + i.nodeSize,
      mark: a
    })));
  }), r;
}
function Js(e, t, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const i = e.find((o) => o.type === t && o.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function _c(e, t, n = {}) {
  const { empty: r, ranges: i } = e.selection, o = t ? Hi(t, e.schema) : null;
  if (r)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((c) => o ? o.name === c.type.name : !0).find((c) => Ol(c.attrs, n, { strict: !1 }));
  let a = 0;
  const s = [];
  if (i.forEach(({ $from: c, $to: f }) => {
    const h = c.pos, p = f.pos;
    e.doc.nodesBetween(h, p, (m, g) => {
      if (!m.isText && !m.marks.length)
        return;
      const v = Math.max(h, g), b = Math.min(p, g + m.nodeSize), x = b - v;
      a += x, s.push(...m.marks.map((y) => ({
        mark: y,
        from: v,
        to: b
      })));
    });
  }), a === 0)
    return !1;
  const l = s.filter((c) => o ? o.name === c.mark.type.name : !0).filter((c) => Ol(c.mark.attrs, n, { strict: !1 })).reduce((c, f) => c + f.to - f.from, 0), d = s.filter((c) => o ? c.mark.type !== o && c.mark.type.excludes(o) : !0).reduce((c, f) => c + f.to - f.from, 0);
  return (l > 0 ? l + d : l) >= a;
}
function jA(e, t, n = {}) {
  if (!t)
    return is(e, null, n) || _c(e, null, n);
  const r = Fd(t, e.schema);
  return r === "node" ? is(e, t, n) : r === "mark" ? _c(e, t, n) : !1;
}
function O1(e, t) {
  const { nodeExtensions: n } = Rd(t), r = n.find((a) => a.name === e);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, o = tt(Le(r, "group", i));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function WA(e) {
  var t;
  const n = (t = e.type.createAndFill()) === null || t === void 0 ? void 0 : t.toJSON(), r = e.toJSON();
  return JSON.stringify(n) === JSON.stringify(r);
}
function UA(e) {
  return e instanceof He;
}
function ny(e, t, n) {
  const i = e.state.doc.content.size, o = ii(t, 0, i), a = ii(n, 0, i), s = e.coordsAtPos(o), l = e.coordsAtPos(a, -1), d = Math.min(s.top, l.top), u = Math.max(s.bottom, l.bottom), c = Math.min(s.left, l.left), f = Math.max(s.right, l.right), h = f - c, p = u - d, v = {
    top: d,
    bottom: u,
    left: c,
    right: f,
    width: h,
    height: p,
    x: c,
    y: d
  };
  return {
    ...v,
    toJSON: () => v
  };
}
function qA(e, t, n) {
  var r;
  const { selection: i } = t;
  let o = null;
  if (Tf(i) && (o = i.$cursor), o) {
    const s = (r = e.storedMarks) !== null && r !== void 0 ? r : o.marks();
    return !!n.isInSet(s) || !s.some((l) => l.type.excludes(n));
  }
  const { ranges: a } = i;
  return a.some(({ $from: s, $to: l }) => {
    let d = s.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(n) : !1;
    return e.doc.nodesBetween(s.pos, l.pos, (u, c, f) => {
      if (d)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(n), p = !!n.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(n));
        d = h && p;
      }
      return !d;
    }), d;
  });
}
const YA = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: o } = n, { empty: a, ranges: s } = o, l = Hi(e, r.schema);
  if (i)
    if (a) {
      const d = xs(r, l);
      n.addStoredMark(l.create({
        ...d,
        ...t
      }));
    } else
      s.forEach((d) => {
        const u = d.$from.pos, c = d.$to.pos;
        r.doc.nodesBetween(u, c, (f, h) => {
          const p = Math.max(h, u), m = Math.min(h + f.nodeSize, c);
          f.marks.find((v) => v.type === l) ? f.marks.forEach((v) => {
            l === v.type && n.addMark(p, m, l.create({
              ...v.attrs,
              ...t
            }));
          }) : n.addMark(p, m, l.create(t));
        });
      });
  return qA(r, n, l);
}, KA = (e, t) => ({ tr: n }) => (n.setMeta(e, t), !0), GA = (e, t = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const o = sn(e, n.schema);
  return o.isTextblock ? i().command(({ commands: a }) => k1(o, t)(n) ? !0 : a.clearNodes()).command(({ state: a }) => k1(o, t)(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, JA = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, i = ii(e, 0, r.content.size), o = He.create(r, i);
    t.setSelection(o);
  }
  return !0;
}, XA = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, { from: i, to: o } = typeof e == "number" ? { from: e, to: e } : e, a = Xe.atStart(r).from, s = Xe.atEnd(r).to, l = ii(i, a, s), d = ii(o, a, s), u = Xe.create(r, l, d);
    t.setSelection(u);
  }
  return !0;
}, QA = (e) => ({ state: t, dispatch: n }) => {
  const r = sn(e, t.schema);
  return TD(r)(t, n);
};
function E1(e, t) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => t == null ? void 0 : t.includes(i.type.name));
    e.tr.ensureMarks(r);
  }
}
const ZA = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: n, dispatch: r, editor: i }) => {
  const { selection: o, doc: a } = t, { $from: s, $to: l } = o, d = i.extensionManager.attributes, u = Js(d, s.node().type.name, s.node().attrs);
  if (o instanceof He && o.node.isBlock)
    return !s.parentOffset || !Uo(a, s.pos) ? !1 : (r && (e && E1(n, i.extensionManager.splittableMarks), t.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  if (r) {
    const c = l.parentOffset === l.parent.content.size;
    o instanceof Xe && t.deleteSelection();
    const f = s.depth === 0 ? void 0 : IA(s.node(-1).contentMatchAt(s.indexAfter(-1)));
    let h = c && f ? [
      {
        type: f,
        attrs: u
      }
    ] : void 0, p = Uo(t.doc, t.mapping.map(s.pos), 1, h);
    if (!h && !p && Uo(t.doc, t.mapping.map(s.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
      {
        type: f,
        attrs: u
      }
    ] : void 0), p && (t.split(t.mapping.map(s.pos), 1, h), f && !c && !s.parentOffset && s.parent.type !== f)) {
      const m = t.mapping.map(s.before()), g = t.doc.resolve(m);
      s.node(-1).canReplaceWith(g.index(), g.index() + 1, f) && t.setNodeMarkup(t.mapping.map(s.before()), f);
    }
    e && E1(n, i.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return !0;
}, eP = (e) => ({ tr: t, state: n, dispatch: r, editor: i }) => {
  var o;
  const a = sn(e, n.schema), { $from: s, $to: l } = n.selection, d = n.selection.node;
  if (d && d.isBlock || s.depth < 2 || !s.sameParent(l))
    return !1;
  const u = s.node(-1);
  if (u.type !== a)
    return !1;
  const c = i.extensionManager.attributes;
  if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
    if (s.depth === 2 || s.node(-3).type !== a || s.index(-2) !== s.node(-2).childCount - 1)
      return !1;
    if (r) {
      let g = ve.empty;
      const v = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
      for (let O = s.depth - v; O >= s.depth - 3; O -= 1)
        g = ve.from(s.node(O).copy(g));
      const b = s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3, x = Js(c, s.node().type.name, s.node().attrs), y = ((o = a.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(x)) || void 0;
      g = g.append(ve.from(a.createAndFill(null, y) || void 0));
      const C = s.before(s.depth - (v - 1));
      t.replace(C, s.after(-b), new Ae(g, 4 - v, 0));
      let $ = -1;
      t.doc.nodesBetween(C, t.doc.content.size, (O, z) => {
        if ($ > -1)
          return !1;
        O.isTextblock && O.content.size === 0 && ($ = z + 1);
      }), $ > -1 && t.setSelection(Xe.near(t.doc.resolve($))), t.scrollIntoView();
    }
    return !0;
  }
  const f = l.pos === s.end() ? u.contentMatchAt(0).defaultType : null, h = Js(c, u.type.name, u.attrs), p = Js(c, s.node().type.name, s.node().attrs);
  t.delete(s.pos, l.pos);
  const m = f ? [
    { type: a, attrs: h },
    { type: f, attrs: p }
  ] : [{ type: a, attrs: h }];
  if (!Uo(t.doc, s.pos, 2))
    return !1;
  if (r) {
    const { selection: g, storedMarks: v } = n, { splittableMarks: b } = i.extensionManager, x = v || g.$to.parentOffset && g.$from.marks();
    if (t.split(s.pos, 2, m).scrollIntoView(), !x || !r)
      return !0;
    const y = x.filter((C) => b.includes(C.type.name));
    t.ensureMarks(y);
  }
  return !0;
}, Lu = (e, t) => {
  const n = Of((a) => a.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = e.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && zi(e.doc, n.pos) && e.join(n.pos), !0;
}, Fu = (e, t) => {
  const n = Of((a) => a.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = e.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && zi(e.doc, r) && e.join(r), !0;
}, tP = (e, t, n, r = {}) => ({ editor: i, tr: o, state: a, dispatch: s, chain: l, commands: d, can: u }) => {
  const { extensions: c, splittableMarks: f } = i.extensionManager, h = sn(e, a.schema), p = sn(t, a.schema), { selection: m, storedMarks: g } = a, { $from: v, $to: b } = m, x = v.blockRange(b), y = g || m.$to.parentOffset && m.$from.marks();
  if (!x)
    return !1;
  const C = Of(($) => O1($.type.name, c))(m);
  if (x.depth >= 1 && C && x.depth - C.depth <= 1) {
    if (C.node.type === h)
      return d.liftListItem(p);
    if (O1(C.node.type.name, c) && h.validContent(C.node.content) && s)
      return l().command(() => (o.setNodeMarkup(C.pos, h), !0)).command(() => Lu(o, h)).command(() => Fu(o, h)).run();
  }
  return !n || !y || !s ? l().command(() => u().wrapInList(h, r) ? !0 : d.clearNodes()).wrapInList(h, r).command(() => Lu(o, h)).command(() => Fu(o, h)).run() : l().command(() => {
    const $ = u().wrapInList(h, r), O = y.filter((z) => f.includes(z.type.name));
    return o.ensureMarks(O), $ ? !0 : d.clearNodes();
  }).wrapInList(h, r).command(() => Lu(o, h)).command(() => Fu(o, h)).run();
}, nP = (e, t = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: o = !1 } = n, a = Hi(e, r.schema);
  return _c(r, a, t) ? i.unsetMark(a, { extendEmptyMarkRange: o }) : i.setMark(a, t);
}, rP = (e, t, n = {}) => ({ state: r, commands: i }) => {
  const o = sn(e, r.schema), a = sn(t, r.schema);
  return is(r, o, n) ? i.setNode(a) : i.setNode(o, n);
}, iP = (e, t = {}) => ({ state: n, commands: r }) => {
  const i = sn(e, n.schema);
  return is(n, i, t) ? r.lift(i) : r.wrapIn(i, t);
}, oP = () => ({ state: e, dispatch: t }) => {
  const n = e.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let o;
    if (i.spec.isInputRules && (o = i.getState(e))) {
      if (t) {
        const a = e.tr, s = o.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          a.step(s.steps[l].invert(s.docs[l]));
        if (o.text) {
          const l = a.doc.resolve(o.from).marks();
          a.replaceWith(o.from, o.to, e.schema.text(o.text, l));
        } else
          a.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, aP = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, { empty: r, ranges: i } = n;
  return r || t && i.forEach((o) => {
    e.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, sP = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var o;
  const { extendEmptyMarkRange: a = !1 } = t, { selection: s } = n, l = Hi(e, r.schema), { $from: d, empty: u, ranges: c } = s;
  if (!i)
    return !0;
  if (u && a) {
    let { from: f, to: h } = s;
    const p = (o = d.marks().find((g) => g.type === l)) === null || o === void 0 ? void 0 : o.attrs, m = Cf(d, l, p);
    m && (f = m.from, h = m.to), n.removeMark(f, h, l);
  } else
    c.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, lP = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, a = null;
  const s = Fd(typeof e == "string" ? e : e.name, r.schema);
  return s ? (s === "node" && (o = sn(e, r.schema)), s === "mark" && (a = Hi(e, r.schema)), i && n.selection.ranges.forEach((l) => {
    const d = l.$from.pos, u = l.$to.pos;
    r.doc.nodesBetween(d, u, (c, f) => {
      o && o === c.type && n.setNodeMarkup(f, void 0, {
        ...c.attrs,
        ...t
      }), a && c.marks.length && c.marks.forEach((h) => {
        if (a === h.type) {
          const p = Math.max(f, d), m = Math.min(f + c.nodeSize, u);
          n.addMark(p, m, a.create({
            ...h.attrs,
            ...t
          }));
        }
      });
    });
  }), !0) : !1;
}, dP = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = sn(e, n.schema);
  return $D(i, t)(n, r);
}, uP = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = sn(e, n.schema);
  return wD(i, t)(n, r);
};
var cP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: jD,
  clearContent: WD,
  clearNodes: UD,
  command: qD,
  createParagraphNear: YD,
  cut: KD,
  deleteCurrentNode: GD,
  deleteNode: JD,
  deleteRange: XD,
  deleteSelection: QD,
  enter: ZD,
  exitCode: eA,
  extendMarkRange: nA,
  first: rA,
  focus: iA,
  forEach: oA,
  insertContent: aA,
  insertContentAt: dA,
  joinUp: uA,
  joinDown: cA,
  joinBackward: fA,
  joinForward: pA,
  joinItemBackward: hA,
  joinItemForward: mA,
  joinTextblockBackward: gA,
  joinTextblockForward: vA,
  keyboardShortcut: bA,
  lift: $A,
  liftEmptyBlock: wA,
  liftListItem: kA,
  newlineInCode: xA,
  resetAttributes: SA,
  scrollIntoView: CA,
  selectAll: TA,
  selectNodeBackward: MA,
  selectNodeForward: OA,
  selectParentNode: EA,
  selectTextblockEnd: DA,
  selectTextblockStart: AA,
  setContent: PA,
  setMark: YA,
  setMeta: KA,
  setNode: GA,
  setNodeSelection: JA,
  setTextSelection: XA,
  sinkListItem: QA,
  splitBlock: ZA,
  splitListItem: eP,
  toggleList: tP,
  toggleMark: nP,
  toggleNode: rP,
  toggleWrap: iP,
  undoInputRule: oP,
  unsetAllMarks: aP,
  unsetMark: sP,
  updateAttributes: lP,
  wrapIn: dP,
  wrapInList: uP
});
const fP = Xt.create({
  name: "commands",
  addCommands() {
    return {
      ...cP
    };
  }
}), pP = Xt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new cn({
        key: new zn("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), hP = Xt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new cn({
        key: new zn("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (t, n) => {
              e.isFocused = !0;
              const r = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            },
            blur: (t, n) => {
              e.isFocused = !1;
              const r = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), mP = Xt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: a }) => [
      () => a.undoInputRule(),
      // maybe convert first text block node to default node
      () => a.command(({ tr: s }) => {
        const { selection: l, doc: d } = s, { empty: u, $anchor: c } = l, { pos: f, parent: h } = c, p = c.parent.isTextblock && f > 0 ? s.doc.resolve(f - 1) : c, m = p.parent.type.spec.isolating, g = c.pos - c.parentOffset, v = m && p.parent.childCount === 1 ? g === c.pos : rt.atStart(d).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !v || v && c.parent.type.name === "paragraph" ? !1 : a.clearNodes();
      }),
      () => a.deleteSelection(),
      () => a.joinBackward(),
      () => a.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: a }) => [
      () => a.deleteSelection(),
      () => a.deleteCurrentNode(),
      () => a.joinForward(),
      () => a.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: a }) => [
        () => a.newlineInCode(),
        () => a.createParagraphNear(),
        () => a.liftEmptyBlock(),
        () => a.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, o = {
      ...r,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Mf() || Zv() ? o : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new cn({
        key: new zn("clearDocument"),
        appendTransaction: (e, t, n) => {
          if (!(e.some((p) => p.docChanged) && !t.doc.eq(n.doc)))
            return;
          const { empty: i, from: o, to: a } = t.selection, s = rt.atStart(t.doc).from, l = rt.atEnd(t.doc).to;
          if (i || !(o === s && a === l) || !(n.doc.textBetween(0, n.doc.content.size, " ", " ").length === 0))
            return;
          const c = n.tr, f = Nd({
            state: n,
            transaction: c
          }), { commands: h } = new Id({
            editor: this.editor,
            state: f
          });
          if (h.clearNodes(), !!c.steps.length)
            return c;
        }
      })
    ];
  }
}), gP = Xt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new cn({
        key: new zn("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Ji {
  constructor(t, n, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = t, this.editor = n, this.currentNode = i;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var t;
    return (t = this.actualDepth) !== null && t !== void 0 ? t : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(t) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, t);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const t = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(t);
    return new Ji(n, this.editor);
  }
  get before() {
    let t = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.from - 3)), new Ji(t, this.editor);
  }
  get after() {
    let t = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.to + 3)), new Ji(t, this.editor);
  }
  get children() {
    const t = [];
    return this.node.content.forEach((n, r) => {
      const i = n.isBlock && !n.isTextblock, o = this.pos + r + 1, a = this.resolvedPos.doc.resolve(o);
      if (!i && a.depth <= this.depth)
        return;
      const s = new Ji(a, this.editor, i, i ? n : null);
      i && (s.actualDepth = this.depth + 1), t.push(new Ji(a, this.editor, i, i ? n : null));
    }), t;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const t = this.children;
    return t[t.length - 1] || null;
  }
  closest(t, n = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === t)
        if (Object.keys(n).length > 0) {
          const o = i.node.attrs, a = Object.keys(n);
          for (let s = 0; s < a.length; s += 1) {
            const l = a[s];
            if (o[l] !== n[l])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(t, n = {}) {
    return this.querySelectorAll(t, n, !0)[0] || null;
  }
  querySelectorAll(t, n = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const o = Object.keys(n);
    return this.children.forEach((a) => {
      r && i.length > 0 || (a.node.type.name === t && o.every((l) => n[l] === a.node.attrs[l]) && i.push(a), !(r && i.length > 0) && (i = i.concat(a.querySelectorAll(t, n, r))));
    }), i;
  }
  setAttribute(t) {
    const n = this.editor.state.selection;
    this.editor.chain().setTextSelection(this.from).updateAttributes(this.node.type.name, t).setTextSelection(n.from).run();
  }
}
const vP = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 1px !important;
  height: 1px !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function yP(e, t, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return t && i.setAttribute("nonce", t), i.setAttribute("data-tiptap-style", ""), i.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(i), i;
}
let bP = class extends MD {
  constructor(t = {}) {
    super(), this.isFocused = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(t), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }));
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = yP(vP, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(t = {}) {
    this.options = {
      ...this.options,
      ...t
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(t, n = !0) {
    this.setOptions({ editable: t }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   */
  registerPlugin(t, n) {
    const r = Kv(n) ? n(t, [...this.state.plugins]) : [...this.state.plugins, t], i = this.state.reconfigure({ plugins: r });
    this.view.updateState(i);
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKey The plugins name
   */
  unregisterPlugin(t) {
    if (this.isDestroyed)
      return;
    const n = typeof t == "string" ? `${t}$` : t.key, r = this.state.reconfigure({
      // @ts-ignore
      plugins: this.state.plugins.filter((i) => !i.key.startsWith(n))
    });
    this.view.updateState(r);
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var t, n;
    const i = [...this.options.enableCoreExtensions ? [
      pP,
      HD.configure({
        blockSeparator: (n = (t = this.options.coreExtensionOptions) === null || t === void 0 ? void 0 : t.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      fP,
      hP,
      mP,
      gP
    ] : [], ...this.options.extensions].filter((o) => ["extension", "node", "mark"].includes(o == null ? void 0 : o.type));
    this.extensionManager = new Ho(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Id({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    const t = ey(this.options.content, this.schema, this.options.parseOptions), n = Xv(t, this.options.autofocus);
    this.view = new qE(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Vo.create({
        doc: t,
        selection: n || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(t) {
    this.isCapturingTransaction = !0, t(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(t) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = t;
        return;
      }
      t.steps.forEach((a) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(a);
      });
      return;
    }
    const n = this.state.apply(t), r = !this.state.selection.eq(n.selection);
    this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: t
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: t
    });
    const i = t.getMeta("focus"), o = t.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: t
    }), o && this.emit("blur", {
      editor: this,
      event: o.event,
      transaction: t
    }), !(!t.docChanged || t.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: t
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(t) {
    return ty(this.state, t);
  }
  isActive(t, n) {
    const r = typeof t == "string" ? t : null, i = typeof t == "string" ? n : t;
    return jA(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return LA(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(t) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = t || {};
    return FA(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...Jv(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return WA(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.view && this.view.destroy(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var t;
    return !(!((t = this.view) === null || t === void 0) && t.docView);
  }
  $node(t, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(t, n)) || null;
  }
  $nodes(t, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(t, n)) || null;
  }
  $pos(t) {
    const n = this.state.doc.resolve(t);
    return new Ji(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function yo(e) {
  return new _d({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = tt(e.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = t, a = r[r.length - 1], s = r[0];
      if (a) {
        const l = s.search(/\S/), d = n.from + s.indexOf(a), u = d + a.length;
        if (Ef(n.from, n.to, t.doc).filter((h) => h.mark.type.excluded.find((m) => m === e.type && m !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        u < n.to && o.delete(u, n.to), d > n.from && o.delete(n.from + l, d);
        const f = n.from + l + a.length;
        o.addMark(n.from + l, f, e.type.create(i || {})), o.removeStoredMark(e.type);
      }
    }
  });
}
function $P(e) {
  return new _d({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = tt(e.getAttributes, void 0, r) || {}, { tr: o } = t, a = n.from;
      let s = n.to;
      const l = e.type.create(i);
      if (r[1]) {
        const d = r[0].lastIndexOf(r[1]);
        let u = a + d;
        u > s ? u = s : s = u + r[1].length;
        const c = r[0][r[0].length - 1];
        o.insertText(c, a + r[0].length - 1), o.replaceWith(u, s, l);
      } else r[0] && o.insert(a - 1, e.type.create(i)).delete(o.mapping.map(a), o.mapping.map(s));
      o.scrollIntoView();
    }
  });
}
function Lc(e) {
  return new _d({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = t.doc.resolve(n.from), o = tt(e.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), e.type))
        return null;
      t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, o);
    }
  });
}
function as(e) {
  return new _d({
    find: e.find,
    handler: ({ state: t, range: n, match: r, chain: i }) => {
      const o = tt(e.getAttributes, void 0, r) || {}, a = t.tr.delete(n.from, n.to), l = a.doc.resolve(n.from).blockRange(), d = l && cf(l, e.type, o);
      if (!d)
        return null;
      if (a.wrap(l, d), e.keepMarks && e.editor) {
        const { selection: c, storedMarks: f } = t, { splittableMarks: h } = e.editor.extensionManager, p = f || c.$to.parentOffset && c.$from.marks();
        if (p) {
          const m = p.filter((g) => h.includes(g.type.name));
          a.ensureMarks(m);
        }
      }
      if (e.keepAttributes) {
        const c = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(c, o).run();
      }
      const u = a.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === e.type && zi(a.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(r, u)) && a.join(n.from - 1);
    }
  });
}
class Dn {
  constructor(t = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = tt(Le(this, "addOptions", {
      name: this.name
    }))), this.storage = tt(Le(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Dn(t);
  }
  configure(t = {}) {
    const n = this.extend();
    return n.options = Ld(this.options, t), n.storage = tt(Le(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(t = {}) {
    const n = new Dn({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = tt(Le(n, "addOptions", {
      name: n.name
    })), n.storage = tt(Le(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: t, mark: n }) {
    const { tr: r } = t.state, i = t.state.selection.$from;
    if (i.pos === i.end()) {
      const a = i.marks();
      if (!!!a.find((d) => (d == null ? void 0 : d.type.name) === n.name))
        return !1;
      const l = a.find((d) => (d == null ? void 0 : d.type.name) === n.name);
      return l && r.removeStoredMark(l), r.insertText(" ", i.pos), t.view.dispatch(r), !0;
    }
    return !1;
  }
}
let An = class Fc {
  constructor(t = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = tt(Le(this, "addOptions", {
      name: this.name
    }))), this.storage = tt(Le(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Fc(t);
  }
  configure(t = {}) {
    const n = this.extend();
    return n.options = Ld(this.options, t), n.storage = tt(Le(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(t = {}) {
    const n = new Fc({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = tt(Le(n, "addOptions", {
      name: n.name
    })), n.storage = tt(Le(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function _i(e) {
  return new RD({
    find: e.find,
    handler: ({ state: t, range: n, match: r, pasteEvent: i }) => {
      const o = tt(e.getAttributes, void 0, r, i);
      if (o === !1 || o === null)
        return null;
      const { tr: a } = t, s = r[r.length - 1], l = r[0];
      let d = n.to;
      if (s) {
        const u = l.search(/\S/), c = n.from + l.indexOf(s), f = c + s.length;
        if (Ef(n.from, n.to, t.doc).filter((p) => p.mark.type.excluded.find((g) => g === e.type && g !== p.mark.type)).filter((p) => p.to > c).length)
          return null;
        f < n.to && a.delete(f, n.to), c > n.from && a.delete(n.from + u, c), d = n.from + u + s.length, a.addMark(n.from + u, d, e.type.create(o || {})), a.removeStoredMark(e.type);
      }
    }
  });
}
const wP = Dn.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const n = xs(e, this.type);
        return Object.entries(n).some(([, i]) => !!i) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), kP = Xt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.color) === null || t === void 0 ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: t }) => t().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), xP = Xt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.fontFamily) === null || t === void 0 ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily.split(",").map((t) => CSS.escape(t.trim())).join(", ")}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: t }) => t().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), SP = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, CP = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, TP = Dn.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (e) => e.getAttribute("data-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["mark", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: t }) => t.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: t }) => t.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      yo({
        find: SP,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _i({
        find: CP,
        type: this.type
      })
    ];
  }
});
var Dl = 200, on = function() {
};
on.prototype.append = function(t) {
  return t.length ? (t = on.from(t), !this.length && t || t.length < Dl && this.leafAppend(t) || this.length < Dl && t.leafPrepend(this) || this.appendInner(t)) : this;
};
on.prototype.prepend = function(t) {
  return t.length ? on.from(t).append(this) : this;
};
on.prototype.appendInner = function(t) {
  return new MP(this, t);
};
on.prototype.slice = function(t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = this.length), t >= n ? on.empty : this.sliceInner(Math.max(0, t), Math.min(this.length, n));
};
on.prototype.get = function(t) {
  if (!(t < 0 || t >= this.length))
    return this.getInner(t);
};
on.prototype.forEach = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(t, n, r, 0) : this.forEachInvertedInner(t, n, r, 0);
};
on.prototype.map = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(o, a) {
    return i.push(t(o, a));
  }, n, r), i;
};
on.from = function(t) {
  return t instanceof on ? t : t && t.length ? new ry(t) : on.empty;
};
var ry = /* @__PURE__ */ function(e) {
  function t(r) {
    e.call(this), this.values = r;
  }
  e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return t.prototype.flatten = function() {
    return this.values;
  }, t.prototype.sliceInner = function(i, o) {
    return i == 0 && o == this.length ? this : new t(this.values.slice(i, o));
  }, t.prototype.getInner = function(i) {
    return this.values[i];
  }, t.prototype.forEachInner = function(i, o, a, s) {
    for (var l = o; l < a; l++)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, t.prototype.forEachInvertedInner = function(i, o, a, s) {
    for (var l = o - 1; l >= a; l--)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, t.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Dl)
      return new t(this.values.concat(i.flatten()));
  }, t.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Dl)
      return new t(i.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(t.prototype, n), t;
}(on);
on.empty = new ry([]);
var MP = /* @__PURE__ */ function(e) {
  function t(n, r) {
    e.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, t.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, t.prototype.forEachInner = function(r, i, o, a) {
    var s = this.left.length;
    if (i < s && this.left.forEachInner(r, i, Math.min(o, s), a) === !1 || o > s && this.right.forEachInner(r, Math.max(i - s, 0), Math.min(this.length, o) - s, a + s) === !1)
      return !1;
  }, t.prototype.forEachInvertedInner = function(r, i, o, a) {
    var s = this.left.length;
    if (i > s && this.right.forEachInvertedInner(r, i - s, Math.max(o, s) - s, a + s) === !1 || o < s && this.left.forEachInvertedInner(r, Math.min(i, s), o, a) === !1)
      return !1;
  }, t.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var o = this.left.length;
    return i <= o ? this.left.slice(r, i) : r >= o ? this.right.slice(r - o, i - o) : this.left.slice(r, o).append(this.right.slice(0, i - o));
  }, t.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new t(this.left, i);
  }, t.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new t(i, this.right);
  }, t.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new t(this.left, new t(this.right, r)) : new t(this, r);
  }, t;
}(on);
const OP = 500;
class ar {
  constructor(t, n) {
    this.items = t, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(t, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, o;
    n && (i = this.remapping(r, this.items.length), o = i.maps.length);
    let a = t.tr, s, l, d = [], u = [];
    return this.items.forEach((c, f) => {
      if (!c.step) {
        i || (i = this.remapping(r, f + 1), o = i.maps.length), o--, u.push(c);
        return;
      }
      if (i) {
        u.push(new wr(c.map));
        let h = c.step.map(i.slice(o)), p;
        h && a.maybeStep(h).doc && (p = a.mapping.maps[a.mapping.maps.length - 1], d.push(new wr(p, void 0, void 0, d.length + u.length))), o--, p && i.appendMap(p, o);
      } else
        a.maybeStep(c.step);
      if (c.selection)
        return s = i ? c.selection.map(i.slice(o)) : c.selection, l = new ar(this.items.slice(0, r).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: a, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(t, n, r, i) {
    let o = [], a = this.eventCount, s = this.items, l = !i && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < t.steps.length; u++) {
      let c = t.steps[u].invert(t.docs[u]), f = new wr(t.mapping.maps[u], c, n), h;
      (h = l && l.merge(f)) && (f = h, u ? o.pop() : s = s.slice(0, s.length - 1)), o.push(f), n && (a++, n = void 0), i || (l = f);
    }
    let d = a - r.depth;
    return d > DP && (s = EP(s, d), a -= d), new ar(s.append(o), a);
  }
  remapping(t, n) {
    let r = new Wo();
    return this.items.forEach((i, o) => {
      let a = i.mirrorOffset != null && o - i.mirrorOffset >= t ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, a);
    }, t, n), r;
  }
  addMaps(t) {
    return this.eventCount == 0 ? this : new ar(this.items.append(t.map((n) => new wr(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(t, n) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - n), o = t.mapping, a = t.steps.length, s = this.eventCount;
    this.items.forEach((f) => {
      f.selection && s--;
    }, i);
    let l = n;
    this.items.forEach((f) => {
      let h = o.getMirror(--l);
      if (h == null)
        return;
      a = Math.min(a, h);
      let p = o.maps[h];
      if (f.step) {
        let m = t.steps[h].invert(t.docs[h]), g = f.selection && f.selection.map(o.slice(l + 1, h));
        g && s++, r.push(new wr(p, m, g));
      } else
        r.push(new wr(p));
    }, i);
    let d = [];
    for (let f = n; f < a; f++)
      d.push(new wr(o.maps[f]));
    let u = this.items.slice(0, i).append(d).append(r), c = new ar(u, s);
    return c.emptyItemCount() > OP && (c = c.compress(this.items.length - r.length)), c;
  }
  emptyItemCount() {
    let t = 0;
    return this.items.forEach((n) => {
      n.step || t++;
    }), t;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(t = this.items.length) {
    let n = this.remapping(0, t), r = n.maps.length, i = [], o = 0;
    return this.items.forEach((a, s) => {
      if (s >= t)
        i.push(a), a.selection && o++;
      else if (a.step) {
        let l = a.step.map(n.slice(r)), d = l && l.getMap();
        if (r--, d && n.appendMap(d, r), l) {
          let u = a.selection && a.selection.map(n.slice(r));
          u && o++;
          let c = new wr(d.invert(), l, u), f, h = i.length - 1;
          (f = i.length && i[h].merge(c)) ? i[h] = f : i.push(c);
        }
      } else a.map && r--;
    }, this.items.length, 0), new ar(on.from(i.reverse()), o);
  }
}
ar.empty = new ar(on.empty, 0);
function EP(e, t) {
  let n;
  return e.forEach((r, i) => {
    if (r.selection && t-- == 0)
      return n = i, !1;
  }), e.slice(n);
}
class wr {
  constructor(t, n, r, i) {
    this.map = t, this.step = n, this.selection = r, this.mirrorOffset = i;
  }
  merge(t) {
    if (this.step && t.step && !t.selection) {
      let n = t.step.merge(this.step);
      if (n)
        return new wr(n.getMap().invert(), n, this.selection);
    }
  }
}
class wi {
  constructor(t, n, r, i, o) {
    this.done = t, this.undone = n, this.prevRanges = r, this.prevTime = i, this.prevComposition = o;
  }
}
const DP = 20;
function AP(e, t, n, r) {
  let i = n.getMeta(Ii), o;
  if (i)
    return i.historyState;
  n.getMeta(NP) && (e = new wi(e.done, e.undone, null, 0, -1));
  let a = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return e;
  if (a && a.getMeta(Ii))
    return a.getMeta(Ii).redo ? new wi(e.done.addTransform(n, void 0, r, Xs(t)), e.undone, D1(n.mapping.maps[n.steps.length - 1]), e.prevTime, e.prevComposition) : new wi(e.done, e.undone.addTransform(n, void 0, r, Xs(t)), null, e.prevTime, e.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(a && a.getMeta("addToHistory") === !1)) {
    let s = n.getMeta("composition"), l = e.prevTime == 0 || !a && e.prevComposition != s && (e.prevTime < (n.time || 0) - r.newGroupDelay || !PP(n, e.prevRanges)), d = a ? Bu(e.prevRanges, n.mapping) : D1(n.mapping.maps[n.steps.length - 1]);
    return new wi(e.done.addTransform(n, l ? t.selection.getBookmark() : void 0, r, Xs(t)), ar.empty, d, n.time, s == null ? e.prevComposition : s);
  } else return (o = n.getMeta("rebased")) ? new wi(e.done.rebased(n, o), e.undone.rebased(n, o), Bu(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new wi(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), Bu(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
}
function PP(e, t) {
  if (!t)
    return !1;
  if (!e.docChanged)
    return !0;
  let n = !1;
  return e.mapping.maps[0].forEach((r, i) => {
    for (let o = 0; o < t.length; o += 2)
      r <= t[o + 1] && i >= t[o] && (n = !0);
  }), n;
}
function D1(e) {
  let t = [];
  return e.forEach((n, r, i, o) => t.push(i, o)), t;
}
function Bu(e, t) {
  if (!e)
    return null;
  let n = [];
  for (let r = 0; r < e.length; r += 2) {
    let i = t.map(e[r], 1), o = t.map(e[r + 1], -1);
    i <= o && n.push(i, o);
  }
  return n;
}
function iy(e, t, n, r) {
  let i = Xs(t), o = Ii.get(t).spec.config, a = (r ? e.undone : e.done).popEvent(t, i);
  if (!a)
    return;
  let s = a.selection.resolve(a.transform.doc), l = (r ? e.done : e.undone).addTransform(a.transform, t.selection.getBookmark(), o, i), d = new wi(r ? l : a.remaining, r ? a.remaining : l, null, 0, -1);
  n(a.transform.setSelection(s).setMeta(Ii, { redo: r, historyState: d }).scrollIntoView());
}
let zu = !1, A1 = null;
function Xs(e) {
  let t = e.plugins;
  if (A1 != t) {
    zu = !1, A1 = t;
    for (let n = 0; n < t.length; n++)
      if (t[n].spec.historyPreserveItems) {
        zu = !0;
        break;
      }
  }
  return zu;
}
const Ii = new zn("history"), NP = new zn("closeHistory");
function IP(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new cn({
    key: Ii,
    state: {
      init() {
        return new wi(ar.empty, ar.empty, null, 0, -1);
      },
      apply(t, n, r) {
        return AP(n, r, t, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(t, n) {
          let r = n.inputType, i = r == "historyUndo" ? oy : r == "historyRedo" ? ay : null;
          return i ? (n.preventDefault(), i(t.state, t.dispatch)) : !1;
        }
      }
    }
  });
}
const oy = (e, t) => {
  let n = Ii.getState(e);
  return !n || n.done.eventCount == 0 ? !1 : (t && iy(n, e, t, !1), !0);
}, ay = (e, t) => {
  let n = Ii.getState(e);
  return !n || n.undone.eventCount == 0 ? !1 : (t && iy(n, e, t, !0), !0);
}, sy = Xt.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: t }) => oy(e, t),
      redo: () => ({ state: e, dispatch: t }) => ay(e, t)
    };
  },
  addProseMirrorPlugins() {
    return [
      IP(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), RP = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", _P = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", ua = (e, t) => {
  for (const n in t)
    e[n] = t[n];
  return e;
}, Bc = "numeric", zc = "ascii", Vc = "alpha", Qs = "asciinumeric", zs = "alphanumeric", Hc = "domain", ly = "emoji", LP = "scheme", FP = "slashscheme", P1 = "whitespace";
function BP(e, t) {
  return e in t || (t[e] = []), t[e];
}
function to(e, t, n) {
  t[Bc] && (t[Qs] = !0, t[zs] = !0), t[zc] && (t[Qs] = !0, t[Vc] = !0), t[Qs] && (t[zs] = !0), t[Vc] && (t[zs] = !0), t[zs] && (t[Hc] = !0), t[ly] && (t[Hc] = !0);
  for (const r in t) {
    const i = BP(r, n);
    i.indexOf(e) < 0 && i.push(e);
  }
}
function zP(e, t) {
  const n = {};
  for (const r in t)
    t[r].indexOf(e) >= 0 && (n[r] = !0);
  return n;
}
function xn(e) {
  e === void 0 && (e = null), this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
xn.groups = {};
xn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const t = this, n = t.j[e];
    if (n)
      return n;
    for (let r = 0; r < t.jr.length; r++) {
      const i = t.jr[r][0], o = t.jr[r][1];
      if (o && i.test(e))
        return o;
    }
    return t.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, t) {
    return t === void 0 && (t = !1), t ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, t, n, r) {
    for (let i = 0; i < e.length; i++)
      this.tt(e[i], t, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, t, n, r) {
    r = r || xn.groups;
    let i;
    return t && t.j ? i = t : (i = new xn(t), n && r && to(t, n, r)), this.jr.push([e, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, t, n, r) {
    let i = this;
    const o = e.length;
    if (!o)
      return i;
    for (let a = 0; a < o - 1; a++)
      i = i.tt(e[a]);
    return i.tt(e[o - 1], t, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, t, n, r) {
    r = r || xn.groups;
    const i = this;
    if (t && t.j)
      return i.j[e] = t, t;
    const o = t;
    let a, s = i.go(e);
    if (s ? (a = new xn(), ua(a.j, s.j), a.jr.push.apply(a.jr, s.jr), a.jd = s.jd, a.t = s.t) : a = new xn(), o) {
      if (r)
        if (a.t && typeof a.t == "string") {
          const l = ua(zP(a.t, r), n);
          to(o, l, r);
        } else n && to(o, n, r);
      a.t = o;
    }
    return i.j[e] = a, a;
  }
};
const et = (e, t, n, r, i) => e.ta(t, n, r, i), Hn = (e, t, n, r, i) => e.tr(t, n, r, i), N1 = (e, t, n, r, i) => e.ts(t, n, r, i), xe = (e, t, n, r, i) => e.tt(t, n, r, i), Kr = "WORD", jc = "UWORD", ss = "LOCALHOST", Wc = "TLD", Uc = "UTLD", Zs = "SCHEME", Lo = "SLASH_SCHEME", Df = "NUM", dy = "WS", Af = "NL", Va = "OPENBRACE", Ha = "CLOSEBRACE", Al = "OPENBRACKET", Pl = "CLOSEBRACKET", Nl = "OPENPAREN", Il = "CLOSEPAREN", Rl = "OPENANGLEBRACKET", _l = "CLOSEANGLEBRACKET", Ll = "FULLWIDTHLEFTPAREN", Fl = "FULLWIDTHRIGHTPAREN", Bl = "LEFTCORNERBRACKET", zl = "RIGHTCORNERBRACKET", Vl = "LEFTWHITECORNERBRACKET", Hl = "RIGHTWHITECORNERBRACKET", jl = "FULLWIDTHLESSTHAN", Wl = "FULLWIDTHGREATERTHAN", Ul = "AMPERSAND", ql = "APOSTROPHE", Yl = "ASTERISK", ki = "AT", Kl = "BACKSLASH", Gl = "BACKTICK", Jl = "CARET", Si = "COLON", Pf = "COMMA", Xl = "DOLLAR", kr = "DOT", Ql = "EQUALS", Nf = "EXCLAMATION", xr = "HYPHEN", Zl = "PERCENT", ed = "PIPE", td = "PLUS", nd = "POUND", rd = "QUERY", If = "QUOTE", Rf = "SEMI", Sr = "SLASH", ja = "TILDE", id = "UNDERSCORE", uy = "EMOJI", od = "SYM";
var cy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Kr,
  UWORD: jc,
  LOCALHOST: ss,
  TLD: Wc,
  UTLD: Uc,
  SCHEME: Zs,
  SLASH_SCHEME: Lo,
  NUM: Df,
  WS: dy,
  NL: Af,
  OPENBRACE: Va,
  CLOSEBRACE: Ha,
  OPENBRACKET: Al,
  CLOSEBRACKET: Pl,
  OPENPAREN: Nl,
  CLOSEPAREN: Il,
  OPENANGLEBRACKET: Rl,
  CLOSEANGLEBRACKET: _l,
  FULLWIDTHLEFTPAREN: Ll,
  FULLWIDTHRIGHTPAREN: Fl,
  LEFTCORNERBRACKET: Bl,
  RIGHTCORNERBRACKET: zl,
  LEFTWHITECORNERBRACKET: Vl,
  RIGHTWHITECORNERBRACKET: Hl,
  FULLWIDTHLESSTHAN: jl,
  FULLWIDTHGREATERTHAN: Wl,
  AMPERSAND: Ul,
  APOSTROPHE: ql,
  ASTERISK: Yl,
  AT: ki,
  BACKSLASH: Kl,
  BACKTICK: Gl,
  CARET: Jl,
  COLON: Si,
  COMMA: Pf,
  DOLLAR: Xl,
  DOT: kr,
  EQUALS: Ql,
  EXCLAMATION: Nf,
  HYPHEN: xr,
  PERCENT: Zl,
  PIPE: ed,
  PLUS: td,
  POUND: nd,
  QUERY: rd,
  QUOTE: If,
  SEMI: Rf,
  SLASH: Sr,
  TILDE: ja,
  UNDERSCORE: id,
  EMOJI: uy,
  SYM: od
});
const Ao = /[a-z]/, Vu = new RegExp("\\p{L}", "u"), Hu = new RegExp("\\p{Emoji}", "u"), ju = /\d/, I1 = /\s/, R1 = `
`, VP = "️", HP = "‍";
let Vs = null, Hs = null;
function jP(e) {
  e === void 0 && (e = []);
  const t = {};
  xn.groups = t;
  const n = new xn();
  Vs == null && (Vs = _1(RP)), Hs == null && (Hs = _1(_P)), xe(n, "'", ql), xe(n, "{", Va), xe(n, "}", Ha), xe(n, "[", Al), xe(n, "]", Pl), xe(n, "(", Nl), xe(n, ")", Il), xe(n, "<", Rl), xe(n, ">", _l), xe(n, "（", Ll), xe(n, "）", Fl), xe(n, "「", Bl), xe(n, "」", zl), xe(n, "『", Vl), xe(n, "』", Hl), xe(n, "＜", jl), xe(n, "＞", Wl), xe(n, "&", Ul), xe(n, "*", Yl), xe(n, "@", ki), xe(n, "`", Gl), xe(n, "^", Jl), xe(n, ":", Si), xe(n, ",", Pf), xe(n, "$", Xl), xe(n, ".", kr), xe(n, "=", Ql), xe(n, "!", Nf), xe(n, "-", xr), xe(n, "%", Zl), xe(n, "|", ed), xe(n, "+", td), xe(n, "#", nd), xe(n, "?", rd), xe(n, '"', If), xe(n, "/", Sr), xe(n, ";", Rf), xe(n, "~", ja), xe(n, "_", id), xe(n, "\\", Kl);
  const r = Hn(n, ju, Df, {
    [Bc]: !0
  });
  Hn(r, ju, r);
  const i = Hn(n, Ao, Kr, {
    [zc]: !0
  });
  Hn(i, Ao, i);
  const o = Hn(n, Vu, jc, {
    [Vc]: !0
  });
  Hn(o, Ao), Hn(o, Vu, o);
  const a = Hn(n, I1, dy, {
    [P1]: !0
  });
  xe(n, R1, Af, {
    [P1]: !0
  }), xe(a, R1), Hn(a, I1, a);
  const s = Hn(n, Hu, uy, {
    [ly]: !0
  });
  Hn(s, Hu, s), xe(s, VP, s);
  const l = xe(s, HP);
  Hn(l, Hu, s);
  const d = [[Ao, i]], u = [[Ao, null], [Vu, o]];
  for (let c = 0; c < Vs.length; c++)
    vi(n, Vs[c], Wc, Kr, d);
  for (let c = 0; c < Hs.length; c++)
    vi(n, Hs[c], Uc, jc, u);
  to(Wc, {
    tld: !0,
    ascii: !0
  }, t), to(Uc, {
    utld: !0,
    alpha: !0
  }, t), vi(n, "file", Zs, Kr, d), vi(n, "mailto", Zs, Kr, d), vi(n, "http", Lo, Kr, d), vi(n, "https", Lo, Kr, d), vi(n, "ftp", Lo, Kr, d), vi(n, "ftps", Lo, Kr, d), to(Zs, {
    scheme: !0,
    ascii: !0
  }, t), to(Lo, {
    slashscheme: !0,
    ascii: !0
  }, t), e = e.sort((c, f) => c[0] > f[0] ? 1 : -1);
  for (let c = 0; c < e.length; c++) {
    const f = e[c][0], p = e[c][1] ? {
      [LP]: !0
    } : {
      [FP]: !0
    };
    f.indexOf("-") >= 0 ? p[Hc] = !0 : Ao.test(f) ? ju.test(f) ? p[Qs] = !0 : p[zc] = !0 : p[Bc] = !0, N1(n, f, f, p);
  }
  return N1(n, "localhost", ss, {
    ascii: !0
  }), n.jd = new xn(od), {
    start: n,
    tokens: ua({
      groups: t
    }, cy)
  };
}
function WP(e, t) {
  const n = UP(t.replace(/[A-Z]/g, (s) => s.toLowerCase())), r = n.length, i = [];
  let o = 0, a = 0;
  for (; a < r; ) {
    let s = e, l = null, d = 0, u = null, c = -1, f = -1;
    for (; a < r && (l = s.go(n[a])); )
      s = l, s.accepts() ? (c = 0, f = 0, u = s) : c >= 0 && (c += n[a].length, f++), d += n[a].length, o += n[a].length, a++;
    o -= c, a -= f, d -= c, i.push({
      t: u.t,
      // token type/name
      v: t.slice(o - d, o),
      // string value
      s: o - d,
      // start index
      e: o
      // end index (excluding)
    });
  }
  return i;
}
function UP(e) {
  const t = [], n = e.length;
  let r = 0;
  for (; r < n; ) {
    let i = e.charCodeAt(r), o, a = i < 55296 || i > 56319 || r + 1 === n || (o = e.charCodeAt(r + 1)) < 56320 || o > 57343 ? e[r] : e.slice(r, r + 2);
    t.push(a), r += a.length;
  }
  return t;
}
function vi(e, t, n, r, i) {
  let o;
  const a = t.length;
  for (let s = 0; s < a - 1; s++) {
    const l = t[s];
    e.j[l] ? o = e.j[l] : (o = new xn(r), o.jr = i.slice(), e.j[l] = o), e = o;
  }
  return o = new xn(n), o.jr = i.slice(), e.j[t[a - 1]] = o, o;
}
function _1(e) {
  const t = [], n = [];
  let r = 0, i = "0123456789";
  for (; r < e.length; ) {
    let o = 0;
    for (; i.indexOf(e[r + o]) >= 0; )
      o++;
    if (o > 0) {
      t.push(n.join(""));
      for (let a = parseInt(e.substring(r, r + o), 10); a > 0; a--)
        n.pop();
      r += o;
    } else
      n.push(e[r]), r++;
  }
  return t;
}
const ls = {
  defaultProtocol: "http",
  events: null,
  format: L1,
  formatHref: L1,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function _f(e, t) {
  t === void 0 && (t = null);
  let n = ua({}, ls);
  e && (n = ua(n, e instanceof _f ? e.o : e));
  const r = n.ignoreTags, i = [];
  for (let o = 0; o < r.length; o++)
    i.push(r[o].toUpperCase());
  this.o = n, t && (this.defaultRender = t), this.ignoreTags = i;
}
_f.prototype = {
  o: ls,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, t, n) {
    const r = t != null;
    let i = this.o[e];
    return i && (typeof i == "object" ? (i = n.t in i ? i[n.t] : ls[e], typeof i == "function" && r && (i = i(t, n))) : typeof i == "function" && r && (i = i(t, n.t, n)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, t, n) {
    let r = this.o[e];
    return typeof r == "function" && t != null && (r = r(t, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
};
function L1(e) {
  return e;
}
function fy(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
fy.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const t = this.toString(), n = e.get("truncate", t, this), r = e.get("format", t, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e) {
    return e === void 0 && (e = ls.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const t = this, n = this.toHref(e.get("defaultProtocol")), r = e.get("formatHref", n, this), i = e.get("tagName", n, t), o = this.toFormattedString(e), a = {}, s = e.get("className", n, t), l = e.get("target", n, t), d = e.get("rel", n, t), u = e.getObj("attributes", n, t), c = e.getObj("events", n, t);
    return a.href = r, s && (a.class = s), l && (a.target = l), d && (a.rel = d), u && ua(a, u), {
      tagName: i,
      attributes: a,
      content: o,
      eventListeners: c
    };
  }
};
function Bd(e, t) {
  class n extends fy {
    constructor(i, o) {
      super(i, o), this.t = e;
    }
  }
  for (const r in t)
    n.prototype[r] = t[r];
  return n.t = e, n;
}
const F1 = Bd("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), B1 = Bd("text"), qP = Bd("nl"), js = Bd("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e) {
    return e === void 0 && (e = ls.defaultProtocol), this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== ss && e[1].t === Si;
  }
}), jn = (e) => new xn(e);
function YP(e) {
  let {
    groups: t
  } = e;
  const n = t.domain.concat([Ul, Yl, ki, Kl, Gl, Jl, Xl, Ql, xr, Df, Zl, ed, td, nd, Sr, od, ja, id]), r = [ql, Si, Pf, kr, Nf, rd, If, Rf, Rl, _l, Va, Ha, Pl, Al, Nl, Il, Ll, Fl, Bl, zl, Vl, Hl, jl, Wl], i = [Ul, ql, Yl, Kl, Gl, Jl, Xl, Ql, xr, Va, Ha, Zl, ed, td, nd, rd, Sr, od, ja, id], o = jn(), a = xe(o, ja);
  et(a, i, a), et(a, t.domain, a);
  const s = jn(), l = jn(), d = jn();
  et(o, t.domain, s), et(o, t.scheme, l), et(o, t.slashscheme, d), et(s, i, a), et(s, t.domain, s);
  const u = xe(s, ki);
  xe(a, ki, u), xe(l, ki, u), xe(d, ki, u);
  const c = xe(a, kr);
  et(c, i, a), et(c, t.domain, a);
  const f = jn();
  et(u, t.domain, f), et(f, t.domain, f);
  const h = xe(f, kr);
  et(h, t.domain, f);
  const p = jn(F1);
  et(h, t.tld, p), et(h, t.utld, p), xe(u, ss, p);
  const m = xe(f, xr);
  et(m, t.domain, f), et(p, t.domain, f), xe(p, kr, h), xe(p, xr, m);
  const g = xe(p, Si);
  et(g, t.numeric, F1);
  const v = xe(s, xr), b = xe(s, kr);
  et(v, t.domain, s), et(b, i, a), et(b, t.domain, s);
  const x = jn(js);
  et(b, t.tld, x), et(b, t.utld, x), et(x, t.domain, s), et(x, i, a), xe(x, kr, b), xe(x, xr, v), xe(x, ki, u);
  const y = xe(x, Si), C = jn(js);
  et(y, t.numeric, C);
  const $ = jn(js), O = jn();
  et($, n, $), et($, r, O), et(O, n, $), et(O, r, O), xe(x, Sr, $), xe(C, Sr, $);
  const z = xe(l, Si), P = xe(d, Si), U = xe(P, Sr), ie = xe(U, Sr);
  et(l, t.domain, s), xe(l, kr, b), xe(l, xr, v), et(d, t.domain, s), xe(d, kr, b), xe(d, xr, v), et(z, t.domain, $), xe(z, Sr, $), et(ie, t.domain, $), et(ie, n, $), xe(ie, Sr, $);
  const W = [
    [Va, Ha],
    // {}
    [Al, Pl],
    // []
    [Nl, Il],
    // ()
    [Rl, _l],
    // <>
    [Ll, Fl],
    // （）
    [Bl, zl],
    // 「」
    [Vl, Hl],
    // 『』
    [jl, Wl]
    // ＜＞
  ];
  for (let H = 0; H < W.length; H++) {
    const [_, T] = W[H], M = xe($, _);
    xe(O, _, M), xe(M, T, $);
    const V = jn(js);
    et(M, n, V);
    const Q = jn();
    et(M, r), et(V, n, V), et(V, r, Q), et(Q, n, V), et(Q, r, Q), xe(V, T, $), xe(Q, T, $);
  }
  return xe(o, ss, x), xe(o, Af, qP), {
    start: o,
    tokens: cy
  };
}
function KP(e, t, n) {
  let r = n.length, i = 0, o = [], a = [];
  for (; i < r; ) {
    let s = e, l = null, d = null, u = 0, c = null, f = -1;
    for (; i < r && !(l = s.go(n[i].t)); )
      a.push(n[i++]);
    for (; i < r && (d = l || s.go(n[i].t)); )
      l = null, s = d, s.accepts() ? (f = 0, c = s) : f >= 0 && f++, i++, u++;
    if (f < 0)
      i -= u, i < r && (a.push(n[i]), i++);
    else {
      a.length > 0 && (o.push(Wu(B1, t, a)), a = []), i -= f, u -= f;
      const h = c.t, p = n.slice(i - u, i);
      o.push(Wu(h, t, p));
    }
  }
  return a.length > 0 && o.push(Wu(B1, t, a)), o;
}
function Wu(e, t, n) {
  const r = n[0].s, i = n[n.length - 1].e, o = t.slice(r, i);
  return new e(o, n);
}
const GP = typeof console != "undefined" && console && console.warn || (() => {
}), JP = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Mt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function XP() {
  xn.groups = {}, Mt.scanner = null, Mt.parser = null, Mt.tokenQueue = [], Mt.pluginQueue = [], Mt.customSchemes = [], Mt.initialized = !1;
}
function z1(e, t) {
  if (t === void 0 && (t = !1), Mt.initialized && GP(`linkifyjs: already initialized - will not register custom scheme "${e}" ${JP}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Mt.customSchemes.push([e, t]);
}
function QP() {
  Mt.scanner = jP(Mt.customSchemes);
  for (let e = 0; e < Mt.tokenQueue.length; e++)
    Mt.tokenQueue[e][1]({
      scanner: Mt.scanner
    });
  Mt.parser = YP(Mt.scanner.tokens);
  for (let e = 0; e < Mt.pluginQueue.length; e++)
    Mt.pluginQueue[e][1]({
      scanner: Mt.scanner,
      parser: Mt.parser
    });
  Mt.initialized = !0;
}
function py(e) {
  return Mt.initialized || QP(), KP(Mt.parser.start, e, WP(Mt.scanner.start, e));
}
function hy(e, t, n) {
  if (t === void 0 && (t = null), n === void 0 && (n = null), t && typeof t == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    n = t, t = null;
  }
  const r = new _f(n), i = py(e), o = [];
  for (let a = 0; a < i.length; a++) {
    const s = i[a];
    s.isLink && (!t || s.t === t) && r.check(s) && o.push(s.toFormattedObject(r));
  }
  return o;
}
function ZP(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function eN(e) {
  return new cn({
    key: new zn("autolink"),
    appendTransaction: (t, n, r) => {
      const i = t.some((d) => d.docChanged) && !n.doc.eq(r.doc), o = t.some((d) => d.getMeta("preventAutolink"));
      if (!i || o)
        return;
      const { tr: a } = r, s = NA(n.doc, [...t]);
      if (HA(s).forEach(({ newRange: d }) => {
        const u = RA(r.doc, d, (h) => h.isTextblock);
        let c, f;
        if (u.length > 1 ? (c = u[0], f = r.doc.textBetween(c.pos, c.pos + c.node.nodeSize, void 0, " ")) : u.length && r.doc.textBetween(d.from, d.to, " ", " ").endsWith(" ") && (c = u[0], f = r.doc.textBetween(c.pos, d.to, void 0, " ")), c && f) {
          const h = f.split(" ").filter((v) => v !== "");
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], m = c.pos + f.lastIndexOf(p);
          if (!p)
            return !1;
          const g = py(p).map((v) => v.toObject());
          if (!ZP(g))
            return !1;
          g.filter((v) => v.isLink).map((v) => ({
            ...v,
            from: m + v.start + 1,
            to: m + v.end + 1
          })).filter((v) => r.schema.marks.code ? !r.doc.rangeHasMark(v.from, v.to, r.schema.marks.code) : !0).filter((v) => e.validate ? e.validate(v.value) : !0).forEach((v) => {
            Ef(v.from, v.to, r.doc).some((b) => b.mark.type === e.type) || a.addMark(v.from, v.to, e.type.create({
              href: v.href
            }));
          });
        }
      }), !!a.steps.length)
        return a;
    }
  });
}
function tN(e) {
  return new cn({
    key: new zn("handleClickLink"),
    props: {
      handleClick: (t, n, r) => {
        var i, o;
        if (e.whenNotEditable && t.editable || r.button !== 0)
          return !1;
        let a = r.target;
        const s = [];
        for (; a.nodeName !== "DIV"; )
          s.push(a), a = a.parentNode;
        if (!s.find((f) => f.nodeName === "A"))
          return !1;
        const l = ty(t.state, e.type.name), d = r.target, u = (i = d == null ? void 0 : d.href) !== null && i !== void 0 ? i : l.href, c = (o = d == null ? void 0 : d.target) !== null && o !== void 0 ? o : l.target;
        return d && u ? (window.open(u, c), !0) : !1;
      }
    }
  });
}
function nN(e) {
  return new cn({
    key: new zn("handlePasteLink"),
    props: {
      handlePaste: (t, n, r) => {
        const { state: i } = t, { selection: o } = i, { empty: a } = o;
        if (a)
          return !1;
        let s = "";
        r.content.forEach((d) => {
          s += d.textContent;
        });
        const l = hy(s).find((d) => d.isLink && d.value === s);
        return !s || !l ? !1 : (e.editor.commands.setMark(e.type, {
          href: l.href
        }), !0);
      }
    }
  });
}
const rN = Dn.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  onCreate() {
    this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        z1(e);
        return;
      }
      z1(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    XP();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      validate: void 0
    };
  },
  addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [{ tag: 'a[href]:not([href *= "javascript:" i])' }];
  },
  renderHTML({ HTMLAttributes: e }) {
    var t;
    return !((t = e.href) === null || t === void 0) && t.startsWith("javascript:") ? ["a", Ct(this.options.HTMLAttributes, { ...e, href: "" }), 0] : ["a", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: t }) => t().setMark(this.name, e).setMeta("preventAutolink", !0).run(),
      toggleLink: (e) => ({ chain: t }) => t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      _i({
        find: (e) => {
          const t = [];
          if (e) {
            const n = hy(e).filter((r) => r.isLink);
            n.length && n.forEach((r) => t.push({
              text: r.value,
              data: {
                href: r.href
              },
              index: r.start
            }));
          }
          return t;
        },
        type: this.type,
        getAttributes: (e) => {
          var t;
          return {
            href: (t = e.data) === null || t === void 0 ? void 0 : t.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [];
    return this.options.autolink && e.push(eN({
      type: this.type,
      validate: this.options.validate
    })), this.options.openOnClick && e.push(tN({
      type: this.type,
      whenNotEditable: this.options.openOnClick === "whenNotEditable"
    })), this.options.linkOnPaste && e.push(nN({
      editor: this.editor,
      type: this.type
    })), e;
  }
}), my = An.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), gy = An.create({
  name: "text",
  group: "inline"
}), iN = Xt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => e.style.textAlign || this.options.defaultAlignment,
            renderHTML: (e) => e.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${e.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: t }) => this.options.alignments.includes(e) ? this.options.types.map((n) => t.updateAttributes(n, { textAlign: e })).every((n) => n) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((t) => e.resetAttributes(t, "textAlign")).every((t) => t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), oN = Dn.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), aN = /^\s*>\s$/, sN = An.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["blockquote", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      as({
        find: aN,
        type: this.type
      })
    ];
  }
}), lN = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, dN = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, uN = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, cN = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, fN = Dn.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["strong", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      yo({
        find: lN,
        type: this.type
      }),
      yo({
        find: uN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _i({
        find: dN,
        type: this.type
      }),
      _i({
        find: cN,
        type: this.type
      })
    ];
  }
}), pN = An.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ct(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), V1 = Dn.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const n = xs(e, this.type);
        return Object.entries(n).some(([, i]) => !!i) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), H1 = /^\s*([-+*])\s$/, hN = An.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(pN.name, this.editor.getAttributes(V1.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = as({
      find: H1,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = as({
      find: H1,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(V1.name),
      editor: this.editor
    })), [
      e
    ];
  }
}), mN = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))$/, gN = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))/g, vN = Dn.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      yo({
        find: mN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _i({
        find: gN,
        type: this.type
      })
    ];
  }
}), yN = /^```([a-z]+)?[\s\n]$/, bN = /^~~~([a-z]+)?[\s\n]$/, $N = An.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: null,
        parseHTML: (e) => {
          var t;
          const { languageClassPrefix: n } = this.options, o = [...((t = e.firstElementChild) === null || t === void 0 ? void 0 : t.classList) || []].filter((a) => a.startsWith(n)).map((a) => a.replace(n, ""))[0];
          return o || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "pre",
      Ct(this.options.HTMLAttributes, t),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, n = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : n || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: n } = t, { $from: r, empty: i } = n;
        if (!i || r.parent.type !== this.type)
          return !1;
        const o = r.parentOffset === r.parent.nodeSize - 2, a = r.parent.textContent.endsWith(`

`);
        return !o || !a ? !1 : e.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: n, doc: r } = t, { $from: i, empty: o } = n;
        if (!o || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const s = i.after();
        return s === void 0 || r.nodeAt(s) ? !1 : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Lc({
        find: yN,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      Lc({
        find: bN,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new cn({
        key: new zn("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = t.clipboardData.getData("text/plain"), r = t.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, o = i == null ? void 0 : i.mode;
            if (!n || !o)
              return !1;
            const { tr: a } = e.state;
            return e.state.selection.from === e.state.doc.nodeSize - (1 + e.state.selection.$to.depth * 2) ? a.insert(e.state.selection.from - 1, this.type.create({ language: o })) : a.replaceSelectionWith(this.type.create({ language: o })), a.setSelection(Xe.near(a.doc.resolve(Math.max(0, a.selection.from - 2)))), a.insertText(n.replace(/\r\n?/g, `
`)), a.setMeta("paste", !0), e.dispatch(a), !0;
          }
        }
      })
    ];
  }
}), wN = An.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function kN(e = {}) {
  return new cn({
    view(t) {
      return new xN(t, e);
    }
  });
}
class xN {
  constructor(t, n) {
    var r;
    this.editorView = t, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let o = (a) => {
        this[i](a);
      };
      return t.dom.addEventListener(i, o), { name: i, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: t, handler: n }) => this.editorView.dom.removeEventListener(t, n));
  }
  update(t, n) {
    this.cursorPos != null && n.doc != t.state.doc && (this.cursorPos > t.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(t) {
    t != this.cursorPos && (this.cursorPos = t, t == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let t = this.editorView.state.doc.resolve(this.cursorPos), n = !t.parent.inlineContent, r;
    if (n) {
      let s = t.nodeBefore, l = t.nodeAfter;
      if (s || l) {
        let d = this.editorView.nodeDOM(this.cursorPos - (s ? s.nodeSize : 0));
        if (d) {
          let u = d.getBoundingClientRect(), c = s ? u.bottom : u.top;
          s && l && (c = (c + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: u.left, right: u.right, top: c - this.width / 2, bottom: c + this.width / 2 };
        }
      }
    }
    if (!r) {
      let s = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: s.left - this.width / 2, right: s.left + this.width / 2, top: s.top, bottom: s.bottom };
    }
    let i = this.editorView.dom.offsetParent;
    this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let o, a;
    if (!i || i == document.body && getComputedStyle(i).position == "static")
      o = -pageXOffset, a = -pageYOffset;
    else {
      let s = i.getBoundingClientRect();
      o = s.left - i.scrollLeft, a = s.top - i.scrollTop;
    }
    this.element.style.left = r.left - o + "px", this.element.style.top = r.top - a + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(t) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), t);
  }
  dragover(t) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: t.clientX, top: t.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), i = r && r.type.spec.disableDropCursor, o = typeof i == "function" ? i(this.editorView, n, t) : i;
    if (n && !o) {
      let a = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = Zg(this.editorView.state.doc, a, this.editorView.dragging.slice);
        s != null && (a = s);
      }
      this.setCursor(a), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(t) {
    (t.target == this.editorView.dom || !this.editorView.dom.contains(t.relatedTarget)) && this.setCursor(null);
  }
}
const SN = Xt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      kN(this.options)
    ];
  }
});
class Nt extends rt {
  /**
  Create a gap cursor.
  */
  constructor(t) {
    super(t, t);
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    return Nt.valid(r) ? new Nt(r) : rt.near(r);
  }
  content() {
    return Ae.empty;
  }
  eq(t) {
    return t instanceof Nt && t.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Nt(t.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Lf(this.anchor);
  }
  /**
  @internal
  */
  static valid(t) {
    let n = t.parent;
    if (n.isTextblock || !CN(t) || !TN(t))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = n.contentMatchAt(t.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(t, n, r = !1) {
    e: for (; ; ) {
      if (!r && Nt.valid(t))
        return t;
      let i = t.pos, o = null;
      for (let a = t.depth; ; a--) {
        let s = t.node(a);
        if (n > 0 ? t.indexAfter(a) < s.childCount : t.index(a) > 0) {
          o = s.child(n > 0 ? t.indexAfter(a) : t.index(a) - 1);
          break;
        } else if (a == 0)
          return null;
        i += n;
        let l = t.doc.resolve(i);
        if (Nt.valid(l))
          return l;
      }
      for (; ; ) {
        let a = n > 0 ? o.firstChild : o.lastChild;
        if (!a) {
          if (o.isAtom && !o.isText && !He.isSelectable(o)) {
            t = t.doc.resolve(i + o.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        o = a, i += n;
        let s = t.doc.resolve(i);
        if (Nt.valid(s))
          return s;
      }
      return null;
    }
  }
}
Nt.prototype.visible = !1;
Nt.findFrom = Nt.findGapCursorFrom;
rt.jsonID("gapcursor", Nt);
class Lf {
  constructor(t) {
    this.pos = t;
  }
  map(t) {
    return new Lf(t.map(this.pos));
  }
  resolve(t) {
    let n = t.resolve(this.pos);
    return Nt.valid(n) ? new Nt(n) : rt.near(n);
  }
}
function CN(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.index(t), r = e.node(t);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function TN(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.indexAfter(t), r = e.node(t);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function MN() {
  return new cn({
    props: {
      decorations: AN,
      createSelectionBetween(e, t, n) {
        return t.pos == n.pos && Nt.valid(n) ? new Nt(n) : null;
      },
      handleClick: EN,
      handleKeyDown: ON,
      handleDOMEvents: { beforeinput: DN }
    }
  });
}
const ON = zv({
  ArrowLeft: Ws("horiz", -1),
  ArrowRight: Ws("horiz", 1),
  ArrowUp: Ws("vert", -1),
  ArrowDown: Ws("vert", 1)
});
function Ws(e, t) {
  const n = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
  return function(r, i, o) {
    let a = r.selection, s = t > 0 ? a.$to : a.$from, l = a.empty;
    if (a instanceof Xe) {
      if (!o.endOfTextblock(n) || s.depth == 0)
        return !1;
      l = !1, s = r.doc.resolve(t > 0 ? s.after() : s.before());
    }
    let d = Nt.findGapCursorFrom(s, t, l);
    return d ? (i && i(r.tr.setSelection(new Nt(d))), !0) : !1;
  };
}
function EN(e, t, n) {
  if (!e || !e.editable)
    return !1;
  let r = e.state.doc.resolve(t);
  if (!Nt.valid(r))
    return !1;
  let i = e.posAtCoords({ left: n.clientX, top: n.clientY });
  return i && i.inside > -1 && He.isSelectable(e.state.doc.nodeAt(i.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new Nt(r))), !0);
}
function DN(e, t) {
  if (t.inputType != "insertCompositionText" || !(e.state.selection instanceof Nt))
    return !1;
  let { $from: n } = e.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = ve.empty;
  for (let a = r.length - 1; a >= 0; a--)
    i = ve.from(r[a].createAndFill(null, i));
  let o = e.state.tr.replace(n.pos, n.pos, new Ae(i, 0, 0));
  return o.setSelection(Xe.near(o.doc.resolve(n.pos + 1))), e.dispatch(o), !1;
}
function AN(e) {
  if (!(e.selection instanceof Nt))
    return null;
  let t = document.createElement("div");
  return t.className = "ProseMirror-gapcursor", Kt.create(e.doc, [qn.widget(e.selection.head, t, { key: "gapcursor" })]);
}
const PN = Xt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      MN()
    ];
  },
  extendNodeSchema(e) {
    var t;
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (t = tt(Le(e, "allowGapCursor", n))) !== null && t !== void 0 ? t : null
    };
  }
}), NN = An.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", Ct(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: n, editor: r }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: i, storedMarks: o } = n;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: a } = this.options, { splittableMarks: s } = r.extensionManager, l = o || i.$to.parentOffset && i.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && l && a) {
              const c = l.filter((f) => s.includes(f.type.name));
              d.ensureMarks(c);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), IN = An.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, Ct(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((e, t) => ({
      ...e,
      [`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({ level: t })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((e) => Lc({
      find: new RegExp(`^(#{1,${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), RN = An.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", Ct(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: t }) => {
        const { $to: n } = t.selection, r = e();
        return n.parentOffset === 0 ? r.insertContentAt(Math.max(n.pos - 2, 0), { type: this.name }) : r.insertContent({ type: this.name }), r.command(({ tr: i, dispatch: o }) => {
          var a;
          if (o) {
            const { $to: s } = i.selection, l = s.end();
            if (s.nodeAfter)
              s.nodeAfter.isTextblock ? i.setSelection(Xe.create(i.doc, s.pos + 1)) : s.nodeAfter.isBlock ? i.setSelection(He.create(i.doc, s.pos)) : i.setSelection(Xe.create(i.doc, s.pos));
            else {
              const d = (a = s.parent.type.contentMatch.defaultType) === null || a === void 0 ? void 0 : a.create();
              d && (i.insert(l, d), i.setSelection(Xe.create(i.doc, l + 1)));
            }
            i.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      $P({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), _N = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, LN = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, FN = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, BN = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, zN = Dn.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      yo({
        find: _N,
        type: this.type
      }),
      yo({
        find: FN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _i({
        find: LN,
        type: this.type
      }),
      _i({
        find: BN,
        type: this.type
      })
    ];
  }
}), VN = An.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ct(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), HN = An.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ct(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), j1 = Dn.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const n = xs(e, this.type);
        return Object.entries(n).some(([, i]) => !!i) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), W1 = /^(\d+)\.\s$/, jN = An.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...n } = e;
    return t === 1 ? ["ol", Ct(this.options.HTMLAttributes, n), 0] : ["ol", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(HN.name, this.editor.getAttributes(j1.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = as({
      find: W1,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = as({
      find: W1,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (t) => ({ start: +t[1], ...this.editor.getAttributes(j1.name) }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1],
      editor: this.editor
    })), [
      e
    ];
  }
}), WN = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, UN = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, qN = Dn.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      yo({
        find: WN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _i({
        find: UN,
        type: this.type
      })
    ];
  }
}), YN = Xt.create({
  name: "starterKit",
  addExtensions() {
    var e, t, n, r, i, o, a, s, l, d, u, c, f, h, p, m, g, v;
    const b = [];
    return this.options.blockquote !== !1 && b.push(sN.configure((e = this.options) === null || e === void 0 ? void 0 : e.blockquote)), this.options.bold !== !1 && b.push(fN.configure((t = this.options) === null || t === void 0 ? void 0 : t.bold)), this.options.bulletList !== !1 && b.push(hN.configure((n = this.options) === null || n === void 0 ? void 0 : n.bulletList)), this.options.code !== !1 && b.push(vN.configure((r = this.options) === null || r === void 0 ? void 0 : r.code)), this.options.codeBlock !== !1 && b.push($N.configure((i = this.options) === null || i === void 0 ? void 0 : i.codeBlock)), this.options.document !== !1 && b.push(wN.configure((o = this.options) === null || o === void 0 ? void 0 : o.document)), this.options.dropcursor !== !1 && b.push(SN.configure((a = this.options) === null || a === void 0 ? void 0 : a.dropcursor)), this.options.gapcursor !== !1 && b.push(PN.configure((s = this.options) === null || s === void 0 ? void 0 : s.gapcursor)), this.options.hardBreak !== !1 && b.push(NN.configure((l = this.options) === null || l === void 0 ? void 0 : l.hardBreak)), this.options.heading !== !1 && b.push(IN.configure((d = this.options) === null || d === void 0 ? void 0 : d.heading)), this.options.history !== !1 && b.push(sy.configure((u = this.options) === null || u === void 0 ? void 0 : u.history)), this.options.horizontalRule !== !1 && b.push(RN.configure((c = this.options) === null || c === void 0 ? void 0 : c.horizontalRule)), this.options.italic !== !1 && b.push(zN.configure((f = this.options) === null || f === void 0 ? void 0 : f.italic)), this.options.listItem !== !1 && b.push(VN.configure((h = this.options) === null || h === void 0 ? void 0 : h.listItem)), this.options.orderedList !== !1 && b.push(jN.configure((p = this.options) === null || p === void 0 ? void 0 : p.orderedList)), this.options.paragraph !== !1 && b.push(my.configure((m = this.options) === null || m === void 0 ? void 0 : m.paragraph)), this.options.strike !== !1 && b.push(qN.configure((g = this.options) === null || g === void 0 ? void 0 : g.strike)), this.options.text !== !1 && b.push(gy.configure((v = this.options) === null || v === void 0 ? void 0 : v.text)), b;
  }
});
var KN = "tippy-box", vy = "tippy-content", GN = "tippy-backdrop", yy = "tippy-arrow", by = "tippy-svg-arrow", Yi = {
  passive: !0,
  capture: !0
}, $y = function() {
  return document.body;
};
function JN(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function Uu(e, t, n) {
  if (Array.isArray(e)) {
    var r = e[t];
    return r == null ? Array.isArray(n) ? n[t] : n : r;
  }
  return e;
}
function Ff(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function wy(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function U1(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      e(r);
    }, t);
  };
}
function XN(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(r) {
    delete n[r];
  }), n;
}
function QN(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Fo(e) {
  return [].concat(e);
}
function q1(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function ZN(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function eI(e) {
  return e.split("-")[0];
}
function ad(e) {
  return [].slice.call(e);
}
function Y1(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function Wa() {
  return document.createElement("div");
}
function ds(e) {
  return ["Element", "Fragment"].some(function(t) {
    return Ff(e, t);
  });
}
function tI(e) {
  return Ff(e, "NodeList");
}
function nI(e) {
  return Ff(e, "MouseEvent");
}
function rI(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function iI(e) {
  return ds(e) ? [e] : tI(e) ? ad(e) : Array.isArray(e) ? e : ad(document.querySelectorAll(e));
}
function qu(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function K1(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function oI(e) {
  var t, n = Fo(e), r = n[0];
  return r != null && (t = r.ownerDocument) != null && t.body ? r.ownerDocument : document;
}
function aI(e, t) {
  var n = t.clientX, r = t.clientY;
  return e.every(function(i) {
    var o = i.popperRect, a = i.popperState, s = i.props, l = s.interactiveBorder, d = eI(a.placement), u = a.modifiersData.offset;
    if (!u)
      return !0;
    var c = d === "bottom" ? u.top.y : 0, f = d === "top" ? u.bottom.y : 0, h = d === "right" ? u.left.x : 0, p = d === "left" ? u.right.x : 0, m = o.top - r + c > l, g = r - o.bottom - f > l, v = o.left - n + h > l, b = n - o.right - p > l;
    return m || g || v || b;
  });
}
function Yu(e, t, n) {
  var r = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    e[r](i, n);
  });
}
function G1(e, t) {
  for (var n = t; n; ) {
    var r;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var Tr = {
  isTouch: !1
}, J1 = 0;
function sI() {
  Tr.isTouch || (Tr.isTouch = !0, window.performance && document.addEventListener("mousemove", ky));
}
function ky() {
  var e = performance.now();
  e - J1 < 20 && (Tr.isTouch = !1, document.removeEventListener("mousemove", ky)), J1 = e;
}
function lI() {
  var e = document.activeElement;
  if (rI(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function dI() {
  document.addEventListener("touchstart", sI, Yi), window.addEventListener("blur", lI);
}
var uI = typeof window != "undefined" && typeof document != "undefined", cI = uI ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Po(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function X1(e) {
  var t = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return e.replace(t, " ").replace(n, "").trim();
}
function fI(e) {
  return X1(`
  %ctippy.js

  %c` + X1(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function xy(e) {
  return [
    fI(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var us;
process.env.NODE_ENV !== "production" && pI();
function pI() {
  us = /* @__PURE__ */ new Set();
}
function Jr(e, t) {
  if (e && !us.has(t)) {
    var n;
    us.add(t), (n = console).warn.apply(n, xy(t));
  }
}
function qc(e, t) {
  if (e && !us.has(t)) {
    var n;
    us.add(t), (n = console).error.apply(n, xy(t));
  }
}
function hI(e) {
  var t = !e, n = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  qc(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), qc(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var Sy = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, mI = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Rn = Object.assign({
  appendTo: $y,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Sy, mI), gI = Object.keys(Rn), vI = function(t) {
  process.env.NODE_ENV !== "production" && Ty(t, []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    Rn[r] = t[r];
  });
};
function Cy(e) {
  var t = e.plugins || [], n = t.reduce(function(r, i) {
    var o = i.name, a = i.defaultValue;
    if (o) {
      var s;
      r[o] = e[o] !== void 0 ? e[o] : (s = Rn[o]) != null ? s : a;
    }
    return r;
  }, {});
  return Object.assign({}, e, n);
}
function yI(e, t) {
  var n = t ? Object.keys(Cy(Object.assign({}, Rn, {
    plugins: t
  }))) : gI, r = n.reduce(function(i, o) {
    var a = (e.getAttribute("data-tippy-" + o) || "").trim();
    if (!a)
      return i;
    if (o === "content")
      i[o] = a;
    else
      try {
        i[o] = JSON.parse(a);
      } catch {
        i[o] = a;
      }
    return i;
  }, {});
  return r;
}
function Q1(e, t) {
  var n = Object.assign({}, t, {
    content: wy(t.content, [e])
  }, t.ignoreAttributes ? {} : yI(e, t.plugins));
  return n.aria = Object.assign({}, Rn.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function Ty(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    var i = XN(Rn, Object.keys(Sy)), o = !JN(i, r);
    o && (o = t.filter(function(a) {
      return a.name === r;
    }).length === 0), Jr(o, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var bI = function() {
  return "innerHTML";
};
function Yc(e, t) {
  e[bI()] = t;
}
function Z1(e) {
  var t = Wa();
  return e === !0 ? t.className = yy : (t.className = by, ds(e) ? t.appendChild(e) : Yc(t, e)), t;
}
function em(e, t) {
  ds(t.content) ? (Yc(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Yc(e, t.content) : e.textContent = t.content);
}
function Kc(e) {
  var t = e.firstElementChild, n = ad(t.children);
  return {
    box: t,
    content: n.find(function(r) {
      return r.classList.contains(vy);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(yy) || r.classList.contains(by);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(GN);
    })
  };
}
function My(e) {
  var t = Wa(), n = Wa();
  n.className = KN, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = Wa();
  r.className = vy, r.setAttribute("data-state", "hidden"), em(r, e.props), t.appendChild(n), n.appendChild(r), i(e.props, e.props);
  function i(o, a) {
    var s = Kc(t), l = s.box, d = s.content, u = s.arrow;
    a.theme ? l.setAttribute("data-theme", a.theme) : l.removeAttribute("data-theme"), typeof a.animation == "string" ? l.setAttribute("data-animation", a.animation) : l.removeAttribute("data-animation"), a.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof a.maxWidth == "number" ? a.maxWidth + "px" : a.maxWidth, a.role ? l.setAttribute("role", a.role) : l.removeAttribute("role"), (o.content !== a.content || o.allowHTML !== a.allowHTML) && em(d, e.props), a.arrow ? u ? o.arrow !== a.arrow && (l.removeChild(u), l.appendChild(Z1(a.arrow))) : l.appendChild(Z1(a.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: t,
    onUpdate: i
  };
}
My.$$tippy = !0;
var $I = 1, Us = [], Ku = [];
function wI(e, t) {
  var n = Q1(e, Object.assign({}, Rn, Cy(Y1(t)))), r, i, o, a = !1, s = !1, l = !1, d = !1, u, c, f, h = [], p = U1(je, n.interactiveDebounce), m, g = $I++, v = null, b = ZN(n.plugins), x = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, y = {
    // properties
    id: g,
    reference: e,
    popper: Wa(),
    popperInstance: v,
    props: n,
    state: x,
    plugins: b,
    // methods
    clearDelayTimeouts: Ht,
    setProps: Nn,
    setContent: yr,
    show: B,
    hide: w,
    hideWithInteractivity: ye,
    enable: er,
    disable: Pn,
    unmount: Pe,
    destroy: Se
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && qc(!0, "render() function has not been supplied."), y;
  var C = n.render(y), $ = C.popper, O = C.onUpdate;
  $.setAttribute("data-tippy-root", ""), $.id = "tippy-" + y.id, y.popper = $, e._tippy = y, $._tippy = y;
  var z = b.map(function(J) {
    return J.fn(y);
  }), P = e.hasAttribute("aria-expanded");
  return Me(), oe(), V(), Q("onCreate", [y]), n.showOnCreate && lt(), $.addEventListener("mouseenter", function() {
    y.props.interactive && y.state.isVisible && y.clearDelayTimeouts();
  }), $.addEventListener("mouseleave", function() {
    y.props.interactive && y.props.trigger.indexOf("mouseenter") >= 0 && _().addEventListener("mousemove", p);
  }), y;
  function U() {
    var J = y.props.touch;
    return Array.isArray(J) ? J : [J, 0];
  }
  function ie() {
    return U()[0] === "hold";
  }
  function W() {
    var J;
    return !!((J = y.props.render) != null && J.$$tippy);
  }
  function H() {
    return m || e;
  }
  function _() {
    var J = H().parentNode;
    return J ? oI(J) : document;
  }
  function T() {
    return Kc($);
  }
  function M(J) {
    return y.state.isMounted && !y.state.isVisible || Tr.isTouch || u && u.type === "focus" ? 0 : Uu(y.props.delay, J ? 0 : 1, Rn.delay);
  }
  function V(J) {
    J === void 0 && (J = !1), $.style.pointerEvents = y.props.interactive && !J ? "" : "none", $.style.zIndex = "" + y.props.zIndex;
  }
  function Q(J, be, R) {
    if (R === void 0 && (R = !0), z.forEach(function(ae) {
      ae[J] && ae[J].apply(ae, be);
    }), R) {
      var F;
      (F = y.props)[J].apply(F, be);
    }
  }
  function ue() {
    var J = y.props.aria;
    if (J.content) {
      var be = "aria-" + J.content, R = $.id, F = Fo(y.props.triggerTarget || e);
      F.forEach(function(ae) {
        var pe = ae.getAttribute(be);
        if (y.state.isVisible)
          ae.setAttribute(be, pe ? pe + " " + R : R);
        else {
          var we = pe && pe.replace(R, "").trim();
          we ? ae.setAttribute(be, we) : ae.removeAttribute(be);
        }
      });
    }
  }
  function oe() {
    if (!(P || !y.props.aria.expanded)) {
      var J = Fo(y.props.triggerTarget || e);
      J.forEach(function(be) {
        y.props.interactive ? be.setAttribute("aria-expanded", y.state.isVisible && be === H() ? "true" : "false") : be.removeAttribute("aria-expanded");
      });
    }
  }
  function Y() {
    _().removeEventListener("mousemove", p), Us = Us.filter(function(J) {
      return J !== p;
    });
  }
  function ce(J) {
    if (!(Tr.isTouch && (l || J.type === "mousedown"))) {
      var be = J.composedPath && J.composedPath()[0] || J.target;
      if (!(y.props.interactive && G1($, be))) {
        if (Fo(y.props.triggerTarget || e).some(function(R) {
          return G1(R, be);
        })) {
          if (Tr.isTouch || y.state.isVisible && y.props.trigger.indexOf("click") >= 0)
            return;
        } else
          Q("onClickOutside", [y, J]);
        y.props.hideOnClick === !0 && (y.clearDelayTimeouts(), y.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), y.state.isMounted || ee());
      }
    }
  }
  function S() {
    l = !0;
  }
  function j() {
    l = !1;
  }
  function Z() {
    var J = _();
    J.addEventListener("mousedown", ce, !0), J.addEventListener("touchend", ce, Yi), J.addEventListener("touchstart", j, Yi), J.addEventListener("touchmove", S, Yi);
  }
  function ee() {
    var J = _();
    J.removeEventListener("mousedown", ce, !0), J.removeEventListener("touchend", ce, Yi), J.removeEventListener("touchstart", j, Yi), J.removeEventListener("touchmove", S, Yi);
  }
  function N(J, be) {
    qe(J, function() {
      !y.state.isVisible && $.parentNode && $.parentNode.contains($) && be();
    });
  }
  function Ce(J, be) {
    qe(J, be);
  }
  function qe(J, be) {
    var R = T().box;
    function F(ae) {
      ae.target === R && (Yu(R, "remove", F), be());
    }
    if (J === 0)
      return be();
    Yu(R, "remove", c), Yu(R, "add", F), c = F;
  }
  function I(J, be, R) {
    R === void 0 && (R = !1);
    var F = Fo(y.props.triggerTarget || e);
    F.forEach(function(ae) {
      ae.addEventListener(J, be, R), h.push({
        node: ae,
        eventType: J,
        handler: be,
        options: R
      });
    });
  }
  function Me() {
    ie() && (I("touchstart", ke, {
      passive: !0
    }), I("touchend", re, {
      passive: !0
    })), QN(y.props.trigger).forEach(function(J) {
      if (J !== "manual")
        switch (I(J, ke), J) {
          case "mouseenter":
            I("mouseleave", re);
            break;
          case "focus":
            I(cI ? "focusout" : "blur", le);
            break;
          case "focusin":
            I("focusout", le);
            break;
        }
    });
  }
  function Ye() {
    h.forEach(function(J) {
      var be = J.node, R = J.eventType, F = J.handler, ae = J.options;
      be.removeEventListener(R, F, ae);
    }), h = [];
  }
  function ke(J) {
    var be, R = !1;
    if (!(!y.state.isEnabled || Ke(J) || s)) {
      var F = ((be = u) == null ? void 0 : be.type) === "focus";
      u = J, m = J.currentTarget, oe(), !y.state.isVisible && nI(J) && Us.forEach(function(ae) {
        return ae(J);
      }), J.type === "click" && (y.props.trigger.indexOf("mouseenter") < 0 || a) && y.props.hideOnClick !== !1 && y.state.isVisible ? R = !0 : lt(J), J.type === "click" && (a = !R), R && !F && Yt(J);
    }
  }
  function je(J) {
    var be = J.target, R = H().contains(be) || $.contains(be);
    if (!(J.type === "mousemove" && R)) {
      var F = xt().concat($).map(function(ae) {
        var pe, we = ae._tippy, dt = (pe = we.popperInstance) == null ? void 0 : pe.state;
        return dt ? {
          popperRect: ae.getBoundingClientRect(),
          popperState: dt,
          props: n
        } : null;
      }).filter(Boolean);
      aI(F, J) && (Y(), Yt(J));
    }
  }
  function re(J) {
    var be = Ke(J) || y.props.trigger.indexOf("click") >= 0 && a;
    if (!be) {
      if (y.props.interactive) {
        y.hideWithInteractivity(J);
        return;
      }
      Yt(J);
    }
  }
  function le(J) {
    y.props.trigger.indexOf("focusin") < 0 && J.target !== H() || y.props.interactive && J.relatedTarget && $.contains(J.relatedTarget) || Yt(J);
  }
  function Ke(J) {
    return Tr.isTouch ? ie() !== J.type.indexOf("touch") >= 0 : !1;
  }
  function We() {
    Tt();
    var J = y.props, be = J.popperOptions, R = J.placement, F = J.offset, ae = J.getReferenceClientRect, pe = J.moveTransition, we = W() ? Kc($).arrow : null, dt = ae ? {
      getBoundingClientRect: ae,
      contextElement: ae.contextElement || H()
    } : e, ut = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(jt) {
        var Dt = jt.state;
        if (W()) {
          var br = T(), $r = br.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Co) {
            Co === "placement" ? $r.setAttribute("data-placement", Dt.placement) : Dt.attributes.popper["data-popper-" + Co] ? $r.setAttribute("data-" + Co, "") : $r.removeAttribute("data-" + Co);
          }), Dt.attributes.popper = {};
        }
      }
    }, gt = [{
      name: "offset",
      options: {
        offset: F
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !pe
      }
    }, ut];
    W() && we && gt.push({
      name: "arrow",
      options: {
        element: we,
        padding: 3
      }
    }), gt.push.apply(gt, (be == null ? void 0 : be.modifiers) || []), y.popperInstance = lf(dt, $, Object.assign({}, be, {
      placement: R,
      onFirstUpdate: f,
      modifiers: gt
    }));
  }
  function Tt() {
    y.popperInstance && (y.popperInstance.destroy(), y.popperInstance = null);
  }
  function Oe() {
    var J = y.props.appendTo, be, R = H();
    y.props.interactive && J === $y || J === "parent" ? be = R.parentNode : be = wy(J, [R]), be.contains($) || be.appendChild($), y.state.isMounted = !0, We(), process.env.NODE_ENV !== "production" && Jr(y.props.interactive && J === Rn.appendTo && R.nextElementSibling !== $, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function xt() {
    return ad($.querySelectorAll("[data-tippy-root]"));
  }
  function lt(J) {
    y.clearDelayTimeouts(), J && Q("onTrigger", [y, J]), Z();
    var be = M(!0), R = U(), F = R[0], ae = R[1];
    Tr.isTouch && F === "hold" && ae && (be = ae), be ? r = setTimeout(function() {
      y.show();
    }, be) : y.show();
  }
  function Yt(J) {
    if (y.clearDelayTimeouts(), Q("onUntrigger", [y, J]), !y.state.isVisible) {
      ee();
      return;
    }
    if (!(y.props.trigger.indexOf("mouseenter") >= 0 && y.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(J.type) >= 0 && a)) {
      var be = M(!1);
      be ? i = setTimeout(function() {
        y.state.isVisible && y.hide();
      }, be) : o = requestAnimationFrame(function() {
        y.hide();
      });
    }
  }
  function er() {
    y.state.isEnabled = !0;
  }
  function Pn() {
    y.hide(), y.state.isEnabled = !1;
  }
  function Ht() {
    clearTimeout(r), clearTimeout(i), cancelAnimationFrame(o);
  }
  function Nn(J) {
    if (process.env.NODE_ENV !== "production" && Jr(y.state.isDestroyed, Po("setProps")), !y.state.isDestroyed) {
      Q("onBeforeUpdate", [y, J]), Ye();
      var be = y.props, R = Q1(e, Object.assign({}, be, Y1(J), {
        ignoreAttributes: !0
      }));
      y.props = R, Me(), be.interactiveDebounce !== R.interactiveDebounce && (Y(), p = U1(je, R.interactiveDebounce)), be.triggerTarget && !R.triggerTarget ? Fo(be.triggerTarget).forEach(function(F) {
        F.removeAttribute("aria-expanded");
      }) : R.triggerTarget && e.removeAttribute("aria-expanded"), oe(), V(), O && O(be, R), y.popperInstance && (We(), xt().forEach(function(F) {
        requestAnimationFrame(F._tippy.popperInstance.forceUpdate);
      })), Q("onAfterUpdate", [y, J]);
    }
  }
  function yr(J) {
    y.setProps({
      content: J
    });
  }
  function B() {
    process.env.NODE_ENV !== "production" && Jr(y.state.isDestroyed, Po("show"));
    var J = y.state.isVisible, be = y.state.isDestroyed, R = !y.state.isEnabled, F = Tr.isTouch && !y.props.touch, ae = Uu(y.props.duration, 0, Rn.duration);
    if (!(J || be || R || F) && !H().hasAttribute("disabled") && (Q("onShow", [y], !1), y.props.onShow(y) !== !1)) {
      if (y.state.isVisible = !0, W() && ($.style.visibility = "visible"), V(), Z(), y.state.isMounted || ($.style.transition = "none"), W()) {
        var pe = T(), we = pe.box, dt = pe.content;
        qu([we, dt], 0);
      }
      f = function() {
        var gt;
        if (!(!y.state.isVisible || d)) {
          if (d = !0, $.offsetHeight, $.style.transition = y.props.moveTransition, W() && y.props.animation) {
            var Vn = T(), jt = Vn.box, Dt = Vn.content;
            qu([jt, Dt], ae), K1([jt, Dt], "visible");
          }
          ue(), oe(), q1(Ku, y), (gt = y.popperInstance) == null || gt.forceUpdate(), Q("onMount", [y]), y.props.animation && W() && Ce(ae, function() {
            y.state.isShown = !0, Q("onShown", [y]);
          });
        }
      }, Oe();
    }
  }
  function w() {
    process.env.NODE_ENV !== "production" && Jr(y.state.isDestroyed, Po("hide"));
    var J = !y.state.isVisible, be = y.state.isDestroyed, R = !y.state.isEnabled, F = Uu(y.props.duration, 1, Rn.duration);
    if (!(J || be || R) && (Q("onHide", [y], !1), y.props.onHide(y) !== !1)) {
      if (y.state.isVisible = !1, y.state.isShown = !1, d = !1, a = !1, W() && ($.style.visibility = "hidden"), Y(), ee(), V(!0), W()) {
        var ae = T(), pe = ae.box, we = ae.content;
        y.props.animation && (qu([pe, we], F), K1([pe, we], "hidden"));
      }
      ue(), oe(), y.props.animation ? W() && N(F, y.unmount) : y.unmount();
    }
  }
  function ye(J) {
    process.env.NODE_ENV !== "production" && Jr(y.state.isDestroyed, Po("hideWithInteractivity")), _().addEventListener("mousemove", p), q1(Us, p), p(J);
  }
  function Pe() {
    process.env.NODE_ENV !== "production" && Jr(y.state.isDestroyed, Po("unmount")), y.state.isVisible && y.hide(), y.state.isMounted && (Tt(), xt().forEach(function(J) {
      J._tippy.unmount();
    }), $.parentNode && $.parentNode.removeChild($), Ku = Ku.filter(function(J) {
      return J !== y;
    }), y.state.isMounted = !1, Q("onHidden", [y]));
  }
  function Se() {
    process.env.NODE_ENV !== "production" && Jr(y.state.isDestroyed, Po("destroy")), !y.state.isDestroyed && (y.clearDelayTimeouts(), y.unmount(), Ye(), delete e._tippy, y.state.isDestroyed = !0, Q("onDestroy", [y]));
  }
}
function ma(e, t) {
  t === void 0 && (t = {});
  var n = Rn.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (hI(e), Ty(t, n)), dI();
  var r = Object.assign({}, t, {
    plugins: n
  }), i = iI(e);
  if (process.env.NODE_ENV !== "production") {
    var o = ds(r.content), a = i.length > 1;
    Jr(o && a, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = i.reduce(function(l, d) {
    var u = d && wI(d, r);
    return u && l.push(u), l;
  }, []);
  return ds(e) ? s[0] : s;
}
ma.defaultProps = Rn;
ma.setDefaultProps = vI;
ma.currentInput = Tr;
Object.assign({}, $g, {
  effect: function(t) {
    var n = t.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
ma.setDefaultProps({
  render: My
});
class kI {
  constructor({ editor: t, element: n, view: r, tippyOptions: i = {}, updateDelay: o = 250, shouldShow: a }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: l, from: d, to: u }) => {
      const { doc: c, selection: f } = l, { empty: h } = f, p = !c.textBetween(d, u).length && Tf(l.selection), m = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || m) || h || p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(s.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.handleDebouncedUpdate = (s, l) => {
      const d = !(l != null && l.selection.eq(s.state.selection)), u = !(l != null && l.doc.eq(s.state.doc));
      !d && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, d, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (s, l, d, u) => {
      var c, f, h;
      const { state: p, composing: m } = s, { selection: g } = p;
      if (m || !l && !d)
        return;
      this.createTooltip();
      const { ranges: b } = g, x = Math.min(...b.map(($) => $.$from.pos)), y = Math.max(...b.map(($) => $.$to.pos));
      if (!((c = this.shouldShow) === null || c === void 0 ? void 0 : c.call(this, {
        editor: this.editor,
        view: s,
        state: p,
        oldState: u,
        from: x,
        to: y
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (UA(p.selection)) {
            let $ = s.nodeDOM(x);
            const O = $.dataset.nodeViewWrapper ? $ : $.querySelector("[data-node-view-wrapper]");
            if (O && ($ = O.firstChild), $)
              return $.getBoundingClientRect();
          }
          return ny(s, x, y);
        })
      }), this.show();
    }, this.editor = t, this.element = n, this.view = r, this.updateDelay = o, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: t } = this.editor.options, n = !!t.parentElement;
    this.tippy || !n || (this.tippy = ma(t, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(t, n) {
    const { state: r } = t, i = r.selection.$from.pos !== r.selection.$to.pos;
    if (this.updateDelay > 0 && i) {
      this.handleDebouncedUpdate(t, n);
      return;
    }
    const o = !(n != null && n.selection.eq(t.state.selection)), a = !(n != null && n.doc.eq(t.state.doc));
    this.updateHandler(t, o, a, n);
  }
  show() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.show();
  }
  hide() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.hide();
  }
  destroy() {
    var t, n;
    !((t = this.tippy) === null || t === void 0) && t.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const Oy = (e) => new cn({
  key: typeof e.pluginKey == "string" ? new zn(e.pluginKey) : e.pluginKey,
  view: (t) => new kI({ view: t, ...e })
});
Xt.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Oy({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class xI {
  constructor({ editor: t, element: n, view: r, tippyOptions: i = {}, shouldShow: o }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: s }) => {
      const { selection: l } = s, { $anchor: d, empty: u } = l, c = d.depth === 1, f = d.parent.isTextblock && !d.parent.type.spec.code && !d.parent.textContent;
      return !(!a.hasFocus() || !u || !c || !f || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var s;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((s = this.element.parentNode) === null || s === void 0) && s.contains(a.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.editor = t, this.element = n, this.view = r, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: t } = this.editor.options, n = !!t.parentElement;
    this.tippy || !n || (this.tippy = ma(t, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(t, n) {
    var r, i, o;
    const { state: a } = t, { doc: s, selection: l } = a, { from: d, to: u } = l;
    if (n && n.doc.eq(s) && n.selection.eq(l))
      return;
    if (this.createTooltip(), !((r = this.shouldShow) === null || r === void 0 ? void 0 : r.call(this, {
      editor: this.editor,
      view: t,
      state: a,
      oldState: n
    }))) {
      this.hide();
      return;
    }
    (i = this.tippy) === null || i === void 0 || i.setProps({
      getReferenceClientRect: ((o = this.tippyOptions) === null || o === void 0 ? void 0 : o.getReferenceClientRect) || (() => ny(t, d, u))
    }), this.show();
  }
  show() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.show();
  }
  hide() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.hide();
  }
  destroy() {
    var t, n;
    !((t = this.tippy) === null || t === void 0) && t.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const Ey = (e) => new cn({
  key: typeof e.pluginKey == "string" ? new zn(e.pluginKey) : e.pluginKey,
  view: (t) => new xI({ view: t, ...e })
});
Xt.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Ey({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
$e({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: t }) {
    const n = q(null);
    return ot(() => {
      const { updateDelay: r, editor: i, pluginKey: o, shouldShow: a, tippyOptions: s } = e;
      i.registerPlugin(Oy({
        updateDelay: r,
        editor: i,
        element: n.value,
        pluginKey: o,
        shouldShow: a,
        tippyOptions: s
      }));
    }), bo(() => {
      const { pluginKey: r, editor: i } = e;
      i.unregisterPlugin(r);
    }), () => {
      var r;
      return nn("div", { ref: n }, (r = t.default) === null || r === void 0 ? void 0 : r.call(t));
    };
  }
});
function tm(e) {
  return l4((t, n) => ({
    get() {
      return t(), e;
    },
    set(r) {
      e = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          n();
        });
      });
    }
  }));
}
class SI extends bP {
  constructor(t = {}) {
    return super(t), this.vueRenderers = Gn(/* @__PURE__ */ new Map()), this.contentComponent = null, this.reactiveState = tm(this.view.state), this.reactiveExtensionStorage = tm(this.extensionStorage), this.on("transaction", () => {
      this.reactiveState.value = this.view.state, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), s4(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(t, n) {
    super.registerPlugin(t, n), this.reactiveState.value = this.view.state;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(t) {
    super.unregisterPlugin(t), this.reactiveState.value = this.view.state;
  }
}
const CI = $e({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const t = q(), n = o0();
    return ps(() => {
      const r = e.editor;
      r && r.options.element && t.value && an(() => {
        if (!t.value || !r.options.element.firstChild)
          return;
        const i = D(t.value);
        t.value.append(...r.options.element.childNodes), r.contentComponent = n.ctx._, r.setOptions({
          element: i
        }), r.createNodeViews();
      });
    }), bo(() => {
      const r = e.editor;
      if (!r || (r.isDestroyed || r.view.setProps({
        nodeViews: {}
      }), r.contentComponent = null, !r.options.element.firstChild))
        return;
      const i = document.createElement("div");
      i.append(...r.options.element.childNodes), r.setOptions({
        element: i
      });
    }), { rootEl: t };
  },
  render() {
    const e = [];
    return this.editor && this.editor.vueRenderers.forEach((t) => {
      const n = nn(ca, {
        to: t.teleportElement,
        key: t.id
      }, nn(t.component, {
        ref: t.id,
        ...t.props
      }));
      e.push(n);
    }), nn("div", {
      ref: (t) => {
        this.rootEl = t;
      }
    }, ...e);
  }
});
$e({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: t }) {
    const n = q(null);
    return ot(() => {
      const { pluginKey: r, editor: i, tippyOptions: o, shouldShow: a } = e;
      i.registerPlugin(Ey({
        pluginKey: r,
        editor: i,
        element: n.value,
        tippyOptions: o,
        shouldShow: a
      }));
    }), bo(() => {
      const { pluginKey: r, editor: i } = e;
      i.unregisterPlugin(r);
    }), () => {
      var r;
      return nn("div", { ref: n }, (r = t.default) === null || r === void 0 ? void 0 : r.call(t));
    };
  }
});
$e({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return nn(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
$e({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, t;
    return nn(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e));
  }
});
const TI = (e = {}) => {
  const t = il();
  return ot(() => {
    t.value = new SI(e);
  }), bo(() => {
    var n;
    (n = t.value) === null || n === void 0 || n.destroy();
  }), t;
};
var MI = /* @__PURE__ */ Xt.create({
  name: "fontSize",
  addOptions: function() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes: function() {
    return [{
      types: this.options.types,
      attributes: {
        fontSize: {
          default: null,
          parseHTML: function(n) {
            return n.style.fontSize.replace(/['"]+/g, "");
          },
          renderHTML: function(n) {
            return n.fontSize ? {
              style: "font-size: " + n.fontSize
            } : {};
          }
        }
      }
    }];
  },
  addCommands: function() {
    return {
      setFontSize: function(n) {
        return function(r) {
          var i = r.chain;
          return i().setMark("textStyle", {
            fontSize: n
          }).run();
        };
      },
      unsetFontSize: function() {
        return function(n) {
          var r = n.chain;
          return r().setMark("textStyle", {
            fontSize: null
          }).removeEmptyTextStyle().run();
        };
      }
    };
  }
});
const Dy = (e) => {
  const t = "bg-gray-200", n = "text-gray-700 rounded transition ease-out duration-100 focus:outline-none hover:bg-gray-200 focus:bg-gray-200", r = "bg-gray-100 text-gray-300 cursor-not-allowed";
  return {
    classStyles: E(() => ({
      [t]: e.active && !e.disabled,
      [n]: !e.disabled,
      [r]: e.disabled
    }))
  };
}, OI = $e({
  name: "EditorButton",
  props: {
    // actually used in the useButtonStyles composable
    // eslint-disable-next-line vue/no-unused-properties
    active: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    return {
      classStyles: Dy(e).classStyles
    };
  }
}), EI = ["disabled"];
function DI(e, t, n, r, i, o) {
  return k(), A("button", {
    type: "button",
    tabindex: "-1",
    disabled: e.disabled,
    class: te([e.classStyles, "h-7 w-7"])
  }, [
    se(e.$slots, "default")
  ], 10, EI);
}
const ln = /* @__PURE__ */ Je(OI, [["render", DI]]), AI = () => {
  const e = q(!1), t = q();
  return {
    isPopoverOpen: e,
    togglePopover: () => {
      if (e.value) {
        e.value = !1;
        return;
      }
      e.value = !0;
    },
    close: (i) => {
      var o;
      i !== void 0 && ((o = t.value) != null && o.contains(i.target)) || (e.value = !1);
    },
    button: t
  };
}, PI = $e({
  name: "EditorDropdownButton",
  components: {
    DsPopover: df,
    DsIcon: Ue
  },
  inheritAttrs: !1,
  props: {
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    return {
      ...AI(),
      // dropdown buttons have no active state
      ...Dy({ ...e, active: !1 }),
      PopoverVariant: zo
    };
  }
});
function NI(e, t, n, r, i, o) {
  const a = Be("DsIcon"), s = Be("DsPopover");
  return k(), ge(s, {
    show: e.isPopoverOpen && !e.disabled,
    variant: e.PopoverVariant.White,
    onClickOutside: e.close
  }, {
    content: de(() => [
      se(e.$slots, "popover-content")
    ]),
    default: de(() => [
      G("button", {
        ref: "button",
        type: "button",
        tabindex: "-1",
        class: te([e.classStyles, "flex justify-center space-x-1 px-1.5 items-center h-7"]),
        onClick: t[0] || (t[0] = (...l) => e.togglePopover && e.togglePopover(...l))
      }, [
        se(e.$slots, "button-content"),
        Jt(fe(a, {
          name: "chevron-up",
          variant: "regular",
          size: "xs"
        }, null, 512), [
          [Cn, e.isPopoverOpen]
        ]),
        Jt(fe(a, {
          name: "chevron-down",
          variant: "regular",
          size: "xs"
        }, null, 512), [
          [Cn, !e.isPopoverOpen]
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["show", "variant", "onClickOutside"]);
}
const Bf = /* @__PURE__ */ Je(PI, [["render", NI]]), II = $e({
  name: "EditorColorButton",
  components: {
    DsIcon: Ue,
    EditorDropdownButton: Bf
  },
  props: {
    editor: {
      type: Object,
      required: !0
    },
    extension: {
      type: String,
      default: "textStyle"
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    const t = q(), n = (o) => {
      e.extension === "textStyle" ? e.editor.chain().focus().setColor(o).run() : e.editor.chain().focus().toggleHighlight({ color: o }).run();
    };
    return {
      colors: [
        {
          hexadecimal: e.extension === "textStyle" ? "#000000" : "#ffffff",
          tailwind: e.extension === "textStyle" ? "bg-black" : "bg-white"
        },
        {
          hexadecimal: "#535864",
          tailwind: "bg-gray-700"
        },
        {
          hexadecimal: "#4181D2",
          tailwind: "bg-blue-500"
        },
        {
          hexadecimal: "#A6D64D",
          tailwind: "bg-green-500"
        },
        {
          hexadecimal: "#E83F25",
          tailwind: "bg-red-500"
        },
        {
          hexadecimal: "#FFB62D",
          tailwind: "bg-orange-500"
        }
      ],
      colorInput: t,
      asHtmlInputElement: (o) => o.target,
      handleClick: n
    };
  }
}), RI = { class: "flex flex-wrap" }, _I = ["onClick"], LI = { class: "w-full mt-1 flex justify-between rounded p-0.5 bg-blue-100 hover:bg-blue-200 hover:text-blue-800 active:bg-blue-100 focus:bg-blue-200 text-blue-700" }, FI = ["value"];
function BI(e, t, n, r, i, o) {
  const a = Be("DsIcon"), s = Be("EditorDropdownButton");
  return k(), ge(s, { disabled: e.disabled }, {
    "button-content": de(() => [
      se(e.$slots, "button-content")
    ]),
    "popover-content": de(() => [
      G("div", RI, [
        (k(!0), A(Ie, null, Ze(e.colors, (l) => (k(), A("button", {
          key: l.hexadecimal,
          class: te([l.tailwind, "mx-0.5 flex shrink-0 justify-center items-center h-7 w-7 border rounded pb-0.5"]),
          onClick: (d) => e.handleClick(l.hexadecimal)
        }, [
          e.editor.isActive(e.extension, { color: l.hexadecimal }) ? (k(), ge(a, {
            key: 0,
            class: "text-white",
            name: "check",
            size: "sm"
          })) : K("", !0)
        ], 10, _I))), 128))
      ]),
      G("div", LI, [
        G("span", {
          class: "text-xs self-center cursor-pointer",
          onClick: t[0] || (t[0] = (l) => e.colorInput.click())
        }, " Benutzerdefiniert: "),
        G("input", {
          ref: "colorInput",
          type: "color",
          class: "h-5 w-8 m-0.5 ml-1 rounded",
          value: e.editor.getAttributes(e.extension).color,
          onInput: t[1] || (t[1] = (l) => e.handleClick(e.asHtmlInputElement(l).value))
        }, null, 40, FI)
      ])
    ]),
    _: 3
  }, 8, ["disabled"]);
}
const nm = /* @__PURE__ */ Je(II, [["render", BI]]), zI = $e({
  name: "EditorFontFamilyButton",
  components: {
    DsIcon: Ue,
    EditorDropdownButton: Bf
  },
  props: {
    editor: {
      type: Object,
      required: !0
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    return e.editor.commands.setFontFamily("Arial"), {
      setFontFamily: (r) => {
        e.editor.chain().focus().setFontFamily(r).run();
      },
      fontFamilies: [
        {
          title: "Andale Mono",
          family: "andale mono, monospace"
        },
        {
          title: "Arial",
          family: "Arial"
        },
        {
          title: "Book Antiqua",
          family: '"book antiqua", palatino, serif'
        },
        {
          title: "Comic Sans",
          family: '"comic sans ms", sans-serif'
        },
        {
          title: "Courier New",
          family: "Courier New"
        },
        {
          title: "Georgia",
          family: " georgia, palatino, serif"
        },
        {
          title: "Helvetica",
          family: "helvetica, helvetica regular, arial, sans-serif"
        },
        {
          title: "Impact",
          family: "impact, sans-serif"
        },
        {
          title: "Tahoma",
          family: "tahoma, arial, helvetica, sans-serif"
        },
        {
          title: "Terminal",
          family: "terminal, monaco, monospace"
        },
        {
          title: "Times New Roman",
          family: '"times new roman", times, serif'
        },
        {
          title: "Trebuchet",
          family: '"trebuchet ms", geneva, sans-serif'
        },
        {
          title: "Verdana",
          family: "verdana, geneva, sans-serif"
        }
      ]
    };
  }
}), VI = ["onClick"], HI = { class: "w-4 shrink-0 text-gray-500" };
function jI(e, t, n, r, i, o) {
  const a = Be("DsIcon"), s = Be("EditorDropdownButton");
  return k(), ge(s, { disabled: e.disabled }, {
    "button-content": de(() => [
      se(e.$slots, "button-content")
    ]),
    "popover-content": de(() => [
      (k(!0), A(Ie, null, Ze(e.fontFamilies, (l) => (k(), A("div", {
        key: l.title,
        class: "text-xs p-0.5 flex flex-nowrap px-2 rounded-sm w-full focus:outline-none hover:bg-gray-100 text-sm text-left py-1 cursor-pointer",
        onClick: (d) => e.setFontFamily(l.family)
      }, [
        G("div", HI, [
          e.editor.isActive("textStyle", { fontFamily: l.family }) ? (k(), ge(a, {
            key: 0,
            name: "check",
            size: "xs"
          })) : K("", !0)
        ]),
        G("div", {
          style: mt({ fontFamily: l.family })
        }, Te(l.title), 5)
      ], 8, VI))), 128))
    ]),
    _: 3
  }, 8, ["disabled"]);
}
const WI = /* @__PURE__ */ Je(zI, [["render", jI]]), UI = $e({
  name: "EditorFontSizeButton",
  components: {
    DsIcon: Ue,
    EditorDropdownButton: Bf
  },
  props: {
    editor: {
      type: Object,
      required: !0
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    const t = (i) => {
      e.editor.chain().focus().setFontSize(`${i}pt`).run();
    }, n = [8, 9, 10, 11, 12, 14, 18, 24, 30, 36];
    return {
      hasASizeBeenSelected: () => !n.every((i) => e.editor.isActive("textStyle", { fontSize: `${i}pt` })),
      handleClick: t,
      sizes: n
    };
  }
}), qI = ["onClick"], YI = { class: "w-4 shrink-0 text-gray-500" };
function KI(e, t, n, r, i, o) {
  const a = Be("DsIcon"), s = Be("EditorDropdownButton");
  return k(), ge(s, { disabled: e.disabled }, {
    "button-content": de(() => [
      se(e.$slots, "button-content")
    ]),
    "popover-content": de(() => [
      (k(!0), A(Ie, null, Ze(e.sizes, (l) => (k(), A("div", {
        key: l,
        class: "text-xs p-0.5 flex flex-nowrap px-2 rounded-sm w-full focus:outline-none hover:bg-gray-100 text-sm text-left py-1 cursor-pointer",
        onClick: (d) => e.handleClick(l)
      }, [
        G("div", YI, [
          e.editor.isActive({ fontSize: `${l}pt` }) ? (k(), ge(a, {
            key: 0,
            name: "check",
            size: "xs"
          })) : K("", !0)
        ]),
        G("div", null, Te(l) + " pt ", 1)
      ], 8, qI))), 128))
    ]),
    _: 3
  }, 8, ["disabled"]);
}
const GI = /* @__PURE__ */ Je(UI, [["render", KI]]), JI = An.create({
  name: "oneLineDocument",
  topNode: !0,
  content: "block"
}), XI = {
  key: 0,
  class: "bg-gray-300 shadow-sm rounded-t py-1"
}, QI = { class: "flex flex-wrap -my-1" }, ZI = { class: "flex flex-col" }, eR = { class: "flex flex-col" }, qV = /* @__PURE__ */ $e({
  __name: "DsEditor",
  props: {
    modelValue: {},
    extensions: { default: () => [] },
    disabled: { type: Boolean },
    html: { type: Boolean },
    inline: { type: Boolean },
    fontFamily: { type: Boolean },
    fontSize: { type: Boolean },
    textColor: { type: Boolean },
    highlight: { type: Boolean },
    textAlignment: { type: Boolean },
    links: { type: Boolean },
    history: { type: Boolean }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = E(() => {
      let l = "border focus:outline-none rounded text-black px-3 grow ";
      return n.inline ? (l += "sm:pt-1.5 pt-1 pb-1 leading-snug text-gray-900 sm:text-sm ", l += n.disabled ? "border-gray-200 " : "border-gray-300 ") : l += "py-2 overflow-x-auto space-y-3 border-transparent rounded-t-none ", n.disabled ? l += "text-gray-500 bg-gray-100 cursor-not-allowed " : l += "focus:border-blue-500 focus:shadow-outline-blue ", l;
    }), o = n.inline ? [
      sy,
      gy,
      my,
      JI
    ] : [
      wP,
      YN.configure({
        code: !1,
        codeBlock: !1,
        horizontalRule: !1
      }),
      oN
    ];
    n.inline || (n.fontFamily && o.push(xP), n.fontSize && o.push(MI), n.textColor && o.push(kP), n.highlight && o.push(TP.configure({
      multicolor: !0
    })), n.textAlignment && o.push(iN.configure({
      types: ["heading", "paragraph"]
    })), n.links && o.push(rN.configure({
      openOnClick: !1
    })));
    const a = TI({
      content: QS(n.modelValue) ? {
        type: n.inline ? "oneLineDocument" : "doc",
        content: [{
          type: "paragraph",
          attrs: { textAlign: "left" }
        }]
      } : n.modelValue,
      extensions: [
        ...o,
        ...n.extensions
      ],
      onUpdate: () => {
        a.value !== void 0 && r(
          "update:modelValue",
          n.html ? a.value.getHTML() : a.value.getJSON()
        );
      },
      onFocus: () => r("focus"),
      onBlur: () => r("blur"),
      editorProps: {
        attributes: {
          tabindex: n.disabled ? "-1" : "0",
          class: i.value
        }
      },
      editable: !n.disabled
    });
    Fe(() => n.modelValue, (l) => {
      if (a.value === void 0) return;
      const d = n.html ? a.value.getHTML() : JSON.stringify(a.value.getJSON()), u = typeof l == "string" ? l : JSON.stringify(l);
      d !== u && (a.value.commands.setContent(l), r(
        "update:modelValue",
        n.html ? a.value.getHTML() : a.value.getJSON()
      ));
    }), Fe(() => n.disabled, () => {
      a.value !== void 0 && a.value.setOptions({
        editorProps: {
          attributes: {
            tabindex: n.disabled ? "-1" : "0",
            class: i.value
          }
        },
        editable: !n.disabled
      });
    });
    function s() {
      if (a.value === void 0) return;
      const l = a.value.getAttributes("link").href, d = window.prompt("URL", l);
      if (d !== null) {
        if (d === "") {
          a.value.chain().focus().extendMarkRange("link").unsetLink().run();
          return;
        }
        a.value.chain().focus().extendMarkRange("link").setLink({ href: d }).run();
      }
    }
    return (l, d) => (k(), A("div", {
      class: te([{
        "cursor-not-allowed": l.disabled,
        border: !l.inline,
        "border-gray-300": !l.disabled && !l.inline,
        "border-gray-200": l.disabled && !l.inline
      }, "rounded divide-y shadow-sm bg-white flex flex-col"])
    }, [
      D(a) !== void 0 && !l.inline ? (k(), A("div", XI, [
        G("div", QI, [
          G("span", {
            class: te([l.disabled ? "bg-gray-100" : "bg-white", "flex space-x-1 p-1 mx-1 my-1 items-center rounded"])
          }, [
            fe(ln, {
              active: D(a).isActive("bold") && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[0] || (d[0] = (u) => D(a).chain().focus().toggleBold().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "bold",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive("italic") && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[1] || (d[1] = (u) => D(a).chain().focus().toggleItalic().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "italic",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive("underline") && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[2] || (d[2] = (u) => D(a).chain().focus().toggleUnderline().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "underline",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive("strike") && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[3] || (d[3] = (u) => D(a).chain().focus().toggleStrike().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "strikethrough",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"])
          ], 2),
          l.fontFamily || l.fontSize || l.textColor || l.highlight ? (k(), A("span", {
            key: 0,
            class: te([l.disabled ? "bg-gray-100" : "bg-white", "flex space-x-1 p-1 mx-1 my-1 items-center rounded"])
          }, [
            l.fontFamily ? (k(), ge(WI, {
              key: 0,
              class: "w-7",
              disabled: l.disabled,
              editor: D(a)
            }, {
              "button-content": de(() => [
                fe(Ue, {
                  name: "font",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["disabled", "editor"])) : K("", !0),
            l.fontSize ? (k(), ge(GI, {
              key: 1,
              class: "w-7",
              disabled: l.disabled,
              editor: D(a)
            }, {
              "button-content": de(() => [
                fe(Ue, {
                  name: "text-size",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["disabled", "editor"])) : K("", !0),
            l.textColor ? (k(), ge(nm, {
              key: 2,
              disabled: l.disabled,
              editor: D(a)
            }, {
              "button-content": de(() => [
                G("div", ZI, [
                  fe(Ue, {
                    name: "font",
                    variant: "regular",
                    size: "sm"
                  }),
                  G("div", {
                    class: te(["mt-px mx-auto w-4 h-1 rounded mb-1", l.disabled ? "editor__font-button--disabled" : "editor__font-button"])
                  }, null, 2)
                ])
              ]),
              _: 1
            }, 8, ["disabled", "editor"])) : K("", !0),
            l.highlight ? (k(), ge(nm, {
              key: 3,
              disabled: l.disabled,
              editor: D(a),
              extension: "highlight"
            }, {
              "button-content": de(() => [
                G("div", eR, [
                  fe(Ue, {
                    name: "highlighter",
                    variant: "duotone",
                    size: "sm"
                  }),
                  G("div", {
                    class: te(["mt-px w-4 h-1 rounded mb-1", l.disabled ? "editor__font-button--disabled" : "editor__font-button"])
                  }, null, 2)
                ])
              ]),
              _: 1
            }, 8, ["disabled", "editor"])) : K("", !0)
          ], 2)) : K("", !0),
          G("span", {
            class: te([l.disabled ? "bg-gray-100" : "bg-white", "flex space-x-1 p-1 mx-1 my-1 items-center rounded"])
          }, [
            fe(ln, {
              active: D(a).isActive("bulletList") && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[4] || (d[4] = (u) => D(a).chain().focus().toggleBulletList().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "list-ul",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive("orderedList") && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[5] || (d[5] = (u) => D(a).chain().focus().toggleOrderedList().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "list-ol",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"])
          ], 2),
          l.textAlignment ? (k(), A("span", {
            key: 1,
            class: te([l.disabled ? "bg-gray-100" : "bg-white", "flex space-x-1 p-1 mx-1 my-1 items-center rounded"])
          }, [
            fe(ln, {
              active: D(a).isActive({ textAlign: "left" }) && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[6] || (d[6] = (u) => D(a).chain().focus().setTextAlign("left").run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "align-left",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive({ textAlign: "center" }) && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[7] || (d[7] = (u) => D(a).chain().focus().setTextAlign("center").run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "align-center",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive({ textAlign: "right" }) && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[8] || (d[8] = (u) => D(a).chain().focus().setTextAlign("right").run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "align-right",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive({ textAlign: "justify" }) && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[9] || (d[9] = (u) => D(a).chain().focus().setTextAlign("justify").run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "align-justify",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"])
          ], 2)) : K("", !0),
          G("span", {
            class: te([l.disabled ? "bg-gray-100" : "bg-white", "flex space-x-1 p-1 mx-1 my-1 items-center rounded"])
          }, [
            fe(ln, {
              active: D(a).isActive("heading", { level: 1 }) && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[10] || (d[10] = (u) => D(a).chain().focus().toggleHeading({ level: 1 }).run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "h1",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive("heading", { level: 2 }) && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[11] || (d[11] = (u) => D(a).chain().focus().toggleHeading({ level: 2 }).run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "h2",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"]),
            fe(ln, {
              active: D(a).isActive("heading", { level: 3 }) && D(a).isFocused,
              disabled: l.disabled,
              onClick: d[12] || (d[12] = (u) => D(a).chain().focus().toggleHeading({ level: 3 }).run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "h3",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["active", "disabled"])
          ], 2),
          l.links ? (k(), A("span", {
            key: 2,
            class: te([l.disabled ? "bg-gray-100" : "bg-white", "flex space-x-1 p-1 mx-1 my-1 items-center rounded"])
          }, [
            fe(ln, {
              disabled: l.disabled,
              onClick: s
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "link",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            Jt(fe(ln, {
              disabled: l.disabled,
              onClick: d[13] || (d[13] = (u) => D(a).chain().focus().unsetLink().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "unlink",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [Cn, D(a).isActive("link")]
            ])
          ], 2)) : K("", !0),
          l.history ? (k(), A("span", {
            key: 3,
            class: te([l.disabled ? "bg-gray-100" : "bg-white", "flex space-x-1 p-1 mx-1 my-1 items-center rounded"])
          }, [
            fe(ln, {
              disabled: l.disabled,
              onClick: d[14] || (d[14] = (u) => D(a).chain().undo().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "undo-alt",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            fe(ln, {
              disabled: l.disabled,
              onClick: d[15] || (d[15] = (u) => D(a).chain().redo().run())
            }, {
              default: de(() => [
                fe(Ue, {
                  name: "redo-alt",
                  variant: "regular",
                  size: "sm"
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 2)) : K("", !0)
        ])
      ])) : K("", !0),
      fe(D(CI), {
        ref: "editorContent",
        editor: D(a),
        class: "editor-content grow flex",
        tabindex: "-1"
      }, null, 8, ["editor"])
    ], 2));
  }
});
var Ay = { exports: {} };
/*!
 2020 Jason Mulligan <jason.mulligan@avoidwork.com>
 @version 6.4.0
*/
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(W5, function() {
    var n = /^(b|B)$/, r = { iec: { bits: ["b", "Kib", "Mib", "Gib", "Tib", "Pib", "Eib", "Zib", "Yib"], bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"] }, jedec: { bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"], bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] } }, i = { iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"], jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"] }, o = { floor: Math.floor, ceil: Math.ceil };
    function a(s) {
      var l, d, u, c, f, h, p, m, g, v, b, x, y, C, $, O, z, P, U, ie, W, H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = [], T = 0;
      if (isNaN(s)) throw new TypeError("Invalid number");
      if (u = H.bits === !0, $ = H.unix === !0, x = H.pad === !0, d = H.base || 2, y = H.round !== void 0 ? H.round : $ ? 1 : 2, p = H.locale !== void 0 ? H.locale : "", m = H.localeOptions || {}, O = H.separator !== void 0 ? H.separator : "", z = H.spacer !== void 0 ? H.spacer : $ ? "" : " ", U = H.symbols || {}, P = d === 2 && H.standard || "jedec", b = H.output || "string", f = H.fullform === !0, h = H.fullforms instanceof Array ? H.fullforms : [], l = H.exponent !== void 0 ? H.exponent : -1, ie = o[H.roundingMethod] || Math.round, g = (v = Number(s)) < 0, c = d > 2 ? 1e3 : 1024, W = isNaN(H.precision) === !1 ? parseInt(H.precision, 10) : 0, g && (v = -v), (l === -1 || isNaN(l)) && (l = Math.floor(Math.log(v) / Math.log(c))) < 0 && (l = 0), l > 8 && (W > 0 && (W += 8 - l), l = 8), b === "exponent") return l;
      if (v === 0) _[0] = 0, C = _[1] = $ ? "" : r[P][u ? "bits" : "bytes"][l];
      else {
        T = v / (d === 2 ? Math.pow(2, 10 * l) : Math.pow(1e3, l)), u && (T *= 8) >= c && l < 8 && (T /= c, l++);
        var M = Math.pow(10, l > 0 ? y : 0);
        _[0] = ie(T * M) / M, _[0] === c && l < 8 && H.exponent === void 0 && (_[0] = 1, l++), C = _[1] = d === 10 && l === 1 ? u ? "kb" : "kB" : r[P][u ? "bits" : "bytes"][l], $ && (_[1] = P === "jedec" ? _[1].charAt(0) : l > 0 ? _[1].replace(/B$/, "") : _[1], n.test(_[1]) && (_[0] = Math.floor(_[0]), _[1] = ""));
      }
      if (g && (_[0] = -_[0]), W > 0 && (_[0] = _[0].toPrecision(W)), _[1] = U[_[1]] || _[1], p === !0 ? _[0] = _[0].toLocaleString() : p.length > 0 ? _[0] = _[0].toLocaleString(p, m) : O.length > 0 && (_[0] = _[0].toString().replace(".", O)), x && Number.isInteger(_[0]) === !1 && y > 0) {
        var V = O || ".", Q = _[0].toString().split(V), ue = Q[1] || "", oe = ue.length, Y = y - oe;
        _[0] = "".concat(Q[0]).concat(V).concat(ue.padEnd(oe + Y, "0"));
      }
      return f && (_[1] = h[l] ? h[l] : i[P][l] + (u ? "bit" : "byte") + (_[0] === 1 ? "" : "s")), b === "array" ? _ : b === "object" ? { value: _[0], symbol: _[1], exponent: l, unit: C } : _.join(z);
    }
    return a.partial = function(s) {
      return function(l) {
        return a(l, s);
      };
    }, a;
  });
})(Ay);
var tR = Ay.exports;
const nR = /* @__PURE__ */ w0(tR), rR = $e({
  name: "DsFileList",
  components: {
    DsIcon: Ue
  },
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    return {
      fileSize(e) {
        return nR(e, { locale: "de" });
      },
      fileIcon(e) {
        const t = e.toLowerCase();
        return t.endsWith(".pdf") ? "file-pdf" : t.endsWith(".zip") ? "file-archive" : t.endsWith(".xls") ? "file-excel" : t.endsWith(".docx") ? "file-word" : t.endsWith(".pptx") ? "file-powerpoint" : t.endsWith(".txt") ? "file-alt" : t.endsWith(".csv") ? "file-csv" : /\.(png|jpe?g|gif|bmp|svg)$/.test(t) ? "file-image" : "file";
      }
    };
  }
}), iR = { class: "border rounded-md divide-y" }, oR = ["title", "textContent"], aR = ["textContent"], sR = { class: "flex grow justify-end item-center space-x-1.5" };
function lR(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), A("div", iR, [
    (k(!0), A(Ie, null, Ze(e.files, (s) => (k(), A("div", {
      key: s.name,
      class: "p-1.5 flex items-center space-x-2 text-sm h-9"
    }, [
      fe(a, {
        name: e.fileIcon(s.name),
        variant: "regular",
        class: "text-gray-500 ml-0.5"
      }, null, 8, ["name"]),
      G("span", {
        class: "truncate",
        title: s.name,
        textContent: Te(s.name)
      }, null, 8, oR),
      s.size !== null && s.size !== void 0 ? (k(), A("span", {
        key: 0,
        class: "shrink-0 text-gray-500",
        textContent: Te(e.fileSize(s.size))
      }, null, 8, aR)) : K("", !0),
      G("div", sR, [
        se(e.$slots, "default", { file: s })
      ])
    ]))), 128))
  ]);
}
const dR = /* @__PURE__ */ Je(rR, [["render", lR]]);
function uR(e) {
  const t = q(!1), n = q(0);
  let r = 0;
  return _n(e, "dragenter", (i) => {
    var o, a;
    i.preventDefault(), r += 1, n.value = (a = (o = i.dataTransfer) == null ? void 0 : o.items.length) != null ? a : 0, t.value = !0;
  }), _n(e, "dragover", (i) => {
    i.preventDefault();
  }), _n(e, "dragleave", (i) => {
    i.preventDefault(), r -= 1, n.value = 0, r === 0 && (t.value = !1);
  }), _n(e, "drop", (i) => {
    i.preventDefault(), r = 0, n.value = 0, t.value = !1;
  }), {
    isOverDropZone: t,
    dropZoneFileCount: n
  };
}
const cR = $e({
  name: "DsFileUpload",
  components: {
    DsIcon: Ue,
    DsFileList: dR
  },
  props: {
    /**
     * The selected file(s).
     */
    modelValue: {
      type: Array,
      required: !0
    },
    name: {
      type: [String, null],
      default: null
    },
    required: {
      type: Boolean
    },
    /**
     * Changes the file upload to a multi file upload.
     */
    multiple: {
      type: Boolean
    },
    /**
     * The file input element accept attribute.
     */
    accept: {
      type: String,
      default: ""
    },
    /**
     * The max combined file size allowed during upload in MB.
     */
    maxSize: {
      type: Number,
      default: 0
    },
    /**
     * Hides the FileList to make custom styling possible.
     */
    hideFileList: {
      type: Boolean
    },
    /**
     * Makes the file upload look lighter
     */
    light: {
      type: Boolean
    },
    /**
     * No borders. For implementing more complex layouts.
     */
    inline: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(e, t) {
    const n = q(), r = q(""), i = O5(n), o = (p) => t.emit("update:modelValue", p), {
      isOverDropZone: a,
      dropZoneFileCount: s
    } = uR(n), l = (p) => {
      if (e.maxSize === 0)
        return !0;
      const m = fh(e.modelValue, (b) => b.size), v = e.maxSize * 1048576;
      return fh(p, (b) => b.size) + m <= v;
    }, d = (p) => e.modelValue.findIndex(
      (m) => m.name === p.name && m.size === p.size
    ), u = (p) => ({
      file: p,
      name: p.name,
      size: p.size,
      isLoading: !1,
      isCompleted: !1
    }), c = E(
      () => e.accept.length === 0 ? [] : e.accept.split(",").map((p) => p.trim())
    ), f = (p) => {
      r.value = p, setTimeout(() => {
        r.value = "";
      }, 3e3);
    }, h = (p) => Array.from(p).filter((m) => {
      if (d(m) !== -1)
        return !1;
      if (e.accept.length > 0) {
        const g = m.name.split(".").pop();
        if (!c.value.includes(`.${g}`))
          return f("Ungültiger Dateityp"), !1;
      }
      return !0;
    }).map((m) => u(m)).concat(e.modelValue);
    return w5(
      () => e.modelValue,
      () => {
        e.modelValue.every((p) => p.isCompleted) && n.value !== void 0 && n.value !== null && (n.value.value = "");
      },
      { debounce: 1e3, deep: !0 }
    ), {
      inputId: q(lC("fileInput")),
      fileInput: n,
      errorText: r,
      handleInputChange(p) {
        const m = p.target;
        if (!(m.files === null || m.files.length === 0)) {
          if (!l(m.files)) {
            f(`Maximalgröße für Dateien muss eingehalten werden: ${e.maxSize} MB`);
            return;
          }
          o(e.multiple ? h(m.files) : [u(m.files[0])]);
        }
      },
      handleDropEvent(p) {
        var g, v;
        p.preventDefault();
        const m = (v = (g = p.dataTransfer) == null ? void 0 : g.files) != null ? v : new FileList();
        if (m.length !== 0) {
          if (!l(m)) {
            f(`Maximalgröße für Dateien muss eingehalten werden: ${e.maxSize} MB`);
            return;
          }
          if (!e.multiple && m.length > 1) {
            f("Zu viele Dateien");
            return;
          }
          o(e.multiple ? h(m) : [u(m[0])]);
        }
      },
      removeFile(p) {
        if (!e.multiple) {
          n.value !== void 0 && (n.value.value = ""), o([]);
          return;
        }
        o(e.modelValue.filter(
          (m) => m.name !== p.name || m.size !== p.size
        ));
      },
      isLoading(p) {
        const m = d(p);
        return m === -1 ? !1 : e.modelValue[m].isLoading;
      },
      fileInputName: E(() => e.name === null ? "" : e.multiple ? `${e.name}[]` : e.name),
      styleClasses: E(() => {
        const p = !e.multiple && s.value > 1;
        return {
          /** Borderless mode */
          "border-transparent": e.inline,
          /** Dark/Light mode */
          "bg-gray-100": !a.value && (!e.light && !i.value || e.light && i.value),
          "bg-gray-200": !e.light && i.value,
          /** DragAndDrop */
          "border-dashed": a.value,
          "border-blue-500 bg-blue-100": a.value && !p,
          "border-red-500 bg-red-100": a.value && p,
          /** Multiple */
          "flex-col space-y-2 tracking-wide p-3": e.multiple,
          /** Single */
          "grow p-2": !e.multiple
        };
      })
    };
  }
}), fR = { class: "relative" }, pR = ["for"], hR = { key: 0 }, mR = /* @__PURE__ */ G("span", { class: "text-blue-500 underline" }, "auswählen", -1), gR = {
  key: 1,
  class: "text-red-700"
}, vR = ["id", "name", "multiple", "required", "accept"], yR = ["onClick"];
function bR(e, t, n, r, i, o) {
  const a = Be("DsIcon"), s = Be("DsFileList");
  return k(), A("div", null, [
    G("div", fR, [
      Jt(G("label", {
        for: e.inputId,
        tabindex: "0",
        class: te(["relative rounded flex items-center justify-center text-gray-700 pointer-events-none text-xs border focus:border-blue-500 focus:shadow-outline-blue focus:outline-none transition ease-out duration-100 text-center", e.styleClasses]),
        onKeydown: t[0] || (t[0] = Re((l) => {
          var d;
          return (d = e.fileInput) == null ? void 0 : d.click();
        }, ["enter"])),
        onDragover: t[1] || (t[1] = Ge(() => {
        }, ["prevent"]))
      }, [
        fe(a, {
          name: "upload",
          size: "lg",
          "fixed-width": "",
          class: te([{ "mr-2": !e.multiple }])
        }, null, 8, ["class"]),
        fe(ur, {
          "enter-active-class": "ease-out duration-75",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "ease-in duration-150",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0",
          mode: "out-in"
        }, {
          default: de(() => [
            e.errorText.length === 0 ? (k(), A("span", hR, [
              it(" Datei" + Te(e.multiple ? "(en)" : "") + " hier ablegen oder ", 1),
              mR
            ])) : (k(), A("span", gR, Te(e.errorText), 1))
          ]),
          _: 1
        })
      ], 42, pR), [
        [Cn, e.multiple || e.modelValue.length === 0]
      ]),
      G("input", {
        id: e.inputId,
        ref: "fileInput",
        name: e.fileInputName,
        type: "file",
        multiple: e.multiple,
        required: e.required,
        accept: e.accept,
        class: "absolute top-0 bottom-0 left-0 right-0 opacity-0 fileInputStretch",
        tabindex: "-1",
        onChange: t[2] || (t[2] = (...l) => e.handleInputChange && e.handleInputChange(...l)),
        onDrop: t[3] || (t[3] = (...l) => e.handleDropEvent && e.handleDropEvent(...l))
      }, null, 40, vR)
    ]),
    !e.hideFileList && e.modelValue.length > 0 ? (k(), ge(s, {
      key: 0,
      files: e.modelValue,
      class: te({ "mt-3": e.multiple }),
      onDrop: t[5] || (t[5] = (l) => !e.multiple && e.handleDropEvent(l)),
      onDragover: t[6] || (t[6] = Ge(() => {
      }, ["prevent"]))
    }, {
      default: de(({ file: l }) => [
        G("button", {
          type: "button",
          class: te([e.isLoading(l) ? "cursor-default" : "hover:bg-red-100 focus:bg-red-100", "flex items-center justify-center h-6 w-7 rounded shrink-0 text-base focus:outline-none transition ease-out duration-200"]),
          onClick: (d) => !e.isLoading(l) && e.removeFile(l)
        }, [
          e.isLoading(l) ? (k(), ge(a, {
            key: 0,
            name: "spinner-third",
            class: "text-gray-500",
            spin: "",
            "fixed-width": ""
          })) : (k(), ge(a, {
            key: 1,
            name: "xmark",
            class: "text-red-500",
            "fixed-width": ""
          }))
        ], 10, yR),
        e.multiple ? K("", !0) : (k(), A("button", {
          key: 0,
          type: "button",
          class: "flex items-center justify-center h-6 w-7 rounded shrink-0 bg-blue-100 hover:bg-blue-200 focus:bg-blue-200 focus:outline-none transition ease-out duration-200",
          onClick: t[4] || (t[4] = Ge((d) => {
            var u;
            return (u = e.fileInput) == null ? void 0 : u.click();
          }, ["prevent"]))
        }, [
          fe(a, {
            name: "sync-alt",
            class: "text-blue-700"
          })
        ]))
      ]),
      _: 1
    }, 8, ["files", "class"])) : K("", !0)
  ]);
}
const YV = /* @__PURE__ */ Je(cR, [["render", bR]]), $R = { class: "relative" }, wR = ["value"], KV = /* @__PURE__ */ $e({
  __name: "DsFormattedNumberInput",
  props: {
    modelValue: {},
    showZero: { type: Boolean },
    withFractions: { type: Boolean },
    suffix: { default: "" },
    suffixCallback: { type: Function, default: (e, t) => t },
    disabled: { type: Boolean },
    maxDigits: { default: 14 },
    defaultValue: { default: 0 },
    size: { default: "base" },
    placeholder: { default: null },
    lazy: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = q(null);
    ot(() => {
      var f, h, p;
      (f = i.value) == null || f.input.setAttribute(
        "inputmode",
        n.withFractions ? "decimal" : "numeric"
      ), (h = i.value) == null || h.input.setAttribute(
        "android:inputType",
        n.withFractions ? "numberDecimal" : "number"
      ), (p = i.value) == null || p.input.setAttribute(
        "android:digits",
        n.withFractions ? "0123456789,." : "0123456789"
      );
    });
    const o = new Intl.NumberFormat("de-DE", {
      style: "decimal",
      minimumFractionDigits: n.withFractions ? 2 : 0,
      maximumFractionDigits: n.withFractions ? 2 : 0
    }), a = q(!1), s = E({
      get: () => {
        let f = "0";
        return n.modelValue !== null && (f = n.modelValue.toString()), f === "0" && !n.showZero && (f = ""), f = f.replace(".", ","), f;
      },
      set: (f) => {
        var p, m;
        let h = n.defaultValue;
        if (typeof f == "string") {
          if (i.value === null)
            return;
          const { input: g } = i.value;
          let v = f.replace(/[^\d,]/, ""), b = null;
          f.charAt(0) === "," && (v = `0${f}`);
          const x = (m = (p = v.match(/^-?\d+(?:,\d{0,2})?/)) == null ? void 0 : p[0]) != null ? m : "";
          g.value !== x && (b = g.selectionStart === 0 || g.selectionStart === null ? 0 : g.selectionStart - 1), g.value = x, b !== null && i.value.input.setSelectionRange(b, b), x !== "" && (h = Number(x.replace(",", ".")));
        }
        r("update:modelValue", h);
      }
    }), l = E(() => {
      var p;
      const f = Number(s.value.replace(",", ".")), h = o.format(f);
      return f !== 0 && n.suffix === "" ? h : f === 0 && !n.showZero ? (p = n.placeholder) != null ? p : n.suffix : n.suffixCallback(
        f,
        n.suffix ? `${h} ${n.suffix}` : h
      );
    }), d = (f) => {
      var U;
      const { data: h, inputType: p } = f, m = f.target;
      if (["deleteContentBackward", "deleteContentForward"].includes(p))
        return !0;
      if (f.isComposing)
        return f.preventDefault(), !1;
      const g = h !== null && h >= "0" && h <= "9", v = h === ".", b = h === "," || v;
      if (!g && !b)
        return f.preventDefault(), !1;
      const x = m.value, y = x.indexOf(","), C = y >= 0, $ = x.substring(0, C ? y : void 0).length, O = n.maxDigits === null || $ < n.maxDigits || m.selectionStart === 0 && m.selectionEnd === m.value.length, z = g && O && (!C || y + 3 !== x.length || ((U = m.selectionStart) != null ? U : 0) <= y), P = b && n.withFractions && y === -1 && x.length > 0;
      return P && v ? (f.preventDefault(), f.target.value += ",", !1) : z || P ? !0 : (f.preventDefault(), !1);
    }, u = (f) => {
      var x, y;
      f.preventDefault();
      const h = f.clipboardData || window.clipboardData;
      if (h == null || i.value == null)
        return;
      const p = h.getData("Text").replace(/[^0-9,]/gi, ""), m = (x = i.value.input.selectionStart) != null ? x : 0, g = (y = i.value.input.selectionEnd) != null ? y : m;
      let v = p;
      if (m) {
        const C = s.value.slice(0, m), $ = s.value.slice(g);
        v = `${C}${p}${$}`;
      }
      const b = v.indexOf(",");
      b >= 0 && (v = n.withFractions ? v.slice(0, b + 3) : v.slice(0, b)), s.value = v;
    }, c = E(() => [n.suffix, n.placeholder].includes(l.value));
    return (f, h) => (k(), A("div", $R, [
      fe(pa, {
        ref_key: "inputRef",
        ref: i,
        modelValue: s.value,
        "onUpdate:modelValue": h[0] || (h[0] = (p) => s.value = p),
        disabled: f.disabled,
        size: f.size,
        immediate: !f.lazy,
        onFocus: h[1] || (h[1] = (p) => a.value = !0),
        onBlur: h[2] || (h[2] = (p) => a.value = !1),
        onBeforeinput: d,
        onPaste: u
      }, null, 8, ["modelValue", "disabled", "size", "immediate"]),
      Jt(G("input", {
        class: te(["whitespace-nowrap w-full leading-5 min-w-0 rounded absolute top-0 left-0 border", {
          [D(ml)[f.size]]: !0,
          "text-gray-300": c.value,
          "text-gray-900": !c.value,
          "bg-gray-100 text-gray-500 border-gray-200 focus:outline-none": f.disabled,
          "bg-white border-gray-300 pointer-events-none": !f.disabled
        }]),
        type: "text",
        readonly: "",
        value: l.value,
        tabindex: "-1"
      }, null, 10, wR), [
        [Cn, !a.value]
      ])
    ]));
  }
}), Py = Symbol("IntroTour"), kR = (e) => {
  mr(Py, e);
}, Ny = () => Zn(Py), xR = (e) => {
  const { body: t } = document, n = document.documentElement, r = window.pageYOffset || n.scrollTop || t.scrollTop, i = window.pageXOffset || n.scrollLeft || t.scrollLeft, o = e.getBoundingClientRect();
  return {
    top: o.top + r,
    width: o.width,
    height: o.height,
    left: o.left + i
  };
}, SR = $e({
  name: "DsIntroTour",
  components: {
    DsButton: gr
  },
  inheritAttrs: !1,
  props: {
    label: {
      type: String,
      default: ""
    },
    steps: {
      type: Array,
      default: () => []
    },
    startOnLoad: {
      type: Boolean
    }
  },
  emits: ["reset", "start", "end"],
  setup(e, t) {
    const n = il({}), r = E(() => e.steps.filter(($) => $ in n.value)), i = q(""), o = E(() => r.value.indexOf(i.value)), a = E(() => i.value !== ""), s = q(), l = E(() => {
      if (s.value === void 0)
        return 0;
      const $ = getComputedStyle(s.value);
      return parseFloat($.transitionDuration) * 1e3;
    }), d = () => {
      t.emit("start"), t.emit("reset"), i.value = r.value[0] || "";
    }, u = () => {
      i.value = "", t.emit("reset"), t.emit("end");
    }, c = ($) => {
      const O = Math.max(0, Math.min(r.value.length, o.value + $));
      if (O === r.value.length) {
        u();
        return;
      }
      i.value = r.value[O];
    };
    e.startOnLoad && ot(d);
    const f = q("");
    kR({
      activeStep: f,
      registerStep($) {
        n.value = { ...n.value, [$.name]: $ };
      },
      unregisterStep($) {
        const { [$]: O, ...z } = n.value;
        n.value = z;
      },
      start: d
    });
    const h = q(), p = q(), m = () => {
      p.value !== void 0 && (p.value.destroy(), p.value = void 0);
    };
    bo(m);
    const g = E(() => n.value[i.value]), v = q({
      top: void 0,
      left: void 0,
      width: void 0,
      height: void 0
    });
    Fe(
      [f, h],
      ([$, O]) => {
        if ($ === "") {
          m();
          return;
        }
        const z = n.value[$].element.value;
        O === void 0 || z === void 0 || (p.value !== void 0 && p.value.destroy(), p.value = lf(z, O, {
          placement: n.value[$].placement,
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 20]
              }
            }
          ]
        }));
      },
      {
        // Wait for template refs to update
        flush: "post"
      }
    );
    const b = E(() => {
      var $;
      return ($ = g.value) == null ? void 0 : $.element.value;
    });
    Fe(i, ($) => {
      $ === "" && (v.value = {
        top: void 0,
        left: void 0,
        width: void 0,
        height: void 0
      });
    });
    const x = bp(() => {
      const $ = b.value;
      if ($ == null)
        return;
      const O = xR($);
      v.value = {
        top: `calc(${O.top}px - var(--overlay-offset, 0))`,
        left: `calc(${O.left}px - var(--overlay-offset, 0))`,
        width: `calc(${O.width}px + 2 * var(--overlay-offset, 0))`,
        height: `calc(${O.height}px + 2* var(--overlay-offset, 0))`
      };
    });
    Fe(v, async () => {
      var $;
      await (($ = p.value) == null ? void 0 : $.update());
    }), $0(b, x);
    const y = q();
    T5(y, x, {
      attributes: !0,
      characterData: !0,
      childList: !0,
      subtree: !0
    });
    const C = P5();
    return Fe(() => C, x, { deep: !0 }), Fe([i, () => C], bp(([$]) => {
      f.value = "", $ !== "" && setTimeout(() => {
        f.value = $;
      }, l.value);
    }), { deep: !0 }), {
      isActive: a,
      hasHighlightedStep: E(() => f.value !== ""),
      activeStep: g,
      container: y,
      popover: h,
      stopTour: u,
      previous() {
        c(-1);
      },
      next() {
        c(1);
      },
      hasPrevious: E(() => o.value > 0),
      hasNext: E(() => o.value < r.value.length - 1),
      overlay: s,
      overlayStyle: v
    };
  }
}), CR = "_overlay_1j79s_2", TR = {
  overlay: CR
}, MR = {
  key: 0,
  style: { zIndex: 995 },
  class: "fixed inset-0"
}, OR = { class: "absolute inset-0 text-center" }, ER = {
  style: { zIndex: 1e3 },
  class: "p-3 bg-gray-800 text-gray-200 rounded-b-md inline-block text-left space-y-2 whitespace-nowrap shadow-lg"
}, DR = { class: "flex items-center justify-between space-x-6" }, AR = {
  key: 0,
  class: "font-semibold text-lg"
}, PR = { class: "flex items-center space-x-3" }, NR = { class: "font-semibold text-xs w-1/3" }, IR = { class: "bg-gray-900 rounded-full h-2 grow p-px" }, RR = {
  key: 0,
  ref: "popover"
}, _R = { class: "bg-white p-4 shadow-lg rounded-lg space-y-4 max-w-sm" }, LR = { class: "flex items-end justify-between space-x-6" };
function FR(e, t, n, r, i, o) {
  const a = Be("DsButton");
  return k(), A(Ie, null, [
    e.isActive ? (k(), A("div", MR, [
      G("div", OR, [
        G("div", ER, [
          G("div", DR, [
            e.label.length > 0 ? (k(), A("span", AR, Te(e.label), 1)) : K("", !0),
            fe(a, {
              variant: "secondary",
              icon: "ban",
              onClick: e.stopTour
            }, {
              default: de(() => [
                it(" Abbrechen ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          G("div", PR, [
            G("span", NR, " Schritt " + Te(e.steps.indexOf(e.activeStep.name) + 1) + " von " + Te(e.steps.length), 1),
            G("div", IR, [
              G("div", {
                style: mt({ width: `${(e.steps.indexOf(e.activeStep.name) + 1) / e.steps.length * 100}%` }),
                class: "rounded-full bg-blue-500 h-full transition-all duration-200"
              }, null, 4)
            ])
          ])
        ])
      ]),
      e.hasHighlightedStep ? (k(), A("div", RR, [
        G("div", _R, [
          G("div", null, [
            (k(), ge(Qn(e.activeStep.description)))
          ]),
          G("div", LR, [
            G("div", null, [
              e.hasPrevious ? (k(), ge(a, {
                key: 0,
                icon: "arrow-left",
                variant: "secondary",
                onClick: e.previous
              }, null, 8, ["onClick"])) : K("", !0)
            ]),
            G("div", null, [
              fe(a, {
                icon: e.activeStep.isLocked.value ? "lock" : e.hasNext ? "arrow-right" : "check",
                "icon-align": "right",
                disabled: e.activeStep.isLocked.value,
                onClick: e.next
              }, {
                default: de(() => [
                  it(Te(e.hasNext ? "Weiter" : "Fertig"), 1)
                ]),
                _: 1
              }, 8, ["icon", "disabled", "onClick"])
            ])
          ])
        ])
      ], 512)) : K("", !0)
    ])) : K("", !0),
    G("div", $t({ ref: "container" }, e.$attrs), [
      se(e.$slots, "default")
    ], 16),
    (k(), ge(ca, { to: "body" }, [
      fe(ur, {
        "enter-active-class": "duration-75",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "duration-75",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: de(() => [
          e.isActive ? (k(), A("div", {
            key: 0,
            ref: "overlay",
            style: mt(e.overlayStyle),
            class: te([e.$style.overlay, "absolute rounded-xl duration-300 ease-in-out"])
          }, null, 6)) : K("", !0)
        ]),
        _: 1
      })
    ]))
  ], 64);
}
const BR = {
  $style: TR
}, GV = /* @__PURE__ */ Je(SR, [["render", FR], ["__cssModules", BR]]), zR = $e({
  name: "DsIntroTourButton",
  components: {
    DsButton: gr
  },
  setup() {
    const e = Ny();
    if (e === void 0)
      throw new Error("No IntroTourState provided");
    return {
      startTour: () => e.start()
    };
  }
});
function VR(e, t, n, r, i, o) {
  const a = Be("DsButton");
  return k(), ge(a, {
    variant: "outline",
    icon: "graduation-cap",
    onClick: e.startTour
  }, {
    default: de(() => [
      it(" Einführung starten ")
    ]),
    _: 1
  }, 8, ["onClick"]);
}
const JV = /* @__PURE__ */ Je(zR, [["render", VR]]), HR = $e({
  name: "DsIntroTourStep",
  props: {
    name: {
      type: String,
      required: !0
    },
    /**
     * The placement relative to the highlighted area.
     * This property is not reactive (the popup won't move upon change).
     */
    placement: {
      type: String,
      default: "bottom"
    },
    isLocked: {
      type: Boolean
    }
  },
  setup(e, t) {
    const n = q(), r = E(() => e.isLocked), i = Ny();
    if (i === void 0)
      throw new Error("No IntroTourState provided");
    return Fe(() => e.name, (a, s, l) => {
      const { description: d } = t.slots;
      if (d === void 0) {
        console.warn("Skipping step due to missing description slot");
        return;
      }
      i.registerStep({
        name: a,
        element: n,
        placement: e.placement,
        description: d,
        isLocked: r
      }), l(() => {
        i.unregisterStep(a);
      });
    }, { immediate: !0 }), {
      isActive: E(() => e.name === i.activeStep.value),
      element: n
    };
  }
});
function jR(e, t, n, r, i, o) {
  return k(), A("div", {
    ref: "element",
    style: mt({ zIndex: e.isActive ? 999 : void 0 }),
    class: te({ relative: e.isActive })
  }, [
    se(e.$slots, "default")
  ], 6);
}
const XV = /* @__PURE__ */ Je(HR, [["render", jR]]), Iy = Symbol("List"), WR = (e) => {
  mr(Iy, e);
}, UR = () => Zn(Iy), qR = $e({
  name: "DsList",
  props: {
    // eslint-disable-next-line vue/no-unused-properties
    icon: {
      type: String,
      default: "long-arrow-right"
    },
    // eslint-disable-next-line vue/no-unused-properties
    treeView: {
      type: Boolean
    }
  },
  setup(e) {
    WR(e);
  }
}), YR = "_tree_1vcol_2", KR = {
  tree: YR
};
function GR(e, t, n, r, i, o) {
  return k(), A("ul", {
    class: te(["space-y-1", { [e.$style.tree]: e.treeView }])
  }, [
    se(e.$slots, "default")
  ], 2);
}
const JR = {
  $style: KR
}, QV = /* @__PURE__ */ Je(qR, [["render", GR], ["__cssModules", JR]]), XR = $e({
  name: "DsListItem",
  components: {
    DsIcon: Ue
  },
  props: {
    icon: {
      type: String,
      default: ""
    },
    iconClass: {
      type: String,
      default: "text-blue-700"
    }
  },
  setup(e) {
    const t = UR();
    if (t === void 0)
      throw new Error("No ListState provided");
    return {
      validIcon: E(() => e.icon || t.icon),
      treeView: E(() => t.treeView)
    };
  }
});
function QR(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), A("li", {
    class: te(["flex space-x-2 items-center", {
      "ml-10": e.treeView
    }])
  }, [
    e.treeView ? K("", !0) : (k(), ge(a, {
      key: 0,
      name: e.validIcon,
      class: te(e.iconClass),
      "fixed-width": ""
    }, null, 8, ["name", "class"])),
    se(e.$slots, "default")
  ], 2);
}
const ZV = /* @__PURE__ */ Je(XR, [["render", QR]]), ZR = $e({
  name: "DsListItemGroup",
  components: { DsButton: gr },
  props: {
    label: {
      type: String,
      default: ""
    }
  },
  setup() {
    const e = q(!1), t = E(() => e.value ? "chevron-down" : "chevron-right"), n = (i) => {
      e.value = i;
    };
    return {
      isOpen: e,
      toggleIcon: t,
      toggleNextLevel: () => {
        n(!e.value);
      },
      setOpen: n
    };
  }
}), e_ = {
  "item-group": "_item-group_1gki2_2",
  "group-label": "_group-label_1gki2_15"
}, t_ = { class: "flex items-center" }, n_ = { class: "flex items-center space-x-2 w-full" }, r_ = ["textContent"], i_ = {
  key: 0,
  class: "block relative"
};
function o_(e, t, n, r, i, o) {
  const a = Be("DsButton");
  return k(), A("li", {
    class: te(["relative", {
      [e.$style["item-group"]]: e.isOpen,
      [e.$style["group-label"]]: !0
    }])
  }, [
    G("div", t_, [
      fe(a, {
        variant: "outline",
        icon: e.toggleIcon,
        size: "sm",
        class: "p-3",
        onClick: e.toggleNextLevel
      }, null, 8, ["icon", "onClick"]),
      G("div", n_, [
        se(e.$slots, "title", {
          toggle: e.setOpen,
          isOpen: e.isOpen
        }, () => [
          G("span", {
            class: "cursor-pointer",
            onClick: t[0] || (t[0] = (...s) => e.toggleNextLevel && e.toggleNextLevel(...s)),
            textContent: Te(e.label)
          }, null, 8, r_)
        ])
      ])
    ]),
    e.isOpen ? (k(), A("ul", i_, [
      se(e.$slots, "default")
    ])) : K("", !0)
  ], 2);
}
const a_ = {
  $style: e_
}, eH = /* @__PURE__ */ Je(ZR, [["render", o_], ["__cssModules", a_]]), s_ = $e({
  name: "DsListCard",
  props: {
    centerItems: {
      type: Boolean
    },
    rounded: {
      type: Boolean
    },
    withBorder: {
      type: Boolean
    }
  },
  setup(e, { slots: t }) {
    return {
      slots: t
    };
  }
}), l_ = {
  key: 0,
  class: "mr-2"
}, d_ = {
  key: 1,
  class: "flex-1"
}, u_ = {
  key: 2,
  class: "ml-auto md:flex md:items-center"
};
function c_(e, t, n, r, i, o) {
  return k(), A("article", {
    class: te(["bg-white flex p-2", {
      "items-center": e.centerItems,
      rounded: e.rounded,
      "border border-gray-200": e.withBorder
    }])
  }, [
    e.slots.left !== void 0 ? (k(), A("div", l_, [
      se(e.$slots, "left")
    ])) : K("", !0),
    e.slots.content !== void 0 ? (k(), A("div", d_, [
      se(e.$slots, "content")
    ])) : K("", !0),
    e.slots.right !== void 0 ? (k(), A("div", u_, [
      se(e.$slots, "right")
    ])) : K("", !0)
  ], 2);
}
const tH = /* @__PURE__ */ Je(s_, [["render", c_]]);
var jo = /* @__PURE__ */ ((e) => (e.Info = "info", e.Success = "success", e.Warning = "warning", e.Error = "error", e))(jo || {});
const f_ = {
  [jo.Info]: "bg-blue-100 text-blue-700",
  [jo.Success]: "bg-green-100 text-green-700",
  [jo.Warning]: "bg-orange-100 text-orange-700",
  [jo.Error]: "bg-red-100 text-red-700"
}, yi = () => {
}, p_ = $e({
  name: "DsModal",
  components: {
    DsButton: gr,
    DsIcon: Ue
  },
  props: {
    show: {
      type: Boolean
    },
    icon: {
      type: String,
      default: "",
      required: !1
    },
    overflow: {
      type: String,
      default: "hidden",
      required: !1
    },
    variant: {
      type: String,
      default: jo.Info
      // validator
    },
    title: {
      type: String,
      default: ""
    },
    /**
     * The label placed on the confirm button (usually the primary action).
     *
     * Ignored when overwriting the footer slot.
     */
    confirmLabel: {
      type: String,
      default: "OK"
    },
    confirmDisabled: {
      type: Boolean
    },
    /**
     * Only shows a single, primary button with the contents of "cancelLabel".
     *
     * Ignored when overwriting the footer slot.
     */
    cancelOnly: {
      type: Boolean
    },
    /**
     * The label placed on the cancel button (usually the secondary action).
     *
     * Ignored when overwriting the footer slot.
     */
    cancelLabel: {
      type: String,
      default: "Schließen"
    },
    cancelDisabled: {
      type: Boolean
    },
    /**
     * Indicates that clicking outside (or by pressing ESC) should not
     * close the modal by choosing the "cancel" action by default.
     */
    actionRequired: {
      type: Boolean
    },
    size: {
      type: String,
      default: "sm"
    },
    anchor: {
      type: String,
      default: void 0
    },
    /**
     * The modal content usually gets some text formatting
     * classes applied. Use this flag to disable the defaults
     * (works like a reset).
     */
    customContent: {
      type: Boolean
    },
    hideButtons: {
      type: Boolean
    }
  },
  emits: ["cancel", "close", "confirm"],
  setup(e, t) {
    const n = q(), r = () => {
      t.emit("cancel"), t.emit("close");
    }, i = [
      "overflow-hidden",
      "overflow-auto",
      "overflow-visible",
      "overflow-scroll",
      "overflow-x-auto",
      "overflow-y-auto",
      "overflow-x-hidden",
      "overflow-y-hidden",
      "overflow-overflow-x-clip",
      "overflow-y-clip",
      "overflow-x-visible",
      "overflow-y-visible",
      "overflow-x-scroll",
      "overflow-y-scroll"
    ], o = E(() => `overflow-${e.overflow}`), a = E(() => VS(i, (h) => h === o.value) !== -1), s = q(!1), l = E(() => e.show || s.value), d = q(yi), u = q(yi), c = () => {
      s.value = !1;
    };
    x5(l, () => {
      var h;
      (h = n.value) == null || h.focus();
    });
    const f = () => {
      e.confirmDisabled || (t.emit("confirm"), t.emit("close"));
    };
    return {
      wrapper: n,
      shouldShow: l,
      overflowClass: o,
      isAllowedOverflow: a,
      hasIcon: E(() => e.icon !== ""),
      iconClasses: E(() => f_[e.variant]),
      cancelWhenOptional() {
        e.actionRequired || r();
      },
      confirmWhenOptional() {
        !e.actionRequired && !e.cancelOnly && f();
      },
      confirm: f,
      cancel: r,
      confirmHandler: d,
      cancelHandler: u,
      open(h = {}) {
        return l.value && c(), new Promise((p) => {
          d.value = h.confirmed === void 0 && h.always === void 0 ? c : async () => {
            await Promise.all([
              (h.confirmed || yi)(),
              (h.always || yi)()
            ]), c();
          }, u.value = h.aborted === void 0 && h.always === void 0 ? c : async () => {
            await Promise.all([
              (h.aborted || yi)(),
              (h.always || yi)()
            ]), c();
          }, s.value = !0;
          const m = Fe(s, () => {
            d.value = yi, u.value = yi, m(), p();
          });
        });
      }
    };
  }
}), h_ = { class: "flex items-end justify-center min-h-dvh text-center sm:block" }, m_ = {
  key: 0,
  class: "fixed inset-0 transition-opacity",
  "aria-hidden": "true"
}, g_ = {
  key: 0,
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, v_ = { class: "sm:flex sm:items-start" }, y_ = ["textContent"], b_ = {
  key: 0,
  class: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"
};
function $_(e, t, n, r, i, o) {
  const a = Be("DsIcon"), s = Be("DsButton");
  return k(), ge(ca, { to: "body" }, [
    G("div", {
      ref: "wrapper",
      class: te(["fixed inset-0 overflow-y-auto focus:outline-none z-[999]", {
        "pointer-events-auto": e.shouldShow,
        "pointer-events-none": !e.shouldShow
      }]),
      tabindex: "-1",
      onKeyup: [
        t[1] || (t[1] = Re(Ge((...l) => e.cancelWhenOptional && e.cancelWhenOptional(...l), ["exact"]), ["esc"])),
        t[2] || (t[2] = Re(Ge((...l) => e.confirmWhenOptional && e.confirmWhenOptional(...l), ["exact"]), ["enter"]))
      ]
    }, [
      G("div", h_, [
        fe(ur, {
          "enter-active-class": "ease-out duration-150",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "ease-in duration-75",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: de(() => [
            e.shouldShow ? (k(), A("div", m_, [
              G("div", {
                class: "absolute inset-0 bg-gray-500/75",
                onClick: t[0] || (t[0] = (...l) => e.cancelWhenOptional && e.cancelWhenOptional(...l))
              })
            ])) : K("", !0)
          ]),
          _: 1
        }),
        e.anchor !== "top" ? (k(), A("span", g_, "​")) : K("", !0),
        fe(ur, {
          "enter-active-class": "ease-out duration-150",
          "enter-from-class": "opacity-0 scale-95",
          "enter-to-class": "opacity-100 scale-100",
          "leave-active-class": "ease-in duration-75",
          "leave-from-class": "opacity-100 scale-100",
          "leave-to-class": "opacity-0 scale-95"
        }, {
          default: de(() => [
            e.shouldShow ? (k(), A("div", {
              key: 0,
              class: te([{
                "sm:max-w-lg": e.size === "sm",
                "sm:max-w-3xl": e.size === "md",
                "sm:max-w-5xl": e.size === "lg",
                [e.overflowClass]: e.isAllowedOverflow
              }, "inline-block align-bottom bg-white rounded-b-none rounded-t-lg sm:rounded-lg px-4 py-5 sm:p-6 mt-8 sm:mb-8 text-left shadow-xl transform transition-all sm:align-middle w-full"]),
              role: "dialog",
              "aria-modal": "true"
            }, [
              G("div", v_, [
                e.hasIcon ? (k(), A("div", {
                  key: 0,
                  class: te([e.iconClasses, "mx-auto shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-12 sm:w-12"])
                }, [
                  fe(a, {
                    name: e.icon,
                    size: "lg",
                    variant: "regular",
                    "fixed-width": ""
                  }, null, 8, ["name"])
                ], 2)) : K("", !0),
                G("div", {
                  class: te([e.hasIcon ? "mt-4 sm:mt-0 sm:ml-5 " : "", "grow max-w-full"])
                }, [
                  e.title !== "" ? (k(), A("h3", {
                    key: 0,
                    class: "text-xl text-center sm:text-left leading-6 font-bold text-gray-900 mb-2",
                    textContent: Te(e.title)
                  }, null, 8, y_)) : K("", !0),
                  G("div", {
                    class: te({ "text-sm text-gray-700 text-center sm:text-left": !e.customContent })
                  }, [
                    se(e.$slots, "default")
                  ], 2)
                ], 2)
              ]),
              e.hideButtons ? K("", !0) : (k(), A("div", b_, [
                e.cancelOnly ? K("", !0) : (k(), ge(s, {
                  key: 0,
                  size: "lg",
                  class: "w-full sm:ml-3 sm:w-auto",
                  variant: e.variant === "error" ? "danger" : "primary",
                  handler: e.confirmHandler,
                  disabled: e.confirmDisabled,
                  onClick: e.confirm
                }, {
                  default: de(() => [
                    it(Te(e.confirmLabel), 1)
                  ]),
                  _: 1
                }, 8, ["variant", "handler", "disabled", "onClick"])),
                fe(s, {
                  class: te(["w-full sm:w-auto", e.cancelOnly ? "" : "mt-3 sm:mt-0"]),
                  size: "lg",
                  variant: e.cancelOnly ? "primary" : "secondary",
                  handler: e.cancelHandler,
                  disabled: e.cancelDisabled,
                  onClick: e.cancel
                }, {
                  default: de(() => [
                    it(Te(e.cancelLabel), 1)
                  ]),
                  _: 1
                }, 8, ["class", "variant", "handler", "disabled", "onClick"]),
                se(e.$slots, "buttons")
              ]))
            ], 2)) : K("", !0)
          ]),
          _: 3
        })
      ])
    ], 34)
  ]);
}
const nH = /* @__PURE__ */ Je(p_, [["render", $_]]), w_ = $e({
  name: "DsTag",
  components: {
    DsIcon: Ue
  },
  props: {
    icon: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    closeable: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["close"],
  setup(e, t) {
    return {
      close(n) {
        t.emit("close", n);
      }
    };
  }
}), k_ = { class: "inline-flex overflow-x-hidden" }, x_ = ["disabled"];
function S_(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), A("span", {
    class: te([{
      "text-blue-700 border-blue-300": !e.disabled,
      "text-gray-500 border-gray-200": e.disabled
    }, "rounded p-px border inline-flex h-6 text-sm whitespace-nowrap bg-white overflow-x-hidden"])
  }, [
    e.icon !== "" || e.category !== "" ? (k(), A("span", {
      key: 0,
      class: te([{
        "bg-blue-100": !e.disabled,
        "bg-gray-100": e.disabled
      }, "space-x-1.5 rounded px-1.5 font-semibold"])
    }, [
      e.icon !== "" ? (k(), ge(a, {
        key: 0,
        name: e.icon,
        class: te({
          "text-blue-500": !e.disabled,
          "text-gray-300": e.disabled
        })
      }, null, 8, ["name", "class"])) : K("", !0),
      it(" " + Te(e.category), 1)
    ], 2)) : K("", !0),
    G("span", k_, [
      G("span", {
        class: te(e.closeable ? "pl-1.5 pr-0.5 text-ellipsis overflow-x-hidden" : "px-1.5")
      }, [
        se(e.$slots, "default", {}, () => [
          it(Te(e.label), 1)
        ])
      ], 2),
      e.closeable ? (k(), A("button", {
        key: 0,
        type: "button",
        class: te([{
          "text-blue-500 hover:border-blue-200": !e.disabled,
          "text-gray-300 cursor-not-allowed": e.disabled
        }, "px-1.5 border border-transparent focus:outline-none rounded focus:border-blue-300 leading-none"]),
        disabled: e.disabled,
        onClick: t[0] || (t[0] = (...s) => e.close && e.close(...s))
      }, [
        fe(a, {
          name: "xmark",
          variant: "regular"
        })
      ], 10, x_)) : K("", !0)
    ])
  ], 2);
}
const rm = /* @__PURE__ */ Je(w_, [["render", S_]]);
var el = /* @__PURE__ */ ((e) => (e.INVALID_FORMAT = "INVALID_FORMAT", e))(el || {});
function C_(e, t, n) {
  return yn(e) && n in e && t in e;
}
function im(e, t) {
  const n = e.search.indexOf(` ${t}`) !== -1, r = e.search.startsWith(t);
  let i = 1;
  return r ? i = 3 : n && (i = 2), t.length / e.search.length * i;
}
function Ry(e, t, n) {
  const r = e.trim().toLowerCase();
  return t.map((s) => {
    var u, c, f;
    let l = "";
    if (yn(s)) {
      const h = (u = n == null ? void 0 : n.searchKeys) != null ? u : [];
      if (h.length === 0)
        throw new Error("objectKey is required when the item is an object");
      l = h.map((p) => `${cl(s, p)}`).reduce((p, m) => p === "" ? m : `${p} ${m}`, "");
    } else YS(s) && (l = s);
    l = (c = l.toLowerCase()) != null ? c : "";
    const d = (f = l.indexOf(r)) != null ? f : -1;
    return {
      item: s,
      index: d,
      search: l
    };
  }).filter(
    (s) => s.index !== -1
  ).sort((s, l) => {
    const d = im(s, r);
    return im(l, r) - d;
  }).map((s) => s.item);
}
const T_ = { class: "flex flex-row flex-wrap grow overflow-x-hidden" }, M_ = ["disabled", "onKeydown"], O_ = {
  key: 0,
  class: "m-1.5 mb-0.5 text-sm text-center text-gray-500"
}, E_ = ["data-test"], D_ = { class: "shrink-0 w-5 text-gray-500" }, A_ = ["textContent"], P_ = {
  key: 0,
  class: "m-1.5 text-sm text-center text-gray-500"
}, rH = /* @__PURE__ */ $e({
  __name: "DsMultiselect",
  props: /* @__PURE__ */ rc({
    options: { default: () => [] },
    maxVisibleSelections: { default: 0 },
    validation: { type: Function, default: () => !0 },
    itemBlueprint: { type: Function, default: (e) => e },
    allowNewOptions: { type: Boolean },
    noOptionsText: { default: "Keine Einträge verfügbar" },
    allowNewOptionsText: { default: "Tippen um neuen Eintrag hinzuzufügen" },
    newOptionGroup: { default: void 0 },
    validationFailedMsg: { default: null },
    objectAsValue: { type: Boolean },
    valueKey: { default: "value" },
    labelKey: { default: "label" },
    groupKey: { default: void 0 },
    groupKeyOrder: { default: () => [] },
    searchKeys: { default: () => [] },
    disabled: { type: Boolean },
    isLoading: { type: Boolean },
    id: { default: void 0 },
    virtualized: { type: Boolean },
    itemHeight: { default: 0 }
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const { INVALID_FORMAT: t } = el, n = e, r = zm(e, "modelValue"), i = E(() => n.valueKey.toString()), o = E(() => n.labelKey.toString()), a = E(() => (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      new Set(n.options.map((_) => _[i.value]))
    )), s = E(() => n.objectAsValue ? r.value.filter((_) => !a.value.has(_[i.value])) : []), l = (_, T) => C_(_, i.value, o.value) ? _[i.value] === T[i.value] : _ === T[i.value], d = (_) => r.value.some(
      (T) => l(T, _)
    ), u = (_) => {
      const T = r.value.findIndex(
        (M) => l(M, _)
      );
      T !== -1 && (r.value = r.value.slice(0, T).concat(r.value.slice(T + 1)));
    }, c = (_) => {
      if (d(_)) {
        u(_);
        return;
      }
      r.value = [
        ...r.value,
        n.objectAsValue ? _ : _[i.value]
      ];
    }, f = () => {
      r.value = r.value.slice(0, -1);
    }, h = E(() => [
      ...s.value,
      ...n.options
    ].filter(
      (_) => r.value.some((T) => l(T, _))
    ).slice(0, n.maxVisibleSelections > 0 ? n.maxVisibleSelections : r.value.length)), p = E(() => n.maxVisibleSelections > 0 ? r.value.length - n.maxVisibleSelections : 0), m = q(""), g = q(), v = async () => {
      var _;
      await an(), (_ = g.value) == null || _.focus();
    }, b = async () => {
      m.value === "" && f(), await v();
    }, x = () => {
      m.value = "";
    }, y = q(null), C = E(() => m.value.length === 0 ? n.options : Ry(m.value, n.options, {
      searchKeys: [
        ...n.searchKeys,
        o.value
      ]
    })), $ = E(() => {
      var M;
      if (!n.allowNewOptions || m.value === "" || ((M = C.value[0]) == null ? void 0 : M[o.value]) === m.value || n.options.some(
        (V) => V[i.value] === m.value
      ))
        return null;
      const T = {
        [o.value]: m.value,
        [i.value]: n.itemBlueprint(m.value)
      };
      return n.newOptionGroup !== void 0 && (T.group = n.newOptionGroup), n.validation(m.value) || (T[i.value] = el.INVALID_FORMAT), T;
    }), O = E(() => $.value !== null), z = E(() => {
      const _ = C.value;
      return O.value && $.value !== null && _.unshift($.value), _;
    }), P = async (_) => {
      if (_ == null || _ < 0)
        return;
      Object.values(el).includes(z.value[_][i.value].toString()) || (c(z.value[_]), x()), await v();
    }, U = (_, T) => {
      _ || (y.value && y.value.toggle(), T.stopPropagation(), T.preventDefault());
    }, {
      ignoreUpdates: ie
    } = k5(m, () => {
      y.value && !y.value.isOpen && y.value.toggle();
    }), W = async (_, T) => {
      u(T), await v();
    }, H = () => {
      m.value !== "" && ie(() => {
        n.allowNewOptions && n.validation(m.value) ? P(0) : x();
      });
    };
    return (_, T) => {
      var M;
      return k(), ge(Cd, {
        id: _.id,
        ref_key: "dropdown",
        ref: y,
        "button-class": {
          "w-full flex items-left text-left rounded sm:text-sm sm:leading-5 shadow-sm border relative": !0,
          "bg-white border-gray-300 focus-within:border-blue-500 cursor-pointer focus-within:shadow-outline-blue": !_.disabled,
          "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed": (M = _.disabled) != null ? M : !1
        },
        items: z.value,
        disabled: _.disabled || _.isLoading,
        "list-class": "m-1",
        "item-class": "px-2 rounded-sm",
        "scroll-y-margin": 4,
        "group-key": _.groupKey,
        "group-key-order": _.groupKeyOrder,
        "item-height": _.itemHeight,
        virtualized: _.virtualized,
        "preselect-first-value": "",
        "keep-open-on-select": "",
        unfocusable: "",
        onSelect: P,
        onOpen: v,
        onClose: H,
        onKeydown: T[2] || (T[2] = Re(Ge((V) => m.value += " ", ["prevent"]), ["space"]))
      }, {
        button: de(({ isOpen: V }) => [
          G("div", {
            class: te([{ "cursor-not-allowed": _.disabled }, "focus:outline-none w-full flex items-start align-end pr-2 pl-0.5"])
          }, [
            fe($s, {
              "is-loading": _.isLoading,
              class: "text-lg"
            }, null, 8, ["is-loading"]),
            G("span", T_, [
              (k(!0), A(Ie, null, Ze(h.value, (Q) => (k(), ge(rm, {
                key: Q[o.value],
                disabled: _.disabled,
                title: Q[o.value],
                class: "m-0.5",
                closeable: "",
                "data-test": `taglist-item-${Q[i.value]}`,
                onClose: Ge((ue) => W(V, Q), ["stop"])
              }, {
                default: de(() => [
                  it(Te(Q[o.value]), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "title", "data-test", "onClose"]))), 128)),
              p.value > 0 ? (k(), ge(rm, {
                key: 0,
                disabled: "",
                class: "bg-gray-200 m-0.5",
                "data-test": "hidden-tag-indicator"
              }, {
                default: de(() => [
                  it(" +" + Te(p.value), 1)
                ]),
                _: 1
              })) : K("", !0),
              Jt(G("input", {
                ref_key: "input",
                ref: g,
                "onUpdate:modelValue": T[0] || (T[0] = (Q) => m.value = Q),
                "data-test": "dropdown-input",
                class: te([{
                  "bg-gray-100": _.disabled,
                  "w-0.5": !V && m.value === "",
                  "w-1/5 grow": V
                }, "h-6 ml-2 focus:outline-none cursor-pointer focus:cursor-text m-0.5"]),
                disabled: _.disabled,
                type: "text",
                onKeydown: [
                  Re(b, ["delete"]),
                  Re((Q) => U(V, Q), ["enter"]),
                  T[1] || (T[1] = Re((Q) => m.value.length > 0 && _.allowNewOptions && P(0), ["tab"]))
                ]
              }, null, 42, M_), [
                [s0, m.value]
              ])
            ]),
            fe(Ue, {
              name: V ? "chevron-up" : "chevron-down",
              class: te([{
                "text-gray-500": !_.disabled,
                "text-gray-300": _.disabled
              }, "order-last mx-1 my-auto"])
            }, null, 8, ["name", "class"])
          ], 2)
        ]),
        extra: de(() => [
          _.allowNewOptions && m.value.length === 0 ? (k(), A("p", O_, Te(_.allowNewOptionsText), 1)) : K("", !0)
        ]),
        item: de(({ item: V, index: Q }) => [
          se(_.$slots, "option", {
            option: V,
            isSelected: d(V),
            isDraft: Q === 0 && O.value,
            isInvalid: V.value === D(t)
          }, () => {
            var ue;
            return [
              G("div", {
                class: "flex items-start",
                "data-test": `dropdown-item-${V[i.value]}`
              }, [
                G("div", D_, [
                  Jt(fe(Ue, {
                    name: "check",
                    "data-test": "selected-checkmark"
                  }, null, 512), [
                    [Cn, d(V)]
                  ]),
                  Jt(fe(Ue, { name: "plus" }, null, 512), [
                    [
                      Cn,
                      !d(V) && Q === 0 && O.value
                    ]
                  ]),
                  !d(V) && !(Q === 0 && O.value) ? (k(), A(Ie, { key: 0 }, [
                    it("   ")
                  ], 64)) : K("", !0)
                ]),
                G("div", null, [
                  it(Te(V[o.value]) + " ", 1),
                  Q === 0 && O.value && V.value === D(t) ? (k(), A("div", {
                    key: 0,
                    class: "text-gray-700 mt-0.5",
                    textContent: Te((ue = _.validationFailedMsg) != null ? ue : "Kein valides Format.")
                  }, null, 8, A_)) : K("", !0)
                ])
              ], 8, E_)
            ];
          })
        ]),
        "no-items": de(() => [
          _.allowNewOptions ? K("", !0) : (k(), A("div", P_, [
            m.value.length > 0 ? (k(), A(Ie, { key: 0 }, [
              it(" Keine Ergebnisse gefunden ")
            ], 64)) : (k(), A(Ie, { key: 1 }, [
              it(Te(_.noOptionsText), 1)
            ], 64))
          ]))
        ]),
        _: 3
      }, 8, ["id", "button-class", "items", "disabled", "group-key", "group-key-order", "item-height", "virtualized"]);
    };
  }
}), N_ = 6e3;
var Xi = /* @__PURE__ */ ((e) => (e.Info = "info", e.Success = "success", e.Warning = "warning", e.Error = "error", e.Neutral = "neutral", e))(Xi || {});
const Gu = q(
  /* @__PURE__ */ new Map()
), om = q(0), Ju = q(!1), I_ = () => {
  const e = (o) => {
    Gu.value.delete(o);
  };
  return {
    show: (o, a = Xi.Info, s = N_, l = []) => {
      if (!Ju.value)
        throw new Error("Service not mounted! Make sure you mount DsNotification in your app.");
      om.value += 1;
      const d = om.value;
      Gu.value.set(d, {
        message: o,
        variant: a,
        hasTimeout: s > 0,
        actions: l
      }), s > 0 && setTimeout(() => {
        e(d);
      }, s);
    },
    remove: e,
    list: () => Gu.value,
    hasBeenMounted: () => Ju.value,
    setMounted: (o) => {
      Ju.value = o;
    }
  };
}, R_ = $e({
  name: "DsNotification",
  components: { DsButton: gr, DsIcon: Ue },
  props: {
    offset: {
      type: [Number, String, null],
      default: null
    },
    target: {
      type: String,
      default: "body"
    }
  },
  emits: {
    notifyAction(e) {
      return typeof e == "string";
    }
  },
  setup(e, t) {
    var u;
    const n = I_(), r = q((u = window.innerWidth) != null ? u : 0), i = (c) => {
      n.remove(c);
    }, o = (c, f, h) => {
      t.emit("notifyAction", f), h && i(c);
    }, a = E(
      () => Array.from(n.list()).reverse()
    ), s = {
      [Xi.Success]: "text-green-800 bg-green-100",
      [Xi.Info]: "text-blue-800 bg-blue-100",
      [Xi.Warning]: "text-orange-800 bg-orange-100",
      [Xi.Error]: "text-red-800 bg-red-100",
      [Xi.Neutral]: "bg-white"
    };
    a0(() => {
      if (n.hasBeenMounted())
        throw Error("Notification handler already has been mounted - please avoid mounting the DsNotification component twice!");
    });
    const l = () => {
      r.value = window.innerWidth;
    };
    ot(() => {
      n.setMounted(!0), window.addEventListener("resize", l);
    }), hr(() => {
      n.setMounted(!1), window.removeEventListener("resize", l);
    });
    const d = E(() => {
      const c = {};
      return r.value >= 1024 && (e.offset === null ? c.top = "0.5rem" : c.top = typeof e.offset == "string" ? e.offset : `${e.offset}rem`), c;
    });
    return {
      notificationList: a,
      variantStyles: s,
      removeNotification: i,
      offsetStyle: d,
      emitNotifyAction: o
    };
  }
}), __ = ["data-id", "onClick"], L_ = {
  key: 0,
  class: "p-3 flex space-x-2 bg-white"
};
function F_(e, t, n, r, i, o) {
  const a = Be("DsButton"), s = Be("DsIcon");
  return k(), ge(ca, { to: e.target }, [
    fe(d4, {
      tag: "ul",
      name: "notificationList",
      class: te(["fixed right-2 left-2 bottom-2 lg:bottom-auto lg:left-auto space-y-4 flex flex-col items-center lg:items-end z-[2000] pointer-events-none", e.$attrs.class]),
      style: mt(e.offsetStyle)
    }, {
      default: de(() => [
        (k(!0), A(Ie, null, Ze(e.notificationList, ([l, d]) => {
          var u, c, f;
          return k(), A("li", {
            key: `${l}-${d.message}`,
            class: te(["cursor-pointer pointer-events-auto rounded shadow-lg lg:max-w-lg relative flex-shrink", {
              [e.variantStyles[d.variant]]: !0
            }]),
            "data-id": l,
            onClick: (h) => e.removeNotification(l)
          }, [
            G("div", {
              class: te(["p-3", { "pr-10": !d.hasTimeout }])
            }, Te(d.message), 3),
            (c = (u = d.actions) == null ? void 0 : u.length) != null && c ? (k(), A("div", L_, [
              (k(!0), A(Ie, null, Ze((f = d.actions) == null ? void 0 : f.slice(0, 2), (h) => (k(), A("div", {
                key: h.title
              }, [
                fe(a, {
                  icon: h.icon,
                  size: "sm",
                  variant: "outline",
                  onClick: Ge((p) => {
                    var m;
                    return e.emitNotifyAction(l, h.action, (m = h.closeOnAction) != null ? m : !0);
                  }, ["stop"])
                }, {
                  default: de(() => [
                    it(Te(h.title), 1)
                  ]),
                  _: 2
                }, 1032, ["icon", "onClick"])
              ]))), 128))
            ])) : K("", !0),
            d.hasTimeout ? K("", !0) : (k(), ge(s, {
              key: 1,
              name: "xmark",
              size: "lg",
              variant: "light",
              class: "ml-4 absolute top-3 right-3"
            }))
          ], 10, __);
        }), 128))
      ]),
      _: 1
    }, 8, ["class", "style"])
  ], 8, ["to"]);
}
const iH = /* @__PURE__ */ Je(R_, [["render", F_], ["__scopeId", "data-v-ea0c4bc7"]]);
var Gc = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(Gc || {});
const B_ = $e({
  name: "DsProgressBar",
  props: {
    percent: {
      type: Number,
      required: !0
    },
    size: {
      type: String,
      default: Gc.Medium
    },
    /**
     * Not combinable with displayTime
     */
    showProgress: {
      type: Boolean
    },
    showProgressInline: {
      type: Boolean
    },
    flat: {
      type: Boolean
    },
    backwards: {
      type: Boolean
    },
    /**
     * If you want to use css animation, pass in the displayTime in seconds.
     * Not combinable with showProgress
     */
    displayTime: {
      type: Number,
      default: 0
    }
  },
  emits: ["finished"],
  setup(e, { emit: t }) {
    const n = E(() => {
      if (e.percent < 0)
        throw new Error("You must specify an integer value in the range 0 to 100");
      return !e.backwards && e.percent >= 100 ? (t("finished"), 100) : (e.backwards && e.percent === 0 && t("finished"), e.percent);
    }), r = q(!1);
    e.displayTime > 0 && (setTimeout(() => {
      t("finished");
    }, e.displayTime * 1e3), setTimeout(() => {
      r.value = !0;
    }, 0));
    const i = E(() => e.backwards ? r.value ? 0 : 100 : r.value ? 100 : 0);
    return {
      percentDone: n,
      ProgressBarSize: Gc,
      startWidthCssAnimation: i
    };
  }
}), z_ = "_bar_3gdd0_2", V_ = "_animate_3gdd0_6", H_ = "_pulse_3gdd0_1", j_ = "_small_3gdd0_10", W_ = {
  bar: z_,
  animate: V_,
  pulse: H_,
  small: j_
}, U_ = {
  key: 0,
  class: "w-full text-center"
};
function q_(e, t, n, r, i, o) {
  return k(), A(Ie, null, [
    !e.showProgressInline && e.showProgress && e.displayTime === 0 ? (k(), A("div", U_, Te(e.percentDone) + "% ", 1)) : K("", !0),
    G("div", {
      class: te(["w-full bg-gray-100 overflow-hidden relative", {
        "h-2": e.size === e.ProgressBarSize.Small,
        "h-8": e.size === e.ProgressBarSize.Medium,
        "h-10": e.size === e.ProgressBarSize.Large,
        rounded: !e.flat
      }])
    }, [
      e.showProgressInline && e.showProgress && e.displayTime === 0 ? (k(), A("div", {
        key: 0,
        class: te(["absolute left-1/2 top-1/2 z-10 -translate-y-1/2 -translate-x-1/2", {
          [e.$style.small]: e.size === e.ProgressBarSize.Small,
          "text-xs": e.size === e.ProgressBarSize.Medium,
          "text-lg": e.size === e.ProgressBarSize.Large,
          "text-white": e.percent > 55
        }])
      }, Te(e.percentDone) + "% ", 3)) : K("", !0),
      G("div", {
        class: te(["bg-gradient-to-b from-blue-500 to-blue-700 h-full flex justify-center items-center", {
          [e.$style.bar]: !0,
          [e.$style.animate]: e.percentDone < 100 && e.displayTime === 0,
          rounded: !e.flat
        }]),
        style: mt({
          width: `${e.displayTime === 0 ? e.percentDone : e.startWidthCssAnimation}%`,
          transition: e.displayTime > 0 ? `width ${e.displayTime}s ease-in-out` : void 0
        })
      }, null, 6)
    ], 2)
  ], 64);
}
const Y_ = {
  $style: W_
}, oH = /* @__PURE__ */ Je(B_, [["render", q_], ["__cssModules", Y_]]);
function _y(e, t, n) {
  let r = q(n == null ? void 0 : n.value), i = E(() => e.value !== void 0);
  return [E(() => i.value ? e.value : r.value), function(o) {
    return i.value || (r.value = o), t == null ? void 0 : t(o);
  }];
}
let K_ = Symbol("headlessui.useid"), G_ = 0;
function Ss() {
  return Zn(K_, () => `${++G_}`)();
}
function li(e) {
  var t;
  if (e == null || e.value == null) return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function Ly(e, t, ...n) {
  if (e in t) {
    let i = t[e];
    return typeof i == "function" ? i(...n) : i;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Ly), r;
}
var J_ = Object.defineProperty, X_ = (e, t, n) => t in e ? J_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, am = (e, t, n) => (X_(e, typeof t != "symbol" ? t + "" : t, n), n);
let Q_ = class {
  constructor() {
    am(this, "current", this.detect()), am(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }
}, Z_ = new Q_();
function tl(e) {
  if (Z_.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = li(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let eL = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Da = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Da || {}), Jc = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Jc || {}), tL = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(tL || {});
function nL(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(eL)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var rL = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(rL || {}), iL = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(iL || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let oL = ["textarea", "input"].join(",");
function aL(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, oL)) != null ? n : !1;
}
function Fy(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let i = t(n), o = t(r);
    if (i === null || o === null) return 0;
    let a = i.compareDocumentPosition(o);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function sm(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: i = [] } = {}) {
  var o;
  let a = (o = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? o : document, s = Array.isArray(e) ? n ? Fy(e) : e : nL(e);
  i.length > 0 && s.length > 1 && (s = s.filter((p) => !i.includes(p))), r = r != null ? r : a.activeElement;
  let l = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, s.indexOf(r)) - 1;
    if (t & 4) return Math.max(0, s.indexOf(r)) + 1;
    if (t & 8) return s.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, c = 0, f = s.length, h;
  do {
    if (c >= f || c + f <= 0) return 0;
    let p = d + c;
    if (t & 16) p = (p + f) % f;
    else {
      if (p < 0) return 3;
      if (p >= f) return 1;
    }
    h = s[p], h == null || h.focus(u), c += l;
  } while (h !== a.activeElement);
  return t & 6 && aL(h) && h.select(), 2;
}
function lm(e, t) {
  if (e) return e;
  let n = t != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function sL(e, t) {
  let n = q(lm(e.value.type, e.value.as));
  return ot(() => {
    n.value = lm(e.value.type, e.value.as);
  }), ps(() => {
    var r;
    n.value || li(t) && li(t) instanceof HTMLButtonElement && !((r = li(t)) != null && r.hasAttribute("type")) && (n.value = "button");
  }), n;
}
function lL({ container: e, accept: t, walk: n, enabled: r }) {
  ps(() => {
    let i = e.value;
    if (!i || r !== void 0 && !r.value) return;
    let o = tl(e);
    if (!o) return;
    let a = Object.assign((l) => t(l), { acceptNode: t }), s = o.createTreeWalker(i, NodeFilter.SHOW_ELEMENT, a, !1);
    for (; s.nextNode(); ) n(s.currentNode);
  });
}
var dL = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(dL || {}), uL = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(uL || {});
function So({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...i }) {
  var o;
  let a = zy(r, n), s = Object.assign(i, { props: a });
  if (e || t & 2 && a.static) return Xu(s);
  if (t & 1) {
    let l = (o = a.unmount) == null || o ? 0 : 1;
    return Ly(l, { 0() {
      return null;
    }, 1() {
      return Xu({ ...i, props: { ...a, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Xu(s);
}
function Xu({ props: e, attrs: t, slots: n, slot: r, name: i }) {
  var o, a;
  let { as: s, ...l } = zf(e, ["unmount", "static"]), d = (o = n.default) == null ? void 0 : o.call(n, r), u = {};
  if (r) {
    let c = !1, f = [];
    for (let [h, p] of Object.entries(r)) typeof p == "boolean" && (c = !0), p === !0 && f.push(h);
    c && (u["data-headlessui-state"] = f.join(" "));
  }
  if (s === "template") {
    if (d = By(d != null ? d : []), Object.keys(l).length > 0 || Object.keys(t).length > 0) {
      let [c, ...f] = d != null ? d : [];
      if (!cL(c) || f.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${i} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(t)).map((m) => m.trim()).filter((m, g, v) => v.indexOf(m) === g).sort((m, g) => m.localeCompare(g)).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
      let h = zy((a = c.props) != null ? a : {}, l, u), p = u4(c, h, !0);
      for (let m in h) m.startsWith("on") && (p.props || (p.props = {}), p.props[m] = h[m]);
      return p;
    }
    return Array.isArray(d) && d.length === 1 ? d[0] : d;
  }
  return nn(s, Object.assign({}, l, u), { default: () => d });
}
function By(e) {
  return e.flatMap((t) => t.type === Ie ? By(t.children) : [t]);
}
function zy(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let i in r) i.startsWith("on") && typeof r[i] == "function" ? (n[i] != null || (n[i] = []), n[i].push(r[i])) : t[i] = r[i];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](i, ...o) {
    let a = n[r];
    for (let s of a) {
      if (i instanceof Event && i.defaultPrevented) return;
      s(i, ...o);
    }
  } });
  return t;
}
function Vy(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function zf(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function cL(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Vf = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Vf || {});
let Hy = $e({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    var r;
    let { features: i, ...o } = e, a = { "aria-hidden": (i & 2) === 2 ? !0 : (r = o["aria-hidden"]) != null ? r : void 0, hidden: (i & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return So({ ourProps: a, theirProps: o, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} });
var ei = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(ei || {});
function jy(e = {}, t = null, n = []) {
  for (let [r, i] of Object.entries(e)) Uy(n, Wy(t, r), i);
  return n;
}
function Wy(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Uy(e, t, n) {
  if (Array.isArray(n)) for (let [r, i] of n.entries()) Uy(e, Wy(t, r.toString()), i);
  else n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : jy(n, t, e);
}
function qy(e) {
  var t, n;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let i of r.elements) if (i !== e && (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image")) {
      i.click();
      return;
    }
    (n = r.requestSubmit) == null || n.call(r);
  }
}
let Yy = Symbol("DescriptionContext");
function fL() {
  let e = Zn(Yy, null);
  if (e === null) throw new Error("Missing parent");
  return e;
}
function Hf({ slot: e = q({}), name: t = "Description", props: n = {} } = {}) {
  let r = q([]);
  function i(o) {
    return r.value.push(o), () => {
      let a = r.value.indexOf(o);
      a !== -1 && r.value.splice(a, 1);
    };
  }
  return mr(Yy, { register: i, slot: e, name: t, props: n }), E(() => r.value.length > 0 ? r.value.join(" ") : void 0);
}
$e({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-description-${Ss()}`, o = fL();
  return ot(() => hr(o.register(i))), () => {
    let { name: a = "Description", slot: s = q({}), props: l = {} } = o, { ...d } = e, u = { ...Object.entries(l).reduce((c, [f, h]) => Object.assign(c, { [f]: D(h) }), {}), id: i };
    return So({ ourProps: u, theirProps: d, slot: s.value, attrs: t, slots: n, name: a });
  };
} });
let Ky = Symbol("LabelContext");
function Gy() {
  let e = Zn(Ky, null);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Gy), t;
  }
  return e;
}
function jf({ slot: e = {}, name: t = "Label", props: n = {} } = {}) {
  let r = q([]);
  function i(o) {
    return r.value.push(o), () => {
      let a = r.value.indexOf(o);
      a !== -1 && r.value.splice(a, 1);
    };
  }
  return mr(Ky, { register: i, slot: e, name: t, props: n }), E(() => r.value.length > 0 ? r.value.join(" ") : void 0);
}
let pL = $e({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-label-${Ss()}`, o = Gy();
  return ot(() => hr(o.register(i))), () => {
    let { name: a = "Label", slot: s = {}, props: l = {} } = o, { passive: d, ...u } = e, c = { ...Object.entries(l).reduce((f, [h, p]) => Object.assign(f, { [h]: D(p) }), {}), id: i };
    return d && (delete c.onClick, delete c.htmlFor, delete u.onClick), So({ ourProps: c, theirProps: u, slot: s, attrs: n, slots: t, name: a });
  };
} });
function hL(e, t) {
  return e === t;
}
let Jy = Symbol("RadioGroupContext");
function Xy(e) {
  let t = Zn(Jy, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Xy), n;
  }
  return t;
}
let mL = $e({ name: "RadioGroup", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => hL }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-radiogroup-${Ss()}`, s = q(null), l = q([]), d = jf({ name: "RadioGroupLabel" }), u = Hf({ name: "RadioGroupDescription" });
  i({ el: s, $el: s });
  let [c, f] = _y(E(() => e.modelValue), (g) => t("update:modelValue", g), E(() => e.defaultValue)), h = { options: l, value: c, disabled: E(() => e.disabled), firstOption: E(() => l.value.find((g) => !g.propsRef.disabled)), containsCheckedOption: E(() => l.value.some((g) => h.compare(Xr(g.propsRef.value), Xr(e.modelValue)))), compare(g, v) {
    if (typeof e.by == "string") {
      let b = e.by;
      return (g == null ? void 0 : g[b]) === (v == null ? void 0 : v[b]);
    }
    return e.by(g, v);
  }, change(g) {
    var v;
    if (e.disabled || h.compare(Xr(c.value), Xr(g))) return !1;
    let b = (v = l.value.find((x) => h.compare(Xr(x.propsRef.value), Xr(g)))) == null ? void 0 : v.propsRef;
    return b != null && b.disabled ? !1 : (f(g), !0);
  }, registerOption(g) {
    l.value.push(g), l.value = Fy(l.value, (v) => v.element);
  }, unregisterOption(g) {
    let v = l.value.findIndex((b) => b.id === g);
    v !== -1 && l.value.splice(v, 1);
  } };
  mr(Jy, h), lL({ container: E(() => li(s)), accept(g) {
    return g.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : g.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(g) {
    g.setAttribute("role", "none");
  } });
  function p(g) {
    if (!s.value || !s.value.contains(g.target)) return;
    let v = l.value.filter((b) => b.propsRef.disabled === !1).map((b) => b.element);
    switch (g.key) {
      case ei.Enter:
        qy(g.currentTarget);
        break;
      case ei.ArrowLeft:
      case ei.ArrowUp:
        if (g.preventDefault(), g.stopPropagation(), sm(v, Da.Previous | Da.WrapAround) === Jc.Success) {
          let b = l.value.find((x) => {
            var y;
            return x.element === ((y = tl(s)) == null ? void 0 : y.activeElement);
          });
          b && h.change(b.propsRef.value);
        }
        break;
      case ei.ArrowRight:
      case ei.ArrowDown:
        if (g.preventDefault(), g.stopPropagation(), sm(v, Da.Next | Da.WrapAround) === Jc.Success) {
          let b = l.value.find((x) => {
            var y;
            return x.element === ((y = tl(x.element)) == null ? void 0 : y.activeElement);
          });
          b && h.change(b.propsRef.value);
        }
        break;
      case ei.Space:
        {
          g.preventDefault(), g.stopPropagation();
          let b = l.value.find((x) => {
            var y;
            return x.element === ((y = tl(x.element)) == null ? void 0 : y.activeElement);
          });
          b && h.change(b.propsRef.value);
        }
        break;
    }
  }
  let m = E(() => {
    var g;
    return (g = li(s)) == null ? void 0 : g.closest("form");
  });
  return ot(() => {
    Fe([m], () => {
      if (!m.value || e.defaultValue === void 0) return;
      function g() {
        h.change(e.defaultValue);
      }
      return m.value.addEventListener("reset", g), () => {
        var v;
        (v = m.value) == null || v.removeEventListener("reset", g);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: g, name: v, form: b, ...x } = e, y = { ref: s, id: a, role: "radiogroup", "aria-labelledby": d.value, "aria-describedby": u.value, onKeydown: p };
    return nn(Ie, [...v != null && c.value != null ? jy({ [v]: c.value }).map(([C, $]) => nn(Hy, Vy({ features: Vf.Hidden, key: C, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: b, disabled: g, name: C, value: $ }))) : [], So({ ourProps: y, theirProps: { ...n, ...zf(x, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: n, slots: r, name: "RadioGroup" })]);
  };
} });
var gL = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(gL || {});
let vL = $e({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let o = (i = e.id) != null ? i : `headlessui-radiogroup-option-${Ss()}`, a = Xy("RadioGroupOption"), s = jf({ name: "RadioGroupLabel" }), l = Hf({ name: "RadioGroupDescription" }), d = q(null), u = E(() => ({ value: e.value, disabled: e.disabled })), c = q(1);
  r({ el: d, $el: d });
  let f = E(() => li(d));
  ot(() => a.registerOption({ id: o, element: f, propsRef: u })), hr(() => a.unregisterOption(o));
  let h = E(() => {
    var y;
    return ((y = a.firstOption.value) == null ? void 0 : y.id) === o;
  }), p = E(() => a.disabled.value || e.disabled), m = E(() => a.compare(Xr(a.value.value), Xr(e.value))), g = E(() => p.value ? -1 : m.value || !a.containsCheckedOption.value && h.value ? 0 : -1);
  function v() {
    var y;
    a.change(e.value) && (c.value |= 2, (y = li(d)) == null || y.focus());
  }
  function b() {
    c.value |= 2;
  }
  function x() {
    c.value &= -3;
  }
  return () => {
    let { value: y, disabled: C, ...$ } = e, O = { checked: m.value, disabled: p.value, active: !!(c.value & 2) }, z = { id: o, ref: d, role: "radio", "aria-checked": m.value ? "true" : "false", "aria-labelledby": s.value, "aria-describedby": l.value, "aria-disabled": p.value ? !0 : void 0, tabIndex: g.value, onClick: p.value ? void 0 : v, onFocus: p.value ? void 0 : b, onBlur: p.value ? void 0 : x };
    return So({ ourProps: z, theirProps: $, slot: O, attrs: t, slots: n, name: "RadioGroupOption" });
  };
} }), Qy = Symbol("GroupContext"), yL = $e({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: n }) {
  let r = q(null), i = jf({ name: "SwitchLabel", props: { htmlFor: E(() => {
    var a;
    return (a = r.value) == null ? void 0 : a.id;
  }), onClick(a) {
    r.value && (a.currentTarget.tagName === "LABEL" && a.preventDefault(), r.value.click(), r.value.focus({ preventScroll: !0 }));
  } } }), o = Hf({ name: "SwitchDescription" });
  return mr(Qy, { switchRef: r, labelledby: i, describedby: o }), () => So({ theirProps: e, ourProps: {}, slot: {}, slots: t, attrs: n, name: "SwitchGroup" });
} }), bL = $e({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: null }, disabled: { type: Boolean, default: !1 }, tabIndex: { type: Number, default: 0 } }, inheritAttrs: !1, setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-switch-${Ss()}`, s = Zn(Qy, null), [l, d] = _y(E(() => e.modelValue), (b) => t("update:modelValue", b), E(() => e.defaultChecked));
  function u() {
    d(!l.value);
  }
  let c = q(null), f = s === null ? c : s.switchRef, h = sL(E(() => ({ as: e.as, type: n.type })), f);
  i({ el: f, $el: f });
  function p(b) {
    b.preventDefault(), u();
  }
  function m(b) {
    b.key === ei.Space ? (b.preventDefault(), u()) : b.key === ei.Enter && qy(b.currentTarget);
  }
  function g(b) {
    b.preventDefault();
  }
  let v = E(() => {
    var b, x;
    return (x = (b = li(f)) == null ? void 0 : b.closest) == null ? void 0 : x.call(b, "form");
  });
  return ot(() => {
    Fe([v], () => {
      if (!v.value || e.defaultChecked === void 0) return;
      function b() {
        d(e.defaultChecked);
      }
      return v.value.addEventListener("reset", b), () => {
        var x;
        (x = v.value) == null || x.removeEventListener("reset", b);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: b, value: x, form: y, tabIndex: C, ...$ } = e, O = { checked: l.value }, z = { id: a, ref: f, role: "switch", type: h.value, tabIndex: C === -1 ? 0 : C, "aria-checked": l.value, "aria-labelledby": s == null ? void 0 : s.labelledby.value, "aria-describedby": s == null ? void 0 : s.describedby.value, onClick: p, onKeyup: m, onKeypress: g };
    return nn(Ie, [b != null && l.value != null ? nn(Hy, Vy({ features: Vf.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: l.value, form: y, disabled: $.disabled, name: b, value: x })) : null, So({ ourProps: z, theirProps: { ...n, ...zf($, ["modelValue", "defaultChecked"]) }, slot: O, attrs: n, slots: r, name: "Switch" })]);
  };
} }), $L = pL;
const wL = $e({
  props: {
    active: {
      type: Boolean
    },
    focus: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  }
});
function kL(e, t, n, r, i, o) {
  return k(), A("div", {
    class: te(["border rounded-full pointer-events-none h-4 w-4 hover:bg-blue-100 flex items-center justify-center shrink-0 ease-out duration-100 transition-colors", e.disabled ? {
      "border-gray-200 bg-gray-100": !e.active,
      "border-gray-300 bg-gray-300": e.active
    } : {
      "border-gray-300 bg-white": !e.active,
      "border-blue-500 bg-blue-500": e.active,
      "ring-offset-2 ring-2 ring-blue-500 outline-none": e.focus
    }])
  }, [
    G("div", {
      class: te([e.disabled ? "bg-gray-100" : "bg-white", "rounded-full h-2 w-2"])
    }, null, 2)
  ], 2);
}
const xL = /* @__PURE__ */ Je(wL, [["render", kL]]), Zy = Symbol("GroupState"), SL = () => Zn(Zy), CL = (e) => {
  mr(Zy, e);
}, TL = $e({
  name: "DsRadioButton",
  components: {
    DsIcon: Ue,
    RadioCircle: xL,
    RadioGroupOption: vL
  },
  props: {
    value: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    const t = SL();
    if (t === void 0)
      throw new Error("No GroupState provided");
    const n = q(!1), r = E(() => t.value.disabled || e.disabled), i = (o) => {
      e.disabled || (n.value = o);
    };
    return {
      focus: n,
      groupOrButtonDisabled: r,
      variant: E(() => t.value.variant),
      isActive: E(() => t.value.active === e.value),
      handleFocus: i,
      setActive() {
        r.value || (t.value.active = e.value);
      }
    };
  }
}), ML = ["textContent"], OL = {
  key: 1,
  class: "pointer-events-none"
}, EL = {
  key: 0,
  class: "pointer-events-none"
}, DL = { class: "font-semibold leading-none" }, AL = {
  key: 1,
  class: "pointer-events-none"
}, PL = { class: "font-semibold leading-none" }, NL = ["textContent"];
function IL(e, t, n, r, i, o) {
  const a = Be("RadioCircle"), s = Be("RadioGroupOption"), l = Be("DsIcon");
  return e.variant === "default" ? (k(), ge(s, {
    key: 0,
    type: "button",
    value: e.value,
    disabled: e.groupOrButtonDisabled,
    class: te([e.groupOrButtonDisabled ? "cursor-not-allowed text-gray-500" : "cursor-pointer", "flex items-center text-left leading-none focus:outline-none"]),
    onFocus: t[0] || (t[0] = (d) => e.handleFocus(!0)),
    onBlur: t[1] || (t[1] = (d) => e.handleFocus(!1)),
    onClick: e.setActive
  }, {
    default: de(() => [
      fe(a, {
        focus: e.focus,
        active: e.isActive,
        disabled: e.groupOrButtonDisabled,
        class: "mr-3"
      }, null, 8, ["focus", "active", "disabled"]),
      e.label !== "" ? (k(), A("div", {
        key: 0,
        class: "pointer-events-none",
        textContent: Te(e.label)
      }, null, 8, ML)) : (k(), A("div", OL, [
        se(e.$slots, "default", {}, void 0, !0)
      ]))
    ]),
    _: 3
  }, 8, ["value", "disabled", "class", "onClick"])) : e.variant === "card" ? (k(), ge(s, {
    key: 1,
    type: "button",
    value: e.value,
    disabled: e.groupOrButtonDisabled,
    class: te([e.groupOrButtonDisabled ? {
      "border-gray-500 ring-1 ring-gray-500 ring-inset": e.isActive,
      "border-gray-100": !e.isActive,
      "text-gray-500 cursor-not-allowed": !0
    } : {
      "border-blue-500 ring-1 ring-blue-500 ring-inset shadow": e.isActive,
      "cursor-pointer": !0
    }, "p-3 flex items-start border rounded-md text-left focus:outline-none transition ease-out duration-100"]),
    onFocus: t[2] || (t[2] = (d) => e.handleFocus(!0)),
    onBlur: t[3] || (t[3] = (d) => e.handleFocus(!1)),
    onClick: e.setActive
  }, {
    default: de(() => [
      fe(a, {
        focus: e.focus,
        active: e.isActive,
        disabled: e.groupOrButtonDisabled,
        class: "mr-3"
      }, null, 8, ["focus", "active", "disabled"]),
      e.label !== "" ? (k(), A("div", EL, [
        G("div", DL, [
          it(Te(e.label) + " ", 1),
          e.icon !== "" ? (k(), ge(l, {
            key: 0,
            name: e.icon,
            variant: "regular",
            class: te(["ml-2", e.groupOrButtonDisabled ? {
              "text-gray-100": e.isActive,
              "text-gray-300": !e.isActive
            } : {
              "text-blue-500": e.isActive,
              "text-gray-500": !e.isActive
            }])
          }, null, 8, ["name", "class"])) : K("", !0)
        ]),
        G("div", {
          class: te([e.groupOrButtonDisabled ? "text-gray-500" : "text-gray-700", "text-sm mt-1 leading-tight"])
        }, [
          se(e.$slots, "default", {}, void 0, !0)
        ], 2)
      ])) : (k(), A("div", AL, [
        G("div", PL, [
          se(e.$slots, "default", {}, void 0, !0),
          e.icon !== "" ? (k(), ge(l, {
            key: 0,
            name: e.icon,
            variant: "regular",
            class: "ml-2 text-gray-500"
          }, null, 8, ["name"])) : K("", !0)
        ]),
        G("div", {
          class: te([e.groupOrButtonDisabled ? "text-gray-300" : "text-gray-700", "text-sm mt-1 leading-tight"]),
          textContent: Te(e.description)
        }, null, 10, NL)
      ]))
    ]),
    _: 3
  }, 8, ["value", "disabled", "class", "onClick"])) : ["button", "button-col"].includes(e.variant) ? (k(), ge(s, {
    key: 2,
    type: "button",
    value: e.value,
    disabled: e.groupOrButtonDisabled,
    class: te(["px-3 py-2 h-8 text-sm rounded-none grow inline-flex items-center justify-center leading-none font-medium focus:outline-none transition ease-out duration-100 border", {
      "border-gray-300 bg-gray-300 text-white": e.groupOrButtonDisabled && e.isActive,
      "border-gray-200 text-gray-500": e.groupOrButtonDisabled && !e.isActive,
      "cursor-not-allowed": e.groupOrButtonDisabled,
      "border-blue-500 hover:border-blue-700 active:border-blue-500 focus:border-blue-700 bg-blue-500 hover:bg-blue-700 active:bg-blue-500 focus:bg-blue-700 text-white shadow": !e.groupOrButtonDisabled && e.isActive,
      "border-blue-200 hover:bg-blue-100 active:bg-blue-100 focus:bg-blue-100 text-blue-700": !e.groupOrButtonDisabled && !e.isActive,
      "cursor-pointer": !e.groupOrButtonDisabled,
      "first:rounded-l last:rounded-r": e.variant === "button",
      "first:rounded-t last:rounded-b": e.variant === "button-col"
    }]),
    onClick: e.setActive
  }, {
    default: de(() => [
      e.icon !== "" ? (k(), ge(l, {
        key: 0,
        name: e.icon,
        class: te([e.groupOrButtonDisabled ? {
          "text-gray-100": e.isActive,
          "text-gray-300": !e.isActive
        } : {
          "text-white": e.isActive,
          "text-blue-500": !e.isActive
        }, "pointer-events-none mr-1.5"]),
        "fixed-width": ""
      }, null, 8, ["name", "class"])) : K("", !0),
      se(e.$slots, "default", {}, () => [
        it(Te(e.label), 1)
      ], !0)
    ]),
    _: 3
  }, 8, ["value", "disabled", "class", "onClick"])) : K("", !0);
}
const RL = /* @__PURE__ */ Je(TL, [["render", IL], ["__scopeId", "data-v-1ece301c"]]), _L = {
  default: "space-y-3",
  button: "flex -space-x-px",
  "button-col": "flex flex-col -space-y-px",
  card: "grid gap-3"
}, LL = $e({
  name: "DsRadioGroup",
  components: {
    DsRadioButton: RL,
    RadioGroup: mL
  },
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: "default"
    },
    values: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(e, t) {
    const n = () => ({
      active: e.modelValue,
      variant: e.variant,
      disabled: e.disabled
    }), r = q(n());
    return Fe(e, () => {
      r.value = n();
    }, { deep: !0 }), Fe(() => {
      var i;
      return (i = r.value) == null ? void 0 : i.active;
    }, (i) => {
      t.emit("update:modelValue", i);
    }), CL(r), {
      classes: E(() => _L[e.variant]),
      state: r
    };
  }
});
function FL(e, t, n, r, i, o) {
  const a = Be("DsRadioButton"), s = Be("RadioGroup");
  return k(), ge(s, {
    modelValue: e.state.active,
    "onUpdate:modelValue": t[0] || (t[0] = (l) => e.state.active = l),
    class: te(e.classes),
    disabled: e.disabled
  }, {
    default: de(() => [
      (k(!0), A(Ie, null, Ze(e.values, (l) => (k(), ge(a, {
        key: l.value,
        icon: l.icon,
        value: l.value,
        description: l.description
      }, {
        default: de(() => [
          it(Te(l.label), 1)
        ]),
        _: 2
      }, 1032, ["icon", "value", "description"]))), 128)),
      se(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["modelValue", "class", "disabled"]);
}
const sH = /* @__PURE__ */ Je(LL, [["render", FL], ["__scopeId", "data-v-ea12ecac"]]);
function qs(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function BL(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function e3(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var dm = e3(function(e, t) {
  e.exports = /* @__PURE__ */ function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(p) {
      return p.split("").reverse().join("");
    }
    function i(p, m) {
      return p.substring(0, m.length) === m;
    }
    function o(p, m) {
      return p.slice(-1 * m.length) === m;
    }
    function a(p, m, g) {
      if ((p[m] || p[g]) && p[m] === p[g]) throw new Error(m);
    }
    function s(p) {
      return typeof p == "number" && isFinite(p);
    }
    function l(p, m) {
      return p = p.toString().split("e"), (+((p = (p = Math.round(+(p[0] + "e" + (p[1] ? +p[1] + m : m)))).toString().split("e"))[0] + "e" + (p[1] ? +p[1] - m : -m))).toFixed(m);
    }
    function d(p, m, g, v, b, x, y, C, $, O, z, P) {
      var U, ie, W, H = P, _ = "", T = "";
      return x && (P = x(P)), !!s(P) && (p !== !1 && parseFloat(P.toFixed(p)) === 0 && (P = 0), P < 0 && (U = !0, P = Math.abs(P)), p !== !1 && (P = l(P, p)), (P = P.toString()).indexOf(".") !== -1 ? (W = (ie = P.split("."))[0], g && (_ = g + ie[1])) : W = P, m && (W = r(W).match(/.{1,3}/g), W = r(W.join(r(m)))), U && C && (T += C), v && (T += v), U && $ && (T += $), T += W, T += _, b && (T += b), O && (T = O(T, H)), T);
    }
    function u(p, m, g, v, b, x, y, C, $, O, z, P) {
      var U, ie = "";
      return z && (P = z(P)), !(!P || typeof P != "string") && (C && i(P, C) && (P = P.replace(C, ""), U = !0), v && i(P, v) && (P = P.replace(v, "")), $ && i(P, $) && (P = P.replace($, ""), U = !0), b && o(P, b) && (P = P.slice(0, -1 * b.length)), m && (P = P.split(m).join("")), g && (P = P.replace(g, ".")), U && (ie += "-"), (ie = (ie += P).replace(/[^0-9\.\-.]/g, "")) !== "" && (ie = Number(ie), y && (ie = y(ie)), !!s(ie) && ie));
    }
    function c(p) {
      var m, g, v, b = {};
      for (p.suffix === void 0 && (p.suffix = p.postfix), m = 0; m < n.length; m += 1) if ((v = p[g = n[m]]) === void 0) g !== "negative" || b.negativeBefore ? g === "mark" && b.thousand !== "." ? b[g] = "." : b[g] = !1 : b[g] = "-";
      else if (g === "decimals") {
        if (!(v >= 0 && v < 8)) throw new Error(g);
        b[g] = v;
      } else if (g === "encoder" || g === "decoder" || g === "edit" || g === "undo") {
        if (typeof v != "function") throw new Error(g);
        b[g] = v;
      } else {
        if (typeof v != "string") throw new Error(g);
        b[g] = v;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(p, m, g) {
      var v, b = [];
      for (v = 0; v < n.length; v += 1) b.push(p[n[v]]);
      return b.push(g), m.apply("", b);
    }
    function h(p) {
      if (!(this instanceof h)) return new h(p);
      typeof p == "object" && (p = c(p), this.to = function(m) {
        return f(p, d, m);
      }, this.from = function(m) {
        return f(p, u, m);
      });
    }
    return h;
  }();
}), zL = BL(e3(function(e, t) {
  (function(n) {
    function r(B) {
      return i(B) && typeof B.from == "function";
    }
    function i(B) {
      return typeof B == "object" && typeof B.to == "function";
    }
    function o(B) {
      B.parentElement.removeChild(B);
    }
    function a(B) {
      return B != null;
    }
    function s(B) {
      B.preventDefault();
    }
    function l(B) {
      return B.filter(function(w) {
        return !this[w] && (this[w] = !0);
      }, {});
    }
    function d(B, w) {
      return Math.round(B / w) * w;
    }
    function u(B, w) {
      var ye = B.getBoundingClientRect(), Pe = B.ownerDocument, Se = Pe.documentElement, J = x(Pe);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (J.x = 0), w ? ye.top + J.y - Se.clientTop : ye.left + J.x - Se.clientLeft;
    }
    function c(B) {
      return typeof B == "number" && !isNaN(B) && isFinite(B);
    }
    function f(B, w, ye) {
      ye > 0 && (g(B, w), setTimeout(function() {
        v(B, w);
      }, ye));
    }
    function h(B) {
      return Math.max(Math.min(B, 100), 0);
    }
    function p(B) {
      return Array.isArray(B) ? B : [B];
    }
    function m(B) {
      var w = (B = String(B)).split(".");
      return w.length > 1 ? w[1].length : 0;
    }
    function g(B, w) {
      B.classList && !/\s/.test(w) ? B.classList.add(w) : B.className += " " + w;
    }
    function v(B, w) {
      B.classList && !/\s/.test(w) ? B.classList.remove(w) : B.className = B.className.replace(new RegExp("(^|\\b)" + w.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(B, w) {
      return B.classList ? B.classList.contains(w) : new RegExp("\\b" + w + "\\b").test(B.className);
    }
    function x(B) {
      var w = window.pageXOffset !== void 0, ye = (B.compatMode || "") === "CSS1Compat";
      return { x: w ? window.pageXOffset : ye ? B.documentElement.scrollLeft : B.body.scrollLeft, y: w ? window.pageYOffset : ye ? B.documentElement.scrollTop : B.body.scrollTop };
    }
    function y() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function C() {
      var B = !1;
      try {
        var w = Object.defineProperty({}, "passive", { get: function() {
          B = !0;
        } });
        window.addEventListener("test", null, w);
      } catch {
      }
      return B;
    }
    function $() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function O(B, w) {
      return 100 / (w - B);
    }
    function z(B, w, ye) {
      return 100 * w / (B[ye + 1] - B[ye]);
    }
    function P(B, w) {
      return z(B, B[0] < 0 ? w + Math.abs(B[0]) : w - B[0], 0);
    }
    function U(B, w) {
      return w * (B[1] - B[0]) / 100 + B[0];
    }
    function ie(B, w) {
      for (var ye = 1; B >= w[ye]; ) ye += 1;
      return ye;
    }
    function W(B, w, ye) {
      if (ye >= B.slice(-1)[0]) return 100;
      var Pe = ie(ye, B), Se = B[Pe - 1], J = B[Pe], be = w[Pe - 1], R = w[Pe];
      return be + P([Se, J], ye) / O(be, R);
    }
    function H(B, w, ye) {
      if (ye >= 100) return B.slice(-1)[0];
      var Pe = ie(ye, w), Se = B[Pe - 1], J = B[Pe], be = w[Pe - 1];
      return U([Se, J], (ye - be) * O(be, w[Pe]));
    }
    function _(B, w, ye, Pe) {
      if (Pe === 100) return Pe;
      var Se = ie(Pe, B), J = B[Se - 1], be = B[Se];
      return ye ? Pe - J > (be - J) / 2 ? be : J : w[Se - 1] ? B[Se - 1] + d(Pe - B[Se - 1], w[Se - 1]) : Pe;
    }
    var T, M;
    n.PipsMode = void 0, (M = n.PipsMode || (n.PipsMode = {})).Range = "range", M.Steps = "steps", M.Positions = "positions", M.Count = "count", M.Values = "values", n.PipsType = void 0, (T = n.PipsType || (n.PipsType = {}))[T.None = -1] = "None", T[T.NoValue = 0] = "NoValue", T[T.LargeValue = 1] = "LargeValue", T[T.SmallValue = 2] = "SmallValue";
    var V = function() {
      function B(w, ye, Pe) {
        var Se;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [Pe || !1], this.xNumSteps = [!1], this.snap = ye;
        var J = [];
        for (Object.keys(w).forEach(function(be) {
          J.push([p(w[be]), be]);
        }), J.sort(function(be, R) {
          return be[0][0] - R[0][0];
        }), Se = 0; Se < J.length; Se++) this.handleEntryPoint(J[Se][1], J[Se][0]);
        for (this.xNumSteps = this.xSteps.slice(0), Se = 0; Se < this.xNumSteps.length; Se++) this.handleStepPoint(Se, this.xNumSteps[Se]);
      }
      return B.prototype.getDistance = function(w) {
        for (var ye = [], Pe = 0; Pe < this.xNumSteps.length - 1; Pe++) ye[Pe] = z(this.xVal, w, Pe);
        return ye;
      }, B.prototype.getAbsoluteDistance = function(w, ye, Pe) {
        var Se, J = 0;
        if (w < this.xPct[this.xPct.length - 1]) for (; w > this.xPct[J + 1]; ) J++;
        else w === this.xPct[this.xPct.length - 1] && (J = this.xPct.length - 2);
        Pe || w !== this.xPct[J + 1] || J++, ye === null && (ye = []);
        var be = 1, R = ye[J], F = 0, ae = 0, pe = 0, we = 0;
        for (Se = Pe ? (w - this.xPct[J]) / (this.xPct[J + 1] - this.xPct[J]) : (this.xPct[J + 1] - w) / (this.xPct[J + 1] - this.xPct[J]); R > 0; ) F = this.xPct[J + 1 + we] - this.xPct[J + we], ye[J + we] * be + 100 - 100 * Se > 100 ? (ae = F * Se, be = (R - 100 * Se) / ye[J + we], Se = 1) : (ae = ye[J + we] * F / 100 * be, be = 0), Pe ? (pe -= ae, this.xPct.length + we >= 1 && we--) : (pe += ae, this.xPct.length - we >= 1 && we++), R = ye[J + we] * be;
        return w + pe;
      }, B.prototype.toStepping = function(w) {
        return w = W(this.xVal, this.xPct, w);
      }, B.prototype.fromStepping = function(w) {
        return H(this.xVal, this.xPct, w);
      }, B.prototype.getStep = function(w) {
        return w = _(this.xPct, this.xSteps, this.snap, w);
      }, B.prototype.getDefaultStep = function(w, ye, Pe) {
        var Se = ie(w, this.xPct);
        return (w === 100 || ye && w === this.xPct[Se - 1]) && (Se = Math.max(Se - 1, 1)), (this.xVal[Se] - this.xVal[Se - 1]) / Pe;
      }, B.prototype.getNearbySteps = function(w) {
        var ye = ie(w, this.xPct);
        return { stepBefore: { startValue: this.xVal[ye - 2], step: this.xNumSteps[ye - 2], highestStep: this.xHighestCompleteStep[ye - 2] }, thisStep: { startValue: this.xVal[ye - 1], step: this.xNumSteps[ye - 1], highestStep: this.xHighestCompleteStep[ye - 1] }, stepAfter: { startValue: this.xVal[ye], step: this.xNumSteps[ye], highestStep: this.xHighestCompleteStep[ye] } };
      }, B.prototype.countStepDecimals = function() {
        var w = this.xNumSteps.map(m);
        return Math.max.apply(null, w);
      }, B.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, B.prototype.convert = function(w) {
        return this.getStep(this.toStepping(w));
      }, B.prototype.handleEntryPoint = function(w, ye) {
        var Pe;
        if (!c(Pe = w === "min" ? 0 : w === "max" ? 100 : parseFloat(w)) || !c(ye[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(Pe), this.xVal.push(ye[0]);
        var Se = Number(ye[1]);
        Pe ? this.xSteps.push(!isNaN(Se) && Se) : isNaN(Se) || (this.xSteps[0] = Se), this.xHighestCompleteStep.push(0);
      }, B.prototype.handleStepPoint = function(w, ye) {
        if (ye) if (this.xVal[w] !== this.xVal[w + 1]) {
          this.xSteps[w] = z([this.xVal[w], this.xVal[w + 1]], ye, 0) / O(this.xPct[w], this.xPct[w + 1]);
          var Pe = (this.xVal[w + 1] - this.xVal[w]) / this.xNumSteps[w], Se = Math.ceil(Number(Pe.toFixed(3)) - 1), J = this.xVal[w] + this.xNumSteps[w] * Se;
          this.xHighestCompleteStep[w] = J;
        } else this.xSteps[w] = this.xHighestCompleteStep[w] = this.xVal[w];
      }, B;
    }(), Q = { to: function(B) {
      return B === void 0 ? "" : B.toFixed(2);
    }, from: Number }, ue = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, oe = { tooltips: ".__tooltips", aria: ".__aria" };
    function Y(B, w) {
      if (!c(w)) throw new Error("noUiSlider: 'step' is not numeric.");
      B.singleStep = w;
    }
    function ce(B, w) {
      if (!c(w)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      B.keyboardPageMultiplier = w;
    }
    function S(B, w) {
      if (!c(w)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      B.keyboardMultiplier = w;
    }
    function j(B, w) {
      if (!c(w)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      B.keyboardDefaultStep = w;
    }
    function Z(B, w) {
      if (typeof w != "object" || Array.isArray(w)) throw new Error("noUiSlider: 'range' is not an object.");
      if (w.min === void 0 || w.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      B.spectrum = new V(w, B.snap || !1, B.singleStep);
    }
    function ee(B, w) {
      if (w = p(w), !Array.isArray(w) || !w.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      B.handles = w.length, B.start = w;
    }
    function N(B, w) {
      if (typeof w != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      B.snap = w;
    }
    function Ce(B, w) {
      if (typeof w != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      B.animate = w;
    }
    function qe(B, w) {
      if (typeof w != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      B.animationDuration = w;
    }
    function I(B, w) {
      var ye, Pe = [!1];
      if (w === "lower" ? w = [!0, !1] : w === "upper" && (w = [!1, !0]), w === !0 || w === !1) {
        for (ye = 1; ye < B.handles; ye++) Pe.push(w);
        Pe.push(!1);
      } else {
        if (!Array.isArray(w) || !w.length || w.length !== B.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        Pe = w;
      }
      B.connect = Pe;
    }
    function Me(B, w) {
      switch (w) {
        case "horizontal":
          B.ort = 0;
          break;
        case "vertical":
          B.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function Ye(B, w) {
      if (!c(w)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      w !== 0 && (B.margin = B.spectrum.getDistance(w));
    }
    function ke(B, w) {
      if (!c(w)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (B.limit = B.spectrum.getDistance(w), !B.limit || B.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function je(B, w) {
      var ye;
      if (!c(w) && !Array.isArray(w)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(w) && w.length !== 2 && !c(w[0]) && !c(w[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (w !== 0) {
        for (Array.isArray(w) || (w = [w, w]), B.padding = [B.spectrum.getDistance(w[0]), B.spectrum.getDistance(w[1])], ye = 0; ye < B.spectrum.xNumSteps.length - 1; ye++) if (B.padding[0][ye] < 0 || B.padding[1][ye] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var Pe = w[0] + w[1], Se = B.spectrum.xVal[0];
        if (Pe / (B.spectrum.xVal[B.spectrum.xVal.length - 1] - Se) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function re(B, w) {
      switch (w) {
        case "ltr":
          B.dir = 0;
          break;
        case "rtl":
          B.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function le(B, w) {
      if (typeof w != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var ye = w.indexOf("tap") >= 0, Pe = w.indexOf("drag") >= 0, Se = w.indexOf("fixed") >= 0, J = w.indexOf("snap") >= 0, be = w.indexOf("hover") >= 0, R = w.indexOf("unconstrained") >= 0, F = w.indexOf("drag-all") >= 0, ae = w.indexOf("smooth-steps") >= 0;
      if (Se) {
        if (B.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        Ye(B, B.start[1] - B.start[0]);
      }
      if (R && (B.margin || B.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      B.events = { tap: ye || J, drag: Pe, dragAll: F, smoothSteps: ae, fixed: Se, snap: J, hover: be, unconstrained: R };
    }
    function Ke(B, w) {
      if (w !== !1) if (w === !0 || i(w)) {
        B.tooltips = [];
        for (var ye = 0; ye < B.handles; ye++) B.tooltips.push(w);
      } else {
        if ((w = p(w)).length !== B.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        w.forEach(function(Pe) {
          if (typeof Pe != "boolean" && !i(Pe)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        }), B.tooltips = w;
      }
    }
    function We(B, w) {
      if (w.length !== B.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      B.handleAttributes = w;
    }
    function Tt(B, w) {
      if (!i(w)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      B.ariaFormat = w;
    }
    function Oe(B, w) {
      if (!r(w)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      B.format = w;
    }
    function xt(B, w) {
      if (typeof w != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      B.keyboardSupport = w;
    }
    function lt(B, w) {
      B.documentElement = w;
    }
    function Yt(B, w) {
      if (typeof w != "string" && w !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      B.cssPrefix = w;
    }
    function er(B, w) {
      if (typeof w != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof B.cssPrefix == "string" ? (B.cssClasses = {}, Object.keys(w).forEach(function(ye) {
        B.cssClasses[ye] = B.cssPrefix + w[ye];
      })) : B.cssClasses = w;
    }
    function Pn(B) {
      var w = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: Q, format: Q }, ye = { step: { r: !1, t: Y }, keyboardPageMultiplier: { r: !1, t: ce }, keyboardMultiplier: { r: !1, t: S }, keyboardDefaultStep: { r: !1, t: j }, start: { r: !0, t: ee }, connect: { r: !0, t: I }, direction: { r: !0, t: re }, snap: { r: !1, t: N }, animate: { r: !1, t: Ce }, animationDuration: { r: !1, t: qe }, range: { r: !0, t: Z }, orientation: { r: !1, t: Me }, margin: { r: !1, t: Ye }, limit: { r: !1, t: ke }, padding: { r: !1, t: je }, behaviour: { r: !0, t: le }, ariaFormat: { r: !1, t: Tt }, format: { r: !1, t: Oe }, tooltips: { r: !1, t: Ke }, keyboardSupport: { r: !0, t: xt }, documentElement: { r: !1, t: lt }, cssPrefix: { r: !0, t: Yt }, cssClasses: { r: !0, t: er }, handleAttributes: { r: !1, t: We } }, Pe = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: ue, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      B.format && !B.ariaFormat && (B.ariaFormat = B.format), Object.keys(ye).forEach(function(F) {
        if (a(B[F]) || Pe[F] !== void 0) ye[F].t(w, a(B[F]) ? B[F] : Pe[F]);
        else if (ye[F].r) throw new Error("noUiSlider: '" + F + "' is required.");
      }), w.pips = B.pips;
      var Se = document.createElement("div"), J = Se.style.msTransform !== void 0, be = Se.style.transform !== void 0;
      w.transformRule = be ? "transform" : J ? "msTransform" : "webkitTransform";
      var R = [["left", "top"], ["right", "bottom"]];
      return w.style = R[w.dir][w.ort], w;
    }
    function Ht(B, w, ye) {
      var Pe, Se, J, be, R, F = y(), ae = $() && C(), pe = B, we = w.spectrum, dt = [], ut = [], gt = [], Vn = 0, jt = {}, Dt = B.ownerDocument, br = w.documentElement || Dt.documentElement, $r = Dt.body, Co = Dt.dir === "rtl" || w.ort === 1 ? 0 : 100;
      function Ur(L, X) {
        var ne = Dt.createElement("div");
        return X && g(ne, X), L.appendChild(ne), ne;
      }
      function h3(L, X) {
        var ne = Ur(L, w.cssClasses.origin), me = Ur(ne, w.cssClasses.handle);
        if (Ur(me, w.cssClasses.touchArea), me.setAttribute("data-handle", String(X)), w.keyboardSupport && (me.setAttribute("tabindex", "0"), me.addEventListener("keydown", function(Ee) {
          return O3(Ee, X);
        })), w.handleAttributes !== void 0) {
          var De = w.handleAttributes[X];
          Object.keys(De).forEach(function(Ee) {
            me.setAttribute(Ee, De[Ee]);
          });
        }
        return me.setAttribute("role", "slider"), me.setAttribute("aria-orientation", w.ort ? "vertical" : "horizontal"), X === 0 ? g(me, w.cssClasses.handleLower) : X === w.handles - 1 && g(me, w.cssClasses.handleUpper), ne;
      }
      function Gf(L, X) {
        return !!X && Ur(L, w.cssClasses.connect);
      }
      function m3(L, X) {
        var ne = Ur(X, w.cssClasses.connects);
        Se = [], (J = []).push(Gf(ne, L[0]));
        for (var me = 0; me < w.handles; me++) Se.push(h3(X, me)), gt[me] = me, J.push(Gf(ne, L[me + 1]));
      }
      function g3(L) {
        return g(L, w.cssClasses.target), w.dir === 0 ? g(L, w.cssClasses.ltr) : g(L, w.cssClasses.rtl), w.ort === 0 ? g(L, w.cssClasses.horizontal) : g(L, w.cssClasses.vertical), g(L, getComputedStyle(L).direction === "rtl" ? w.cssClasses.textDirectionRtl : w.cssClasses.textDirectionLtr), Ur(L, w.cssClasses.base);
      }
      function v3(L, X) {
        return !(!w.tooltips || !w.tooltips[X]) && Ur(L.firstChild, w.cssClasses.tooltip);
      }
      function Jf() {
        return pe.hasAttribute("disabled");
      }
      function Hd(L) {
        return Se[L].hasAttribute("disabled");
      }
      function jd() {
        R && (ga("update" + oe.tooltips), R.forEach(function(L) {
          L && o(L);
        }), R = null);
      }
      function Xf() {
        jd(), R = Se.map(v3), Kd("update" + oe.tooltips, function(L, X, ne) {
          if (R && w.tooltips && R[X] !== !1) {
            var me = L[X];
            w.tooltips[X] !== !0 && (me = w.tooltips[X].to(ne[X])), R[X].innerHTML = me;
          }
        });
      }
      function y3() {
        ga("update" + oe.aria), Kd("update" + oe.aria, function(L, X, ne, me, De) {
          gt.forEach(function(Ee) {
            var Qe = Se[Ee], _e = Cs(ut, Ee, 0, !0, !0, !0), Lt = Cs(ut, Ee, 100, !0, !0, !0), At = De[Ee], yt = String(w.ariaFormat.to(ne[Ee]));
            _e = we.fromStepping(_e).toFixed(1), Lt = we.fromStepping(Lt).toFixed(1), At = we.fromStepping(At).toFixed(1), Qe.children[0].setAttribute("aria-valuemin", _e), Qe.children[0].setAttribute("aria-valuemax", Lt), Qe.children[0].setAttribute("aria-valuenow", At), Qe.children[0].setAttribute("aria-valuetext", yt);
          });
        });
      }
      function b3(L) {
        if (L.mode === n.PipsMode.Range || L.mode === n.PipsMode.Steps) return we.xVal;
        if (L.mode === n.PipsMode.Count) {
          if (L.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var X = L.values - 1, ne = 100 / X, me = []; X--; ) me[X] = X * ne;
          return me.push(100), Qf(me, L.stepped);
        }
        return L.mode === n.PipsMode.Positions ? Qf(L.values, L.stepped) : L.mode === n.PipsMode.Values ? L.stepped ? L.values.map(function(De) {
          return we.fromStepping(we.getStep(we.toStepping(De)));
        }) : L.values : [];
      }
      function Qf(L, X) {
        return L.map(function(ne) {
          return we.fromStepping(X ? we.getStep(ne) : ne);
        });
      }
      function $3(L) {
        function X(At, yt) {
          return Number((At + yt).toFixed(7));
        }
        var ne = b3(L), me = {}, De = we.xVal[0], Ee = we.xVal[we.xVal.length - 1], Qe = !1, _e = !1, Lt = 0;
        return (ne = l(ne.slice().sort(function(At, yt) {
          return At - yt;
        })))[0] !== De && (ne.unshift(De), Qe = !0), ne[ne.length - 1] !== Ee && (ne.push(Ee), _e = !0), ne.forEach(function(At, yt) {
          var St, pt, Qt, gn, Wt, sp, Xd, lp, dp, up, Qd = At, To = ne[yt + 1], cp = L.mode === n.PipsMode.Steps;
          for (cp && (St = we.xNumSteps[yt]), St || (St = To - Qd), To === void 0 && (To = Qd), St = Math.max(St, 1e-7), pt = Qd; pt <= To; pt = X(pt, St)) {
            for (lp = (Wt = (gn = we.toStepping(pt)) - Lt) / (L.density || 1), up = Wt / (dp = Math.round(lp)), Qt = 1; Qt <= dp; Qt += 1) me[(sp = Lt + Qt * up).toFixed(5)] = [we.fromStepping(sp), 0];
            Xd = ne.indexOf(pt) > -1 ? n.PipsType.LargeValue : cp ? n.PipsType.SmallValue : n.PipsType.NoValue, !yt && Qe && pt !== To && (Xd = 0), pt === To && _e || (me[gn.toFixed(5)] = [pt, Xd]), Lt = gn;
          }
        }), me;
      }
      function w3(L, X, ne) {
        var me, De, Ee = Dt.createElement("div"), Qe = ((me = {})[n.PipsType.None] = "", me[n.PipsType.NoValue] = w.cssClasses.valueNormal, me[n.PipsType.LargeValue] = w.cssClasses.valueLarge, me[n.PipsType.SmallValue] = w.cssClasses.valueSub, me), _e = ((De = {})[n.PipsType.None] = "", De[n.PipsType.NoValue] = w.cssClasses.markerNormal, De[n.PipsType.LargeValue] = w.cssClasses.markerLarge, De[n.PipsType.SmallValue] = w.cssClasses.markerSub, De), Lt = [w.cssClasses.valueHorizontal, w.cssClasses.valueVertical], At = [w.cssClasses.markerHorizontal, w.cssClasses.markerVertical];
        function yt(pt, Qt) {
          var gn = Qt === w.cssClasses.value, Wt = gn ? Qe : _e;
          return Qt + " " + (gn ? Lt : At)[w.ort] + " " + Wt[pt];
        }
        function St(pt, Qt, gn) {
          if ((gn = X ? X(Qt, gn) : gn) !== n.PipsType.None) {
            var Wt = Ur(Ee, !1);
            Wt.className = yt(gn, w.cssClasses.marker), Wt.style[w.style] = pt + "%", gn > n.PipsType.NoValue && ((Wt = Ur(Ee, !1)).className = yt(gn, w.cssClasses.value), Wt.setAttribute("data-value", String(Qt)), Wt.style[w.style] = pt + "%", Wt.innerHTML = String(ne.to(Qt)));
          }
        }
        return g(Ee, w.cssClasses.pips), g(Ee, w.ort === 0 ? w.cssClasses.pipsHorizontal : w.cssClasses.pipsVertical), Object.keys(L).forEach(function(pt) {
          St(pt, L[pt][0], L[pt][1]);
        }), Ee;
      }
      function Wd() {
        be && (o(be), be = null);
      }
      function Ud(L) {
        Wd();
        var X = $3(L), ne = L.filter, me = L.format || { to: function(De) {
          return String(Math.round(De));
        } };
        return be = pe.appendChild(w3(X, ne, me));
      }
      function Zf() {
        var L = Pe.getBoundingClientRect(), X = "offset" + ["Width", "Height"][w.ort];
        return w.ort === 0 ? L.width || Pe[X] : L.height || Pe[X];
      }
      function ji(L, X, ne, me) {
        var De = function(Qe) {
          var _e = k3(Qe, me.pageOffset, me.target || X);
          return !!_e && !(Jf() && !me.doNotReject) && !(b(pe, w.cssClasses.tap) && !me.doNotReject) && !(L === F.start && _e.buttons !== void 0 && _e.buttons > 1) && (!me.hover || !_e.buttons) && (ae || _e.preventDefault(), _e.calcPoint = _e.points[w.ort], void ne(_e, me));
        }, Ee = [];
        return L.split(" ").forEach(function(Qe) {
          X.addEventListener(Qe, De, !!ae && { passive: !0 }), Ee.push([Qe, De]);
        }), Ee;
      }
      function k3(L, X, ne) {
        var me = L.type.indexOf("touch") === 0, De = L.type.indexOf("mouse") === 0, Ee = L.type.indexOf("pointer") === 0, Qe = 0, _e = 0;
        if (L.type.indexOf("MSPointer") === 0 && (Ee = !0), L.type === "mousedown" && !L.buttons && !L.touches) return !1;
        if (me) {
          var Lt = function(St) {
            var pt = St.target;
            return pt === ne || ne.contains(pt) || L.composed && L.composedPath().shift() === ne;
          };
          if (L.type === "touchstart") {
            var At = Array.prototype.filter.call(L.touches, Lt);
            if (At.length > 1) return !1;
            Qe = At[0].pageX, _e = At[0].pageY;
          } else {
            var yt = Array.prototype.find.call(L.changedTouches, Lt);
            if (!yt) return !1;
            Qe = yt.pageX, _e = yt.pageY;
          }
        }
        return X = X || x(Dt), (De || Ee) && (Qe = L.clientX + X.x, _e = L.clientY + X.y), L.pageOffset = X, L.points = [Qe, _e], L.cursor = De || Ee, L;
      }
      function ep(L) {
        var X = 100 * (L - u(Pe, w.ort)) / Zf();
        return X = h(X), w.dir ? 100 - X : X;
      }
      function x3(L) {
        var X = 100, ne = !1;
        return Se.forEach(function(me, De) {
          if (!Hd(De)) {
            var Ee = ut[De], Qe = Math.abs(Ee - L);
            (Qe < X || Qe <= X && L > Ee || Qe === 100 && X === 100) && (ne = De, X = Qe);
          }
        }), ne;
      }
      function S3(L, X) {
        L.type === "mouseout" && L.target.nodeName === "HTML" && L.relatedTarget === null && qd(L, X);
      }
      function C3(L, X) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && L.buttons === 0 && X.buttonsProperty !== 0) return qd(L, X);
        var ne = (w.dir ? -1 : 1) * (L.calcPoint - X.startCalcPoint);
        tp(ne > 0, 100 * ne / X.baseSize, X.locations, X.handleNumbers, X.connect);
      }
      function qd(L, X) {
        X.handle && (v(X.handle, w.cssClasses.active), Vn -= 1), X.listeners.forEach(function(ne) {
          br.removeEventListener(ne[0], ne[1]);
        }), Vn === 0 && (v(pe, w.cssClasses.drag), Jd(), L.cursor && ($r.style.cursor = "", $r.removeEventListener("selectstart", s))), w.events.smoothSteps && (X.handleNumbers.forEach(function(ne) {
          Wi(ne, ut[ne], !0, !0, !1, !1);
        }), X.handleNumbers.forEach(function(ne) {
          _t("update", ne);
        })), X.handleNumbers.forEach(function(ne) {
          _t("change", ne), _t("set", ne), _t("end", ne);
        });
      }
      function Yd(L, X) {
        if (!X.handleNumbers.some(Hd)) {
          var ne;
          X.handleNumbers.length === 1 && (ne = Se[X.handleNumbers[0]].children[0], Vn += 1, g(ne, w.cssClasses.active)), L.stopPropagation();
          var me = [], De = ji(F.move, br, C3, { target: L.target, handle: ne, connect: X.connect, listeners: me, startCalcPoint: L.calcPoint, baseSize: Zf(), pageOffset: L.pageOffset, handleNumbers: X.handleNumbers, buttonsProperty: L.buttons, locations: ut.slice() }), Ee = ji(F.end, br, qd, { target: L.target, handle: ne, listeners: me, doNotReject: !0, handleNumbers: X.handleNumbers }), Qe = ji("mouseout", br, S3, { target: L.target, handle: ne, listeners: me, doNotReject: !0, handleNumbers: X.handleNumbers });
          me.push.apply(me, De.concat(Ee, Qe)), L.cursor && ($r.style.cursor = getComputedStyle(L.target).cursor, Se.length > 1 && g(pe, w.cssClasses.drag), $r.addEventListener("selectstart", s, !1)), X.handleNumbers.forEach(function(_e) {
            _t("start", _e);
          });
        }
      }
      function T3(L) {
        L.stopPropagation();
        var X = ep(L.calcPoint), ne = x3(X);
        ne !== !1 && (w.events.snap || f(pe, w.cssClasses.tap, w.animationDuration), Wi(ne, X, !0, !0), Jd(), _t("slide", ne, !0), _t("update", ne, !0), w.events.snap ? Yd(L, { handleNumbers: [ne] }) : (_t("change", ne, !0), _t("set", ne, !0)));
      }
      function M3(L) {
        var X = ep(L.calcPoint), ne = we.getStep(X), me = we.fromStepping(ne);
        Object.keys(jt).forEach(function(De) {
          De.split(".")[0] === "hover" && jt[De].forEach(function(Ee) {
            Ee.call(Ms, me);
          });
        });
      }
      function O3(L, X) {
        if (Jf() || Hd(X)) return !1;
        var ne = ["Left", "Right"], me = ["Down", "Up"], De = ["PageDown", "PageUp"], Ee = ["Home", "End"];
        w.dir && !w.ort ? ne.reverse() : w.ort && !w.dir && (me.reverse(), De.reverse());
        var Qe, _e = L.key.replace("Arrow", ""), Lt = _e === De[0], At = _e === De[1], yt = _e === me[0] || _e === ne[0] || Lt, St = _e === me[1] || _e === ne[1] || At, pt = _e === Ee[0], Qt = _e === Ee[1];
        if (!(yt || St || pt || Qt)) return !0;
        if (L.preventDefault(), St || yt) {
          var gn = yt ? 0 : 1, Wt = ap(X)[gn];
          if (Wt === null) return !1;
          Wt === !1 && (Wt = we.getDefaultStep(ut[X], yt, w.keyboardDefaultStep)), Wt *= At || Lt ? w.keyboardPageMultiplier : w.keyboardMultiplier, Wt = Math.max(Wt, 1e-7), Wt *= yt ? -1 : 1, Qe = dt[X] + Wt;
        } else Qe = Qt ? w.spectrum.xVal[w.spectrum.xVal.length - 1] : w.spectrum.xVal[0];
        return Wi(X, we.toStepping(Qe), !0, !0), _t("slide", X), _t("update", X), _t("change", X), _t("set", X), !1;
      }
      function E3(L) {
        L.fixed || Se.forEach(function(X, ne) {
          ji(F.start, X.children[0], Yd, { handleNumbers: [ne] });
        }), L.tap && ji(F.start, Pe, T3, {}), L.hover && ji(F.move, Pe, M3, { hover: !0 }), L.drag && J.forEach(function(X, ne) {
          if (X !== !1 && ne !== 0 && ne !== J.length - 1) {
            var me = Se[ne - 1], De = Se[ne], Ee = [X], Qe = [me, De], _e = [ne - 1, ne];
            g(X, w.cssClasses.draggable), L.fixed && (Ee.push(me.children[0]), Ee.push(De.children[0])), L.dragAll && (Qe = Se, _e = gt), Ee.forEach(function(Lt) {
              ji(F.start, Lt, Yd, { handles: Qe, handleNumbers: _e, connect: X });
            });
          }
        });
      }
      function Kd(L, X) {
        jt[L] = jt[L] || [], jt[L].push(X), L.split(".")[0] === "update" && Se.forEach(function(ne, me) {
          _t("update", me);
        });
      }
      function D3(L) {
        return L === oe.aria || L === oe.tooltips;
      }
      function ga(L) {
        var X = L && L.split(".")[0], ne = X ? L.substring(X.length) : L;
        Object.keys(jt).forEach(function(me) {
          var De = me.split(".")[0], Ee = me.substring(De.length);
          X && X !== De || ne && ne !== Ee || D3(Ee) && ne !== Ee || delete jt[me];
        });
      }
      function _t(L, X, ne) {
        Object.keys(jt).forEach(function(me) {
          var De = me.split(".")[0];
          L === De && jt[me].forEach(function(Ee) {
            Ee.call(Ms, dt.map(w.format.to), X, dt.slice(), ne || !1, ut.slice(), Ms);
          });
        });
      }
      function Cs(L, X, ne, me, De, Ee, Qe) {
        var _e;
        return Se.length > 1 && !w.events.unconstrained && (me && X > 0 && (_e = we.getAbsoluteDistance(L[X - 1], w.margin, !1), ne = Math.max(ne, _e)), De && X < Se.length - 1 && (_e = we.getAbsoluteDistance(L[X + 1], w.margin, !0), ne = Math.min(ne, _e))), Se.length > 1 && w.limit && (me && X > 0 && (_e = we.getAbsoluteDistance(L[X - 1], w.limit, !1), ne = Math.min(ne, _e)), De && X < Se.length - 1 && (_e = we.getAbsoluteDistance(L[X + 1], w.limit, !0), ne = Math.max(ne, _e))), w.padding && (X === 0 && (_e = we.getAbsoluteDistance(0, w.padding[0], !1), ne = Math.max(ne, _e)), X === Se.length - 1 && (_e = we.getAbsoluteDistance(100, w.padding[1], !0), ne = Math.min(ne, _e))), Qe || (ne = we.getStep(ne)), !((ne = h(ne)) === L[X] && !Ee) && ne;
      }
      function Gd(L, X) {
        var ne = w.ort;
        return (ne ? X : L) + ", " + (ne ? L : X);
      }
      function tp(L, X, ne, me, De) {
        var Ee = ne.slice(), Qe = me[0], _e = w.events.smoothSteps, Lt = [!L, L], At = [L, !L];
        me = me.slice(), L && me.reverse(), me.length > 1 ? me.forEach(function(St, pt) {
          var Qt = Cs(Ee, St, Ee[St] + X, Lt[pt], At[pt], !1, _e);
          Qt === !1 ? X = 0 : (X = Qt - Ee[St], Ee[St] = Qt);
        }) : Lt = At = [!0];
        var yt = !1;
        me.forEach(function(St, pt) {
          yt = Wi(St, ne[St] + X, Lt[pt], At[pt], !1, _e) || yt;
        }), yt && (me.forEach(function(St) {
          _t("update", St), _t("slide", St);
        }), De != null && _t("drag", Qe));
      }
      function np(L, X) {
        return w.dir ? 100 - L - X : L;
      }
      function A3(L, X) {
        ut[L] = X, dt[L] = we.fromStepping(X);
        var ne = "translate(" + Gd(np(X, 0) - Co + "%", "0") + ")";
        Se[L].style[w.transformRule] = ne, rp(L), rp(L + 1);
      }
      function Jd() {
        gt.forEach(function(L) {
          var X = ut[L] > 50 ? -1 : 1, ne = 3 + (Se.length + X * L);
          Se[L].style.zIndex = String(ne);
        });
      }
      function Wi(L, X, ne, me, De, Ee) {
        return De || (X = Cs(ut, L, X, ne, me, !1, Ee)), X !== !1 && (A3(L, X), !0);
      }
      function rp(L) {
        if (J[L]) {
          var X = 0, ne = 100;
          L !== 0 && (X = ut[L - 1]), L !== J.length - 1 && (ne = ut[L]);
          var me = ne - X, De = "translate(" + Gd(np(X, me) + "%", "0") + ")", Ee = "scale(" + Gd(me / 100, "1") + ")";
          J[L].style[w.transformRule] = De + " " + Ee;
        }
      }
      function ip(L, X) {
        return L === null || L === !1 || L === void 0 ? ut[X] : (typeof L == "number" && (L = String(L)), (L = w.format.from(L)) !== !1 && (L = we.toStepping(L)), L === !1 || isNaN(L) ? ut[X] : L);
      }
      function Ts(L, X, ne) {
        var me = p(L), De = ut[0] === void 0;
        X = X === void 0 || X, w.animate && !De && f(pe, w.cssClasses.tap, w.animationDuration), gt.forEach(function(_e) {
          Wi(_e, ip(me[_e], _e), !0, !1, ne);
        });
        var Ee = gt.length === 1 ? 0 : 1;
        if (De && we.hasNoSize() && (ne = !0, ut[0] = 0, gt.length > 1)) {
          var Qe = 100 / (gt.length - 1);
          gt.forEach(function(_e) {
            ut[_e] = _e * Qe;
          });
        }
        for (; Ee < gt.length; ++Ee) gt.forEach(function(_e) {
          Wi(_e, ut[_e], !0, !0, ne);
        });
        Jd(), gt.forEach(function(_e) {
          _t("update", _e), me[_e] !== null && X && _t("set", _e);
        });
      }
      function P3(L) {
        Ts(w.start, L);
      }
      function N3(L, X, ne, me) {
        if (!((L = Number(L)) >= 0 && L < gt.length)) throw new Error("noUiSlider: invalid handle number, got: " + L);
        Wi(L, ip(X, L), !0, !0, me), _t("update", L), ne && _t("set", L);
      }
      function op(L) {
        if (L === void 0 && (L = !1), L) return dt.length === 1 ? dt[0] : dt.slice(0);
        var X = dt.map(w.format.to);
        return X.length === 1 ? X[0] : X;
      }
      function I3() {
        for (ga(oe.aria), ga(oe.tooltips), Object.keys(w.cssClasses).forEach(function(L) {
          v(pe, w.cssClasses[L]);
        }); pe.firstChild; ) pe.removeChild(pe.firstChild);
        delete pe.noUiSlider;
      }
      function ap(L) {
        var X = ut[L], ne = we.getNearbySteps(X), me = dt[L], De = ne.thisStep.step, Ee = null;
        if (w.snap) return [me - ne.stepBefore.startValue || null, ne.stepAfter.startValue - me || null];
        De !== !1 && me + De > ne.stepAfter.startValue && (De = ne.stepAfter.startValue - me), Ee = me > ne.thisStep.startValue ? ne.thisStep.step : ne.stepBefore.step !== !1 && me - ne.stepBefore.highestStep, X === 100 ? De = null : X === 0 && (Ee = null);
        var Qe = we.countStepDecimals();
        return De !== null && De !== !1 && (De = Number(De.toFixed(Qe))), Ee !== null && Ee !== !1 && (Ee = Number(Ee.toFixed(Qe))), [Ee, De];
      }
      function R3() {
        return gt.map(ap);
      }
      function _3(L, X) {
        var ne = op(), me = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        me.forEach(function(Ee) {
          L[Ee] !== void 0 && (ye[Ee] = L[Ee]);
        });
        var De = Pn(ye);
        me.forEach(function(Ee) {
          L[Ee] !== void 0 && (w[Ee] = De[Ee]);
        }), we = De.spectrum, w.margin = De.margin, w.limit = De.limit, w.padding = De.padding, w.pips ? Ud(w.pips) : Wd(), w.tooltips ? Xf() : jd(), ut = [], Ts(a(L.start) ? L.start : ne, X);
      }
      function L3() {
        Pe = g3(pe), m3(w.connect, Pe), E3(w.events), Ts(w.start), w.pips && Ud(w.pips), w.tooltips && Xf(), y3();
      }
      L3();
      var Ms = { destroy: I3, steps: R3, on: Kd, off: ga, get: op, set: Ts, setHandle: N3, reset: P3, __moveHandles: function(L, X, ne) {
        tp(L, X, ut, ne);
      }, options: ye, updateOptions: _3, target: pe, removePips: Wd, removeTooltips: jd, getPositions: function() {
        return ut.slice();
      }, getTooltips: function() {
        return R;
      }, getOrigins: function() {
        return Se;
      }, pips: Ud };
      return Ms;
    }
    function Nn(B, w) {
      if (!B || !B.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + B);
      if (B.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var ye = Ht(B, Pn(w), w);
      return B.noUiSlider = ye, ye;
    }
    var yr = { __spectrum: V, cssClasses: ue, create: Nn };
    n.create = Nn, n.cssClasses = ue, n.default = yr, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
}));
function um(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every(function(r, i) {
    return r === n[i];
  });
}
var Xc = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = function(a, s, l) {
    const { value: d, modelValue: u, min: c } = Os(a);
    let f = u && u.value !== void 0 ? u : d;
    const h = q(f.value);
    if (qs(f.value) && (f = q(c.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: h };
  }(e), r = function(a, s, l) {
    const { classes: d, showTooltip: u, tooltipPosition: c, orientation: f } = Os(a), h = E(() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...d.value }));
    return { classList: E(() => {
      const p = { ...h.value };
      return Object.keys(p).forEach((m) => {
        p[m] = Array.isArray(p[m]) ? p[m].filter((g) => g !== null).join(" ") : p[m];
      }), u.value !== "always" && (p.target += ` ${u.value === "drag" ? p.tooltipDrag : p.tooltipFocus}`), f.value === "horizontal" && (p.tooltip += c.value === "bottom" ? ` ${p.tooltipBottom}` : ` ${p.tooltipTop}`), f.value === "vertical" && (p.tooltip += c.value === "right" ? ` ${p.tooltipRight}` : ` ${p.tooltipLeft}`), p;
    }) };
  }(e), i = function(a, s, l) {
    const { format: d, step: u } = Os(a), c = l.value, f = l.classList, h = E(() => d && d.value ? typeof d.value == "function" ? { to: d.value } : dm({ ...d.value }) : dm({ decimals: u.value >= 0 ? 0 : 2 })), p = E(() => Array.isArray(c.value) ? c.value.map((m) => h.value) : h.value);
    return { tooltipFormat: h, tooltipsFormat: p, tooltipsMerge: (m, g, v) => {
      var b = getComputedStyle(m).direction === "rtl", x = m.noUiSlider.options.direction === "rtl", y = m.noUiSlider.options.orientation === "vertical", C = m.noUiSlider.getTooltips(), $ = m.noUiSlider.getOrigins();
      C.forEach(function(O, z) {
        O && $[z].appendChild(O);
      }), m.noUiSlider.on("update", function(O, z, P, U, ie) {
        var W = [[]], H = [[]], _ = [[]], T = 0;
        C[0] && (W[0][0] = 0, H[0][0] = ie[0], _[0][0] = h.value.to(parseFloat(O[0])));
        for (var M = 1; M < O.length; M++) (!C[M] || O[M] - O[M - 1] > g) && (W[++T] = [], _[T] = [], H[T] = []), C[M] && (W[T].push(M), _[T].push(h.value.to(parseFloat(O[M]))), H[T].push(ie[M]));
        W.forEach(function(V, Q) {
          for (var ue = V.length, oe = 0; oe < ue; oe++) {
            var Y = V[oe];
            if (oe === ue - 1) {
              var ce = 0;
              H[Q].forEach(function(ee) {
                ce += 1e3 - ee;
              });
              var S = y ? "bottom" : "right", j = x ? 0 : ue - 1, Z = 1e3 - H[Q][j];
              ce = (b && !y ? 100 : 0) + ce / ue - Z, C[Y].innerHTML = _[Q].join(v), C[Y].style.display = "block", C[Y].style[S] = ce + "%", f.value.tooltipHidden.split(" ").forEach((ee) => {
                C[Y].classList.contains(ee) && C[Y].classList.remove(ee);
              });
            } else C[Y].style.display = "none", f.value.tooltipHidden.split(" ").forEach((ee) => {
              C[Y].classList.add(ee);
            });
          }
        });
      });
    } };
  }(e, 0, { value: n.value, classList: r.classList }), o = function(a, s, l) {
    const { orientation: d, direction: u, tooltips: c, step: f, min: h, max: p, merge: m, id: g, disabled: v, options: b, classes: x, format: y, lazy: C, ariaLabelledby: $, aria: O } = Os(a), z = l.value, P = l.initialValue, U = l.tooltipsFormat, ie = l.tooltipsMerge, W = l.tooltipFormat, H = l.classList, _ = q(null), T = q(null), M = q(!1), V = E(() => {
      let ee = { cssPrefix: "", cssClasses: H.value, orientation: d.value, direction: u.value, tooltips: !!c.value && U.value, connect: "lower", start: qs(z.value) ? h.value : z.value, range: { min: h.value, max: p.value } };
      if (f.value > 0 && (ee.step = f.value), Array.isArray(z.value) && (ee.connect = !0), $ && $.value || O && Object.keys(O.value).length) {
        let N = Array.isArray(z.value) ? z.value : [z.value];
        ee.handleAttributes = N.map((Ce) => Object.assign({}, O.value, $ && $.value ? { "aria-labelledby": $.value } : {}));
      }
      return y.value && (ee.ariaFormat = W.value), ee;
    }), Q = E(() => {
      let ee = { id: g && g.value ? g.value : void 0 };
      return v.value && (ee.disabled = !0), ee;
    }), ue = E(() => Array.isArray(z.value)), oe = () => {
      let ee = T.value.get();
      return Array.isArray(ee) ? ee.map((N) => parseFloat(N)) : parseFloat(ee);
    }, Y = function(ee) {
      let N = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      T.value.set(ee, N);
    }, ce = (ee) => {
      s.emit("input", ee), s.emit("update:modelValue", ee), s.emit("update", ee);
    }, S = () => {
      T.value = zL.create(_.value, Object.assign({}, V.value, b.value)), c.value && ue.value && m.value >= 0 && ie(_.value, m.value, " - "), T.value.on("set", () => {
        const ee = oe();
        s.emit("change", ee), s.emit("set", ee), C.value && ce(ee);
      }), T.value.on("update", () => {
        if (!M.value) return;
        const ee = oe();
        ue.value && um(z.value, ee) || !ue.value && z.value == ee ? s.emit("update", ee) : C.value || ce(ee);
      }), T.value.on("start", () => {
        s.emit("start", oe());
      }), T.value.on("end", () => {
        s.emit("end", oe());
      }), T.value.on("slide", () => {
        s.emit("slide", oe());
      }), T.value.on("drag", () => {
        s.emit("drag", oe());
      }), _.value.querySelectorAll("[data-handle]").forEach((ee) => {
        ee.onblur = () => {
          _.value && H.value.focused.split(" ").forEach((N) => {
            _.value.classList.remove(N);
          });
        }, ee.onfocus = () => {
          H.value.focused.split(" ").forEach((N) => {
            _.value.classList.add(N);
          });
        };
      }), M.value = !0;
    }, j = () => {
      T.value.off(), T.value.destroy(), T.value = null;
    }, Z = (ee, N) => {
      M.value = !1, j(), S();
    };
    return ot(S), hr(j), Fe(ue, Z, { immediate: !1 }), Fe(h, Z, { immediate: !1 }), Fe(p, Z, { immediate: !1 }), Fe(f, Z, { immediate: !1 }), Fe(d, Z, { immediate: !1 }), Fe(u, Z, { immediate: !1 }), Fe(c, Z, { immediate: !1 }), Fe(m, Z, { immediate: !1 }), Fe(y, Z, { immediate: !1, deep: !0 }), Fe(b, Z, { immediate: !1, deep: !0 }), Fe(x, Z, { immediate: !1, deep: !0 }), Fe(z, (ee, N) => {
      N && (typeof N == "object" && typeof ee == "object" && ee && Object.keys(N) > Object.keys(ee) || typeof N == "object" && typeof ee != "object" || qs(ee)) && Z();
    }, { immediate: !1 }), Fe(z, (ee) => {
      if (qs(ee)) return void Y(h.value, !1);
      let N = oe();
      ue.value && !Array.isArray(N) && (N = [N]), (ue.value && !um(ee, N) || !ue.value && ee != N) && Y(ee, !1);
    }, { deep: !0 }), { slider: _, slider$: T, isRange: ue, sliderProps: Q, init: S, destroy: j, refresh: Z, update: Y, reset: () => {
      ce(P.value);
    } };
  }(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: i.tooltipFormat, tooltipsFormat: i.tooltipsFormat, tooltipsMerge: i.tooltipsMerge, classList: r.classList });
  return { ...r, ...i, ...o };
} };
Xc.render = function(e, t, n, r, i, o) {
  return k(), A("div", $t(e.sliderProps, { ref: "slider" }), null, 16);
}, Xc.__file = "src/Slider.vue";
const VL = $e({
  name: "DsSlider",
  components: { Slider: Xc },
  props: {
    modelValue: {
      type: [Number, Array],
      required: !0
    },
    disabled: {
      type: Boolean
    },
    options: {
      type: Object,
      default: null
    }
  },
  emits: ["update:modelValue"],
  setup(e, t) {
    return {
      value: E({
        get: () => e.modelValue,
        set(n) {
          t.emit("update:modelValue", n);
        }
      })
    };
  }
});
function HL(e, t, n, r, i, o) {
  var s, l, d, u, c, f, h, p, m, g;
  const a = Be("Slider");
  return k(), ge(a, {
    modelValue: e.value,
    "onUpdate:modelValue": t[0] || (t[0] = (v) => e.value = v),
    min: (s = e.options) == null ? void 0 : s.min,
    max: (l = e.options) == null ? void 0 : l.max,
    disabled: e.disabled,
    step: (d = e.options) == null ? void 0 : d.step,
    tooltips: (u = e.options) == null ? void 0 : u.tooltips,
    "tooltip-position": (c = e.options) == null ? void 0 : c.tooltipPosition,
    "show-tooltip": (f = e.options) == null ? void 0 : f.showTooltip,
    format: (h = e.options) == null ? void 0 : h.format,
    orientation: (p = e.options) == null ? void 0 : p.orientation,
    direction: (m = e.options) == null ? void 0 : m.direction,
    lazy: (g = e.options) == null ? void 0 : g.lazy,
    class: "ds-slider"
  }, null, 8, ["modelValue", "min", "max", "disabled", "step", "tooltips", "tooltip-position", "show-tooltip", "format", "orientation", "direction", "lazy"]);
}
const lH = /* @__PURE__ */ Je(VL, [["render", HL]]), jL = $e({
  name: "DsSelect",
  components: {
    DsIcon: Ue,
    DsInput: pa,
    DsDropdown: Cd,
    DsLoadingState: $s
  },
  props: {
    /**
     * Either a list of strings, or a list of objects holding the values.
     */
    data: {
      type: Array,
      required: !0
    },
    /**
     * Key in the `data` array (of objects) that should be used for the value.
     */
    valueKey: {
      type: String,
      default: "value"
    },
    /**
     * Return the whole object as a value instead of the value key.
     */
    objectAsValue: {
      type: Boolean
    },
    /**
     * Key in the `data` array (of objects) that should be used for grouping.
     */
    groupKey: {
      type: String,
      default: ""
    },
    searchKeys: {
      type: Array,
      default: () => []
    },
    /**
     * If a group is given, specify the order in which you want
     * the groups to appear.
     * */
    groupKeyOrder: {
      type: Array,
      default: () => []
    },
    /**
     * The value of the control.
     */
    modelValue: {
      type: [Number, String, Object, null],
      default: null
    },
    labelKey: {
      type: String,
      default: "label"
    },
    /**
     * Defines that the value cannot be empty
     * so that outputting a correct value is required
     */
    required: {
      type: Boolean
    },
    minSearchLength: {
      type: Number,
      default: 0
    },
    onSearch: {
      type: Function,
      default: null
    },
    debounceSearch: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: "Keine Auswahl"
    },
    placement: {
      type: String,
      default: "bottom"
    },
    dropdownWidth: {
      type: Number,
      default: null
    },
    /**
     * Removes the border to let it blend in with the background.
     */
    inline: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    },
    id: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: "base"
    },
    /**
     * Virtualize dropdown list. Does not work for grouped dropdowns at the moment.
     */
    virtualized: {
      type: Boolean
    },
    /**
     * Only needed if virtualized. Defines the height of each item.
     */
    itemHeight: {
      type: Number,
      default: 0
    },
    /**
     * Disable maximum height of dropdown item list (max-height: 16rem).
     */
    disableMaxHeight: {
      type: Boolean
    },
    noResultsDropdownInfoText: {
      type: String,
      default: "Keine Ergebnisse gefunden."
    },
    /**
     * Keeps the search results available after one item has been selected
     */
    showAsyncResultsAfterSelection: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(e, t) {
    const n = q(), r = q("");
    function i(m) {
      return yn(m) ? m[e.labelKey].toString() : m.toString();
    }
    const o = E({
      get: () => r.value,
      set: Q0((m) => {
        r.value = m;
      }, e.debounceSearch ? 300 : 0)
    }), a = E(() => r.value.length > Math.min(1, e.minSearchLength)), s = E(() => r.value.length < e.minSearchLength && !e.showAsyncResultsAfterSelection ? [] : e.onSearch !== null ? e.data : Ry(
      r.value,
      e.data,
      { searchKeys: [...e.searchKeys, e.labelKey] }
    )), l = q(e.modelValue);
    Fe(() => e.modelValue, (m) => {
      l.value = m;
    });
    const d = E({
      // we always need to return the object here
      get: () => {
        var m;
        return yn(e.data[0]) && !yn(l.value) ? (m = e.data.find((v) => cl(v, e.valueKey) === e.modelValue)) != null ? m : null : l.value;
      },
      set: (m) => {
        var v;
        if (e.required && (m === null || m < 0))
          return;
        const g = m !== null && !yn(m) && (v = s.value[m]) != null ? v : null;
        l.value = g, r.value = "", yn(g) && !e.objectAsValue ? t.emit("update:modelValue", cl(g, e.valueKey)) : t.emit("update:modelValue", g);
      }
    }), u = q(0), c = E(() => u.value > 0);
    Fe(r, async () => {
      e.onSearch === null || r.value.length < e.minSearchLength || (u.value++, await e.onSearch(r.value), u.value--);
    });
    const f = q(e.minSearchLength > 0), h = async () => {
      var m;
      await an(), (m = n.value) == null || m.focus();
    };
    return {
      entry: d,
      internalEntry: l,
      props: e,
      getLabel: i,
      handleOverflowChange: (m) => {
        if (!(e.minSearchLength > 0 || r.value.length > 0)) {
          if (m) {
            f.value = !0, h();
            return;
          }
          f.value = !1;
        }
      },
      search: n,
      searchQuery: r,
      debounceSearchQuery: o,
      showSearch: f,
      results: s,
      showResults: a,
      focusSearch: h,
      isSearchLoading: c,
      sizeClasses: E(() => ml[e.size])
    };
  }
}), WL = { class: "grow truncate" }, UL = { class: "text-gray-900" }, qL = {
  key: 1,
  class: "text-gray-500"
}, YL = ["disabled"], KL = { class: "p-px border-b border-gray-200" }, GL = { class: "text-gray-900" }, JL = { class: "relative p-1 text-sm text-center text-gray-500" };
function XL(e, t, n, r, i, o) {
  const a = Be("DsLoadingState"), s = Be("DsIcon"), l = Be("DsInput"), d = Be("DsDropdown");
  return k(), ge(d, {
    id: e.id,
    items: e.results,
    "button-class": {
      "flex items-center space-x-2 text-left border rounded sm:leading-5 focus:outline-none relative": !0,
      "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed": e.disabled,
      "bg-white focus:shadow-outline-blue focus:border-blue-500 cursor-pointer": !e.disabled,
      "inline-flex border-transparent": e.inline,
      "flex w-full": !e.inline,
      "shadow-sm border-gray-300": !e.disabled && !e.inline,
      [e.sizeClasses]: !0
    },
    "list-class": "m-1",
    "item-class": "px-2 py-1 rounded-sm",
    "scroll-y-margin": 4,
    placement: e.placement,
    width: e.dropdownWidth,
    disabled: e.disabled || e.isLoading,
    "group-key": e.groupKey,
    "group-key-order": e.groupKeyOrder,
    "item-height": e.itemHeight,
    virtualized: e.virtualized,
    onSelect: t[2] || (t[2] = (u) => e.entry = u),
    onOpen: e.focusSearch,
    onClose: t[3] || (t[3] = (u) => e.searchQuery = ""),
    onKeydown: t[4] || (t[4] = Re((u) => !e.disabled && !e.required ? e.entry = null : null, ["delete"])),
    onIsOverflowing: e.handleOverflowChange
  }, qt({
    button: de(({ isOpen: u }) => [
      G("div", WL, [
        fe(a, {
          "is-loading": e.isLoading,
          class: "text-lg"
        }, null, 8, ["is-loading"]),
        e.entry !== null ? se(e.$slots, "entry", {
          key: 0,
          entry: e.entry
        }, () => [
          G("span", UL, Te(e.getLabel(e.entry)), 1)
        ]) : (k(), A("span", qL, Te(e.placeholder), 1))
      ]),
      G("div", {
        class: te(["shrink-0 pt-px", e.disabled ? "text-gray-300" : "text-gray-500"])
      }, [
        e.entry !== null && !e.required ? (k(), A("button", {
          key: 0,
          type: "button",
          disabled: e.disabled,
          class: te([{ "cursor-not-allowed": e.disabled }, "px-2 focus:outline-none"]),
          tabindex: "-1",
          onClick: t[0] || (t[0] = Ge((c) => e.entry = null, ["stop"]))
        }, [
          fe(s, {
            name: "xmark",
            variant: "regular"
          })
        ], 10, YL)) : K("", !0),
        fe(s, {
          name: u ? "chevron-up" : "chevron-down"
        }, null, 8, ["name"])
      ], 2)
    ]),
    item: de(({ item: u }) => [
      se(e.$slots, "entry", { entry: u }, () => [
        G("span", GL, Te(e.getLabel(u)), 1)
      ])
    ]),
    "no-items": de(() => [
      G("div", JL, [
        e.searchQuery.length < e.minSearchLength ? (k(), A(Ie, { key: 0 }, [
          it(" Mind. " + Te(e.minSearchLength) + " Zeichen zum Suchen... ", 1)
        ], 64)) : (k(), A(Ie, { key: 1 }, [
          fe(a, {
            "is-loading": e.isSearchLoading,
            class: "text-lg",
            opaque: ""
          }, null, 8, ["is-loading"]),
          it(" " + Te(e.noResultsDropdownInfoText), 1)
        ], 64))
      ])
    ]),
    _: 2
  }, [
    e.showSearch ? {
      name: "extra",
      fn: de(() => [
        G("div", KL, [
          fe(l, {
            ref: "search",
            modelValue: e.debounceSearchQuery,
            "onUpdate:modelValue": t[1] || (t[1] = (u) => e.debounceSearchQuery = u),
            icon: "search",
            placeholder: "Suchen...",
            immediate: "",
            inline: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["id", "items", "button-class", "placement", "width", "disabled", "group-key", "group-key-order", "item-height", "virtualized", "onOpen", "onIsOverflowing"]);
}
const dH = /* @__PURE__ */ Je(jL, [["render", XL]]), uH = /* @__PURE__ */ $e({
  __name: "DsSkeleton",
  props: {
    gradient: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (k(), A("div", {
      class: te({
        "animate-pulse rounded": !0,
        "bg-gradient-to-br from-gray-300 to-gray-200": t.gradient,
        "bg-gray-300": !t.gradient
      })
    }, null, 2));
  }
}), t3 = Symbol("StepperProvider"), Yr = {
  icon: {
    0: "text-gray-700",
    1: "text-white",
    2: "text-gray-300"
  },
  iconContainer: {
    0: "bg-gray-200 text-gray-700",
    1: "bg-blue-500 text-blue-500",
    2: "bg-gray-100 text-gray-200"
  },
  label: {
    0: "text-gray-700",
    1: "text-blue-500",
    2: "text-gray-200"
  }
}, QL = $e({
  name: "DsStep",
  components: { DsIcon: Ue },
  props: {
    icon: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    step: {
      type: Number,
      required: !0
    },
    clickable: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    const t = Zn(t3);
    if (t === void 0)
      throw new Error("Stepper not injected");
    const n = E(() => e.step <= t.activeStep.value), r = E(() => e.disabled), i = E(() => e.step === t.registeredSteps.value[0]), o = () => {
      !e.clickable || r.value || (t.activeStep.value = e.step);
    }, a = E(() => {
      const s = {
        icon: Yr.icon[
          0
          /* DEFAULT */
        ],
        iconContainer: Yr.iconContainer[
          0
          /* DEFAULT */
        ],
        label: Yr.label[
          0
          /* DEFAULT */
        ]
      };
      return n.value ? (s.icon = Yr.icon[
        1
        /* ACTIVE_OR_COMLETED */
      ], s.iconContainer = Yr.iconContainer[
        1
        /* ACTIVE_OR_COMLETED */
      ], s.label = Yr.label[
        1
        /* ACTIVE_OR_COMLETED */
      ]) : r.value && (s.icon = Yr.icon[
        2
        /* DISABLED */
      ], s.iconContainer = Yr.iconContainer[
        2
        /* DISABLED */
      ], s.label = Yr.label[
        2
        /* DISABLED */
      ]), s;
    });
    return ot(() => t.register(e.step)), hr(() => t.unregister(e.step)), {
      setActive: o,
      isActive: n,
      isDisabled: r,
      activeStyle: a,
      isFirst: i
    };
  }
}), ZL = "_step_1k248_2", eF = {
  step: ZL
}, tF = { class: "flex flex-col items-center flex-1" }, nF = ["active", "first", "disabled"];
function rF(e, t, n, r, i, o) {
  const a = Be("DsIcon");
  return k(), A("div", tF, [
    G("div", {
      class: te(["flex justify-center relative w-full", e.$style.step]),
      active: e.isActive,
      first: e.isFirst,
      disabled: e.isDisabled
    }, [
      (k(), ge(Qn(e.clickable ? "button" : "div"), {
        class: te(["w-14 h-14 flex items-center justify-center text-xl rounded-full z-10", e.activeStyle.iconContainer]),
        type: "button",
        disabled: e.isDisabled,
        onClick: e.setActive
      }, {
        default: de(() => [
          fe(a, {
            name: e.icon,
            class: te([e.activeStyle.icon]),
            "fixed-width": ""
          }, null, 8, ["name", "class"])
        ]),
        _: 1
      }, 8, ["class", "disabled", "onClick"]))
    ], 10, nF),
    G("span", {
      class: te(["text-sm text-center mt-1 px-4 font-semibold", [e.activeStyle.label]])
    }, Te(e.label), 3)
  ]);
}
const iF = {
  $style: eF
}, cH = /* @__PURE__ */ Je(QL, [["render", rF], ["__cssModules", iF]]), oF = $e({
  name: "DsStepper",
  props: {
    activeStep: {
      type: Number,
      default: 1
    }
  },
  emits: {
    change(e) {
      return typeof e == "number";
    }
  },
  setup(e, { emit: t }) {
    const n = q(e.activeStep), r = q([]);
    mr(t3, {
      activeStep: n,
      registeredSteps: r,
      register(i) {
        r.value.push(i);
      },
      unregister(i) {
        r.value = r.value.filter((o) => o !== i), i === n.value && (n.value = i > 1 ? n.value - 1 : 1);
      }
    }), Fe(() => e.activeStep, (i) => {
      n.value = i;
    }), Fe(() => n.value, () => {
      t("change", n.value);
    });
  }
}), aF = { class: "flex flex-auto" };
function sF(e, t, n, r, i, o) {
  return k(), A("div", aF, [
    se(e.$slots, "default")
  ]);
}
const fH = /* @__PURE__ */ Je(oF, [["render", sF]]), lF = {
  sm: {
    box: "h-4 w-7",
    dot: "h-3 w-3",
    translate: "translate-x-3",
    text: "text-sm"
  },
  md: {
    box: "h-5 w-9",
    dot: "h-4 w-4",
    translate: "translate-x-4",
    text: "text-base"
  },
  lg: {
    box: "h-6 w-10",
    dot: "h-5 w-5",
    translate: "translate-x-4",
    text: "text-base"
  }
}, dF = $e({
  name: "DsSwitch",
  components: {
    HUISwitch: bL,
    HUISwitchGroup: yL,
    HUISwitchLabel: $L
  },
  props: {
    disabled: {
      type: Boolean
    },
    modelValue: {
      type: Boolean
    },
    size: {
      type: String,
      default: "sm"
    },
    labelFirst: {
      type: Boolean
    },
    labelGrow: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(e, t) {
    const n = q(!1);
    return {
      sizes: lF,
      focus: n,
      activeColor: E(() => e.disabled ? "bg-gray-300" : "bg-blue-500"),
      inactiveColor: E(() => e.disabled ? "bg-gray-100" : "bg-gray-200"),
      active: E({
        get: () => e.modelValue,
        set: (r) => {
          t.emit("update:modelValue", r);
        }
      })
    };
  }
});
function uF(e, t, n, r, i, o) {
  const a = Be("HUISwitch"), s = Be("HUISwitchLabel"), l = Be("HUISwitchGroup");
  return k(), ge(l, null, {
    default: de(() => [
      G("div", {
        class: te(["inline-flex items-center", { "flex-row-reverse": e.labelFirst }])
      }, [
        fe(a, {
          modelValue: e.active,
          "onUpdate:modelValue": t[0] || (t[0] = (d) => e.active = d),
          class: te([{
            [e.activeColor]: e.active,
            [e.inactiveColor]: !e.active,
            "pointer-events-none": e.disabled,
            "ring-offset-2 ring-2 ring-blue-500 outline-none": e.focus,
            [e.sizes[e.size].box]: !0
          }, "relative inline-flex shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75"]),
          tabindex: e.disabled ? -1 : 0,
          disabled: e.disabled,
          onKeydown: t[1] || (t[1] = Re((d) => e.active = !e.active, ["enter"])),
          onFocus: t[2] || (t[2] = (d) => e.focus = !0),
          onBlur: t[3] || (t[3] = (d) => e.focus = !1)
        }, {
          default: de(() => [
            G("span", {
              "aria-hidden": "true",
              class: te([{
                [e.sizes[e.size].translate]: e.active,
                "bg-blue-100": e.active && !e.disabled,
                "bg-gray-100": e.active && e.disabled,
                "bg-gray-700": !e.active && !e.disabled,
                "bg-gray-300": !e.active && e.disabled,
                [e.sizes[e.size].dot]: !0
              }, "inline-block rounded-full ring-0 transition ease-in-out duration-100 pointer-events-none"])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["modelValue", "class", "tabindex", "disabled"]),
        fe(s, {
          class: te(["font-medium text-gray-700", {
            "ml-2": !e.labelFirst,
            "mr-2": e.labelFirst,
            grow: e.labelGrow,
            [e.sizes[e.size].text]: !0
          }])
        }, {
          default: de(() => [
            se(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"])
      ], 2)
    ]),
    _: 3
  });
}
const pH = /* @__PURE__ */ Je(dF, [["render", uF]]), Qc = {
  classes: [],
  sort(e, t, n) {
    return `${e[n]}`.localeCompare(`${t[n]}`);
  },
  format(e, t) {
    return `${e[t]}`;
  }
}, cF = new Intl.NumberFormat("de-DE"), fF = {
  ...Qc,
  classes: [...Qc.classes, "justify-end", "tabular-nums"],
  sort(e, t, n) {
    const r = Number.parseFloat(e[n]), i = Number.parseFloat(t[n]);
    return r > i ? 1 : -1;
  },
  format(e, t) {
    return cF.format(e[t]);
  }
}, cm = {
  default: Qc,
  number: fF
};
var Ki = /* @__PURE__ */ ((e) => (e.Ascending = "asc", e.Descending = "desc", e))(Ki || {});
const pF = { class: "shadow-sm border border-gray-200 bg-white sm:rounded-md flex flex-col justify-between" }, hF = { class: "flex bg-gray-100/50" }, mF = ["onClick"], gF = {
  key: 0,
  class: "self-center mx-1"
}, vF = ["onClick"], yF = { class: "bg-white rounded-md border shadow-xl p-2 flex flex-col" }, bF = /* @__PURE__ */ G("div", { class: "py-5 text-center text-gray-500 text-md pointer-events-none col-span-full select-none" }, " Keine Einträge gefunden ", -1), $F = ["onClick"], wF = {
  key: 0,
  class: "p-2 text-sm"
}, kF = { class: "font-semibold" }, xF = /* @__PURE__ */ $e({
  __name: "DsTable",
  props: {
    sortSettings: { default: () => ({ name: null, order: Ki.Ascending }) },
    columns: {},
    data: {},
    selected: { default: void 0 },
    selectedKey: { default: "id" },
    condensed: { type: Boolean },
    selectable: { type: Boolean },
    hideFooter: { type: Boolean },
    virtualized: { type: Boolean },
    itemHeight: { default: 0 }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = new Intl.NumberFormat("de-DE"), r = e, i = t, o = E(() => r.virtualized ? r.itemHeight > 0 ? r.itemHeight : (r.condensed ? 28 : 43) + 1 : 0), a = E(() => Xr(r.columns)), s = E(() => Object.keys(a.value).reduce(
      (C, $) => {
        const { format: O = "default" } = a.value[$];
        return C[$] = typeof O == "string" ? cm[O] : {
          ...cm.default,
          ...O
        }, C;
      },
      {}
    )), l = q(""), d = Gn({});
    function u(C) {
      const { filter: $ } = s.value[C];
      $ !== void 0 && (d[C] = $.defaults());
    }
    Fe(
      s,
      (C) => {
        Object.keys(C).forEach(u);
      },
      { immediate: !0 }
    );
    const c = E(() => Object.values(a.value).reduce((C, { width: $ = 1 }) => C + +$, 0)), f = E(() => Object.keys(a.value).reduce((C, $) => {
      const {
        width: O = 1,
        grow: z = a.value[$].width === void 0,
        truncate: P = !0
      } = a.value[$];
      return C[$] = {
        value: typeof O == "number" ? `${O}fr` : O,
        style: r.virtualized ? {
          flex: `${z ? 1 : 0} 0 ${O}px`
        } : {},
        classes: [
          ...s.value[$].classes,
          r.virtualized ? "overflow-hidden" : "",
          r.condensed ? "py-1" : "py-3"
        ],
        innerClasses: [
          r.virtualized && P ? "truncate" : ""
        ]
      }, C;
    }, {})), h = Gn(r.sortSettings);
    function p(C) {
      l.value = l.value === C ? "" : C;
    }
    function m(C) {
      var $;
      return ($ = s.value[C].filter) == null ? void 0 : $.isActive(d[C]);
    }
    const g = E(() => {
      const C = Object.keys(s.value).reduce((P, U) => {
        const ie = s.value[U];
        return ie.filter !== void 0 && ie.filter.isActive(d[U]) && (P[U] = ie.filter.createFilter(d[U], U)), P;
      }, {}), $ = r.data.filter((P) => Object.keys(d).every((U) => C[U] === void 0 || C[U](P)));
      if (h.name === null)
        return $;
      const O = s.value[h.name];
      if (O === void 0)
        return $;
      const z = h.order === Ki.Ascending ? 1 : -1;
      return $.sort(
        (P, U) => {
          var ie;
          return O.sort(P, U, (ie = h.name) != null ? ie : "") * z;
        }
      );
    });
    function v(C) {
      i("select", C);
    }
    function b(C, $ = !1) {
      $ || (C !== h.name ? (h.name = C, h.order = Ki.Ascending) : h.order = h.order === Ki.Ascending ? Ki.Descending : Ki.Ascending);
    }
    function x(C) {
      return n.format(C);
    }
    const y = E(() => Object.values(f.value).map((C) => C.value).join(" "));
    return (C, $) => (k(), A("div", pF, [
      fe(D(Z0), {
        disabled: !C.virtualized,
        "outer-container-class": `grow ${C.virtualized ? "" : "grid"}`,
        "outer-container-style": C.virtualized ? {
          "--row-width": `${c.value}px`
        } : {
          gridTemplateColumns: y.value,
          gridTemplateRows: "min-content"
        },
        items: g.value,
        "item-height": o.value,
        "item-class": C.$style.itemRow,
        "inner-container-class": C.virtualized ? "" : "!contents",
        class: te([C.hideFooter ? "" : "border-b", "overflow-x-auto"])
      }, qt({
        before: de(() => [
          G("div", {
            class: te(
              C.virtualized ? `${C.$style.itemRow} flex border-b bg-white sticky top-0 divide-x divide-gray-200 shadow-sm` : "!contents"
            ),
            style: { zIndex: 5 }
          }, [
            (k(!0), A(Ie, null, Ze(a.value, (O, z, P) => (k(), A("div", {
              key: z,
              style: mt(f.value[z].style),
              class: te(C.virtualized ? "overflow-hidden" : `border-b bg-white sticky top-0 shadow-sm ${P > 0 ? "border-l" : ""}`)
            }, [
              G("div", hF, [
                G("button", {
                  type: "button",
                  class: te(["grow px-4 py-2 text-left text-xs leading-4 font-semibold text-gray-500 uppercase tracking-wider focus:outline-none transition-colors duration-75 ease-out whitespace-nowrap block w-full", {
                    "cursor-default": O.notSortable,
                    "hover:bg-gray-100 focus:bg-gray-100": !O.notSortable
                  }]),
                  tabindex: "-1",
                  onClick: (U) => b(z, O.notSortable)
                }, [
                  G("span", null, Te(O.label), 1),
                  G("span", {
                    class: te(`ml-1 ${h.name !== z ? "invisible" : ""}`)
                  }, [
                    Jt(fe(Ue, { name: "chevron-up" }, null, 512), [
                      [Cn, h.order === "asc"]
                    ]),
                    Jt(fe(Ue, { name: "chevron-down" }, null, 512), [
                      [Cn, h.order === "desc"]
                    ])
                  ], 2)
                ], 10, mF),
                d[z] !== void 0 ? (k(), A("div", gF, [
                  fe(df, {
                    show: l.value === z,
                    onClickOutside: $[1] || ($[1] = (U) => p(""))
                  }, {
                    template: de(() => {
                      var U, ie;
                      return [
                        G("div", yF, [
                          (k(), ge(Qn((U = s.value[z].filter) == null ? void 0 : U.component), $t({ ref_for: !0 }, {
                            ...(ie = s.value[z].filter) == null ? void 0 : ie.props,
                            ...d[z]
                          }, {
                            onUpdate: (W) => d[z] = W,
                            onClose: $[0] || ($[0] = (W) => p(""))
                          }), null, 16, ["onUpdate"])),
                          fe(gr, {
                            icon: "undo",
                            variant: "outline",
                            class: "mt-2",
                            onClick: (W) => u(z)
                          }, {
                            default: de(() => [
                              it(" Filter zurücksetzen ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ];
                    }),
                    default: de(() => [
                      G("button", {
                        type: "button",
                        class: te([
                          m(z) ? "bg-blue-200 text-blue-500" : "text-gray-300",
                          "hover:text-blue-500 hover:bg-blue-200 rounded px-1 w-6 h-6 shrink-0 transition-colors duration-75 focus:ring-blue-500 focus:outline-none flex items-center justify-center"
                        ]),
                        onClick: (U) => p(z)
                      }, [
                        fe(Ue, {
                          name: "filter",
                          size: "sm"
                        })
                      ], 10, vF)
                    ]),
                    _: 2
                  }, 1032, ["show"])
                ])) : K("", !0)
              ])
            ], 6))), 128))
          ], 2)
        ]),
        _: 2
      }, [
        g.value.length === 0 ? {
          name: "after",
          fn: de(() => [
            bF
          ]),
          key: "0"
        } : {
          name: "default",
          fn: de(({ item: O, index: z }) => [
            G("div", {
              class: te([[
                C.virtualized ? "flex border-t" : "!contents",
                C.selectable ? "hover:bg-gray-100 cursor-pointer" : void 0,
                !C.virtualized && C.selectable ? C.$style.selectableContents : void 0,
                C.selected !== void 0 && C.selected === O[C.selectedKey] ? ["bg-gray-100", C.$style.selectedContents] : void 0
              ], "text-sm -mt-px"]),
              onClick: (P) => v(O)
            }, [
              (k(!0), A(Ie, null, Ze(a.value, (P, U) => (k(), A("div", {
                key: U,
                style: mt(f.value[U].style),
                class: te([[...f.value[U].classes, C.virtualized || z === 0 ? void 0 : "border-t border-gray-200"], "px-4 flex items-center"])
              }, [
                G("div", {
                  class: te(f.value[U].innerClasses)
                }, [
                  se(C.$slots, `entry-${U}`, {
                    column: P,
                    entry: O,
                    value: O[U]
                  }, () => [
                    it(Te(s.value[U].format(O, U, P)), 1)
                  ])
                ], 2)
              ], 6))), 128))
            ], 10, $F)
          ]),
          key: "1"
        }
      ]), 1032, ["disabled", "outer-container-class", "outer-container-style", "items", "item-height", "item-class", "inner-container-class", "class"]),
      C.hideFooter ? K("", !0) : (k(), A("div", wF, [
        G("span", kF, Te(x(g.value.length)) + " " + Te(g.value.length === 1 ? "Eintrag" : "Einträge"), 1)
      ]))
    ]));
  }
}), SF = "_selectableContents_7l5sg_2", CF = "_selectedContents_7l5sg_3", TF = "_itemRow_7l5sg_7", MF = {
  selectableContents: SF,
  selectedContents: CF,
  itemRow: TF
}, OF = {
  $style: MF
}, hH = /* @__PURE__ */ Je(xF, [["__cssModules", OF]]), n3 = (e) => e, EF = $e({
  name: "EnumFilter",
  components: {
    DsButton: gr,
    DsIcon: Ue
  },
  props: {
    selected: {
      type: Array,
      default: () => []
    },
    values: {
      type: Object,
      required: !0
    }
  },
  emits: ["update"],
  setup(e, t) {
    const n = (r) => {
      t.emit("update", {
        ...e,
        selected: r
      });
    };
    return {
      select(r) {
        n([...e.selected, r]);
      },
      deselect(r) {
        const i = [...e.selected];
        i.splice(i.indexOf(r), 1), n(i);
      },
      all() {
        n(Object.keys(e.values));
      },
      clear() {
        n([]);
      }
    };
  }
}), DF = { class: "font-normal" }, AF = { class: "-mx-2 flex flex-col" }, PF = ["onClick"], NF = { class: "text-sm text-gray-900" }, IF = { class: "flex mt-2 space-x-1" };
function RF(e, t, n, r, i, o) {
  const a = Be("DsIcon"), s = Be("DsButton");
  return k(), A("div", DF, [
    G("div", AF, [
      (k(!0), A(Ie, null, Ze(e.values, (l, d) => (k(), A("button", {
        key: d,
        type: "button",
        class: "text-left px-2 focus:outline-none hover:bg-blue-100 focus:bg-blue-200 transition-colors duration-75",
        onClick: Ge((u) => e.selected.indexOf(d) >= 0 ? e.deselect(d) : e.select(d), ["stop"])
      }, [
        e.selected.indexOf(d) >= 0 ? (k(), ge(a, {
          key: 0,
          name: "square-check",
          class: "mr-2 text-blue-500"
        })) : (k(), ge(a, {
          key: 1,
          name: "square",
          variant: "regular",
          class: "mr-2 text-gray-500"
        })),
        G("span", NF, Te(l), 1)
      ], 8, PF))), 128))
    ]),
    G("div", IF, [
      fe(s, {
        class: "grow",
        size: "sm",
        variant: "secondary",
        onClick: e.all
      }, {
        default: de(() => [
          it(" Alle ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      fe(s, {
        class: "grow",
        size: "sm",
        variant: "secondary",
        onClick: e.clear
      }, {
        default: de(() => [
          it(" Keine ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]);
}
const _F = /* @__PURE__ */ Je(EF, [["render", RF]]), mH = (e, t) => {
  let n, r;
  Array.isArray(e) ? (n = e.reduce((o, a) => ({ ...o, [a]: a }), {}), r = e) : (n = e, r = Object.keys(e));
  const i = r.length;
  return n3({
    component: _F,
    props: {
      values: n
    },
    defaults: () => ({
      selected: t || r
    }),
    isActive(o) {
      return o.selected.length !== i;
    },
    createFilter(o, a) {
      return (s) => o.selected.includes(s[a]);
    }
  });
}, LF = $e({
  name: "SearchFilter",
  components: {
    DsInput: pa
  },
  props: {
    query: {
      type: String,
      required: !0
    }
  },
  emits: ["update"],
  setup(e, t) {
    const n = q();
    return ot(() => {
      setTimeout(() => {
        var r;
        return (r = n.value) == null ? void 0 : r.focus();
      }, 1);
    }), {
      input: n,
      model: E({
        get: () => e.query,
        set: Q0(
          (r) => t.emit("update", {
            ...e,
            query: r
          }),
          250
        )
      })
    };
  }
});
function FF(e, t, n, r, i, o) {
  const a = Be("DsInput");
  return k(), ge(a, {
    ref: "input",
    modelValue: e.model,
    "onUpdate:modelValue": t[0] || (t[0] = (s) => e.model = s),
    placeholder: "Suchen...",
    immediate: ""
  }, null, 8, ["modelValue"]);
}
const BF = /* @__PURE__ */ Je(LF, [["render", FF]]), fm = /[^a-zA-Z0-9üöäÜÖÄß\s]/g, gH = (e) => {
  const t = Array.isArray(e) ? (n) => e.map((r) => `${n[r]}`) : e;
  return n3({
    component: BF,
    defaults: () => ({
      query: ""
    }),
    isActive(n) {
      return n.query.length > 0;
    },
    createFilter(n) {
      const r = zS(n.query.trim().replace(/\s+/g, " ")), i = new RegExp(r, "ig"), a = r.replace(fm, "").split(" ").map((l) => `(?=.*${l})`), s = new RegExp(`^${a.join("")}.*$`, "ig");
      return (l) => {
        const d = t(l).join(" ");
        return i.test(d) || s.test(
          // Only use searchable characters
          d.replace(fm, "")
        );
      };
    }
  });
}, r3 = Symbol("TabsProvider"), zF = { key: 0 }, vH = /* @__PURE__ */ $e({
  __name: "DsTab",
  props: {
    title: {},
    icon: {},
    iconClass: {},
    iconVariant: {},
    badge: {},
    tabId: {},
    alwaysRender: { type: Boolean },
    deletable: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Zn(r3), r = q();
    if (n === void 0)
      throw new Error("No TabState provided");
    a0(() => {
      r.value = n.register(t);
    }), bo(() => {
      r.value !== void 0 && n.unregister(r.value);
    });
    const i = E(() => n.active.value === r.value);
    return (o, a) => i.value || o.alwaysRender ? Jt((k(), A("div", zF, [
      se(o.$slots, "default")
    ], 512)), [
      [Cn, i.value]
    ]) : K("", !0);
  }
}), VF = ["href"], HF = {
  key: 0,
  class: "shrink-0 leading-none"
}, jF = /* @__PURE__ */ $e({
  __name: "DsTabLink",
  props: {
    href: {},
    title: {},
    icon: {},
    iconClass: { default: "" },
    iconVariant: { default: "solid" },
    badge: {},
    selected: { type: Boolean },
    deletable: { type: Boolean },
    tabId: { default: "" }
  },
  emits: ["delete"],
  setup(e, { emit: t }) {
    const n = e;
    n.deletable && n.tabId === "" && console.warn("You must specify a tabId for all deletable tabs, otherwise the event propagation wont work.");
    const r = t;
    return (i, o) => (k(), A("a", {
      href: i.href,
      class: te([{
        "border-blue-300 text-blue-500 focus:text-blue-700 focus:border-blue-500 cursor-default": i.selected,
        "text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 border-transparent": !i.selected
      }, "whitespace-nowrap py-2 px-5 border-b-2 -mb-px font-medium text-sm leading-5 h-10 flex items-center space-x-1.5"])
    }, [
      i.icon !== void 0 ? (k(), A("span", HF, [
        fe(Ue, {
          name: i.icon,
          class: te(i.iconClass),
          variant: i.iconVariant,
          size: "lg",
          "fixed-width": ""
        }, null, 8, ["name", "class", "variant"])
      ])) : K("", !0),
      G("span", null, Te(i.title), 1),
      i.badge ? (k(), ge(Z4, {
        key: 1,
        type: "primary"
      }, {
        default: de(() => [
          it(Te(i.badge), 1)
        ]),
        _: 1
      })) : K("", !0),
      i.deletable ? (k(), ge(gr, {
        key: 2,
        variant: "clear",
        icon: "times",
        "icon-align": "center",
        size: "sm",
        onClick: o[0] || (o[0] = Ge((a) => r("delete", i.tabId), ["prevent", "stop"]))
      })) : K("", !0)
    ], 10, VF));
  }
}), WF = {}, UF = { class: "overflow-x-auto" }, qF = { class: "border-b border-gray-200 flex" };
function YF(e, t) {
  return k(), A("div", UF, [
    G("nav", qF, [
      se(e.$slots, "default")
    ])
  ]);
}
const KF = /* @__PURE__ */ Je(WF, [["render", YF]]), GF = {
  key: 0,
  class: "border-l whitespace-nowrap py-2 px-2 -mb-px font-medium text-sm leading-5 h-10 flex items-center"
}, yH = /* @__PURE__ */ $e({
  __name: "DsTabs",
  props: {
    activeTab: {},
    withAddButton: { type: Boolean }
  },
  emits: ["update:activeTab", "deleteTab", "addTab"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = q(/* @__PURE__ */ new Map()), o = q(0), a = q(String(n.activeTab)), s = ci(), l = (c) => {
      const f = c.toString();
      i.value.has(f) && (u.unregister(f), r("deleteTab", c));
    }, d = (c) => {
      if (a.value = c, !i.value.has(c)) {
        const f = [...i.value.keys()];
        f.length > 0 && ([a.value] = f);
      }
      r("update:activeTab", a.value);
    };
    Fe(
      () => n.activeTab,
      (c) => {
        d(String(c));
      }
    );
    const u = {
      active: a,
      register(c) {
        var h;
        const f = String((h = c.tabId) != null ? h : o.value);
        if (i.value.has(f))
          throw new Error(`Tab with id ${f} already exists!`);
        return i.value.set(f, c), i.value.has(a.value) || d(f), o.value += 1, f;
      },
      unregister(c) {
        const f = [...i.value.keys()];
        if (i.value.delete(c), a.value === c) {
          const h = f.indexOf(c);
          f.splice(h, 1);
          const p = Math.max(0, Math.min(h, f.length - 1));
          a.value = f[p];
        }
      }
    };
    return mr(r3, u), (c, f) => (k(), A(Ie, null, [
      fe(KF, null, {
        default: de(() => [
          (k(!0), A(Ie, null, Ze(i.value, ([h, p]) => (k(), ge(jF, {
            key: h,
            selected: h === a.value,
            href: "#",
            "tab-id": p.tabId,
            icon: p.icon,
            "icon-class": p.iconClass,
            "icon-variant": p.iconVariant,
            title: p.title,
            badge: p.badge,
            deletable: p.deletable,
            onClick: Ge((m) => d(h), ["prevent"]),
            onDelete: l
          }, null, 8, ["selected", "tab-id", "icon", "icon-class", "icon-variant", "title", "badge", "deletable", "onClick"]))), 128)),
          c.withAddButton ? (k(), A("div", GF, [
            fe(gr, {
              variant: "clear",
              size: "sm",
              class: "mb-1",
              icon: "plus",
              "icon-align": D(s).addButtonLabel !== void 0 ? "left" : "center",
              onClick: f[0] || (f[0] = (h) => r("addTab"))
            }, {
              default: de(() => [
                se(c.$slots, "addButtonLabel")
              ]),
              _: 3
            }, 8, ["icon-align"])
          ])) : K("", !0)
        ]),
        _: 3
      }),
      se(c.$slots, "default")
    ], 64));
  }
}), JF = {
  sm: "sm:text-sm",
  base: "sm:text-sm",
  lg: "text-lg"
}, XF = $e({
  name: "DsTextarea",
  components: { DsLoadingState: $s },
  inheritAttrs: !1,
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "base"
    },
    noResize: {
      type: Boolean,
      required: !1
    },
    isLoading: {
      type: Boolean
    },
    cols: {
      type: Number,
      default: void 0
    },
    rows: {
      type: Number,
      default: void 0
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(e, { emit: t, attrs: n }) {
    const r = q(), i = E(() => Object.hasOwn(n, "autofocus")), o = E({
      get: () => e.modelValue,
      set: (a) => t("update:modelValue", a)
    });
    return ot(() => {
      i.value && r.value instanceof HTMLTextAreaElement && r.value !== document.activeElement && r.value.focus();
    }), {
      autofocus: i,
      textarea: r,
      valueProxy: o,
      sizeClasses: JF,
      attrs: n
    };
  }
}), QF = { class: "relative" }, ZF = ["autofocus", "cols", "rows", "placeholder"];
function eB(e, t, n, r, i, o) {
  const a = Be("DsLoadingState");
  return k(), A("div", QF, [
    fe(a, {
      "is-loading": e.isLoading,
      class: "text-xl",
      "inline-border": ""
    }, null, 8, ["is-loading"]),
    Jt(G("textarea", $t({
      ref: "textarea",
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.valueProxy = s)
    }, e.attrs, {
      autofocus: e.autofocus,
      cols: e.cols,
      rows: e.rows,
      class: ["block w-full sm:leading-5 focus:outline-none min-w-0 rounded border py-2 px-3", {
        "bg-gray-100 border-gray-200 text-gray-500": e.attrs.disabled,
        "bg-white focus-visible:outline-none focus:border-blue-500 focus:shadow-outline-blue text-gray-900 shadow-sm": !e.attrs.disabled,
        "resize-none": e.noResize,
        [e.sizeClasses[e.size]]: !0
      }],
      placeholder: e.placeholder
    }), null, 16, ZF), [
      [s0, e.valueProxy]
    ])
  ]);
}
const bH = /* @__PURE__ */ Je(XF, [["render", eB]]), tB = { class: "text-gray-900" }, nB = { class: "relative p-1 text-sm text-center text-gray-500" }, $H = /* @__PURE__ */ $e({
  __name: "DsTypeahead",
  props: {
    modelValue: {},
    source: {},
    minSearchLength: { default: 3 },
    isLoading: { type: Boolean },
    placeholder: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean },
    itemHeight: { default: 0 },
    virtualized: { type: Boolean },
    size: { default: "base" }
  },
  emits: ["search", "selected", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = q(""), o = E({
      get: () => n.modelValue,
      set: (s) => r("update:modelValue", s)
    });
    Fe(() => o.value, (s) => {
      s.length >= n.minSearchLength && s !== i.value && r("search", s);
    });
    const a = (s) => {
      const l = n.source[s];
      i.value = l.label, o.value = l.label, r("selected", l);
    };
    return (s, l) => (k(), ge(D(Cd), {
      id: s.id,
      items: s.source,
      "list-class": "m-1",
      "item-class": "px-2 py-1 rounded-sm",
      "scroll-y-margin": 4,
      disabled: s.disabled || s.isLoading,
      "item-height": s.itemHeight,
      virtualized: s.virtualized,
      unfocusable: "",
      "dont-toggle-on-container-focus": "",
      "prevent-close-on-button-focus": "",
      onSelect: a
    }, {
      button: de(({ open: d, close: u }) => [
        fe(pa, {
          modelValue: o.value,
          "onUpdate:modelValue": l[0] || (l[0] = (c) => o.value = c),
          placeholder: s.placeholder,
          "is-loading": s.isLoading,
          size: s.size,
          class: "w-full",
          immediate: "",
          onFocus: d,
          onInput: d,
          onKeydown: Re(Ge(() => an(() => u()), ["stop"]), ["tab"])
        }, null, 8, ["modelValue", "placeholder", "is-loading", "size", "onFocus", "onInput", "onKeydown"])
      ]),
      item: de(({ item: d }) => [
        se(s.$slots, "entry", { entry: d }, () => [
          G("span", tB, Te(d.label), 1)
        ])
      ]),
      "no-items": de(() => [
        G("div", nB, [
          o.value.length < s.minSearchLength ? (k(), A(Ie, { key: 0 }, [
            it(" Mind. " + Te(s.minSearchLength) + " Zeichen zum Suchen... ", 1)
          ], 64)) : (k(), A(Ie, { key: 1 }, [
            fe(D($s), {
              "is-loading": s.isLoading,
              class: "text-lg",
              opaque: ""
            }, null, 8, ["is-loading"]),
            it(" Keine Ergebnisse gefunden. ")
          ], 64))
        ])
      ]),
      _: 3
    }, 8, ["id", "items", "disabled", "item-height", "virtualized"]));
  }
}), rB = { class: "flex flex-col pl-0" }, iB = { class: "flex -ml-1.5 space-x-4" }, oB = { key: 0 }, aB = { class: "flex flex-grow leading-tight gap-2" }, sB = {
  key: 0,
  class: "font-semibold"
}, lB = { key: 1 }, dB = { class: "text-gray-500" }, uB = { key: 1 }, cB = { class: "flex items-center -mt-1.5 pb-1.5" }, fB = {
  key: 0,
  class: "flex-shrink-0 flex items-center justify-center mr-3 overflow-hidden bg-blue-100 rounded-full w-9 h-9"
}, pB = ["src"], hB = { class: "flex flex-grow leading-tight gap-2" }, mB = {
  key: 0,
  class: "font-semibold"
}, gB = { key: 1 }, vB = { class: "text-gray-500" }, wH = /* @__PURE__ */ $e({
  __name: "DsTimeline",
  props: {
    nodes: {},
    menuOptions: {}
  },
  setup(e) {
    const t = e, n = (a, s) => {
      t.menuOptions && t.menuOptions[a] && t.menuOptions[a].onClick(s);
    }, r = (a) => ({
      "text-orange-500 bg-orange-100": a === "orange",
      "text-red-500 bg-red-100": a === "red",
      "text-green-500 bg-green-100": a === "green",
      "text-blue-500 bg-blue-100": a === "blue" || !a
    }), i = (a) => ({
      "border-l-orange-500": a === "orange",
      "border-l-red-500": a === "red",
      "border-l-green-500": a === "green",
      "border-l-blue-500": a === "blue" || !a
    }), o = (a) => ({
      "bg-orange-500": a === "orange",
      "bg-red-500": a === "red",
      "bg-green-500": a === "green",
      "bg-blue-500": a === "blue" || !a
    });
    return (a, s) => (k(), A("ul", rB, [
      (k(!0), A(Ie, null, Ze(a.nodes, (l, d) => (k(), A("li", {
        key: d,
        class: te(["list-none relative text-gray-700 first:before:top-8 before:content-[''] before:absolute before:left-3 before:ml-1.5 before:w-0.5 before:bg-gray-200 before:top-0 after:content-[''] after:absolute after:left-6 after:-ml-px after:w-0.5 after:h-8 after:bg-white after:bottom-0", {
          "before:bottom-0": d !== a.nodes.length - 1,
          "before:bottom-50": d === a.nodes.length - 1
        }])
      }, [
        G("div", iB, [
          G("div", {
            class: te(["mt-1 relative flex items-center justify-center flex-none text-gray-500 bg-white rounded-full w-12", [l.inline ? "h-7" : "h-12"]])
          }, [
            G("div", {
              "data-test": "node-icon",
              class: te(["p-2 rounded-full w-9 h-9 flex items-center justify-center", l.inline ? "bg-transparent" : r(l.color)])
            }, [
              fe(D(Ue), {
                name: l.icon || "list",
                class: "text-lg"
              }, null, 8, ["name"])
            ], 2)
          ], 2),
          G("div", {
            class: te(["mb-5 overflow-y-auto flex", [
              l.inline ? "flex-grow py-1 pt-2" : "border flex-grow rounded-md mb-5",
              i(l.color)
            ]]),
            "data-test": "node-content"
          }, [
            l.inline ? K("", !0) : (k(), A("div", {
              key: 0,
              class: te(["w-1 -ml-px flex-shrink-0 flex-grow-0", o(l.color)])
            }, null, 2)),
            G("div", {
              class: te({ "w-full p-4 flex-grow space-y-3": !l.inline })
            }, [
              l.inline ? (k(), A("div", oB, [
                G("div", aB, [
                  l.ownerName && l.ownerName !== "" ? (k(), A("span", sB, Te(l.ownerName), 1)) : K("", !0),
                  l.ownerName === "" ? (k(), A("span", lB, " System ")) : K("", !0),
                  se(a.$slots, "default", { node: l }, () => [
                    G("span", null, Te(l.body), 1)
                  ]),
                  G("span", dB, Te(l.timeAgo), 1)
                ])
              ])) : (k(), A("div", uB, [
                G("div", cB, [
                  l.ownerAvatar ? (k(), A("div", fB, [
                    G("img", {
                      src: l.ownerAvatar,
                      alt: "avatar"
                    }, null, 8, pB)
                  ])) : K("", !0),
                  G("div", hB, [
                    l.ownerName && l.ownerName !== "" ? (k(), A("span", mB, Te(l.ownerName), 1)) : K("", !0),
                    l.ownerName === "" ? (k(), A("span", gB, " System ")) : K("", !0),
                    G("span", vB, Te(l.timeAgo), 1)
                  ]),
                  a.menuOptions && a.menuOptions.length ? (k(), ge(D(Cd), {
                    key: 1,
                    width: 100,
                    items: a.menuOptions.map((u) => u.label),
                    onSelect: (u) => n(u, l)
                  }, {
                    button: de(() => [
                      fe(D(gr), { icon: "ellipsis-h" })
                    ]),
                    _: 2
                  }, 1032, ["items", "onSelect"])) : K("", !0)
                ]),
                se(a.$slots, "default", { node: l }, () => [
                  it(Te(l.body), 1)
                ])
              ]))
            ], 2)
          ], 2)
        ])
      ], 2))), 128))
    ]));
  }
}), yB = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-579]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:2\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]], 0, 0, 0, 0, 0, 0, [["2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}"], ["(?:4[0-7]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}"], 0, ["857[58]\\d{4}"]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["12\\d{7}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}"]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}"], ["(?:6[89]|7[235-9])\\d{7}"], ["800\\d{6}"], ["90[016]\\d{6}"], ["878\\d{6}"], 0, ["5[18]\\d{7}"], ["74[0248]\\d{6}"], 0, ["84[0248]\\d{6}"]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6[25-9]\\d)\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}", [10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["19(?:0[01]|4[78])\\d{7}", [11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}"], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|190|[2379]\\d\\d))\\d{5}"], ["800\\d{6}"], ["9(?:0[05689]|76)\\d{6}"], ["70[01]\\d{6}"], 0, ["9(?:5\\d|7[2-4])\\d{6}"], 0, ["9[17]0\\d{6}"], ["8[134]\\d{7}"]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["15(?:[0-25-9]\\d\\d|310)\\d{6}|1(?:6[023]|7\\d)\\d{7,8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], 0, ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}"], ["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["(?:1[3-79][1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[02]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|111|77\\d)|1(?:1(?:[03][01]|[124]\\d)|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["694(?:[0-249]\\d|3[0-8])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:[013]\\d|2[0-25-8]|4[0-29]|5[1-9]))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[59]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|848[0-35-9]|9(?:29[013-9]|39[01]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-8]|6[02357-9])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[129]|84[0-29]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-7])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}", [7, 8, 9]], ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", [8, 9, 10, 11, 12, 13]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], 0, ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, 0, ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-29]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, 0, ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["345849\\d{4}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["(?:20(?:[23579]\\d|88)|30(?:2\\d|4))\\d{6}", [9, 10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, 0, ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}|[12]468\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])\\d{4}"], ["69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-3]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}|(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}", [7, 8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["21(?:1[013-5]|2\\d)\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-7]|5[01])\\d{4}", [6]], ["(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"], ["80[0-5]\\d{6}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], 0, ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:[04]0|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], 0, 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], 0, ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["8(?:09[0-6]|95[0-2])\\d{4}|(?:8(?:0[1-8]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[124-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["9[1-689]\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:6[0-689]|77|9\\d)\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[019]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[01578]|8[078]|9\\d)\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72(?:[48]0|6[01])\\d{5}|7(?:[015-8]\\d|20|36|4[0-5]|9[89])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[46])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:7[5-79]|9[5-8])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function bB(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(yB), e.apply(this, n);
}
function Zc(e) {
  "@babel/helpers - typeof";
  return Zc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zc(e);
}
function $B(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function wB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function kB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && cs(e, t);
}
function xB(e) {
  var t = o3();
  return function() {
    var r = fs(e), i;
    if (t) {
      var o = fs(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return SB(this, i);
  };
}
function SB(e, t) {
  if (t && (Zc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return i3(e);
}
function i3(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function e0(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return e0 = function(r) {
    if (r === null || !CB(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t != "undefined") {
      if (t.has(r)) return t.get(r);
      t.set(r, i);
    }
    function i() {
      return nl(r, arguments, fs(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), cs(i, r);
  }, e0(e);
}
function nl(e, t, n) {
  return o3() ? nl = Reflect.construct : nl = function(i, o, a) {
    var s = [null];
    s.push.apply(s, o);
    var l = Function.bind.apply(i, s), d = new l();
    return a && cs(d, a.prototype), d;
  }, nl.apply(null, arguments);
}
function o3() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function CB(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function cs(e, t) {
  return cs = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, cs(e, t);
}
function fs(e) {
  return fs = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, fs(e);
}
var ti = /* @__PURE__ */ function(e) {
  kB(n, e);
  var t = xB(n);
  function n(r) {
    var i;
    return wB(this, n), i = t.call(this, r), Object.setPrototypeOf(i3(i), n.prototype), i.name = i.constructor.name, i;
  }
  return $B(n);
}(/* @__PURE__ */ e0(Error)), Wf = 2, TB = 17, MB = 3, pr = "0-9０-９٠-٩۰-۹", OB = "-‐-―−ー－", EB = "／/", DB = "．.", AB = "  ­​⁠　", PB = "()（）［］\\[\\]", NB = "~⁓∼～", sd = "".concat(OB).concat(EB).concat(DB).concat(AB).concat(PB).concat(NB), Uf = "+＋";
function pm(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), i = 0; i < 3; i++) {
    var o = Number(n[i]), a = Number(r[i]);
    if (o > a) return 1;
    if (a > o) return -1;
    if (!isNaN(o) && isNaN(a)) return 1;
    if (isNaN(o) && !isNaN(a)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var IB = {}.constructor;
function rl(e) {
  return e != null && e.constructor === IB;
}
function t0(e) {
  "@babel/helpers - typeof";
  return t0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, t0(e);
}
function zd(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function RB(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Vd(e, t, n) {
  return t && RB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var _B = "1.2.0", LB = "1.7.35", hm = " ext. ", FB = /^\d+$/, kn = /* @__PURE__ */ function() {
  function e(t) {
    zd(this, e), HB(t), this.metadata = t, a3.call(this, t);
  }
  return Vd(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && FB.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new mm(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new mm(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[n];
        if (i)
          return i;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), mm = /* @__PURE__ */ function() {
  function e(t, n) {
    zd(this, e), this.globalMetadataObject = n, this.metadata = t, a3.call(this, n.metadata);
  }
  return Vd(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(i) {
        return new BB(i, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && gm(this.types(), n))
        return new VB(gm(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? hm : this.metadata[13] || hm;
    }
  }]), e;
}(), BB = /* @__PURE__ */ function() {
  function e(t, n) {
    zd(this, e), this._format = t, this.metadata = n;
  }
  return Vd(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !zB.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), zB = /^\(?\$1\)?$/, VB = /* @__PURE__ */ function() {
  function e(t, n) {
    zd(this, e), this.type = t, this.metadata = n;
  }
  return Vd(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function gm(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function HB(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!rl(e) || !rl(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(rl(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + jB(e) + ": " + e, "."));
}
var jB = function(t) {
  return t0(t);
};
function qf(e, t) {
  if (t = new kn(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function WB(e, t) {
  return t.countries.hasOwnProperty(e);
}
function a3(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? pm(t, _B) === -1 ? this.v2 = !0 : pm(t, LB) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var UB = ";ext=", No = function(t) {
  return "([".concat(pr, "]{1,").concat(t, "})");
};
function s3(e) {
  var t = "20", n = "15", r = "9", i = "6", o = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", c = "[  \\t]*", f = "(?:,{2}|;)", h = UB + No(t), p = o + l + a + No(t) + s, m = o + d + a + No(r) + s, g = u + No(i) + "#", v = c + f + a + No(n) + s, b = c + "(?:,)+" + a + No(r) + s;
  return h + "|" + p + "|" + m + "|" + g + "|" + v + "|" + b;
}
var qB = "[" + pr + "]{" + Wf + "}", YB = "[" + Uf + "]{0,1}(?:[" + sd + "]*[" + pr + "]){3,}[" + sd + pr + "]*", KB = new RegExp("^[" + Uf + "]{0,1}(?:[" + sd + "]*[" + pr + "]){1,2}$", "i"), GB = YB + // Phone number extensions
"(?:" + s3() + ")?", JB = new RegExp(
  // Either a short two-digit-only phone number
  "^" + qB + "$|^" + GB + "$",
  "i"
);
function XB(e) {
  return e.length >= Wf && JB.test(e);
}
function QB(e) {
  return KB.test(e);
}
var vm = new RegExp("(?:" + s3() + ")$", "i");
function ZB(e) {
  var t = e.search(vm);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(vm), i = 1; i < r.length; ) {
    if (r[i])
      return {
        number: n,
        ext: r[i]
      };
    i++;
  }
}
var ez = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function tz(e) {
  return ez[e];
}
function nz(e, t) {
  var n = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = rz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rz(e, t) {
  if (e) {
    if (typeof e == "string") return ym(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ym(e, t);
  }
}
function ym(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function bm(e) {
  for (var t = "", n = nz(e.split("")), r; !(r = n()).done; ) {
    var i = r.value;
    t += iz(i, t) || "";
  }
  return t;
}
function iz(e, t, n) {
  return e === "+" ? t ? void 0 : "+" : tz(e);
}
function Yf(e, t) {
  return oz(e, void 0, t);
}
function oz(e, t, n) {
  var r = n.type(t), i = r && r.possibleLengths() || n.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  var o = e.length, a = i[0];
  return a === o ? "IS_POSSIBLE" : a > o ? "TOO_SHORT" : i[i.length - 1] < o ? "TOO_LONG" : i.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function az(e, t, n) {
  if (t === void 0 && (t = {}), n = new kn(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return l3(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function l3(e, t) {
  switch (Yf(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function ui(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function sz(e, t) {
  var n = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = lz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lz(e, t) {
  if (e) {
    if (typeof e == "string") return $m(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $m(e, t);
  }
}
function $m(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var dz = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Kf(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new kn(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (ui(r, n.nationalNumberPattern())) {
      if (Qu(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Qu(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = sz(dz), o; !(o = i()).done; ) {
        var a = o.value;
        if (Qu(r, a, n))
          return a;
      }
    }
  }
}
function Qu(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : ui(e, t.pattern());
}
function uz(e, t, n) {
  if (t = t || {}, n = new kn(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return Kf(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return ui(r, n.nationalNumberPattern());
}
function cz(e, t, n) {
  var r = new kn(n), i = r.getCountryCodesForCallingCode(e);
  return i ? i.filter(function(o) {
    return fz(t, o, n);
  }) : [];
}
function fz(e, t, n) {
  var r = new kn(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function pz(e) {
  return e.replace(new RegExp("[".concat(sd, "]+"), "g"), " ").trim();
}
var hz = /(\$\d)/;
function mz(e, t, n) {
  var r = n.useInternationalFormat, i = n.withNationalPrefix, o = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && t.nationalPrefixFormattingRule() ? t.format().replace(hz, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? pz(o) : o;
}
var gz = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function vz(e, t, n) {
  var r = new kn(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (gz.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function yz(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function bz(e, t) {
  var n = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = $z(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $z(e, t) {
  if (e) {
    if (typeof e == "string") return wm(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wm(e, t);
  }
}
function wm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function km(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? km(Object(n), !0).forEach(function(r) {
      wz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : km(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Sm = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function kz(e, t, n, r) {
  if (n ? n = xm(xm({}, Sm), n) : n = Sm, r = new kn(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var i = r.countryCallingCode(), o = n.v2 ? e.nationalNumber : e.phone, a;
  switch (t) {
    case "NATIONAL":
      return o ? (a = ld(o, e.carrierCode, "NATIONAL", r, n), Zu(a, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (a = ld(o, null, "INTERNATIONAL", r, n), a = "+".concat(i, " ").concat(a), Zu(a, e.ext, r, n.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(o);
    case "RFC3966":
      return yz({
        number: "+".concat(i).concat(o),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = Sz(o, e.carrierCode, i, n.fromCountry, r);
      return Zu(s, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function ld(e, t, n, r, i) {
  var o = xz(r.formats(), e);
  return o ? mz(e, o, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function xz(e, t) {
  for (var n = bz(e), r; !(r = n()).done; ) {
    var i = r.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var o = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (t.search(o) !== 0)
        continue;
    }
    if (ui(t, i.pattern()))
      return i;
  }
}
function Zu(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function Sz(e, t, n, r, i) {
  var o = qf(r, i.metadata);
  if (o === n) {
    var a = ld(e, t, "NATIONAL", i);
    return n === "1" ? n + " " + a : a;
  }
  var s = vz(r, void 0, i.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(ld(e, null, "INTERNATIONAL", i));
}
function Cm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cm(Object(n), !0).forEach(function(r) {
      Cz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Cz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Tz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Mz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Oz(e, t, n) {
  return t && Mz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Ez = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (Tz(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var i = Az(t, r), o = i.country, a = i.countryCallingCode;
    this.country = o, this.countryCallingCode = a, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return Oz(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : cz(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return az(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return uz(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new kn(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Kf(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return kz(this, n, r ? Tm(Tm({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), Dz = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Az(e, t) {
  var n, r, i = new kn(t);
  return Dz(e) ? (n = e, i.selectNumberingPlan(n), r = i.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var Pz = new RegExp("([" + pr + "])");
function Nz(e, t, n, r) {
  if (t) {
    var i = new kn(r);
    i.selectNumberingPlan(t, n);
    var o = new RegExp(i.IDDPrefix());
    if (e.search(o) === 0) {
      e = e.slice(e.match(o)[0].length);
      var a = e.match(Pz);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return e;
    }
  }
}
function Iz(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var i, o, a = r.length - 1, s = a > 0 && r[a];
      if (t.nationalPrefixTransformRule() && s)
        i = e.replace(n, t.nationalPrefixTransformRule()), a > 1 && (o = r[1]);
      else {
        var l = r[0];
        i = e.slice(l.length), s && (o = r[1]);
      }
      var d;
      if (s) {
        var u = e.indexOf(r[1]), c = e.slice(0, u);
        c === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = r[0];
      return {
        nationalNumber: i,
        nationalPrefix: d,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function n0(e, t) {
  var n = Iz(e, t), r = n.carrierCode, i = n.nationalNumber;
  if (i !== e) {
    if (!Rz(e, i, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !_z(i, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: i,
    carrierCode: r
  };
}
function Rz(e, t, n) {
  return !(ui(e, n.nationalNumberPattern()) && !ui(t, n.nationalNumberPattern()));
}
function _z(e, t) {
  switch (Yf(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Lz(e, t, n, r) {
  var i = t ? qf(t, r) : n;
  if (e.indexOf(i) === 0) {
    r = new kn(r), r.selectNumberingPlan(t, n);
    var o = e.slice(i.length), a = n0(o, r), s = a.nationalNumber, l = n0(e, r), d = l.nationalNumber;
    if (!ui(d, r.nationalNumberPattern()) && ui(s, r.nationalNumberPattern()) || Yf(d, r) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: o
      };
  }
  return {
    number: e
  };
}
function Fz(e, t, n, r) {
  if (!e)
    return {};
  var i;
  if (e[0] !== "+") {
    var o = Nz(e, t, n, r);
    if (o && o !== e)
      i = !0, e = "+" + o;
    else {
      if (t || n) {
        var a = Lz(e, t, n, r), s = a.countryCallingCode, l = a.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new kn(r);
  for (var d = 2; d - 1 <= MB && d <= e.length; ) {
    var u = e.slice(1, d);
    if (r.hasCallingCode(u))
      return r.selectNumberingPlan(u), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(d)
      };
    d++;
  }
  return {};
}
function Bz(e, t) {
  var n = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = zz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zz(e, t) {
  if (e) {
    if (typeof e == "string") return Mm(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Mm(e, t);
  }
}
function Mm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Vz(e, t) {
  var n = t.countries, r = t.defaultCountry, i = t.metadata;
  i = new kn(i);
  for (var o = [], a = Bz(n), s; !(s = a()).done; ) {
    var l = s.value;
    if (i.country(l), i.leadingDigits()) {
      if (e && e.search(i.leadingDigits()) === 0)
        return l;
    } else if (Kf({
      phone: e,
      country: l
    }, void 0, i.metadata))
      if (r) {
        if (l === r)
          return l;
        o.push(l);
      } else
        return l;
  }
  if (o.length > 0)
    return o[0];
}
function Hz(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, i = t.metadata, o = i.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : Vz(n, {
      countries: o,
      defaultCountry: r,
      metadata: i.metadata
    });
}
var d3 = "+", jz = "[\\-\\.\\(\\)]?", Om = "([" + pr + "]|" + jz + ")", Wz = "^\\" + d3 + Om + "*[" + pr + "]" + Om + "*$", Uz = new RegExp(Wz, "g"), r0 = pr, qz = "[" + r0 + "]+((\\-)*[" + r0 + "])*", Yz = "a-zA-Z", Kz = "[" + Yz + "]+((\\-)*[" + r0 + "])*", Gz = "^(" + qz + "\\.)*" + Kz + "\\.?$", Jz = new RegExp(Gz, "g"), Em = "tel:", i0 = ";phone-context=", Xz = ";isub=";
function Qz(e) {
  var t = e.indexOf(i0);
  if (t < 0)
    return null;
  var n = t + i0.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function Zz(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Uz.test(e) || Jz.test(e);
}
function eV(e, t) {
  var n = t.extractFormattedPhoneNumber, r = Qz(e);
  if (!Zz(r))
    throw new ti("NOT_A_NUMBER");
  var i;
  if (r === null)
    i = n(e) || "";
  else {
    i = "", r.charAt(0) === d3 && (i += r);
    var o = e.indexOf(Em), a;
    o >= 0 ? a = o + Em.length : a = 0;
    var s = e.indexOf(i0);
    i += e.substring(a, s);
  }
  var l = i.indexOf(Xz);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var tV = 250, nV = new RegExp("[" + Uf + pr + "]"), rV = new RegExp("[^" + pr + "#]+$");
function iV(e, t, n) {
  if (t = t || {}, n = new kn(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new ti("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = aV(e, t.v2, t.extract), i = r.number, o = r.ext, a = r.error;
  if (!i) {
    if (t.v2)
      throw a === "TOO_SHORT" ? new ti("TOO_SHORT") : new ti("NOT_A_NUMBER");
    return {};
  }
  var s = lV(i, t.defaultCountry, t.defaultCallingCode, n), l = s.country, d = s.nationalNumber, u = s.countryCallingCode, c = s.countryCallingCodeSource, f = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new ti("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < Wf) {
    if (t.v2)
      throw new ti("TOO_SHORT");
    return {};
  }
  if (d.length > TB) {
    if (t.v2)
      throw new ti("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var h = new Ez(u, d, n.metadata);
    return l && (h.country = l), f && (h.carrierCode = f), o && (h.ext = o), h.__countryCallingCodeSource = c, h;
  }
  var p = (t.extended ? n.hasSelectedNumberingPlan() : l) ? ui(d, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: f,
    valid: p,
    possible: p ? !0 : !!(t.extended === !0 && n.possibleLengths() && l3(d, n)),
    phone: d,
    ext: o
  } : p ? sV(l, d, o) : {};
}
function oV(e, t, n) {
  if (e) {
    if (e.length > tV) {
      if (n)
        throw new ti("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(nV);
    if (!(r < 0))
      return e.slice(r).replace(rV, "");
  }
}
function aV(e, t, n) {
  var r = eV(e, {
    extractFormattedPhoneNumber: function(a) {
      return oV(a, n, t);
    }
  });
  if (!r)
    return {};
  if (!XB(r))
    return QB(r) ? {
      error: "TOO_SHORT"
    } : {};
  var i = ZB(r);
  return i.ext ? i : {
    number: r
  };
}
function sV(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function lV(e, t, n, r) {
  var i = Fz(bm(e), t, n, r.metadata), o = i.countryCallingCodeSource, a = i.countryCallingCode, s = i.number, l;
  if (a)
    r.selectNumberingPlan(a);
  else if (s && (t || n))
    r.selectNumberingPlan(t, n), t && (l = t), a = n || qf(t, r.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: o,
      countryCallingCode: a
    };
  var d = n0(bm(s), r), u = d.nationalNumber, c = d.carrierCode, f = Hz(a, {
    nationalNumber: u,
    defaultCountry: t,
    metadata: r
  });
  return f && (l = f, f === "001" || r.country(l)), {
    country: l,
    countryCallingCode: a,
    countryCallingCodeSource: o,
    nationalNumber: u,
    carrierCode: c
  };
}
function Dm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Am(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dm(Object(n), !0).forEach(function(r) {
      dV(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Dm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function dV(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function uV(e, t, n) {
  return iV(e, Am(Am({}, t), {}, {
    v2: !0
  }), n);
}
function Pm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cV(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pm(Object(n), !0).forEach(function(r) {
      fV(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fV(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pV(e, t) {
  return vV(e) || gV(e, t) || mV(e, t) || hV();
}
function hV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mV(e, t) {
  if (e) {
    if (typeof e == "string") return Nm(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Nm(e, t);
  }
}
function Nm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function gV(e, t) {
  var n = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function vV(e) {
  if (Array.isArray(e)) return e;
}
function yV(e) {
  var t = Array.prototype.slice.call(e), n = pV(t, 4), r = n[0], i = n[1], o = n[2], a = n[3], s, l, d;
  if (typeof r == "string")
    s = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    a ? (l = o, d = a) : (l = void 0, d = o), i && (l = cV({
      defaultCountry: i
    }, l));
  else if (rl(i))
    o ? (l = i, d = o) : d = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: s,
    options: l,
    metadata: d
  };
}
function Im(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Im(Object(n), !0).forEach(function(r) {
      bV(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Im(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bV(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $V(e, t, n) {
  t && t.defaultCountry && !WB(t.defaultCountry, n) && (t = Rm(Rm({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return uV(e, t, n);
  } catch (r) {
    if (!(r instanceof ti)) throw r;
  }
}
function wV() {
  var e = yV(arguments), t = e.text, n = e.options, r = e.metadata;
  return $V(t, n, r);
}
function kV() {
  return bB(wV, arguments);
}
const kH = /* @__PURE__ */ $e({
  __name: "DsPhoneNumberInput",
  props: /* @__PURE__ */ rc({
    format: { default: "INTERNATIONAL" },
    countryCode: { default: "DE" },
    size: { default: "base" },
    placeholder: { default: "+49 123 4567890" },
    immediate: { type: Boolean },
    mobile: { type: Boolean }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ rc(["update:modelValue", "valid", "invalid"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = t, i = zm(e, "modelValue"), o = q(null), a = E(() => {
      var h, p;
      return (p = (h = o.value) == null ? void 0 : h.input) != null ? p : null;
    }), s = E(() => u(i.value)), l = E({
      get: () => c({
        number: s.value,
        format: n.format,
        emit: !0
      }),
      set: (h) => {
        const p = u(h);
        a.value && (a.value.value = p), r("update:modelValue", c({ number: p, format: n.format }));
      }
    });
    ot(() => {
      var h;
      return (h = a.value) == null ? void 0 : h.addEventListener("paste", d);
    }), hr(() => {
      var h;
      return (h = a.value) == null ? void 0 : h.removeEventListener("paste", d);
    });
    function d(h) {
      var p, m;
      i.value = (m = (p = h.target) == null ? void 0 : p.value) != null ? m : "";
    }
    function u(h) {
      var p;
      return ((p = h == null ? void 0 : h.replace(/[^\d\s+]/g, "")) != null ? p : "").trimStart();
    }
    function c({
      number: h,
      format: p,
      emit: m = !1
    }) {
      const g = f(h);
      if (!(g != null && g.isValid()))
        return m && r("invalid"), h;
      const v = g.getType() === "MOBILE", b = g.getType() === "FIXED_LINE";
      return n.mobile && !v || !n.mobile && !b ? (m && r("invalid"), h) : (m && r("valid"), g.format(p));
    }
    function f(h) {
      return kV(h, n.countryCode);
    }
    return (h, p) => (k(), ge(pa, {
      ref_key: "dsInput",
      ref: o,
      modelValue: l.value,
      "onUpdate:modelValue": p[0] || (p[0] = (m) => l.value = m),
      type: "tel",
      immediate: h.immediate,
      size: h.size,
      placeholder: h.placeholder
    }, null, 8, ["modelValue", "immediate", "size", "placeholder"]));
  }
});
var u3 = {}, c3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return Array.isArray(n) ? n.map((r) => t(r)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([r, i]) => [
      r,
      t(i)
    ])) : n;
  }
})(c3);
var xV = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: e }) => ({
      ...e("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: e }) => e("blur"),
    backdropBrightness: ({ theme: e }) => e("brightness"),
    backdropContrast: ({ theme: e }) => e("contrast"),
    backdropGrayscale: ({ theme: e }) => e("grayscale"),
    backdropHueRotate: ({ theme: e }) => e("hueRotate"),
    backdropInvert: ({ theme: e }) => e("invert"),
    backdropOpacity: ({ theme: e }) => e("opacity"),
    backdropSaturate: ({ theme: e }) => e("saturate"),
    backdropSepia: ({ theme: e }) => e("sepia"),
    backgroundColor: ({ theme: e }) => e("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: e }) => e("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: e }) => ({
      ...e("colors"),
      DEFAULT: e("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: e }) => e("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: e }) => ({
      ...e("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: e }) => e("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: e }) => e("colors"),
    colors: ({ colors: e }) => ({
      inherit: e.inherit,
      current: e.current,
      transparent: e.transparent,
      black: e.black,
      white: e.white,
      slate: e.slate,
      gray: e.gray,
      zinc: e.zinc,
      neutral: e.neutral,
      stone: e.stone,
      red: e.red,
      orange: e.orange,
      amber: e.amber,
      yellow: e.yellow,
      lime: e.lime,
      green: e.green,
      emerald: e.emerald,
      teal: e.teal,
      cyan: e.cyan,
      sky: e.sky,
      blue: e.blue,
      indigo: e.indigo,
      violet: e.violet,
      purple: e.purple,
      fuchsia: e.fuchsia,
      pink: e.pink,
      rose: e.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: e }) => e("borderColor"),
    divideOpacity: ({ theme: e }) => e("borderOpacity"),
    divideWidth: ({ theme: e }) => e("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: e }) => e("spacing"),
    gradientColorStops: ({ theme: e }) => e("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: e }) => ({
      ...e("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: e, breakpoints: t }) => ({
      ...e("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(e("screens"))
    }),
    minHeight: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: e }) => e("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: e }) => e("spacing"),
    placeholderColor: ({ theme: e }) => e("colors"),
    placeholderOpacity: ({ theme: e }) => e("opacity"),
    ringColor: ({ theme: e }) => ({
      DEFAULT: e("colors.blue.500", "#3b82f6"),
      ...e("colors")
    }),
    ringOffsetColor: ({ theme: e }) => e("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: e }) => ({
      DEFAULT: "0.5",
      ...e("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: e }) => ({
      ...e("spacing")
    }),
    scrollPadding: ({ theme: e }) => e("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: e }) => ({
      ...e("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: e }) => e("colors"),
    textDecorationColor: ({ theme: e }) => e("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: e }) => ({
      ...e("spacing")
    }),
    textOpacity: ({ theme: e }) => e("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: e }) => ({
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const t = c3, n = /* @__PURE__ */ r(xV);
  function r(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  const i = (0, t.cloneDeep)(n.default.theme);
})(u3);
let ec = u3;
var SV = (ec.__esModule ? ec : { default: ec }).default;
const _m = /* @__PURE__ */ w0(SV);
var f3 = {}, p3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(r, i) {
    return {
      handler: r,
      config: i
    };
  }
  t.withOptions = function(r, i = () => ({})) {
    const o = function(a) {
      return {
        __options: a,
        handler: r(a),
        config: i(a)
      };
    };
    return o.__isOptionsFunction = !0, o.__pluginFunction = r, o.__configFunction = i, o;
  };
  const n = t;
})(p3);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const t = /* @__PURE__ */ n(p3);
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const r = t.default;
})(f3);
let tc = f3;
var CV = (tc.__esModule ? tc : { default: tc }).default;
const TV = /* @__PURE__ */ w0(CV), MV = {
  transparent: "transparent",
  black: "#000000",
  white: "#FFFFFF",
  gray: {
    50: "#FAFAFF",
    100: "#F2F2F5",
    200: "#D9DADF",
    300: "#B4B8C0",
    // 400
    500: "#858B98",
    // 600
    700: "#535864",
    800: "#41464F",
    900: "#292B31"
  },
  blue: {
    100: "#D8E7F7",
    200: "#B4CEEF",
    300: "#8FB7E7",
    // 400
    500: "#4181D2",
    // 600
    700: "#2360B0",
    800: "#1D4E8C"
    // 900
  },
  red: {
    100: "#FCDAD5",
    // 200
    300: "#F18571",
    // 400
    500: "#E83F25",
    // 600
    700: "#9E2511",
    800: "#7D0000"
    // 900
  },
  green: {
    100: "#EAF6D4",
    // 200
    300: "#C8E78F",
    // 400
    500: "#A6D64D",
    // 600
    700: "#7EB023",
    800: "#658C1D"
    // 900
  },
  orange: {
    100: "#FFF0D0",
    // 200
    300: "#FFD27A",
    // 400
    500: "#FFB62D",
    // 600
    700: "#DB8E00",
    800: "#AF7200"
    // 900
  }
}, OV = {
  theme: {
    colors: MV,
    extend: {
      fontFamily: {
        sans: ["Inter var", ..._m.fontFamily.sans]
      },
      minHeight: {
        6: _m.spacing[6]
      },
      maxWidth: {
        lg: "32rem"
      }
    }
  },
  variants: {
    extend: {
      borderRadius: ["first", "last"]
    },
    // No responsive changes to font families
    fontFamily: []
  }
}, xH = TV(({
  addUtilities: e
}) => {
  e({
    ".shadow-xs": {
      "@apply ring-1 ring-black/5": {}
    },
    ".shadow-outline-blue": {
      "@apply ring-2 ring-blue-300/60 ring-offset-1 ring-offset-blue-500": {}
    },
    ".shadow-outline-red": {
      "@apply ring-2 ring-red-300/60 ring-offset-1 ring-offset-red-500": {}
    }
  });
}, OV);
globalThis['styleInject']=function(css,ref){if(ref===void 0){ref={}}var insertAt=ref.insertAt;if(!css||typeof document==="undefined"){return}var head=document.head||document.getElementsByTagName("head")[0];var style=document.createElement("style");style.type="text/css";if(insertAt==="top"){if(head.firstChild){head.insertBefore(style,head.firstChild)}else{head.appendChild(style)}}else{head.appendChild(style)}if(style.styleSheet){style.styleSheet.cssText=css}else{style.appendChild(document.createTextNode(css))}};globalThis['styleInject'](`
.dp__theme_light {
  --dp-background-color: #fff;
  --dp-text-color: #292B31; /*design system color gray-900*/
  --dp-hover-color: #B4CEEF; /*design system color blue-200*/
  --dp-hover-text-color: #fff;
  --dp-hover-icon-color: #959595;
  --dp-primary-color: #4181D2; /*design system color blue-500*/
  --dp-primary-disabled-color: #8FB7E7; /*design system color blue-300*/
  --dp-primary-text-color: #f8f5f5;
  --dp-secondary-color: #c0c4cc;
  --dp-border-color: #ddd;
  --dp-menu-border-color: #ddd;
  --dp-border-color-hover: #aaaeb7;
  --dp-disabled-color: #f6f6f6;
  --dp-scroll-bar-background: #f3f3f3;
  --dp-scroll-bar-color: #959595;
  --dp-success-color: #A6D64D; /*design system color green-500*/
  --dp-success-color-disabled: #a3d9b1;
  --dp-icon-color: #959595;
  --dp-danger-color: #E83F25; /*design system color red-500*/
  --dp-marker-color: #E83F25; /*design system color red-500*/
  --dp-tooltip-color: #fafafa;
  --dp-disabled-color-text: #B4B8C0; /*design system color gray-300*/
  --dp-highlight-color: rgb(25 118 210 / 10%);
  --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
  --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
  --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);

  --dp-cell-size: 25px; /*Width and height of calendar cell*/
  --dp-menu-padding: 0px; /*Menu padding*/

  --dp-font-size: 0.75rem;
}
.dp__month_year_wrap {
  font-size: 1rem;
}
.dp__calendar_row {
  padding-right: 0.5em;
  padding-left: 0.5em;
}
.dp__calendar_header {
  padding: 0.5em;
}
.dp__inner_nav {
  border-radius: 0;
}
.dp__month_year_row {
  margin-top: 0.5em;
}
.dp__arrow_top {
  visibility: hidden;
}
.dp__arrow_bottom {
  visibility: hidden;
}


.editor-content h1 {
  font-weight: bolder !important;
  font-size: x-large !important;
  line-height: 1.1 !important;
}
.editor-content h2 {
  font-weight: bolder !important;
  font-size: large !important;
}
.editor-content h3 {
  font-weight: bolder !important;
  font-size: medium !important;
}
.editor-content ul {
  list-style-type: disc !important;
}
.editor-content ol {
  list-style-type: decimal !important;
}
.editor-content ul, .editor-content ol {
  padding: 0 1rem !important;
}
.editor-content a {
  color: #4787D1 !important;
  text-decoration: underline !important;
}
.editor__font-button {
  background: linear-gradient(to right, rgb(101, 84, 192) 25%, rgb(0, 184,
  217) 25%, rgb(0, 184, 217) 50%, rgb(255, 153, 31) 50%, rgb(255, 153, 31)
  75%, rgb(222, 53, 11) 75%) !important;
}
.editor__font-button--disabled {
  background: #C9D0D4
}


input[type=file], /* FF, IE7+, chrome (except button) */
input[type=file]::-webkit-file-upload-button { /* chromes and blink button */
    cursor: pointer;
}
.fileInputStretch {
  height: 100% !important;
  width: 100% !important;
}


/* Override HeadlessUI style to avoid button display styles on safari (up to version 15) */
[type="button"][data-v-d9449d22] {
  -webkit-appearance: none;
}


.listbox-grid[data-v-46b378f7] {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: minmax(0, auto) auto auto 1fr;
}
.listbox-grid-default[data-v-46b378f7] {
  grid-template-areas:
    "group-filters group-filters group-filters"
    "filter-bar filter-bar filter-bar"
    "header-source placeholder header-selection"
    "listbox-source listbox-buttons listbox-selection";
}
.filter-bar[data-v-46b378f7] { grid-area: filter-bar;
}
.group-filters[data-v-46b378f7] { grid-area: group-filters;
}
.header-source[data-v-46b378f7] { grid-area: header-source;
}
.header-selection[data-v-46b378f7] { grid-area: header-selection;
}
.listbox-source[data-v-46b378f7] { grid-area: listbox-source;
}
.listbox-buttons[data-v-46b378f7] { grid-area: listbox-buttons;
}
.listbox-selection[data-v-46b378f7] { grid-area: listbox-selection;
}


@keyframes fadeInRight-ea0c4bc7 {
0% {
    transform: translateX(50px);
    opacity: 0;
}
100% {
    transform: translateX(0);
    opacity: 1;
}
}
@keyframes fadeInBottom-ea0c4bc7 {
0% {
    transform: translateY(50px);
    opacity: 0;
}
100% {
    transform: translateY(0);
    opacity: 1;
}
}
@keyframes fadeOutRight-ea0c4bc7 {
0% {
    transform: translateX(0);
    opacity: 1;
}
100% {
    transform: translateX(50px);
    opacity: 0;
}
}
@keyframes fadeOutBottom-ea0c4bc7 {
0% {
    transform: translateY(0);
    opacity: 1;
}
100% {
    transform: translateY(50px);
    opacity: 0;
}
}
.notificationList-move[data-v-ea0c4bc7] {
  transition-timing-function: ease-in-out;
  transition-property: all;
  transition-duration: 400ms;
}
.notificationList-enter-active[data-v-ea0c4bc7] {
  animation-name: fadeInBottom-ea0c4bc7;
}
.notificationList-leave-active[data-v-ea0c4bc7] {
  animation-name: fadeOutBottom-ea0c4bc7;
}
.notificationList-enter-active[data-v-ea0c4bc7],
.notificationList-leave-active[data-v-ea0c4bc7] {
  animation-duration: 250ms;
  animation-fill-mode: both;
}
@media screen and (min-width: 1024px) {
.notificationList-enter-active[data-v-ea0c4bc7] {
    animation-name: fadeInRight-ea0c4bc7;
}
.notificationList-leave-active[data-v-ea0c4bc7] {
    animation-name: fadeOutRight-ea0c4bc7;
}
}
.progress-container[data-v-ea0c4bc7]{
  overflow: hidden;
  border-bottom-left-radius: .25rem;
  border-bottom-right-radius: .25rem;
}
.progress-container--info[data-v-ea0c4bc7] div > div {
  background: #4787D1;
}
.progress-container--success[data-v-ea0c4bc7] div > div {
  background: #7DC24C;
}
.progress-container--warning[data-v-ea0c4bc7] div > div {
  background: #F2AD0D;
}
.progress-container--error[data-v-ea0c4bc7] div > div {
  background: #E85B52;
}


div[role="tooltip"] .arrow[data-v-c06796f7] {
  display: inline-block;
  position: absolute;
  --ds-arrow-color: #383F42;
  --ds-arrow-size: 0.65rem;
  --ds-arrow-rotate: 0deg;
  --ds-arrow-border-padding: 0px;
  --ds-arrow-position: calc(-1 * 2 * (var(--ds-arrow-size) - .08rem) - var(--ds-arrow-border-padding));

  border-left: var(--ds-arrow-size) solid transparent;
  border-right: var(--ds-arrow-size) solid transparent;
  border-bottom: var(--ds-arrow-size) solid var(--ds-arrow-color);
  border-top: var(--ds-arrow-size) solid transparent;
}
div[role="tooltip"] .arrow.arrow-white[data-v-c06796f7] {
  --ds-arrow-border-padding: 1px;
  --ds-arrow-color: #e2e2e2;
}
div[role="tooltip"] .arrow.arrow-small[data-v-c06796f7] {
  --ds-arrow-size: 0.5rem;
}
div[role="tooltip"] .arrow.arrow-large[data-v-c06796f7] {
  --ds-arrow-size: 0.75rem;
}
div[role="tooltip"][data-popper-placement="top"] .arrow[data-v-c06796f7],
div[role="tooltip"][data-popper-placement="bottom"] .arrow[data-v-c06796f7] {
  left: 50%;
  transform: translateX(-50%) rotate(var(--ds-arrow-rotate));
}
div[role="tooltip"][data-popper-placement="left"] .arrow[data-v-c06796f7],
div[role="tooltip"][data-popper-placement="right"] .arrow[data-v-c06796f7] {
  top: 50%;
  transform: translateY(-50%) rotate(var(--ds-arrow-rotate));
}
div[role="tooltip"][data-popper-placement="top"] .arrow[data-v-c06796f7] {
  bottom: var(--ds-arrow-position);
  --ds-arrow-rotate: 180deg;
}
div[role="tooltip"][data-popper-placement="bottom"] .arrow[data-v-c06796f7] {
  top: var(--ds-arrow-position);
}
div[role="tooltip"][data-popper-placement="left"] .arrow[data-v-c06796f7] {
  right: var(--ds-arrow-position);
  --ds-arrow-rotate: 90deg;
}
div[role="tooltip"][data-popper-placement="right"] .arrow[data-v-c06796f7] {
  left: var(--ds-arrow-position);
  --ds-arrow-rotate: -90deg;
}
div[role="tooltip"][data-popper-placement="top"] .arrow-container[data-v-c06796f7] {
  margin-bottom: 0.5rem;
}
div[role="tooltip"][data-popper-placement="bottom"] .arrow-container[data-v-c06796f7] {
  margin-top: 0.5rem;
}
div[role="tooltip"][data-popper-placement="left"] .arrow-container[data-v-c06796f7] {
  margin-right: 1rem;
}
div[role="tooltip"][data-popper-placement="right"] .arrow-container[data-v-c06796f7] {
  margin-left: 1rem;
}

.dp__input_wrap{position:relative;width:100%;box-sizing:unset}.dp__input_wrap:focus{border-color:var(--dp-border-color-hover);outline:none}.dp__input{background-color:var(--dp-background-color);border-radius:var(--dp-border-radius);font-family:var(--dp-font-family);border:1px solid var(--dp-border-color);outline:none;transition:border-color .2s cubic-bezier(0.645, 0.045, 0.355, 1);width:100%;font-size:var(--dp-font-size);line-height:calc(var(--dp-font-size)*1.5);padding:var(--dp-input-padding);color:var(--dp-text-color);box-sizing:border-box}.dp__input::-moz-placeholder{opacity:.7}.dp__input::placeholder{opacity:.7}.dp__input:hover{border-color:var(--dp-border-color-hover)}.dp__input_reg{caret-color:rgba(0,0,0,0)}.dp__input_focus{border-color:var(--dp-border-color-hover)}.dp__disabled{background:var(--dp-disabled-color)}.dp__disabled::-moz-placeholder{color:var(--dp-disabled-color-text)}.dp__disabled::placeholder{color:var(--dp-disabled-color-text)}.dp__input_icons{display:inline-block;width:var(--dp-font-size);height:var(--dp-font-size);stroke-width:0;font-size:var(--dp-font-size);line-height:calc(var(--dp-font-size)*1.5);padding:6px 12px;color:var(--dp-icon-color);box-sizing:content-box}.dp__input_icon{cursor:pointer;position:absolute;top:50%;inset-inline-start:0;transform:translateY(-50%);color:var(--dp-icon-color)}.dp__clear_icon{position:absolute;top:50%;inset-inline-end:0;transform:translateY(-50%);cursor:pointer;color:var(--dp-icon-color)}.dp__input_icon_pad{padding-inline-start:var(--dp-input-icon-padding)}.dp__input_valid{box-shadow:0 0 var(--dp-border-radius) var(--dp-success-color);border-color:var(--dp-success-color)}.dp__input_valid:hover{border-color:var(--dp-success-color)}.dp__input_invalid{box-shadow:0 0 var(--dp-border-radius) var(--dp-danger-color);border-color:var(--dp-danger-color)}.dp__input_invalid:hover{border-color:var(--dp-danger-color)}.dp__menu{background:var(--dp-background-color);border-radius:var(--dp-border-radius);min-width:var(--dp-menu-min-width);font-family:var(--dp-font-family);font-size:var(--dp-font-size);-webkit-user-select:none;-moz-user-select:none;user-select:none;border:1px solid var(--dp-menu-border-color);box-sizing:border-box}.dp__menu::after{box-sizing:border-box}.dp__menu::before{box-sizing:border-box}.dp__menu:focus{border:1px solid var(--dp-menu-border-color);outline:none}.dp--menu-wrapper{position:absolute;z-index:99999}.dp__menu_inner{padding:var(--dp-menu-padding)}.dp--menu--inner-stretched{padding:6px 0}.dp__menu_index{z-index:99999}.dp-menu-loading,.dp__menu_readonly,.dp__menu_disabled{position:absolute;inset:0;z-index:999999}.dp__menu_disabled{background:rgba(255,255,255,.5);cursor:not-allowed}.dp__menu_readonly{background:rgba(0,0,0,0);cursor:default}.dp-menu-loading{background:rgba(255,255,255,.5);cursor:default}.dp--menu-load-container{display:flex;height:100%;width:100%;justify-content:center;align-items:center}.dp--menu-loader{width:48px;height:48px;border:var(--dp-loader);border-bottom-color:rgba(0,0,0,0);border-radius:50%;display:inline-block;box-sizing:border-box;animation:dp-load-rotation 1s linear infinite;position:absolute}@keyframes dp-load-rotation{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.dp__arrow_top{left:var(--dp-arrow-left);top:0;height:12px;width:12px;background-color:var(--dp-background-color);position:absolute;border-inline-end:1px solid var(--dp-menu-border-color);border-top:1px solid var(--dp-menu-border-color);transform:translate(-50%, -50%) rotate(-45deg)}.dp__arrow_bottom{left:var(--dp-arrow-left);bottom:0;height:12px;width:12px;background-color:var(--dp-background-color);position:absolute;border-inline-end:1px solid var(--dp-menu-border-color);border-bottom:1px solid var(--dp-menu-border-color);transform:translate(-50%, 50%) rotate(45deg)}.dp__action_extra{text-align:center;padding:2px 0}.dp--preset-dates{padding:5px;border-inline-end:1px solid var(--dp-border-color)}@media only screen and (width <= 600px){.dp--preset-dates{display:flex;align-self:center;border:none;overflow-x:auto;max-width:calc(var(--dp-menu-width) - var(--dp-action-row-padding)*2)}}.dp--preset-dates-collapsed{display:flex;align-self:center;border:none;overflow-x:auto;max-width:calc(var(--dp-menu-width) - var(--dp-action-row-padding)*2)}.dp__sidebar_left{padding:5px;border-inline-end:1px solid var(--dp-border-color)}.dp__sidebar_right{padding:5px;margin-inline-end:1px solid var(--dp-border-color)}.dp--preset-range{display:block;width:100%;padding:5px;text-align:left;white-space:nowrap;color:var(--dp-text-color);border-radius:var(--dp-border-radius);transition:var(--dp-common-transition)}.dp--preset-range:hover{background-color:var(--dp-hover-color);color:var(--dp-hover-text-color);cursor:pointer}@media only screen and (width <= 600px){.dp--preset-range{border:1px solid var(--dp-border-color);margin:0 3px}.dp--preset-range:first-child{margin-left:0}.dp--preset-range:last-child{margin-right:0}}.dp--preset-range-collapsed{border:1px solid var(--dp-border-color);margin:0 3px}.dp--preset-range-collapsed:first-child{margin-left:0}.dp--preset-range-collapsed:last-child{margin-right:0}.dp__menu_content_wrapper{display:flex}@media only screen and (width <= 600px){.dp__menu_content_wrapper{flex-direction:column-reverse}}.dp--menu-content-wrapper-collapsed{flex-direction:column-reverse}.dp__calendar_header{position:relative;display:flex;justify-content:center;align-items:center;color:var(--dp-text-color);white-space:nowrap;font-weight:bold}.dp__calendar_header_item{text-align:center;flex-grow:1;height:var(--dp-cell-size);padding:var(--dp-cell-padding);width:var(--dp-cell-size);box-sizing:border-box}.dp__calendar_row{display:flex;justify-content:center;align-items:center;margin:var(--dp-row-margin)}.dp__calendar_item{text-align:center;flex-grow:1;box-sizing:border-box;color:var(--dp-text-color)}.dp__calendar{position:relative}.dp__calendar_header_cell{border-bottom:thin solid var(--dp-border-color);padding:var(--dp-calendar-header-cell-padding)}.dp__cell_inner{display:flex;align-items:center;text-align:center;justify-content:center;border-radius:var(--dp-cell-border-radius);height:var(--dp-cell-size);padding:var(--dp-cell-padding);width:var(--dp-cell-size);border:1px solid rgba(0,0,0,0);box-sizing:border-box;position:relative}.dp__cell_inner:hover{transition:all .2s}.dp__cell_auto_range_start,.dp__date_hover_start:hover,.dp__range_start{border-end-end-radius:0;border-start-end-radius:0}.dp__cell_auto_range_end,.dp__date_hover_end:hover,.dp__range_end{border-end-start-radius:0;border-start-start-radius:0}.dp__range_end,.dp__range_start,.dp__active_date{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__date_hover_end:hover,.dp__date_hover_start:hover,.dp__date_hover:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__cell_offset{color:var(--dp-secondary-color)}.dp__cell_disabled{color:var(--dp-secondary-color);cursor:not-allowed}.dp__range_between{background:var(--dp-range-between-dates-background-color);color:var(--dp-range-between-dates-text-color);border-radius:0;border:1px solid var(--dp-range-between-border-color)}.dp__range_between_week{background:var(--dp-primary-color);color:var(--dp-primary-text-color);border-radius:0;border-top:1px solid var(--dp-primary-color);border-bottom:1px solid var(--dp-primary-color)}.dp__today{border:1px solid var(--dp-primary-color)}.dp__week_num{color:var(--dp-secondary-color);text-align:center}.dp__cell_auto_range{border-radius:0;border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color)}.dp__cell_auto_range_start{border-start-start-radius:var(--dp-cell-border-radius);border-end-start-radius:var(--dp-cell-border-radius);border-inline-start:1px dashed var(--dp-primary-color);border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color)}.dp__cell_auto_range_end{border-start-end-radius:var(--dp-cell-border-radius);border-end-end-radius:var(--dp-cell-border-radius);border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color);border-inline-end:1px dashed var(--dp-primary-color)}.dp__calendar_header_separator{width:100%;height:1px;background:var(--dp-border-color)}.dp__calendar_next{margin-inline-start:var(--dp-multi-calendars-spacing)}.dp__marker_line,.dp__marker_dot{height:5px;background-color:var(--dp-marker-color);position:absolute;bottom:0}.dp__marker_dot{width:5px;border-radius:50%;left:50%;transform:translateX(-50%)}.dp__marker_line{width:100%;left:0}.dp__marker_tooltip{position:absolute;border-radius:var(--dp-border-radius);background-color:var(--dp-tooltip-color);padding:5px;border:1px solid var(--dp-border-color);z-index:99999;box-sizing:border-box;cursor:default}.dp__tooltip_content{white-space:nowrap}.dp__tooltip_text{display:flex;align-items:center;flex-flow:row nowrap;color:var(--dp-text-color)}.dp__tooltip_mark{height:5px;width:5px;border-radius:50%;background-color:var(--dp-text-color);color:var(--dp-text-color);margin-inline-end:5px}.dp__arrow_bottom_tp{bottom:0;height:8px;width:8px;background-color:var(--dp-tooltip-color);position:absolute;border-inline-end:1px solid var(--dp-border-color);border-bottom:1px solid var(--dp-border-color);transform:translate(-50%, 50%) rotate(45deg)}.dp__instance_calendar{position:relative;width:100%}@media only screen and (width <= 600px){.dp__flex_display{flex-direction:column}}.dp--flex-display-collapsed{flex-direction:column}.dp__cell_highlight{background-color:var(--dp-highlight-color)}.dp__month_year_row{display:flex;align-items:center;height:var(--dp-month-year-row-height);color:var(--dp-text-color);box-sizing:border-box}.dp__inner_nav{display:flex;align-items:center;justify-content:center;cursor:pointer;height:var(--dp-month-year-row-button-size);width:var(--dp-month-year-row-button-size);color:var(--dp-icon-color);text-align:center;border-radius:50%}.dp__inner_nav svg{height:var(--dp-button-icon-height);width:var(--dp-button-icon-height)}.dp__inner_nav:hover{background:var(--dp-hover-color);color:var(--dp-hover-icon-color)}[dir=rtl] .dp__inner_nav{transform:rotate(180deg)}.dp__inner_nav_disabled:hover,.dp__inner_nav_disabled{background:var(--dp-disabled-color);color:var(--dp-disabled-color-text);cursor:not-allowed}.dp--year-select,.dp__month_year_select{text-align:center;cursor:pointer;height:var(--dp-month-year-row-height);display:flex;align-items:center;justify-content:center;border-radius:var(--dp-border-radius);box-sizing:border-box;color:var(--dp-text-color)}.dp--year-select:hover,.dp__month_year_select:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp__month_year_select{width:50%}.dp--year-select{width:100%}.dp__month_year_wrap{display:flex;flex-direction:row;width:100%}.dp__year_disable_select{justify-content:space-around}.dp--header-wrap{display:flex;width:100%;flex-direction:column}.dp__overlay{width:100%;background:var(--dp-background-color);transition:opacity 1s ease-out;z-index:99999;font-family:var(--dp-font-family);color:var(--dp-text-color);box-sizing:border-box}.dp--overlay-absolute{position:absolute;height:100%;top:0;left:0}.dp--overlay-relative{position:relative}.dp__overlay_container::-webkit-scrollbar-track{box-shadow:var(--dp-scroll-bar-background);background-color:var(--dp-scroll-bar-background)}.dp__overlay_container::-webkit-scrollbar{width:5px;background-color:var(--dp-scroll-bar-background)}.dp__overlay_container::-webkit-scrollbar-thumb{background-color:var(--dp-scroll-bar-color);border-radius:10px}.dp__overlay:focus{border:none;outline:none}.dp__container_flex{display:flex}.dp__container_block{display:block}.dp__overlay_container{flex-direction:column;overflow-y:auto;height:var(--dp-overlay-height)}.dp__time_picker_overlay_container{height:100%}.dp__overlay_row{padding:0;box-sizing:border-box;display:flex;margin-inline:auto auto;flex-wrap:wrap;max-width:100%;width:100%;align-items:center}.dp__flex_row{flex:1}.dp__overlay_col{box-sizing:border-box;width:33%;padding:var(--dp-overlay-col-padding);white-space:nowrap}.dp__overlay_cell_pad{padding:var(--dp-common-padding) 0}.dp__overlay_cell_active{cursor:pointer;border-radius:var(--dp-border-radius);text-align:center;background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__overlay_cell{cursor:pointer;border-radius:var(--dp-border-radius);text-align:center}.dp__overlay_cell:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp__cell_in_between{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__over_action_scroll{right:5px;box-sizing:border-box}.dp__overlay_cell_disabled{cursor:not-allowed;background:var(--dp-disabled-color)}.dp__overlay_cell_disabled:hover{background:var(--dp-disabled-color)}.dp__overlay_cell_active_disabled{cursor:not-allowed;background:var(--dp-primary-disabled-color)}.dp__overlay_cell_active_disabled:hover{background:var(--dp-primary-disabled-color)}.dp__btn,.dp--qr-btn,.dp--time-invalid,.dp--time-overlay-btn{border:none;font:inherit;transition:var(--dp-common-transition);line-height:normal}.dp--year-mode-picker{display:flex;width:100%;align-items:center;justify-content:space-between;height:var(--dp-cell-size)}.dp--tp-wrap{max-width:var(--dp-menu-min-width)}.dp__time_input{width:100%;display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;font-family:var(--dp-font-family);color:var(--dp-text-color)}.dp__time_col_reg_block{padding:0 20px}.dp__time_col_reg_inline{padding:0 10px}.dp__time_col_reg_with_button{padding:0 15px}.dp__time_col_sec{padding:0 10px}.dp__time_col_sec_with_button{padding:0 5px}.dp__time_col{text-align:center;display:flex;align-items:center;justify-content:center;flex-direction:column}.dp__time_col_block{font-size:var(--dp-time-font-size)}.dp__time_display{cursor:pointer;color:var(--dp-text-color);border-radius:var(--dp-border-radius);display:flex;align-items:center;justify-content:center}.dp__time_display:hover:enabled{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__time_display_block{padding:0 3px}.dp__time_display_inline{padding:5px}.dp__time_picker_inline_container{display:flex;width:100%;justify-content:center}.dp__inc_dec_button{padding:5px;margin:0;height:var(--dp-time-inc-dec-button-size);width:var(--dp-time-inc-dec-button-size);display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:50%;color:var(--dp-icon-color);box-sizing:border-box}.dp__inc_dec_button svg{height:var(--dp-time-inc-dec-button-size);width:var(--dp-time-inc-dec-button-size)}.dp__inc_dec_button:hover{background:var(--dp-hover-color);color:var(--dp-primary-color)}.dp__inc_dec_button_inline{width:100%;padding:0;height:8px;cursor:pointer;display:flex;align-items:center}.dp__inc_dec_button_disabled:hover,.dp__inc_dec_button_disabled{background:var(--dp-disabled-color);color:var(--dp-disabled-color-text);cursor:not-allowed}.dp__pm_am_button{background:var(--dp-primary-color);color:var(--dp-primary-text-color);border:none;padding:var(--dp-common-padding);border-radius:var(--dp-border-radius);cursor:pointer}.dp__tp_inline_btn_bar{width:100%;height:4px;background-color:var(--dp-secondary-color);transition:var(--dp-common-transition);border-collapse:collapse}.dp__tp_inline_btn_top:hover .dp__tp_btn_in_r{background-color:var(--dp-primary-color);transform:rotate(12deg) scale(1.15) translateY(-2px)}.dp__tp_inline_btn_top:hover .dp__tp_btn_in_l{background-color:var(--dp-primary-color);transform:rotate(-12deg) scale(1.15) translateY(-2px)}.dp__tp_inline_btn_bottom:hover .dp__tp_btn_in_r{background-color:var(--dp-primary-color);transform:rotate(-12deg) scale(1.15) translateY(-2px)}.dp__tp_inline_btn_bottom:hover .dp__tp_btn_in_l{background-color:var(--dp-primary-color);transform:rotate(12deg) scale(1.15) translateY(-2px)}.dp--time-overlay-btn{background:none}.dp--time-invalid{background-color:var(--dp-disabled-color)}.dp__action_row{display:flex;align-items:center;width:100%;padding:var(--dp-action-row-padding);box-sizing:border-box;color:var(--dp-text-color);flex-flow:row nowrap}.dp__action_row svg{height:var(--dp-button-icon-height);width:auto}.dp__selection_preview{display:block;color:var(--dp-text-color);font-size:var(--dp-preview-font-size);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.dp__action_buttons{display:flex;flex:0;white-space:nowrap;align-items:center;justify-content:flex-end;margin-inline-start:auto}.dp__action_button{display:inline-flex;align-items:center;background:rgba(0,0,0,0);border:1px solid rgba(0,0,0,0);padding:var(--dp-action-buttons-padding);line-height:var(--dp-action-button-height);margin-inline-start:3px;height:var(--dp-action-button-height);cursor:pointer;border-radius:var(--dp-border-radius);font-size:var(--dp-preview-font-size);font-family:var(--dp-font-family)}.dp__action_buttons .dp__action_select{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__action_buttons .dp__action_select:hover{background:var(--dp-primary-color);transition:var(--dp-action-row-transtion)}.dp__action_buttons .dp__action_select:disabled{background:var(--dp-primary-disabled-color);cursor:not-allowed}.dp__action_cancel{color:var(--dp-text-color);border:1px solid var(--dp-border-color)}.dp__action_cancel:hover{border-color:var(--dp-primary-color);transition:var(--dp-action-row-transtion)}.dp-quarter-picker-wrap{display:flex;flex-direction:column;height:100%;min-width:var(--dp-menu-min-width)}.dp--qr-btn{width:100%;padding:var(--dp-common-padding)}.dp--qr-btn:not(.dp--highlighted,.dp--qr-btn-active,.dp--qr-btn-disabled,.dp--qr-btn-between){background:none}.dp--qr-btn:hover:not(.dp--qr-btn-active,.dp--qr-btn-disabled){background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp--quarter-items{display:flex;flex-direction:column;flex:1;width:100%;height:100%;justify-content:space-evenly}.dp--qr-btn-active{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp--qr-btn-between{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp--qr-btn-disabled{cursor:not-allowed;background:var(--dp-disabled-color)}.dp--qr-btn-disabled:hover{background:var(--dp-disabled-color)}.dp__btn,.dp--time-overlay-btn,.dp--time-invalid,.dp--qr-btn{border:none;font:inherit;transition:var(--dp-common-transition);line-height:normal}.dp--year-mode-picker{display:flex;width:100%;align-items:center;justify-content:space-between;height:var(--dp-cell-size)}:root{--dp-common-transition: all 0.1s ease-in;--dp-menu-padding: 6px 8px;--dp-animation-duration: 0.1s;--dp-menu-appear-transition-timing: cubic-bezier(.4, 0, 1, 1);--dp-transition-timing: ease-out;--dp-action-row-transtion: all 0.2s ease-in;--dp-font-family: -apple-system, blinkmacsystemfont, "Segoe UI", roboto, oxygen, ubuntu, cantarell, "Open Sans", "Helvetica Neue", sans-serif;--dp-border-radius: 4px;--dp-cell-border-radius: 4px;--dp-transition-length: 22px;--dp-transition-timing-general: 0.1s;--dp-button-height: 35px;--dp-month-year-row-height: 35px;--dp-month-year-row-button-size: 25px;--dp-button-icon-height: 20px;--dp-calendar-wrap-padding: 0 5px;--dp-cell-size: 35px;--dp-cell-padding: 5px;--dp-common-padding: 10px;--dp-input-icon-padding: 35px;--dp-input-padding: 6px 30px 6px 12px;--dp-menu-min-width: 260px;--dp-action-buttons-padding: 1px 6px;--dp-row-margin: 5px 0;--dp-calendar-header-cell-padding: 0.5rem;--dp-multi-calendars-spacing: 10px;--dp-overlay-col-padding: 3px;--dp-time-inc-dec-button-size: 32px;--dp-font-size: 1rem;--dp-preview-font-size: 0.8rem;--dp-time-font-size: 2rem;--dp-action-button-height: 22px;--dp-action-row-padding: 8px}.dp__theme_dark{--dp-background-color: #212121;--dp-text-color: #fff;--dp-hover-color: #484848;--dp-hover-text-color: #fff;--dp-hover-icon-color: #959595;--dp-primary-color: #005cb2;--dp-primary-disabled-color: #61a8ea;--dp-primary-text-color: #fff;--dp-secondary-color: #a9a9a9;--dp-border-color: #2d2d2d;--dp-menu-border-color: #2d2d2d;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #737373;--dp-disabled-color-text: #d0d0d0;--dp-scroll-bar-background: #212121;--dp-scroll-bar-color: #484848;--dp-success-color: #00701a;--dp-success-color-disabled: #428f59;--dp-icon-color: #959595;--dp-danger-color: #e53935;--dp-marker-color: #e53935;--dp-tooltip-color: #3e3e3e;--dp-highlight-color: rgb(0 92 178 / 20%);--dp-range-between-dates-background-color: var(--dp-hover-color, #484848);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #fff);--dp-range-between-border-color: var(--dp-hover-color, #fff);--dp-loader: 5px solid #005cb2}.dp__theme_light{--dp-background-color: #fff;--dp-text-color: #212121;--dp-hover-color: #f3f3f3;--dp-hover-text-color: #212121;--dp-hover-icon-color: #959595;--dp-primary-color: #1976d2;--dp-primary-disabled-color: #6bacea;--dp-primary-text-color: #f8f5f5;--dp-secondary-color: #c0c4cc;--dp-border-color: #ddd;--dp-menu-border-color: #ddd;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #f6f6f6;--dp-scroll-bar-background: #f3f3f3;--dp-scroll-bar-color: #959595;--dp-success-color: #76d275;--dp-success-color-disabled: #a3d9b1;--dp-icon-color: #959595;--dp-danger-color: #ff6f60;--dp-marker-color: #ff6f60;--dp-tooltip-color: #fafafa;--dp-disabled-color-text: #8e8e8e;--dp-highlight-color: rgb(25 118 210 / 10%);--dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);--dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);--dp-loader: 5px solid #1976d2}.dp__flex{display:flex;align-items:center}.dp__btn{background:none}.dp__main{font-family:var(--dp-font-family);-webkit-user-select:none;-moz-user-select:none;user-select:none;box-sizing:border-box;position:relative;width:100%}.dp__pointer{cursor:pointer}.dp__icon{stroke:currentcolor;fill:currentcolor}.dp__button{width:100%;text-align:center;color:var(--dp-icon-color);cursor:pointer;display:flex;align-items:center;place-content:center center;padding:var(--dp-common-padding);box-sizing:border-box;height:var(--dp-button-height)}.dp__button.dp__overlay_action{position:absolute;bottom:0}.dp__button:hover{background:var(--dp-hover-color);color:var(--dp-hover-icon-color)}.dp__button svg{height:var(--dp-button-icon-height);width:auto}.dp__button_bottom{border-bottom-left-radius:var(--dp-border-radius);border-bottom-right-radius:var(--dp-border-radius)}.dp__flex_display{display:flex}.dp__flex_display_with_input{flex-direction:column;align-items:flex-start}.dp__relative{position:relative}.calendar-next-enter-active,.calendar-next-leave-active,.calendar-prev-enter-active,.calendar-prev-leave-active{transition:all var(--dp-transition-timing-general) ease-out}.calendar-next-enter-from{opacity:0;transform:translateX(var(--dp-transition-length))}.calendar-next-leave-to{opacity:0;transform:translateX(calc(var(--dp-transition-length) * -1))}.calendar-prev-enter-from{opacity:0;transform:translateX(calc(var(--dp-transition-length) * -1))}.calendar-prev-leave-to{opacity:0;transform:translateX(var(--dp-transition-length))}.dp-menu-appear-bottom-enter-active,.dp-menu-appear-bottom-leave-active,.dp-menu-appear-top-enter-active,.dp-menu-appear-top-leave-active,.dp-slide-up-enter-active,.dp-slide-up-leave-active,.dp-slide-down-enter-active,.dp-slide-down-leave-active{transition:all var(--dp-animation-duration) var(--dp-transition-timing)}.dp-menu-appear-top-enter-from,.dp-menu-appear-top-leave-to,.dp-slide-down-leave-to,.dp-slide-up-enter-from{opacity:0;transform:translateY(var(--dp-transition-length))}.dp-menu-appear-bottom-enter-from,.dp-menu-appear-bottom-leave-to,.dp-slide-down-enter-from,.dp-slide-up-leave-to{opacity:0;transform:translateY(calc(var(--dp-transition-length) * -1))}.dp--arrow-btn-nav{transition:var(--dp-common-transition)}.dp--highlighted{background-color:var(--dp-highlight-color)}

/*# sourceMappingURL=main.css.map */

._extension_vk470_2 {
  height: calc(100% - 2px);
}
._prefix_vk470_6 {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  left: 1px;
  top: 1px;
}
._suffix_vk470_13 {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  right: 1px;
  top: 1px;
}


._overlay_1j79s_2 {
    --overlay-offset: 1rem;
    --overlay-opacity: 0.666;

    transition-property: opacity, top, left, width, height;
    will-change: top, left, width, height;

    box-shadow:
      0 0 0 99999px rgba(0, 0, 0, var(--overlay-opacity)),
      inset 0 0 0.5rem rgba(0, 0, 0, var(--overlay-opacity));

    z-index: 990;
}


._tree_1vcol_2 {
  width: 100%;
}
._tree_1vcol_2 ul {
  margin-left: 2.5rem;
}


._item-group_1gki2_2::before {
  border-left: 1px solid #DFE3E8;
  content: "";
  left: 1.6rem;
  position: absolute;
  top: 2.3rem;
  height: calc(100% - 1.5rem);
}
._item-group_1gki2_2 > ul > li {
  position: relative;
}
._item-group_1gki2_2 > ul > li:not(._group-label_1gki2_15) {
  padding: 0.75rem;
}
._item-group_1gki2_2 > ul > li:not(._group-label_1gki2_15)::before {
  border-left: 1px solid #DFE3E8;
  content: "";
  left: -0.96rem;
  position: absolute;
  top: -0.7rem;
  height: calc(100% + 1.5rem);
}


._inline-border_1xd73_2 {
  top: 1px;
  left: 1px;
  height: calc(100% - 2px);
  width: calc(100% - 2px);
}


._bar_3gdd0_2 {
  transition: width 1s ease;
}
._animate_3gdd0_6 {
  animation: _pulse_3gdd0_1 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
._small_3gdd0_10 {
  font-size: .5rem;
}
@keyframes _pulse_3gdd0_1 {
0%, 100% {
    opacity: 1;
}
50% {
    opacity: .8;
}
}


._step_1k248_2::before {
    content: ' ';
    background: rgb(223, 227, 232);
    position: absolute;
    width: 100%;
    /** Subtract half the height */
    top: calc(50% - 2px);
    right: 50%;
    height: 4px;
    z-index: 0;
}
._step_1k248_2[active="true"]::before {
    background: rgba(71,135,209,1);
}
._step_1k248_2[first="true"]::before {
    display: none;
}
._step_1k248_2[disabled="true"]::before {
    background-color: rgb(242, 245, 247);
}


._selectableContents_7l5sg_2:hover > div,
._selectedContents_7l5sg_3 > div {
  background-color: #F2F2F5; /* TODO: support tailwind PostCSS theme("colors.gray.100"); */
}
._itemRow_7l5sg_7 {
  min-width: var(--row-width);
}


/* Override HeadlessUI style to avoid button display styles on safari (up to version 15) */
[type="button"][data-v-1ece301c] {
  -webkit-appearance: none;
}


/* Override HeadlessUI style to avoid button display styles on safari (up to version 15) */
[type="button"][data-v-ea12ecac] {
  -webkit-appearance: none;
}

.slider-target,.slider-target *{-webkit-touch-callout:none;-webkit-tap-highlight-color:rgba(0,0,0,0);box-sizing:border-box;touch-action:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.slider-target{position:relative}.slider-base,.slider-connects{height:100%;position:relative;width:100%;z-index:1}.slider-connects{overflow:hidden;z-index:0}.slider-connect,.slider-origin{height:100%;position:absolute;right:0;top:0;transform-origin:0 0;transform-style:flat;width:100%;will-change:transform;z-index:1}.slider-txt-dir-rtl.slider-horizontal .slider-origin{left:0;right:auto}.slider-vertical .slider-origin{top:-100%;width:0}.slider-horizontal .slider-origin{height:0}.slider-handle{backface-visibility:hidden;position:absolute}.slider-touch-area{height:100%;width:100%}.slider-state-tap .slider-connect,.slider-state-tap .slider-origin{transition:transform .3s}.slider-state-drag *{cursor:inherit!important}.slider-tooltip-drag .slider-tooltip,.slider-tooltip-focus .slider-tooltip{display:none!important}.slider-tooltip-drag .slider-active .slider-tooltip,.slider-tooltip-drag.slider-state-drag .slider-tooltip:not(.slider-tooltip-hidden),.slider-tooltip-focus.slider-focused .slider-tooltip:not(.slider-tooltip-hidden){display:block!important}.slider-horizontal{height:var(--slider-height,6px)}.slider-horizontal .slider-handle{height:var(--slider-handle-height,16px);right:calc(var(--slider-handle-width, 16px)/2*-1);top:calc((var(--slider-handle-height, 16px) - var(--slider-height, 6px))/2*-1 + -1px);width:var(--slider-handle-width,16px)}.slider-vertical{height:var(--slider-vertical-height,300px);width:var(--slider-height,6px)}.slider-vertical .slider-handle{bottom:calc(var(--slider-handle-width, 16px)/2*-1);height:var(--slider-handle-width,16px);right:calc((var(--slider-handle-height, 16px) - var(--slider-height, 6px))/2*-1 + -1px);width:var(--slider-handle-height,16px)}.slider-txt-dir-rtl.slider-horizontal .slider-handle{left:calc(var(--slider-handle-width, 16px)/2*-1);right:auto}.slider-base{background-color:var(--slider-bg,#d1d5db)}.slider-base,.slider-connects{border-radius:var(--slider-radius,9999px)}.slider-connect{background:var(--slider-connect-bg,#10b981);cursor:pointer}.slider-draggable{cursor:ew-resize}.slider-vertical .slider-draggable{cursor:ns-resize}.slider-handle{background:var(--slider-handle-bg,#fff);border:var(--slider-handle-border,0);border-radius:var(--slider-handle-radius,9999px);box-shadow:var(--slider-handle-shadow,.5px .5px 2px 1px rgba(0,0,0,.32));cursor:grab;height:var(--slider-handle-height,16px);width:var(--slider-handle-width,16px)}.slider-handle:focus{box-shadow:0 0 0 var(--slider-handle-ring-width,3px) var(--slider-handle-ring-color,rgba(16,185,129,.188)),var(--slider-handle-shadow,.5px .5px 2px 1px rgba(0,0,0,.32));outline:none}.slider-active{box-shadow:var(--slider-handle-shadow-active,.5px .5px 2px 1px rgba(0,0,0,.42));cursor:grabbing}[disabled] .slider-connect{background:var(--slider-connect-bg-disabled,#9ca3af)}[disabled] .slider-handle,[disabled].slider-handle,[disabled].slider-target{cursor:not-allowed}[disabled] .slider-tooltip{background:var(--slider-tooltip-bg-disabled,#9ca3af);border-color:var(--slider-tooltip-bg-disabled,#9ca3af)}.slider-tooltip{background:var(--slider-tooltip-bg,#10b981);border:1px solid var(--slider-tooltip-bg,#10b981);border-radius:var(--slider-tooltip-radius,5px);color:var(--slider-tooltip-color,#fff);display:block;font-size:var(--slider-tooltip-font-size,.875rem);font-weight:var(--slider-tooltip-font-weight,600);line-height:var(--slider-tooltip-line-height,1.25rem);min-width:var(--slider-tooltip-min-width,20px);padding:var(--slider-tooltip-py,2px) var(--slider-tooltip-px,6px);position:absolute;text-align:center;white-space:nowrap}.slider-horizontal .slider-tooltip-top{bottom:calc(var(--slider-handle-height, 16px) + var(--slider-tooltip-arrow-size, 5px) + var(--slider-tooltip-distance, 3px));left:50%;transform:translate(-50%)}.slider-horizontal .slider-tooltip-top:before{border:var(--slider-tooltip-arrow-size,5px) solid transparent;border-top-color:inherit;bottom:calc(var(--slider-tooltip-arrow-size, 5px)*-2);content:"";height:0;left:50%;position:absolute;transform:translate(-50%);width:0}.slider-horizontal .slider-tooltip-bottom{left:50%;top:calc(var(--slider-handle-height, 16px) + var(--slider-tooltip-arrow-size, 5px) + var(--slider-tooltip-distance, 3px));transform:translate(-50%)}.slider-horizontal .slider-tooltip-bottom:before{border:var(--slider-tooltip-arrow-size,5px) solid transparent;border-bottom-color:inherit;content:"";height:0;left:50%;position:absolute;top:calc(var(--slider-tooltip-arrow-size, 5px)*-2);transform:translate(-50%);width:0}.slider-vertical .slider-tooltip-left{right:calc(var(--slider-handle-height, 16px) + var(--slider-tooltip-arrow-size, 5px) + var(--slider-tooltip-distance, 3px));top:50%;transform:translateY(-50%)}.slider-vertical .slider-tooltip-left:before{border:var(--slider-tooltip-arrow-size,5px) solid transparent;border-left-color:inherit;content:"";height:0;position:absolute;right:calc(var(--slider-tooltip-arrow-size, 5px)*-2);top:50%;transform:translateY(-50%);width:0}.slider-vertical .slider-tooltip-right{left:calc(var(--slider-handle-height, 16px) + var(--slider-tooltip-arrow-size, 5px) + var(--slider-tooltip-distance, 3px));top:50%;transform:translateY(-50%)}.slider-vertical .slider-tooltip-right:before{border:var(--slider-tooltip-arrow-size,5px) solid transparent;border-right-color:inherit;content:"";height:0;left:calc(var(--slider-tooltip-arrow-size, 5px)*-2);position:absolute;top:50%;transform:translateY(-50%);width:0}.slider-horizontal .slider-origin>.slider-tooltip{left:auto;transform:translate(50%)}.slider-horizontal .slider-origin>.slider-tooltip-top{bottom:calc(var(--slider-tooltip-arrow-size, 5px) + (var(--slider-handle-height, 16px) - var(--slider-height, 6px))/2 + var(--slider-tooltip-distance, 3px) + 1px)}.slider-horizontal .slider-origin>.slider-tooltip-bottom{top:calc(var(--slider-tooltip-arrow-size, 5px) + (var(--slider-handle-height, 16px) - var(--slider-height, 6px))/2 + var(--slider-tooltip-distance, 3px) + var(--slider-height, 6px) - 1px)}.slider-vertical .slider-origin>.slider-tooltip{top:auto;transform:translateY(calc((var(--slider-tooltip-line-height, 1.25rem) - var(--slider-tooltip-py, 2px))*-1 + 1px))}.slider-vertical .slider-origin>.slider-tooltip-left{right:calc(var(--slider-tooltip-arrow-size, 5px) + var(--slider-height, 6px) + (var(--slider-handle-height, 16px) - var(--slider-height, 6px))/2 + var(--slider-tooltip-distance, 3px) - 1px)}.slider-vertical .slider-origin>.slider-tooltip-right{left:calc(var(--slider-tooltip-arrow-size, 5px) + var(--slider-height, 6px) + (var(--slider-handle-height, 16px) - var(--slider-height, 6px))/2 + var(--slider-tooltip-distance, 3px) - var(--slider-height, 6px) + 1px)}

.ds-slider {
  --slider-bg: #c9d0d4;
  --slider-height: 8px;
  --slider-connect-bg: #c9d0d4;

  --slider-handle-border: 2px solid #c9d0d4;
  --slider-handle-ring-width: 2px;
  --slider-handle-ring-color: #96c5e7;
  --slider-handle-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0);

  --slider-tooltip-bg: #4787d1;
  --slider-tooltip-distance: 4px;
  --slider-tooltip-bg-disabled: #919699;

  cursor: pointer;
}
[disabled] .ds-slider {
  cursor: inherit;
}
[disabled] .slider-handle:focus {
  box-shadow: var(
    --slider-handle-shadow,
    0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32)
  );
}


input[type="color"] {
  -webkit-appearance: none;
}
input[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
}
input[type="color"]::-webkit-color-swatch {
  border-radius: 0.25rem;
  border: none
}
`);
export {
  Ta as CardSlot,
  LV as DsAccordion,
  FV as DsAlert,
  Z4 as DsBadge,
  gr as DsButton,
  BV as DsCard,
  zV as DsCarousel,
  F5 as DsCheckbox,
  VV as DsDataButton,
  nw as DsDatepicker,
  Cd as DsDropdown,
  vC as DsDropdownBase,
  WV as DsDualListbox,
  qV as DsEditor,
  RT as DsFieldError,
  dR as DsFileList,
  YV as DsFileUpload,
  HV as DsForm,
  qT as DsFormGroup,
  KV as DsFormattedNumberInput,
  Ue as DsIcon,
  pa as DsInput,
  GV as DsIntroTour,
  JV as DsIntroTourButton,
  XV as DsIntroTourStep,
  QV as DsList,
  tH as DsListCard,
  ZV as DsListItem,
  eH as DsListItemGroup,
  $s as DsLoadingState,
  nH as DsModal,
  rH as DsMultiselect,
  iH as DsNotification,
  kH as DsPhoneNumberInput,
  df as DsPopover,
  oH as DsProgressBar,
  RL as DsRadioButton,
  sH as DsRadioGroup,
  dH as DsSelect,
  uH as DsSkeleton,
  lH as DsSlider,
  cH as DsStep,
  fH as DsStepper,
  pH as DsSwitch,
  vH as DsTab,
  jF as DsTabLink,
  KF as DsTabLinks,
  hH as DsTable,
  yH as DsTabs,
  rm as DsTag,
  bH as DsTextarea,
  wH as DsTimeline,
  $H as DsTypeahead,
  Z0 as DsVirtualList,
  jo as ModalVariant,
  el as MultiselectError,
  N_ as NotificationDefaultTimeout,
  Xi as NotificationVariant,
  zo as PopoverVariant,
  Gc as ProgressBarSize,
  Ki as SortOrder,
  t3 as StepperProvider,
  r3 as TabsProvider,
  ac as TriggerPosition,
  mH as createEnumFilter,
  gH as createSearchFilter,
  C_ as isMultiselectItem,
  xH as tailwindPlugin,
  I_ as useNotification
};
